module.exports={
"label_emailtocloudcc_department":`Departamento`,
"label.wei.weiresearch":`Micro-votação`,
"message.error.appsecret.null":`A palavra-passe da chave secreta não pode ser nula!`,
"label.file.orderbylastmodifydate":`Ordenado pela última vez modificada`,
"label.minus":`-Minus`,
"label.horizontalbar":`Linhas Horizontais`,
"label.emailobject.emailsentfailed":`O correio não chegou a send！`,
"assignedresource.check":`Este recurso de serviço foi atribuído a uma marcação de serviço. Por favor, não adicionar repetidamente.`,
"label.finish":`Completo`,
"label.document.history":`Descarregar histórico`,
"label.customfields.number.numberLengthHelpText":`1.Por favor, introduza o comprimento do número e o número de casas decimais. Por exemplo, um número com um comprimento de 8 e 2 casas decimais pode aceitar valores até "12345678,90".`,
"label.standard.buttonandlink.info":`A substituição de botões e links padrão altera o significado do URL CloudCC.com e quaisquer chamadas para esse URL, tais como uma página personalizada do CloudCC.com, um atalho do navegador, ou um sistema externo. Pode substituir o URL CloudCC.com por um botão padrão ou link por uma página personalizada.`,
"front-epwechat-module-v1-contacts-desc":`Quando activado, o objecto da WeCom Contacts será adicionado ao sistema CloudCC, a informação do cliente da WeCom será sincronizada com este objecto.`,
"label.mr.caption.contact.result":`Encontrar duplicados e fundir: Resultados para consulta de duplicados de Contactos`,
"label.ems.selectaccount":`Seleccionar conta`,
"label.group.no.activity":`Não há grupos activos correspondentes.`,
"label.call.for":`Convidado por`,
"label.newreportguide":`Novo Guia de Relatório`,
"component.telerecord.label.name":`Nomes`,
"vue.add.dashboard.component":`Adicionar {titleName} Componente`,
"label.chatter.sendEmailToGroupMember.check.V":`Ver Votos`,
"UG.ST.002":`Determinar`,
"label.setting.intergrationmanage":`Gestão da Integração`,
"label.field.apiname.validate":`Por favor, introduza um número entre 0 e 6.`,
"label.emailmerge.list.deletefolder":`Apagar pasta`,
"vue_label_pool_received":`Recebido`,
"label_emailtocloudcc_step1_case1":`Email para o caso`,
"message.sumlength":`A soma do comprimento e do número de casas decimais não pode exceder 18 palcos.`,
"vue_label_approve_reassignapproval":`reatribuiu esta aprovação a {pessoas}`,
"label.specify.time":`Hora: 13:00 de Junho, 21 de Junho, 2016`,
"vue_label_report_sortdown":`Ordenar por ordem decrescente`,
"chatter.login.now":`Carregamento...`,
"label.import.page2.notsuited":`Não mapeado`,
"label.please.fill.out":`Por favor preencha`,
"label.recordtype.edit.description":`Seleccione um valor de "Valores Disponíveis", depois adicione-o a "Valores Seleccionados" e transforme-o num valor da lista de selecção para este tipo de registo. Note que apagar um valor da lista de selecção não remove este valor de nenhum registo existente. Finalmente, seleccionar o valor padrão da lista de selecção para o tipo de registo.`,
"label.customer.tab.new":`Separador Novo Cliente`,
"label.sameas":`O mesmo que`,
"front-filter-module-v1-filter-a-week-ago":`Uma semana atrás`,
"label.processsetting.disable.process.failed":`Falha em desactivar o processo!`,
"label.summaryreport.2018.step4":`Passo 4 Seleccionar os critérios do relatório`,
"label.secrecyinfo":`Informação Confidencial,Não Espalhe`,
"label.custom.page.component.general.settings":`Componente Configurações Gerais`,
"label.ccpeak.folder":`Pastas de classe não arquivadas`,
"vue_label_homepage_select_button_operation":`Botão Seleccionar`,
"message.pleaseinputrightdistance":`Por favor introduza os dias de intervalo correctos`,
"label.mobile.phone.required.short":`é necessário`,
"vue_label_account_equityseructure":`Estrutura accionista`,
"label.file.library.error1":`Este ficheiro já se encontra nesta biblioteca.`,
"fliter.nextmonth":`Próximo mês`,
"label.mr.descreption.oneGroupNote2":`conjunto de informação empresarial,há`,
"label.allfolderdashboard":`Todas as Pastas do Painel`,
"lable.opppdt.selPdt.bykeywords":`Por palavra-chave`,
"setup_layout_label_selectedfield":`Seleccionar campos`,
"label.file.preview.convert.firstpage.failure":`Ocorreu um erro ao visualizar os dados prévios, por favor clique em pré-visualizar ou descarregue para ver`,
"vue_label_systemSettings_companie":`Constituição de empresa`,
"label.loginhis.recently":`Histórico de login recente`,
"label.permission.visualpagepermission.edit":`Atribuição de páginas personalizadas`,
"label.ccservice.validate.email":`O formato do valor correspondente {2} do campo {1} sob o objecto API {0} está incorrecto. Por favor introduza o endereço de correio electrónico correcto!`,
"label.sms.companyname.gm":`Definição de SMS-2`,
"lable.opppdt.addpdt.table.discount":`Desconto (% de desconto)`,
"Lead.Scoring.Setting.LevelSetting":`Configurações de Popularidade de Liderança`,
"message.duplication.label.duplicationremark":`é a operação de consulta de dados duplicados quando se trata de registos novos ou de edição`,
"label.file.preview.error":`Ocorreu um erro quando preveiw, por favor descarregue para ver`,
"label.imgfield.type.input":`Inserir imagem`,
"label.file.share.email.content1":`Nome do ficheiro: #nome do ficheiro`,
"vue_label_notice_batchedit_fail":`A actualização de dados com id {0} falha com motivo de falha {1}.`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.four":`Quatro`,
"label.view.sortview.printview":`Imprimir`,
"label.projectManagement.Addposttask":`Adicionar pós-tarefa`,
"vue_label_commonobjects_view_fail":`Falha em definir a visualização por defeito`,
"label.dayinweek":`Semana`,
"label.layout.notexist":`O esquema não existe.`,
"label.brief.total":`Registo {total}`,
"label.dashboardSetup.tz.bb":`Ir para Relatórios`,
"label_emailtocloudcc_select3":`Por favor seleccione o proprietário do disco`,
"label.input.least.string":`Por favor introduza pelo menos {0} caracteres`,
"label.app.step2":`Passo 2 Introduzir os Detalhes`,
"lable.account.LastWeek":`Semana passada`,
"label.notifications":`Notificações`,
"label.tabpage.viewname":`Ver nome`,
"label.knowledge.language.italian":`Italiano`,
"label.sendmail.step2.introduce":`Por favor escolha um modelo de e-mail`,
"label_enable_or_no":`Quer activar ?`,
"pagecreator_button_save":`Guardar`,
"template.chart.cplb":`Categoria de produto`,
"label.knowledge.publish":`Não pode ser publicado para ele não qualificado.`,
"label.name.required":`O campo do nome é obrigatório`,
"component.chatter.label.myfans":`Os meus seguidores`,
"label.rejectoperate":`Acções de Rejeição`,
"label.report.action.addtodashboard3":`Seleccionar Painel de controlo`,
"label.icon.101":`Livro-texto`,
"label.data.exp.su.ok":`Exportar`,
"label.appupload.component.type.layout":`Layouts de página`,
"template.chart.yscb":`Custo orçamentado`,
"label.tabularreport.selectorder":`Determinar o tipo de exibição de cada coluna de relatório`,
"email.title.one":`Recuperar Palavra-passe`,
"label.case.copy.link":`Copiar Ligação Web`,
"label.mr.descreption.oneGroupReData4":`grupo,está restante`,
"label.newprocess5.error.des":`Só se podem introduzir números.`,
"label.partnerCloud.loginButton":`Botão Login`,
"label.interfaceconstraint.adminonly":`Apenas os administradores podem utilizar esta interface.`,
"label.campaign.channel.input.date":`2.Por favor, defina o periord de validade para o seu canal de marketing:`,
"label.clientwebsiteentranceprofile":`Perfil do Portal do Cliente`,
"UG.opportunity.011":`Transacção de importação`,
"label.page.copy.value.paste.template":`Copie e cole o valor do campo de fusão no seu modelo abaixo.`,
"label.notselect":`Sem selecção`,
"label.weixin.input.password":`Por favor introduza a sua palavra-passe.`,
"label.email.select.template":`Seleccione o modelo`,
"label_chatter_ok":`Confirme`,
"permissionService.error":`A atribuição do conjunto de permissões falhou, verificar se a licença do pedido expirou ou se a atribuição atingiu o limite superior.`,
"label.webtocloudcc.sorry":`Desculpe, erro de página, por favor tente novamente ou contacte o seu administrador.`,
"UG.opportunity.007":`Papel de contacto`,
"label.manageAll.forapproval":`Itens a aprovar`,
"label.imgfield.type.ref":`Fórmula Imagem`,
"label.profile.setcustomtab":`Definições de Separadores Personalizados`,
"label.tabpage.datatyoez":`Tipo de dados`,
"label.partnerCloud.basicSetting.editPersonal":`Permitir aos utilizadores da nuvem de parceiros editar informação pessoal`,
"label.mr.caption.account":`Encontrar duplicados e fundir: Codições para consulta de duplicados de contas`,
"message.serviceterritoryMe.time.violation":`Violação do tempo de envio: o período de envio não está dentro do intervalo de tempo dos membros regionais.`,
"pagecreator_page_message_publish_success":`Página publicada com sucesso`,
"label.field.formula.timezonetip":`Note o suporte de fuso horário múltiplo para funções do tipo data/hora. ao usar a função do sistema, tal como data do sistema numa fórmula para obter a hora actual, esta deve ser substituída pela sua correspondente função de fuso horário múltiplo, tal como data_actual.`,
"label.marketseamemset.specialuser":`Membro especial`,
"label.staticresource.message":`Detalhe dos recursos estáticos`,
"label.workflow.rulecondition":`Critérios de Regra`,
"component_salesperformance_label_nodata":`Adicione a sua oportunidade de negócio e volte aqui para ver o gráfico de desempenho.`,
"label.customfields.textarea.tip":`Permite aos utilizadores introduzir múltiplas linhas de texto, até 4000 caracteres.`,
"font-evaluate-module-v1-template":`Modelo personalizado`,
"label.step3.total5":`Etapa 3 de 5`,
"label.customfields.formula.percent.tip":`Calcular uma percentagem e adicionar automaticamente o sinal da percentagem ao número.`,
"label.sortdesc":`Descer`,
"lable.PowerProcess.edit":`Editar Processo de Direito de Autor`,
"label.dongshifang.description":`Configure a informação do Dongshifang para satisfazer as necessidades dos serviços de envio e recepção de SMS da sua organização.`,
"label.chatter.addressee":`Destinatário`,
"vue_label_systemSettings_obj2":`Consola de Gestão de Objectos`,
"label.selectreporttype.tip":`Escolha o tipo de dados que pretende incluir neste relatório`,
"label.version.enterprise":`Edição Empresarial`,
"label.area.add":`Acrescentar Território`,
"label.h5.bookmarked":`Bookmarks`,
"label.step5.total7":`Passo 5 de 7`,
"front-lightning-module-v1-title-quotation":`Prever Citação`,
"label.search.onlymyrecords":`Limite aos artigos que possuo`,
"vue_label_commonobjects_noduplication":`Duplicata de {字段} em {记录}`,
"label.customerpage.edit":`Editar Separadores em Páginas Personalizadas`,
"message.please.choose.user":`Por favor seleccione o utilizador`,
"label.approval.his.currentactor":`Aprovador actual`,
"label.field.duplicate.error.msg3":`Pode crear 3 campos de propriedades únicas, no máximo.`,
"label.page_url":`URL da página`,
"label.permission.goback":`Voltar aos Conjuntos de Permissões`,
"vue_label_commonobjects_view_kanban_notice2":`Para ver todos os registos, utilize a vista de lista ou a vista de ecrã dividido`,
"label.group.no.recent.searchs":`Não existem grupos que correspondam a grupos vistos recentemente.`,
"label.event.fiducial.point":`pontual`,
"label.integrations.mailchimp.addtolist":`Adicione os contactos e leads seleccionados da sua conta CloudCC à sua lista Mailchimp`,
"label.workflow.configrule.introduce":`Introduza o nome, descrição, e critérios para desencadear a regra do seu fluxo de trabalho. No passo seguinte, associar acções de fluxo de trabalho a esta regra de fluxo de trabalho.`,
"label.icon.161":`Mala`,
"label.recordtype.enable":`Activo`,
"label_mailboxes_limit":`O número de caixas de correio excede o limite.`,
"label.notification.time3":`{0} horas atrás`,
"label.setsharerule.step2":`Passo 2 Seleccionar quais os registos a partilhar`,
"vue_label_homepage_somecomponents":`Cuidado! Depois de adicionar o componente, a altura excede o limite e causou uma visualização incompleta. Favor apagar alguns componentes`,
"label.icon.63":`Poço Subterrâneo`,
"label.use.standard.sharerules":`Usar as Regras Padrão de Partilha`,
"label.button.step2.select.required.field":`Passo 2 Seleccionar os campos necessários`,
"lable.Confirm.collect.potential.customers":`Confirmar para recolher chumbo {nome}`,
"label.version.sum.custompage":`página(s) personalizada(s)`,
"label.file.ccchat.changefile":`Alterar ficheiro`,
"label.mobile.phone.phone.call":`Chamada`,
"label.appupload.managed.img":`Controlado`,
"vue_label_chatter_comment":`comentário`,
"label.central.european.time":`Tempo da Europa Central`,
"label.three.quarter":`Terceiro Trimestre`,
"label.service.newBuildDialog.filter.editor":`Editor de filtros`,
"pagecreator_systemstyle_funcpath":`/ construtor / biblioteca de estilo de marca`,
"label_chatter_collect":`Favoritos`,
"label.custom.page.component.window.settings":`Configuração de janelas de componentes`,
"component_chatter_file_label_title":`Carregamento de ficheiros`,
"label.marketsea.button.discard":`Descartar`,
"label.Batch.input":`Batch Input`,
"vue_label_campaign_market_members":`Membros existentes no mercado`,
"label.salescloud.salesdashboard":`Painéis de vendas`,
"message.summaryconditionrepeated":`Desculpe, condições sumárias duplicadas, por favor re-selecione!`,
"label.tianyancha.h5.companycode":`Código da empresa`,
"label.quickbooks.description":`Mantenha-se a par das suas facturas, pagamentos e orçamentos QuickBooks Online.`,
"label.colombia.time":`Tempo Colômbia`,
"label.usermanage.unknown.license":`Licença inválida, e não pode criar novos utilizadores, por favor contacte o seu administrador.`,
"label.operatedata.selectoperateandobject":`Seleccionar operação (Importação ou Exportação) e objectos`,
"message.setup.field.picklist.valuerepeated":`Os valores da lista não podem ser repetidos, por favor, volte a entrar.`,
"label.editerror.list":`A lista de dados não foi editada.`,
"pagecreator_page_message_save_success":`Página guardada com sucesso`,
"label.icon.154":`Computador`,
"label.emailsync.setting":`Configurações pessoais de e-mail`,
"label.startuploadfile.step2":`Passo 3 Clique em "iniciar o carregamento" para carregar ficheiros`,
"label.dashboard.notmeet.conditions":`Não foi encontrada informação correspondente e o painel de instrumentos não foi configurado.`,
"label.temp.del.conf":`Tem a certeza de que quer apagar?`,
"label.sms.authkey":`Senha de Autenticação`,
"lable.oppt.jieduan.choosejieduan":`Seleccionar a fase fechada`,
"label.tabpage.viewNamez":`Por favor introduza o nome da vista`,
"label.totalQuotation":`Total da cotação`,
"label.tabpage.hoursagoz":`Horas`,
"label.receiveadminnews":`Receber a emissão de notícias da Administrator's News Broadcast`,
"label.field.is.lookup":`O campo é ralado ao campo de pesquisa?`,
"label.any_changes":`Quaisquer alterações feitas aqui também actualizarão o seu rodapé em`,
"lable.products.to.assets":`Confirmar a transferência do produto para o activo?`,
"label.dashboard.compare":`Comparação`,
"vue_label_chatter_notice1":`Após a eliminação do grupo, todas as informações do grupo serão eliminadas, mas os ficheiros do grupo não serão eliminados`,
"label_tabpage_exitz":`Sair`,
"label.potentialcustomerflow":`Processos de Leads`,
"label.longtext":`Área de Texto (Longo)`,
"october":`Outubro`,
"label.customer.email":`Email`,
"label.partnerCloud.productSet.addChildren":`Adicionar Subnível`,
"label.defaultline.cannot.greater":`O número padrão de linhas não deve exceder 30.`,
"front-detail-module-v1-view-report":`Ver Relatório`,
"label.knowledge.setting.hint.sixteen":`Guardar conhecimentos e continuar a transmitir`,
"label.page.use.merged.field":`Com Merge Field`,
"label.salescloud.salescloud.continuerecover":`se continuar, a eliminação será feita e descoberta`,
"front-project-module-v1-from-template-create":`Criar a partir do modelo`,
"label.exportall":`Exportar todos os Registos de todos os Objectos`,
"label.weixin.recalculate.shared.results":`Recalcular os resultados das regras de partilha`,
"label.components.isTemplate":`Dados do modelo`,
"label_emailsync_status":`Estado do e-mail do utilizador`,
"label.file.library.delete":`Tem a certeza que quer apagar {librayrname}？`,
"label.integrations.username":`Nome de utilizador`,
"front-lightningset-module-v1-detail-page-report-chart":`Gráficos de relatório na página de detalhe`,
"label_tabular":`Layout da lista`,
"label.approverecords":`Aprovar`,
"vue_label_helpcenter_topic":`Utilização e Ajuda da Versão Relâmpago`,
"label.h5.date.none":`None`,
"lable.outlook.mcto.allrecord":`Todos os Registos`,
"label.readandwrite":`Leitura/escrita`,
"label.allfold":`Recolher tudo`,
"AD":`Endereço`,
"message.custom.field.donotdelete.reporttype":`O campo é referenciado pela fonte de dados do relatório`,
"label.escalation.setup.newaction.title":`Acção de Escalação Editar`,
"label.dashboard.snapshot.settings":`Definições de snapshots do painel de instrumentos`,
"label.attendance.inner":`Trabalhador de escritório`,
"chatter.ns":`Nova mensagem`,
"label.validate.nowork":`Erro: campo inválido, por favor voltar a seleccionar a localização da mensagem de erro.`,
"label.custom.EmptyCanvas":`Tela transparente`,
"label.service.miniProgram.fillImageOrder":`Por favor, introduza a ordem de carrossel.`,
"label.icon.16":`Serviço`,
"label.selected":`Seleccionado`,
"component_chatter_link_label_name":`Nome da ligação`,
"label.reportsSubscriptionPage.schedulereport.starttime":`Hora de início preferida`,
"label.file.uploadNewVersion":`Carregar nova versão`,
"chatter.group.theMembership":`Adesão`,
"label.knowledge.recommended.articles":`Artigos sugeridos`,
"label.appupload.install.parentobj":`Objecto principal`,
"label.file.recent":`Recente`,
"vue_label_helpcenter_quote":`A cotação representa o preço sugerido dos produtos e serviços da sua empresa. Pode criar cotações a partir de oportunidades e dos seus produtos.<br>?No canto superior direito da informação detalhada, pode utilizar o botão para sincronizar a cotação da oportunidade de negócio, ou sincronizar a cotação com a oportunidade de negócio. Quando a cotação é sincronizada com a oportunidade, quaisquer alterações à linha de cotação serão sincronizadas com o produto da oportunidade, e vice-versa. Cada oportunidade de negócio pode ter múltiplas cotações associadas, qualquer uma das quais pode ser sincronizada com a oportunidade de negócio.<br>?No canto superior direito da informação detalhada, pode gerar pdf e pré-visualizar a cotação, e pode imprimir, descarregar ou guardar directamente.`,
"message.error.field.default":`O valor por defeito deve ser um número inteiro positivo.`,
"label.campaignmember.main.importmember.contacts.desc":`Importar contactos da campanha a partir de ficheiros.`,
"vue_label_calendar_show_only_this_calendar":`Mostrar apenas este Calendário`,
"vue_label_quot_syncfrom":`Sincronização a partir de oportunidades de negócio`,
"label.data.expnode.e_desc2":`2. Exportar por modelo: os utilizadores podem seleccionar o modelo para exportar dados.`,
"label.login.verification.mfa.desc1":`Deve instalar uma aplicação de AMF no seu dispositivo inteligente para continuar. As aplicações comuns que suportam AMF em dispositivos inteligentes são: Onions, Google Authenticator.`,
"label.jiandangfenpei.desc":`Atribuir o acesso da página personalizada actual ao perfil. Os administradores têm acesso a todas as páginas personalizadas.`,
"label_tabpage_thisrecord":`Este registo`,
"lable.SalesCommitmentKanBan.totalPaymentAmount":`Montante de Recibos de Rollup`,
"message.error.object.notvalidcurrency":`Moeda inválida`,
"label.edit.discount":`Editar Desconto`,
"label.setup.mobile.offlinecache.setenable":`Activar a função offline do lado móvel`,
"UG.ST.005":`Já o tenho, não me volte a mostrar esta página e da próxima vez faça o login directamente.`,
"label.assignedapprover":`Aprovador Designado`,
"template.chart.htlx":`Estatísticas do tipo de contrato`,
"scope":`No âmbito`,
"label.workmate.search":`Pesquisar colegas`,
"message.validation.isnotdigits":`Por favor introduza o número inválido`,
"label.ccpeak.use.class.time.page":`Se a classe for chamada por uma página personalizada, chamar o método invoker() na classe PageClsInvoker.`,
"setup_mainpage_label_welcome27":`A plataforma CloudCC fornece funções como a importação, exportação, eliminação de lotes e transferência de lotes de todos os dados de objectos no sistema.`,
"front-epwechat-module-v1-epwechat-integrate":`Integração WeCom`,
"label.file.publiclink":`Ligação pública`,
"front-epwechat-module-v1-input-name":`Por favor introduza o nome da empresa`,
"lable.Number.of.columns":`Colunas`,
"message.error.dev.service.duplicateparameter":`Parâmetros de serviço em duplicado.`,
"label.projectManagement.percent.complete":`Percentagem de Conclusão`,
"label.chatter.nextSevenday":`Próximos 7 dias`,
"chatter.feed.myfollowers":`Os meus seguidores`,
"label.bacchtransfer.pleaseselecttouser":`Transferir para`,
"label_partner_workspace_member_memo":`Todos os utilizadores com perfil seleccionado e conjunto de permissões podem aceder a esta nuvem de parceiros.`,
"label.marketsea.chosen.member":`Membros seleccionados`,
"label.marketsea.assignment.setup":`Definições de atribuição`,
"label.myaccount":`As minhas contas`,
"label.schedulejob.setup.schedule.executedate":`Executar o tempo`,
"label.uploadaccessory":`Upload do anexo`,
"Homepage.News.004":`Nenhuma notícia recente.`,
"label.marketsea.name":`Nome do Pool de chumbo`,
"label.pending.task":`Tarefas Abertas`,
"label.report.details":`Detalhes`,
"UG.homepage.008":`Compreender o estado actual do negócio (briefings de vendas, quadros de liderança, funis de vendas, etc.), visualizar oportunidades de negócio que possam ser problemáticas, prever o desempenho futuro, aceitar e atribuir atempadamente questões importantes, e tomar decisões informadas.`,
"label.h5.similar.opportunity.clear.all":`Limpar tudo`,
"label.tabpage.noz":`Não`,
"label.report.recent.all.reports":`Todos os relatórios`,
"vue_label_lead_to_score":`Clique em Pontuar para pontuar as pistas na vista actual.`,
"vue_label_normal_receivable_sf":`Recebíveis`,
"label.layout.edittabdistribute":`Layout do separador Editar`,
"label.validate.function.funcFormat.PRIORVALUE":`PRIORVALUE(campo)`,
"label.salescloud.field.editoptionlist":`Edição da lista de selecção`,
"APPIntegration.Dropbox.01":`Seleccionar ficheiros da Dropbox`,
"label.campaign.channel.step2":`Passo 2: Configurar os valores padrão do campo de chumbo deste canal de marketing`,
"label_partner_new_function":`Descrição da função`,
"vue_label_chat_no_search_results":`Sem resultados de pesquisa`,
"vue_label_commonobjects_detail_visitstate":`Estado de visita`,
"label.sendemail.send.testemail":`Este é um email de teste, se puder receber este email, pode usar esta caixa de correio para enviar emails.`,
"label.attendance.clear.position":`Pontos de referência claros`,
"chatter.write.n":`Comentário sobre este post`,
"label_chatter_sendmail":`Enviar e-mail`,
"label.remindertime":`Tempo de Lembrete`,
"label.app.elegantgray":`Cinzento Elegante`,
"label.tabpage.ownedz":`Totalmente`,
"label.select.approval":`Seleccione o autorizador`,
"UG.Lead.007":`Google sync`,
"chatter.emailSetUp":`O meu CCChat Lembra a configuração`,
"label.default.censor":`Examinador por defeito`,
"vue_label_notice_uploadavatar_success":`Avatar carregado com sucesso`,
"label.sms.title":`Informação sobre a interface SMS`,
"front-console-choose-contact":`Escolher Contacto`,
"label.field.edit.des":`A pontuação mais alta mostra mais ícones de estrelas, e a pontuação máxima é 100.`,
"label.pw.big.letter":`Caixa alta`,
"label.select.time.dimension":`Por favor escolha a dimensão temporal`,
"UG_Campaign_004":`Campanha de importação`,
"label.dashboard.summary":`Métrica`,
"label.ems.yahoo":`Yahoo!`,
"label.leadscore.rule.name":`Nome da regra de pontuação de chumbo`,
"vue_label_calendar_object_name":`Nome do objecto`,
"label.icon.69":`Máquina`,
"label.reporttotal":`Totais`,
"lable.SalesCommitmentKanBan.theActualContract":`Montante real do contrato`,
"label.project.member.data":`Este utilizador já é um membro do projecto actual!`,
"label.cloudccclass.list.viewremark":`Ajuda para esta página`,
"label.deleteObject.isNotAdministrator":`Não é um administrador e não pode apagar objectos.`,
"lable.edit.queue.nameandemail":`Nome e endereço de e-mail da fila`,
"label.recordtype.tabname":`Tipos de registos`,
"label.file.is.ok":`Está tudo bem`,
"label.knowledge.language.german":`Alemão`,
"label.layout.realityapprover":`Aprovador real`,
"label.ems.with7day":`Dentro de 7 dias`,
"label.autoRegister.changepwd.setpwd.setpwd.button":`Instalar`,
"label.weixin.edit.polls":`Mudança de voto`,
"label.layout.mobile.default.tab":`Seleccione o separador por defeito na aplicação móvel`,
"vue_label_report_deletegroupcolumn":`Eliminar coluna de grupo`,
"label.group.archived.success":`Arquivo com sucesso`,
"label.customfields.formula.returntype":`Tipo de Retorno de Fórmula`,
"label.file.followers":`Seguidores`,
"label.textmessage.new.templates.message1":`O nome do modelo não pode ser empty！`,
"label.selected.field.length":`Não mais de 10 fileds seleccionados`,
"ObjectDetailed_ViewKeyInformation_Layout":`Editar informação chave`,
"label.paging.totalofpage":`Um total de {0} páginas`,
"label.ccchat.message.new.error41":`Para falar com mais pessoas, tente usar grupos`,
"message.recordtype.detail.noselectlist":`Nenhuma lista de selecção pode ser afixada`,
"label.conditiontag.lookup.title":`Seleccione os valores da lista de selecção abaixo para adicionar.`,
"label_partner_setup":`Configurações de nuvens de parceiros`,
"front-epwechat-module-v1-android-packname":`Nome do pacote Android:`,
"lable.custom.Current.CY":`CY actual`,
"label.newprocess2.desc":`Se o desconto for superior a 0,3%, avalia-se como verdadeiro.`,
"label.operatedata.selectobjectfields":`Seleccionar os campos do objecto exportado`,
"report_reportdatasource_label":`Fonte de dados do relatório`,
"label.chosesubject.others":`Outras actividades`,
"label.list.desc2":`Pode gerar uma página de PC para acesso ao lado do PC ou uma página móvel para acesso a dispositivos móveis.`,
"vue_group_several_groups":`grupos {totalSize}`,
"label.page.button.linkurl":`Botão ou Link URL`,
"show.week":`Mostrar fim-de-semana`,
"label.gotocalendar.new":`Ir ao calendário e criar eventos`,
"button.reset.advancedsearch":`Limpar Condições de Pesquisa Avançada`,
"label.h5.chatter.feedandcomnum":`Enviar e deixar uma mensagem`,
"lable.opppdt.addpdt.table.unitprice":`Preço de venda`,
"label.dataimport.validate":`Seleccionar a verificação a ser executada`,
"label.lead.score":`Pontuação de chumbo`,
"vue_label_help_product":`Brochura de produtos e preços`,
"label.role.select":`Seleccionar funções`,
"lable.opppdt.selPdt.searchproduct":`Encontrar Produtos`,
"component_event_label_newevent":`Novos eventos`,
"front-invoice-online-payment-setup-configure-button":`Configurar agora`,
"label.stdashbord.xsld.business.img2":`Quantidade total de fase de oportunidade com 1%-99% de probabilidade`,
"label.event.moveup.2week":`2 semanas à frente`,
"label.partnerCloud.priceOfManual.allCustomer":`Todas as contas`,
"lable.account.dep":`Clique no botão Novo para definir um novo ano fiscal.`,
"label.dataimport.insertdata.error.null.update":`O valor de $schemefield_name$ neste registo é nulo e não pode ser actualizado. O registo ignorou a importação`,
"label_component_helper_businesschange_0activity":`30 dias sem qualquer actividade`,
"lable.account.NextbbDays":`Próximos 60 dias`,
"label_scope_length":`Alcance-Comprimento`,
"label.customfields.operation":`executar uma exportação de dados`,
"serviceappointment.save.workorder":`Por favor escolha uma ordem de trabalho associada ao item da linha de ordem de trabalho.`,
"label.field.update.hide.editor":`Esconder Editor de Fórmula`,
"button.partner.new":`Nova nuvem de parceiros`,
"label.stdashbord.xsld.business.oppdetails":`Detalhes da Oposição`,
"message.pleasewaitingnextversion":`Esta funcionalidade estará disponível no próximo lançamento.`,
"label_tabpage_potentialcustomersz":`Líderes`,
"label_emailtocloudcc_step2":`Passo 2`,
"label.weixin.username":`Nome`,
"label.quickbooks.viewlist.type":`TIPO`,
"front-kefu-moudle-v1-Select-seats":`Escolha o Agente`,
"label.customsetting.manage":`Gerir`,
"label.tabpage.field":`Campo`,
"label.custom.page.button.icon.URL":`URL do Ícone do Botão`,
"font-evaluate-module-v1-evaluation-link":`Adicionar link de avaliação:`,
"vue_label_salesfunnel_notice3":`Quantidade de oportunidades de negócio com uma probabilidade de 1% - 99%`,
"front-email-payment-describe":`Obrigado pelo vosso apoio ao nosso negócio. Pode pagar online através da seguinte ligação, e visualizar, imprimir e descarregar facturas em formato PDF.`,
"label.productsales.today.noevttskaddevt":`Não há eventos e tarefas em aberto, pode clicar em " " no canto superior direito para adicionar um novo evento.`,
"component.setup.iframe.label.memo":`Clique no ícone de definições e introduza o endereço url incorporado.`,
"front-email-payment-select-country":`Favor entrar no país`,
"label.ems.starred":`Correios estrelados`,
"component_setup_label_object":`Objectos`,
"label.query.detail.viewpartneruser":`Ver utilizador parceiro`,
"this.year":`Este Ano`,
"serviceresource.isactive.notactive":`Este serviço não está activado.`,
"label.marketing.message.recipientisnull":`O destinatário não pode estar vazio`,
"label.unfold":`Expandir`,
"label.service.assetBOM.view.tip":`Não tem a permissão para ver a lista técnica de bens. Por favor contacte o administrador.`,
"label.validate.function.funcExplain.ISCHANGED":`Verifique se o valor do campo é diferente do valor anterior. Caso contrário, devolver VERDADEIRO, caso contrário devolver FALSO.`,
"label.validate.function.funcExplain.NOW":`Devolve uma datat e ime representando o momento actual`,
"label.phoenix.islands.time":`Phoenix Is. Hora`,
"vue_label_checkduplicate_complete_filter_rules":`Por favor, complete as condições do filtro`,
"vue_label_report_rowcount":`Contagem de filas`,
"chatter.p":`pessoa`,
"label.umeng.activity.distributetask":`atribuiu-lhe uma tarefa.`,
"UG_quota_05":`Bisync com Oportunidades`,
"june":`Junho`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.tuesday":`Terça-feira`,
"vue_label_commonobjects_view_chart_upto5":`Até 5 grupos`,
"vue_label_opportunity_contactrole_searchallcontacts":`Pesquisar todos os contactos`,
"label.custom.field.task.notice":`Notificação de tarefas`,
"label.weixin.insert.address":`Inserir Localização`,
"label.attachementNew.desc":`Arquivar o anexo a um documento, e o anexo não pode ser apagado.`,
"setup_mainpage_label_welcome18":`As definições de permissões de nível empresarial do CloudCC permitem-lhe controlar os direitos de utilização de utilizadores individuais enquanto trabalha com dados e módulos. As definições de permissões baseadas em funções incluem também posições de utilizador, grupos, funções, regras de partilha de dados, e controlos de segurança a nível de campo para permitir a partilha de dados entre diferentes pessoas e departamentos da empresa.`,
"front-kefu-instance-noarea":`Não foi criada nenhuma instância para esta área, por favor seleccione novamente`,
"label.please.ChooseMax":`Por favor escolha até {a} opções de produtos.`,
"label.businesschance":`Oportunidades`,
"label.verticalline-group":`Colunas Verticais - Agrupamento de Colunas`,
"label.ordering.platform":``,
"label.product.pricebooks.ples":`Por favor seleccione Livro de Preços`,
"vue_label_norm_addcomponent":`Novo Componente`,
"label.ServiceCloud.Installation.address":`Endereço de instalação`,
"vue_label_report_groupcolumn":`Coluna de grupo`,
"label.ccchat.person.invite.notallsucc":`{0} os endereços de e-mail foram guardados mas não enviados. para enviar um convite, corrigir o seguinte erro e clicar em enviar.`,
"label.customfields.optionlist.tip":`Permite aos utilizadores seleccionar um valor a partir de uma lista que define.`,
"UG.activity.07":`Criar uma tarefa`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.last":`Último`,
"label.permission.accessname":`Nome de acesso`,
"lable.custom.year.stadate":`Data de início do Ano Personalizado`,
"label.ems.inputmails":`Receber servidor de e-mail (i)`,
"label.cpq.quote.transfer.order.already":`Esta citação é transferida para encomenda. Por favor, eliminar a encomenda original e depois regenerar uma encomenda.`,
"label.sendletter.status":`Estatuto de Membro da Campanha`,
"vue_label_commonobjects_view_save_as_view":`Guardar como vista`,
"message.mobilechooseatmostfive":`Seleccionar até 5 campos`,
"label.errormessage.batchedit.nopermission":`Nenhum registo de dados que tenha permissão para editar.`,
"label.dataoperate.tip":`Seleccionar a operação e os objectos.`,
"label.enableoperate":`Acções disponíveis`,
"label.ems.usernamepassword.error":`Erro na conta da caixa de correio ou na palavra-passe.`,
"label.campaignmember.selectmember.deletemember":`Retirar membros de`,
"label.Tab":`Tabs`,
"label.emailobject.template.message1":`Por favor seleccione um campo, e clique em "Inserir". Com o ">" significa clicar para ver mais campos disponíveis.`,
"label.approvalstep3.tip":`Especificar o utilizador que deve aprovar os registos que entram nesta etapa. Opcionalmente, escolher se o delegado do aprovador também está autorizado a aprovar estes pedidos.`,
"label.inusing":`Activo`,
"label.edit.select.tre":`Lista de caixas de verificação`,
"label.appointmentconfirmail.wizard.title1":`Olá {0}`,
"label.partnerCloud.financeSetting.setAlipay":`Configurar Alipay`,
"lable.edit.queue.avobj":`Objectos disponíveis`,
"vue_label_checkduplicate_verify_all_characters":`Verificar todos os caracteres`,
"label.huntingzone":`Gama de pesquisa`,
"label.request.approved":`O pedido foi aprovado, não repetir.`,
"label.sharerule.msgerror":`Erro interno do servidor`,
"front-epwechat-module-v1-tick-unbound":`Por favor, assinale e aceite as informações acima não vinculativas`,
"label.console.step6":`Passo 6 Escolha como as listas são exibidas`,
"label.multilang.micropost.vote":`{0} bilhete(s)`,
"message.error.appid.null":`A chave secreta não pode ser nula!`,
"lable.product.delq":`Eliminar Questões`,
"label.h5.approval.leixing":`Tipo de Aprovação`,
"label.edit.field.select.style1":`Azulejo cada opção`,
"label.passwordPolicy.setup.alpandnum":`Deve misturar caracteres alfa e numéricos`,
"label.ems.close2":`Fechar`,
"label.report.reporttypetitle":`Fonte de dados`,
"label.umeng.approval.approvalsuccess":`foi submetido para aprovação.`,
"label.page.showamount":`Total de registos por página:`,
"label.copy.asset.successfully":`Copiar lista técnica de activos com sucesso.`,
"vue_label_homepage_bigscreen_dark":`Escuro`,
"vue_label_email_selected_members":`Membros seleccionados`,
"label.file.preview":`Pré-visualização`,
"label.partner.new.step3.name":`Nome`,
"label.forecast.settings.periods.ago":`ciclo(s) atrás`,
"label.evaluation.praise":`Bom`,
"label.cloudccsite.edit":`Edição do site`,
"label.knowledgebase.advanced.filtering":`Filtro Avançado`,
"label.knowledgebase.framework":`Moldura`,
"vue_label_pool_ownedpool":`Piscina Principal`,
"label.exchange.sync.setting.license":`Com esta funcionalidade activada, alguns dos seus dados organizacionais podem ser guardados no servidor Microsoft Exchange em formato de implementação interna ou de base em nuvem e processados através do servidor Microsoft Exchange.`,
"front-console-conversation-btn2":`Resposta por email`,
"label.projectManagement.thelastone":`Este é o último registo.`,
"message.duplication.confirmscript.mergeoperation":`Estes registos são fundidos num único registo através dos valores seleccionados. Nota: a acção de fundir não pode ser revogada. Tem a certeza de que pretende fundir os registos?`,
"lable.outlook.detail.nosyn":`Fora de sincronia`,
"label.iscopy":`Permitir cópia`,
"message.matrixReportSetupStage.row":`Por favor seleccionar 【Specify Linha Headers】 base subtotal, e deve seleccionar uma base subtotal pelo menos em duas bases subtotal.`,
"label.forecast.forehistory.possibility":`Probabilidade`,
"label.timetrigger.validate":`O valor introduzido deve ser um número inteiro positivo, e o sistema executará automaticamente as acções do fluxo de trabalho quando este deve ser um número inteiro positivo, que é o momento em que a dependência do fluxo de trabalho é satisfeita, o sistema executará automaticamente a operação do fluxo de trabalho.`,
"member.name.choice.field":`O nome do membro é um campo obrigatório !`,
"label.undone_external page":`Isto é irreversível, pelo que é favor confirmar. Este formulário não é utilizado em nenhuma página de login, mas pode ser utilizado noutro local. Por exemplo, pode ter utilizado o código de incorporação para o inserir numa página externa.`,
"UG_Lead_012":`Pistas de importação`,
"component_chatter_label_fans":`Seguidores`,
"label.systeminfo":`Informação do sistema`,
"label.mr.descreption.oneGroupNote1":`Seleccione pelo menos duas peças de dados e clique em [Load Selected Information] para saltar para a página de fusão de dados.<br>Esta é a página`,
"label.wtd.changefields.selfields":`Seleccione os campos a incluir no seu formulário Web-to-CloudCC:`,
"message.error.fileinfoid.null":`fileinfoid não pode estar vazio! Ficheiro de informação id`,
"label_tabpage_cownerz":`Mudança de proprietário`,
"setup_layout_button_save":`Guardar`,
"Dashboard.View.Createdbyme":``,
"label.escalation.setup.detail.order":`Encomenda`,
"button.partner.start":`Comece a usar`,
"label.htyj.remark1":`A sua edição actual não suporta a visualização do objecto do contrato`,
"component.event.label.person":`Pessoa nomeada`,
"label.appointmentconfirmail.wizard.subtitle3":`Localização`,
"label.emailtocloudcc.filed.username":`Endereço de correio electrónico`,
"label.vlidaterule.remark":`Definir uma regra de validação, especificando uma condição de erro e uma mensagem de erro correspondente. O utilizador pode corrigir o erro e tentar novamente.`,
"message.duplication.label.insertoption":`Acção Sobre Criar`,
"front-web-module-v1-detail-comment-toast":`Por favor, complete todas as avaliações`,
"label.import.page2.notsuitedfiledwillbenotimport":`Aviso: O sistema não importará campos não mapeados`,
"label.h5.similar.opportunity.enable":`Possibilitar oportunidades semelhantes`,
"label.allunfold":`Expandir tudo`,
"component_setup_iframe_label_inputurl":`Introduza o endereço url`,
"label.manage.all":`Gerir tudo`,
"label.mobile.side.tab.cs":`Funções comuns`,
"label.datamanage.contact.information":`Informação de contacto`,
"lable.outlook.edit.sel":`Seleccione um valor`,
"label.imgfield.type.url.tip2":`Por exemplo: http://www.cloudcc.com/images/logo.png&cimgSize=50,50`,
"setup.layout.label.areasetup":`Propriedades da Secção`,
"label.date":`Data`,
"vue_label_commonobjects_detail_openfilter":`Expandir o filtro`,
"label.loginip.pagecue":`Introduza a gama de endereços IP válidos a partir dos quais os utilizadores com este perfil podem entrar no sistema.`,
"vue_label_email_not_valid":`O e-mail que introduziu não é um endereço de e-mail válido`,
"label.page.step5.add.application":`Passo 5 Adicionar às aplicações personalizadas`,
"label.dashboard.donot.delete":`Não se pode apagar esta pasta porque alguns painéis de instrumentos nela existentes.`,
"label.visitAPPexchange":`CloudCC App Store (Nova Janela)`,
"label.generate.location":`Gerar dados de latitude e longitude do cliente.`,
"lable.quote.syncing.syncingbutton":`Tradução: Equipa PT-Subs`,
"label.pw.error.text":`As duas palavraspasse que digitou não coincidem.`,
"label_partner_setup_Enable":`Verifiquem`,
"label.file.preview.unav":`Pré-visualização não cavalgáveld`,
"label.sms.tip":`A partir da Internet`,
"setup.mainpage.label.welcome21":`A plataforma CloudCC fornece a função de modelo de email definido pelo utilizador, que é conveniente para os utilizadores utilizarem e melhorarem a eficiência do trabalho.`,
"label.trigger.for.example":`Por exemplo: actualizar a oportunidade no gatilho de actualização da conta, actualizar o gatilho de actualização da conta na oportunidade e accionar o gatilho de actualização da conta. Se não houver nenhum controlo condicional no gatilho, então o sistema permite até 3 chamadas circulares deste tipo.`,
"setup.layout.button.layoutprop":`Adequações`,
"component.chatter.label.fans":`Seguidores`,
"lable.PowerProcess.event.edit":`Editar Marco`,
"label.detailintro":`Descrição dos artigos da linha`,
"vue_label_report_nosearchresults":`Sem resultados de pesquisa`,
"error.name.repeat":`O nome não pode ser repetido.`,
"label.emailEncoding":`Codificação de e-mail`,
"label.partnerCloud.financeSetting.enableAccount":`Activar conta de descontos`,
"label_emailtocloudcc_clear":`Limpar`,
"setup_mainpage_label_welcome12":`O utilizador pode completar a definição do relatório clicando no rato, sem programação, e seguindo os passos rápidos do sistema. O sistema tem um relatório de lista, um relatório de resumo e um relatório de matriz para escolher. Estão também disponíveis opções de visualização para todos os campos. Remover informação desnecessária do campo. Ao mesmo tempo, fornece uma variedade de exibições gráficas incluindo tiras, linhas de dobra, anéis, funis, e bolos, para que os utilizadores possam ver num relance.`,
"lable.SalesCommitmentKanBan.contractStartDate":`Data de início do contrato`,
"front-starter-v1-potential-customer-tips-success":`Activar com sucesso o Pool de Chumbo`,
"UG_Forcast_02":`As previsões são estimativas de vendas esperadas para um determinado período, e os modelos de previsão podem ajudá-lo a determinar a procura de produtos e receitas de vendas num determinado período. Os gestores podem utilizar previsões para estabelecer objectivos e medir o progresso da equipa. A previsão global da organização pode reflectir o resumo de todas as vendas por representante de vendas (independentemente da fase de conclusão das vendas desde a fase de pipeline até à fase de encerramento).`,
"label.escalation.setup.detail.ruleentries":`Entradas de Regra`,
"lable.SalesCommitmentKanBan.allComplete":`Montante Total Completo`,
"label.appupload.install.apicanuse":`O nome da api está disponível`,
"label.organiza.field":`Campos de organização`,
"button.partner.workspace.manage":`Gestão`,
"lable.PowerProcess.setevent":`Marco Marco de referência`,
"label.emailobject.groupemail.msg2":`Falta o endereço de e-mail. Isto impedirá que o e-mail seja enviado para este recibo.`,
"label.h5.orderbyname":`Ordenados pelo nome`,
"vue_label_salesadvance_opportunities":`Número de oportunidade`,
"label.appointment.disable.cancel":`Desactivar o cancelamento`,
"label.trigger.folder.edit":`Página de activação : Editar Pasta`,
"label.customfields.new.step2.opration.unique.info.v2":`Tratar "ABC" e "abc" como valores diferentes (sensível a maiúsculas e minúsculas)`,
"label.icon.40":`Posicionamento`,
"label.eventmenuandlink":`Botões de evento e ligações`,
"label.service.gantt.candidate":`Candidato`,
"label.top.userphoto":`Foto do utilizador`,
"label.appointmentconfirmail.wizard.btn2":`Cancelar reunião`,
"label.print":`Imprimir`,
"saveandreturn":`Salvar e Voltar`,
"lable.account.CurrentandNextCY":`CY actual e CY seguinte`,
"label.group.no.recent1":`Não visualizou nenhum grupo activo.`,
"lable.Asset.conversion":`Gerar bens de acordo com a "Transição de Bens" do produto da encomenda ao transferir bens.`,
"label.emailtocloudcc.button.sure":`Confirme`,
"label.Path.List":`Lista de Caminhos`,
"label.please.rule.name":`Por favor, introduza o nome das regras.`,
"label.knowledge.category.hint.six":`Grupo de Categorias Disponíveis`,
"setup_mainpage_label_welcome28":`Instruções: Clique no menu do lado esquerdo desta página → Gerir Configurações → Gestão de Dados → Importação e Exportação de Dados, Transferência de Lote, Eliminar Lote.`,
"vue_label_commonobjects_view_chart_editchart":`Editar gráfico`,
"label.permission.detail.app.object":`Configuração de objectos`,
"label.multilang.totalpage":`de`,
"label.marketsea.button.return":`Regresso`,
"Click.to.load.more":`Clique para carregar mais`,
"label.validate.globalvariable":`Variável Global`,
"label.marketsea.iseditseabymanager":`Permitir que os administradores alterem o pool de chumbo a que pertence.`,
"label.price.yuan":`Preço (Yuan)`,
"label.service.resource.uesr.tip":`Seleccionar um utilizador para criar recursos de serviço e o tipo de recursos não pode ser a tripulação.`,
"vue_label_help_viewusageguide":`Ver o guia do utilizador da versão Relâmpago`,
"label.autoRegister.changepwd.setpwd.too.long":`Demasiado longo`,
"label.campagin.roi.fwsl":`Número de visitas`,
"label.campaign.mobile":`Aplicação móvel`,
"UG.Lead.012":`Pistas de importação`,
"link.recordtype.detail.backtoobject":`Voltar a Objectos Personalizados`,
"front-kefu-moudle-callcentrt-hasclose":`O Call Center Fechou`,
"label.category.5":`TI Alta tecnologia`,
"label.import.page1.selectwayofdealdata":`Seleccionar o modo de processamento de dados`,
"chatter.emailReceiveEmail":`Receber lembrete de CCChat`,
"vue_label_file_manage_lib_members":`Gerir os membros da biblioteca de ficheiros`,
"label.appupload.upload.overview":`Recapitulação`,
"label.service.miniProgram.inputNumber":`Por favor preencha um número no prazo de 0-999.`,
"label.emailtemplate.finishdetailinfo":`Preencher os detalhes do modelo de e-mail.`,
"label.weixin.fmu.before.day":`{0} dias antes`,
"label.integrations.login":`Login`,
"label.dashboard.setUpHomePage":`A página inicial foi configurada para mostrar`,
"label_partner_common_webSit":`Domínio`,
"front-epwechat-module-v1-unbound-user":`Utilizadores não vinculados`,
"label.partnerCloud.basicSetting.offline":`Activar o Pagamento Offline`,
"label.start.loginip":`Iniciar endereço IP`,
"label.projectManagement.delete.subtasks":`Toda a informação relacionada com esta subtarefa será também apagada se esta subtarefa for apagada, e os dados não podem ser recuperados. Tem a certeza de confirmar a eliminação?`,
"label.message.batchapp":`Aprovação em massa`,
"message.duplication.label.ruletitle":`Regras em duplicado`,
"label.all_networks":`Toda a Rede`,
"label.select_columns":`Seleccione as colunas que gostaria de ver para os seus envios de formulários`,
"vue_label_notice_uploadavatar_exceed":`O tamanho da imagem do avatar carregado não pode exceder 2MB`,
"message.error.get.failed":`Falha na obtenção de informações!`,
"label.quickbooks.viewlist.duedate":`DATA DE DURAÇÃO`,
"label.ccchat.topic.search":`Tópico de pesquisa`,
"label.forecast.shre.manager":`Atribuição de Gestores`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.thursday":`Quinta-feira`,
"lable.product.pricebooks.copy":`Clone do Livro de Preços Existentes`,
"label.instrumentPanel.minLabelname":`Este valor deve ser positivo e inferior ao valor do ponto de quebra 1.`,
"front-market-form-createdsecond":`Campo de preenchimento automático na página de registo`,
"label.submission_detail":`Detalhe da submissão`,
"label.customfields.checkbox.tip":`Permite aos utilizadores seleccionar um valor Verdadeiro (verificado) ou Falso (não verificado).`,
"label.escalation.setup.list.description":`Pode determinar automaticamente as acções quando os casos cumpriram os critérios e para além do tempo especificado. Ao escalar um caso, pode optar por notificar automaticamente o utilizador e reatribuir o caso a um novo utilizador.`,
"UG.Forcast.05":`Configurações de previsão: passo {0}/{1}`,
"label.data.import":`Importação de dados`,
"label.upload.error.cause":`o carregamento falhou devido a`,
"label.search.change.remark":`Aplica-se às definições dos objectos mostrados na barra de pesquisa no lado esquerdo da página inicial`,
"serviceappointment.edit.status.limitwithstatus":`O estatuto da nomeação de serviço não pode ser alterado de {0} para {1}.`,
"label.department.operation":`Operação`,
"label.textmessage.vonage.message3":`Para procurar a chave API e o segredo API, pode entrar na sua conta Vonage API e ir a "Definições" sob o nome da sua conta. Para procurar números de telefone que tem na sua conta Vonage API, pode ir a "Numbers under Products", e clicar em "Your numbers" para ver todos os números de telefone que tem.`,
"label.privacystatement.dialog":`Declaração de privacidade (Nova janela)`,
"label.datamanage.import.leadfield":`Na lista seguinte, seleccione os campos do ficheiro de importação que devem importar leads. Depois clique em seguinte:`,
"label.appupload.upload.install.failar":`Instalar Failed`,
"label.viewall":`Ver tudo`,
"label.sendemail.chat.addComentsfavoritesubject":`CloudCC CCChat responde a Bookmarked`,
"lable.custom.dp":`Esta página permite-lhe definir anos personalizados.`,
"label.mobile.more.share":`Partilhar com Colegas ou Grupos`,
"lable.name.cannot.be.empty":`O nome não pode estar vazio`,
"label.autoRegister.changepwd.setpwd.password":`A sua palavra-passe`,
"label.multipleactivity.aevents":`Evento(s)`,
"label.many.dayline.lastday":`Último dia`,
"lable.Please.bind.the.QuickBooks.record.first":`Por favor, encadernar primeiro os registos do livro rápido.`,
"vue_no_related_dashboards":`Sem painéis de bordo relevantes!`,
"label.newdashboardpage.name":`Nome`,
"vue_label_commonobjects_detail_network":`Rede de Relação`,
"label.tianyancha.reginstitute":`Autoridade de registo`,
"label.the.lower.bound.of.each.level.must.be.equal.to.the.upper.bound.of.the.upper.level.":`O limite inferior de cada nível deve ser igual ao limite superior do nível superior quando a fixação de preços por blocos.`,
"label.chat.file.upload.info":`Carregar ficheiros`,
"label.appexchange.vlidaterule":`Regras de Validação`,
"label.salescloud.salesdashboard.current.business":`Oportunidades actuais`,
"label.app.step4.homeisfrist":`A página inicial deve ser o primeiro separador e não pode ser removida.`,
"label.weixin.micro.research.optionname":`Nome da Micro Survey Choice`,
"label.paging.totalofnbsp":`Um total de {0}`,
"label.opportunity.perm.title":`Pedir Acesso`,
"front-kefu-moudle-v1-zhyzcw-reinput":`Erro de verificação do locatário. Por favor, reentrar`,
"label.unsaved_changes":`Se continuar a operação, as alterações não guardadas serão perdidas.`,
"label_partner_all_description":`Descrição`,
"lable.account.Next.CQ":`Próximo CQ`,
"chatter.feed.menutype.feed.me":`Para mim`,
"label.sourcetranstemp":`Fonte - Produz um ficheiro que contém todo o texto que é traduzível`,
"label.apply.newuser.validate":`Registo de novo utilizador no CloudCC, código de validação:`,
"label.user.password.error":`Erro de nome de utilizador ou senha, ou utilizador inválido!`,
"label.there.is.no.quotation.line.item.in.this.quotation.line.group.at.present.":`Não são encontrados itens de linha de cotação neste grupo de linha de cotação. Por favor clique em "Adicionar Produto" para adicionar.`,
"lable.PowerProcess.time.filed":`Com base no campo de data e hora no {detailInterestType}`,
"label.file.default.value.is.integer":`Apenas números inteiros podem ser introduzidos`,
"label.processsetting.please.select.field":`Por favor, seleccione os campos.`,
"label.app.step3.introduce":`O tamanho do ficheiro de um logótipo de uma aplicação personalizada deve ser inferior a 20 KB. As dimensões da imagem devem ter um máximo de 300 pixels de largura por 55 pixels de altura para melhores resultados. As imagens maiores serão redimensionadas e podem parecer distorcidas.`,
"button_partner_save":`Guardar`,
"label.marketingmanagement":`Marketing`,
"label.isEnableVisualpage_new.leftlist":`Páginas Personalizadas Disponíveis`,
"label.salescloud.teamrole.optionlist.choose.correct":`O mesmo item existe na lista, por favor modifique.`,
"System_ChangeUser_Info_001":`O proprietário mudou e clique para voltar à página anterior.`,
"front-console-no-contact":`Sem Contacto`,
"component.assistant.label.overduetask":`Oportunidades com Tarefas Vencidas`,
"label.roleofpartner":`Papel do parceiro`,
"label.appointmentconfirmpage.wizard.subtitle4-1":`Você e {0}`,
"front-template-V1-Please-select-a-picture":`Por favor escolha uma imagem`,
"lable.SalesCommitmentKanBan.allsignedCommitmentRate":`Taxa de Compromisso Total Assinado`,
"label.h5.similar.opportunity.step2.conment":`Seleccionar entre 3 e 10 campos ou listas relacionadas para comparar quando encontrar oportunidades semelhantes.`,
"label.projectManagement.alert.frequency.will.not.work":`Quando selecciona Não, o lembrete não funciona.`,
"vue_label_fllscreen":`Visualização em ecrã inteiro`,
"label.customfields.selectcontainfieldlayout":`Seleccione os layouts de página que devem incluir este campo.`,
"label.appointment.wizard.subtitle1-4":`45 min`,
"label.tianyancha.businessverify.unagree":`Discordar`,
"label.unique":`Único`,
"setup_mainpage_label_welcome10":`Instruções: Clicar no menu do lado esquerdo da página → Application Settings → Create → Object → Object Name → Custom Layout.`,
"vue_label_account_subsidiary":`Subsidiária`,
"label.dataimport.format.error":`Erro de formato, por favor usar o formato como MM/DD/YYYYY ou YYYY-MM-DD.`,
"label.email.new":`Novo Email`,
"label.log.descri":`Descrição do funcionamento`,
"vue_label_dashboard_componentname":`Por favor introduza o nome do componente`,
"label.weixin.quick.reply":`Resposta rápida`,
"label.productsales.payment.badversion":`A sua edição actual não suporta a visualização do objecto do contrato, pelo que não pode visualizar a lista de pagamento.`,
"label.position":`Localização`,
"label.Annex.Conditions":`Adicionar filtros lógicos para condições adicionais （e.g.：1 e 2 ou 3 ）`,
"label_tabpage_endz":`Fim`,
"label.setup.mobile.bottombutton.prompt":`Aviso: Para guardar estas definições irá alterar as definições originais do utilizador do primeiro nível da aplicação móvel.`,
"lable.Edit.template":`Modelo de Relatório do Serviço de Edição`,
"vue_label_report_onlydisplay2000":`Mostrar apenas dados de 2000`,
"label.salescloud.salesdashboard.sign.account.top5":`Top 5 Contas Assinadas`,
"label.weixin.ontime":`Pontual`,
"font-evaluate-module-v1-disappoint":`Lamento desapontarvos!`,
"chatter.sel.addre":`Podem ser seleccionados até 5 recipientes!`,
"label.mobile.phone.month.summary":`Resumo mensal`,
"label.partnerCloud.priceOfManual.selected":`Conta seleccionada`,
"label.south.georgia.time":`Hora Padrão da Geórgia do Sul`,
"label.create.ccdocument":`Acrescentar anexo`,
"label.chatter.to":`Para`,
"label.ems.minute":`Acta`,
"label.mobile.phone.submit.tome":`Submetido a mim`,
"label.approvalstep1":`Passo 1 Introduzir nome e descrição`,
"label.h5.similar.opportunity.last.months9":`Recentes 6-9 Meses`,
"Opportunity_Detailed_Phase_Label_003":`Mudança de etapa`,
"lable.PowerProcess.time.input":`Por favor, introduza uma hora.`,
"label.stdashbord.xsld.business.yqzsr":`Montante Total Previsto`,
"label.icon.64":`Projector`,
"label.data.choses.i_desc":`De acordo com as suas necessidades, importar dados de um único objecto.`,
"label.integrations.mainlandchinaleads":`China Continental Lidera`,
"vue_label_notice_savemenu_success":`Menu guardado com sucesso`,
"front-kefu-moudle-v1-xzhxzxkf-online":`Escolha o serviço online Easemob`,
"label_chatter_name":`Nome`,
"label.Viewon_Linkedin":`Vista do LinkedIn`,
"lable.PowerProcess.chioce.event":`Por favor, seleccione o marco miliário.`,
"component.chatter.file.label.maxsize":`O tamanho máximo do ficheiro é de 20m`,
"label.validate.function.funcExplain.SECOND":`Devolver segundo do dia (Dos campos Data/Hora)`,
"label.data.downpage.i.title.num4":`4、If tem um campo de relação de pesquisa e um campo de relação de mestre-detalhe no objecto que pretende importar, o valor para esse campo deve ser ID, caso contrário é inválido.`,
"label.icon.139":`Moeda`,
"label.app.step4.atleastone":`O separador Home não pode ser removido.`,
"label.weixin.input.telephone":`Por favor introduza o número do telemóvel`,
"label.setup.mobile.bottombutton.remark":`Uma organização poderia configurar as definições iniciais da página de primeiro nível de acordo com o processo empresarial.`,
"label.file.searchs":`Ficheiros de Pesquisa...`,
"vue_label_email_there_is_no_draft_yet":`Ainda não existe um rascunho`,
"front-kefu-moudle-v1-bind-seats":`Agente de ligação`,
"label.customfields.lookupmuti.tip":`Cria uma relação que liga este objecto a outro objecto. O campo de relação permite aos utilizadores clicar num ícone de pesquisa para seleccionar múltiplos valores de uma lista popup. O outro objecto é a fonte dos valores da lista.`,
"label.integrations.password":`Senha`,
"label.data.newtemplate.t_conditions":`Condições do modelo`,
"message.error.repeatsubmit":`A submissão é repetida ou são abertas várias modificações na mesma página. Se estas últimas, por favor submeter na janela recém-aberta.`,
"label.umeng.approval.approvalreassign":`O pedido de aprovação para o #obj é reatribuído. #objnome`,
"lable.edit.queue.selobj":`Erro: A fila deve ter pelo menos um objecto seleccionado`,
"label.compact.layout.frame":`Moldura da página`,
"label.sms.companyname.dsf.infor":`Este serviço apenas apoia a China continental`,
"template.report.individual.case.source":`Fonte do caso`,
"pagecreator.button.pcpage":`Pc fim`,
"vue_label_commonobject_selectdatatime":`Escolher data e hora`,
"label.icon.181":`Ficheiro`,
"label.loginip.setup.please":`Por favor especifique a gama IP.`,
"vue_label_dashboard_?secondarygroup":`Por favor seleccione um grupo secundário`,
"lable.outlook.mcto.pleasedes":`Introduza os domínios de correio electrónico aos quais não deseja associar, e separe-os por ",".`,
"DetailedInfo_Activity_EmailMessage_01":`{0} enviar um e-mail para {1}.`,
"label.sendmail.step4":`Passo 4 Os e-mails que submeteu estão a ser processados.`,
"label.monitorsys.delete.source":`Descrição`,
"label.monitorsys.log.datetime":`Descarregar registo de auditoria de operações-chave dentro do intervalo de tempo de pesquisa(Excel.xls)`,
"component_chatter_label_myfans":`Os meus seguidores`,
"label.tianyancha.h5.registereddate":`Data de registo`,
"label.multilang.feedtrack.operatecreate":`{0} o registo tem sido created：`,
"label.console.step6.no":`Escolha como as listas são exibidas`,
"four":`Quatro`,
"message.confirmsetpwdforuser":`Redefinir palavra-passe para novos utilizadores?`,
"label.cape.verde.time":`Hora de Cabo Verde`,
"label.queue.new":`Nova fila`,
"label.cloudccsite.start":`Página Principal do Site Activo`,
"label.data.exp.way":`Método de exportação`,
"label.lock.record.donot.delete":`Não se pode apagar os registos bloqueados.`,
"label_emailtocloudcc_filed_type":`Fornecedor`,
"frame_personinfo_label_minipic":`Imagem em miniatura`,
"label.checkfield.choosetab":`Seleccione os campos para encontrar réplicas`,
"component.setup.tabs.label.default":`Página predefinida`,
"page.404.button.toknowmore":`Saiba mais`,
"vue_label_SMS_message_sent_cannot_be_empty":`O conteúdo da mensagem enviada não pode estar vazio`,
"label.lookupreplaceselectvalue":`Encontrar e Substituir a Lista de Recolha`,
"pagecreator_layout_button_new":`Novo layout`,
"label.mobile.more.upload":`Carregar Nova Versão`,
"front-kefu-moudle-v1-Connection-failure":`A ligação falhou`,
"label.version.support.unlimited":`Apoio Ilimitado`,
"message.error.notmarketseamember":`Não é membro do grupo principal`,
"label.taskandincident":`Tarefas e Eventos`,
"label.report.export.print.title":`Imprimir Visualizações de Relatórios`,
"label.file.publicview.error2":`A ligação pública não está correcta, por favor use uma nova ligação pública`,
"label_chatter_cancel":`Cancelar`,
"front-web-module-v1-detail-comment-satisfied":`Nível de Satisfação`,
"label.knowledge.delete.topic":`Erro ao eliminar o assunto utilizado neste artigo de conhecimento.`,
"label.forecast.forehistory.all":`Todos`,
"label.displaybutton":`Botões mostrados`,
"label.icon.148":`Robô`,
"label_tabpage_ok":`Confirme`,
"label.checkfield.merge.mainrecord":`Registo mestre`,
"label.notification.arketsea.restored":`{5} restaurado {2}  {0}：{1}`,
"setup.mainpage.label.welcome31":`Instruções: Clique no menu do lado esquerdo desta página → Gerir Configurações → Criar Aplicação →`,
"front-kefu-moudle-v1-jtrrt-connect":`Associar os utilizadores do CloudCC às extensões do TRRT`,
"vue_label_calendar_please_select":`Por favor seleccione o campo apresentado`,
"setup.layout.label.pagename":`Nome do layout da página`,
"template.chart.schdywjhz":`Valor da Oportunidade de Campanha`,
"label.access_report":`Quem pode aceder a este relatório?`,
"label.assignment.layout.section.optional":`Disponível em`,
"label_chatter_recently":`Recentemente`,
"lable.chat.advanced.setting":`Configuração avançada`,
"label.knowledge.category.hint.eight":`Categoria Grupo`,
"message.error.facebookuid.null":`O ID de utilizador do Facebook não pode estar vazio!`,
"label.step5.total6":`Passo 5 de 6`,
"label.is.cancel.delete":`Cancelar a eliminação?`,
"setup_mainpage_label_welcome11":`Relatório personalizado`,
"label.answers":`Respostas`,
"label.approvalstep1.tip":`Introduza um nome, descrição, e número do passo para a sua nova etapa de aprovação.`,
"template.chart.htjeph":`Valor do Contrato Ranking`,
"label.campaigns.onsiteregistration":`Registo no local`,
"front-epwechat-module-v1-input-agentid":`Por favor, introduza agentId`,
"label.emailobject.wizard.desc2":`Rastrear e-mails a serem abertos e horários de abertura`,
"label.multilang.chatterdetial.vote":`{0} bilhete(s)`,
"label.customsetting.manage.value":`Dados personalizados`,
"front-electronic-export-listCount":`{totalVer} dados no total na vista actual, seleccionar os dados importados`,
"label.dashboard.create.prompt":`Não é possível criar painéis de instrumentos sobre relatórios tabulares.`,
"label_tabpage_askz":`O que gostaria de perguntar`,
"label.ems.sentmail":`Caixa de saída`,
"label.reportlist.untop":`Não fixado`,
"label.owner.h5.plzchose":`Por favor seleccione o proprietário e guarde`,
"label.callcenter.addup.10.pieces":`Adicionar 10 dados, no máximo, uma vez`,
"label.ccdocument.save":`Guardar documento`,
"label.productcannotnull":`O produto não pode estar vazio`,
"label_tabpage_enabletomobile":`Se deve activar o lado móvel`,
"lable.account.CYAgo":`2 CY Ago`,
"lable.Select.the.returned.high.seas.pool":`Seleccionar pool devolvido`,
"tuesday":`Terça-feira`,
"label.partnerCloud.basicSetting.partnerPayment":`Activar o Fundo de Parceiros`,
"label.validate.function.funcExplain.WEEKDAY":`Devolver um dia específico da semana. 1 representa o domingo e 7 representa o sábado`,
"label.query.detail.manageexuser":`Gerir Utilizadores Externos`,
"vue_label_systemSettings_environment":`Ambiente`,
"component_setup_tabs_label_delete":`Eliminar`,
"label.weixin.delete.ccchat":`Tem a certeza de que quer apagar este post?`,
"label.lanxin.title":`Lanxin-H5Micro App`,
"label.layout.editcondition.morethanten":`Pode seleccionar até 10 campos como critério de pesquisa.`,
"label.project.hit.fourteen":`Aviso de Actualização de Marcos`,
"label.createby":`Criado por`,
"label.moreoperation":`Mais Operar`,
"label.lock.tip":`Bloquear os registos de serem editados`,
"label.check.input.condition.three":`Tipo de campo de fórmula e resumo de rollup não são suportados para inserir`,
"label.quote.dingjia":`Fixação de preços`,
"label.currentuseremail":`O endereço de e-mail actual do utilizador`,
"UG_homepage_004":`Automação`,
"chatter.link":`Ligação`,
"label.new.zealand.standard.time":`Horário de Verão da Nova Zelândia`,
"APPIntegration.Dropbox.setting.02":`Deficientes`,
"label.version.searchandmerge":`Verificar Duplicação & Fusão`,
"label.allmenus.showmsg.nomenu":`Não encontrei o menu！`,
"front-template-V1-Enable-disable":`Activar | Desactivar`,
"label.marketing.setting4":`O registo regressa com sucesso ao URL padrão`,
"UG.Forcast.07":`Permitir previsão`,
"vue_label_systemSettings_correlation":`Modo de exibição da lista relacionada`,
"label.cloudccsite.remark.length":`Permite aos utilizadores introduzir até 255 caracteres`,
"label.favorite":`Favoritos`,
"template.report.converted.leads":`Leads convertidos`,
"label.campaignmember.main.description":`Utilize esta página para gerir memebers de campanha. Pode adicionar novos membros à campanha ou actualizar o estado actual dos membros da campanha.`,
"label.salescloud.teamrole.account.organization":`Os membros da equipa podem ter um nível mais elevado de acesso a esta conta do que as definições de acesso por defeito da sua orgnização.`,
"label.permission.modifyAppPermission.canselectapp":`Aplicações disponíveis`,
"front-epwechat-module-v1-self":`Instalação de aplicações autocriadas`,
"message.duplication.label.matchexactletters":`Exacto`,
"label.appointmentdetail.wizard.title18":`Plano de sexta-feira`,
"label.area":`Territórios`,
"label.sso.saml.sp.username":`Nome de utilizador`,
"lable.outlook.new":`Nova Configuração de Sincronização de Troca`,
"label.custom.field.close.conversion":`Fechado - Convertido`,
"lable.outlook.detail.tmaping":`Campos de Tarefas do Mapa`,
"label.emailobject.emaildetail.nextactivity.event":`Acrescentar um evento`,
"vue_label_commonobjects_detail_date":`A data de fim não pode ser inferior à data de início`,
"vue_label_email_mark?as":`Marcar como`,
"label.guestgroup":`Equipas de contas`,
"label_emailtocloudcc_filed_server":`Servidor`,
"label.icon.186":`Consultoria`,
"label.department.user.edit":`Editar`,
"label.custom.page.component.button.settings":`Configuração dos Botões Componentes`,
"label.partnerCloud.orderingPlatform.nextProduct":`Quer guardar a configuração actual do produto e configurar o próximo produto?`,
"vue_label_appstore_cloud_platform":`plataforma oficial da nuvem`,
"label.page.previous":`Anterior`,
"label.direct.dashboard.week.report":`Nova Nota de Trabalho Semanal`,
"label.ServiceCloud.prompt.warning":`Sem estatísticas de distribuição de recursos por endereço.`,
"label.emailtocloudcc.position":`Posição`,
"vue_label_email_please_enter_the_message_content":`Por favor introduza o conteúdo do correio`,
"labal_About_to_jump":`Em breve será redireccionado.`,
"label_profile_mobile_setup_stand":`Página inicial padrão`,
"label.visualpage.component.n3":`3.Parâmetros. Os parâmetros estão escritos nas args propertites ,args="nome:'zhang', idade:26" Note aspas duplas simples.`,
"vue_label_report_operationmode":`Modo de funcionamento do relatório`,
"label.reportsSubscription.select.attached.file":`Por favor seleccione o tipo de ficheiro anexo.`,
"label.afghanistan.time":`Tempo Afeganistão`,
"label.vlidaterule.formulatrue":`Se esta expressão de fórmula for?verdadeira, exibir o texto definido na área de Mensagem de Erro`,
"label.ccchat.person.invite.erroremail":`O formato do endereço de correio electrónico está incorrecto.`,
"label.viewDashboard":`Ir para Lista de Painéis`,
"label.at":`em`,
"label.notification.arketsea.beforeretrieve":`O seu {0}：{1} vai ser reciclado para {2}，remaining tempo: {6} dias`,
"label.field.update.show.editor":`Mostrar Editor de Fórmula`,
"label.weixin.polls.time":`Data da votação`,
"vue_label_commonobjects_detail_activity_nostarttime":`Sem hora de início`,
"label.direct.dashboard.me.not.approval70":`Itens de Aprovação Pendentes Submetidos por Mim`,
"label.data.setok.t_desc3":`, Operação.`,
"label.view.edit.search.describe":`Pesquisa após introdução de palavras-chave`,
"label.importsourcefiletip":`Antes de importar o seu ficheiro separado por tabulação traduzida, certifique-se do seguinte: <span><ul><li>1.Crie um ficheiro separado para cada língua que gostaria de importar que contenha apenas o nome e a tradução.</li><li>2.O atributo de língua no topo de cada ficheiro é necessário. O atributo de idioma é assim\uff1aLanguage=en_US.</li><<li>3.para se certificar de que os seus ficheiros de importação são guardados na codificação UTF-8 antes de importar.</li>4.certifique-se de introduzir o avanço de linha no fim do ficheiro que pretende importar.</li></ul></span>`,
"UG.Case.01":`Caso`,
"label.weixin.report.filters":`Filtros`,
"vue_label_homepage_profilehomepageassignment":`Atribuição da página inicial do perfil`,
"label_tabpage_editview":`Vista de edição`,
"label.tabpage.allpotentialcustomers":`Todas as pistas`,
"label.sendemail.send.standbyemail":`(caixa de saída de reserva)`,
"errormessage.email.atleastonereceiver.z":`Deve seleccionar ou editar um endereço de recepção.`,
"workflow.action.tasks.assignortype.ownertype":`Tipo de proprietário`,
"label.list.userinterface.new.page.setup":`Nova página`,
"chatter.seladress":`Por favor, seleccione pelo menos um destinatário.`,
"Pagelayout_Setup_004":`Podem ser definidos até 4 campos`,
"label.mobile.home.page.tenbig.opp":`Top 10 Oportunidades nos próximos 30 dias`,
"label.wtd.changefields.newpc":`Gerar Página PC`,
"label.opportunity.perm.remark":`Isto é uma oportunidade privada,por favor contacte o "owneridccname" <br> proprietário para obter acesso.`,
"label.data.exp.tempdes":`Descrição do modelo`,
"label.appointment.wizard.subtitle2-1":`A partir de`,
"lable.currencyManage.button.manageexchangeRate":`Gerir Taxas de Câmbio Datadas`,
"label.file.viewinfo":`Ver detalhes do ficheiro`,
"label.integrations.mailchimp.export.failed":`A exportação de dados falhou, por favor verifique a sua ligação à rede e tente novamente`,
"pagecreator_page_button_edit":`Editar`,
"label.icon.86":`Briefcase`,
"label.exchange.sync.reset":`Reset Sync`,
"label.customfields.lookupfilter":`Pode criar um filtro para limitar os registos que estão disponíveis para o utilizador no campo Lookup.`,
"label.component.hotdeal.nopermission":`Para ver os seus dados relacionados com oportunidades de negócio, contacte o seu administrador do CloudCC.`,
"label.address.province":`Estado`,
"lable.PowerProcess.3digit.input":`Não mais do que três dígitos.`,
"label.asset":`Bens`,
"label.passwordPolicy.setup.nopwdremember":`Nenhuma senha lembrada`,
"front-electronic-signature-setting-intro2":`Antes de iniciar um contrato, por favor prédefinir o modelo na plataforma DocuSign. Ao iniciar a assinatura, pode seleccionar o modelo de contrato prédefinido.`,
"pagecreator.page.button.new":`Nova página`,
"label.tabpage.step2":`Etapa 2 especificar as condições do filtro`,
"label_switch_two_column_or_responsive_layout":`Mudar para layout de duas colunas ou responsivo`,
"label.batchDelete":`Eliminação em massa`,
"chatter.edit.ct":`Edite as suas informações de contacto.`,
"UG_ST_003":`Não tem permissão para criar {0}, por favor contacte o administrador, clique em confirmar para ir directamente para a interface {0}.`,
"label.timzone.tip.info2":`Ao utilizar o formato de data simples para formatar a data, deve definir fusos horários para instâncias de formato de data simples, tais como SimpleDateFormat myDateFormat=novo SimpleDateFormat("yyyyy-MM-dd");myDateFormat.setTimeZone(TimeUtil.getUserTimeZone(userInfo));ou obter uma instância utilizando o método de ferramenta fornecido por TimeUtil, SimpleDateFormat myDateFormat=TimeUtil.getSimpleDateFormat("yyyyy-MM-dd",userInfo);`,
"label.ems.firstsynchistory":`Pela primeira vez sincronizar os mails desde há quanto tempo`,
"label.currency.invalid":`Moedas inactivas`,
"label.mask.custom":`Personalizar`,
"lable.opppdt.addpdt.title":`Seleccionar Produto`,
"label.appointment.wizard.subtitle3-3":`Quarta-feira`,
"label.weixin.report.criteria":`Agrupados por`,
"label.appupload.upload.install.uninstall":`Incapaz de instalar`,
"label.compact.layout.frame.split":`Exibição em ecrã separado`,
"label.email.attach.complete.info":`Após o carregamento estar completo,o ficheiro será apresentado na lista de anexos abaixo`,
"label.Receivables":`Contas a receber`,
"label.linkedin.title.setting":`Informação integrada do LinkedIn`,
"label.companynotice":`Anúncio da empresa`,
"label.emailobject.discard":`Descartar`,
"label.selected.searchfield":`Campo de resultados de pesquisa seleccionado`,
"front-electronic-signature-explainDocusign":`DocuSign Esignature Descrição:`,
"chatter.link.name":`Nome da ligação`,
"label.low":`Baixo`,
"label.verticalline":`Colunas Verticais`,
"label.approval.isallowed.reject.label":`Permitir a rejeição ao aprovar dados únicos?`,
"label.emailtocloudcc.button.enable":`Activo`,
"label.dashboardSetup.showdw.d5":`Unidade Inteira`,
"label.usermanage.not.authority":`Não dispõe de permissões suficientes para o fazer.`,
"label.customobjects.track.introduce0":`Esta página permite-lhe seleccionar quais os campos a seguir na lista relacionada com {0} "Field Tracking". Sempre que um utilizador modificar qualquer dos campos seleccionados abaixo, o valor do campo antigo e o valor do novo campo, bem como a data, hora, características da alteração, e o utilizador que faz a alteração são adicionados à lista relacionada com "Rastreamento de Campo".`,
"canlendarmonth":`Mês do calendário`,
"vue_label_dashboard_minimum":`Por favor introduza o mínimo`,
"label.salescloud.optionlist.inputname.linealone":`Introduza um ou mais valores da lista de selecção abaixo, com cada valor separado por uma nova linha.`,
"message.error.organuzation.information.null":`Não existe informação sobre a organização.`,
"label.tabpage.maxfilez":`O tamanho máximo do ficheiro é`,
"message.validation.apiname":`Deve começar com uma letra. Deve conter apenas letras,números,e sublinhado. Deve conter apenas letras maiúsculas e minúsculas,números,e sublinhado. E o comprimento máximo é de 50 caracteres, o comprimento mínimo é de 2 caracteres.`,
"report.type.label.contractPayment":`Contratos e Contas a Receber`,
"label.limiting.choose.three.files":`Pode seleccionar 3 ficheiros, seleccionados agora.`,
"label.reportTypeFocus":`Foco da fonte de dados do relatório`,
"Report_Delete_Confirm_Title":`Por favor confirme`,
"front-gantt-module-reorder-milestones":`Reordenar marcos`,
"front-starter-v1-customer-tips-success":`Activar o pool de contas com sucesso`,
"label.tabpage.isdeleteview":`Tem a certeza de apagar esta vista?`,
"label.favorite.title":`Plataforma CloudCC`,
"page.layout.sysinfo":`Informação do sistema`,
"label.tabpage.pleaseSelectz":`Seleccione por favor`,
"label.smsnotice":`Notificações SMS`,
"label.forecast.customforecast.foretype.Pipeline":`Gasoduto`,
"label.rejectbehaviour":`Comportamento de Rejeição`,
"label.searchlayout.view.example.new":`Ver exemplo (Nova Janela)`,
"vue_label_homepage_notice2":`Pode atribuir manualmente o layout da página inicial, facilitando aos empregados a realização eficaz das suas tarefas diárias`,
"label.import.index.chooseidorother":`3、You pode escolher usar o ID ou nome para corresponder ao registo e preencher o campo de pesquisa. Se precisar de adquirir o ID do registo correspondente e outras informações, pode criar um relatório e definir o nome do registo e o ID do registo como colunas de grupo, e depois exportar o relatório.`,
"label.westem.european.summer.time":`Tempo da Europa Ocidental`,
"label.brackets":`Parênteses`,
"asset.serialnumber.unique":`O número de série do activo já existe, por favor não o adicione repetidamente.`,
"label.callcenter.access.keyID":`Acesso à chave de identificação secreta`,
"label.calendar.month.view":`Vista do Mês`,
"label.realdelete":`Eliminar permanentemente`,
"label.partnerCloud.orderingPlatform.amountPaid:":`A ser pago:`,
"label.reportTypName":`fonte de dados do relatório Nome`,
"lable.newtabpage.opensearchresult":`Expandir resultados da pesquisa`,
"front-kefu-moudle-v1-Session-duration":`Duração da Sessão:`,
"label.import.index.ignore":`Ignorar`,
"label.customfields.url.tip":`Quando os utilizadores clicam no campo, o URL abre-se numa nova janela ou numa janela actual de acordo com as configurações dos utilizadores, e o padrão é abrir o URL numa nova janela.`,
"label.projectManagement.editMilestone":`Editar Marco`,
"front-gantt-module-v1-project-gantt-list":`Lista de projectos`,
"label.validate.remark":`As regras de validação ajudam a melhorar a qualidade dos dados, impedindo que os utilizadores guardem dados incorrectos. É possível definir uma ou mais regras de validação que consistem numa condição de erro e na correspondente mensagem de erro. As regras de validação são executadas em tempo recorde de economia de tempo. Se uma condição de erro for cumprida, a gravação é abortada e é exibida uma mensagem de erro.`,
"front-kefu-moudle-v1-sjgsbzq-reinput":`O formato do número de telefone está incorrecto. Por favor, reentrar`,
"label.channel.name":`Nome do canal`,
"label.weixin.cloudcc.user.message":`Informação aos utilizadores do CloudCC`,
"label.icon.59":`Workshop`,
"label.ccpeak.function":`Método`,
"lable.opppdt.selPdt.leastten.fields":`Por favor seleccione até 5 campos`,
"label.deadline":`Prazo de entrega`,
"label.product.sel":`Selecção do Livro de Preços`,
"vue_label_helpcenter_detail2":`Todos os eventos: Mostrar todos os eventos a que tem acesso, mesmo que não esteja a participar.<br>     Pode também filtrar os registos de actividade que deseja visualizar com base no intervalo de datas e tipo de actividade.<br>    4. Dynamic<br>      Todas as pessoas que podem ver este registo podem deixar uma mensagem e publicar sob a coluna "Dynamic" do registo, e também podem ver todas as alterações de informação, as últimas actividades, e os comentários e publicações de outras pessoas sobre este registo. Esta coluna facilita a comunicação e colaboração em linha entre si e os seus colegas, ajudando a melhorar o trabalho de equipa e a eficiência.<br> Posting<br>     Passo 1: Clique na barra de postagem e introduza o conteúdo da postagem<br>     Passo 2: Clique no botão Ficheiro/Link para adicionar um ficheiro/link conforme necessário<br>       Passo 3: Clique em "Partilhar" para terminar a postagem. <br> Ver post<br>     Depois de o post ser publicado com sucesso, pode ver o micro-post que acabou de publicar abaixo. O micro-post é composto pelas seguintes partes: avatar, nome da pessoa, conteúdo do micro-post e métodos de interacção (como/comentar/editar/apagar post). <br> Ordenar e encontrar posts<br>     Clique na lista suspensa à direita de "Ordenar" para alterar a ordenação dos posts. <br>       ordenação "Última Actividade": ordenar pelo último tempo de interacção dos micro-postes;<br>     "Último Post "Ordenar": Organizar pelo tempo de publicação dos micropontos;<br>      Ver diferentes tipos de micropontos<br>     Micropontos de texto simples: Navegue por todo o conteúdo directamente na área de publicação do micro-post;<br>     ;  Micro-postes contendo ficheiros: clique no botão de descarga do ficheiro para descarregar o ficheiro localmente para visualização;<br>     Micro-postes contendo ligações: clique na ligação do micro-post para abri-lo;<br> Comentar e gostar de micro-postes<br>     Commenting<br>   Passo 1: Clique em "Comentar" abaixo de cada micro-post <br>     Passo 2: Introduza o comentário na caixa de texto que abre<br>   Passo 3: Adicionar o ficheiro/link ao comentário conforme necessário Passo 4: Clique em "Comentário" sob a caixa de texto para completar a operação<br>     Apagar comentário<br>    A editora do comentário pode apagar o conteúdo do comentário. Clique no botão à direita do comentário e seleccione "Delete" (Eliminar) na caixa pendente.`,
"pagecreator_layout_button_mergecell":`Fundir células`,
"Lead_Scoring_Setting_Rule_Setup_Active":`Activo`,
"label.query.detail.loginbypartneruser":`Login por utilizador parceiro`,
"label.view.selectrenderfields":`Seleccione os campos a exibir`,
"label.code.add":`Acrescentar informação sobre a ligação do código QR`,
"label.appointmentconfirmpage.wizard.title1":`REUNIÃO AGENDADA`,
"label.timzone.tip.title":`Quando se lida com datas usando nova data() ou calendário, deve-se ter o cuidado de lidar com as questões de fuso horário múltiplo correspondentes. além disso, a classe de ferramentas de timeutil fornece uma série de ferramentas que suportam fusos horários múltiplos.`,
"label.tag.addtags.visibility":`Visibilidade`,
"label.appointmentconfirmpage.wizard.title3":`Tem a certeza de cancelar a marcação existente e fazer uma nova marcação?`,
"lable.outlook.detail.oldest":`Mais antigo`,
"label.account.custom.quarter.timeerror":`A Data de início ou a Data de fim de trimestre personalizada está entre os trimestres personalizados do histórico, por favor verifique e reinicie`,
"label.sendsms.idea":`Respeitado`,
"label.manageAll.pagenum2":`Esta é a última página.`,
"serviceterritory.isactive.notactive":`Este território de serviço não está habilitado.`,
"label.userinfo.newpwd.notnull":`Por favor introduza a sua nova palavra-passe.`,
"vue_label_dashboard_nolinkagedashboard":`Sem tablier de ligação`,
"message.cannotdeleteapproval":`Não se pode eliminar este processo de aprovação.`,
"label.wtd.detail.m":`Móvel`,
"label.app.step4.introduce":`Escolha os separadores a incluir nesta aplicação personalizada.`,
"label.ccchat.error.permission":`Sem acesso`,
"UG_opportunity_009":`Ou`,
"label.Receivables.TheActualAmountOfMoney":`Recibos reais`,
"label.callcenter.no.search":`Nenhuma pergunta relevante para a informação`,
"label.user.introduce":`Utilizadores`,
"message.datalocked.addpdt":`Este registo de oportunidade está bloqueado, não se pode adicionar Pruduto.`,
"label.sendsms.step1":`Passo1: Especificar destinatários`,
"label.brief.contracts":`Contratos`,
"label.setup.mini.swap":`Colocação do carrossel`,
"label.emailobject.wizard.desc1":`Ligue o seu e-mail, envie o correio aqui e sincronize automaticamente com o registo`,
"label.login.verification.mfa.desc2":`Se não conseguir verificar por algum motivo, tal como perder ou apagar por engano aplicações de AMF no seu telefone, poderá ter ouvido o administrador desvincular a AMF.`,
"label.notification.receiveSms.message":`Recebeu uma mensagem de texto de {!fromaddress}, clique para ver mais detalhes`,
"label.emailmerge.mergeFolder.publicfolder":`Modelos de fusão de emails públicos não arquivados`,
"label.password.update.false":`Não foi possível alterar a palavrapasse, por favor contacte o administrador!`,
"label_tabpage_systemz":`Sistema(s)`,
"label.dataimport.objectid.null":`O ID do objecto está vazio e não pode ser importado`,
"label.currency.type":`Tipo de moeda`,
"component_setup_button_appurl":`Sistema url`,
"label.appointmentconfirmail.wizard.title2":`Tem uma agenda {0}`,
"lable.product.please.enter":`Por favor, introduza`,
"label.escalation.setup.title":`Regras de Escalação de Casos`,
"label.create_failure":`Falha na criação da forma`,
"label.weixin.brand.model":`Modelo de marca`,
"label.layout.nameoftestobj2":`Nome do objecto de teste dois`,
"vue_label_filters_number":`São suportados 10 arquivadores para cada relatório.`,
"label.file.following":`A seguir`,
"vue_label_account_all_contracts":`Transferir todos os contratos dos proprietários dos clientes`,
"label.service.please.select.cycle.type":`Por favor seleccione o tipo de ciclo`,
"label.weixin.weipoll.optionname":`Nome da Escolha do Micro Voto`,
"label.data.newtemplate.null":`Nenhum`,
"message.passwordPolicy.validate.complexReq1":`Erro:A sua palavra-passe deve ter uma mistura de letras e números`,
"label.forecast.shre.editmanager":`Gerente Editar`,
"label.emailtemplate.tip":`Abaixo está uma lista de todos os seus modelos de correio electrónico na pasta seleccionada. Clique no novo botão para criar um novo modelo de texto ou HTML para e-mail. Pode utilizar estes modelos de correio electrónico ao enviar um único correio electrónico.`,
"label.tag.manage.button":`Gerir Etiquetas`,
"label.changepw":`Alterar Palavra-passe`,
"label.sso.saml.sp.idsource.nameid":`A identidade está no elemento NameIdentifier da declaração Assunto`,
"label.salescloud.teamrole.addmember":`Adicionar membros do Grupo de Oportunidades CloudCC`,
"label.h5.similar.opportunity.last.months6":`3-6 meses recentes`,
"message.save.opportunity.role.save.failed":`Falha em salvar o papel de contacto`,
"vue_label_report_formulainformation":`Informação sobre a fórmula`,
"label.area.assignuser.remark":`Atribuir Utilizadores ao Território`,
"label.multilang.viewlist.total":`{0} Seleccionado`,
"label.newprocessstep4":`Passo 4 Seleccionar Modelos de Notificação por Email`,
"label.permission.objectpermission.open":`Aberto`,
"label.service.gantt.close.list":`Fechar lista`,
"label.standarduserfield":`Campos de utilizador padrão`,
"vue_label_commonobjects_detail_the_administrator":`O registo foi bloqueado, por favor contacte o administrador.`,
"label.exchange.sync.account":`Credenciais da conta do Serviço de Troca de Credenciais`,
"label.mr.title.button.back":`voltar, e redefinir os critérios de pesquisa`,
"label.notsetup.operation":`Erro de condição da linha, nenhum operador foi definido.`,
"label.notifications_center":`Notificações Cente`,
"label.event.moveup.5hour":`5 horas à frente`,
"report_label_pleaseinput":`Introduza o que pretende pesquisar`,
"label.batchadd.newbatchpage.errorlist":`A adição de dados falhou`,
"label.quickbooks.invoices":`Facturas`,
"chatter.feed.usingchatter":`Ligue o CCChat, os seus utilizadores podem seguir algumas pessoas ou registos e postar.`,
"label.all.marketing.activities":`Proprietário da campanha de mercado`,
"label.lookup.finish":`Auto-Completamento de Pesquisa`,
"label.weixin.unbind":`Desobstruir`,
"front-console-closeTime":`Tempo de fecho`,
"label.service.rest.time":`Tempo restante`,
"label.mr.descreption.condition1":`Introduzir o âmbito e as regras para encontrar registos duplicados. Clique em [Find Duplicates] para obter registos duplicados qualificados.`,
"label.group.new":`Novo Grupo`,
"vue_label_SMS_sending_please_wait":`Envio, por favor aguarde`,
"label.Standardobj.tab":`Separadores de objectos padrão`,
"label_chatter_pastEvents":`Actividades passadas`,
"label.chatter.priority":`Prioridade`,
"select.nullvalue":`-None-`,
"setup_layout_group_pagecomponent":`Componentes da página`,
"label.dataimport.dataerror.check":`Erro de dados, por favor verifique os dados.`,
"label.permission.detail.app.pagesetting.tip":`Definições de Permissões de Páginas Personalizadas Excedidas`,
"label.knowledge.language.polish":`Polaco`,
"label.project.hit.two":`Lembrete de expiração da subtarefa`,
"label.customerapp":`Aplicação personalizada`,
"label.reportsSubscriptionPage.condition.value":`Valor`,
"label.tabpage.no2z":`No2`,
"lable.system.administrator":`Desculpe, não tem acesso para operar. Por favor contacte o administrador.`,
"homepage.layout.buttion":`Atribuição do layout da página`,
"label.notification.event.overlapEvent":`O utilizador delegado já foi atribuído a um evento {subject} a partir de {begintime}-{endtime}, quer criar este evento de qualquer forma`,
"label.customfields":`Campos personalizados`,
"label.data.downpage.e.title":`Passos para a exportação de dados`,
"label.notification.serviceappointment.remove":`A sua encomenda de trabalho enviada {0} foi cancelada, por favor organize razoavelmente o seu trabalho.`,
"label.campagin.roi.zhuangtai":`Situação da campanha`,
"label.applt.updown":`Descarregar o Código QR do Miniprograma`,
"label.customfields.new.step1.tip":`Especificar o tipo de informação que o campo personalizado irá conter.`,
"label.staticresource.upload.limit":`Apenas ficheiros nestes formatos podem ser carregados: png, jpg, gif, js, css, zip.`,
"chatter.edit.user.p":`Mudar Foto do Utilizador`,
"label.icon.32":`Computador`,
"vue_label_homepage_notice_cantset":`A página inicial do perfil não está configurada para este perfil, a página inicial padrão do perfil não pode ser modificada`,
"front-epwechat-module-v1-agree-unbound":`Concordar e aceitar as informações acima referidas sem compromisso`,
"label.version.chatter.cooperation":`CCChat`,
"label.customer.tab.step1.selectstyle":`Por favor, escolha um estilo de separador.`,
"label.select.an.asset":`Por favor, seleccione um bem.`,
"label.search.sizer.field":`Pesquisar campos de filtros`,
"label.emailmerge.mergeFolder.lastone":`Por favor, seleccione pelo menos um modelo.`,
"label_tabpage_step2":`Etapa 2 especificar as condições do filtro`,
"label.version.lead.automatic.allocation":`Regras de Atribuição de Chumbo`,
"label.projectManagement.update.succeeded":`Actualização com sucesso`,
"label_tabpage_bar":`Bar`,
"label.appupload.component.type.tab":`Tab`,
"label.pigeonhole.sel.f":`Escolha as pastas a arquivar`,
"homepage.components.status":`Estado dos componentes`,
"label.currency.edit.new":`Currency Edit: Nova moeda`,
"label.input.new.password":`Por favor introduza a nova palavrapasse correcta`,
"chatter.group.membersName":`MMeMber Nome`,
"label.myinfo.modify":`Edição de Informação Pessoal`,
"label_tabpage_next":`Próximo Passo`,
"vue_label_homepage_card_closedopportunities":`Oportunidades Fechadas`,
"label.permission.edit":`Editar Propriedades`,
"message.error.searchfield.objid.null":`A identificação do objecto requerida pelo campo de consulta não pode estar vazia`,
"label.partnerCloud.productSet":`Configuração do produto`,
"label.emailtocloudcc.filed.emailto":`Envie um e-mail para`,
"label.service.miniProgram.uploadingImage":`Por favor, carregar imagem carrossel.`,
"label.sso.saml.idp.description1":`Aplicações ligadas`,
"label.event.moveup.10minutes":`10 minutos à frente`,
"label.quote.createby":`Preparador`,
"label.workflow.baseontimeoparate":`Acções de fluxo de trabalho dependentes do tempo`,
"label.searchall.r":`Pesquisar novamente`,
"vue_label_homepage_differentprofiles":`Atribuir diferentes homepages a diferentes perfis`,
"label.campaign.channel.step1":`Passo1: Informação`,
"label.event.moveup.2hour":`2 horas à frente`,
"font-evaluate-module-v1-cancle-reply":`Cancelar autoresposta`,
"message.datalocked.delete":`Não se pode apagar este registo porque estava bloqueado. Se desejar apagá-lo, contacte por favor o administrador.`,
"label.sso.listOfKey":`Lista de chaves`,
"label_chatter_newtask":`Nova tarefa`,
"label_emailsync_form_seversetting":`Configuração`,
"label.partner.new.function":`Descrição da característica`,
"vue_label_notice_homepage_pleaceentername":`Por favor introduza o nome da página inicial`,
"message.please.choose.opportunity":`Por favor seleccione oportunidade de negócio`,
"label_file_use_most_user":`Utilizadores com o espaço de armazenamento mais utilizado`,
"label.htyj.remark2":`por isso não pode ver os montantes contratuais`,
"label.formula.message":`quando a fórmula é avaliada como false，the pronto para a submissão de falhas`,
"UG_Case_04":`Atribuição de casos`,
"label.displaycolumn":`Mostrar Colunas`,
"vue_label_campaign_selected_member_status":`Actualização para o estatuto de membro seleccionado`,
"label.workflow.operate":`Acções de fluxo de trabalho`,
"label_chatter_mail":`Correio`,
"label.setup.mini.setting":`Definição de Mini-Programas de Backgroud`,
"vue_label_chat_invitetojoin":`Convidou "{convidar}" a juntar-se ao chat do grupo`,
"setup.object.field.dependency.label.linkedfieldvalue":`Campo Dependente`,
"vue_label_email_update_template":`Modelo de actualização`,
"label.email.template.private.mail":`Pasta Exclusiva de Modelos de Email`,
"lable.Confirm .potential.customers":`Confirmar para reciclar chumbo {nome}`,
"vue_label_leadpool":`Pool de chumbo`,
"label.ems.hostorpost.error":`Erro de configuração do servidor ou da porta,verifique por favor.`,
"label.search.saveok":`Poupar com sucesso`,
"label.custom.field.cannot.maping":`Incapaz de mapear para este campo várias vezes`,
"label.projectManagement.dispatched":`Enviado`,
"time":`Hora`,
"label.choose_socialnetwork":`Escolha uma rede social para começar`,
"label.vlidaterule.checkedtrue":`Se a fórmula for caixa de verificação, não há necessidade de aspas duplas`,
"label.appointmentconfirmail.wizard.btn1":`Reprogramar`,
"front-kefu-moudle-v1-maxchars-input":`Podem ser introduzidos até {0} caracteres`,
"setup.mainpage.label.welcome10":`Instruções: Clicar no menu do lado esquerdo da página → Application Settings → Create → Object → Object Name → Custom Layout.`,
"label.ems.company.setup.title":`Configurar a caixa de correio electrónico da empresa`,
"label.channel":`Canais`,
"label.textmessage.groupsms":`Grupo SMS`,
"label.asset.deleted.successfully":`Eliminar a lista técnica de activos com sucesso.`,
"label.knowledgebase.new.workspace":`Novo Espaço de Trabalho`,
"label.ServiceCloud.diliweizhi":`Localização`,
"label.private_me":`Privado para proprietário (eu)`,
"label.service.miniProgram.imageLink":`Ligação Carrossel`,
"label.area.assigned":`Utilizadores Atribuídos`,
"label.weixin..xsld.name":`Nome da oportunidade`,
"label.campaign.matchway.select.name":`Nome`,
"label.installedsoft":`Pacotes instalados`,
"label.projectManagement.spare.time":`Tempo disponível`,
"label.user.select.custom.text.sendemail":`Seleccionar formato de texto personalizado para enviar correio electrónico directamente`,
"label_chatter_chatter":`CCChat`,
"label.approveorrefuse":`Aprovar/Rejeitar`,
"startdate.enddate.time.illegal":`A data de início deve ser inferior ou igual à data final.`,
"label.project.hit.eight":`Lembrete diário de tarefas`,
"message.duplication.label.uncheck":`Não-verificação`,
"label.allocation.role":`Atribuir Utilizadores`,
"label.sendemail.lead.scoreinfo":`Caro #nome de utilizador:{r}o sistema pontuou todas as pistas das visualizações das pistas que seleccionou "#viewlabel" com base nas regras de pontuação das pistas. é necessário #timestr.{r}n por favor inicie sessão e abra a visualização para verificar os resultados.\Atenção: Se não conseguir ver a pontuação das pistas que marcou, por favor edite a vista e adicione "lead scoring" ao campo para ver o resultado da pontuação.rr] Obrigado e com os melhores cumprimentos!r] #orgname`,
"lable.oppt.jieduan.closejieduan":`Fechar esta oportunidade`,
"label.ems.verify":`Verifiquem`,
"message.error.startdate":`A data de início deve ser anterior à data final`,
"label.campaignmember.main.deletelead":`Retirar as Leads dos Membros`,
"label.partnerCloud.financeSetting.account":`Após a activação do fundo parceiro, os objectos do fundo parceiro e a declaração do fundo serão adicionados. Os utilizadores parceiros podem utilizar a conta no CloudCC para pagar as encomendas.`,
"message.datalocked":`o seu registo está bloqueado. Se precisar de o editar, por favor contacte o seu administrador.`,
"lable.opppdt.selPbk.pricebook":`Livros de preços`,
"label.knowledgebase.restore.article":`Restaurar o Artigo?`,
"label.object.batchadd":`Adicionar Lote {objNome}`,
"label.what_happen":`Página após a submissão do formulário`,
"label.roleandunderling":`Papéis e Subordinados`,
"label.knowledge.language.russian":`Russo`,
"front-electronic-signature-explain-first":`Antes de vincular a assinatura E, recomendase que se registe e certifique na plataforma Fadada.`,
"component.sendmail.label.subject":`Tema`,
"month":`Mês`,
"label_chatter_save":`Guardar`,
"label.view.sortview.sectiontitle":`A vista será apresentada na ordem seleccionada`,
"label.mobile.home.page.major.project":`Projectos-chave`,
"label.weixin.input.filename":`Por favor introduza o nome do ficheiro`,
"label.pagelayout.remark":`Esta página permite-lhe criar diferentes layouts de página para mostrar`,
"label.service.miniProgram.store":`História da marca`,
"label.recordtype.edit.selected":`Valor seleccionado`,
"message.selectgroupcondition":`Favor seleccionar as condições de agrupamento`,
"label.y.axis.cannot.empty":`O eixo Y não pode ser nulo`,
"label.textmessage.vonage.connected.count":`Conte como Contacto`,
"setup.layout.label.readonly":`Read-Only`,
"front-kefu-moudle-service-agent":`Serviço ao cliente`,
"message.login.mfaverification.page.invalid":`A página é inválida, por favor actualize.`,
"label.central.standard.time":`Tempo Padrão Central`,
"label.processnoticepic":`Imagem de atenção do processo de aprovação`,
"vue_label_helpcenter_calendar1.2":`Regras de exibição de entradas de calendário: as entradas de calendário serão exibidas na grelha de calendário, e a área da grelha onde a entrada de calendário está localizada representa o intervalo de tempo do registo. As entradas de calendário que abrangem mais de 24 horas serão exibidas no topo da escala de tempo no dia, semana, e vistas de disponibilidade. Se houver múltiplas entradas de calendário numa grelha na visualização do mês, pode clicar em " Mais" para as visualizar. O lado esquerdo ou direito da entrada de calendário é um semicírculo, o que significa que não existe tal registo no dia anterior ou seguinte da grelha. O lado esquerdo ou direito da entrada do calendário é arredondado em ângulos rectos, indicando que ainda existe este registo no dia anterior ou no dia seguinte da grelha. <br> Localizar rapidamente a data na vista do calendário: É possível localizar o intervalo de datas apresentado na vista de calendário à esquerda, seleccionando a hora no pequeno calendário no lado direito da página do calendário. Também pode clicar nos ícones "<" e ">" no canto superior direito da página do calendário para mudar rapidamente as datas. Se a hora da sua vista de calendário não for a hora actual, pode clicar no ícone "Hoje" no canto superior direito da página de calendário para mudar rapidamente para hoje. <br> Vista de lista<br> Mudar da vista de calendário para a vista de lista: Clique no ícone "calendário" no canto superior direito da vista de calendário e seleccione "tabela" para mudar para a vista de lista de eventos. <br> Utilização da vista de lista: Para visualizar eventos específicos ou múltiplos eventos ao mesmo tempo, abra a vista de tabela. Existem vistas de lista predefinidas na vista de lista. Clique no ícone "drop-down" no canto superior esquerdo da vista de lista para exibir todas as vistas de lista a que tem acesso. Também pode personalizar a visualização da lista de eventos para satisfazer as suas necessidades. <br> 2. O meu calendário e outros calendários<br> O meu calendário<br> O meu calendário contém o meu calendário de eventos e o calendário de objectos. <br> O meu calendário de eventos: Mostrar todos os registos de eventos onde a pessoa designada é sua na visualização do calendário. O meu calendário de eventos não pode ser removido, editado ou alterado a cores. Pode partilhar "O Meu Calendário de Eventos" com os seus colegas.`,
"label.approval.end":`Fim`,
"vue_label_report_notice_cannotdelete":`Há relatórios nesta pasta que não podem ser apagados`,
"label.sso.saml.idp.loginurl":`URL de login do idP`,
"label.emailtocloudcc.filed.port":`Porto`,
"label.directdashboard.righttitle":`Painéis de Análise de Vendas`,
"label.knowledge.case.suggest.article":`Artigos sugeridos em casos`,
"label.version.maxcount":`para além do limite.`,
"label.weixin..xsld.yjqyrq":`Data de fecho`,
"front-project-module-v1-unmarket-is-template":`Template desmarcado`,
"label.mobile.quickcreate.default.map":`Mapa`,
"chatter.click.p":`Clique para pré-visualizar`,
"label.chat.topic.all.topic":`Todos os Tópicos`,
"label.channel.head":`Supervisor do Canal`,
"lable.edit.queue.emaildes":`Introduzir o nome da fila e o endereço de correio electrónico a utilizar ao enviar notificações (por exemplo, quando um caso tiver sido colocado na fila). O endereço de correio electrónico pode ser para um indivíduo ou para uma lista de distribuição. Quando um objecto é atribuído a uma fila, apenas os membros da fila serão notificados.`,
"label.tag.filter":`Filtro de etiquetas`,
"label_chatter_filterTimeLine":`Linha de tempo de filtragem`,
"label.dashboard.show.value":`Mostrar valores`,
"vue_label_normal_solution_sf":`Solução`,
"label.customfields.location.tip":`Permite ao utilizador definir a localização. inclui componentes de longitude e dimensão que podem ser utilizados para calcular distâncias.`,
"label.weixin.copyright":`Copyright© 2008-2022 CloudCC.com,inc. Todos os direitos reservados por CloudCC.com`,
"label.icon.33":`Computador`,
"label.mr.title.opportunityName":`Nome da oportunidade`,
"template.report.sales.month":`Vendas deste Mês`,
"chatter.group.lookingForPeople":`Comece a dactilografar um nome`,
"label_tabpage_userz":`Utilizadores`,
"label.reportsSubscriptionPage.email.formatselection":`Por favor seleccione o formato de relatório que pretende obter através do e-mail`,
"lable.product.plist":`Preço de Lista`,
"label.multilang.activity.monthline":`Semana {0}`,
"label.ccchat.whose.name.contains2":`Membros de qualquer grupo de campanha`,
"label.mobile.phone.day.report":`Notas de trabalho diárias`,
"label.processsetting.set.files":`Campos definidos`,
"label.systemlog.s":`Sucesso`,
"label.tabpage.uploadsz":`Carregar`,
"serviceterritory.member.time.conflict":`Dentro deste intervalo de tempo, os recursos de serviço tornaram-se membros de outros territórios de serviço.`,
"label_chatter_startDate":`Dados de início`,
"label.search.at.least.two":`Os termos de pesquisa não devem ser inferiores a 2 caracteres.`,
"label.approval.ressign.project":`Itens a atribuir`,
"lable.custom.Previous.CY":`CY anterior`,
"label_chatter_link":`Ligação`,
"label.weixin.group.name":`Nome`,
"label.partnerCloud.basicSetting.domainName":`A operação é irreversível e o nome de domínio não pode ser alterado depois de inicializado. Tem a certeza de confirmar a operação?`,
"lable.SalesCommitmentKanBan.targetContract":`Montante do contrato alvo`,
"label.currency.new":`Nova Moeda Corporativa`,
"message.passwordPolicy.validate.complexReq3":`Erro:A sua palavra-chave deve ter uma mistura de números e letras maiúsculas e minúsculas, e caracteres especiais.`,
"label.icon.127":`Médicos`,
"label.customfields.fieldname.tip":`O nome do campo é uma referência interna e é utilizado para fins de integração, tal como o API.`,
"chatter.feed.menutype.feed":`Resumo`,
"label.home.standard.dashboard.role":`Não tem informação de papel, pelo que não pode visualizar o painel de compromisso de vendas.`,
"label.customfields.fielddependency.button":`Clique no botão para incluir ou excluir valores seleccionados da lista de selecção dependente`,
"label.recentprojects":`Artigos recentes`,
"label.appupload.logo.introduce":`O logótipo da embalagem deve ser inferior a 20KB. As dimensões da imagem devem ter um máximo de 60 pixels de largura por 60 pixels de altura para melhores resultados. As imagens maiores serão redimensionadas e podem parecer distorcidas.`,
"label.integrations.northamericanleads":`Líderes Norte-Americanos`,
"label.sms.balance":`Equilíbrio (yuan)`,
"label.ccchat.message.num":`Notícias`,
"label.embed_website":`Para incorporar este formulário, basta copiar e colar o código abaixo no código HTML do seu website.`,
"label.trigger.check.error":`A verificação da sintaxe do gatilho falhou.`,
"label.bmap.baidu.maps":`Mapas Baidu`,
"label.nextapproverauto":`Próximo Aprovador Automatizado Determinado por`,
"label.customfields.date.tip":`Permite aos utilizadores introduzir uma data ou escolher uma data a partir de um calendário popup.`,
"button.partner.back":`Regresso`,
"label.layout.editcondition.tip":`Seleccione os campos que pretende utilizar como critérios de pesquisa. Note que pode seleccionar até 10 campos.`,
"label.stacked.area":`Área Empilhada`,
"font-evaluate-module-v1-case-closed":`Apenas quando o caso é encerrado`,
"label_emailsync_status_log":`Registo de ligação`,
"label.version.area.and.sales":`Equipa de Gestão e Vendas do Território`,
"label.service.booking.sessions":`Tempo de nomeação de serviço`,
"label.untransfile":`Não traduzido`,
"label.textmessage.sentfail":`Falha no envio`,
"label.emailtemplate.detailinfo":`Detalhes do modelo`,
"setup_mainpage_label_welcome13":`Instruções: Clique no menu superior → Relatórios → Novo`,
"label.ccchat.error.nullid":`O ID não pode estar vazio`,
"label.partnerCloud.partnerAccount.rebate":`Receitas de Rebate`,
"label.appupload.component.type.scheme":`Campo`,
"front-kefu-moudle-phonein":`Chamada recebida`,
"label.emailmerge.list.description":`Os modelos de fusão de correio são documentos MicroSoft Word com campos de fusão que fazem referência aos campos CloudCC.com.`,
"vue_label_commonobjects_detail_select_first":`Por favor, seleccione primeiro os itens relacionados`,
"label_emailsync_form_action":`Acção`,
"label.customfieldrelation":`Campos personalizados e relações`,
"label.ems.other.msg":`Por favor, conteúdo CloudCC admin(<a href='mailto:admin@cloudcc.com' style='text-decoration: sublinhado;'>admin@cloudcc.com</a>), iniciar o serviço de sincronização de correio.`,
"label.appointment.wizard.subtitle4-3-4":`1 h`,
"label.service.miniProgram.isOpen":``,
"equal":`igual a`,
"label.partnerCloud.financeSetting.merchantInformation":`Caminho de acesso: Plataforma do comerciante  Centro de contas  Informação do comerciante`,
"vue_label_calendar_displayed_field_name":`Nome do campo apresentado`,
"UG_opportunity_002":`Defina o seu ciclo de vendas, configure a fase`,
"label.tag.addtags.button1":`Guardar`,
"label.explain":`Instruções`,
"label.icon.166":`Pavilhão`,
"label.exchange.sync.setting.use":`Activar o Exchange Sync`,
"label.chatter.assignPerson":`Pessoa nomeada`,
"lable.PowerProcess.event.condition":`Condições de Marcos`,
"label.addattachment.step1":`Passo 1 Seleccionar o ficheiro`,
"label.account.fiscal.quarter.timeerror":`A data de início do trimestre fiscal ou a data de fim do trimestre fiscal está entre os trimestres fiscais históricos, por favor verifique e reinicie`,
"label.URL":`URL para referência`,
"label.icon.134":`Dados`,
"label.forecast.customforecast.foredis.sq":`Milhares`,
"label.custom.field.number.decimal":`Número de dígitos errado.`,
"label.version.history.track.error":`A sua versão apenas suporta a selecção de <=5 campos, não pode seleccionar mais campos.`,
"label.log.os":`Sistema operativo`,
"label.partner.workspace.tab.option":`Separadores disponíveis`,
"label.partnerCloud.partnerAccount.accountWater":`Declaração do Fundo`,
"setup_layout_label_norelatedlist":`Nenhuma lista relacionada`,
"label.import.page1.nextstep":`Próximo`,
"label.emailobject.view.attached":`Emails com anexos`,
"label.SalesCommitmentKanBan.allTask":`Montante total da tarefa`,
"label.eastem.daylight.time":`Horário de Verão do Leste`,
"label.create_engaging":`Criar um posto atractivo para se ligar ao mundo.`,
"label.area.adduser":`Adicionar ou eliminar utilizador`,
"label.timezone.importtimezone.user":`Usar o fuso horário de login do utilizador`,
"label.passwordPolicy.setup.pwdremember1":`1 palavra-passe lembrada`,
"label.query.detail.openpartneruser":`Habilitar o utilizador parceiro`,
"label.senduser":`Enviar de`,
"Pagelayout_Setup_001":`Por favor, seleccione as listas relacionadas que seriam exibidas no esquema de flutuação.`,
"label.mobile.parameter.setup":`Definições de aplicações móveis`,
"message.device.not.bound.mfa":`Dispositivos AMF não vinculados`,
"setup.layout.label.buttonarea":`Área de Botões`,
"chatter.email.reply.like":`Comentários sobre um artigo de que gosto`,
"label.chatter.day":`Dia`,
"label.sendemail.chat.addComentspraisesubject":`CloudCC CCChat responde que o post gostou`,
"label.field.remark2":`página.`,
"label.ggReleaseRange.release":`Gama de publicações`,
"lebel.alreadyback":`Relembrado`,
"label.appupload.install.appname":`Nome do aplicativo`,
"label.selectnewadeckertag":`Seleccionar a etiqueta para o novo campo de hierarquia`,
"label.cliententrancewebsiteadmin":`Administrador do Portal do Cliente`,
"label.checkbox.checked":`Seleccionado`,
"UG.Case.03":`Actualização automática de casos`,
"vue_label_dashboard_group":`Por favor seleccione um grupo`,
"label.import.index.preparedata":`Prepare os dados que pretende importar`,
"vue_label_member_notice1":`Pode carregar ficheiros JPG, GIF ou PNG, o tamanho máximo do ficheiro é de 2M`,
"message.modify.success":`Modificação bem sucedida.`,
"label.userquotas":`Cotas`,
"label.appointmentpage.wizard.subtitle3-1":`Nome`,
"label.import.index.maxdata2":`2、Before importando, certifique-se por favor de importar primeiro todos os registos relacionados com o mesmo. Por exemplo, se houver uma relação de pesquisa entre o objecto que está actualmente a importar e os contactos, por favor importe primeiro esses contactos, e depois importe os seus dados. Se precisar de obter o ID do registo correspondente e outras informações, pode criar um relatório e definir o nome do registo e o ID do registo como uma coluna de grupo, e depois exportar o relatório.`,
"label.pc.sectionpart":`Secção PC`,
"template.chart.wcldqzkh":`Líderes não processados`,
"label.save.the.block.pricing.information.of.the.current.price.manual":`Quer guardar a informação de preços em bloco do livro de preços actual?`,
"label.partnerCloud.financeSetting.payments":`Permitir o pagamento online`,
"lable.account.ThisWeek":`Esta Semana`,
"label.validate.function.funcFormat.RIGHT":`DIREITO(texto, num_chars)`,
"label.app.select.bgcolor":`Seleccionar cor de fundo`,
"label.planned.work":`Trabalhos planeados`,
"label.passwordPolicy.setup.nolimit":`Sem limite`,
"label.vlidaterule.s":`Se desactivar a moeda utilizada pelo utilizador, a moeda do utilizador será definida para a Moeda Corporativa.`,
"label.paging.totalofrecords":`Um total de {0} registos`,
"label.customobjects.behaviour":`Acções`,
"vue_label_ccchat_notice_deletecommentsuccess":`Comentário eliminado com sucesso`,
"label.lock.record.dele":`O disco está bloqueado, não é possível apagá-lo.`,
"label.data.expnode.e.desc3":`3、Template Criar: o utilizador pode fazer o modelo de acordo com os campos e condições que serão exportados para satisfazer as suas necessidades, o que é conveniente para utilizar na próxima vez.`,
"label.button.step3.create.page":`Passo 3 Geração de páginas`,
"label.sharer":`Partilhar de`,
"label.service.cycle.type":`Tipo de ciclo`,
"lable.SalesCommitmentKanBan.allreceivingCommitmentRate":`Taxa de Compromisso Total de Recibos`,
"label.formuladate":`Formato da data: aaaa-MM-DD hh:mm:ss ou MM/DD/YYYYYhhh:mm:ss, como por exemplo: 2007-12-25 12:25:30 ou 25/12/2007 12:25:30.Pode também utilizar hoje() ou agora();`,
"front-template-V1-addImg":`Adicionar imagem`,
"label.basecontrol":`Acesso básico`,
"label.forecast.settings.lable1":`Agregação de Dados Previstos`,
"message.error.file.null":`O ficheiro de upload não pode estar vazio`,
"label.multiply":`*Multiply`,
"message.duplication.label.targetobject":`Objecto`,
"label.addattachment":`Acrescentar anexo`,
"vue_label_dashboard_notice_editcertification":`Tem a certeza de que quer editar o componente {nome}?`,
"label.notification.tip2":`Sem Novas Notificações`,
"lable.quote.syncingfrom.firstsync":`Inicial Sync: Oportunidade de citação`,
"label.createtasktip":`Criar uma tarefa para associar a uma ou mais regras de fluxo de trabalho, processos de aprovação, ou processos de atribuição de direitos. Ao alterar uma tarefa, quaisquer modificações serão aplicáveis a todas as regras, aprovações, ou processos de direitos a ela associados.`,
"label.leave":`Sair`,
"front-invoice-online-payment-setup-china":`Aplicar às contas chinesas`,
"label.appointment.wizard.subtitle4-1-2":`30 min`,
"label.projectManagement.the.person.not.be.informed":`Quando selecciona Não, a pessoa responsável não pode ser notificada!`,
"label.campagin.roi.name":`Nome da campanha`,
"label.import.page1.newcreate":`Criar`,
"label.data.downpage.i.title.num2":`2、Before começa a importar, certifique-se de que o nome do campo no ficheiro que pretende importar corresponde ao nome do campo objecto no CloudCC.`,
"label.callcenter.call.in":`Chamada em`,
"label.weixin.activity.phone":`Actividade: Chamada`,
"label.forecast.customforecast.type.role":`Por Função`,
"label.moscow.standard.time":`Hora Padrão de Moscovo`,
"label.profile.setcustomobjectrecordtype":`Definições de tipo de registo personalizado`,
"lable.edit.queue.new":`Nova fila`,
"label.newAPPexchange":`Nova aplicação...`,
"message.custom.field.donotdelete.fieldupdate":`Este campo é referenciado por uma actualização de campo num outro fluxo de trabalho ou processo de aprovação.`,
"label.chatter.state":`Estado`,
"label.subject_line":``,
"template.report.folder.active":`Análise de campanhas e acções`,
"label.icon.114":`Casa`,
"label.assignment.setup.newentries.step3":`Passo 3 Seleccionar o utilizador a quem atribuir o chumbo`,
"label.salescloud.salesdashboard.sales.behavior.rankings":`Visão Geral do Comportamento Pessoal`,
"label.weixin.optiontwo":`Escolha 2`,
"label.sso.saml.idp.config.sp":`Prestadores de serviços`,
"System_TimeField_Description":`Permite aos utilizadores entrar a uma hora local. Por exemplo, "14:40 PM", "14:40" e "14:40:00" são todas horas válidas para este campo.`,
"label.knowledgebase.draft":`Projecto`,
"label.chat.topic.no.more.suggestions":`Nenhuma outra sugestão`,
"label.quote.product":`Produto`,
"label.cryptographictext":`Texto Encriptado`,
"label.custom.unlock":`Desbloquear`,
"label.assignment.setup.newentries.step2":`Passo 2 Seleccionar os critérios para esta entrada de regra`,
"label.tabularreport.selectline":`Seleccione as colunas que pretende incluir no relatório.`,
"label.exchange.sync.state.contact.m2":`Os registos foram sincronizados nos últimos 60 minutos:`,
"label.codeType":`Tipo de código`,
"saturday":`Sábado`,
"label.mask.type":`Tipos de Máscaras`,
"label.schedulejob.setup.schedule.Monthly":`Mensal`,
"label.import.page2.totalfiled{{20}}，{{4}}notsuited":`文件中共{{20}}个字段，剩余{{20}}个未映射

{{20}} campos no ficheiro , {20}} não mapeados`,
"label.projectManagement.delete.item":`Todas as informações relacionadas com este projecto serão apagadas se o projecto for apagado, e os dados não podem ser recuperados. Tem a certeza de confirmar a eliminação?`,
"label.page.general.us.and.western.europe":`Línguas gerais dos EUA e da Europa Ocidental`,
"label.reportsSubscription.status":`Subscrevido`,
"label.discount.baifenbi":`Desconto (%)`,
"font-evaluate-module-v1-web-page-evaluation-settings":`Configuração de Avaliação Web`,
"message.error.searchwork":`As suas palavras-chave introduzidas devem ter 2 ou mais caracteres.`,
"label.weixin.option.setting":`Definições de escolha (até 10 escolhas)`,
"label.lead.score.prompt1":`Marcar um único registo de chumbo automaticamente ao criar ou editar. Mas é necessário pontuar manualmente vários registos de chumbo, ao importar ou criar por interface.`,
"label.exception.must.try.throw":`As excepções devem ser atiradas para fora num bloco de estaca.`,
"label.activity.plan":`Plano`,
"label.partnerCloud.productSet.editor":`Opção de edição`,
"label.mobile.quickcreate.default.signinnew":`Iniciar sessão`,
"label.summaryreport.2018.step6.new":`Passo 6 Seleccionar o tipo de gráfico e o item em destaque`,
"vue_label_homepage_owner":`A minha página inicial`,
"vue_label_dashboard_editfoldersuccessfully":`Editar pasta com sucesso`,
"label.quickbooks.view.overdueinvoices":`Facturas em atraso`,
"label.emailtocloudcc.redmessage4":`Por favor introduza os detalhes da porta`,
"label.tabpage.equalz":`Igual a`,
"lable.quote.syncing.firstsync":`Initial Sync: Citação para Oportunidade`,
"label.download.CloudCCAPP":`Descarregar o CloudCC App`,
"label.icon.6":`Moeda`,
"label.list.serial.number":`Número de série`,
"label.profile.setstandardobjectrecordtype":`Configurações de tipo de registo padrão`,
"label.customize.memory.function.sorting.error":`O tempo de resposta da consulta é demasiado longo e provoca um timeout da página. Pode ser porque a Memória de Ordenação de Cabeçalhos está activada. Por favor, vá para as configurações pessoais e desactive esta função.`,
"message.view.addtoallusers":`Visibilidade dos utilizadores relacionados`,
"label.globaloperation.operationtype.record.phone":`Registar uma chamada`,
"lable.opppdt.selPdt.searchresult":`Resultados da pesquisa`,
"label.import":`Importação`,
"label.service.gantt.work.based.resources":`Recurso Baseado em Horas de Trabalho`,
"label_partner_template_detailimage":`Fotografia`,
"label.cpq.product.feature.option.count":`O mínimo de opções de produtos não pode ser maior do que o máximo de opções de produtos`,
"label.chatter.newtask":`Nova Tarefa`,
"font-trade-module-v1-invoice-total-price":`Pagamentos totais planeados`,
"setup_mainpage_label_welcome29":`Integração padrão API com produtos de terceiros`,
"label.data.exportall.all.btn":`Exportar todos os dados`,
"front-epwechat-module-v1-unbound-WeChat":`Desobstruir a WeCom`,
"label.salescloud.salesdashboard.performance.rankings":`Contratos de Vendas de Equipas Classificações de Montantes`,
"label.import.page1.newcreateandupdate":`Actualizar e começar de novo`,
"component.chatter.post.button.file":`Acrescentar anexos`,
"label.partnerCloud.orderingPlatform.createOrder":`Nova encomenda`,
"label.lookup.multiple.data":`Dados múltiplos encontrados, por favor seleccionar manualmente`,
"button.partner.save":`Guardar`,
"label.service.add.timeslot":`Acrescentar horário`,
"label.campaign.matchway.select.email":`Email`,
"front-sales-button-fromQB":`Actualização a partir do QuickBooks`,
"label.icon.108":`Seta`,
"lable.outlook.edit.efmapping":`Mapeamentos de Campo Editar`,
"label_tabpage_refreshz":`Actualizar`,
"chatter.follow.cancel":`Pare de seguir`,
"label.totals.sum":`Total`,
"label.noRequest":`Não é necessário`,
"vue_label_homepage_fixedcomponent":`Por favor seleccione um componente fixo`,
"label.knowledge.delete.case":`Erro ao eliminar o artigo do caso.`,
"label.weixin..xsld.yjwc":`Receitas esperadas`,
"label.customcomponent.page.index.console.btn":`Consola de desenvolvimento`,
"label.sendsms.batch":`SMS em massa`,
"vue_label_chat_onlychosechat":`Apenas utilizadores da equipa podem ser seleccionados para o chat`,
"label.tabpage.page":`Página`,
"label.cyen.note":`Activar Moeda. Note-se que a acção da moeda activada é irreversível.`,
"label.weixin.againsend":`Reenviar`,
"label.processnumber":`Passo nº.`,
"label.emailobject.to":`Para:`,
"label.event.today":`Hoje`,
"label.dashboard.dispalyPosition":`Posição de Despalhada`,
"message.error.recalculate.dupoperate":`Recalculando, por favor não operar frequentemente.`,
"vue_label_email_linkrecordsuccess":`Registo associado com sucesso`,
"label.updateoutboundnews":`Actualização de Mensagens de Saída`,
"label_emailtocloudcc_exists2":`Esta caixa de correio foi configurada para Enviar por e-mail para Case. Não repetir as definições.`,
"label.tag.addtags.button2":`Cancelar`,
"label.stdashbord.xsld.business.role":`Este papel é retirado das funções de habilitação nas hierarquias de previsões`,
"label.commonnew":`Normal novo`,
"label.validate.remark2":`Amostra de utilização:`,
"label.reportsSubscriptionPage.condition.checkbox":`Acrescentar condições a este relatório`,
"label.globalselect":`Conjunto de Valores da Lista Global de Opções`,
"label.partnerCloud.partnerAccount.available":`Quantia disponível`,
"label_tabpage_nothingz":`Nada`,
"label.version.webtolead":`We to Lead`,
"label.projectManagement.heat.map":`Mapa do calor`,
"message.error.pleasecorrectdata":`Por favor, reveja todas as seguintes mensagens de erro para corrigir os dados.`,
"label.hight.tip":`Quando o filtro avançado não está activado, a relação das diferentes condições de filtragem é "and", ou seja, um registo que satisfaz as características comuns de 1 e 2.`,
"label.workflow.estimatecondition3":`Criado ou cada vez que é editado`,
"AssetRelationship.time.limit.error":`A data de início deve ser anterior ou igual à data de vencimento.`,
"label.multilang.workflow.dayinmonth":`O {1} cada {0} mês(s)`,
"label.reportsSubscriptionPage.schedulereport.daily":`Diário`,
"label.emailtocloudcc.step1.name":`Escolha Função`,
"label.follow_up":`Email de acompanhamento`,
"label.price.list.price.cannot.be.empty":`O preço de lista não pode estar vazio.`,
"label.chatter.link":`Ligação`,
"label.ccpeak.condition.return.record":`Devolve registos por condição e suporta condições "onde" comuns.`,
"pagecreator.layout.message.canntdelete":`O layout actual não é permitido apagar`,
"label.compact.layout.main":`Principal esquema de informação chave`,
"label.testandupdate":`Verificar por Actualização`,
"button_partner_cancel":`Cancelar`,
"label.activity":`Actividades`,
"label.knowledge.setting.hint.fourteen":`Prepara-te para escrever!`,
"vue_label_commonobjects_view_open_from_list":`Abrir a partir da lista para começar`,
"front-electronic-export-intro":`2000 registos podem ser exportados para Mailchimp por uma vez`,
"label.chosen.all":`Todos os campos`,
"label.file.extension":`Extensão do ficheiro`,
"vue_label_systemSettings_server_miniprogram":`Miniprograma de serviço`,
"label.weixin.no.pending.wdgz.qin.today":`Nenhum horário de trabalho para hoje.`,
"label_tabpage_issuez":`Edição`,
"label.staticresource.tip":`Utilize recursos estáticos para carregar conteúdos que deseja consultar numa página personalizada, incluindo .zip, imagens, folhas de estilo, JavaScript e outros ficheiros.`,
"label.approvalstep":`Passos de Aprovação`,
"label.china.standard.time":`Tempo Padrão da China`,
"label.appexchange.download.tiaoguo":`Ignorar`,
"label.callcenter.link.Amazon.connect":`Amazon Connect`,
"vue.dashboard.notRequired.notConformToTheRules":`Incapaz de se submeter! Os itens necessários não são preenchidos ou não estão em conformidade com as regras.`,
"label.appointment.wizard.title1":`Definir Disponibilidade`,
"label.chat.remove.bookmark":`Remover Bookmark`,
"label.tabpage.advancedsearch":`Pesquisa avançada`,
"batch.ranf.f":`Os registos de transferência em massa falharam`,
"label.appointment.wizard.subtitle4-1-4":`1 h`,
"label.brief.account":`Contas`,
"component.chatter.link.label.url":`Link url`,
"label_emailtocloudcc_redmessage8":`Erro de parâmetro, por favor contacte o administrador.`,
"label.object.create.two.number.field":`Podem ser criados até 2 campos personalizados de número automático por objecto.`,
"label.salecommit.not.roleinformation":`Não tem papéis e não pode visualizar os painéis de compromisso de vendas.`,
"label.defautline.cannot.less":`O número padrão de linhas não deve ser inferior a 1.`,
"label.selectedproducts":`Número de produtos seleccionados`,
"label.productsales.today.notskadd":`Não há tarefas em expiração, pode clicar em " " no canto superior direito para adicionar nova tarefa.`,
"lable.account.year.stadate":`Data de início do ano fiscal`,
"label.mobile.phone.month.plan2":`As Tarefas deste Mês`,
"label.ccpeakfolder":`Pastas de classe`,
"setup_mainpage_label_welcome21":`A plataforma CloudCC fornece a função de modelo de email definido pelo utilizador, que é conveniente para os utilizadores utilizarem e melhorarem a eficiência do trabalho.`,
"label.modify.layout":`Editar Layout`,
"report.label.folder":`Pastas`,
"label.tianyancha.businessverify.rewritename":`Nome da conta de reenchimento`,
"lable.currencyAdv.dao":`para`,
"label.mobilelayout":`Layout móvel`,
"label.the.current.model.is.enabled.and.cannot.be.edited.":`O modelo actual é activado e não editável.`,
"label_partner_all_disable":`Desactivar`,
"label.ownerapproverfield":`Campo de Aprovação do Proprietário`,
"label.emailobject.template.message4":`Alguns dos campos inseridos na mensagem são nulos, por favor editar e reenviar!`,
"label.productsales.today.notsk":`Não há tarefas que expirem.`,
"label.multilang.document.upload.success":`Os ficheiros {0} foram carregados com sucessolt e os ficheiros {1} falharam`,
"label.manageAll.sta3":`Rejeitado`,
"vue_label_calendar_week_view":`Vista da semana do calendário`,
"setup_layout_label_nocustompage":`Sem páginas personalizadas`,
"label.weixin.wdyj.jxdcl":`Taxa de realização de desempenho pessoal`,
"label.donot.update":`Não tem permissão para modificar!`,
"setup.mainpage.label.welcome14":`Gestão do processo de personalização do fluxo de trabalho, aprovação`,
"UG_Campaign_002":`Planear, executar e monitorizar a eficácia das actividades do mercado.`,
"label.layout2":`Layout Dois`,
"label.app.looup":`Encontrar aplicações`,
"label.projectManagement.selectitem":`Por favor seleccione o projecto`,
"label.field.relating.rule":`Regras de associação de campos de pesquisa`,
"vue_label_commonobjects_detail_selectname":`Por favor seleccione primeiro um nome`,
"front-email-payment-Invoice-select-pay":`Seleccione Pagar por:`,
"label.customfields.formula.numberexample":`Fahrenheit = 1.8 * Celsius__c 32`,
"component_event_label_enddate":`*End Time`,
"label.partnerCloud.partnerAccount.lineOfCredit":`Limite de crédito`,
"label.chatter.newpost":`Último posto`,
"label.report_dashboard":`Este relatório será guardado nos seus relatórios. Pode também adicionálo a um painel de instrumentos.`,
"label.assigned":`Atribuído a`,
"Homepage_News_002":`A componente de notícias não está actualmente disponível.`,
"label.approval.select.relatedobj":`Para seleccionar o item relevante, deve escolher um tipo`,
"label.service.miniProgram.isTop":`Pegajoso no topo`,
"message.error.object.datatoolang":`O comprimento dos dados é demasiado longo, máximo {!comprimento} caracteres.`,
"label.importsourcetip":`A importação é concebida para aceitar os ficheiros produzidos a partir do nosso processo de Exportação. Se ainda não fez uma exportação, por favor vá agora para a página de exportação.`,
"label.select.deadlineplease.deadline":`Por favor, seleccione o prazo.`,
"vue_label_account_equityrelationship":`Relação de equidade`,
"label.account.Calendar.month":`Mês do calendário`,
"label.appointment.wizard.subtitle3-4":`Quinta-feira`,
"font-evaluate-module-v1-smaller-500":`O ficheiro deve ser inferior a 500KB`,
"label.reportsSubscriptionPage.email.tome":`Enviado para mim`,
"label.ccchat.person.invite.existpers":`Já rastreio:`,
"label.appointment.wizard.subtitle1-3":`30 min`,
"front-kefu-moudle-connected":`Ligado`,
"label.campaignmember.main.duplicatelist.tip":`O sistema encontrará aqui duplicados leads e membros da campanha com base nas definições.`,
"label.visualpage.such.tags.double":`Estas etiquetas aparecerão em par`,
"label.sendsms.batch.step2.introduce":`Por favor seleccione um modelo SMS.`,
"Account_News_Setting_002":`Utilize as definições de conta abaixo para especificar o comportamento padrão da conta para a sua organização.`,
"message.encryptchange.alert":`Está prestes a converter {{!fieldapi}} de um campo de Texto Encriptado (Armazenamento Encriptado) para um campo de Texto Encriptado (Display Encrypted), após conversão bem sucedida, este campo será armazenado em texto claro na base de dados, que pode ser exibido em texto claro ou texto encriptado de acordo com as definições do perfil. Os campos são pesquisáveis.\r Esta operação é irreversível, quer continuar?`,
"label.mainpageset.description":`Configure a sua página inicial a nível de organização com base nas suas necessidades empresariais reais.<br>Os componentes em configuração padrão que não são relevantes para o seu negócio podem ser desactivados ou desligados.<br>Enable: os componentes activados são exibidos na página inicial de todos os membros.<br>Disable: componentes desactivados não são exibidos na página inicial de todos os membros, nem serão exibidos na lista de "Configure My Homepage" em app.<br>Turn off: componentes desactivados não são exibidos nas páginas iniciais de todos os membros por defeito, e os utilizadores podem ligá-los através de "Configure My Homepage" em app.`,
"label_tabpage_linknamez":`Nome da ligação`,
"label.companyname":`CloudCC.com Ltd. Co`,
"label.currency.current":`Moeda Corrente da Empresa`,
"label.campaignmember.main.duplicatelist.html.title":`Definição da remoção das duplicações através da digitalização do código`,
"label.sendsms.batch.step3.plan":`Plano da data de entrega`,
"label.profile":`Perfil`,
"label.canceluploadfile.step":`Clique no botão Cancelar para cancelar todos os ficheiros mostrados na área superior`,
"message.newreport":`Novo Relatório`,
"label.service.newBuildDialog.date.selection":`Seleccione Data`,
"label.lookup":`Pesquisa`,
"label.file.editinfo":`Editar detalhes do ficheiro`,
"component_assistant_label_nodata":`Nenhum evento hoje, por favor verifique mais tarde.`,
"label.tianyancha.businessverify.msg4":`Esta função utiliza serviços de terceiros e está actualmente disponível aos utilizadores gratuitamente. mas o CloudCC não garante que terceiros forneçam sempre o serviço aos utilizadores gratuitamente. se terceiros cobrarem uma taxa, o CloudCC tem o direito de cobrar ou impedir o utilizador de utilizar esta função.`,
"label.noequal":`!=Não Igual`,
"vue_label_metric_column":`A tabela deve ter pelo menos 1 coluna de avaliação.`,
"label_reportType_chose_and_form":`Seleccionar a fonte de dados do relatório e um formato de relatório`,
"vue_label_pool_reasondescription":`{0} descrição da razão`,
"label.isusing":`Activo`,
"label.passwordPolicy.setup.pwdremember5":`5 palavras-passe lembradas`,
"label.cancel":`Cancelar`,
"vue_label_helpcenter_detail1.1":`actividades, e dinâmica de cada registo, e dobrar ou desdobrar a informação correspondente no canto superior direito do módulo. Pode também visualizar e gerir os dados associados ao registo através da lista relacionada.<br> 1. Pode editar, copiar, apagar ou partilhar dados para outro pessoal através dos botões no canto superior direito.<br>Ver a informação detalhada do utilizador, e pode editar directamente alguns campos na página para alterar o proprietário ou o tipo de registo dos dados.<br>Ver e gerir os dados associados ao registo através da lista relacionada. Na lista relacionada com o ficheiro, carregue o ficheiro gravado, ou clique no nome do ficheiro para descarregar e visualizar o ficheiro correspondente.<br> 2. Listas relacionadas<br>ligar rapidamente através da lista relacionada, e utilizar a janela flutuante para visualizar até 10 registos relacionados. Clique para entrar na vista de lista, ver todos os registos relacionados, e editar inline.<br>Utilizar a disposição do cartão para ver e gerir os registos relacionados abaixo.<br> 3. Actividades<br> Na página de detalhes registados, a versão Lightning não exibe as duas listas relacionadas de "actividades não processadas" ou "histórico de actividades". Em vez disso, é exibida a linha temporal de actividades.<br>Linha temporal de actividades exibindo conteúdo<br> A linha temporal de actividades pode exibir todas as actividades que do futuro para o passado no registo actual. As tarefas em atraso e as tarefas e eventos futuros são exibidas no módulo "Tarefas em atraso e eventos futuros" da linha temporal de eventos. Tarefas passadas ou actualmente concluídas, eventos, chamadas gravadas, e-mails, e mensagens de texto serão mostrados no mês correspondente.<br>`,
"registration.page.preview":`Pré-visualização da página de registo`,
"label.quickbooks.search":`Pesquisa`,
"label.setup.mobile.bottombutton.tab.show":`Afixação de separadores no fundo`,
"lable.want.to.delete.tem":`Tem a certeza de que quer apagar o modelo de relatório de serviço {currentTelmplateName}?`,
"label.multilang.fielddtrack.dealkey":`Modificar {0} de {1} para {2}.`,
"vue_label_pool_return":`Regresso`,
"vue_label_calendar_failed_to_share_calendar":`Falha na partilha do calendário`,
"label.less":`< Menos do que`,
"label.email.form.html":`Html`,
"label.tag.nodata":`Sem registos`,
"label.setarticlecon":`Especificar critérios de entrada`,
"label.searchlayout.displayrow":`Colunas a exibir`,
"label.change.task":`Vista de Tarefa`,
"lable.quote.editqtpdt.title":`Citação Itens de linha Editar`,
"label.appointment.wizard.subtitle4-4":`Até que ponto no futuro alguém o pode reservar?`,
"label.custom.page.button.css":`Botão CSS`,
"label.input.documentmessage":`Introduzir detalhes`,
"vue_label_commonobjects_detail_email_address":`Endereço do destinatário`,
"label.chatter.filterTimeLine":`Linha de tempo de filtragem`,
"label.must.select.twoorthree.records":`Deve seleccionar dois ou três registos para fundir`,
"label.mobile.setup":`Configuração de aplicações móveis`,
"vue_label_commonobjects_detail_key_field":`Campos chave`,
"label.chatter.relateitem":`Relacionado com`,
"label.customobjects.tip":`Depois de ter criado um objecto personalizado, pode criar um separador personalizado, listas relacionadas personalizadas, relatórios e painéis de controlo para os utilizadores interagirem com os dados do objecto personalizado. Também pode aceder a dados de objectos personalizados através da API.`,
"label.sso.saml.idp.config":`Provedor de Identidade`,
"label.knowledgebase.affect.article.version":`A modificação irá afectar a tradução existente? Em caso afirmativo, pode marcar a tradução preciosa como "Expirada" e gerar uma lista de pendentes de tradução para os fornecedores de tradução.`,
"message.error.record":`O registo correspondente não foi encontrado!`,
"message.duplication.label.fieldname":`Campo`,
"setup.layout.button.cancel":`Cancelar`,
"label_radar_map_function":`Utilizar gráficos de radar com múltiplas métricas para medir o papel dos contactos na cadeia de decisão de vendas.`,
"label.campagin.roi.fss":`Número Enviado`,
"label.emailobject.template.giveup":`Cancelar`,
"label.apiname.exists":`O nome API já existe.`,
"message.failtoreaddata":`Dados lidos falharam`,
"label.file.versionedit":`Modificador de conteúdo`,
"template.report.lost.business.opportunity":`Oportunidades perdidas`,
"label.ccchat.group.allowgd":`Permitir aos grupos arquivar`,
"label.fieldaccesslimit":`Acessibilidade de Campo`,
"label_target_model":`Modelo alvo`,
"message.validation.isnoturl":`URL inválido`,
"servicecrew.member.time.conflict":`Dentro deste intervalo de tempo, os recursos de serviço tornaram-se membros de outras equipas de serviço.`,
"label.knowledgebase.delete.details":`Eliminará qualquer informação de atribuição.`,
"vue_label_normal_bottom":`Fundo`,
"label.custombutton.editerror":`A edição falhou`,
"label.dashboardSetup.showdw.d6":`Automático`,
"message.error.field.decimalPlaces":`Erro no formato de entrada decimal.`,
"label.tabpage.busoppnamez":`Nome da oportunidade de negócio`,
"label.insertfield.intro":`Por favor seleccione um campo, e clique em "Inserir". Com o ">" significa clicar para ver mais campos disponíveis.`,
"setup.layout.label.nocustompage":`Sem páginas personalizadas`,
"front-gantt-module-project-has-only":`Este projecto tem apenas {n} marcos`,
"label.weixin.fmu.am":`{0} AM`,
"label.emailsync.status.connectaccounts":`Conta de e-mail conectada`,
"label.customcomponent.check.name.same":`Este nome já existe.`,
"label.validate.function.funcFormat.HOUR":`HORA(data)`,
"label.approvepagelayout4":`Copiar o layout da página anterior`,
"label.knowledge.category.hint.nine":`Activar Grupo de Categorias`,
"label.report.sorting.column":`Column Sort`,
"label.hours":`Relógio`,
"label.email.clearAllemail":`Quer esvaziar todos os e-mails sincronizados na caixa de correio?`,
"font-evaluate-module-v1-satisfaction":`Avaliação Satisfeita`,
"label.service.hide.more.info":`Esconder mais informações`,
"label.area.list.intro":`Pode editar informações sobre o território nesta página.`,
"label.sendemail.chat.addPostat":`Caro #nome:{\i1}nome: olá! #userName mencionou-o num micropost.`,
"label.data.newtemplate.e_seltype.desc":`Existem dois tipos de dados derivados</li><li class="titledesc1">1.um é o formato CSV(o padrão)</li><li class="titledesc1">2.o outro é o formato de compressão. O modo de formato de compressão é dividido em dois tipos</li><li class="titledesc1">2.1.um tipo é a geração automática de senha de ficheiros comprimidos,a senha gerada automaticamente será enviada ao utilizador após a caixa de correio de exportação de dados bem sucedida</li><li class="titledesc1">2.2.outro é introduzir manualmente a senha dos ficheiros comprimidos,a senha de introdução manual não será enviada para a caixa de correio do utilizador,portanto a necessidade de os utilizadores se lembrarem da senha.Se não introduzir,a senha por defeito não é nenhuma senha.`,
"message.passwordPolicy.validate.minlengths":`Erro:A sua palavra-passe deve ser pelo menos`,
"message.save":`Tem a certeza de que quer salvar?`,
"label.marketsea.notfollowdays1":`Depois de obter`,
"label.app.step1":`Passo 1 Seleccionar tipo`,
"message.error.pageid.null":`O ID das redes sociais do Facebook não pode estar vazio!`,
"label.weixin.input.lookupfield":`Introduzir palavras-chave para encontrar o micro voto correspondente`,
"label.whChatAccount":`Conta WeChat`,
"label.tabpage.groupingitem":`Artigo de agrupamento`,
"label.callboard.introduce":`Todos os anúncios da sua empresa estão listados abaixo.`,
"label.financial.services.seminar":`Seminário de Planeamento Financeiro`,
"label.data.file.i_title.num1":`1. O ficheiro importado deve ser um ficheiro em formato CSV. O ficheiro tem de conter um título e não pode ser importado sem título.`,
"label.visualpage.filename.exist":`O nome do ficheiro já existe.`,
"front-kefu-moudle-v1-new-chats":`Novo agente`,
"label.console.step5.tab":`separador aberto`,
"vue_label_opportunity_contactrole_edit":`Editar Funções de Contacto`,
"label.projectManagement.delete.return":`Voltará à página anterior após a eliminação dos últimos dados.`,
"registration.page.designs":`Página de Aparência para Registo`,
"label.console.step6.heigth":`Heigth`,
"label.objectRelationshipAtLeast":`ter pelo menos um registo relacionado com`,
"label.knowledge.delete.viewstat":`Erroe ao apagar os dados de navegação do artigo de conhecimento`,
"label.direct.dashboard.month.report":`Nova Nota de Trabalho Mensal`,
"label_tabpage_lookatmorez":`Ver Mais`,
"label.setup.rights.management":`Gestão dos direitos`,
"label.campaign.channel.clear.img":`Imagem clara`,
"label.calendar":`Calendário`,
"label.biaoqingfaxian.username":`Conta`,
"label.weixin.wdyj.jxht":`Contratos de Performance de Vendas Pessoais`,
"label.emailtocloudcc.exists1":`Esta caixa de correio foi configurada para "Email to Lead". Não repetir as definições.`,
"label.emailtocloudcc.filed.password":`Senha`,
"label.what_create":`Que tipo de formulário deseja criar?`,
"vue_label_report_onlydisplaypart":`Pode ser exibido um máximo de 50 dados, e exibir todos os dados após a execução.`,
"label.up":`Para cima`,
"label.addattachment.edit":`Edição de anexos`,
"label.ccchat.message.search.desc5":`As palavras de pesquisa não podem ser inferiores a 2 caracteres`,
"label.chose.nonotice":`Por favor, seleccione o registo que já não o recorda`,
"UG_activity_06":`Deseja acompanhar com contas`,
"label.set_contactsmarketing":`Definir como contacto da campanha`,
"pagecreator.layout.button.horizontal":`Desmontagem lateral`,
"label.brief.opportunity2":`Oportunidades esperadas para fechar`,
"label.ems.nomsg":`Não configurado`,
"label.fieldupdate.tip":`As actualizações de campo permitem-lhe alterar automaticamente um valor de campo para aquele que especificar. As actualizações de campo são acções associadas a regras de fluxo de trabalho e processos de aprovação.`,
"label.sso.saml.sp.federationid":`ID da Federação`,
"label.import.page2.suited":`Mapeado`,
"message.error.appexchange.integrity":`Assegurar a integridade dos componentes do pacote de carregamento.`,
"label.fielddatatype":`Tipo de dados de campo`,
"message.approval.cannotsubmit.detail2":`O registo deve satisfazer os seguintes critérios ou a fórmula avalia-se como verdadeira, caso contrário o pedido de aprovação não pode ser apresentado, por favor, voltar a apresentar o pedido após a modificação.`,
"vue_label_commonobjects_detail_cloud_as_a_user":``,
"label.summaryreport.selectlinetogroup":`Seleccione a coluna em que o agrupamento de relatórios se baseia`,
"label.tabpage.norecordtypez":`Tipo de registo inutilizável`,
"label.icon.141":`Moeda`,
"label.addattachment.step3.intruduce":`Se estiver a carregar, isto irá cancelar o carregamento em curso.`,
"label.trigger.recursive.call.three":`Os gatilhos podem ser chamados interativamente, o número de loops é limitado a 3 vezes, se mais de 3 vezes o sistema tiver um prompt de erro.`,
"maintenanceplan.workorder.type.asset.workorder":`Por favor escolha "Uma ordem de trabalho para cada bem" como o tipo de ordem de trabalho de geração.`,
"label.emailtocloudcc.select1":`Por favor escolha`,
"label.system.log":`Registo de Auditoria de Configuração`,
"vue_homepage_dashboard_not_support_fullscreen":`Desculpe, a sua navegação não suporta ecrã completo.`,
"label.projectManagement.nodata.resource":`Ainda não envolvido em nenhum projecto. Acrescentar 'Meu' informação do projecto aos membros para ver a alocação de tempo dos membros da equipa.`,
"label.exchange.sync.state.contact":`Contactos`,
"label.field.type":`Tipo de campo`,
"label.selected.object":`Objecto Seleccionado`,
"label.customfields.new.step2":`Passo 2 Introduzir os Detalhes`,
"label.monitorsys.delete.style":`Tipos de operação`,
"label.projectcondition":`Critérios de entrada`,
"potential.customers.field.default":`Ajuste por defeito dos cabos`,
"message.password.nosame":`As palavras-passe não coincidem.`,
"label.validate.function.funcExplain.MONTH":`Retorna o mês, que é um número entre 1 (Janeiro) e 12 (Dezembro)`,
"label.project.user.project.count":`Número de Projectos em que os Utilizadores Participaram`,
"chatter.to":`para`,
"vue_label_commonobjects_detail_activity_owntask":`tarefa própria`,
"label.generate.mobile.page":`A página móvel está completa.`,
"label.escalation.setup.newentries.step1":`Passo 1 Estabelecer a ordem em que esta entrada de regra será processada`,
"label.email_footer":`Rodapé de email`,
"label_partner_workspace_member_profile":`Perfis disponíveis`,
"label.loginhis.between":`Data de início distância data final não pode exceder 2 meses`,
"label.user.verficationcode.error":`Código de verificação errado.`,
"label.email_notifications":`Enviar notificação de submissão por email`,
"APPIntegration_Dropbox_01":`Seleccionar ficheiros da Dropbox`,
"label.projectManagement.Selectweek":`Seleccione Semana`,
"wednesday":`Quarta-feira`,
"message.atleastonereceiver":`Por favor seleccione pelo menos um destinatário`,
"label.applt.link.text":`Ligámos a sua empresa ao mini programa do portal. Copie o endereço do portal do mini programa dedicado à sua empresa, coloque o endereço do mini programa no link de salto para o menu de acesso oficial da sua empresa, depois os clientes podem clicar no menu para utilizar o mini programa. (Menu oficial de contas personalizadas < Saltar para o mini programa < Caminho do mini programa)`,
"label.wait.for.a.moment":`Por favor, aguarde um momento enquanto estabelece a língua...`,
"vue_label_chatter_only_group_members_look":`Apenas os membros do grupo têm acesso à visualização, pode tentar candidatar-se para se juntar ao grupo`,
"label.knowledgebase.last.release":`Publicado pela última vez`,
"component.setup.label.pagesize":`Itens por página`,
"label.paging.totalofpages":`Um total de {0} páginas`,
"label.globaloperation.successmessage":`Mensagem de sucesso`,
"label.logout":`Sair`,
"label.partner.common.enable":`Activar a nuvem de parceiros`,
"label.permission.objectpermission.goback":`Voltar à lista: Conjuntos de permissões`,
"label.approvalstep5.required":`Obrigatório`,
"component_chatter_label_to":`Para`,
"message.please.choose.role":`Por favor, seleccione o papel`,
"maintenanceasset.servicecontract.contractlineitem.illegal":`Deve seleccionar o item de linha do contrato ao abrigo do contrato de serviço associado ao plano de manutenção.`,
"label.projectManagement.Resource.usage.view":`Vista de utilização dos recursos`,
"label.smsmainbody":`Texto da Mensagem`,
"label.ccchat.error.nullname":`O nome é obrigatório`,
"label.appupload.upload.version":`Número de versão`,
"label.data.setok.t_desc2":`Voltar à página do modelo de dados`,
"vue_label_pool_allocationstatus":`Estado de atribuição`,
"label.tianyancha.orgapprovedinstitute":`Instituto aprovado pelo Org`,
"label.quickbooks.searchlist.startdate":`Data de início`,
"label.setapp":`Definições da aplicação`,
"chatter.about":`Sobre Mim`,
"label.layoutname":`Nome do layout da página`,
"label.icon.160":`Terra`,
"label.tabpage.Rolesz":`Papéis e subordinados`,
"label.console.step5.introduce":`Escolha a forma de apresentação`,
"label.customfields.totalsummary.gettogetherfield":`Campo a agregar`,
"message.appexchange.addtopackage.profile":`Apenas um componente de perfil pode ser adicionado num pacote!`,
"vue_label_file_user_header_pic":`Avatar`,
"font-trade-module-v1-invoice-detail-price":`Pagamentos detalhados`,
"homepage.components.three":`Passo 3 Introduzir o conteúdo do visor de componentes personalizados`,
"nine":`Nove`,
"label.marketsea.button.restore":`Restaurar`,
"label.forecast.editshrepage.desc2":`A partilha individual só pode ser utilizada para conceder um maior acesso aos dados, e não para restringir o acesso.`,
"label.cloudccsite.list":`Sítios`,
"label.icon.35":`Nuvem`,
"vue_label_pricebook_price":`Acrescentar preço padrão`,
"label.version.sum.addressfield":`Campo(s) de endereço(s)`,
"label.projectManagement.Gotomilestone":`Voltar-se para o marco miliário`,
"label.dataimport.name.length":`Erro: o comprimento do nome é demasiado longo.`,
"label_alculation_method":`Método de caculação`,
"label.uploadfile":`Carregar ficheiro`,
"label.ems.otheraccount":`Outra conta`,
"vue_label_commonobjects_detail_group_opportunitystrategy":`Tem a certeza de se juntar a esta equipa`,
"message.error.chatter.img.nodata":`Erro: o ficheiro de imagem não existe e não pode ser capturado.`,
"component.chatter.file.button.files":`Seleccione um documento`,
"label.salescloud.teamrole.optionlist.choose.null":`O nome do papel é necessário`,
"label.yourexportsuc":`O seu pedido de exportação foi processado, por favor veja o seu e-mail.`,
"pagecreator_systemstyle_label_modifycolor":`Editar cor`,
"label_partner_setup_title":`Definições`,
"label.chat.topic.topic":`Tópico`,
"file.error.nottype":`Erro: tipo inválido. tipos de ficheiros que podem ser carregados são txt, doc, excel, ppt, pdf, jpg, jpeg!`,
"label.all_time":`Todo o tempo`,
"homepage_componet_approval_label":`Itens a aprovar`,
"label.partnerCloud.financeSetting.merchantNumber":`WeChat Comerciante Pagador No.`,
"label.user.resetpw":`Redefinir Palavra-passe`,
"label.exchange.sync1":`Depois de criar uma conta de serviço com permissões de imitação para os utilizadores no Microsoft©Exchange, introduza as credenciais da conta de serviço para permitir que o CloudCC comunique com o servidor do Exchange.`,
"label.import.index.editfield":`Editar cartografia de campo`,
"and":`E`,
"label.partnerCloud.cloudInfrastructure":`Configuração Básica da Nuvem de Parceiros`,
"label.escalation.setup.newentries.createdate":`Quando o caso é criado`,
"Pagelayout.Setup.002":`Seleccionou 3 listas relacionadas, e acrescentar mais listas relacionadas irá afectar a disposição da página.`,
"label.customfields.file.tip":`Permitir que o utilizador carregue um ficheiro entre 1 e N.`,
"label.tianyancha.businessverify.accname":`Consulta do nome do cliente em tempo real`,
"label.Additional.Conditions":`Filtrar a nomeação do serviço de acordo com condições adicionais.`,
"label.emailtocloudcc.filed.type":`Fornecedor`,
"vue_label_homepage_fixedcomponents":`Componente padrão`,
"label.visualpage.delerror":`Eliminar falhou, por favor tente novamente mais tarde.`,
"label.tabpage.filetypez":`Tipo de ficheiro`,
"label.emailobject.search.input":`Pesquisa`,
"label.createprocessstep2":`Etapa 2 Especificar critérios de entrada`,
"label.weixin.inhead":`Processamento`,
"component.recdetail.label.title":`Informação detalhada`,
"label.weixin.telephone":`Número de telefone`,
"label.web.link":`Ligação Web`,
"label.partnerCloud.paySuccess":`Pago com sucesso`,
"label.case.adress.link":`Portal do Serviço de Atendimento ao Cliente`,
"label.emailobject.view.connectopp":`Emails Ligados a Oportunidades Abertas`,
"front-kefu-moudle-think-again":`Deixeme Pensar de Novo`,
"label.Button":`Botão`,
"chatter.pt.most":`O tamanho máximo do ficheiro é de 20 MB.`,
"label.service.newBuildDialog.numberdays.horizontal":`Dias antes da data de nível`,
"label.ems.relatedobj":`Objecto relacionado`,
"label.notification.insert.approval":`[提交人] submete [对象] para a sua aprovação`,
"label.setting.codeSet":`Conjunto de códigos`,
"vue_label_report_rowlevelformula":`Fórmula a nível de linha`,
"label.validate.function.funcFormat.TIMENOW":`TIMENOW()`,
"label.copyright":`Copyright © 2008-2022 CloudCC Inc. Todos os direitos reservados.`,
"component.setup.button.save":`Guardar`,
"label.emailsync.button.sure":`Confirme`,
"label.multilang.dupicatecheck.getdatalist":`O {0}--grupo de dados duplicados, tem um total de {1} registos:`,
"label.ccchat.person.invite.tochat":`Convidar pessoas para o CCChat`,
"label_partner_all_maxNum":`Máximo de dados da nuvem de parceiros:`,
"label.checkfield":`Configurações de campo para encontrar duplicados`,
"label.sales.dashboard.income":`Objectivo de receita`,
"label.setup":`Configuração`,
"label.dashboardSetup.center":`Médio`,
"lable.quote.syncing.finished":`Sync Completed`,
"vue_label_helpcenter_dashboard1":`A fim de o ajudar a exibir dados estatísticos de forma mais intuitiva, o painel de controlo CloudCC Sales Cloud Lightning oferece-lhe capacidades de produção gráfica poderosas.<br> Painel de controlo da versão CloudCC Sales Cloud Lightning tem as seguintes características<br>Capaz de utilizar diferentes fontes de dados: pode seleccionar os dados originais numa vista sob o objecto como fonte de dados, ou pode seleccionar os dados após o relatório ser processado como fonte de dados<br>??até 13 tipos de modelos de gráficos para escolher: funil de suporte de vendas, apontador, gráfico de torta, histograma secundário agrupado, etc. <br> Arrastar e largar livremente para alterar o tamanho e posição do gráfico: o painel de instrumentos pode distinguir dados importantes e dados auxiliares colocando a posição e tamanho de diferentes gráficos, que são completamente da sua responsabilidade<br>Painel de instrumentos filtragem geral: O painel de instrumentos suporta a filtragem dos dados do gráfico incorporado com campos de filtragem definidos por intervalo de tempo e utilizador<br>Caching de dados: os dados do gráfico do painel de instrumentos podem ser armazenados em cache quando são criados pela primeira vez, reduzindo o tempo de carga secundária. <br>Penetração de componentes: Pode saltar para os detalhes do relatório correspondente ou para a lista de registos na vista correspondente do objecto, clicando no componente<br>Ligação do componente: No mesmo painel de instrumentos, um componente pode configurar outros componentes da mesma fonte de dados para interagir consigo próprio. Ao clicar na área de dados no componente, outros componentes podem ser definidos para recontar os dados de acordo com as condições de filtragem desta área de dados<br> 1. Criar um novo painel de controlo<br> Como representante de vendas ou gestor do departamento de vendas, pode exibir os seus dados de vendas, fazendo painéis de controlo. A versão Lightning do CloudCC Sales Cloud fornece capacidades ricas para fazer dashboards<br>Nota: Os dados da versão Lightning do dashboard e da versão antiga do dashboard não são interoperáveis. <br> Clique no separador "Painel", clique em "Novo Painel", preencha o nome do painel e seleccione a pasta onde pretende guardar este painel. Pode introduzir um novo painel de bordo.`,
"label.layout.availabletab.trackrecord":`Registos de Viagem`,
"label.campaignmember.main.deletecontact":`Remover Contactos de Membros-Existentes`,
"lable.outlook.mcto.emaltoc":`Quando os e-mails são enviados para CloudCC.com`,
"label.setup.mobile.offlinecache.savesuccess":`As definições de cache off-line foram guardadas com sucesso.`,
"label.timezone.default":`Fuso horário por defeito`,
"label.noRules.have.been.enabled":`Sem regras activadas.`,
"label.ccchat.person.invite.existsend":`Alguns dos endereços de correio electrónico que introduziu correspondem a utilizadores existentes.`,
"label.work":`Trabalho`,
"actualstarttime.actualendtime.time.illegal":`A hora real de início da marcação do serviço deve ser inferior ou igual à hora real de fim.`,
"lable.product.stsp":`Preço padrão de configuração`,
"vue_label_normal_account_sf":`Conta`,
"label.finishpic":`Gráficos Gerados`,
"label.h5.similar.opportunity.step3":`Passo 3 Seleccionar Campos a Exibir para Oportunidades Semelhantes`,
"label.relateobjDefault":`Registo por defeito`,
"label.customcomponent.check.tag.endwith":`O componente deve terminar com o rótulo`,
"label.related.organization":`Oportunidade relacionada`,
"label.recordtype.edit.selectvalue.orderby":`Lista de Opções Valor Ordenar`,
"vue_label_homepage_enter_name":`Por favor introduza um nome`,
"label.permission.group":`Grupos de Permissão`,
"label.emailobject.send":`Enviar`,
"label.ralateuser":`Utilizadores relacionados`,
"label.validate.function.funcFormat.ADDMONTHS":`ADDMONTHS(data,num)`,
"label.tablayoutedit.remark2":`Seleccionar os campos apresentados na página inicial do separador.`,
"setup_mainpage_label_welcome3":`A criação de formulários na plataforma cloudCC baseia-se em bases de dados personalizadas (objecto), os objectos definidos pelo utilizador são tabelas de bases de dados que armazenam dados específicos da sua organização. As relações tabela-a-tabela podem ser facilmente estabelecidas sem qualquer desenvolvimento de programa.`,
"label.user.notallowed.login.scope":`Não está autorizado a iniciar sessão dentro do prazo ou o seu IP é restrito.`,
"label.tel.ten.case":`Pode introduzir até 10 números de telefone para receber notificações, cada número é separado por ",".`,
"front-kefu-moudle-v1-user-info":`Informação ao utilizador`,
"label.aboutme":`Sobre Mim`,
"label.setfieldediting.tip":`Ao definir os passos de aprovação, pode atribuir pedidos de aprovação a diferentes utilizadores. Uma das suas opções é utilizar um campo de utilizador para encaminhar automaticamente estes pedidos. Se quiser utilizar esta opção para qualquer uma das suas etapas de aprovação, seleccione um campo da lista de selecção abaixo. Além disso, quando um registo está em processo de aprovação, será sempre bloqueado - apenas um administrador poderá editá-lo. No entanto, pode optar por permitir também que o aprovador actualmente designado edite o registo.`,
"label.existing_dashboard":`Adicionar ao painel de bordo existente`,
"label.sendemail.spotsign":`Caro #nome: o membro da campanha #customer que convidou para #actividade chegou e assinou, por favor note que.`,
"UG_solution_01":`Fornecer a solução`,
"label.tianyancha.estiblishtime":`Tempo Estiblish`,
"label.pc.lightningpage":`Aplicação leve (beta)`,
"label.saveAndSync":`Guardar e Sincronizar`,
"label.state.end":`Concluído`,
"label.sendemail.queue.assigninfo":`Filas: [#queueName] atribuiu #objectName: #recordName`,
"label.approvalprocessname":`Nome do Processo de Aprovação`,
"label.view.conditions.message":`Filtrado por {!conditions}`,
"label.partnerCloud.financeSetting.alipayCorporate":`Conta empresarial Alipay`,
"label.forecast.detailforecast.de":`s`,
"label.savepayset.failure.nopay":`Por favor, configure pelo menos uma conta de pagamento online`,
"label.step1.total6":`Etapa 1 de 6`,
"label.appointment.wizard.subtitle4-1-3":`45 min`,
"label.emailobject.markasread":`Marcar como lido`,
"message.error.orgid.null":`orgid não pode ser nulo!`,
"label.emailtemplate.mergefield":`Fundir valor de campo`,
"label.weixin.recent.list":`Listas Vistas Recentemente`,
"label.emailsync.form.email":`Email`,
"label.funnel":`Funil`,
"label.logintime.clear":`Tempo Limpo`,
"label.chatter.followed":`Seguiu-se`,
"label.ccpeak.function.field.spack":`Os campos em função devem ter seiva de ambos os lados.`,
"label.setup.mobile.offlinecache.remark":`Depois de activar esta função, os membros da organização podem criar, editar e apagar registos enquanto estiverem offline com dispositivos móveis`,
"label.product.function":`Categorias de embalagens`,
"label.icon.14":`Martelo`,
"message.report.nodata":`Não foram devolvidos quaisquer dados.`,
"label.please.ChooseMin":`Por favor escolha pelo menos {a} opções de produtos`,
"label.tabpage.releaseTourz":`Publicar guia`,
"vue_label_chat_opportunity":`Equipa de Oportunidade`,
"vue_label_chatter_refucecertification":`Tem a certeza de recusar "{nome}" para se juntar ao chat da equipa?`,
"label.version.unlimited":`Ilimitado`,
"label.processsetting.enable.prompt":`Depois de activado, o caminho para as definições estará na página de detalhes correspondente à versão relâmpago. Também se pode guardar as definições primeiro e activar depois.`,
"label.page.display.property":`Propriedades de exibição`,
"label.service.appointmentList.thisOption":`Não verificado`,
"label.register.date":`Data de registo`,
"label.brief.contract.amount":`Montante do contrato`,
"setup.object.field.dependency.label.actionfieldnotnull":`Por favor, seleccione primeiro um campo de controlo.`,
"UG_homepage_009":`Acesso CRM`,
"label.icon.98":`Pasta`,
"label.weixin.datacount":`Total`,
"label.mobile.hasbind":`Este número móvel tem sido utilizado. A última encadernação será libertada se continuar a encadernar.`,
"label.emailtemplate.choosemorecontacts":`Seleccionar mais destinatários`,
"setup_layout_button_deleteitem":`Retirar os artigos seleccionados`,
"vue_label_account_collection_plan":`Plano de recolha não processado`,
"label_chatter_maturiyDate":`Data de expiração`,
"label.emailtocloudcc.license":`Licença`,
"vue_label_checkduplicate_complete_check_rules":`Por favor, complete as regras de verificação em duplicado`,
"chatter.up.type":`Pode carregar um ficheiro jpg, gif ou png.`,
"label.attendance.nocheckout":`Não Check-Out`,
"label.setup.mobile.offlinecache.remark2":`Os separadores seleccionados serão activados nos dispositivos móveis de todos os utilizadores da sua organização como os separadores de cache offline por defeito.cada utilizador pode desactivar os separadores de cache offline das definições organizacionais, ou activar outros separadores como os separadores de cache offline dependendo das suas necessidades.`,
"template.report.count.marketing.activities":`Campanha Total`,
"label.multilingual.tip4":`Se a multilinguagem estiver desactivada, a língua padrão da empresa será definida para chinês ou inglês com base no endereço da empresa, e a língua de todos os utilizadores será definida para a língua padrão da empresa.`,
"label.settings_area":`Área de ajustes`,
"label_assessment_content":`Conteúdo da avaliação`,
"label.top":`Início`,
"UG.Account.06":`Criar uma conta`,
"label.emailtocloudcc.step1.case2":`Uma vez configurado, os e-mails recebidos nesta caixa de correio serão automaticamente registados como registos de casos no CloudCC. De acordo com a caixa de envio, relacionar o caso com o contacto e a conta correspondentes, de modo a facilitar a aceitação e o seguimento dos casos.`,
"label.forecast.forehistory.best.remark":`Notas sobre os melhores casos`,
"label.project.problem.date":`A data de emissão deve situar-se dentro do intervalo de datas do marco ou projecto a que pertence.`,
"label.forecast.customforecast.foredis.wzs":`Números completos`,
"message.setup.field.name.value.notexists":`O valor da lista de papéis da equipa que inseriu não existe, por favor volte a entrar.`,
"label.salescloud.teamrole.opportunity.organization":`Os membros da equipa podem ter maior acesso a esta oportunidade do que as configurações padrão de acesso a oportunidades da sua organização.`,
"label.sms.message.input":`Por favor introduza a mensagem`,
"label.document.type.not.allow":`Este tipo de documento não pode ser carregado!`,
"label.customfields.totalsummary.tip":`Um campo só de leitura que exibe a soma, valor mínimo ou máximo de um campo numa lista relacionada ou a contagem de registos de todos os registos listados numa lista relacionada.`,
"label.tabpage.filesizez":`Tamanho do ficheiro`,
"label.import.page2.filedname":`Nome do ficheiro`,
"label.same.analyze":`A minha análise de oportunidade semelhante`,
"label.service.gantt.refreshData":`Actualizar dados depois de actualizar a página.`,
"label.sendsms.batch.step2.sendbycontext":`Enviar por conteúdo SMS personalizado`,
"UG_Account_05":`Diagrama da estrutura de contacto`,
"label_emailtocloudcc_step1total3":`Etapa 1 de 3`,
"label.weixin.no.history":`Sem registos históricos`,
"label.datamanage.queryfield.error":`Erro de campo de interrogação.`,
"label.emailmerge.mergeFolder.emailmerge":`Modelos de fusão de correio`,
"label.workflow.estimatecondition":`Critérios de avaliação`,
"label.autonumberfield.wrong":`Por favor introduza um número de 0-{0}`,
"label.data.setok.t.desc1":`Se precisar de utilizar este modelo de dados derivados, por favor clique`,
"label.data.downpage.i.title":`Passos de Importação de Dados:`,
"label.data.downpage.i_list.desc2":`Após a importação dos dados, receberá um e-mail lembrando-o da importação com sucesso.`,
"label.opportunity.jieduan":`Estágio actual`,
"vue_label_commonobjects_view_sumby":`Método agregado`,
"label.knowledge.setting.hint.three":`Podemos prepará-lo para a operação. Aqui está o que precisa de preparar:`,
"page.activity.history":`Histórico de actividades`,
"label.cancelQuoteLineGroup":`Cancelar grupo de linhas de cotação`,
"label.addattachment.batch.step3":`Passo 3 clique no botão para terminar.`,
"label.chat.topic.follow":`Siga`,
"label.import.page1.uploadcsvfiled":`Arraste ou clique para carregar o ficheiro CSV`,
"label.batchtransfer.datetype.tip":`Para campos de data, introduza o valor no seguinte formato:`,
"vue_label_systemSettings_application_util":`Consola de Gestão de Aplicações`,
"label.partner.workspace.member.selectedpermission":`Conjunto de permissões seleccionadas`,
"label.service.appointmentList.plansToEnd":`Plano Final`,
"label.industrialandcommercialverification.contactinformation":`Chamada para compra ou perguntas 400-642-2008`,
"chatter.del.p":`Apagar este post`,
"label.forecast.customforecast.replacefirst":`Substituído por mim`,
"Lead.Scoring.Setting.Rule.Setup.RuleName":`Nome da Regra de Pontuação`,
"label.weixin.appr.applicant":`Submetido por`,
"component_event_label_calendar":`Ver calendário`,
"step":`Etapa`,
"label.attendance.setting.position.alert":`O trabalhador de escritório deve definir o local de referência.`,
"label.end":`Concluído`,
"label.mobile.change.owner.success":`mudou para o novo proprietário`,
"label.chinese":`Chinês`,
"label.textmessage.vonage.account":`Informação de conta`,
"front-console-no-related-contact":`Por favor, associese primeiro ao contacto`,
"label.dashboardSetup.seltype":`Tipo de Componente Opcional`,
"chatter.follow.user":`Siga este utilizador`,
"label.textmessage.sentsuccess":`Enviado com sucesso`,
"label.australian.gentral.standard.time":`Horário de Verão Central Australiano （South Australia）`,
"label.validate.function.funcFormat.AND":`AND(logical1,logical2,...)`,
"lable.SalesCommitmentKanBan.contract":`Assinado`,
"label.processsetting.basic.settings":`Configuração básica`,
"label.escalation.setup.newentries.ifcondtions":`Execute esta regra se o`,
"label.lookup.nofound.data":`O valor não existe ou não corresponde ao filtro.`,
"vue_label_commonobjects_view_chart_chartname":`Nome da carta`,
"label.dashboard.show.percent":`Mostrar %`,
"label.sso.saml.sp.userid":`Identificação do utilizador`,
"label_tabpage_minutesagoz":`acta`,
"vue_label_chatter_comment_content":`Por favor introduza o conteúdo dos comentários`,
"label.campaign.channel.step6.mobilepc":`Gerar página móvel e PC`,
"vue_label_homepage_editprofilepage":`Editar Nome`,
"label.tabpage.crecordtypez":`Mudar tipo de registo`,
"label.social.posts.type.null":`O tipo de correio não pode estar vazio`,
"label.projectManagement.groupbyuser":`Agrupamento por Utilizadores`,
"vue_label_email_new_template":`Salvar como um novo modelo`,
"label.ems.close":`Cancelar`,
"label.ccdocument.noauthority.folder":`Não tem permissão para operar esta pasta.`,
"message.filterconditionerror":`<é forte>Error: </strong> As suas condições de filtragem mal cotadas:`,
"label.User.Interface":`Interface do utilizador`,
"label_tabpage_greaterz":`Maior do que`,
"vue_label_CCChat_unfollow":`Unfollow`,
"label.selectandcontinue":`Seleccionar e Continuar`,
"vue_label_commonobjects_detail_influence":`Influência`,
"label.total.have.priority":`é anterior`,
"label.manageAll.sta4":`Recordar`,
"label.setup.mobile.offlinecache.setup":`Definições de cache offline do lado móvel`,
"vue_label_chatter_cancel_adding":`Cancelar`,
"vue_label_lead_select_existing":`Seleccionar existente`,
"front-epwechat-module-v1-contacts-sync":`Sync WeCom Contactos`,
"label.appupload.component.type.recordtype":`Tipos de registos`,
"label.layout.hint":`Esta página não está disponível para prévisualização. Favor guardar e visualizar na página de primeiro plano.`,
"label.change":`Alterar`,
"setup_layout_label_detailpage":`Página de detalhes`,
"label.imgfield.use.tip":`img(docid,width,height), esta função é utilizada para produzir imagens, "docid" é o ID do documento, "width" define a largura da imagem (Tipo inteiro pode ser nulo), "height" define a altura da imagem (Tipo inteiro pode ser nulo).`,
"pagecreator.systemstyle.button.edit":`Estilo de edição`,
"label.delete_externalpage":`O ' ' que pretende apagar não pode ser retirado, por favor confirme novamente. O formulário não é utilizado em nenhuma página de login, mas pode ser utilizado noutro local. Por exemplo, pode ter utilizado o código de incorporação para o inserir numa página externa.`,
"font-evaluate-module-v1-open-case":`Reabrir o caso:`,
"label_not_adjust":`Sem ajuste`,
"vue_label_title_ordernow":`Encomendar agora`,
"label.notification.serviceappointment.allocation":`Foilhe enviada uma nova ordem de trabalho {0}, por favor verifique.`,
"label.objectRelationshipDescription2":`. Pode definir que registos relacionados de outros objectos são devolvidos nos resultados do relatório, escolhendo uma relação com outro objecto.`,
"vue_label_calendar_notice_createfail":`Falha na criação do calendário`,
"label.ems.step1":`Passo 1`,
"label.ems.password":`Senha`,
"label.icon.143":`Banco de Porquinhos`,
"label.select.year":`Seleccionar ano`,
"label.termsforusage.dialog":`Termos de Utilização (Nova janela)`,
"label.tag.addtags.create":`Criar`,
"label.emailobject.groupemail.msg4":`não será enviado devido a um endereço de correio electrónico inválido.`,
"label.version.sum.autonumberfield":`campo(s) de número(s) automático(s)`,
"label.projectManagement.unallocated.time":`Tempo não atribuído`,
"PageLayout.Search.MultiSearch.002":`Activar a caixa de pesquisa personalizada (Pesquisa de campo único)`,
"label.icon.150":`VR`,
"label.SMS.edit":`Edição de Notificação SMS`,
"Opportunity.Detailed.Phase.Label.003":`Mudança de etapa`,
"vue_label_helpcenter_all":`1. Pesquisa geral<br> A pesquisa geral é uma ferramenta para o ajudar a encontrar rapidamente o que precisa. <br>?Introduza palavras-chave na caixa de entrada da pesquisa na barra de navegação na parte superior da página. Durante o processo de introdução, o sistema irá recomendar-lhe conteúdos relevantes em tempo real de acordo com o conteúdo introduzido; <br>?Clique em "Pesquisar" ou prima directamente a tecla Enter para abrir a página de resultados da pesquisa; <br>?Na página de resultados, pode filtrar o objecto à esquerda para ver a lista de resultados da pesquisa sob esse objecto. Foram recomendados até 10 registos para si na lista de resultados. Pode clicar em "Ver Mais" para introduzir a página da lista deste objecto para ver mais resultados de pesquisa; <br>Nota: O sistema procura "cotação", "cliente", "lead", "oportunidade de negócio", "actividade de marketing", "contrato", "produto", "pedido de serviço", "tarefa" e "evento" por defeito. <br> 2. Criar rapidamente<br> Clique em " " na barra de navegação, e pode seleccionar o objecto que pretende criar na janela pendente. <br> 3. Meu Centro<br> Clique no avatar do lado direito da barra de navegação para abrir a janela Meu Centro. São fornecidas as seguintes funções: <br>?Introduza rapidamente a página de configurações pessoais, importação de lotes e entrada de contentores de reciclagem; <br>?Se estiver no período experimental, clique em "Encomendar agora" para entrar rapidamente na página de encomenda do Cloud CC; <br>?Clique numa versão para mudar rapidamente; <br>?Terminar a sessão. <br>?4. Menu<br>?Alguns objectos de menu são-lhe recomendados na barra de menu. Pode clicar num menu para entrar rapidamente na página. Pode também visualizar todos os menus e definir os menus frequentemente utilizados a serem exibidos na barra de menu. <br>?Todos os menus: Clique em "Mais", e clique em "Todos os menus" na parte inferior da caixa pendente; <br>?Personalizar o meu menu: Clique no botão do lado direito do menu para abrir a janela do menu personalizado e definir os menus comuns a serem exibidos na barra de menu em todos os menus. <br> 5. Application launch center<br>> Clique no ícone do lado direito da barra de menu para mudar rapidamente para o administrador do sistema para configurar outros serviços de aplicação para si. <br>Nota: Uma aplicação é uma colecção de uma série de módulos funcionais (tais como gestão de leads, oportunidades de negócio, gestão de contratos, etc.) que podem ser utilizados para satisfazer necessidades empresariais específicas.`,
"label.summaryreport.2018.step5.new":`Passo 5 Seleccionar os critérios do relatório`,
"label.weixin.id":`Número`,
"chatter.pu.mess":`correio(s)`,
"label.weixin.lookup.record":`Encontrar Registos`,
"label.ServiceCloud.statistics.by.address":`Estatísticas por endereço`,
"label.jixiaoswitchoff":`Colapso`,
"label.savealipay.failure":`Falha em salvar a informação do comerciante Alipay`,
"template.chart.khdqfb":`Contabilidade Distribuição Regional`,
"front-email-payment-immediate-payment":`Pague agora`,
"label.dashboard.unit5":`Unidade: 100 milhões`,
"label.tabpage.greaterz":`Maior do que`,
"vue_label_calendar_stop_sharing_calendar":`Parar o calendário de partilha`,
"label.projectManagement.allhours":`Todos (horas)`,
"label.currency":`Moeda`,
"label_vue_create_edit_obj_create_event_dialog_title":`Lembrete de horários repetitivos`,
"front-template-V1-templateSetting":`Configuração do modelo`,
"label.dashboard.away.condition":`Condição de colapso`,
"label.replacelayout":`Substituir o layout da página`,
"label.permission.detail.system.setting.tip":`Executar a operação aplicada às aplicações. Por exemplo: modificar as permissões para todos os dados`,
"label.customfield.delete.prompt":`Rótulo de campo personalizado`,
"label.add":`Acrescentar`,
"label.deputationalsoapprove":`O Aprovador Delegado também pode aprovar este pedido`,
"label.leave_nosave":`Depois de sair, os dados actuais não serão guardados.`,
"label.tianyancha.title":`TianYanCha`,
"vue_label_pool_restore":`Restaurar`,
"chatter.feed.menutype.feed.markcom":`Marcador de Favoritos`,
"label.query.data.error":`Falha na consulta das listas relacionadas`,
"label.pc.ui.2018.unpin":`Unpin`,
"label.partner.template.memo":`Título`,
"label.weixin.cannot.gain.userinformation":`Incapacidade de obter informações do utilizador.`,
"label.stdashbord.xsld.department":`Departamento`,
"label.service.ganttBaiduMap.scheduled.starttime":`Hora de início planeada`,
"label.documentforms":`Documentos`,
"label.operator.insert":`Inserir operador`,
"label.processsetting.select.five.fields":`Podem ser seleccionados até 5 campos.`,
"label.weixin.password":`Senha`,
"vue_label_chatter_share_followers":`Partilhar com seguidores`,
"label.brief.baifang":`Visitas`,
"label.emailobject.track.unopen":`Não aberto`,
"label.sendmail.immediately":`Enviar agora`,
"label.partnerCloud.payTheAmount":`Montante de pagamento`,
"label.integrations.mailchimp.connect":`Ligue o CloudCC à sua conta`,
"label.datamove.record.sucessfully":`registo(s) transferido(s) com sucesso.`,
"lable.outlook.edit.allocation":`Atribuir Utilizadores e Perfis`,
"label.chosesubject.talk":`Programar uma conversa`,
"label.escalation.setup.entrydetail.escalation.time":`Escalar em`,
"label.projectManagement.must.be.less.than.24.hours":`Menos de 24 horas`,
"setup_mainpage_label_welcome15":`As regras de fluxo de trabalho da plataforma CloudCC Cloud automatizam o processo de apoio às suas vendas, marketing, e muito mais. Dependendo de um conjunto de regras predefinidas, os registos podem ser automaticamente atribuídos aos utilizadores ou convertidos de um utilizador para outro. A principal vantagem da gestão do fluxo de trabalho é melhorar a eficiência do trabalho, eliminando muitas operações desnecessárias ao actualizar registos, e melhorar os níveis de processamento do negócio e optimizar processos de controlo através da padronização de métodos de trabalho e da redução de custos operacionais. Suporta aprovação infinita ilimitada para qualquer objecto, e pode activar email de lembrete, SMS de lembrete, tarefa, actualização de campo e outras funções.`,
"label.mobile.phone.week.plan2":`Esta Semana`,
"label.add.newAsset":`Novo Bem`,
"vue_label_salesadvance_losts":`Número de perdas`,
"vue_label_report_editcolumn":`Editar Coluna`,
"vue_label_homepage_assignedtasks":`Tarefas atribuídas`,
"label.posting_from":`Publicado por`,
"year":`Ano`,
"label.autoRegister.changepwd.setpwd.tip.letter":`Pelo menos uma carta`,
"label.version.nonsupport.feature.staticresource":`Esta característica não é suportada temporariamente. Por favor aguarde pela actualização antes de utilizar.`,
"label.toleadmyclientandlinkman":`Importar as Minhas Contas e Contactos`,
"label.appupload.install.processcrash":`Lidar com os conflitos`,
"label.profile.setstandardtab":`Configurações de Separadores Padrão`,
"template.chart.khhyfx":`Análise da Indústria Contabilística`,
"label.reportTypcrtC":`Objecto associado (c) por favor clique para seleccionar o objecto relacionado`,
"vue_label_report_mayormaynothave":`O objecto principal pode ter ou não registos relacionados com este objecto`,
"label.service.gantt.plan.recommendation":`Horário recomendado`,
"label.version.sum.lookupfield":`campos de relação de pesquisa`,
"label.builder":`Construtor de páginas`,
"label.sharerule.remark":`Especificar a partilha deste registo. Pode partilhar os registos e dados relacionados com o utilizador, papel, papel e subordinados, utilizadores num território, utilizadores no território e sub território.  A partilha individual só pode ser utilizada para conceder um acesso mais amplo aos dados, e não para restringir o acesso.`,
"vue_label_email_benn_added":`A caixa de correio foi acrescentada`,
"label.version.allow.sum":`Se necessário, por favor actualize a versão CloudCC.`,
"label.icon.130":`Moeda`,
"label.custom.new":`Novo`,
"label.see_allfields":`Ver todos os campos`,
"front-marketing-module-v1-share-poster":`Partilhar cartaz`,
"label.service.one":`As suas referências de filtro são condições de filtragem indefinidas:`,
"lable.outlook.edit.alprec":`Always Preferred CloudCC.com`,
"Account_News_Setting_001":`Definições de conta`,
"label.mr.caption.opportunity.result":`Encontrar duplicados e fundir: Resultados para pesquisa de duplicados de Oportunidades`,
"label.forbidden":`Desactivar`,
"label.query.detail.openpartner":`Habilitar como utilizador parceiro`,
"label.session_date":`Data da Sessão`,
"label.forecast.customforecast.submit.deyuce":`Previsão`,
"label.emailtocloudcc.filed.server":`Servidor`,
"label.emailtocloudcc.tip2":`Depois de apagar, não poderá utilizar o Email to CloudCC, tem a certeza de que quer apagar?`,
"pagecreator_layout_message_delete_fail":`Apagamento do layout falhou`,
"front-lightning-module-v1-dashborad-export-PDF":`Exportar PDF`,
"lable.quote.syncing.syncingto":`Os itens da linha de citação foram sincronizados com os produtos de oportunidade`,
"message.error.view.lastview.update":`Não é possível eliminar a última vista da lista pública</br>Não é possível alterar a visibilidade da última vista da lista pública de "Visível para todos os utilizadores" para "Visível apenas para mim"<br>>br>>`,
"label.weixin.select.one":`Seleccione pelo menos um`,
"label.projectManagement.Pleaseenterprojectname":`Por favor introduza o nome do projecto...`,
"label.data.downpage.e_list.desc1":`Esta página mostra ficheiros exportados com sucesso. Por favor, descarregue os ficheiros exportados a tempo de adicionar a gravação ao link de descarga no seu e-mail.`,
"label_tabpage_notexceed25":`O registo seleccionado não deve exceder 25`,
"label.campaign.channel.step5.remark":`Terminou a criação da página de registo.`,
"label.setup.mobile.bottombutton.profile.prompt":`Dicas:o menu inferior de perfil personalizado anula as definições unificadas do menu inferior da empresa`,
"label.stdashbord.xsld.business.knx":`Probabilidade`,
"label.setemailtip":`Criar um alerta por correio electrónico para associar a uma ou mais regras de fluxo de trabalho ou processos de aprovação. Ao alterar um alerta por correio electrónico, quaisquer modificações serão aplicáveis a todas as regras ou aprovações associadas a ele.`,
"report.button.go":`Ir para`,
"lable.the.united.arab.emirates":`Os registos foram recebidos.`,
"label.writer. name.file":`Preencha por favor o nome do ficheiro de cotação`,
"label.validate.function.funcExplain.ADDMONTHS":`Adicionar o num mês à data, utilizando a última data do mês se a data for o último dia do mês ou adicionar o num mês tem menos dias.`,
"vue_label_chatter_enter_shared_content":`Por favor, introduza o conteúdo partilhado`,
"message.lookup.condition":`Os critérios de pesquisa devem introduzir mais do que um carácter`,
"vue_label_commonobjects_detail_customers":`Os clientes que desactivarem permanentemente os utilizadores externos irão proibir todos os utilizadores externos associados ao cliente e removê-los de todas as comunidades, grupos, equipas, conjuntos de permissões, e regras de partilha associadas a eles. Ao mesmo tempo, os papéis e grupos associados à conta serão permanentemente eliminados e não aparecerão no caixote do lixo da reciclagem. Tem a certeza?`,
"label.emailobject.view.all":`Todos os e-mails`,
"vue_label_file_size_limit_new":`O Upload falhou. O anexo excede {tamanho}M.`,
"front-gantt-module-please-reorder-milestones":`Por favor, introduza um número válido para reordenar os marcos`,
"label.escalation.setup.entrydetail.escalation.assingTemplate":`Email`,
"label.namespaceprefix":`Prefixo do espaço de nomes`,
"label.ems.delete.success":`Eliminar com sucesso`,
"label.partnerCloud.financeSetting.setWechatPay":`Configurar o WeChat Pay`,
"front-epwechat-module-v1-input-token":`Por favor introduza o Token`,
"setup_object_field_dependency_button_setdependency":`Configurações de Dependência de Campo`,
"chatter.group.request01":`Pedido(s)`,
"message.error.field.number.length":`O comprimento do formato que introduziu o erro.`,
"label.tabpage.lessz":`Menos de`,
"vue_label_notice_uploadavatar_format":`A imagem de avatar carregada só pode ser em formato JPG/PNG/GIF`,
"label.project.hit.thirteen":`Lembrete diário de marco miliário`,
"frame_personinfo_label_usethisimage":`Vamos utilizar variações desta imagem em miniatura em torno da aplicação.`,
"label.startuploadfile.step":`Caso contrário, os ficheiros não carregados com sucesso serão exibidos na área superior,precisam de ser removidos,depois escolher um novo ficheiro.`,
"component_assistant_label_overduetask":`Oportunidades com Tarefas Vencidas`,
"label.partnerCloud.financeSetting.information":`Como criar a informação de subscrição de Alipay?`,
"label.appupload.install.package.component":`Componentes da embalagem`,
"label.emailobject.emaildetail.nextactivity.task":`Adicionar Tarefa`,
"vue_label_chatter_edit_post":`Editar Posto`,
"label.appupload.upload.logo":`Ícone`,
"label.role.selecteduser":`Utilizadores seleccionados`,
"label.letter.assign":`Especificar o conteúdo do convite`,
"label.forecast.shrepage.title":`Detalhes da Partilha de Previsões`,
"lable.Generate.service.appointment":`Nomeações de serviço geradas por item de ordem de trabalho`,
"label.productsales.nodata":`Sem dados`,
"vue_label_email_Please_select_at_least_one_email":`Por favor seleccione pelo menos um e-mail`,
"label.data.downpage.i_title.num4":`4. Se tiver um campo de relação de pesquisa e um campo de relação de mestre-detail no objecto que pretende importar, o valor para esse campo deve ser ID, caso contrário é inválido.`,
"label.new.exchagecurrency":`Novas taxas de câmbio`,
"label.layout.listtip":`A tabela abaixo mostra a atribuição da disposição da página para diferentes perfis.`,
"label.icon.2":`Carteira`,
"label.chat.topic.delete.prompt3":`Tem a certeza de apagar este tópico?`,
"UG_Lead_008":`Código de digitalização de cartões de visita`,
"label.multilang.databatchadd.fail":`{0} os dados não são added：`,
"front-kefu-moudle-v1-chzx-confirm":`Tem a certeza de que quer eliminar o agente?`,
"label.import.page1.matchlabel":`Forma de corresponder {{{$store.state.labelName}}}`,
"label.dashboardSetup.showdw.d3":`Milhões`,
"label.version.ifnecessary":`Se necessário, por favor actualize a sua versão CloudCC.`,
"label.confirm.delete.default.tab":`Tem a certeza de que quer apagar os separadores de registo por defeito?`,
"label.emailtemplate.mergefields.tip":`Quando os utilizadores editam o conteúdo do e-mail, podem adicionar campos fundidos para substituir o texto no conteúdo do e-mail. Quando os emails são enviados, o sistema substitui-os por texto. Por exemplo, {!Contact.name} no seu e-mail tornar-se-á o nome do contacto.`,
"vue_label_chatter_decline_members_join":`Recusar membros para se juntarem ao grupo`,
"label.role.no":`Sem papéis`,
"label.service.gantt.resources":`recursos`,
"label.knowledge.language.simplified":`Chinês simplificado`,
"label.eidt.queue.length.cannot.than":`O comprimento do nome não pode exceder 50 caracteres.`,
"label.mobile.quickcreate.default.tasks":`Tarefas`,
"label.discount.yuan":`Desconto (Yuan)`,
"message.error.delete.pending":`O registo está pendente de aprovação, não o pode apagar.<br>Click <a href='javascript:history.back();'>here</a> para retornar.`,
"chatter.show.mostnews":`Mostrar mais`,
"label.optionlist":`Lista de selecção`,
"template.chart.cpdj":`Preços de produtos`,
"label.user.usernamepassword.error":`Por favor, verifique o seu nome de utilizador e palavra-passe.`,
"label.file.sharetype.check":`Visualizador`,
"label.completed.generated.page":`A página do PC está completa`,
"label.martrixcross":`Matrix Cross`,
"label_tabpage_entercusnamez":`Por favor introduza o nome do cliente`,
"lable.account.NextwDays":`Próximos 30 dias`,
"label.list.userinterface.dashboard.hint":`Novos gráficos de painel de instrumentos rapidamente apresentados em telemóveis, comprimidos, etc.`,
"message.fieldtrack.operatecreate":`Criado em`,
"label.service.gantt.available.plan":`Escalas de tempo que podem ser agendadas:`,
"label.activity.setting":`Definições de actividade`,
"label.tag.manage.record":`Número de registos`,
"label.customcomponent.page.edit.title":`Editar Componentes Personalizados`,
"label.import.index.creationrecord":`Criar um registo`,
"label.tabpage.printz":`Imprimir`,
"label.appointment.wizard.subtitle4-1-5":`1.5 h`,
"label.partnerCloud.orderingPlatform.discountUnit":`Unidade de Desconto:`,
"label.weixin.micro.message.profile.associated":`Conta oficial WeChat associada ao perfil da empresa`,
"label.cpq.opportunity.pricebook.change":`Esta oportunidade foi ligada a uma cotação primária e o livro de preços não pode ser alterado`,
"vue_label_opportunity_business_opportunity":`Os resultados de oportunidades de negócio fechadas e vencedoras de clientes contêm registos com um ou mais dos mesmos campos que a oportunidade de negócio actual.`,
"message.standardreport":`Relatórios Padrão`,
"vue_label_account_outstanding_business":`Transferir todas as oportunidades de negócio não processadas de outros`,
"vue_label_commonobjects_detail_field":`Seleccionar campo de filtro`,
"pagecreator_page_button_delete":`Eliminar`,
"label.leadconvers.permisson":`Sem {!operator} permissão para o {!objectname}, por favor contacte o admministrador!`,
"vue_label_systemSettings_customcode":`Código personalizado`,
"button.partner.cancel":`Cancelar`,
"label.whChatBindingState":`Estatuto de WeChat Binding`,
"label.appointmentconfirmail.wizard.subtitle6":`Telefone`,
"label.recycle.dis.tip2":`Clique em Esvaziar a sua lixeira ou Esvaziar Tudo para esvaziar a lixeira de reciclagem dos utilizadores ou da organização . Isto levará algum tempo, quando o esvaziamento estiver concluído, será notificado por e-mail.`,
"batch.transfer.succ":`dados de transferência de massa bem sucedida`,
"label.chat.add.bookmark":`Favoritos`,
"label.mr.object.contact":`Contactos`,
"component_setup_label_parentobject":`Objecto superior`,
"label.reportsSubscriptionPage.schedulereport.weekly.tuesday":`Terça-feira`,
"vue_label_report_list":`Seleccione o campo a ser exibido no título da lista`,
"label.checkbox.false":`Não`,
"label.chatter.followers":`Seja seguido`,
"label.mr.loadReDate":`Carregar o seleccionado`,
"label.versiontype.Essential":`Essencial`,
"front-project-module-v1-input-actual_working_hours":`Por favor, introduza as horashomem`,
"label.visualpage.staticresource.p2":`2. Note que os tipos de ficheiros de recursos estáticos suportados são png, jpg, gif, js and css`,
"label.query.clone.detail.choose":`Por favor escolha os itens de linha a clonar`,
"component.assistant.label.30daysnoact":`30 dias sem qualquer campanha`,
"label.tianyancha.businessverify.relation":`Tem sido mapeado`,
"vue_label_email_havent_received_the_email_yet":`Nenhum correio recebido agora`,
"label.isEnableVisualpage_new.title":`Habilitar o acesso à página personalizada`,
"lable.SalesCommitmentKanBan.allContractAmount":`Montante total do contrato`,
"label.searchall":`Pesquisar tudo`,
"label.h5.similar.opportunity.select.all":`Seleccionar tudo`,
"label.area.tree.intro":`Pode ver aqui a hierarquia dos territórios.`,
"label.select.up.three.fields":`Atenção: Pode ser seleccionado um máximo de três campos.`,
"label.leadscore.doing":`A pontuação já começou,por favor não repetir a pontuação`,
"message.choosereportobj":`Por favor, seleccione objectos de relatório`,
"button_partner_start":`Comece a usar`,
"label.quote.print":`Citação de impressão`,
"label.workflowoperateselect":`Passo 3 Especificar Acções de Fluxo de Trabalho`,
"label.greate":`> Maior do que`,
"lable.setting.qrcodeOrbarcode.rule":`Regras de Definição do Código QR/Geração de Código Bar`,
"label.partnerCloud.orderingPlatform.discounts":`Horário de Descontos`,
"label.ems.save2draft":`Guardar como rascunho`,
"vue_label_homepage_editname":`Editar nome da página inicial`,
"label.ccdocument.save.error":`Salvar falhou e o código de erro é`,
"label.samoa.standard.time":`Tempo Padrão de Samoa`,
"label.tianyancha.businessverify.msg7":`3. âmbito do serviço`,
"vue_label_commonobjects_view_up_to_data":`A operação suporta até 200 dados`,
"label.manage":`Gerir`,
"label.tooltip":`foi utilizada a fonte de dados do relatório, não se pode editar a relação de objectos!`,
"vue_label_calendar_edit_calendar":`Editar Calendário`,
"label.attendance.keywords":`Por favor introduza as palavras-chave`,
"label.otherinfo":`Outras informações`,
"System_TAB_SeeViewAmount":`Ver Totais`,
"label.recordtype.remark":`Descrição`,
"label.object.cannot.delete":`O objecto não pode ser apagado porque está associado às seguintes relações com outros objectos`,
"label.setup.mobile.bottombutton.saveprompt":`Por favor seleccione 4 páginas de primeiro nível`,
"label.department.lastpage":`É a última página`,
"label.emailtemplate.mergefield.use":`Copiar e colar os valores dos campos no e-mail`,
"vue_label_salesfunnel_notice8":`Proporção de conversões bem sucedidas desta fase para a fase seguinte`,
"lable.opppdt.addpdt.table.product":`Produtos`,
"vue_label_helpcenter_report2.2":`Passo 2: Seleccione como pretende resumir as colunas: Total, Média, Máximo, Mínimo. <br>? Ordene os dados no relatório em ordem ascendente ou descendente<br> Clique no símbolo ↑ ou ↓ ao lado de qualquer campo no cabeçalho do relatório de pré-visualização. Os dados no relatório serão ordenados em ordem ascendente e descendente de acordo com este campo. <br>? <br>Mostrar ou ocultar linhas de detalhes<br> Após agrupar, pode mostrar ou ocultar linhas de detalhes, pré-visualizando a opção "Detail Row" no canto superior direito do relatório. A "Fila de Detalhe" está desligada por defeito. <br>? Ligar ou desligar a pré-visualização automática de actualização<br> A "Pré-visualização automática de actualização" no canto superior direito do relatório de pré-visualização permite-lhe ligar ou desligar a pré-visualização automática de actualização. Quando ligado, o impacto de cada passo que dá nos dados é automaticamente exibido no relatório de pré-visualização. ? Para filtrar os registos do relatório, clique nos filtros<br>Os filtros são divididos em filtros padrão e filtros de campo. <br>Os filtros padrão incluem o filtro Função, o filtro Show Me, e o filtro Data. <br>br>A. O filtro "Função" divide os dados por função actual e por funções subordinadas imediatas, e pode alternar entre funções clicando no nome da função. <br> B. O filtro "Mostrar para Mim" divide os dados por "Mostrar para Mim" e "Mostrar para Todos", com "Mostrar para Mim" mostra os dados onde o proprietário é o utilizador actual, e "Mostrar para Todos" mostra todos os dados onde o utilizador actual tem privilégios de visualização. <br> C. O filtro "Intervalo de datas" divide os dados por data num intervalo de tempo, tal como "Criar data", "Data de fim". <br> O filtro de campo inclui tanto um filtro de campo como um filtro avançado. <bbr>`,
"label.validate.function.funcFormat.YEAR":`ANO(data)`,
"label.service.gantt.timeScale":`Escolher escala de tempo em Gantt`,
"label.data.dataexptemplate.desc1":`1. Os ficheiros de exportação de dados têm dois formatos: formato CSV e formato comprimido. Por omissão para o formato CSV.`,
"template.chart.btjbkhqk":`Diferentes níveis de clientes`,
"label.role.assign.select":`Remover um utilizador da lista <b>Selected Users</b> e atribuir o utilizador à função seleccionada acima.`,
"label.event.lookupmulti.assigner":`Atribuído a`,
"label.appexchange.fieldupdata":`Actualizações de campo do fluxo de trabalho`,
"label.lookup.page.notexists":`A página não sai.`,
"label.appupload.install.error.choice3":`Fundir componentes em conflito num só componente`,
"vue_label_commonobjects_detail_team":`Gestão de Equipas`,
"label.approvereqiest":`Pedido de Aprovação`,
"message.error.id.replace":`A informação do calendário correspondente a {0} não foi encontrada`,
"font-evaluate-module-v1-general":`O tipo de avaliação é Neutra`,
"vue_label_report_whatweek":`Em que dia`,
"vue_label_chatter_img_upload":`Pode carregar ficheiros JPG, GIF ou PNG, o tamanho máximo do ficheiro é de 2M`,
"label.checkbox":`Caixa de verificação`,
"label.visualpage.component.n5":`5.Exemplo. Chamada:`,
"chatter.updat":`Actualização`,
"label.ems.emailaccount":`Conta de e-mail`,
"label.autoRegister.changepwd.setpwd.tip1":`Definir palavra-passe para conta CloudCC`,
"label.import.step1.matchway":`Forma de corresponder { labelNameshow }`,
"label.manageAll.sel.one4":`Itens I Rejeitados`,
"label.tabpage.lookatmorez":`Ver mais`,
"label_tabpage_addadvancedoptions":`Adicionar opções avançadas`,
"message.validation.accept":`Formato inválido`,
"label.handlingnooperate":`Os dados estão a ser processados, por favor não faça mais nada, caso contrário, o processamento falhará.`,
"label.mobile.buttom.homepage":`Página inicial`,
"lable.account.LastaDays":`Últimos 7 dias`,
"label.user.notexists":`O utilizador não existe.`,
"front-electronic-signature-isclose":`Inactivo`,
"label.optional.groups":`Grupos opcionais de linhas de citação`,
"pagecreator.layout.label.layoutname":`Nome do layout`,
"label.error404":`A página que está a tentar visualizar não está aqui, por favor tente novamente mais tarde.`,
"label.eventtrigger":`Desencadeadores de eventos`,
"label.projectManagement.next.page":`Página seguinte`,
"vue_label_SMS_chosen":`Escolhido`,
"label.part.cannot.empty":`O campo não pode ser nulo`,
"label.call.center.jilu":`Histórico de chamadas`,
"front-kefu-moudle-v1-tenant-reinput":`Por favor, introduza o número de identificação do locatário`,
"label.projectManagement.you.want.to.delete.this.data":`Tem a certeza de que quer apagar este registo?`,
"label.projectManagement.nocharge":`Grátis`,
"System_TAB_SeeViewPageAmount":`Ver Páginas`,
"label.password.query.error":`Erro de consulta do utilizador.`,
"message.chooseatleastone":`Seleccionar pelo menos um valor.`,
"label.sortasc":`Ascender`,
"label.stdashbord.xsld.business.jinezhb":`Quantia Proporção`,
"label.attendance.add":`Acrescentar Presenças`,
"vue_label_account_invoices":`Transferir todas as facturas do proprietário do cliente`,
"label_delete _model":`A eliminação de um modelo também eliminará os dados alvo associados e é irreversível. Deseja confirmar a eliminação?`,
"label.folder.sort。discreption":`As pastas serão produzidas na ordem seleccionada.`,
"label.partnerCloud.financeSetting.merchantPlatform":`Caminho de acesso: Plataforma do comerciante  Centro de contas  Segurança API  API SecretＫey`,
"label.equal":`=igual`,
"lable.PowerProcess.Workorder":`Ordem de trabalho`,
"front-docusign-setting-error-tips":`Por favor escolha o campo personalizado`,
"template.report.lead.status":`Situação dos Leads`,
"label.create.remark":`Adicionar Nota`,
"font-evaluate-module-v1-one-points":`Marca Negativa: 1 ponto`,
"label.validate.function.funcExplain.DATETIMEVALUE":`Devolver um valor ano, mês, dia e hora GMT (Campo Data/Hora)`,
"label.report.select.group.mode":`Seleccionar modo de agrupamento`,
"label.h5.editmydetails":`Editar os meus dados`,
"front-epwechat-module-v1-authorize":`Domínio Autorizado Callback`,
"label.tabpage.kanban":`Configuração do painel de visualização`,
"label.emailobject.emaildetail.button.addtocontact":`Adicionar aos Contactos`,
"lable.opppdt.selPbk.description":`Seleccione um livro de preços para esta oportunidade. Só pode adicionar um produto de um único livro de preços, e mudar o livro de preços seleccionado removerá todos os produtos existentes da oportunidade.`,
"component.event.button.save":`Guardar`,
"vue_label_homepage_homepage_assigned_success":`Página inicial atribuída com sucesso`,
"message.duplication.label.blankmatch":`Combinar campos em branco`,
"label.icon.24":`Kit de Primeiros Socorros`,
"label.mobile.same":`O novo número de telefone é o mesmo que o antigo`,
"label.file.library.managemembers.addmember":`Adicionar membros`,
"chatter.sp":`Mostrar Posts`,
"label.user.notlogin.range":`Fora do intervalo de tempo de início de sessão.`,
"label.step3.total7":`Etapa 3 de 7`,
"label.user.fullname":`Nome completo`,
"label.button.menubar":`Barra de menu`,
"#label.importfilestep3":`Passo 3 Seleccionar e carregar o(s) seu(s) ficheiro(s)#`,
"label.appointment.wizard.subtitle6":`Descrição`,
"message.lostnextapprover":`Se desejar submeter o pedido de aprovação, preencha o campo "Utilizador Relevante" para definir o próximo aprovador. Este é o campo "Utilizador Relevante" não pode estar vazio. Quaisquer outras questões, pode contactar o administrador.`,
"label.sso.saml.sp.logoutUrl":`URL único de logout do fornecedor de identidade`,
"label.weixin.isgoon":`A sua informação de membro já existe. Se continuar, o WeChat ID que liga este número de telemóvel antes não poderá utilizar a conta oficial do AidMax WeChat. Tem a certeza de querer continuar?`,
"vue_label_notice_homepage1":`Por favor introduza o valor-alvo correcto dentro de 12 dígitos`,
"label.umeng.activity.event.will":`irá`,
"label.insertURL":`Inserir URL`,
"label.partnerCloud.orderingPlatform.administrator":`Não há livro de preços disponível. Por favor contacte o administrador.`,
"vue_label_systemSettings_emailtemplate":`Email Tamplate`,
"template.dashboard.market.analysis":`Análise da campanha`,
"message.deleteapproval.tip":`Só pode apagar o processo de aprovação que não tenha dados ou registos associados.`,
"pagecreator_page_message_delete":`Apaga a página actualmente seleccionada?`,
"component.telerecord.label.message":`Comentário`,
"front-email-payment-Invoice-preview-opening":`Por favor contacte o administrador do sistema para activar a função de pagamento online e configurar os parâmetros do método de pagamento correspondente.`,
"noless":`Maior ou igual a`,
"label_emailtocloudcc_button_back":`Cancelar`,
"lable.Please.select.a.template":`Por favor, escolha um modelo existente.`,
"front-lightning-module-v1-details-page-chart-relevant":` Quando os objectos associados do relatório seleccionado contendo o objecto actual, é possível filtrar mais tarde os dados do relatório de acordo com o registo actual; Definir se permite aos utilizadores actualizar manualmente os dados do caju.`,
"label.object.page.head":`Cabeçalho de página`,
"label.notification.time1":`dentro de alguns segundos`,
"label.weixin.optionnine":`Escolha 9`,
"label.approval.content.tolang":`O conteúdo que introduziu é demasiado longo, por favor volte a entrar.`,
"label.leadconvers":`Conversão de chumbo`,
"label.compact.layout.frame.tabseq":`Encomenda da página de apresentação:`,
"label.permission":`Conjuntos de permissões`,
"vue_label_notice_new_success":`Criado com sucesso`,
"label.money":`Moeda`,
"label.ccchat.person.invite.unsuppem":`O endereço de correio electrónico que introduziu não suporta {0}`,
"message.profile.del":`Este perfil é um perfil de administrador e não pode ser apagado!`,
"vue_label_report_savelocation":`Guardar localização`,
"label.knowledgebase.select.lighting.target":`Por favor, escolha o alvo Relâmpago`,
"label.visualpage.labelname":`Nome da etiqueta da página`,
"label.notification.ccchat2":`【点赞用户名】liked o seu posto.`,
"label.htyj.wanchenglv":`Percentagem`,
"label.weixin.report.generatedchart":`Gráfico gerado`,
"label.customer.tab.please.label":`Por favor, o separador etiqueta`,
"label.template.lookup":`Ver o modelo`,
"label.attendance.setting.wucha":`Desvio dentro de 200 metros`,
"vue_label_opportunity_product_addproduct":`Adicionar Produto`,
"label.data.setok.t.desc3":`, Operação.`,
"label.emailobject.template.public":`Público`,
"label.setsubmit":`Definições de submissão`,
"chatter.feed.menutype.feed.companycom":`Toda a empresa`,
"label.Generate.Document":`Gerar documento`,
"label.knowledge.setting.hint.six":`Organizar os artigos por classificação de dados.`,
"label.dashboard.show.total":`Mostrar total`,
"attachment.select.warning.001":`O anexo está arquivado e o botão Arquivar não está disponível, por favor seleccione novamente um anexo.`,
"message.schedulejob.error.delete":`Ocorreu um erro ao eliminar a base de trabalhos.`,
"setup.layout.group.pagecomponent":`Componentes da página`,
"label_partner_new_step3_meno":`Não tem a certeza do que deve entrar? não se preocupe, pode alterá-lo mais tarde a qualquer momento.`,
"label.partnerCloud.orderingPlatform.mutex":`Mutex`,
"label.subtotalrely":`Subtotal Bases`,
"label.file.library.selectFile2Lib":`Adicionar Ficheiros`,
"label.lock.record":`Existem( registos bloqueados`,
"label.multilang.addcustomreporttypestage2.description":`Esta fonte de dados irá gerar um relatório sobre {0}. Escolhendo um objecto que esteja relacionado com ele,
é possível definir que registos relacionados noutros objectos serão devolvidos aos resultados da fonte de dados.`,
"message.duplication.errorinscript.greaterthan10":`Pode seleccionar até 10 registos para fundir.`,
"label.encd":`Mostrar Encriptado`,
"UG.Account.03":`Verificar e fundir proactivamente as contas duplicadas`,
"label.salescloud.teamrole.main2":`Major`,
"label.email.to":`Receptor`,
"label.members.sign.notify":`Notificar o supervisor`,
"template.report.individual.case.priority":`Prioridade do caso`,
"vue_label_report_selectfolder":`Seleccionar pasta`,
"label_partner_all":`Todas as nuvens de parceiros`,
"lable.custom.year":`Anos personalizados`,
"label.ispigeonhole":`Arquivo`,
"label.campaignmember.selectmember.steptotal":`Etapa 2 de 2`,
"label.userphoto.save":`Guardar`,
"label.knowledgebase.published.version.online":`As versões publicadas ainda estão online até que publique este rascunho.`,
"template.report.customer.level.statistics":`Estatísticas de Nível de Conta`,
"label.mobile.phone.day.plan":`Amanhã`,
"label.icon.95":`Ensinar`,
"label.recordphone":`Registar uma chamada`,
"lable.currencyManage.unEnabledadvcurrency.discripation":`A desactivação da gestão avançada da moeda irá descontinuar a utilização de todas as taxas de câmbio datadas para a sua organização. As conversões de campos de moeda sobre oportunidades, produtos de oportunidade, e relatórios associados a estes objectos deixarão de ser mapeados para um intervalo de datas - todas as conversões de moeda utilizarão a taxa de câmbio estática.`,
"label.service.gantt.is.candidate":`Candidato de`,
"label.ruleofchecktask":`Regras de validação de tarefas`,
"label.whole.page.show":`Despalhar página inteira`,
"label.validate.function.funcFormat.ISNULL":`ISNULL(expressão)`,
"label.ccdocument.template.set":`Função do conjunto de gabaritos`,
"label.icon.103":`Horário`,
"lable.no.products.to.assets":`Nenhum produto pode ser transferido para activo.`,
"label.fristname":`Primeiro nome`,
"label.appointmentconfirmail.wizard.subtitle5":`Organizador`,
"label.partner.workspace.myspace":`O meu espaço de trabalho`,
"label.tabpage.optionsz":`Opções`,
"component_chatter_link_button_save":`Publicar`,
"label.validate.function.funcFormat.NOW":`AGORA()`,
"label.discountPlanEditor":`Editor do Plano de Descontos`,
"label.weixin.fmu.pm":`PM`,
"front-gantt-module-milestone-sorting":`Classificação de marcos`,
"label.partnerCloud.maximumNumber":`O máximo de sítios parceiros:`,
"label.mobile.place.record.interval.setup":`Intervalo de Partilha de Localização`,
"label.visiblelinenumber":`Linhas Visíveis`,
"front-kefu-moudle-nopower-calluser":`Sem permissão, por favor contacte o administrador`,
"label.field":`Campos`,
"label.projectManagement.groupbydate":`Grupo por data`,
"label_vue_create_edit_obj_create_event_dialog_desc_deal_field":`programado`,
"label.operation.monitoring.history":`Histórico do Job Monitor`,
"label.data.dataexpalltype.all_desc1":`1. Pode disparar para gerar automaticamente e introduzir manualmente a palavra-passe do ficheiro das compressas exportadas. A palavra-passe gerada automaticamente será enviada para a caixa de correio dos utilizadores quando os dados forem exportados com sucesso. A palavra-passe introduzida manualmente não será enviada para a caixa de correio, pelo que os utilizadores precisam de se lembrar da palavra-passe que introduziram. Se não for inserida, por defeito não há palavra-passe.`,
"front-web-module-v1-detail-comment-proposal":`Aguardando as suas valiosas sugestões`,
"label_partner_workspace_member_selectedpermission":`Conjunto de permissões seleccionadas`,
"vue_label_helpcenter_view1":`Na visão da versão de iluminação, pode ver e gerir intuitiva e flexivelmente os dados a que tem acesso. Através da visualização, pode realizar funções básicas tais como visualização de classificação de dados, visualização de dados de múltiplas formas, adição, modificação e eliminação de dados, e pode também visualizar convenientemente relatórios e gráficos para análise de dados adicionais.<br> 1. Manage view<br> No menu pendente no canto superior esquerdo da visualização, seleccione a visualização que pretende visualizar, e seleccione a visualização padrão através de definições fixas. <br> Utilize o menu de controlo da vista de lista para criar, editar, apagar, ou ordenar vistas. Ao mesmo tempo, utilize a função de filtro no canto superior direito para editar e criar rapidamente novas vistas. <br> 2. Ver dados através de múltiplas vistas <br> É possível ver os dados de diferentes maneiras. No canto superior direito, pode mudar a lista, Kanban, e ecrã dividido para ver os dados. <br>Na vista de lista, alguns tipos de campos podem modificar directamente um único ou múltiplos dados. Faça duplo clique na célula a ser editada, ou clique no botão editar, pode editar directamente os dados na janela pop-up. Para editar vários pedaços de dados, basta seleccionar primeiro vários pedaços de dados, e depois seleccionar "Aplicar aos dados seleccionados" na janela pop-up de edição. <Na vista de lista, pode editar directamente a coluna a ser exibida no canto superior esquerdo, clicar no cabeçalho da tabela para ordenar, ou seleccionar a coluna a ser bloqueada através da janela flutuante descendente. <br> Após definir a vista Kanban, é possível visualizar os dados em grupos, e visualizar o valor sumário de cada grupo. Nas definições da vista Kanban, pode editar a base de agrupamento, a base de resumo e o método de resumo da vista Kanban, e também pode seleccionar até quatro campos para exibir. Pode alterar rapidamente o agrupamento de dados, arrastando e largando. <br>`,
"component.task.label.priority":`Prioridade`,
"label.datamanage.field.error":`Erro no campo do objecto de consulta.`,
"label.console.step3":`Passo 3. Seleccionar a fonte da imagem para a consola`,
"label.ems.emailsyncsetup":`Definição de sincronização de e-mail`,
"label_tabpage_placeenterz":`Por favor, introduza`,
"label.getontocolumn":`Saltar para a Coluna:`,
"label.file.down.e":`O tipo de ficheiro actual não pode ser descarregado`,
"vue_label_notificationcenter_unreadonly":`Apenas não lido`,
"label.login.access.change":`Alterar`,
"label.globaloperation.operationtype.send_e-mail":`Enviar e-mail`,
"label.dashboard.refresh.hint":`Clique em Actualizar para carregar os últimos dados no tablier. Vai demorar algum tempo a executar a fonte de dados, tem a certeza de que quer actualizar?`,
"front-kefu-moudle-open-free":`Habilitar (Julgamento)`,
"label.lanxin.setting.appsecret":`AppSecret`,
"label.payment.manage.order":`Gerir a sua Subscrição`,
"label.chatter.maturiyDate":`Data de expiração`,
"message.mobilechooseatmostthree":`O separador para Mobile App pode seleccionar até três campos.`,
"label.customfields.formula.tip":`Um campo só de leitura que deriva o seu valor de uma expressão de fórmula que se define. O campo da fórmula é actualizado quando qualquer um dos campos de origem muda.`,
"lable.PowerProcess.start.time":`Por favor, seleccione a hora de início.`,
"label.mr.title.button.group2":`conjunto(s) de registos duplicados,um total de`,
"label.atlantic.standard.time":`Horário Padrão do Atlântico`,
"label.account.LengthofTime":`Duração`,
"label.ccchat.message.search.desc2":`mensagens`,
"label.pigeonhole.desc":`O anexo de arquivo é válido apenas para anexos não arquivados.<br/>Após um anexo ser arquivado, não será apagado.`,
"label.partnerCloud.orderingPlatform.sure":`O interruptor {alias} irá esvaziar o carrinho. Tem a certeza de confirmar a operação?`,
"label.default.value.is.positive.integer":`O valor por defeito deve ser um número inteiro positivo`,
"label.partnerCloud.selectOne":`Seleccione pelo menos um menu`,
"label.dashboard.more.condition":`Mais condições`,
"component.event.label.enddate":`*End Time`,
"label.forecast.settings.type":`Tipo de previsão`,
"com.cloudcc.login.error.message.licensenotstart":`A licença não tem início`,
"lable.list.queue":`Filas de espera`,
"label.mobile.app.isdisablum":`Desactivar a selecção de fotografias do álbum móvel no checkin`,
"label.service.gantt.filter":`Ao filtrar por competências, apenas os recursos com a competência seleccionada serão mostrados no gráfico de Gantt`,
"label.potentialcustomeronline":`Web-to-Lead`,
"label.campaignmember.main.deletecontactdesc":`Retirar em massa todos os contactos desta campanha`,
"label.list.desc1":`Usando Web to CloudCC, pode capturar informações de contacto e perfil dos utilizadores e gerar automaticamente novas pistas no CloudCC.com`,
"label.generatepage.title.desc3":`O nome tem de ser único, e o nome tem de implorar com uma letra. Deve conter apenas letras maiúsculas e minúsculas, números, e sublinhado. Não deve ter mais de 30 caracteres.`,
"label.emailtocloudcc.step2total3":`Etapa 2 de 3`,
"label.movablemenu":`Botões de actividade`,
"label.partnerCloud.partnerAccount.topUp":`Completar`,
"label.data.standobject":`Objectos Padrão`,
"label.frequency":`Frequência`,
"label.schedulejob.setup.schedule.end":`Fim`,
"label.chat.topic.following":`A seguir`,
"label.martrixreport.2018.step2":`Passo 2 Resumir a informação por:`,
"label.event.moveup.11hour":`11 horas à frente`,
"label.forecast.customforecast.directorcommit":`Compromisso dos Subordinados Directos`,
"vue_label_homepage_card_view":`Vista de Cartão`,
"vue_labenl_applauncher_notice_closecertification":`Os dados serão perdidos depois de os desligar. Tem a certeza de o fazer?`,
"component_setup_button_weburl":`URL externa`,
"label_emailtocloudcc_button_addemailaddress":`Adicionar Caixa de Correio Empresarial`,
"vue_label_campaign_added_campaign_members":`Adicionou com sucesso membros da campanha`,
"label_tabpage_rtemptyz":`O tipo de registo não pode estar vazio`,
"label.martrixreport.2018.step5":`Passo 5 Seleccionar o tipo de gráfico e o item em destaque`,
"label.moverecord":`Registo de transferência`,
"pagecreator_layout_label_layoutdesc":`Descrição do layout`,
"label.knowledge.setting.data.nine":`Sim, quero eliminar este grupo de categorias e as categorias sob este grupo.`,
"label.icon.90":`Pessoas`,
"label.weixin.micro.research.name":`Nome do Micro Inquérito`,
"label.ccchat.micropost.allowedit":`Permitir que os utilizadores editem mensagens e comentários`,
"vue_label_homepage_fixed_components":`Componente padrão`,
"label.version.document":`Biblioteca de documentos`,
"label_assessment":`Avaliação (Oportunidades - Montante)`,
"label.appupload.component.type.lookuplayout":`Esquema de pesquisa`,
"label_chatter_loadmore":`Carregar mais`,
"component_setup_tabs_label_memo":`Definir o nome da etiqueta do separador`,
"label.icon.167":`Bússola`,
"vue_label_chatter_enter_content_sharing":`Por favor, introduza o conteúdo da partilha e o grupo de partilha`,
"vue_label_notice_modify_success":`Modificado com sucesso`,
"label.sharerules":`Regras de Partilha`,
"label.field.api.exists":`Este campo API nome já existe.`,
"label.icon.83":`Tinta`,
"label.file":`Ficheiro`,
"vue_label_report_foldernameisrequired":`Nome da pasta é necessário`,
"label.emailobject.wizard.btn2":`Conectado, ir para enviar e-mail`,
"label.data.downpage.i_title.num3":`3. B Antes de importar, certifique-se de importar todos os registos relacionados. Por exemplo: se houver uma relação de pesquisa entre os objectos que está actualmente a importar e os contactos, deve importar primeiro os contactos e depois importar os seus dados.`,
"label.email.original.content":`Conteúdo de referência`,
"vue_label_campaign_add_to_campaign":`Adicionar à campanha`,
"label.dashboard.new":`Novo Painel de Instrumentos`,
"label.console.detail":`Pormenores da Consola`,
"label.view.desc":`O campo de data pode ser igual a "ontem", "hoje", "amanhã", "último mês", "este mês", "próximo mês", "última semana", "esta semana", "próxima semana" ou "AAAA-MM-DD、MM/DDD/AAAAA".`,
"label.emailobject.template.insert.continue":`Continuar`,
"label.notification.appointment.overlapEvent":`A hora seleccionada está a ser agendada, por favor seleccione outra hora.`,
"label.console.step6.top":`Fixados ao topo e as listas são sempre visíveis.`,
"label.data.file.the_trigger":`Executar Trigger`,
"message.report.error.operation":`A acção falhou, por favor reinicie o relatório`,
"vue_label_helpcenter_detail3":`<br>     Gostar e não gostar<br>    Pode gostar de um comentário sobre um micro-post ou apenas um micro-post. Depois de gostar, pode ver o número de likes para o posto, e também pode, ao contrário. <br>? Editar e apagar posts<br>     A editora de um post pode reeditar ou apagar o post. <br>     Passo 1: Clique no botão à direita do post e seleccione Editar ou Eliminar na caixa pendente<br>    Passo 2: Abra o Edit/OK para eliminar pop-up<br>     Passo 3: Clique Save/OK para completar a operação<br>5. Histórico de Aprovação<br>? Submeter para Aprovação<br>     O botão "Submeter para Aprovação" aparece quando um novo registo é criado, um pedido de aprovação é chamado de volta, ou uma aprovação é finalmente negada. <br>     Passo 1: Clique em "Submeter para Aprovação". O sistema determina se o registo e o apresentante cumprem o projecto e as condições iniciais de apresentação estabelecidas pelo processo de aprovação, e se todas estas condições forem cumpridas, a apresentação é bem sucedida. <br>     Se a etapa seguinte da configuração do processo de aprovação exigir a selecção manual do aprovador, então a etapa 2 é executada após "Submeter para Aprovação".<br>   Etapa 2: Seleccionar o próximo aprovador e concluir a operação de submissão. <br>? Histórico de Aprovação<br>     A. Antes de submeter:<br>     Clique em "Previsão do Processo de Aprovação", o sistema determinará se o registo e o operador que submete cumprem os itens definidos no processo de aprovação e depois, se todas estas condições forem cumpridas, o processo de aprovação é exibido. <br>     B. Após a submissão:<br>    No histórico de aprovação pode não só visualizar as etapas do histórico de aprovação e o estado actual de aprovação do registo, mas também pré-visualizar o processo de aprovação seguinte. <br>? Pull back approval requests<br>     Se este processo de aprovação for configurado para retirar pedidos de aprovação, estes podem ser retirados a qualquer momento depois de os submeter. <br>     Passo 1: Clique em "Pull Back Approval Request" na página de detalhes do registo <br>   Passo 2: Abra a página Pull Back Approval Request e clique em "Call back approval request" para concluir a operação`,
"Opportunity_Detailed_Phase_Label_004":`dia(s)`,
"PageLayout_Search_MultiSearch_001":`Seleccionar até 3 campos.`,
"vue_label_systemSettings_set_business":`Configure a disposição e os campos de objectos para se adequarem ao seu negócio.`,
"label.compact.layout.frame.select":`Por favor seleccione uma moldura de layout de página`,
"label.tabpage.rolez":`Papel`,
"label.weixin.appr.currentauditor":`Atribuído a`,
"label.knowledgebase.verification.status":`Estado de Verificação`,
"UG_Case_05":`Criar um caso`,
"label.service.marking.completed":`Marcar como Concluído`,
"label.notification.ccchat1":`【发出@的用户名】mentioned você.`,
"label.knowledgebase.no.action.available":`Nenhuma acção disponível`,
"label.tabpage.newlybuildz":`Novo`,
"label.appupload.install.error.choice2":`Renomear os componentes locais que entram em conflito com o pacote`,
"label_tabpage_as":`Como`,
"Opportunity.Detailed.Phase.Label.Popup.001":`Data de Início da Etapa Actual`,
"vue_label_homepage_singlepage":`Adicionar até 10 componentes a uma única página`,
"font-evaluate-module-v1-fair-and-bad":`Quando o tipo de avaliação é Neutra e Negativa`,
"label.partnerCloud.orderingPlatform.orderInformation":`Confirmação de encomenda`,
"label.custom.lead.conversion.notice":`Converter o Lembrete de Chumbo`,
"label.re.upload":`Carregar de novo`,
"label.knowledgebase.top.window":`Janela superior`,
"label.h5.allmarkedasread":`Todos marcados como lidos`,
"vue_label_SMS_open_record_from_start_activation":`Abrir o registo da lista para activar.`,
"label.customer.tab.step2":`Passo 2 Adicionar aos Perfis`,
"label.campaign.channel.input.owner.select2":`Pessoa de Solicitação deste Canal de Marketing`,
"component.task.button.save":`Guardar`,
"front-kefu-moudle-v1-phone-type":`Tipo de telefone`,
"label.wedge-shapearrows":`Flecha da cauda em forma de cunha`,
"vue_label_homepage_todaysevent":`Eventos de hoje`,
"label.data.exp.way.sel":`Seleccionar o modo de exportação`,
"label.setting.intergrationlist.status1":`Esta integração não está actualmente instalada.`,
"button_partner_workspace_disable":`Cancelar activação`,
"label.customfields.reference":`Podem ser referenciados por outros campos, tais como fórmulas, listas de selecção, campos de pesquisa, e assim por diante.`,
"label.publicgroups.new":`Novo Grupo Pubilc`,
"label.data.setok.e_desc3":`， descarregue os seus dados exportados.`,
"vue_label_commonobjects_view_chart_countmode":`Modo de contagem`,
"label.service.appointmentList.earliest.allowedStart":`Primeira Data de Início`,
"label.data.choses.e.desc":`De acordo com as suas necessidades, pode exportar todos os dados ou exportar dados de um objecto.`,
"label.multilang.common.fieldlist.fieldremark":`Aplicar para os campos apresentados na página {0}`,
"label.umeng.activity.event":`evento`,
"label.project.hit.ten":`Lembrete de actualização de emissão`,
"label.c_d_least":`Cada registo "C" deve ter pelo menos um registo "D" relacionado.`,
"label.emailobject.wizard.btn1":`Ligue o seu e-mail`,
"lable.product.pricebooks.info":`Detalhes do Livro de Preços`,
"component_telerecord_label_message":`Comentário`,
"lable.total.of.estimates":`0 estimativas no total`,
"label.stdashbord.xsld.business.oppcounts":`Quantidade de Oporcionalidades`,
"vue_label_commonobject_duplicatewith":`Duplicar {1} em {0}`,
"label.setpicandreport":`Definições de gráficos`,
"label.category.2":`Geral`,
"label.emailtocloudcc.reauthorization":`Reautorização`,
"label.chatter.vote":`Sondagem`,
"label_emailtocloudcc_edit":`Editar`,
"label.pleaseinput":`Entrada`,
"vue_label_homepage_user_particular_application":`A página inicial quando o utilizador utiliza uma aplicação em particular, as atribuições irão sobrepor-se à página inicial padrão`,
"label.allianceID":`Identidade de estrangeiro`,
"label.h5.homepage.cannot.applied.mobile.terminal":`A página inicial do perfil não está configurada para este perfil. Não está disponível para a aplicação móvel.`,
"label.appointmentpage.wizard.notif2":`O nome é obrigatório!`,
"label_emailsync_status_email":`E-mail com acção executada`,
"label.icon.179":`Pessoas`,
"UG_Contract_03":`Criar contrato`,
"label.cy.new":`Nova moeda`,
"label.version.setup.controllist":`Lista de Controlo de Configuração`,
"label.vlidaterule":`Regras de Validação`,
"label.customer.tab.name":`Nome do separador`,
"label.recentview.seloption1":`Visto recentemente`,
"vue_label_report_notice_nameisrequired":`O nome do relatório é obrigatório`,
"label.createapproveprocessstep":`<Criar templates de email</li>1.Ler os tópicos de ajuda</li>2.Criar templates de email</li>3.Criar templates de SMS</li>4.Criar um processo de aprovação usando o Jump Start ou o Assistente Standard</li>>5.Adicionar a lista relacionada com o "Histórico de Aprovação" a todos os layouts de página</li>6.Activar o processo para distribuir aos seus utilizadores</li>`,
"label.gotocalendar":`Ir para Calendário`,
"label.import.page1.pleaseselectobj":`Por favor seleccione primeiro o objecto`,
"label_tabpage_messagez":`Por favor, introduza o seu comentário`,
"vue_label_homepage_profilepage":`Página inicial do perfil`,
"label.tabpage.choose":`Seleccione`,
"label.campaignmember.setup.lead.field":`Campos de chumbo`,
"label.setalipay.null":`As informações necessárias para a configuração de Alipay estão vazias.`,
"label.custom.Current.and.NextCQ":`CQ actual e CQ seguinte`,
"label.knowledgebase.needto.publish.articles":`O artigo arquivado de novo criará uma versão preliminar. Quer publicar o artigo?`,
"pagecreator.layout.message.save.success":`Layout guardado com sucesso`,
"homepage.componet.approval.label":`Itens a aprovar`,
"label.last_submission":`Última Hora Submetida`,
"lable.outlook.detail.prefo":`A troca ganha sempre`,
"label.projectManagement.new.subtask":`Nova Sub-tarefa`,
"label.service.appointmentList.checkThe":`Verificado`,
"message.error.searchlayoutselectdefields":`Não pode ser apagado e deve ser o primeiro campo no esquema de pesquisa.`,
"label.ems.normal":`Normal`,
"vue_label_notice_pleaseselectobject":`Por favor seleccione um objecto`,
"component.sendmail.button.send":`Enviar`,
"label.relevant.records":`Registos relacionados`,
"label.weixin.login.CloudCC":`Iniciar Sessão`,
"label.tag.addtags.private":`Particular`,
"label.appointment.disable.remark":`Desculpe, a função está actualmente desactivada. Se quiser remarcar ou cancelar a reunião, contacte a pessoa responsável em {邮箱地址}.`,
"label.campaignmember.main.addMember1":`Adicionar membros`,
"message.error.objectnofound":`Objecto indefinido`,
"label.employeenum":`Número do funcionário`,
"label.search.applyfilter":`Aplicar filtro`,
"label.version.history.track.nonsupport":`Apenas a versão infinita suporta a função de histórico de rastreio de campo.`,
"label.ccpeak.direction.for.use.time":`Instrução para as aulas programadas [Versão 2.0]`,
"label.ems.settings":`Definições`,
"label_tabpage_arecordtypez":`Tipo de registo disponível`,
"vue_label_pool_assign1":`{1}{2}`,
"label.customcomponent.direction.for.use":`Instrução para Componentes Personalizados [ versão 2.0]`,
"label.appupload.appname":`Nome do pacote`,
"label.cpq.order.status.no.active":`Só encomendas com estatuto activo podem gerar contratos`,
"label.dashboard.maxlength":`Pode introduzir até 255 caracteres`,
"label.customize.memory.function.sorting.title2":`Memória de classificação de cabeçalhos`,
"label.report.chose.obj":`por favor, seleccione a relação objecto e informe a fonte de dados`,
"label.partner.step3":`Passo 3 Informação básica`,
"message.report.type.error.fail":`Fonte de dados do relatório inválido.`,
"pagecreator.page.message.publish.fail":`A publicação da página falhou`,
"label.minimun":`Mínimo`,
"label.state":`Estado`,
"label.customcomponent.referencetype":`Tipo de referência`,
"label.nameandemailtemplate":`Introduza um nome para o seu processo na caixa abaixo e depois seleccione um modelo de e-mail para notificar o autorizador (opcional).`,
"label.customobjects.track.introduce":`Esta página permite-lhe seleccionar os campos que deseja localizar no`,
"label.campaign.matchway.label":`Método de correspondência`,
"label.redistribution":`Reatribuir`,
"label.groupmanage":`Gestão da Organização`,
"label.icon.157":`Câmara`,
"label.quickbooks.viewlist.total":`TOTAL`,
"label.file.copy.file.fail":`Cópia falhada,por favor copiar manualmente`,
"label.outline.selectfield":`Campos seleccionados em resumo:`,
"label.datetime.maxsize":`O ciclo de uma consulta não pode ser superior a três meses.`,
"label.dashboard.CustomDashboardMyHomePage":`Personalizar os Painéis da minha página inicial`,
"label.data.customobject":`Objectos personalizados`,
"vue_label_SMS_noselected":`Nenhum registo seleccionado`,
"label_tabpage_value":`Valor`,
"label.quote.qianming":`Assinatura`,
"label.view.source":`Ver Código Fonte`,
"label_popup_infoz":`Pronto`,
"label.emailtocloudcc.redmessage8":`Erro de parâmetro, por favor contacte o administrador.`,
"label.tianyancha.Search.business":`Pesquisar informação de registo de empresas`,
"vue_label_systemSettings_server":`Serviço`,
"vue_label_homepage_dashboard_components":`Componente do painel de instrumentos`,
"label.search.listview":`Vista de lista`,
"label.service.gantt.distribution.success":`Atribuído com sucesso`,
"label.icon.4":`Carteira`,
"label.partnerCloud.orderingPlatform.calculate":`Calcular preço`,
"label.forecast.edittotal.ycyx":`Prioridade Prevista`,
"vue_label_commonobjects_detail_to_precise_search":`Pesquisa exacta`,
"label.order.number":`Encomenda`,
"setup.mainpage.label.welcome7":`Instruções: Clicar no menu do lado esquerdo da página → Configurações da aplicação → Criar → Objecto → Nome do objecto → Campo personalizado.`,
"label.weixin.user.binding":`Encadernação do utilizador`,
"label.custom.canvas.size":`Tamanho da tela`,
"label.projectManagement.recent.projects":`Projecto recente`,
"vue_label_helpcenter_lead":`Acompanhe e administre as suas pistas através do Cloud CC. Use as regras configuradas para marcar e atribuir leads, e converta-os em clientes, contactos e oportunidades de negócio correspondentes no momento certo.<br>Pontuação<br> No canto superior direito da vista, use o botão de pontuação por lotes para marcar leads na vista.<br>distribuição<br>> Ao criar ou editar um lead, seleccione Atribuir no fundo da página para atribuir o lead ao pessoal correspondente para processamento de acordo com as regras existentes.<br>Conversão<br> No momento certo, pode converter leads em clientes e contactos clicando no botão de conversão no canto superior direito da página de detalhes. Ao mesmo tempo, pode criar oportunidades de negócio e tarefas correspondentes para facilitar o acompanhamento contínuo das oportunidades de transacção.`,
"label.enabledprocess":`Processos de Aprovação Activa`,
"label.emailobject.noemail":`Ainda não há correio, vá e envie um!`,
"label.validate.remark3":`Determinar se um campo é necessário com base no valor de outro campo`,
"vue_label_salesadvance_retention":`Retenção`,
"label.product.managep":`Gerir Livros de Preços`,
"font-evaluate-module-v1-not-report":`Não reabrir`,
"label.emailmerge.mergepage.step1":`1. escolher os registos a fundir:`,
"front-epwechat-module-v1-epwechat-describe":`CloudCC proporciona a integração com a WeCom, combinando as poderosas características da WeCom com a versão leve H5 do sistema CloudCC,<br /> ajudandoo a gerir convenientemente as relações com os clientes, operar o tráfego de domínio privado, e melhorar as receitas das empresas.`,
"label.partner.template.detailimage":`Fotografia`,
"label.recycle.clearall":`Lixeira Vazia da sua Organização`,
"chatter.error.nottype":`Erro:Tipo de ficheiro inválido. Por favor utilizar ficheiros JPG,GIF ou PNG.`,
"pagecreator.button.cancel":`Cancelar`,
"front-market-form-quired-ziduan":`Campos obrigatórios na página de registo`,
"vue_label_report_columnname":`Nome da coluna`,
"message.notdelete.type":`Não pode apagar este tipo de registo, porque os perfis seguintes utilizam este tipo de registo como valor por defeito.`,
"label.ccpeak.folder.all.time":`Todas as Pastas de Classe Agendadas`,
"label.quickbooks.searchlist.total3":`Existem {0} estimativas não vinculadas para um valor total de {1}.`,
"label.forecast.detailforecast.quantity":`Previsão da quantidade`,
"label.knowledge.language.british":`Britânico`,
"label.vlidaterule.example.messagelocation":`Esta mensagem de erro pode aparecer ou no topo da página ou abaixo de um campo específico na página`,
"front-kefu-moudle-chf-success":`Dividido com sucesso`,
"vue_label_jihui_yi":`Oportunidade 1`,
"label.import.step1.null":`Não há opções disponíveis`,
"label.console.step5.tab.subtab":`Como uma subárea de`,
"batch.edit.permission":`Sem permissões para editar`,
"label.weixin.fmu.before.min":`{0} minutos antes do previsto`,
"chatter.up.file":`O carregamento do ficheiro demora algum tempo, dependendo do tamanho do ficheiro carregado, aguarde, por favor.`,
"setup.layout.group.field":`Campos`,
"label.chat.unlike":`Gosto`,
"vue_label_dashboard_updatefrequency":`Frequência de actualização`,
"label.trigger.folder.new":`Páginas de activação: Nova Pasta`,
"label.process.des.app":`Clique no link à direita para ver detalhes do registo actual.`,
"vue_label_pool_assignselect":`Escolher designar membros`,
"label.lookup.user":`Pesquisar Colegas`,
"label.mobilescreentablayoutedit.remark2":`Seleccionar os campos de filtragem apresentados na página inicial do separador em Mobile App.`,
"label.data.exp.objtemp":`Criará o modelo para exportar os dados deste objecto da seguinte forma cretira`,
"label.weixin.moreselect.error":`Apenas 10 registos que pode seleccionar`,
"label.icon.25":`Ligadura`,
"lable.sample.text":`Exemplo de texto`,
"label.most.setup.obj":`Podem ser definidos até 10 objectos.`,
"label.weixin.coming":`Em breve`,
"label.editdescription":`Nota Editar`,
"label.multipleactivity.multiple":`Multi Utilizadores`,
"label.sso.saml.idp.entityid":`ID da entidade`,
"label.SMS.pho.filed":`Campo Telefónico`,
"message.serviceabsence.violation":`Violação do período de atribuição: está em conflito com o registo de ausência.`,
"label.forecast.settings.type.clist":`Utilizar famílias de produtos`,
"label.state.noend":`Incompleto`,
"label.sourcetemp":`Fonte`,
"vue_label_chatter_name_link":`Por favor preencha o nome e o link`,
"label.emailobject.attach":`Anexar`,
"label.everyother":`Todos os outros`,
"label.title":`CloudCC.com`,
"vue_label_chat_haventactivate":`Ainda não activou uma conta de chat. Quer activar agora?`,
"pagecreator_layout_button_delete":`Apagar layout`,
"label.transfer.temporarily":`Chamada`,
"label.service.dispatchingUnits.search.services":`Nomeação do Serviço de Pesquisa`,
"customer.message.fail.chat":`Falha na obtenção de registos de mensagens, por favor contacte o administrador para obter ajuda`,
"label.apiname.toolong":`O nome API é demasiado longo.`,
"label.empty.filter":`Filtros transparentes`,
"label_tabpage_personalCenterz":`Centro pessoal`,
"label.minutes":`Ata`,
"label.multipleactivity.atasks":`Tarefa(s)`,
"label_tabpage_deleteview":`Apagar a vista`,
"pagecreator_layout_message_save_success":`Layout guardado com sucesso`,
"label.reportlineorder":`Ordem das Colunas de Relatório`,
"label.total.forecast.have.priority":`qualquer previsão é anterior, mas as que aceitam outras sub-condições são anteriores`,
"label.custom.quarter.subtitle":`Trimestre personalizado`,
"label.icon.79":`Imprimir`,
"label.hiddenoperate":`Ocultar acções`,
"label.project.hit.six":`Aviso de atribuição de tarefas`,
"label.visualpageaction.errordesc":`Não tem a permissão para excutar a operação que solicitou. Por favor contacte o proprietário do registo ou o seu administrador.`,
"label.chat.unmute":`Cancelar "não desconcentrar".`,
"label.zhaiyao":`Abstrato`,
"vue_label_commonobjects_detail_bcc":`Bcc`,
"label.customcomponent.page.index.table.version":`Versão API`,
"UG.quota.06":`Criar uma citação`,
"label.icon.152":`Robô`,
"label.partnerCloud.partnerAccount.account":`Nome de utilizador`,
"label.file.sharewith":`Partilha`,
"label.data.dataexptemplate.desc2":`2. O formato de compressão está dividido em dois tipos: um é gerar automaticamente a palavra-passe do ficheiro comprimido, o outro é introduzir manualmente a palavra-passe do ficheiro comprimido.`,
"vue_label_dashboard_newfoldersuccessfully":`Criar nova pasta com sucesso`,
"label.campaignmember.main.importmember":`Membros de campanhas de importação em massa`,
"label.htyj.completed":`Concluído`,
"label.reportTypeLabel":`Rótulo do tipo de relatório`,
"label.customer.tab.label":`Rótulo do separador`,
"label.dashboard.component":`Componentes`,
"label.safetystatement.dialog":`Declaração de segurança (Nova janela)`,
"label.forecast.settings.data":`Data Prevista`,
"label.knowledgebase.modifiedby":`Modificado por`,
"label.batchadd.remark":`Adicionar Registos Múltiplos`,
"button.partner.delete":`Eliminar`,
"Pagelayout_Setup_005":`O nome tem de ser colocado em primeiro lugar.`,
"label.forecast.edit.wcpxl":`Sem famílias de produtos`,
"lable.PowerProcess.seq.input":`Por favor, introduza uma encomenda.`,
"pagecreator.layout.message.delete.fail":`Apagamento do layout falhou`,
"label.emailobject.edit":`EDIT`,
"label.weixin.million":`Dez mil yuan`,
"setup.mainpage.button.manageobject":`Gestão de objectos`,
"label.weixin.participants.perfect.information":`Os participantes são obrigados a melhorar a informação`,
"vue_label_campaign_campaign_members":`Adicionar membros da campanha`,
"label.ccchat.person.invite.emplaceholder":`Introduzir endereços de correio electrónico, e separar por ponto e vírgula`,
"label.mobile.phone.new":`Novo`,
"font-evaluate-module-v1-small-program-evaluation-settings":`Configuração de avaliação de miniprograma`,
"UG.opportunity.005":`Processo de vendas múltiplas`,
"vue_label_report_polymerization":`Agregado`,
"label.multilang.lookfiltercondition.fieldtypenotmate":`A condição da linha {0} está incorrecta, o tipo de campo não corresponde!`,
"label.knowledgebase.delete.draft":`Eliminar rascunho?`,
"label.mr.descreption.condition3":`Regra - correspondência exacta: verificar este item e encontrar registos duplicados com os mesmos caracteres de campo. Se for verificado, encontrar duplicados pelos primeiros caracteres invaidará.`,
"Lead.Auto.Scoring.Setting":`Definição da pontuação de chumbo`,
"label.marketing.channel.default":`Canal de Marketing (Activado por defeito)`,
"front-project-module-v1-select-projecttemplate":`Seleccionar modelo de projecto`,
"front-email-payment-select-area":`Favor entrar no distrito`,
"lable.PowerProcess.message":`Informação sobre o processo de concessão de direitos`,
"label.weixin.free.get.captcha":`Obter Código de Verificação Gratuito`,
"label.projectManagement.please.select.task.or.question":`Por favor seleccione Tarefa/Issue`,
"label.pacific.daylight.time":`Horário de Verão do Pacífico`,
"label.sendsms.batch.step1.introduce":`Seleccione uma das seguintes vistas (que contém os destinatários deste SMS)`,
"label.same.analyze.account.name":`Nome da conta`,
"Homepage.Contract.FieldMissed.DoesntSupport":`Não existem campos "qdrq" e "htje" no objecto do contrato, pelo que os dados não podem ser mostrados.`,
"label.partnerCloud.orderingPlatform.noProduct":`Não é necessária nenhuma configuração de opção de produto sob este produto.`,
"label.totalsummary":`Resumo do Roll-Up`,
"label.partner.workspace.tab":`Tab`,
"label.entitlement.process.name.unique":`Este nome já existe. Por favor, introduza novamente.`,
"report.label.norole":`Não tem permissão para o fazer, por favor contacte o seu administrador.`,
"label.password.old.error":`Palavra-passe antiga incorrecta, por favor reintroduza-a.`,
"lable.account.quarter.stadate":`Dia de Início do Trimestre Fiscal`,
"label.salescloud.contactrole.choose.correct":`Contactos em duplicado seleccionados, por favor corrigir.`,
"label.schedulejob.setup.schedule.day":`Dia`,
"label.communalusergroup":`Grupos Públicos`,
"label.Display.Fields":`Campos apresentados na lista de apoio ao serviço`,
"label.marketsea":`Piscina`,
"label_partner_setup_address":`Endereço da nuvem de parceiros`,
"label.industrialandcommercialverification.label.url":`URL`,
"lable.data.exp.newtemp":`Exportação de dados e criação de modelos`,
"label.pc.ui.2018":`Vertical`,
"label.version.free":`Edição gratuita`,
"label.dataimport.contact.length":`Erro: o comprimento do nome do contacto é demasiado longo`,
"label.cy.vlidate":`A acção da moeda activada é irreversível. Tem a certeza de que quer activar a Gestão da Moeda?`,
"label.recycle.all":`Todas as Caixas de Reciclagem`,
"label.message.changeaccount.isnot":`O contacto permitiu ao utilizador parceiro,não pode mudar de conta`,
"label.searchlayout.exactsearch":` Dica: Marque a caixa de verificação atrás do campo de pesquisa para efectuar uma pesquisa exacta para esse campo`,
"label.file.size.limit":`Nota: O tamanho máximo do ficheiro é de 10M.`,
"label.mobileapp.modelsetting1":`Configurações do Módulo Móvel Padrão`,
"template.report.overall.sales.opportunities":`Período Global de Vendas (Por Tipo de Oportunidade)`,
"label.password.update.success":`Senha alterada com sucesso.`,
"label.import.page3.gobackhome":`De volta a casa`,
"label.phone":`Telefone`,
"label.detail.vlidaterule":`Ver Regras de Validação`,
"label.weixin.input.usernames":`Por favor introduza o seu nome de utilizador`,
"label.icon.85":`Transformador`,
"vue_label_systemSettings_partner":`Parceiro`,
"label.processsetting.new.process":`Novo Processo`,
"Lead_Scoring_Setting_Rule_Setup_01":`Lista de regras de pontuação de chumbo`,
"setup.layout.component.area":`Área`,
"label.createnewpwdinformuser":`Gerar uma nova palavra-passe e notificar imediatamente o utilizador`,
"label.pwinfo":`Detalhes da palavra-passe`,
"label.imgfield.type.url":`Imagem de referência`,
"label.attendance.sxccheckincy":`Check-In de membros da campanha`,
"lable.PowerProcess.condition.input":`Por favor, seleccione a condição.`,
"label.partnerCloud.partnerAccount.topUpFailure":`Recarga de fialed`,
"label.document.size.too.long":`Tamanho do documento excedido`,
"label.link":`Ligação de acesso`,
"label.partnerproduct.sort.repeat":`O nome da família do produto é tomado.`,
"label.data.setok.e_desc2":`Página de Lista de Dados de Exportação`,
"front-project-module-v1-plase-input-project-name":`Por favor introduza o nome do projecto`,
"label.export":`Exportação`,
"label.icon.45":`Caldeira`,
"label.autoRegister.changepwd.title":`Defina a sua palavra-passe de início de sessão`,
"label_clear_adjust":`Ajuste claro`,
"front-kefu-moudle-return-visit":`Revisão`,
"label.ems.compose":`Compor`,
"Pagelayout_Setup_002":`Seleccionou 3 listas relacionadas, e acrescentar mais listas relacionadas irá afectar a disposição da página.`,
"label.service.gantt.skill.screening":`Utilizar filtro de aptidões`,
"label.partnerCloud.basicSetting.enable":`A Nuvem de Parceiros será desactivada. As acções de login e edição na sua organização serão automaticamente desactivadas pelo sistema.`,
"label.workbanch.setup.description":`Pode configurar as seguintes vistas para mostrar em My Workbanch.`,
"label.category.1":`Todos`,
"label.foldername":`Nome da pasta`,
"label.forecast.settings.shuliang":`Quantidade`,
"label.emailmerge.newtemplate.word":`Por favor, carregue documentos do Microsoft Word.`,
"message.error.type":`tipo não pode estar vazio, precisa de passar de tipo público ou pessoal privado!`,
"label.manualallocation":`Atribuição manual`,
"label.addattachment.step2":`Passo 3 Clique em Upload File para carregar o ficheiro`,
"label.company":`Empresa`,
"label_emailsync_status_export":`Exportar como ficheiro em formato Excel_csv`,
"label.eventreminder":`Lembrete do evento`,
"label.emailtemplate.lookup":`Ver Modelos de Email`,
"label.customsetting.touse.getCustomSetting":`Consultar o tipo de "hierarquia" de definições personalizadas, devolver o apiName e permistions correspondentes (ID é profile ID ou User ID ), Map map = cs.getCustomSetting(String apiName, String id);`,
"label.projectManagement.Resourceuse":`Utilização de recursos`,
"label.appointment.wizard.subtitle4":`Configurações de tempo e tampão`,
"label.donot.close.your.browser":`Durante este processo, por favor não clique noutra ligação ou feche o seu web browser.`,
"label.multilang.customforcast.target":`Alvo de {0}：`,
"setup_layout_label_newarea":`Nova área`,
"component.timeline.button.more":`Mais passos`,
"label.appointmentdetail.wizard.title3":`Duração`,
"label.help.new.features.pc":`Pc-side guia de funcionamento de novas funcionalidades`,
"label.mr.record":`Registo`,
"label.trigger.wgd":`Gatilhos não queimados`,
"label.icon.72":`Caixa de ferramentas`,
"setup.layout.label.detailpage":`Página de detalhes`,
"frame.personinfo.label.usethisimage":`Vamos utilizar variações desta imagem em miniatura em torno da aplicação.`,
"label.multilingual.confirm.open":`Tem a certeza de que o permite? A multilinguagem pode ser utilizada depois de activada.`,
"label.recordcreater":`Criado por`,
"label.afterfinish":`Quando terminar, clique em Guardar`,
"label.companyinformation":`Informação sobre a empresa`,
"step1":`Passo 1`,
"label.sales.page.dashboard.add":`Adicionar à página inicial Painel de controlo`,
"label.processsetting.process.enabled.failed":`Falha em apagar o processo!`,
"label.document.history.date":`Data`,
"label.linkedin.title":`LinkedIn-H5MiniApp`,
"label.foldervisitlimit1":`Todos os utilizadores podem aceder a esta pasta`,
"april":`Abril`,
"label_emailsync_form_disconnect":`Cancelar Conncet`,
"label.appointment.wizard.subtitle4-2-6":`2 Dias`,
"vue_label_notice_follow_success":`Seguiu-se`,
"label.startuploadfile.success":`Ao clicar em "Start Upload", se a barra de progresso atingir 100%, o ficheiro é carregado com sucesso e desaparece na área superior.`,
"message.accesstoken.acquisition.failed":`Falha em obter a ficha de acesso!`,
"label.quickbooks.fieldlabel.fistname":`Primeiro nome`,
"label.appointment.wizard.subtitle1-5":`1 h`,
"2018UI.Homepage.DataNoAccess.Info":`Não tem permissão para ver este registo, por favor clique para voltar ao passo anterior.`,
"label.batchaddattachments":`Fixação de adição em massa`,
"label.ems.next":`Próximo`,
"label.quote.zhekou":`Desconto`,
"lable.product.notdel":`Porque ainda está no manual com outros registos do livro de preços. Os registos relacionados são os seguintes.`,
"label.ems.action":`Acção`,
"message.error.chart.type":`Os tipos de gráficos não podem estar vazios.`,
"label.conditiontag.lookup.value":`Valor`,
"label.chatter.allactivity":`Todas as actividades`,
"label.summaryreport":`Relatórios sumários`,
"label.textmessage.vonage.action":`Acção`,
"label.ccpeak.must.result":`Deve ser utilizado como seguido por pseudónimos para obter do resultado`,
"label.data.newtemplate.savetemp.desc":`Por favor, introduza cuidadosamente o nome e a descrição do modelo para facilitar a sua utilização.`,
"label.projectManagement.search.for.users":`Pesquisa de utilizador`,
"component.milestones.label.title":`Marco histórico`,
"vue_label_applauncher_description_accountpool":`Utilizar o "Account Pool" para gerir convenientemente o estado de seguimento dentro da organização e motivar o pessoal a completar a transacção.`,
"label.import.index.startimport":`Iniciar a importação`,
"page.field.masterinput2":`Entrada Master-Detail`,
"label.mobile.change.owner.permission":`O novo proprietário deve ter permissões de "leitura" neste tipo de registo.`,
"label_partner_common_enable":`Activar a nuvem de parceiros`,
"label.log.browser":`Browser`,
"label.app.step4":`Passo 4 Escolha os separadores`,
"lable.quote.syncing.opportunity":`Oportunidades`,
"label.forecast.customforecast.foredis.jqz":`Valor exacto`,
"label.forecast.forecastroleuserpage.title":`Atribuição de Gestor de Previsões`,
"label.starting.quarter":`Trimestre inicial`,
"label-combination-record":`Registo {index}`,
"label.here":`aqui`,
"label.weixin.underfind.error":`Erro desconhecido`,
"label.cloudccclass.list.tip.time":`Permitir aos programadores desenvolver classes programadas na plataforma CloudCC.com, que podem ser utilizadas para programas programados.`,
"label.data.setok.t_desc1":`Se precisar de utilizar este modelo de dados derivados, por favor clique`,
"label.service.gantt.break.rules":`Quebra de Regras`,
"label.weixin.no.pending.ywjh.qin":`Sem oportunidades para os próximos 30 dias`,
"label.view.atleastone":`A lista não pode estar vazia.`,
"label.attendance.sxccheckin":`Participação na Campanha`,
"label.custom.split":`Split`,
"front-kefu-moudle-v1-yesorno-delete-templete":`Tem a certeza de que quer apagar este modelo?`,
"label_chatter_theme":`Tópicos`,
"label.partner.new.step1":`Passo 1 Escolha o modelo que mais lhe agrada`,
"vue_label_commonobjects_view_settings":`Kanban View Settings`,
"UG_Contract_02":`O contrato é um acordo escrito entre as partes. Muitas empresas utilizam contratos para definir os termos de fazer negócios com outras empresas. Utilize o CloudCC para estabelecer e documentar os seus contratos existentes com as suas contas e oportunidades de negócio. Acompanhe o contrato através do processo de aprovação. Utilize lembretes de fluxo de trabalho para o lembrar do prolongamento do contrato.`,
"label.setup.mobilesetup.isenableh5newandedit":`H5 na sua aplicação móvel.`,
"label.attendance.edit":`Edição de Assiduidade`,
"label.service.miniProgram.fillImageLink":`Por favor, preencha o link do carrossel.`,
"label.b.c.without":`Os registos B podem ter ou não registos "C" relacionados.`,
"label.sso.key":`Código de Autorização`,
"label.star_click":`Clique para limpar`,
"vue_label_SMS_name_or_phone_number_lookup":`pesquisa de nomes de registos`,
"label.case.copre.text":`Também pode descarregar um código QR do portal web dedicado à sua empresa e colocálo no seu website ou dispositivo, depois os clientes podem digitalizar o código QR para utilizar a versão web do portal do cliente.`,
"label.salescloud.forbidden.confirm":`Tem a certeza de que quer desactivar as equipas de oportunidade?`,
"vue_label_chat_conformactivation":`Confirmar activação`,
"label.emailtocloudcc.redmessage9":`Erro na base de dados, por favor contacte o administrador.`,
"label.sahreto":`Partilhar com`,
"label.recordtype.sort":`Os tipos de registos são exibidos pela ordem em que são guardados.`,
"label.allreport":`Todos os relatórios`,
"front-gantt-module-drag-and-drop-subtask":`Arraste (coloqueo numa tarefa) para o fazer como uma subtarefa!`,
"label.permission.objlist.nopermission":`Sem acesso`,
"label_file_num":`Quantidade`,
"chatter.mostword":`O seu comentário é mais de 500 palavras, queira apagar e voltar a entrar.`,
"label.h5.chatter.comment":`Comentário sobre o corpo`,
"vue_label_calendar_notice_havecreated":`Criou um calendário`,
"label.tabpage.loadz":`Carregamento da página, por favor aguarde...`,
"chatter.w.p":`Telefone do trabalho`,
"label.chat.topic.name.desc":`Só se pode alterar o caso e o espaçamento dos nomes dos tópicos.`,
"label_partner_template_name":`Nome do modelo`,
"label.mobile.phone.required.examines.people":`É necessário o "Revised By".`,
"message.error.view.notexists":`A vista não existe.</br> Ou a vista pode ter sido modificada por outra pessoa, clique <a href='javascript:history.back();'> aqui </a>para trás.`,
"label.custom_time":`Tempo personalizado`,
"label_partner_workspace_member_all":`Todos`,
"lable.custom.year.name":`Nome do Ano Personalizado`,
"label.account.previous.M":`Último mês`,
"vue_label_commonobjects_detail_locking":`Fechadura`,
"label.brief.lead":`Líderes`,
"label.linkedin.setting.appsecret":`Senha da Chave Secreta`,
"label.query.detail.closepartner":`Desactivar parceiros`,
"label.isEnableVisualpage_new.rightlist":`Páginas Personalizadas Ativas`,
"front-epwechat-module-v1-unbound-item3":` dados de informação autorizada`,
"label.exchange.sync.setting.info":`Depois de criar uma conta de serviço com permissões de imitação para os utilizadores no Microsoft©Exchange, introduza as credenciais da conta de serviço para permitir que o CloudCC comunique com o servidor do Exchange. Se as credenciais da conta de serviço tiverem sido guardadas, mas o utilizador ainda não conseguir sincronizar os registos, certifique-se por favor de que configurou o Exchange Sync.`,
"label.emailobject.groupemail.fail.title":`Envio de e-mail do grupo CloudCC para endereço de e-mail falhado`,
"label.the.upper.bound.of.each.level.of.edit.discount.must.be.greater.than.the.lower.bound.":`O limite superior para editar cada nível de desconto deve ser maior do que o limite inferior.`,
"label.visualpage.list.vpname":`Nome da página personalizada`,
"label.mask.length.error.message":`O campo de texto encriptado não pode ser superior a 255 caracteres`,
"label.h5.approval.actorname":`Submetido por`,
"label.knowledgebase.view.translation":`Ver Tradução`,
"label.ems.edit":`Editar`,
"vue_label_commonobjects_view_reset_width":`Largura da Coluna de Reposição`,
"label.version.feature.controllist":`Lista de Limites de Funções`,
"label.setuppagelayout":`Layouts de página`,
"vue_label_commonobjects_view_new_view":`Nova Vista`,
"label_tabpage_queuez":`Fila`,
"label.direct.dashboard.wait.me.approval":`Itens a aprovar`,
"message.report.error.noRelatedField":`Nenhum campo relacionado com o relatório. Podem ter sido eliminados, por favor contacte o seu administrador.`,
"label.ccchat.person.invite.notme":`Não pode enviar convites para o seu próprio endereço de correio electrónico.`,
"label.weixin.jieduan.finish":`Marcar a fase actual como concluída`,
"vue_label_commonobjects_detail_?enter_subject":`Por favor introduza o assunto`,
"label_starting_month":`Mês de início`,
"label.address_linetwo":`Linha de endereço 2`,
"message.error.select.contiguous.item":`Selecção de artigos relevantes com`,
"vue_label_pricebook_enterbookname":`Por favor introduza o nome da lista de preços`,
"label.cycleworkflowoperate":`Acções de Fluxo de Trabalho Periódico`,
"label.ems.withoneday":`Hoje`,
"component.todaytask.label.notask":`Hoje em dia não há tarefa de expiração, tomar um café.`,
"label.tianyancha.id":`Identificação da empresa`,
"label.user.illegal.login":`Login ilegal`,
"label.withgathercondition":`Por Critérios Resumidos`,
"label.foldervisitlimit":`Permissões de acesso`,
"label.ccchat.search.conversation":`Pesquisar esta conversa`,
"lable.annual.project.report":`Relatório de Conta do Projecto neste Ano`,
"template.chart.qzkhzhfx":`Análise de Conversão de Chumbo`,
"label.my":`O meu`,
"label.sendsms.batch.chosetemplate":`SMS em massa: Seleccione um modelo ou edite o conteúdo`,
"label.callcenter.enterprise.number":`N.º da empresa`,
"label_last_modified_by_time":`Último modificador & tempo`,
"message.fieldtrack.operaterecord":`Mudou <b>operatefield</b>f>b>operateold</b>to<b>operatenew</b>`,
"label.mobile.more.openin":`Aberto em...`,
"label.multilingual.tip2":`Pode activar ou desactivar a multilinguagem.`,
"label.datamanage.lead.novalue":`Nota: O campo do nome de chumbo é nulo,os registos de contacto não serão importados.`,
"label.custom.revoke":`Desfazer`,
"label_chatter_leaveword":`Comentário`,
"vue_label_ccchat_group_deletedgroup":`O grupo foi eliminado`,
"label.tabpage.operationz":`Campo, a operação não pode estar vazia`,
"label.user.organization.permit.overdue":`A sua licença de organização tem espirais, por favor contacte o administrador!`,
"label.log.datetimeoruser.value":`Por favor, introduza o tempo de consulta e o nome de utilizador.`,
"lable.product.stsp.noavailable":`Não há preço padrão disponível`,
"label.appservice.cannot.delete.app":`Não é possível apagar esta aplicação personalizada, porque alguns perfis estão a utilizar esta aplicação personalizada como a aplicação padrão.`,
"component.event.label.newevent":`Novo Evento`,
"label.view.sortview.exportview":`Vista de exportação`,
"label.uploadfilemaxsize":`O valor máximo permitido para o carregamento de ficheiros é`,
"label.event.weekview":`Vista da semana`,
"label.conversion_rate":`Taxa de Conversão`,
"label.partnerCloud.partnerAccount.useWechat":`Use o scan WeChat para pagar.`,
"UG_Forcast_05":`Configurações de previsão: passo {0}/{1}`,
"label.service.gantt.jobresour":`Mostrar apenas recursos de trabalho`,
"vue_label_campaign_fromopprotunities":`De {dsrjine} oportunidades de negócio`,
"label.app.skyblue":`Azul Céu`,
"label.chinacloudcc":`Cloud Computing China`,
"label.connectOtherFinalNumber":`Limite de Objectos Alcançados<br/>Pode associar até quatro objectos a uma fonte de dados de relatório personalizada.`,
"label.redistributionrequest":`Reatribuir os pedidos de aprovação`,
"label.knowledge.category.button.one":`Adicionar Sub-categoria`,
"label.campagin.pcandmo":`PC e telemóvel`,
"label.project.milestone.date":`A data da etapa deve estar dentro do intervalo de datas do projecto a que pertence.`,
"assetbom.transfer.notpermission":`Não tem a autenticidade para migrar a lista técnica de activos. Por favor contacte o administrador.`,
"label.marketing.setting1":`Canais de Marketing`,
"label.select.file":`Seleccione o ficheiro`,
"message.error.object.contactadministrators":`O sistema é anormal, por favor contacte o administrador do sistema para obter ajuda.`,
"label.custom.quarter.title":`Trimestre personalizado`,
"label.knowledge.case.settings":`Resolução de casos`,
"front-service-cloud-transfer-title":`Transferir Proprietário da lista técnica de activos`,
"label.group.search.searchthisfeed":`Pesquisar este feed`,
"label.report.action.addtodashboard5":`Adicionar ao Novo Painel de Instrumentos`,
"label.mobile.side.tab.remark2":`Ao definir o selector, pode colocar os itens mais utilizados na posição frontal. histórico de chamadas, item de menu só pode ser utilizado para a versão andróide do CloudCC no lado do telemóvel.`,
"contain":`Incluir`,
"label.select.template":`Seleccione o modelo`,
"label.addattachment.step3.weixin":`Passo 3 Clique no botão "Completar" e volte à página anterior.`,
"lable.Order.successfully":`Ordem de transferência para activo com sucesso.`,
"label.user.title":`Título`,
"label.weixin.check.agreement":`Favor verificar o acordo relevante`,
"label.SMS.pfi":`Campo Número de telefone`,
"label.weixin.micro.research":`Micro Inquérito`,
"label.projectManagement.assigned.work":`Trabalho atribuído`,
"label.document.login.error":`O login falhou, por favor tente novamente.`,
"label.mobile.phone.examines.people":`Revisado por`,
"label.safetyset":`Definições de Segurança`,
"label_function_tip":`Esta característica não é actualmente suportada pelos utilizadores chineses do continente. Agradecemos a sua compreensão!`,
"label.app.sort":`Classificar aplicações`,
"component.sendmail.label.cc":`Cc`,
"label.titlename":`Título`,
"label.event.moveup.3day":`3 dias à frente`,
"label.condition":`Condições`,
"label.description.message":`Máximo de 500 caracteres.`,
"label.ems.detailedsettings":`Definições detalhadas`,
"label.repeat.condition.field.prompt":`Por favor preencha um número na secção "De acordo com o tamanho dos caracteres" Filed！`,
"label.validate.function.funcExplain.OR":`Verificar se quaisquer parâmetros são verdadeiros e devolve VERDADEIRO ou FALSO. Só devolve FALSO se todos os parâmetros forem falsos.`,
"label.salecommit.allow.prediction.query":`Não é possível visualizar os painéis de controlo das vendas porque não assinalou a opção Permitir Previsões a partir do Setup-My Personal Information-Personal Settings.`,
"front-kefu-moudle-soft-phone":`Softphone`,
"label.view":`Ver`,
"front-gantt-module-quick-create-task":`Criar tarefa rapidamente`,
"label.all_forms":`Todos os Formulários`,
"front-lightning-module-v1-dashborad-statistical-dimension":`Dimensão estatística`,
"label.forecast.settings.data.chanpin":`Data do produto`,
"label.appointment.wizard.subtitle4-2-7":`3 dias`,
"front-web-module-v1-detail-comment-please":`Por favor introduza o feedback`,
"label_chatter_nextSevenday":`Próximos 7 dias`,
"homepage.components.desctiption":`Esta página permite-lhe criar e editar componentes que podem ser mostrados em um ou mais layouts de página inicial.`,
"label.customcomponent.page.index.table.namespace":`Prefixo do espaço de nomes`,
"label_emailtocloudcc_exists":`O Email já existe.`,
"label_tabpage_save":`Guardar`,
"label.mergeRechecking":`Verificar Duplicação & Fusão`,
"vue_label_helpcenter_view2":`Na vista de ecrã fraccionado, pode mudar rapidamente para ver a informação detalhada de cada dado. <br> 3. Análise rápida dos dados de vendas<br> No canto superior direito da vista, pode abrir o gráfico na vista para realizar uma análise visual simples dos dados na vista. Ao mesmo tempo, é possível visualizar o painel de controlo e a lista de relatórios relacionados com os dados da vista para uma análise mais aprofundada. <br>?Clique no botão do gráfico no canto superior direito, pode visualizar, criar, editar gráficos simples criados com dados de visualização, ou visualizar painéis de instrumentos relacionados com a visualização actual. <br> Passo 1: Clique no botão do gráfico no canto superior direito para expandir o gráfico na página. Pode ver e gerir os gráficos existentes de acordo com as permissões, e ver a lista de painéis de instrumentos relacionados com os dados de visualização. <br> Passo 2: Clique no botão Definições, pode criar, editar, e apagar gráficos de acordo com as permissões. Pode criar quatro estilos de gráficos, gráfico de coluna vertical, gráfico de coluna horizontal, gráfico de tarte e gráfico de funil. <br>?Clique no botão de relatório para visualizar os relatórios relacionados com a vista actual. <br>?4. Gerir dados na vista <br>?Na vista, de acordo com a sua autoridade, pode adicionar, editar, apagar e alterar o proprietário dos dados através dos botões no canto superior direito da vista, ou ao lado de cada pedaço de dados. <br>?Use etiquetas para ajudar na gestão dos seus dados. Use o botão da direita para expandir a lista de gestão de tags, e pode filtrar os dados na visualização com base em tags. Após clicar em Gerir etiquetas, também pode manter e gerir a sua biblioteca de etiquetas. Após seleccionar os dados, utilize o botão Adicionar etiqueta no canto superior direito para adicionar etiquetas aos dados em lotes.`,
"label.app.ismobile":`Afixado em aplicação móvel`,
"chatter.group.changeTheGroupPicture":`Alterar a foto do grupo`,
"label.mr.descreption.reDataList2":`registos de repetição`,
"vue_label_chatter_agree_join":`Concordar em aderir`,
"label.planned.nextrun":`Executar no Próximo Agendado`,
"Homepage.News.003":`Não é possível exibir notícias sem dados de contas, por favor crie uma nova conta e as notícias relacionadas serão exibidas.`,
"label.summaryreport.selectpictype":`Seleccionar o tipo de gráfico e outras opções gráficas`,
"label.app":`Aplicações`,
"label.trigger.name":`Nome do gatilho`,
"vue_label_email_private_template":`Modelo privado`,
"label.appointmentpage.wizard.subtitle1":`Escolher data e hora O fuso horário do Inviter é {0}`,
"label.partnerCloud.orderingPlatform.payment":`Pagamento de encomendas`,
"label.stdashbord.xsld.title":`Funil de vendas`,
"vue_label_pool_poolname":`Nome do pool de contas`,
"label.ServiceCloud.fuwuyuyue.distributionMap":`Mapa de Distribuição de Serviços de Nomeação`,
"front-lightning-module-v1-dashborad-target-value":`Valor Alvo`,
"label.reportsSubscriptionPage.email.keywords":`Pesquisa após introduzir a palavra-chave`,
"label.appointmentconfirmail.wizard.subtitle1":`Nome do evento`,
"label.limited_scanning":`O bilhete de entrada é apenas para digitalização para registo no local`,
"label.weixin.nomore":`Não mais`,
"february":`Fevereiro`,
"label.view.filterbyowner":`Filtrar por Proprietário:`,
"label.contentType":`Extensão do documento`,
"label.customobjdel.master.hsiang":`O Campo de Relação Master-Detail é criado neste objecto, pelo que não o pode apagar.`,
"lable.Removal.succeeded":`Removido com sucesso.`,
"label.weixin.end.incorrect":`Data final inválida`,
"label.email.cc.recipients":`Destinatários do Cc`,
"label.taskevent.list":`Lista de actividades`,
"label.formula":`Fórmula`,
"label.h5.new.errorheader":`Reveja os erros desta página.`,
"label.emailobject.template.private":`Particular`,
"label.visualpage.component.n4":`4.Variável. Pode usar variáveis directamente, e tenha cuidado para não ter citações únicas.`,
"label.newemailnotice.step1":`Passo 1 Seleccionar objecto`,
"label.chatter.file":`Ficheiro`,
"vue_label_checkduplicate_rules":`Estabelecer regras de verificação em duplicado`,
"label.appointment.wizard.subtitle1-6":`1.5 h`,
"label.customReportType":`Fonte de dados do relatório personalizado`,
"vue_label_email_with_accessories":`Emails com anexos`,
"label_efine_assessment_cycle":`Definir período de avaliação do desempenho`,
"label_emailtocloudcc_button_sure":`Confirme`,
"label.forecast.userenablepage.isusing":`Utilizadores habilitados`,
"lable.goal.description":`Descrição do objectivo`,
"message.error.serviceresource.relatedrecordid":`Cada utilizador só pode ser adicionado como um recurso de serviço do tipo {0}.`,
"label.weixin.addbus.information":`Adicionar informação sobre veículos`,
"label.emailtocloudcc.button.view":`Ver`,
"label.detail.workflow":`Ver Fluxos de trabalho`,
"label.standardfilter":`Filtros Standard`,
"label.mobile.phone.results":`Desempenho`,
"chatter.feed.unavailabled":`Inaceitável`,
"label.view.sortview":`Ordenar Vista`,
"label.availabilityobject.wizard.title":`Disponibilidade`,
"Main_Menu_Mobiledownload":`LIGUE-SE`,
"chatter.sticker":`Localizado`,
"label.workflow.intruduce":`Configurar o fluxo de trabalho da organização através da criação de regras de fluxo de trabalho. Cada regra de fluxo de trabalho consiste em:`,
"label.customfields.richtext.tip":`Permite aos utilizadores introduzir texto formatado, adicionar imagens e links. Até 32,768 caracteres em linhas separadas.`,
"label.new.cy.select":`Escolher uma nova moeda a partir da lista disponível.`,
"template.chart.schdzqzkhzhqk":`Conversão de Líderes em Campanhas`,
"label.forecast.customforecast.cpxl":`Família de produtos`,
"front-electronic-signature-open-service":`Activar a Assinatura E`,
"label.datamanage.import.field":`Campos de importação`,
"chatter.email.sendMessageToMe":`Envia-me uma mensagem`,
"message.cannotusebefore":`É favor notar que não poderá utilizar este processo de aprovação até que tenha sido activado.`,
"label.textmessage.vonage.api.secret":`Segredo API`,
"label_chatter_newEvent":`Novo evento`,
"label.ji.year":`{a} ano`,
"label.sendmail.step2":`Passo 2 Seleccionar um modelo de e-mail`,
"label.console.step5.record":`registos abertos`,
"label.customfields.totalsummary.gettogetherfield.isnull":`Por favor seleccione o campo a agregar`,
"vue_label_commonobjects_detail_current_recorder":`O novo proprietário tornar-se-á também o proprietário dos registos relacionados com este projecto, e estes registos são propriedade do actual gravador`,
"label.SMS":`Notificações SMS`,
"label.reconfigure.bundle":`Reconfigurar o Pacote`,
"front-kefu-select-region":`Por favor seleccione a área onde se encontra a instância`,
"chatter.feed.deletefeeds":`Tem a certeza de querer apagar este post e os seus comentários?`,
"label.customsetting.manage.introduce.h":`Se a configuração personalizada for uma hierarquia, é possível adicionar dados para o nível do utilizador, perfil, ou organização. Por exemplo, pode querer exibir valores diferentes dependendo se um utilizador específico está a executar a aplicação, um perfil específico, ou apenas um utilizador geral.`,
"label.product.name":`Nome do produto`,
"vue_label_commonobjects_view_saveas":`Salvar como`,
"label.group.my.archived":`Os Meus Grupos Arquivados`,
"vue_label_pool_coflictmethods":`Conflito com o modo de venda actual`,
"label.appupload.upload":`Carregar`,
"lable.SalesCommitmentKanBan.signedTaskRate":`Taxa de conclusão da tarefa assinada`,
"label.dashboardStandard":`Painéis de controlo standard`,
"label.niboer.time":`Hora do Nepal`,
"label.emailtocloudcc.filed.email":`Email`,
"market.name.social.post":`Postos Sociais`,
"evaluation.detail.notfound":`Comentário detalhado não é encontrado`,
"label.layoutoftestobj":`Layouts de objectos de teste`,
"label.example":`Exemplos`,
"label.campaign.channel.step6.remark6":`por favor visite aqui`,
"chatter.emailLike":`Gosta`,
"label.knowledge.category.button.two":`Categoria de edição`,
"label.alluser":`Todos os Utilizadores`,
"addadvancedconditions":`Adicionar Condições Avançadas`,
"message.selectgsummarycondition":`seleccione os critérios sumários`,
"message.duplication.label.sectionremar2":`Nota: Todos os registos relacionados, incluindo quaisquer notas, anexos e actividades, serão associados ao novo registo fundido.`,
"vue_label_helpcenter_product&pricebook":`Os produtos são o seu catálogo básico para todos os artigos e serviços que vende e os seus preços padrão. A lista de preços permite-lhe criar uma colecção personalizada de produtos e lista de preços associada para utilizadores específicos.`,
"message.duplication.label.isprofile":`Por Permissão`,
"component_setup_label_milestonesfield":`Campo de marco miliário`,
"setup_layout_label_required":`Obrigatório`,
"component_chatter_label_title":`Último post`,
"label.assignment.setup.detail.order":`Ordenar ordem`,
"vue_label_pool_unassigned":`Não atribuído`,
"UG_Lead_007":`Google sync`,
"label.knowledge.record":`Não existem dados relavantes!`,
"label_tabpage_filetypez":`Tipo de ficheiro`,
"label.ccpeak.if.error.message":`Se um erro for devolvido: utilização`,
"label.intialsubmitter":`Submetedores iniciais`,
"label.wei.icon":`Ícone`,
"label.mask.show.last.4":`Máscara com os quatro últimos caracteres`,
"lable.PowerProcess.time.trigger":`Disparador de tempo (min)`,
"july":`Julho`,
"label.usestandardwizard":`Usar o Assistente de Configuração Padrão`,
"label.two.quarter":`Segundo Trimestre`,
"label.size":`Tamanho`,
"label.integrations.mailchimp.massage4":`Mailchimp não está actualmente instalado. Por favor instale o Mailchimp em "Integrações".`,
"label_emailtocloudcc_step2total3":`Etapa 2 de 3`,
"vue_label_chat_customer_group_strategy":`Equipa do cliente`,
"label.searchvalue":`Encontrar valores`,
"label.sendemail.birthday.title":`Lembrete de Aniversário`,
"label.projectManagement.planned.days":`Dias de planeamento (dia)`,
"label.service.gantt.workhours":`Com base na hora de trabalho`,
"label.notification.approval5":`Delegado approval：【提交人】is solicitando o 【对象】approval`,
"label.service.miniProgram.bindAddressDesc":`Portal Oficial do Mini Programa de Atendimento ao Cliente do CloudCC:`,
"chatter.error.wt":`Erro:Tipo de ficheiro inválido.`,
"vue_label_calendar_my_calendar":`O Meu Calendário`,
"label.customername":`Nome da conta`,
"label.salescloud.salesdashboard.huikuan.rankings":`Classificações de pagamento em equipa`,
"message.query.opportunity.contactrole.error":`Oportunidade de negócio de consulta falhou, por favor contacte o administrador!`,
"noequal":`não igual a`,
"label.document.searchcustominfo":`Introduzir palavras-chave para encontrar documentos correspondentes.`,
"label.account.PreviousFQ":`FQ anterior`,
"label.file.f":`Ficheiros`,
"label.dashboard":`Painéis de instrumentos`,
"label.report.folder":`Pastas`,
"batch.edit.permission.list":`Sem permissão para editar a lista de dados`,
"label.file.orderbyowner":`Ordenado pelo proprietário`,
"label.exchange.sync.account.password":`Palavra-passe da conta de serviço:`,
"pagecreator.button.publish":`Publicar`,
"label.modify":`Editar`,
"label.exchange.sync4":`Estados`,
"label.remark.information":`Descrição Informação`,
"label.service.without.major.event":`Nenhum evento importante a ser exibido`,
"label.knowledgebase.release.status":`Estado de publicação`,
"label.tabpage.ok":`Confirme`,
"label_screening_assessment_content":`Conteúdo da avaliação do filtro`,
"label_partner":`Nuvem de parceiros`,
"label.user.detail":`Ver Utilizadores`,
"front-kefu-moudle-or-this":`ou, como este?`,
"label.unselect.object":`Objectos Opcionais`,
"label.quote.contactfax":`Fax`,
"label.weixin.appmanage.alert":`Prima {0} para remover o app das Minhas Aplicações, Prima {1} para adicionar app às Minhas Aplicações.`,
"vue_label_dashboard_thisfolder":`Adicionar painel de controlo público a esta pasta`,
"label.delete":`Eliminar`,
"label.appexchange.installedpage.message1":`Pode visualizar e descarregar aplicações directamente na CloudCC App Store e instalá-las no seu ambiente CloudCC.com.`,
"label.mobile.phone.required.summary":`É necessário um resumo`,
"label.batchadd.newbatchpage.addtr":`Pode ser acrescentado um máximo de 30 registos.`,
"label.partnerCloud.partnerAccount.lockLine":`Quantia bloqueada`,
"label.emailsync.status.connectstatus":`Estado da ligação`,
"label.campaignmember.main.importmember.lead":`Membros Importadores-Leads`,
"message.username.isnull":`É necessário introduzir um valor para o nome de utilizador.`,
"label.forecast.tree.enableuser":`Habilitar os utilizadores`,
"label.multilang.view.viewmessage":`Esta visão tem sido aplicada ao dispositivo móvel. Pode ser escolhido um máximo de 10 campos, agora existem {0}:`,
"friday":`Sexta-feira`,
"label.sendemail.activity.neweventtitle":`Notificação de novos eventos`,
"label.page.addtabto.user":`Anexar o separador às personalizações pessoais existentes`,
"front-kefu-moudle-v1-connect-phone":`Número de telefone de associado`,
"label.wei.pollis":`Vote em`,
"lable.opppdt.editPdt.title":`Editar Produtos de Oportunidade`,
"label.permission.objectpermission.recordfenpei":`Atribuição de Tipo de Registo`,
"pagecreator.layout.message.delete.success":`Layout apagado com sucesso`,
"label.dataimport.isdupecatcher":`Executar Filtros`,
"label.deletelayout.tip":`A fim de eliminar uma disposição de página, é necessário seleccionar outra para a substituir.`,
"label.projectManagement.No.matching.data":`Sem dados correspondentes.`,
"pagecreator_page_message_delete_success":`Página apagada com sucesso`,
"label_tabpage_equalz":`Igual a`,
"label.ems.emailsetup":`Configuração de e-mail`,
"label.decimaldigits":`Lugares decimais`,
"component.chatter.button.delete":`Eliminar`,
"label.isallowreport":`Permitir relatórios`,
"label.view.appliedMobile.message":`Verifique este item, Passo 3. Seleccione os campos a exibir, e pode seleccionar até 6 campos`,
"label.must.positive.integer":`O número deve ser um número inteiro.`,
"label.preview.print.template":`Pré-visualização do modelo de impressão`,
"label.schedulejob.setup.schedule.start":`Início`,
"UG.Case.04":`Atribuição de casos`,
"vue_label_pool_move1":`{1}{2}`,
"label.list.userinterface.enableHoverDetails":`Activar Hover Detalhes`,
"vue_label_email_alltemplates":`Todos os modelos`,
"label_report_chose_obj":`por favor seleccione a relação de objectos e informe a fonte de dados`,
"label.partnerCloud.productSet.del":`Eliminar Item`,
"label.quote.shrdz":`Endereço do destinatário`,
"page.approval.history":`Histórico de Aprovação`,
"lable.outlook.detail.prefc":`Always Preferred CloudCC.com`,
"label.translation.unable.display.view":`Incapaz de exibir vista`,
"label.encrypt.change":`Converter Tipo Criptografado`,
"button.partner.workspace.login.logo.upload":`Carregar imagem`,
"label.batchadd.mustinput2":`é necessário, este registo não pode ser guardado se a informação requerida estiver vazia.`,
"label.dataimport.update.error.check":`Ocorreu um erro na actualização dos dados. Por favor, examine estes dados cuidadosamente.`,
"label.staticresource.name.already.exists":`O nome único do recurso estático já existe!`,
"label.appupload.upload.install.success":`Instalado com sucesso`,
"label.conditiontag.lookup.true":`VERDADEIRO`,
"label.quickbooks.viewlist.customer":`CLIENTE`,
"label.field.edit.change2":`A pontuação mais alta é de pelo menos 1`,
"label.fianalrejectoperate":`Acções de Rejeição Final`,
"label.ccpeak.wgd":`Aulas não arquivadas`,
"label.reportsSubscriptionPage.condition.emailreport":`Resumo   relatório`,
"label.detailinf":`Detalhes`,
"label.eastem.standard.time":`Tempo Padrão Oriental`,
"chatter.group.manager":`Gerente`,
"label.manage_columns":`Gerir o cabeçalho`,
"label.daylight.time":`Tempo de luz diurna`,
"label.weixin.mycar.information":`Os meus Veículos`,
"label.ccpeak.help":`Ajuda para as aulas`,
"lable.outlook.detail.match":`Critérios de correspondência`,
"label.version.nonsupport.approval":`Os Processos de Aprovação não são temporariamente suportados.`,
"label.custom-tailor":`Personalizar`,
"label.showoperate":`Mostrar acções`,
"label.view_edit":`Ver e Editar`,
"label.lead.score.prompt2":`Por favor, seleccione o intervalo de pontuação, clique o botão [Lead Scoring] e o sistema irá pontuar as pistas seleccionadas de acordo com a Regra de Pontuação de Chumbo activa.`,
"label.datamanage.savetemplate.error":`O modelo de salvamento falhou.`,
"label.source":`Fonte`,
"label.multilang.customfieldsetup.reference":`Este campo é referenciado por {0}`,
"chatter.poll.option7":`Escolha 7`,
"label.login.access.day":`dia(s)`,
"label.icon.66":`Equipamento`,
"label.tabpage.kanbansetup":`Configuração do painel de visualização`,
"label_emailtocloudcc_step1_lead2":`Uma vez configurado, os e-mails recebidos nesta caixa de correio serão automaticamente registados como registos de chumbo no CloudCC. Assegure-se de que nenhum negócio é perdido.`,
"label.partnerCloud.partnerAccount.numericValue":`O montante da recarga deve ser um valor numérico.`,
"label.permission.detail.app.object.tip":`Objectos, Campos e Tabs Definições de Acesso`,
"label.emailobject.template.subject":`Assunto`,
"template.report.month.customer":`Contas deste Mês`,
"label.weixin.formerly":`No passado`,
"label.contract":`Contratos`,
"label.help":`Ajuda`,
"vue_label_homepage_setdefault":`Definir como página inicial predefinida`,
"label.icon.52":`Geração de energia`,
"label.customfields.file.count":`O número de ficheiros`,
"UG_Account_07":`Conta de importação`,
"label.addattachment.ntko":`Editar Online`,
"label.service.ganttBaiduMap.assign.service":`Marcação de serviço de assistência a esta pessoa`,
"vue_label_file_my_file":`O meu ficheiro`,
"label.custom.page.hide":`Esconder`,
"label.addexistoperate":`Adicionar Operação Existente`,
"label.already.startdate":`Tempo de início`,
"label.partnerCloud.financeSetting.alipay":`É necessário abrir uma conta comercial Alipay. Apenas a conta comercial é suportada para ser como conta de recibo. As taxas de transacção serão cobradas pela Alipay ao beneficiário.`,
"label.dashboard.summary.editPageFooter":`Editar Rodapé`,
"label.category.8":`Bens de consumo`,
"label.forecast.customforecast.foretype.best":`Melhor caso`,
"message.validation.isnull":`Por favor introduza um valor`,
"label.savewxpay.failure":`Falha em salvar informações do comerciante de pagamentos WeChat`,
"label.file.stop.sharing.desc1":`Pare de partilhar com`,
"label.opportunity.setting.showstage。read.info":`As fases de oportunidade não podem ser modificadas manualmente após o ticking`,
"UG_Campaign_003":`Criar uma campanha`,
"label.edit.field.select.showoptions":`Mostrar todas as opções`,
"message.inputplatformpwd":`Introduzir Palavra-passe de Admin`,
"vue_label_systemSettings_mobel_set":`Configuração de aplicações móveis`,
"label.projectManagement.thefirstone":`Este é o primeiro registo`,
"label.data.newtemplate":`Criar modelo de exportação de dados`,
"label.monitorsys.delete.log":`Registo de Auditoria de Operações Chave`,
"label.template":`Modelos`,
"Lead.Auto.Scoring.Setting.001":`Pontuação automática ao editar ou guardar (excepto os cabos que são importados em lote ou criados por interface)`,
"label.operatesuccess":`Operação bem sucedida.`,
"label.send":`Enviar`,
"chatter.yp":`Esconder Alimentação`,
"label.overall_responses":`Resposta global`,
"vue_label_systemSettings_server_report":`Relatório de serviço`,
"label.icon.113":`Casa`,
"label.partnerCloud.basicSetting.domainSet":`Configurar nome de domínio`,
"label.login.access.text":`Para ajudar no apoio, pode conceder ao administrador o acesso ao login e visitar os seus dados.`,
"vue_label_report_addrowlevelformula":`Adicionar fórmula a nível de linha`,
"message.duplication.label.mergeTitle":`Fundir o meu`,
"label.event.add":`Adicionar Evento`,
"vue_label_homepage_bigscreen_light":`Luz`,
"setup.chatter.enabled":`Não disponível, por favor contacte o Administrador para activar o CCChat.`,
"label.inputreceiver":`Pode introduzir até cinco (5) endereços de correio electrónico para ser notificado. Cada endereço de correio electrónico é separado por ";".`,
"label.custom.page.custom.page":`Páginas personalizadas`,
"label.data.exp.csv":`formato CSV`,
"label.searchlayout.view.example":`Ver exemplo`,
"label_tabpage_fullscreenz":`Ecrã inteiro`,
"label.tabpage.last":`Último passo`,
"lable.outlook.mcto.accepemail":`Os meus endereços de e-mail disponíveis`,
"front-electronic-signature-isopen":`Activo`,
"vue_label_commonobjects_detail_earlier":`Ver Anterior`,
"label.name.cannot.greater.str":`O nome pode introduzir até 255 caracteres.`,
"label.weixin.activity.email":`Actividade: Email`,
"label.tabpage.unequalz":`Desigual a`,
"label_calendar_year":`Ano civil`,
"label.appupload.upload.installor":`Instalado por`,
"label.jixiaoswitchon":`Expandir`,
"label.user.congratulations.send.finish":`Parabéns, e-mail em massa completo.`,
"label.customsetting.touse.getListCustomSetting2":`Consultar os dados do tipo "list" de definições personalizadas, devolver dados únicos correspondentes ao nome da API. Mapa do mapa = cs.getListCustomSetting(String apiName, String Name);`,
"label.recordtype.masterrecordtype.selectedTip":`O tipo de registo mestre não pode ser atribuído ao perfil que já tenha sido atribuído um tipo de registo.`,
"label.tippage.li3":`Para que quaisquer componentes do painel de instrumentos baseados no relatório da falha tenham sido removidos`,
"label.weixin.no.name":`Nenhum assunto`,
"label.tabpage.viewz":`Imprimir vista actual`,
"label.create_contacts":`Criar Lista de Contactos`,
"vue_label_homepage_operationitem":`Por favor seleccione Botão`,
"label.pc.ui.2018.switch.version":`Mudar para a versão`,
"label.salescloud.teamrole.main":`Contacto Principal`,
"label.reportsSubscription.format.report":`Relatório formatado (formato Excel .xlsx)`,
"label.forecast.customforecast.total":`Montante`,
"label.quickbooks.fieldlabel.lastname":`Sobrenome`,
"label.appointment.wizard.title2":`Detalhes da Reunião`,
"label.project.template.one":`Criar um projecto a partir de um modelo de projecto requer 2~3 minutos. Obrigado pela sua espera paciente.`,
"label.timetrigger.workflow":`Quando o fluxo de trabalho está activo.`,
"label.projectManagement.creator":`Criador`,
"label.customfields.formula.selectreturnfieldtype":`Por favor, seleccione o tipo de retorno de fórmula`,
"label.list.userinterface.dashboard.enable":`Activar Novos Componentes do Painel de Instrumentos`,
"label.email.delete.html.format":`Todos os formatos html serão eliminados. tem a certeza?`,
"label.appupload.install.modifyapi":`Modificar o nome conflituoso da api:`,
"label.chat.add.topics":`Acrescentar um tópico`,
"label.savepartner.fail":`Falha em guardar definições para Partner Cloud`,
"label.pc.query.new":`Veja as suas últimas`,
"message.duplication.label.editfiltertitle":`Encontrar Filtro Duplicado Editar`,
"label.task":`Tarefas`,
"label.emailobject.emaildetail.title.toaddress":`Para:`,
"label.setup.mobile.bottombutton.select":`Seleccione as 4 páginas de primeiro nível que pretende mostrar na aplicação móvel`,
"label.loginip.pagecue.invalido":`Endereço de Internet inválido`,
"label_tabpage_listshow":`A lista mostra`,
"component.newrecords.label.10records":`10 registos`,
"label_chatter_file":`Ficheiro`,
"pagecreator.systemstyle.label.detailcolor":`Cor do texto de detalhe`,
"label.forecast.userenablepage.title":`Previsões Utilizadores`,
"front-project-module-v1-actual_working_hours":`Hora do homem relatada`,
"vue_label_systemSettings_Security":`Contenção de Segurança`,
"label.processsetting.two.select.key.fields":`Passo 2: Seleccionar campos-chave para cada etapa do processo e fornecer orientação`,
"label.page.display1":`Registos por página`,
"label.appointmentpage.wizard.subtitle1.2":`O Fuso Horário do Inviter é {0}`,
"label.ggReleaseRange.searchTeam":`Procurar grupo público`,
"chatter.group.searchGroup":`Escreva um nome de grupo...`,
"label_card_type":`Paginação de cartões`,
"label.appupload.managed.tip":`Ser controlado significa que só se pode editar certos atributos.`,
"label.changemyshow":`Alterar a minha exposição`,
"label.custom.CustomQuarter":`Trimestre personalizado`,
"label.tobedelete":`Para ser apagado`,
"label.newPage.unuse":`A sua página está perdida.`,
"label.product.pricebooks":`Livros de preços`,
"label.mobile.layout":`Layouts de páginas de dispositivos móveis`,
"label.multilang.file.items":`{0} projectos:`,
"label.app.step4.tabused":`Separadores seleccionados`,
"label_ccchat_create_account":`Criar uma conta`,
"message.startusingprocess":`Após activar este processo de aprovação, não pode adicionar ou remover etapas de aprovação. Além disso, alguns atributos das etapas de aprovação não serão editáveis. Tem a certeza de querer continuar?`,
"vue_label_email_please_add_a_theme":`Por favor adicione um tema antes de guardar como modelo`,
"label.please.create.a.target.record.first.":`Por favor, crie primeiro um registo indicador`,
"label.processsetting.set.objandfile":`Passo 1: Seleccione os objectos e campos que deseja definir o processo`,
"label.newreport.group.data":`group（s）`,
"label.notcreatenew":`Não criar uma nova oportunidade após a conversão.`,
"lable.custom.CurrentandPreviousCY":`CY actual e CY anterior`,
"front-epwechat-module-v1-input-androidschema":`Por favor introduza o esquema Android`,
"label.projectManagement.unfinished.quantity":`Número Incompleto`,
"label.visualpage.idandname":`O ID e o nome da página são:`,
"label.approvingprojects":`Itens a aprovar`,
"label.partnerCloud.financeSetting.weChat":`O serviço WeChat tem de ser aberto e o acordo de serviço de recolha com a Tencent é necessário. A taxa de transacção será cobrada pela Tencent ao beneficiário do pagamento.`,
"label.quickbooks.viewlist.view":`Ver`,
"label.knowledge.category.hint.ten":`Grupo de Categoria Inactivado`,
"report_type_label_productPricebooks":`Produtos e Livros de Preços`,
"label.fenbeitong.description":`Verificar e activar o formulário de pedido de viagem FenBeiTong para ajudar os funcionários no pedido de viagem de negócios e reembolso de viagens
despesas`,
"label.ccchat.upload.change":`O que mudou? (opcional)`,
"label.emailsync.status.log":`Registo de ligação`,
"label.addnew":`Adicionar Novo`,
"UG_contact_05":`Criar um contacto`,
"label.appupload.componet.queryerror":`Ocorreu um erro durante a pesquisa no omponente. Por favor contacte o seu administrador.`,
"label.salescloud.setting":`Configuração de Venda em Equipa`,
"label.recurrencetimetriggeroperate":`Acções Periódicas de Disparo do Tempo`,
"label.event.moveup.4day":`4 dias à frente`,
"No.Hisitory.Activity":`Nenhuma actividade histórica`,
"label.validate.function.funcFormat.MINUTE":`MINUTOS(data)`,
"label.recentview.seloption3":`Modificado recentemente`,
"label.login.access.nopermission":`--Sem acesso...`,
"label.taskmenuandlink":`Botões de Tarefa e Ligações`,
"label.forecast.customforecast.foredis.sbw":`Milhões`,
"lable.PowerProcess.created.event":`criar marco miliário`,
"label.stdashbord.xsld.funnelchat":`Gráfico de Funil de Vendas`,
"label.step1.total7":`Etapa 1 de 7`,
"label.sendsms.batch.chosepersion":`SMS em massa: Seleccione os destinatários`,
"Lead.Scoring.Setting.Rule.Setup.Value":`Pontuação`,
"label.ccdocument.isdel.folder":`Tem a certeza de que quer apagar esta pasta?`,
"label.discard_change":`Sim, alterações de descarte`,
"label.knowledgebase.assign":`Atribuir`,
"PersonalInfo_LoginHistory_001":`A Broswer valida o link de registo na sua caixa de correio`,
"label.globalselect.deletedvlaue":`Conjunto de valores globais eliminados`,
"label.ems.lookup2":`Pesquisa`,
"label.dataimport.system.unable.determine":`o sistema não pode determinar a perda do`,
"label.weixin.invitation.consultant":`Consultor convidado`,
"label.salescloud.salesdashboard.phone.rankings":`Classificações de Discagem`,
"label.knowledgebase.plan.release":`Plano a publicar`,
"label.integrations.first.half":`A visão actual no total`,
"label.icon.123":`Kit de Primeiros Socorros`,
"label.leadscore.isactivity":`Activo`,
"front-epwechat-module-v1-corpid":`WeCom ID (Corpld)`,
"label.createnewcustomer":`Nova conta`,
"front-lightning-module-v1-details-page-chart-tittle":`Pode inserir módulos de gráficos e diagramas na página de detalhes, e podem ser inseridos até 10 gráficos de relatórios. Por exemplo, pode adicionar um módulo de gráfico de relatório para um registo com tipo de registo como Agente no objecto Contas, adicionar gráficos de volume de vendas de encomenda de agente e relatório de vendas trimestral de agente ao módulo, e filtrar pelo nome da conta para ver os dados relacionados directamente na página de detalhe da conta de agente.`,
"label.customobjects.fieldsrelation":`Campos personalizados e relações`,
"label.dashboardSetup.left":`Esquerda`,
"label.mobile.app.sectionpart":`Secção de Aplicações Móveis`,
"setup.mainpage.label.welcome25":`Instruções: Clique no menu do lado esquerdo desta página → Manage Settings → Security Control → Sharing Settings.`,
"label.custombutton.edit.error":`Erro: O nome já está em uso ou já foi usado anteriormente, por favor escolha um nome diferente.`,
"label.icon.48":`Ventilador de exaustão`,
"label.tabularreport.step2":`Passo 2 Seleccionar a coluna do relatório`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.two":`Dois`,
"UG_quota_01":`Gerir citações de contas`,
"label.customcomponent.btn.usewhere":`Onde é que isto é utilizado?`,
"label.quickbooks.searchresault.email":`Email`,
"label.emailobject.appointment.urltext2":`reservar um tempo aqui`,
"label.tianyancha.field.relation.error":`Por favor, defina primeiro a relação cartográfica entre o campo de tianyancha e o campo do cliente`,
"APPIntegration_Social_facebookerror":`Deve introduzir um URL válido para facebook.com`,
"label.notification.arketsea.transfer":`{5} transferido {0}：{1} de {2} para {3}`,
"lable.SalesCommitmentKanBan.allreceivingTaskRate":`Taxa de conclusão da tarefa Total de Recibos`,
"UG.Account.04":`Filtragem de contas de consulta passiva`,
"this.week":`Esta Semana`,
"label.email.track.attachment.num.control1":`O número de ficheiros carregados excede 10,e não pode ser carregado`,
"label.exchange.sync.state.event":`Eventos`,
"vue_label_systemSettings_websitesetting":`Configuração Web`,
"vue_label_file_replace_reason":`Motivo da substituição`,
"label.version.feature":`Características`,
"E":`Email`,
"label.escalation.setup.entrydetail.escalation.notifyTemplate":`Modelo`,
"label.chosesubject.meet":`Ter uma reunião`,
"UG.ST.003":`Não tem permissão para criar {0}, por favor contacte o administrador, clique em confirmar para ir directamente para a interface {0}.`,
"label.authorization.failure":`A autorização falhou. Por favor, re-autorize!`,
"label.newprocessstep3":`Passo 3 Especificar o Campo de Aprovação e Propriedades de Editabilidade de Registo`,
"lable.outlook.mcto.mostrecord":`Registo com a maioria das actividades`,
"vue_label_normal_select":`Seleccione`,
"label.partner.workspace.login.buttontext":`Texto do botão`,
"template.chart.ydschdtj":`Estatísticas da Campanha Mensal`,
"label.ServiceCloud.zichanmingcheng":`Nome do activo`,
"label.productsales.oppor.nooverdue":`Bom trabalho, sem oportunidades vencidas.`,
"label.appointment.wizard.subtitle3-5":`Sexta-feira`,
"label.payment.the.current.version":`Edição de Subscrição Actual`,
"label.reportlist.top":`Fixado ao topo`,
"label.emailobject.emaildetail.prompt":`Pronto`,
"label.weixin.endst":`O tempo de fim não pode ser antes da hora de início.`,
"report_label_knowcreatehighlevelreport":`Como criar um relatório avançado?`,
"label.quickbooks.view.openestimates":`Estimativas abertas`,
"label.url.cannot.empty":`O URL não pode ser nulo!`,
"label.emailnoticetemplate":`Modelos de Notificação por Email`,
"calendar.tips.task":`Nenhuma tarefa hoje`,
"label_partner_all_operate":`Operação`,
"message.duplication.label.cancelbutton":`Cancelar`,
"vue_label_SMS_addcontact":`Acrescentar contacto`,
"label.martrixreport.setsumfield2":`Seleccione o campo que utilizou como coluna de resumo no seu relatório de matriz`,
"approval_request_email_body":`Os seguintes itens estão a pedir a aprovação:  \n      clique no link abaixo para aprovar:  \n`,
"label.emailobject.emaildetail.field.record":`Registo`,
"label.tab.page":`Página`,
"label_tabpage_prepagez":`Mostrar em todas as páginas`,
"label.iran.daylight.time":`Hora Padrão do Irão`,
"label.event.nextweek":`Semana seguinte`,
"fliter.lastmonth":`Último mês`,
"label.group.no.recent.search":`Não existem grupos que correspondam a grupos vistos recentemente.`,
"label.h5.act.confirm":`Confirme`,
"label_tabpage_mypotentialcustomers":`As minhas pistas`,
"label.tabpage.queuez":`Fila`,
"label.batch.edit.description":`Seleccione para os campos que pretende editar,seleccione pelo menos um campo e até 5.`,
"label.batchadd.newbatchpage.deltr":`Mantenha-se, pelo menos, em linha.`,
"label.industrialandcommercialverification.instructions2":`A versão que está a utilizar é gratuita, e o número máximo de consultas é de 10.000 vezes por dia. Se precisar de expandir o número de consultas, recomenda-se a compra do serviço. Depois de comprar o serviço, obterá o token do fornecedor, configurá-lo nesta página. O vendedor continuará a fornecer-lhe o serviço pago correspondente.`,
"label.rejectrequestbehaviour":`Realizar toda a rejeição <forte>e</sforte> toda a rejeição final para este passo. (Rejeição final)`,
"label.batchCopy":`Clone de Lote`,
"label.service.two":`Alguns filtros são definidos mas não referenciados nos Filtros Avançados.`,
"label.data.import.setup.detail.remark":`Se verificar as seguintes opções,é efectuado nos dados de importação.`,
"vue_label_file_delete_lib":`Eliminar biblioteca de ficheiros`,
"label.integerdigit":`O número de dígitos à esquerda da vírgula decimal`,
"label.profile.standardobjcontrol":`Permissões de objectos padrão`,
"label.reportrecords":`Registos`,
"label.noplan":`Não tem eventos agendados para os próximos 7 dias.`,
"label.visualpage.ytype":`Painéis de instrumentos`,
"label.branch":`;`,
"label.knowledgebase.new.article":`Novo artigo`,
"label.Addressbook":`Contactos`,
"label.delete.reward.groups":`Eliminar grupo de linhas de citação`,
"label.appexchange.uninstallpage.message1":`Eliminar permanentemente todos os componentes deste pacote （listed below）`,
"chatter.group.everyone":`Todos os Utilizadores`,
"label.cooperation":`Cooperação`,
"label.uploadfail":`Upload Fracassado`,
"to":`para`,
"button_partner_delete":`Eliminar`,
"attachment_select_warning_001":`O anexo está arquivado e o botão Arquivar não está disponível, por favor seleccione novamente um anexo.`,
"label.step4.total4":`Etapa 4 de 4`,
"label.login.access.avalid":`Expira Hoje`,
"label.defaultview2":`Lista de pinheiros`,
"vue_label_commonobjects_detail_style":`Estilo de compra`,
"label.selectfield":`Seleccione os campos`,
"label.report.select.column.collect":`Seleccione a coluna a resumir`,
"lable.currencyAdv.newdaterate.existeddate":`A data já está a ser utilizada para HKD.Por favor especifique uma data de início diferente.`,
"pagecreator_systemstyle_button_new":`Novo estilo`,
"label.ccchat.person.invite":`Os colegas convidam`,
"label.sendemail.recycle.clear":`Reciclagem clara`,
"label.usermanage.view.notexist":`O ponto de vista não existe`,
"setup_chatter_enabled":`Não disponível, por favor contacte o Administrador para activar o CCChat.`,
"UG.Contract.01":`Gerir contrato`,
"label.martrixreport.2018.step4":`Passo 4 Seleccionar os critérios do relatório`,
"message.errorinscript":`Questões do guião de execução.`,
"label.knowledgebase.modification.date":`Data modificada`,
"label.projectManagement.the.maximum.number.of.fees.is.10":`Podem ser introduzidos até 10 dígitos para custos`,
"label.list.isActiveNewApproval":`Activar Nova Página de Aprovação`,
"label.mobile.main.page.icon.setup":`Definições de Ícones de Aplicações Móveis`,
"label.select.customer":`Seleccione Conta`,
"label.sharerule":`Partilha de configurações`,
"label.fiscal.FY":`Ano Fiscal`,
"label.appupload.component.type.customfield":`Campo personalizado`,
"label.emailobject.emailsend.sendindividually":`Enviar Individualmente`,
"label.new_formname":`Novo nome do formulário`,
"label.appointment.wizard.notif1":`A hora de fim não deve ser anterior à hora de início`,
"front-console-conversation-evaluate-desc":`Resposta de avaliação de {evaluateInfoName}`,
"homepage.components.lasttime":`Data da última modificação`,
"vue_label_commonobjects_view_chart_deletechart":`Apagar tabela`,
"label.multilang.document.upload.fail":`Os ficheiros {0} foram carregados com sucessolt e os ficheiros {1} falharam`,
"UG_contact_03":`Rastrear contactos num só local, sinais de venda`,
"label.marketsea.istoseafromother":`Permitir a transferência a partir de outras piscinas de chumbo`,
"label.datamanage":`Administração de dados`,
"label.globaloperation.operationtype.create.data":`Criar registo`,
"label.customer.tab.step2.see":`Visibilidade do separador`,
"label.wtd.changefields.desc":`Após os utilizadores submeterem o formulário, serão levados para o URL de retorno especificado no seu website, tal como uma página de "obrigado".`,
"label.ems.eamilinfo":`Informação por e-mail`,
"label.recordtypeselect.new":`Novo tipo de registo`,
"vue_label_report_output":`Tipo de saída da fórmula`,
"label.emailnotice":`Alerta por e-mail`,
"label.icon.196":`Papel higiénico`,
"label.emailsync.status.disabel":`Inactivo`,
"label.tabpage.isdeleterecord":`Se apagar o registo seleccionado`,
"message.selectoneoftypes":`Por favor seleccione um dos seguintes tipos`,
"label.import.index.createid":`Criar ID`,
"vue_label_systemSettings_social2":`Configuração de conta nos meios de comunicação social`,
"label.ccpeak.sel.time":`Classes programadas nesta pasta`,
"label.data.downpage.i_list.desc1":`Durante a importação, os dados que não são importados com sucesso porque os dados estão formatados incorrectamente, ou porque a regra de activação ou validação falha, gera o ficheiro CSV a ser exibido na página actual. Os dados importados com sucesso não serão mostrados na página actual.`,
"label_adjust_forecast":`Ajustar previsão`,
"vue_label_normal_lead_sf":`Chumbo`,
"vue_label_report_notice1":`O relatório contém alterações não guardadas. Se encerrar o relatório, estas alterações serão perdidas. Clique abaixo do botão "Guardar e fechar" para guardar as alterações.`,
"label.notfiledpublicreport":`Relatórios públicos não arquivados`,
"one":`Um`,
"UG.Lead.008":`Código de digitalização de cartões de visita`,
"label.archived":`Arquivado`,
"label.standardabstractfield":`Campos de Resumo Padrão`,
"vue_label_notice_add_fail":`Adicionar falhou`,
"label.sendemail.registIMUser.addresserror":`o endereço de correio electrónico do destinatário está incorrecto`,
"label.ccdocument.toolbar.switch":`Interruptor da barra de ferramentas`,
"first":`O Primeiro`,
"label.icon.147":`Rato`,
"vue_label_jihui_er":`Oportunidade 2`,
"label.ccchat.micropost.isedit":`Modificação de mensagens e comentários`,
"label.department.next":`Página seguinte`,
"front-kefu-moudle-confirm-disable-phone-user":`Tem a certeza de desactivar a marcação para o utilizador {0}?`,
"label.reportsSubscription.time.meets.subscription.frequency":`A data de início e fim não corresponde à frequência de subscrição!`,
"lable.account.NextpDays":`Próximos 120 dias`,
"UG_opportunity_007":`Papel de contacto`,
"label.encrypt":`Criptografado`,
"label.knowledge.category.hint.three":`Eliminar ou substituir a categoria existente, o que remove todas as catetogias associadas ao artigo.`,
"label.customcomponent.usewhere.info":`A seguir estão todas as referências a este componente. Clique na etiqueta de referência para ver a definição.`,
"vue_label_import_addandupdate":`Adicionar e Actualizar`,
"label.email.all.members":`Enviar a todos os membros do grupo por email`,
"component_task_button_save":`Guardar`,
"label.file.deleted.unavailable.desc":`O ficheiro é eliminado,não está disponível ou está indisponível agora.`,
"label.emailsync.status.viewlog":`Ver Registo`,
"label.marketsea.othersetup":`Outras definições`,
"label.data.exp.newtemppage":`Página de criação de modelos`,
"vue_label_lead_score_successsful":`Pontuado com sucesso`,
"label.sendemail.activity.newtask":`Caro #belongtoidccname, olá:o seu colega #createbyidccname atribuiu-lhe uma nova tarefa em #createdate, que diz o seguinte:#sujeito:#sujeito:#expireData:#expireData:#artigo relacionado: #relacionardstrtn conteúdo:#relacionardstrtn conteúdo:#relacionardstrtn conteúdo:#relacionardstrtn #Para mais detalhes, por favor visite este link:rr\n Caminho:r\n SistemaorgNameCRM`,
"component.event.label.soon":`Imediatamente`,
"label.forecast.shrepage.getlist":`Voltar à Hierarquia de Previsões`,
"UG.solution.02":`A solução é uma solução interna da instituição para o problema que as contas encontram.`,
"label.weixin.data.approval":`O registo está sob aprovação`,
"label.build.pagelist":`Lista de páginas do construtor de páginas`,
"label.customsetting.type.hiberarchy":`Hierarquia`,
"label.forecast.ccfh":`Outdo`,
"label.Current.Window":`Mostrar em Janela Existente`,
"label.appointmentdetail.wizard.title20":`Plano de Domingo`,
"label.emailaddress":`Endereço de correio`,
"label.qetting_notifications":`Não está a receber os nossos emails? Certifiquese de que adicionou os endereços de correio electrónico CloudCC à sua lista de permissão e ligou as suas notificações de exportação.`,
"Homepage.News.001":`Notícias`,
"label.runreport":`Relatório de execução`,
"label.customer.tab.step3":`Passo 3 Adicionar às aplicações personalizadas`,
"label.dashboard.snapshot.refresh":`Actualizar`,
"label.approvepagelayout3":`Aprovar o layout da página`,
"vue_label_SMS_send_messages":`Enviar Mensagens`,
"label.executestate.old":`Executado`,
"label.approvalstep3":`Passo 3 Seleccionar o Aprovador Designado`,
"label.step3.total6":`Etapa 3 de 6`,
"front-kefu-moudle-v1-delete-templete":`Apagar modelo`,
"label.data.downpage.e.title.num3":`3、Users pode criar modelos de exportação de acordo com as suas necessidades e seleccionar o item "Export By Template", o que pode tornar a operação de exportação mais conveniente.`,
"label.attendance.outer":`Trabalhador móvel`,
"setup_layout_button_selectall":`Seleccionar tudo`,
"chatter.photo.img":`O tamanho máximo do ficheiro é de 2 MB.`,
"front-dynamiclayout-module-v1-required":`O campo de {required} é definido conforme necessário.`,
"label.mytask":`As minhas tarefas`,
"label.edit.customerinfo":`Perfil da empresa Editar`,
"label.processsetting.process.explain":`A criação e utilização do processo permite aos utilizadores concentrarem-se nos itens mais importantes e mostrar-lhes palavras-chave e dicas no momento certo para os ajudar a completar o processo.`,
"label.emailobject.subject":`Assunto`,
"label.mobileapp.scansetting.message":`Seleccione se pretende guardar os cartões digitalizados no formato de imagem na lista relacionada de "Notas e Anexos", de acordo com o seu cenário de utilização real. <br>Enable: o cartão digitalizado é automaticamente guardado no anexo enquanto o registo está a ser guardado. <br>Disable: guardar apenas o registo.`,
"front-epwechat-module-v1-android-autograph":`Assinatura do aplicativo Android`,
"label_component_helper_potentialcustom":`Leads que lhe foram atribuídos hoje`,
"label.projectManagement.nodata.week.work":`Vamos acrescentar tarefas para melhor organizar o trabalho desta semana.`,
"label_tabpage_rolez":`Papel`,
"label.importsourcestep4":`Passo 3 Importar os seus ficheiros`,
"label.icon.50":`Bússola`,
"lable.service.prompt":`Incapaz de criar novos field，the número de campos atingiu o limite.`,
"label.campaign.channel.input.page":`Especificar uma página Web, definindo geralmente a página inicial da campanha como uma página de agradecimento.`,
"UG.homepage.001":`Ganhar mais negócios em menos tempo`,
"label.step4.total6":`Passo 4 de 6`,
"label.partner.required":`Erro: o domínio não pode estar vazio`,
"label.tag.manage.title":`Gerente- {0}`,
"label.data.downpage.i_title.num1":`1. O sistema apenas suporta o formato CSV comum.`,
"label.custom.quarter.end":`Data final do Trimestre Personalizado`,
"label.layout.distribute":`Atribuição do layout da página`,
"label.version.allsms":`Mas SMS`,
"label.tolead":`Importação`,
"label.texttemplate.usemergefields":`Utilização incorporar campos no modelo SMS.`,
"label.emailobject.sure":`Claro`,
"lable_setup_mobilesetup_isenbaleh5newandedit":`Se activar h5 no seu lado móvel e editar`,
"label.tabpage.messagez":`Por favor, introduza o seu comentário`,
"label.mobile.phone.write.day.report":`Novas Notas de Trabalho Diário`,
"label.data.setok.e.desc2":`Página de Lista de Dados de Exportação`,
"label.emailsync.message":`Pronto`,
"label.sales.page.mubiao":`Atingir o Objectivo`,
"label.ccdocument.list":`Ver o seu último documento`,
"label.tabpage.userGuidez":`Guia do utilizador`,
"label.report.fields":`Campos disponíveis para relatórios`,
"vue_label_checkduplicate_at_same_time":`Satisfazer todos ao mesmo tempo`,
"label.sms.phone":`Telefone de serviço`,
"UG_ST_004":`Não tem a gestão de dados - "permissão de importação de dados, por favor contacte o administrador, clique em confirmar e vá directamente para a interface {0}.`,
"label.mobile.nobindmobile":`Este número móvel não existe agora. Por favor, vincule o número de telemóvel a partir da informação do utilizador`,
"label.partnerCloud.basicSetting.intro":`O CloudCC suporta a criação de múltiplos sítios para parceiros de diferentes tipos e configurar página de login, menus, e permissões separadamente. Por exemplo, os retalhistas podem criar vários sítios para agentes locais e parceiros publicitários.`,
"label.trigger.targetobject":`Objectos Alvo`,
"label.ems.emailsyncperiod":`Período de sincronização de e-mail`,
"lable.Transformation.mode":`Modo de Transformação`,
"label.emailobject.new.template":`Adicionar novo modelo`,
"label.System.Setting":`Configurações do sistema`,
"label.emailtocloudcc.button.addemailaddress":`Adicionar Caixa de Correio Empresarial`,
"lable.a.total.of.invoices":`0 factura no total`,
"label.multilang.customforcast.forecasthistory":`Previsão histórica de {0}：`,
"label.role":`Papéis`,
"advancedconditions":`Condições avançadas de filtragem`,
"label.tabpage.beginz":`Comece em`,
"label.campagin.roi.khzhsl":`Quantidade de conversão de contas`,
"chatter.poll.option5":`Escolha 5`,
"label.weixin.horse.club.registered":`Registo de utilizadores da Aid-Max`,
"frame_personinfo_label_resizeimage":`Para fazer ajustes à sua imagem em miniatura, arraste e redimensione as linhas pontilhadas na sua foto de perfil acima.`,
"label.file.share.select.warning":`Foi criado para ser partilhado!`,
"label.event.this.week":`Esta Semana`,
"label.data.import.object.label":`Etiquetas de objectos`,
"label.visualpage.folder":`Pastas de páginas não arquivadas`,
"vue_label_report_saveandclose":`Guardar e fechar`,
"label.newdashboardpage.saveto":`Guardar para`,
"label.partnerCloud.financeSetting.developerIDTwo":`ID do desenvolvedor`,
"lable.PowerProcess.created.ago.please":`Antes de criar um processo, por favor`,
"label.chatter.myfollowers":`Os meus seguidores`,
"label.campaignmember.main.duplicatelist.title":`Memebers da campanha: Código de digitalização para encontrar definições duplicadas`,
"label.group.no.recent2":`Encontrar grupos para aderir`,
"label.icon.110":`Livro`,
"label.merge.my.account":`Fundir as minhas contas`,
"setup.layout.button.quicksave":`Salvar rapidamente`,
"pagecreator.page.message.canntdelete":`A página actual não é autorizada a apagar`,
"label.report.printable.view":`Vista para impressão`,
"ccchat_fieldtrack_fieldchange":`Mudar de {0} para {1}`,
"label.email.bcc":`Bcc`,
"label.sso.saml.sp.idpcert":`Certificado de Provedor de Identidade`,
"label.step2.total2":`Etapa 2 de 2`,
"lable.product.pricebooks.isn":`Livros de Preços Activos`,
"labal.emailtemplate.namemassage":`O nome único do modelo de correio já existe, por favor reeditar`,
"only.one.field":`Apenas um campo pode ser seleccionado.`,
"label.weixin.appr.audittime":`Data de Aprovação`,
"pagecreator.page.button.delete":`Eliminar`,
"front-kefu-moudle-v1-Session-start-time":`A sessão começa em:`,
"label_chatter_state":`Estado`,
"vue_label_systemSettings_lightningcustom":`IU personalizada em Relâmpagos`,
"label.searchs":`Pesquisa`,
"label.mobile.phone.not.read":`Não revisto`,
"label_chatter_allweather":`Para todas as condições meteorológicas`,
"label.enter.number":`Por favor, introduza um número inteiro entre 0-6.`,
"front-epwechat-module-v1-addressbook-desc":`Quando activados, os contactos e departamentos na WeCom serão sincronizados com os utilizadores e funções da CloudCC`,
"label.emailfield":`Campos de e-mail`,
"pagecreator_button_next":`Próximo passo`,
"label.more.select.merge.records":`Só pode seleccionar até 3 dados para fundir`,
"lable.edit.queue.selobjct":`Objectos seleccionados`,
"label.reportsSubscription.editsubscribe":`Editar Subscrição`,
"label.selectfieldtoautotransmit":`Seleccionar Campo Utilizado para Roteiro de Aprovação Automatizado`,
"label.ccpeak.need.topass":`Necessidade de passar para`,
"label.checkfield.merge":`Fundir`,
"front-lighting-module-v1-detail-file-downlaodInfo":`O registo está bloqueado e não está disponível para descarregar ficheiros. Por favor contacte o administrador para desbloquear.`,
"vue.please.enter.a.chart.name":`Por favor, introduza o nome do gráfico.`,
"label.data.dataexptemplate.desc3":`3. O modo de exportação é válido apenas para os dados comunicados e não é valis para o modelo de exportação. O formato do ficheiro para o modelo de exportação é CSV.`,
"label.setup.mobile.homepageshortcuts.setting":`Página inicial definições de funções rápidas`,
"label.ems.connect.success":`Teste de e-mail bem sucedido`,
"label.applet.text":``,
"label.knowledgebase.parent.window":`Janela dos pais`,
"label_file_size":`Espaço utilizado`,
"label.allocation.department":`Atribuir Utilizadores`,
"label.browser":`Browser`,
"label.reportsSubscriptionPage.schedulereport.weekly.wednesday":`Quarta-feira`,
"label.integrations.description1":`Exportar os dados na vista actual`,
"label.project360":`Projecto 360`,
"label.choose_formtype":`Escolha o tipo de formulário`,
"label_emailsync_status_connectstatus":`Estado da ligação`,
"label.bmap.beijing.city":`Pequim`,
"label.mask.encryption.scheme":`Formato encriptado`,
"label.imgfield.type":`Tipo de imagem`,
"label.person.target.responsible":`Seleccionar o supervisor da baliza.`,
"label.appexchange.installedpage.installdate":`Data de Instalação`,
"label.partnerCloud.orderingPlatform.partnerUsers":`Esta característica só está disponível para utilizadores parceiros.`,
"label.profile.customfieldsafety":`Segurança de Nível de Campo Personalizada`,
"label.no.target.models.available.":`Não há modelos indicadores disponíveis. Favor criar um modelo de indicador ou contactar o administrador.`,
"label.process.execute.tip":`O seu pedido foi processado, aprovado ou rejeitado em massa levará algum tempo, e o sistema informá-lo-á por correio quando o processamento estiver concluído.`,
"label.app.step2.introduce":`Introduza os seguintes campos para definir a aplicação personalizada`,
"label.loginip.cue":`Não é especificado nenhum intervalo de IP e os utilizadores de qualquer endereço IP são autorizados a entrar no sistema.`,
"label.step1.select.tablayout":`Passo 1 Escolha o layout do separador`,
"mainpage.setup.chosecomponent.leastone":`Deve seleccionar um componente pelo menos na página inicial.`,
"label.custom.quarter.name":`Nome do Trimestre Personalizado`,
"chatter.ptup.link":`Postar um link`,
"label.compact.layout.frame.error2":`Informações detalhadas e lista relacionada devem estar no ecrã da esquerda`,
"vue_label_salesfunnel_notice7":`Número total de oportunidades de negócio com uma probabilidade de 100%/Número total de oportunidades de negócio com uma probabilidade de 0% ou 100%`,
"label.multilang.datamanage.dataimport.lostmsg":`O comprimento do título é &nbsp;{0}&nbsp;, mas o comprimento dos dados é &nbsp;{1}&nbsp;, o sistema não pode determinar quais &nbsp;{2}&nbsp; os campos são redundantes.`,
"label.owner.notnull":`O proprietário não pode estar vazio`,
"label.logintime.pagecue.invalidt":`A hora de início não pode ser maior do que a hora final.`,
"vue_label_file_checked_num_limit":`O número de ficheiros seleccionados excede o limite`,
"front-email-payment-repayments":`Pagar de novo`,
"template.report.today.prospects":`Leads de Hoje`,
"label.weixin.appr.status":`Estado`,
"label.knowledge.language.japanese":`Japonês`,
"label.event.reminder.lead.time":`Lembrete`,
"lable.custom.dep":`Clique no botão Novo para definir um novo ano personalizado.`,
"Dashboard_View_Createdbyme":`Painéis de instrumentos criados por mim`,
"label.file.upload.fail":`Upload de ficheiro falhado`,
"label.manager":`Gerente`,
"label.stdashbord.xsld.business.jine":`Montante`,
"label.tag.manage.tag":`Tag`,
"chatter.nlk":`Ao contrário de`,
"label.file.search.people":`Pesquisar pessoas`,
"message.error.domain.format":`Os nomes de domínio só podem consistir em inglês e arrays`,
"label.firstisdefault":`Utilizar o primeiro valor como valor por defeito`,
"label.discount":`Desconto`,
"label.mobile.phone.have.read":`Revisado`,
"label.field_selected":`Este campo foi seleccionado`,
"label.payment.renew.now":`Renovar Agora`,
"label.multilang.lookfiltercondition.notsetup":`A condição da linha {0} está incorrecta, nenhum operador está definido!`,
"label.projectManagement.Selectionday":`Seleccionar Dia`,
"label.user.organization.permit.licensenotstart":`A licença da sua organização não foi activada, por favor tente novamente depois de a licença estar activada`,
"label.download.save.attachment":`Descarregar e guardar em anexo`,
"lable.outlook.mcto.must":`Deve estar em formato de correio electrónico.`,
"vue_label_notice_unfollow_success":`Insegura com sucesso`,
"label.taskinfo":`Passo 2 Configurar Tarefa`,
"label.other.SMS":`Outros números de telefone`,
"label_partner_workspace_login_logo":`Logotipo de cabeçalho`,
"label.weixin.data.lock":`O registo está bloqueado.`,
"label.Yaxis":`Eixo Y`,
"lable.edit.queue.selobjdes":`Seleccione os objectos que deseja atribuir a esta fila. Os registos individuais para esses objectos podem então ser propriedade desta fila.`,
"label.campagin.roi.dcfezb":`Taxa de frequência`,
"label.marketseamemset.maximum":`Montante máximo`,
"label.owner":`Proprietário`,
"label.reportsubscribe.error.noview":`Por favor preencha qual o utilizador que deseja executar este relatório como em "Executando como".`,
"label.icon.133":`Pasta`,
"vue_label_file_share_files":`documentos partilhados`,
"label.searchlayoutfilterfields.remark":`Seleccionar as colunas do campo de filtragem a serem despachadas durante a pesquisa na barra lateral da página inicial e a pesquisa na página inicial do separador.`,
"vue_label_help_contract":`Contrato e plano de recolha`,
"component.chatter.button.message":`Comentário`,
"label.marketsea.recyclereminddays2":`Lembrete de dia (deve ser inferior ao número de dias sem seguimento após a obtenção)`,
"label.webtocloudcc.input.information":`A informação é necessária.`,
"vue_label_chatter_exit_group":`Deixar o grupo`,
"vue_label_lead_notcreatetask":`Não criar tarefa`,
"front-lightning-module-v1-dashborad-date-dimension":`Data Dimensão`,
"setup.layout.label.fieldlist":`Campos disponíveis`,
"label.leadscore.charname":`Nome do campo`,
"label.forecast.customforecast.mybest":`O meu melhor caso`,
"setup_mainpage_label_welcome24":`A plataforma CloudCC fornece definições de acesso de segurança para todos os dados dos objectos no sistema. A partilha de dados e os direitos de acesso podem ser controlados através da definição de várias regras e condições.`,
"label.queue":`Filas de espera`,
"label.icon.159":`Chip`,
"label.path":`Caminho de referência`,
"label.app.message.failtoget":`Falha na obtenção da lista de aplicações`,
"label.returntoprocess":`Voltar à lista: Processos de Aprovação`,
"vue_label_commonobjects_detail_more_data":`Não há mais dados`,
"label.number":`Número`,
"label.product.find":`Encontrar livros de preços`,
"label.legend":`Lenda`,
"label.partner.workspace.member.profile":`Perfis disponíveis`,
"label.service.gantt.sum.appointments":`Marcações de serviço concluídas/Todos os compromissos de serviço`,
"label.partnerCloud.financeSetting.paymentAllowed":`Permitir recarga online`,
"label.integrations.upgrate":`Upgrate`,
"label.timzone.tip.info3":`Quando utiliza a classe de calendário para processar datas, deve definir o fuso horário para a instância do calendário, e pode seleccionar um dos dois métodos seguintes para obter os objectos do calendário: Calendar cal=Calendar.getInstance(TimeUtil.getUserTimeZone(userInfo))和Calendar cal=TimeUtil.getCalendar(userInfo)`,
"label.ems.addaccount2":`Adicionar conta de e-mail`,
"label.partneruser":`Utilizador parceiro`,
"label.validate.globalvariable.user.roleId":`Identificação do papel`,
"pagecreator.layout.button.mergecell":`Fundir células`,
"label.evacuantvalue":`Excluir valores`,
"label.setup.mini.msg":`Cenário de História de Marca/Mensagem`,
"label.icon.178":`Pessoas`,
"vue_label_pricebook_notice_cantbedeleted":`As entradas da lista de preços não podem ser eliminadas porque já existem registos aplicados à lista de preços. Em vez disso, é possível marcar as entradas da lista de preços como inactivas.`,
"vue_label_appstore_application_recommendation":`Recomendação de aplicação popular`,
"label.version.createlimit":`A sua edição actual do CloudCC é {0}, e pode criar {1}. {2}. Agora, o número de {2} é excedido o máximo do seu plano de assinatura, por favor actualize a sua edição CloudCC.`,
"message.duplication.label.sectionremar1":`Seleccione os valores que pretende manter no registo fundido. As linhas em destaque indicam campos que contêm dados contraditórios. O registo principal seleccionado reterá valores de campo só de leitura e ocultos.`,
"label.icon.1":`Nuvem`,
"label.salescloud.salesdashboard.sales.performance":`Resultados Globais dos Contratos de Venda`,
"System_AddressFieldType_Post":`Código Postal`,
"setup_object_field_dependency_label_mustone":`Deve seleccionar pelo menos 1 valor do campo dependente.`,
"label.appointmentdetail.wizard.title6":`Localização`,
"label.layout.testobj2":`Objecto de teste 2`,
"label.searchlayout.dupcacher.field":`Clique no link Encontrar Duplicados e Fundir para ver os campos duplicados.`,
"label.attendance.persons.title":`Utilizadores Adequados`,
"template.report.product.sales":`Venda de produtos`,
"label.editCustomReportType":`Edição de dados do relatório personalizado`,
"label.multilang.ui.setup.profile.alltime":`Todos os tempos são {0}`,
"label.service.dispatchingUnits.noservice.booking":`Sem marcação de serviço`,
"label.validate.remark4":`Assegurar que o número está dentro de um intervalo específico, tal como o desconto inferior a 30%`,
"front-kefu-moudle-v1-Waiting-time":`Tempo de espera:`,
"label.weipagelayout.remark":`Usado na página da aplicação móvel ou WeChat`,
"vue_label_wang_er":`Michael`,
"label.pw.text":`Introduza a palavrapasse para {utilizador}, e certifiquese de que contém pelo menos`,
"message.error.user.data.null":`A informação do utilizador não pode estar vazia!`,
"chatter.like.p":`Como este posto`,
"label.page.double.column.style.cloudcc":`O estilo de 2 colunas fornece funções úteis do CloudCC.com, como Pesquisa e Itens Recentes, na mesma página que o seu conteúdo incorporado.`,
"label.h5.iscloseaccount":`Tem a certeza que quer terminar a sessão?`,
"label.dataimport.insertdata.id.error":`Erro de formato, por favor use uma combinação de letras e números.`,
"label_tabpage_sum":`Total`,
"front-epwechat-module-v1-addressbook-sync":`Livro de Contacto de Sincronização`,
"label.setup.mobile.offlinecache.mostsave":`A plataforma pode definir o tabulador móvel offline activado por defeito até 10`,
"label.weixin.quickcreate":`Criação Rápida`,
"label.forecast.edittotal.de.mubiao":`Quota`,
"label.icon.144":`Garantia`,
"label.icon.155":`Imagem`,
"label.In.the.search":`A pesquisar`,
"message.validation.isnotdateISO":`Data inválida (ISO)`,
"label.service.appointmentList.send.successfully":`Despacho com sucesso`,
"label.dynamicpage.error.exist":`Não existem dados dinâmicos sobre a disposição da página`,
"vue_label_SMS_otherpeople":`e {0} outros`,
"label.cloudccsite.url":`URL do sítio`,
"label.tabpage.contactsz":`Contactos`,
"vue_label_commonobject_notice_clickthename":`Se precisar de descarregar o ficheiro carregado, por favor clique no nome do ficheiro`,
"vue_label_file_new_lib":`Nova biblioteca de ficheiros`,
"label.chatter.card":`Cartão`,
"chatter.feed.menutype.user.allusercom":`Todos os Colegas`,
"label.exchange.sync2":`Definições`,
"template.report.year.income":`Receitas deste ano`,
"label.partner.template.detail":`Descrição das funções`,
"label.setup.service.template":`Modelo de relatório de serviço`,
"label.dataimport.insertdata.id.length":`Erro de formato,por favor verifique este registo e modifique-o. É favor notar que o comprimento inferior a 20 caracteres.`,
"label.partnerCloud.financeSetting.collaborator":`ID do Cooperador`,
"label.processskipwizard":`Feiticeiro de Aprovação do Processo de Início de Salto`,
"label.weixin.inputbusnumber":`Por favor introduza o número da matrícula`,
"label.dashboardSetup.d1":`Ponto de quebra 1`,
"template.report.conversions.number.industry":`Número de conversões de leads (por indústria)`,
"vue_label_chat_group_chat":`chat de grupo`,
"label.file.publicview.error":`O ficheiro é apagado ou não existe ou não pode ser visualizado`,
"label.customfields.location.locationHelpText":`Por favor, introduza um nome de localização, tal como "sede".seja descritivo e específico, e tenha em mente que um registo pode ter múltiplas localizações, tais como "escritório de vendas da costa ocidental" e "escritório de vendas da costa oriental".`,
"message.duplication.label.blankmatchtip":`Defina o campo em branco para corresponder, o padrão é Falso`,
"message.appexchange.addtopackage":`Escolha um ou mais componentes para adicionar a este pacote!`,
"label.ems.return2query":`Voltar à página de consulta de contas de e-mail adicionadas`,
"label_model_name":`Nome do modelo`,
"label.apiname.retainapi":`Nome é o nome reservado do sistema,por favor use um campo diferente de nome API.`,
"lable.Cancel.the.search":`Cancelar Pesquisa`,
"label.custom.viewport":`Ponto de vista`,
"label.weixin.polls.type":`Tipo`,
"label.opportunity.setting.showstage.label":`Promoção automóvel`,
"label_component_helper_businesschange_expiredtask":`Oportunidades com Tarefas Vencidas`,
"label.operator":`Operador`,
"label.ccpeak.use.class.time.listmap":`Acesso passando na Lista<Mapa> colecção`,
"component_timeline_label_past":`Actividades passadas`,
"label.mobile.phone.submit":`Submetido por mim`,
"message.recordtype.new.subtip":`Introduzir um nome e descrição para o novo tipo de registo. O novo tipo de registo incluirá todos os valores da lista de selecção a partir do tipo de registo existente seleccionado abaixo. Depois de guardar o novo tipo de registo, será possível personalizar os valores da lista de selecção.`,
"UG_product_05":`Produto de importação`,
"label.validate.globalvariable.user.id":`Identificação do utilizador`,
"label.umeng.activity.distribute":`atribui a`,
"label.weixin.avote":`Votação`,
"label.weixin.already.sign":`Já assinou.`,
"label.emailmerge.mergepage.generator":`Gerar`,
"label.batchtransfer.transferto":`Transferência para`,
"label.tianyancha.industry":`Indústria`,
"label.addattachment.name":`Nome do ficheiro`,
"label.customfields.formula.date.tip":`Para calcular uma data, por exemplo, adicionar dias a outras datas ou subtrair dias de outras datas.`,
"label.partnerCloud.orderingPlatform.noPayment":`Não pagar`,
"label.emailobject.failedtosend":`Falha no envio`,
"label.knowledge.setting.data.three":`Pode ser seleccionado um máximo de {count} dados de grupos de categorias.`,
"label.weixin.input.maxlength.langtext":`Por favor, introduza aqui, até 32000 caracteres`,
"vue_label_calendar_delete_calendar":`Eliminar Calendário`,
"vue_label_commonobjects_detail_filter":`Filtro de colapso`,
"setup.layout.group.custompage":`Personalizar Página`,
"component_sendmail_label_subject":`Tema`,
"label_tabpage_maxfilez":`O tamanho máximo do ficheiro é`,
"label.logintime.pagecue":`Seleccionar a data e hora em que os utilizadores com este perfil podem iniciar a sessão. Note-se que a hora exacta do fuso horário especificado é utilizada para todas as horas. Mesmo que o utilizador se encontre em fusos horários diferentes, estas horas exactas são utilizadas para a hora de início de sessão.`,
"label.salescloud.salesdashboard.datetime":`Data de fecho`,
"label.format":`Formato`,
"label.newfoundland.daylight.time":`Hora de Verão de Newfoundland`,
"front-kefu-moudle-v1-messagetemplate.finishdetailinfo":`Copiar e colar o valor do campo no conteúdo do SMS`,
"message.chooseatleastoneforshare":`Por favor seleccione pelo menos um utilizador para partilhar`,
"label.multilang.datamanage.importobjfield":`Coluna {0}`,
"label.denglu":`Login`,
"label.popup.infoz":`Pronto`,
"label.schedulejob.setup.schedule.onday":`Em cada mês`,
"label.appointmentdetail.wizard.title16":`Plano de quarta-feira`,
"label.userphoto.dragtoadjust":`Arrastar para ajustar a miniatura`,
"label.product.series":`Família de produtos`,
"message.view.kanban.not.set.group.summary.field":`O painel de visualização não define o campo de resumo do grupo`,
"page.un.activities":`Actividades não iniciadas`,
"label.exchange.sync3":`Configurações`,
"label.login.activityExpired":`O período activo do utilizador expirou, por favor contacte o administrador do sistema.`,
"component_chatter_file_button_files":`Seleccione um documento`,
"message.onlydelete.type":`Só se pode apagar os tipos de registos inactivos. Assim, pode desactivar primeiro os tipos de registos se os quiser apagar.`,
"message.recordtype.selectlayouttouse":`Layout da página a utilizar`,
"label.knowledgebase.unable.restore.draft":`Não é possível recuperar rascunhos apagados.`,
"label.shangqing.name":`Informação empresarial`,
"label.weixin.target.payment":`Pagamento alvo`,
"label.chatter.sendEmailToGroupMember.check":`Ver Posts`,
"front-kefu-moudle-v1-input-single-login-area":`Por favor, introduza o nome de domínio de sessão única`,
"vue_label_zhang_yi":`Alice`,
"label.icon.190":`Secador de cabelo`,
"label.quickbooks.fieldlabel.company":`Empresa`,
"vue_label_email_are_you_sure_to_delete":`Tem a certeza de que vai apagar o correio?`,
"Pagelayout.Setup.005":`O nome tem de ser colocado em primeiro lugar.`,
"label.object.name.two":`Nome do objecto 2`,
"label.tabpage.completez":`Marcar o estado seleccionado para completar`,
"label.setup.mobile.bottombutton.saveerror":`Falha em salvar definições de página de primeiro nível`,
"label.report.action.addtodashboard8":`Seleccione Dashboard Folder`,
"label.data.downpage.i_list.desc3":`Os utilizadores podem ver a razão da importação falhada na última coluna do ficheiro após os downloads.`,
"label.layout":`Layout`,
"label.marketsea.button.assign":`Atribuir`,
"UG.solution.03":`Criar uma solução`,
"label.ccchat.person.invited":`Convidar colegas`,
"label.ccchat.person.invite.address":`Destinatário`,
"label.displaytype1":`Ligação de Página de Detalhe`,
"label.tianyancha.h5.ziranrengudong":`Pessoa singular accionista`,
"lable.SalesCommitmentKanBan.targetReceipts":`Recibos Alvo`,
"message.error.getitems.type":`getItems:tipo não pode estar vazio`,
"label.addattachment.list":`Os seguintes ficheiros foram carregados`,
"label.datamanage.export.false":`Ocorreu um erro durante a exportação.`,
"pagecreator.systemstyle.label.buttonfontcolor":`Texto do botão`,
"label.emailtocloudcc.redmessage1":`Endereço de e-mail inválido`,
"label.weixin.polls.closed":`A votação está encerrada, o prazo é`,
"label.icon.165":`Chapéu`,
"vue_label_report_detailsonly":`Apenas detalhes`,
"component.salesperformance.label.100finish":`Terminado`,
"november":`Novembro`,
"label.data.file.generatejwd":`Gerar o serviço de latitude e longitude de acordo com o endereço`,
"label.salescloud.opportunity.access":`Oportunidades de acesso`,
"label.isremider.remider":`Lembrete`,
"vue_label_total":`Total`,
"label.email.prompt.using.lightning.link":`Definir a ligação de email nas notificações do sistema para estar em conformidade com as ligações Lightning.`,
"label.knowledgebase.cancel.attached.articles":`Artigo em anexo`,
"label.version.custom.xslc":`Processo de venda personalizável`,
"component_setup_button_save":`Guardar`,
"label.ems.cc":`Cc`,
"label.edit.user":`Utilizadores Editar`,
"label.emailtocloudcc.select2":`Por favor escolha o tipo`,
"label.industrialandcommercialverification.fieldnumber":`N.º de campos mapeados:4`,
"label.ccchat.havenot.joined.group":`Não se encontra em nenhum grupo activo`,
"pagecreator_page_label_pagename":`Nome da página`,
"setup.layout.button.save":`Guardar`,
"label.campaignmember.main.updatestatus":`Estatuto dos Membros da Campanha de Actualização em Massa`,
"label.tab.web.edit":`Edição do separador Web`,
"label.ring_chart":`Mapa dos donuts`,
"label.usermanage.resetpwd.error":`A redefinição da palavra-passe falhou e o utilizador não existe.`,
"label.Xaxisscope":`Âmbito do eixo X`,
"label.app.new":`Nova aplicação personalizada`,
"message.modifythereport":`O painel de bordo utiliza este relatório. As alterações podem invalidar o painel de bordo que faz referência a este relatório.`,
"label.component.helper.businesschange.0activity":`30 dias sem qualquer actividade`,
"label.weixin.fmu.noon":`PM`,
"label.enter.rule.name":`Introduza o nome das regras`,
"lable.Confirm.recovery.potential.customers":`Confirmar para recuperar o chumbo {nome}.`,
"lable.PowerProcess.type.created":`Que tipo de processo de concessão de direitos pretende criar?`,
"front-lightning-module-v1-dashbord-rectangle-size":`Tamanho do Orthogon`,
"label.projectManagement.new.service.appointment":`Nova marcação de serviço`,
"label.multilang.totalpage2":`Um total de`,
"pagecreator.systemstyle.label.styledesc":`Descrição de estilo`,
"chatter.up":`Carregamento`,
"2018UI_Homepage_DataDeleted_Info":`Os dados que deseja visualizar foram eliminados, por favor clique para voltar ao passo anterior.`,
"label.knowledge.draft.recordid":`O rascunho de identificação não pode ser nulo!`,
"vue_label_pool_recyclecertification":`{0}{1}{2}{3}？`,
"label.setting.intergrationlist.viewall":`Ver toda a integração`,
"vue_label_file_num_limit_tip":`O número de ficheiros excede o número predefinido. Se precisar de substituir os ficheiros, por favor eliminar primeiro os ficheiros carregados`,
"vue_label_commonobjects_view_refreshat":`Actualizado em {timeInterval} ago`,
"laebe.data.exp.save.success":`Se precisar de utilizar este modelo para exportar dados, por favor volte ao "Export By Template" para operar.`,
"label.mr.caption.contact":`Encontrar duplicados e fundir: Códigos para consulta de duplicados de Contactos`,
"label.webtocloudcc.submit.error":`Falha na submissão`,
"label.multilang.datadelete.delmessage":`Os registos bloqueados ({0}) não podem ser apagados:`,
"label.quickbooks.searchlist.total2":`Existem {0} pagamentos não vinculados para um valor total de {1}.`,
"label.createnew":`Criar Novo...`,
"component.milestones.label.choicestate":`Confirmar este estado`,
"lable.outlook.edit.exist":`Este nome de campo já existe. Introduza um nome de campo único.`,
"vue_label_dashboard_eachother":`Apenas as opiniões do mesmo relatório ou do mesmo objecto podem ser interligadas`,
"label.new.role":`Novo papel`,
"message.error.operationType":`A operação não é definida quando se chama um serviço.`,
"label.fenbeitong.name":`FenBeiTong`,
"label.choose.person":`Por favor, seleccione os destinatários a enviar`,
"label.attendance.thanks":`Obrigado pela sua participação!`,
"label.invoice.message.statusupdatefailed":`A actualização do estado das facturas falhou, por favor tente novamente mais tarde.`,
"template.chart.yzhqzkhlyfx":`Análise da fonte de chumbo convertido`,
"chatter.feed.menutype.user.alluser":`Todos os Colegas`,
"UG_Forcast_04":`Iniciar o julgamento`,
"label.appupload.upload.tips.profile":`Nota: o componente "perfil" foi adicionado a este pacote e não pode ser adicionado novamente (é permitido adicionar até um componente de perfil por pacote).`,
"lable.PowerProcess.leave.the.process":`{describeName} Processo de Saída`,
"template.report.sales.cycle.opportunities":`Duração do Ciclo de Vendas (Por Tipo de Oportunidade)`,
"vue_label_calendar_please_fill_in_the_calendar":`Preencha por favor o nome do calendário`,
"label.salescloud.unit.wanyuan":`unidade ( Yuan chinês)`,
"label.fileAPI":`Nome Único do Documento`,
"label.weixin.link":`Relacionado com`,
"label.service.seconds":`segs`,
"label.encd.visible":`Campo encriptado visível`,
"label.tianyancha.regstatus":`Estado de funcionamento`,
"label.event.moveup.18hour":`18 horas à frente`,
"label.upper.bound":`Limite superior`,
"label.please.insertURL":`Por favor, introduza o URL a ser inserido.`,
"label.approval.notallowed.reject":`Recusa não permitida`,
"label.permission.fieldpermission":`Definições de permissão de campo`,
"label.customcomponent.page.index.title":`Componentes personalizados`,
"label.quickbooks.viewlist.number":`NÃO.`,
"lable.list.queue.sendemail":`Enviar Email aos Membros`,
"label.productsales.today.noevtadd":`Não há eventos abertos, pode clicar em " " no canto superior direito para adicionar um novo evento.`,
"label.report.line.daixuan":`Coluna de relatório pendente`,
"label.reportsSubscription.select.start.endtime":`Por favor, seleccione a hora de início e de fim!`,
"template.chart.schdyscb":`Custo Orçamentado das Campanhas`,
"label.sendemail.chat.addPostatsubject":`Fui mencionado no CCC da CloudCC que micropost`,
"label.RelatedList":`Listas relacionadas`,
"label.knowledgebase.delete.translation.associated.with.draft":`Os projectos de tradução existentes serão ligados à última versão publicada do artigo de língua principal. Se não existir uma versão publicada, todas as traduções serão eliminadas.`,
"vue_label_chatter_submitted_review":`Apresentou um pedido de adesão, por favor aguarde que o administrador reveja`,
"label.layout.list2":`Lista 2`,
"label.manage.area":`Gerir Territórios`,
"label.manageapproveprocess":`Gerir Processos de Aprovação para`,
"workflow.action.tasks.assignortype.created":`Criado por`,
"label.custombutton.nonsupport.operation":`A versão actual não suporta o funcionamento de botões e ligações padrão.`,
"label.ip":`Endereço IP`,
"label.chat.topic.desc.error.info":`A descrição do tema não pode exceder 1000 caracteres. Tente usar uma descrição temática mais curta.`,
"label_tabpage_cue":`Lembrete de informação`,
"label.integrations.mailchimp1":`Ao integrar o CloudCC com o MailChimp, os seus utilizadores poderão importar leads e contactos seleccionados da sua conta CloudCC para o MailChimp.`,
"label.email.track.required":`Informação necessária`,
"label.set.case":`Por favor, defina primeiro o proprietário do caso.`,
"label.weixin.newspaper.coverage.number":`Número da Ficha de Risco`,
"vue_label_approve_submitreason":`Motivo da apresentação`,
"message.oppdt.noenabledpricebook":`Sem Livros de Preços Activos`,
"label.partner.workspace.setup":`Definições`,
"label.version.nonsupport.feature":`Esta funcionalidade não é suportada temporariamente. Se necessário, por favor actualize a versão CloudCC.`,
"com.cloudcc.login.error.message.licenseexpired":`A licença expirou`,
"label.emailsync.form.signin":`Login`,
"label.campaign.channel.input.to.chooselanguage":`Por favor seleccione uma língua`,
"label.tabpage.gotit":`Já o tenho`,
"front-console-no-contact-tip":`Sem dados. Favor contactar a pessoa relevante e visualizar.`,
"label.approval.apiname":`O nome único utilizado pelos pacotes API e Managed deve começar com letra, e utilizar apenas caracteres alfanuméricos e sublinhados. Os nomes não podem terminar com um sublinhado ou ter dois sublinhados consecutivos.`,
"label_emailtocloudcc_filed_ssl":`Ligação segura`,
"component_sendmail_label_fromuser":`Remetente`,
"front-kefu-moudle-v1-new-online-chats":`Novo Agente Online`,
"label.searchlayout.merge.duplicated.results":`Permitir encontrar duplicados e fundir-se`,
"label.weixin.input.maxlength.remark":`Por favor, introduza aqui, até 500 caracteres`,
"component.telerecord.label.related":`Artigos relacionados`,
"label.note":`Notas`,
"message.duplication.label.nletters":`personagens`,
"label.productsales.payment.phb":`Lista de pagamentos`,
"label.forecast.editshrepage.desc":`Previsão:Especificar a partilha deste registo. Pode partilhar este registo e dados relacionados com um utilizador, os utilizadores numa determinada função, ou os utilizadores numa determinada função, mais todos os utilizadores em funções abaixo dessa função.`,
"vue.dashboard.setPenetrationSuccessful":`Conseguir estabelecer a penetração!`,
"label.tabpage.noOperationz":`Este conteúdo é um item fixo e não pode ser operado!`,
"label.email.jump":`Redireccionar para um sítio web de terceiros...`,
"label.appointmentpage.wizard.btn1":`Confirmar Reserva`,
"label.umeng.approval.pass":`#approver aprovou o seu pedido de aprovação #obj.`,
"label.project.hit.twelve":`Lembrete de Expiração de Marco Marco`,
"two":`Dois`,
"label.approvedinfo":`Informação de Aprovação`,
"label.import.step1.choosecsv":`Por favor seleccione o ficheiro csv`,
"vue.please.select.the.expansion.method":`Por favor, seleccione a forma de expansão.`,
"UG.homepage.005":`Inteligência de vendas`,
"Account.News.Setting.003":`Configurações Gerais`,
"label.quickbooks.button.actions":`Acções`,
"lable.list.queue.email":`Email de fila`,
"label.name.lastname":`Sobrenome`,
"message.confirm":`Tem a certeza?`,
"Opportunity.Detailed.Phase.Label.Popup.002":`Data de encerramento do Estágio Actual`,
"label.knowledge.setting.title":`Definições de Conhecimento`,
"label.helptocreateprocess":`Para Criar um novo processo de aprovação, clique em "Create New Approval Process" (Criar novo processo de aprovação) e depois seleccione "Use Jump Start Wizard" (Utilizar o Assistente de Início de Salto) para configurar o seu processo de aprovação em alguns pequenos passos. Ou, seleccione "Use Standard Wizard" para configurar todas as opções de aprovação.`,
"label.batcheditor.remark":`Podem ser editados vários registos.`,
"label.page":`Página`,
"label.newfolder":`Criar Nova Pasta`,
"label.version.interceptor.api":`Interface API`,
"label.sms.toaddress":`recebeu um SMS`,
"front-kefu-moudle-noopen-callcenter":`A organização não activou a função de call center, por favor contacte o administrador`,
"label.data.exp.zip":`Formato de compressão`,
"lable.account.LastcDays":`Últimos 60 dias`,
"label.import.index.starttime":`Tempo estatutário`,
"label.dashboardall":`Todos os Dashboards`,
"label.create_socialpost":`Novo posto`,
"label.searchlayoutedit.remark":`Seleccione os campos e botões apresentados ao clicar na pesquisa da barra lateral na página inicial ou clique na pesquisa do separador.`,
"message.servicecrew.violation":`Violação da atribuição de recursos: os recursos de serviço são membros da equipa neste período.`,
"label.email.attrach.file":`Anexo`,
"report.label.folderandreport":`Relatórios e Pastas`,
"label.list.userinterface.sales.setup":`Configuração da página inicial de vendas`,
"label.martrixreport.2018.step1":`Passo 1 Criar um agrupamento`,
"label.campaignmember.selectmember.memberstatus":`Estatuto de Membro da Campanha`,
"label.textmessage.vonage.api.key":`Chave API`,
"label.tabpage.next":`Próximo Passo`,
"UG_Lead_006":`Visitante do website`,
"label.salescloud.salesdashboard.visit.rankings":`Visitar Rankings`,
"label.myevent":`Os Meus Eventos`,
"label.activity.history":`História`,
"label_tabpage_kanban":`Configuração do painel de visualização`,
"label.weixin.allapp":`Todos os aplicativos`,
"label.query.clone.detail.choose.choosed":`Itens de linha seleccionados`,
"message.error.view.errvalid":`Erro: O campo de nome único de visualização só pode conter sublinhados e caracteres alfanuméricos. Deve ser único, começa com uma letra, exclui espaços, não pode terminar com um sublinhado, e não pode conter dois sublinhados consecutivos.`,
"label.customfields.searchrelation.dependobject.tip":`Seleccionar outro objecto associado a este objecto`,
"label.appointment.wizard.subtitle4-4-3":`3 semanas`,
"label.setup.mobile.offlinecache.saveerror":`A configuração da cache móvel offline não é guardada.`,
"label.planned.started":`Iniciado em`,
"label.page.step4.of.step5":`Passo 4 de 5`,
"label.tabpage.value":`Valor`,
"label.reportlist.allfolder":`Todas as Pastas`,
"label.callcenter.sure.disable.center":`Tem a certeza de desactivar o call center actual?`,
"vue_label_commonobjects_detail_activity_tocalendar":`Ir para Calendário`,
"label.setup.mobile.bottombutton.recovery.default":`Restaurar o Default`,
"label.appointmentdetail.wizard.title15":`Plano de terça-feira`,
"label.icon.15":`Ordem de reparação`,
"component_sendmail_label_touser":`Para`,
"template.report.all.owner":`Proprietário de Leads`,
"front-Partner-email-tips":`Por favor introduza o email para o nome de utilizador`,
"vue_label_systemSettings_mobelhomepagesetting":`Configuração da página inicial da aplicação móvel`,
"label.service.newBuildDialog.aswellas":`e`,
"label.name":`Nome`,
"label.tag.search.taglist":`Lista de etiquetas`,
"label.partnerCloud.priceOfManual.theOnly":`Recomendase a criação do único livro de preços para cada utilizador parceiro. Ou não podiam escolher um de vários livros de preços durante a encomenda. O livro de preços padrão é aplicado se não tiver sido definido um livro de preços específico.`,
"label.knowledge.field.update":`é alterado de {2} para {3}.`,
"label.emailobject.save":`Guardar`,
"label.top.changeVersion":`Horizontal`,
"label.recordtype.edit.unselected":`Valores Existentes`,
"label.knowledgebase.additional.articles":`Anexar Artigo`,
"label.lead.score.confirm":`Por favor, seleccione o intervalo de pontuação, clique o botão [Lead Scoring] e o sistema pontuará os resultados seleccionados de acordo com a Regra de Pontuação activa.<br>>br> Isto pode demorar vários minutos. Receberá um e-mail de confirmação uma vez concluído.<br>>br>>br>`,
"label.projectManagement.pleaseselectadate":`Por favor seleccione a data`,
"label.appointment.wizard.subtitle5":`Nome da reunião`,
"label_setup_failed":`Configuração falhou`,
"label.chatter.collect":`Favoritos`,
"label.appointment.cancelappointment":`Cancelar`,
"front-console-response":`Tempo de resposta`,
"message.delete":`Tem a certeza de que quer apagar?`,
"label.dataimport.type.selected":`Seleccionar o tipo de importação`,
"label.new.target":`Novo Indicador`,
"vue_label_report_autoupdatepreview":`Prévisualização da actualização automática`,
"label.knowledgebase.guidance":`Orientação`,
"label.chatter.mail":`Correio`,
"label.login.verification.scan.code.acquisition":`Código de digitalização a obter:`,
"label.customsetting.changefieldtype":`Mudar tipo de campo`,
"label.data.dataexpalltype.all_desc2":`2. Demora algum tempo a exportar todos os dados. Quando a exportação estiver concluída, receberá um email de lembrete de que a exportação de dados foi bem sucedida.`,
"label.opportunity.contactisnull":`Nenhuma informação do cliente, não pode ser exibida.`,
"pagecreator_layout_button_upload":`Esquema de Upload`,
"label.dashboard.noRecord":`Sem Registos`,
"label.SMS.template":`Nome do modelo de SMS`,
"label.c.d.without":`Os registos C podem ou não ter registos "D" relacionados.`,
"UG.Case.05":`Criar um caso`,
"front-epwechat-module-v1-edit-selfapp":`Editar aplicação criada pela Sefl`,
"label.role.createrole.tip":`Pode construir sobre a hierarquia de papéis existente mostrada nesta página. Para inserir uma nova função, clique em <b> Adicionar Função</b>.`,
"label.grouping":`Grupo Por`,
"vue_label_email_upload_new_file":`Carregar novo ficheiro`,
"label.notification.event3":`O seu evento 【事件名】 começa em 【开始时间】`,
"labe_benchmark_objects":`Objecto de referência`,
"component.chatter.button.collect":`Favoritos`,
"front-QBtoCC-sinchronies":`Sincronizar...`,
"message.submitpage.sms":`Parabéns. SMS enviados com sucesso.`,
"label.imgfield.width":`Largura`,
"label.send_email":`Enviar notificações de submissão por email para`,
"label.queue.list":`Lista de filas de espera`,
"label.tabpage.fieldoptions":`campo tipo de registo, campo lista de opções, e campo lista de opções (escolha múltipla). recomenda-se introduzir no máximo 10 palavras-chave, separadas por vírgulas para conseguir "ou relação", como por exemplo: "Nova Iorque, Toronto, Tóquio".`,
"component.chatter.post.button.save":`Publicar`,
"chatter.group.groupDescriptionInformation":`Descrição do grupo`,
"label_setup_mobilesetup_isenableh5newandedit":`H5 na sua aplicação móvel.`,
"lable.Confirm.recallpotential.customers":`Confirmar para reciclar {num} leads.`,
"label.knowledge.setting.hint.seven":`Seleccione um nome entre os seguintes e conceda acesso por escrito para contribuir com os seus esforços.`,
"label.emailtocloudcc.redmessage2":`Por favor introduza a palavra-passe correcta da sua conta de e-mail`,
"message.validation.equalTo":`Introduzir os mesmos valores.`,
"vue_label_help_golbal":`Navegação global`,
"vue_label_chatter_delete_group_title":`Eliminar grupo`,
"label.user.login.success":`Login Sucesso de Login`,
"label.chatham.standard.time":`Tempo Padrão de Chatham`,
"label.vlidaterule.example.percent":`A percentagem de desconto não pode exceder 30%.`,
"label.group.field":`Especificação do campo de agrupamento`,
"label.trigger.operation.sharetab":`Formulário de Acções de Disparo Partilhado:`,
"label.mobile.phone.write.month.report":`Notas de Trabalho Mensais`,
"label.statusofconvers":`Estado convertido`,
"label.version.emailtemplate.track":`Modelo de e-mail`,
"label.customobjects.onlytrackforupdate":`Rastrear apenas alterações`,
"label_tabpage_enterviewname":`Passo 1 por favor introduza o nome da vista`,
"label.processsetting.three.enable":`Passo 3: Activar`,
"label.service.show.more.info":`Mostrar mais informações`,
"front-epwechat-module-v1-input-iosschema":`Por favor introduza o esquema iOS`,
"label.dataimport.datatype.error":`Erro de tipo de dados, verificar cuidadosamente se os dados e o título correspondem um a um.`,
"label.staticresource":`Recurso estático`,
"label.weixin.customize":`Personalizar`,
"label.product.edit.sel":`Editar Seleccionado`,
"label.appointmentpage.wizard.notif5":`Formato de telefone inválido`,
"label.marketsea.basicsetup":`Configurações básicas`,
"label.workflow.supplyintruduce":`1.Critérios que fazem correr a regra do fluxo de trabalho.<br/> 2.Acções imediatas que executam quando um registo corresponde aos critérios. Por exemplo, o CloudCC pode enviar automaticamente um e-mail que notifica a equipa da conta quando é criada uma nova oportunidade.<br/>3.Acções dependentes do tempo que fazem fila quando um registo corresponde aos critérios, e executam de acordo com os desencadeadores do tempo.`,
"label_report_line_tuozhuai":`Por favor, arraste e solte, ou faça duplo clique para seleccionar a coluna do relatório e ajustar as suas ordens`,
"label.add.new.rule":`Adicionar Regras da Nova Geração`,
"label.marketing.setting2":`Configuração`,
"vue_label_chatter_delete_some_group":`Tem a certeza que quer apagar o grupo "{groupInfoList}"`,
"label.appupload.uploading.wait":`Por favor aguarde`,
"label.linecondition.error":`Erro de condição da linha, descoordenação do tipo de campo!`,
"chatter.group.request":`Pedido`,
"label.recordtype.tabname.remark":`Utilize esta página para criar e manter tipos de registos para a sua organização. Pode exibir diferentes layouts de página e valores de listas de selecção com base em tipos de registos. Para utilizar tipos de registos, adicione o campo Tipo de Registo aos layouts da sua página.`,
"setup_mainpage_label_welcome4":`Instruções: Clique no menu do lado esquerdo da página → Application Settings → Create → Object.`,
"vue_label_salesadvance":`Fase de vendas antecipadas`,
"vue_label_campaign_of_existing_campaign_members":`Por favor, defina o estatuto dos membros da campanha existentes`,
"label.report.object.detail.no.permission":`O tipo de relatório é alterado ou movido. Por favor contacte o administrador para obter ajuda.`,
"label.weixin.untreated":`Aberto`,
"label.service.miniProgram.bindSetOwnerDesc":``,
"label.autoassigntoapprover":`Atribuir automaticamente ao(s) aprovador(es).`,
"label.marketseamemset.containself":`Contém registos auto-construídos`,
"vue_label_report_drill":`Broca`,
"label.order.products.to.assets":`Converter produto de encomenda em activo`,
"label.recordtype.list":`Tipo de Registo Existente`,
"lable.outlook.detail.conflict":`Comportamento de Conflito`,
"pagecreator.page.label.layoutpreview":`Pré-visualização do layout`,
"front-kefu-moudle-v1-zxltyhxzc-buyuser":`O chat de agentes é apoiado pela Easemob. Por favor, compre primeiro uma conta Easemob.`,
"label.convers":`Converta`,
"serviceappointment.worktype.isnot.father.worktype":`O tipo de trabalho associado ao seu registo parental deve ser seleccionado para esta nomeação de serviço.`,
"lable.tianyancha.h5.relatedcom":`Empresas Relavant`,
"label.reportsSubscriptionPage.schedulereport":`Relatório do calendário`,
"label.workbanch.setup.showinworkbanch":`Exibição na minha bancada de trabalho`,
"label_emailsync_connectaccount":`Ligar conta de e-mail`,
"label.usermanage.license.not.qualified":`O sistema detectou que se trata de uma licença de não conformidade, por favor contacte o vendedor para obter novamente a licença!`,
"component_setup_label_displayfield":`Campo de visualização`,
"setup_layout_label_buttonarea":`Área de Botões`,
"label.weixin.input.content":`Por favor, introduza o conteúdo`,
"label.operatedata.importsuc":`Se a importação for bem sucedida, pode verificar o resultado da importação clicando no separador do objecto.`,
"label_tabpage_yes1z":`Sim1`,
"front-electronic-signature-describe":`Acesso à assinatura electrónica, assinar um contrato em qualquer lugar e em qualquer altura. Assine com um clique, seguro e eficiente!`,
"label.event.this.month":`Este Mês`,
"label.document.replaces":`Substituir`,
"label.email.cc":`Cc`,
"chatter.feed.sticker":`Rastreamento de alimentação`,
"vue_label_commonobjects_view_chart_notice_pleaseaddchart":`Por favor, adicionar gráfico`,
"label.cpq.main.quote.transfer.order":`Apenas a cotação primária pode gerar ordens.`,
"label.partnerCloud.partnerAccount.topUpSuccess":`Completar com sucesso`,
"label.appexchange.uninstallpage.uninstall":`Desinstalar`,
"label.campagin.roi.channel":`Canais`,
"label.multilang.versioncontrol.checkversion":`A sua versão actual do CloudCC é {0} o que lhe permite criar {1} {2} que atingiram o limite! Se necessário, por favor actualize a versão CloudCC!`,
"label.emailobject.my.template":`Apenas os meus modelos`,
"label.edittimetrigger":`Edição do Disparador de Tempo`,
"label.setup.mobile.homepageshortcuts.saveerror":`As definições de funções rápidas da página inicial móvel não são guardadas.`,
"label.address.street":`Rua`,
"label.workflow.estimatecondition2":`criado`,
"label.wei.expiresdate":`Data de expiração`,
"label.quickbooks.viewlist.date":`DATA`,
"label.page.select.field.type":`Seleccione o tipo de campo`,
"label.tabpage.mypotentialcustomers":`As minhas pistas`,
"label.file.library.editlib":`Editar Libray Details`,
"label.weixin.message.operateexception":`Pronto`,
"label.visualpage.staticresource.p1":`1.Método de chamada.Refira os recursos estáticos seleccionados referenciando os botões de recursos estáticos`,
"label.icon.175":`Bilhetes de avião`,
"chatter.edit.r":`Escreva um comentário...`,
"label.examinationandapproval.flow":`Processos de Aprovação`,
"label.mr.descreption.reDataList5":`conjuntos de dados.`,
"label.edit.field.select.showstyle":`Estilo de exposição`,
"label.reportsSubscriptionPage.condition.and":`E`,
"label.please.associations":`Por favor, escolha o objecto associado.`,
"label.service.dispatchingUnits.displays.service.appointments":`Mostrar compromissos de serviço que não estão associados a uma região`,
"label.addcurrent":`Adicionar Existentes`,
"label.search.change":`Personalização de objectos pesquisáveis`,
"message.schedulejob.error.modify":`Com base num horário configurado, o trabalho em questão nunca será accionado. Verificar os dados e reapresentar.`,
"label.chatter.sendEmailToGroupMember.subject.L":`{0} links publicados para todos em {1}`,
"label.weixin.micro.oldid":`ID original da conta oficial do WeChat`,
"label.employees.only.invitation.code":`O sistema irá gerar um código de convite único para o funcionário, que pode ser utilizado para fazer convites e pode ser contado como desempenho individual. Note-se que o proprietário principal será o actual proprietário da campanha de marketing ou do canal de marketing de convite. Pode realocar os leads através das regras de atribuição de leads. Para regras de alloacation`,
"lable.PowerProcess.event.msg":`É possível acrescentar acções de fluxo de trabalho dependentes do tempo que ocorrem em cada etapa (marco) no processo de concessão de direitos. Por exemplo, pode configurar acções para enviar um e-mail ao proprietário do caso uma hora antes de uma etapa expirar, ou para actualizar automaticamente campos de casos específicos quando a primeira resposta a uma etapa é completada.`,
"label.file.share.email.content2":`Pré-missão: #sharerole`,
"label.querydetailservice.datalayout.notexist":`A disposição correspondente do registo não existe.`,
"label.group.items":`Item de grupo`,
"label.istouse":`Disponível em`,
"front-electronic-signature-explain":`Fadada Esignature Description:`,
"label.partner.template.thumbnail":`Miniatura`,
"registration.page.selected.fields":`Campos obrigatórios da página de registo`,
"label.reportTypeCategoryLabel":`Fonte de dados`,
"vue_label_email_You_have_not_activated_the_mailbox":`Não activou a caixa de correio`,
"lable.SalesCommitmentKanBan.taskCompletionRate":`Taxa de conclusão da tarefa`,
"label.forecast.detailforecast.program":`Artigos de previsão`,
"label.page.display":`Mostrar`,
"label.passwordPolicy.setup.minute":`acta`,
"label.emailtocloudcc.step1total3":`Etapa 1 de 3`,
"label.file.title":`Título`,
"label.callcenter.private.key":`Chave secreta de acesso privado`,
"com.cloudcc.login.error.message.loginerror":`A sua identificação ou a sua palavra-passe está incorrecta`,
"UG_Lead_004":`Formulário Web`,
"label_tabpage_recordsz":`Registo`,
"label.shangqing.discovery":`Descoberta de Informação Empresarial`,
"vue_label_notice_change_success":`Mudou com sucesso`,
"label.ems.other":`Outros`,
"loading":`Carregamento...`,
"label.committedtoapprove":`Os Pedidos de Aprovação Submetidos`,
"label.category.4":`Financeiro`,
"template.report.folder.customer.situation":`Análise da situação das contas`,
"label.quickbooks.searchresault.phone":`Telefone`,
"label.ccpeak.ccobj.save":`Para guardar o CCObject na base de dados, o método de chamada é`,
"label.knowledge.delete.linked":`Erro ao apagar o artigo associado`,
"label.forecast.settings.future2":`Futuros 2 ciclos`,
"message.error.displaytype.detail":`Tipo de exibição não pode estar vazio, Dia: dia, Mês: mês, Semana: semana, Disponibilidade: disponibilidade!`,
"front-template-V1-search-template-name":`Introduza o nome do objecto e encontre`,
"label.sendsms.batch.step3.introduce":`Actividades de armazenamento de cada SMS`,
"UG.Forcast.08":`Passo anterior`,
"label.inputnameandintro":`Introduzir nome e descrição`,
"label.redistributioned":`Reatribuído`,
"label.service.dispatchingUnits.left.right.total":`{esquerda}-{direita} registos , {contagem total} registos no total.`,
"label.projectManagement.Pleaseentertheactualworkinghours":`Por favor, introduza as horas de trabalho reais`,
"label.exporttemplate":`Exportar o modelo`,
"label.data.downpage":`Página de descarregamento de dados`,
"message.please.choose.contact":`Por favor seleccione um contacto`,
"message.error.dataformat.error":`Erro de formato dos dados`,
"label.customsetting.changefieldtype.losevalue":`A mudança para o tipo de dados seleccionado causará a perda de todos os dados existentes no campo.`,
"label.sendemail.chat.chattype":`O tipo de posto principal:`,
"label.ccdocument.upload.error":`Documento de carregamento de erros.`,
"label.quickbooks.view.all":`Todos`,
"label.data.downpage.e_title":`Passos para a exportação de dados`,
"lable.data.lock":`Os dados estão bloqueados, se precisar de editar, por favor desbloqueie-os primeiro.`,
"label.locked":`Bloqueado`,
"label.customfields.beforedeletedata":`A fim de preservar um registo de dados para referência futura, executar uma exportação de dados antes de eliminar campos personalizados, clicando em Setup | Data Management | Data Export.`,
"label.productsales.oppor.noapproach":`Sem oportunidades com uma data de contrato prevista inferior a 30 dias`,
"label.input.notmore.than.number":`Por favor introduza um número menor ou igual a {0}.`,
"label.list.userinterface.isenable":`Activar a edição em linha`,
"label.listofshare":`Partilhar Lista de Informação`,
"label.emailsync.status.role":`Papel`,
"label.staticresource.useful.realtion":`Onde é que este recurso estático é utilizado`,
"label.sharerule.tip":`Esta página mostra as definições de partilha da sua organização. Estas definições especificam o nível de acesso que os seus utilizadores têm aos dados de outros.`,
"label.qrcodelogin.message.expired":`O Código QR expirou`,
"label.marketing.setting3":`Definição de Canais de Marketing`,
"vue_label_statistical_field":`Campo estatístico`,
"message.view.addtomyhomepage":`Adicionar à minha página inicial Workbench`,
"label.customfields.percent.tip":`Permite aos utilizadores introduzir um número percentual, por exemplo, "10" e adiciona automaticamente o sinal de percentagem ao número.`,
"component_newrecords_label_10records":`10 registos`,
"Lead_Scoring_Warning_001":`Marcar um único registo de chumbo automaticamente ao criar ou editar. Mas é necessário pontuar manualmente vários registos de chumbo, ao importar ou criar por interface.`,
"label.project.planing":`Despacho Homemhora VS Reportado Homemhora neste Ano`,
"label.data.exp.pwdverif":`As palavras-passe são permitidas apenas para letras e números.`,
"coderules.notEnable":`Por favor contacte o administrador para activar as regras de geração de código QR e código de barras.`,
"label.weixin.wdyj.jxhk":`Vendas-Pagamentos de Performance-Pagamentos de Vendas Pessoais`,
"label.data.expnode.e_desc3":`3. Template Create: o utilizador pode fazer o modelo de acordo com os campos e condições que serão exportados para satisfazer as suas necessidades, o que é conveniente para usar na próxima vez.`,
"chatter.group.join":`Junte-se a`,
"vue_label_systemSettings_monitoring":`Monitor`,
"front-kefu-moudle-v1-yesorno-delete-folder":`Tem a certeza de que vai apagar esta pasta?`,
"label.exchange.sync.state.info":`Verificar o estado do sistema para assegurar que os registos estão sincronizados entre o Exchange e o CloudCC.`,
"lable.outlook.mcto.emaildes":`Introduza todos os endereços de e-mail de contactos e contactos que utilizou para enviar e-mail, e separe-os por vírgulas. apenas o e-mail enviado a partir do endereço de e-mail abaixo pode ser adicionado ao Histórico de Actividades se os registos relacionados.`,
"label.ems.save":`Guardar`,
"vue_label_dashboard_maximumvalue":`Por favor introduza o valor máximo`,
"label.passwordPolicy.setup.norestriction":`Sem restrições`,
"label.multilang.customforcast.total":`Acumulação de {0}：`,
"label_partner_all_memo":`A lista mostra todas as nuvens de parceiros na sua organização. clique em url para iniciar sessão.`,
"Account.News.Setting.002":`Utilize as definições de conta abaixo para especificar o comportamento padrão da conta para a sua organização.`,
"label.essential":`necessário`,
"label.nonotice":`Sem mais lembretes`,
"vue_label_calendar_calendar_deleted_successfully":`Calendário apagado com sucesso`,
"message.huanxinagent.disable":`Agente inactivo`,
"label.goto":`Saltar para`,
"label.chat.topic.add.favorite":`Acrescentar aos Favoritos`,
"label.trigger.targetobj":`Objecto alvo`,
"label.form_fields":`Campos do formulário`,
"this.month":`Este Mês`,
"vue_label_homepage_select_view":`Seleccionar Ver`,
"label.weixin.input.subject":`Por favor preencha o assunto`,
"label.ems.emailType":`Tipo de caixa de correio`,
"vue_label_file_safe_type_file":`Favor confirmar que o ficheiro não contém informação sensível. Por favor, considere a partilha de ficheiros com utilizadores ou registos específicos`,
"label.version.case.automatic.upgrade":`Regras de Escalação e Atribuição de Casos`,
"label.input.invalid.credit.card.number":`Por favor introduza o número válido do cartão de crédito`,
"component_timeline_label_future":`Próximo Passo`,
"label.emailtemplate.cannotsupporthtml":`Tipo HTML não suportado actualmente`,
"label.appupload.install.error.info2":`{1} {0}' entra em conflito com os componentes existentes.`,
"label.custom.field.maping":`a este campo.`,
"encd":`Texto Encriptado(Mostrar Criptografado)`,
"label.service.newBuildDialog.filter.logic":`Lógica de filtragem`,
"label.customerinfo":`Perfil da empresa`,
"vue_label_applauncher_notice_activepoolsuccess":`Activação bem sucedida da reserva de chumbo`,
"label.partner.workspace.member.choicepermission":`Seleccione o conjunto de permissões`,
"front-gantt-module-this-task-of-other-tasks":`Esta tarefa existe como uma subtarefa e não pode ser uma subtarefa de outra tarefa!`,
"label_chatter_publish":`Publicar`,
"label.forecast.settings.mrfw":`Começando em`,
"label.Named.Filter":`Nome do filtro`,
"label.department.email":`Endereço de E-Mail`,
"label.updatingfield":`Campo a actualizar`,
"label_partner_template_detail":`Descrição da função`,
"front-epwechat-module-v1-unbound-item":` ligação de todas as empresas`,
"vue_label_file_lib_name":`Nome da Biblioteca de Ficheiros`,
"label.notification.arketsea.distribution":`{5} atribuído {2}{0}：{1} a si`,
"vue_label_norm_removecomponent":`remover componente`,
"component.event.label.begindate":`*Tempo de arranque`,
"chatter.note":`comentário(s) recebido(s)`,
"label.forecast.settings.type.all":`Anular Previsão`,
"label.compact.layout.frame.full":`Visualização no ecrã completo`,
"label.approvalstep3intro":`Usando as opções abaixo, especificar o utilizador a quem o pedido de aprovação deve ser atribuído.`,
"label.notification.approval6":`【被委派人名称】approved o pedido de aprovação de 【提交人】 do 【对象】【对象名称】for.`,
"setup.object.field.dependency.label.actionfieldvalue":`Campo de controlo`,
"label.multilang.page2":`Página`,
"vue_label_email_submitted":`Submetido`,
"label.Standard.button":`Botões Padrão`,
"vue_label_report_emailchoose":`Opção de e-mail`,
"page.field.masterinput.list":`Lista de dados de entrada Master-Detail`,
"label.martrixdown":`Matrix Down`,
"vue_label_helpcenter_opportunity":`No canto superior direito da vista, clique no ícone do funil de vendas para saltar para ver o funil de vendas.<br>?através da barra de progresso intuitiva, acompanhar o progresso de cada oportunidade de negócio, e clique no botão para marcar a conclusão da fase actual, ou ajustar a fase actual. Se encontrar obstáculos no avanço das oportunidades de negócio, pode também expandir a barra de progresso para ver a informação e algumas dicas quentes a que se deve prestar mais atenção na fase actual.<br>Através da lista relacionada do grupo de oportunidades de negócio, os dados das oportunidades de negócio podem ser partilhados com outras pessoas que não têm acesso para os visualizar, de modo a facilitar o trabalho colaborativo.<br>Na lista relacionada com o papel do contacto sob a oportunidade de negócio, adicionar rapidamente o papel na oportunidade ao contacto no cliente correspondente, e depois visualizar a relação superior e subordinada do contacto relacionado através da rede de relações, e utilizar o gráfico do radar para avaliar o contacto actual O valor das oportunidades, acompanhar, localizar pessoas-chave, e verificar os contactos. Papel, estado da visita, grau de relação, estilo de compra e tempos de visita<br>Através da lista relacionada de produtos de oportunidades de negócio, é possível adicionar produtos na mesma lista de preços para a oportunidade de negócio, e editar o preço e a quantidade dos produtos.`,
"label.sso.ssoKeyMan":`Gestão de Chaves de Assinatura Única`,
"label.forecast.edit.desc":`Definir a quota de um utilizador para o período seguinte`,
"label.weixin.newspaper.coverage.time":`Data de risco`,
"label.pleaseselectpro":`Por favor seleccione produtos`,
"label.bottonandlink":`Botões e ligações`,
"label.donot.know.error":`Ocorreu um erro desconhecido, por favor contacte o administrador.`,
"label.account_noordab":`A sua conta tem 0 relatórios personalizados e 2 painéis de controlo.`,
"label.partnerCloud.orderingPlatform.toPay":`Pagamento por Fundo Parceiro`,
"label.many.dayline.nextday":`Dia seguinte`,
"lable.showmorerecords":`Mostrar mais`,
"front-lightning-module-v1-details-page-chart-record-type":`Por favor seleccione o tipo de registo`,
"label.ccpeak.query.record":`procurar os registos`,
"pagecreator.systemstyle.message.save.fail":`Salvar estilo falhou`,
"label.weixin.share.file":`Partilhar ficheiro`,
"errormessage.email.relatedorreceivermusthaveone.z":`Deve seleccionar um destinatário ou um assunto relacionado, pelo menos.`,
"chatter.save.f":`Salvar Failed`,
"button.partner.create":`Novo`,
"label.marketseamemset.lead.title2":`É favor estabelecer um limite superior para o número de pistas que afectam todos os membros. O limite não tem nada a ver com a piscina de alto mar.`,
"label.service.major.event.new":`Novo marco miliário`,
"label.version.custom.site":`Site personalizado`,
"label.permission.visualpagepermission":`Páginas Personalizadas Atribuídas`,
"lable.product.zongjia":`Preço total`,
"label.viewchart":`Ver Gráficos`,
"label.alaska.daylight.time":`Horário de Verão do Alasca`,
"front-kefu-moudle-v1-rgdyhcwzx-reply":`Deixar que mais utilizadores se tornem agentes e sirvam os visitantes, melhorar o serviço ao cliente.`,
"component_assistant_label_todaylead":`As pistas que lhe foram hoje atribuídas`,
"label.sendemail.chat.addComentsfavorite":`Caro #nome:\n ; olá! #userName respondeu ao seu post marcado.`,
"label.smstemplate.tip":`Todos os modelos de SMS na pasta seleccionada estão listados abaixo. Clique no botão "Novo" para criar um novo modelo de texto ou HTML SMS. Pode utilizar estes modelos de SMS ao enviar mensagens. Clique no link de funções para ver informações mais detalhadas".`,
"label.documentname":`Nome do documento`,
"label.icon.162":`Paisagem`,
"label.salescloud.wanyuan":`Yuan`,
"label.view.desc1":`Campo de tipo de registo, campo de lista de selecção e campo de lista de selecção ( multi-selecção), recomenda-se a introdução de até 10 palavras-chave, separadas por vírgulas. Tais como "Nova Iorque, Toronto, Tóquio".`,
"label.searchlayout.lookup.newfield":`Diálogos de Pesquisa que aparecem quando se clica no novo botão nos campos de Pesquisa.`,
"label.emailobject.bcc":`Bcc:`,
"label.manageAll.pagenum1":`Esta é a primeira página.`,
"vue_label_appstore_crm_used_companies":`CRM utilizado por empresas cotadas`,
"label.document.replace":`Substituir`,
"label.assignment.setup.newrule.title":`Nova regra de atribuição de casos`,
"component.chatter.label.mygroup":`O meu grupo`,
"lable.currencyAdv.exchangedate":`Intervalo de datas`,
"label.quickbooks.button.viewinqb":`Ver no QuickBooks`,
"UG.homepage.004":`Automação`,
"label.currencyName":`Nome da moeda`,
"Homepage_News_001":`Notícias`,
"front-lightning-module-v1-details-page-chart-refresh-button":`Mostrar botão de Actualização`,
"label.list.projectSetting.isenable":`Activar o temporizador do projecto (incluir: marco, tarefa, sub-tarefa, problema)`,
"setup.layout.message.relatedlistbutton":`Seleccione botões padrão para exibir no`,
"vue_label_homepage_homepageassignment":`Atribuição da página inicial da aplicação`,
"label.pending":`Pendente`,
"component.timeline.label.today":`Hoje`,
"front-kefu-moudle-free-hasexpire":`O seu teste gratuito expirou`,
"homepage.layout.customlayout":`Layout de página personalizado`,
"label.service.miniProgram.content":`Por favor, preencha o conteúdo.`,
"label.defaultline.must.int":`O número padrão de linhas só pode ser inteiros positivos.`,
"label.mirror_issues":`Se o formulário não espelhar o que vê do seu lado, por favor leia o nosso artigo sobre como resolver problemas de exibição comuns.`,
"label.edit.select.two":`Lista de caixas de selecção única`,
"label.emailmerge.mergeFolder.tip":`Os modelos de fusão demoram algum tempo, durante a fusão, por favor não clique em outras ligações, feche o seu navegador ou actualize a página.`,
"label.ServiceCloud.zichan.distributionMap":`Mapa de distribuição de bens`,
"label.selectfile":`Seleccionar Ficheiros`,
"vue_label_account_equitymanage":`Gerir a relação de equidade`,
"label.email.clearAll":`Limpar tudo`,
"label.selecting.parent.assets":`Escolher o bem dos pais`,
"component.setup.tabs.label.delete":`Eliminar`,
"label.visualpage.top.must.is":`A primeira linha do cabeçalho do oage deve ser:`,
"label.SalesCommitmentDashboard":`Painéis de Compromisso de Vendas`,
"chatter.group.changeTheRole":`Mudar o papel`,
"label.dataimport.insertdata.error":`Ocorreu um erro durante a inserção de novos dados. Por favor, verifique estes dados cuidadosamente.`,
"label.partner":`Nuvem de parceiros`,
"label.process.async.execute.tip":`O seu pedido está a ser processado. A aprovação leva algum tempo e o resultado será mostrado na página de detalhes. Por favor, aguarde.`,
"label.service.newBuildDialog.additional.conditions":`Condições adicionais`,
"label.name_copy":`Está prestes a clonar esta forma existente. Por favor, introduza um nome para a cópia.`,
"label.integrations.install":`Instalar`,
"label.edit.ccpeakfolder.time":`Aulas agendadas: Edição de pastas`,
"label.knowledgebase.filing.time":`Tempo Arquivado`,
"vue_label_chatter_success_exit_group":`Sair com sucesso do grupo`,
"font.market.module.v1.save.name":`Por favor preencha o nome da reunião`,
"label.a.b.without":`Os registos A podem ou não ter registos "B" relacionados.`,
"label.chat.topic.desc":`Descrição`,
"label.field.editoptionlist.introduce":`Introduza o nome do valor da lista de selecção.`,
"label.versiontype.Enterprise":`Empresa`,
"message.selectrulecondition":`Pleasse especificar os critérios da regra`,
"label.custombutton.unknown.operation":`Acções inválidas`,
"label.pricecannotnull":`O preço é necessário`,
"component_salesperformance_label_target":`Alvo`,
"pagecreator.page.message.delete.success":`Página apagada com sucesso`,
"label.help.new.features":`Novas características do CloudCC`,
"label.weixin.vehicle.owner.information":`Detalhes do Proprietário do Veículo`,
"label.exchange.sync.state.user.info":`Verificar o estado de sincronização de um utilizador para assegurar que os registos estão sincronizados entre o Exchange e o CloudCC. Se o utilizador tiver um problema de sincronização entre Exchange e CloudCC, pode reiniciar o processo de sincronização. Reinicializa a informação que o CloudCC para Exchange utiliza apenas e não elimina dados do seu servidor Microsoft Exchange ou CloudCC.`,
"label.batcheditor":`Edição em massa`,
"report.label.knowcreatehighlevelreport":`Como criar um relatório avançado?`,
"label.dataimport.title.length":`O comprimento do título é`,
"label_model_description":`Descrição do modelo`,
"label.tabpage.ctbtsftcz":`Clique no verso para pesquisar o conteúdo`,
"label.channel.activity.member.owner":`Proprietário de Membro da Campanha`,
"label.ems.serverinfo":`Informação do servidor`,
"tjinvilid":`Condições ilegais`,
"label.nameofreport":`Nome do relatório`,
"label.ifapproverreject":`O que acontece se o aprovador rejeitar este pedido?`,
"label.wtd.changefields.title.desc2":`Se precisar de um registo na aplicação móvel "Web to CloudCC" para associar um lead, precisa de criar um campo do objecto actual para procurar o lead, e o nome do campo API é " lead_wtd".`,
"label_emailsync_form_connecttime":`Tempo Relacionado`,
"label.visualpage":`Página personalizada`,
"label.customlink":`Ligações personalizadas`,
"label.lead.score.doing.remark":`O seu pedido foi processado e levará um certo tempo para a pontuação de chumbo. e o sistema informá-lo-á por e-mail quando estiver concluído.`,
"label.h5.act.details":`Detalhes da actividade`,
"label.profile.setrecordtype":`Definições do tipo de registo`,
"label.processsetting.process.enabled.successfully":`Habilitar o processo com sucesso!`,
"label.campaign.url.overtime":`A ligação expirou.`,
"label.structureChart.notFiled":`Não Preenchido`,
"label.h5.chatter.something":`Diz alguma coisa`,
"label.pm":`PM`,
"template.chart.rwlx":`Tipo de tarefa`,
"label.icon.42":`Nuvem`,
"label.project.hit.one":`Aviso de atribuição de subtarefa`,
"label.martrixreport.2018.step3":`Passo 3 Escolher cabeçalhos de coluna`,
"label.wtd.changefields.newmo":`Gerar página móvel`,
"label.downloadTheTemplate":`Descarregar modelo`,
"label_chatter_assignPerson":`Pessoa nomeada`,
"label_emailtocloudcc_license":`Licença`,
"label.willdeletedlayout":`Layouts de página que pretende eliminar`,
"label.projectManagement.delete.question":`Todas as informações relacionadas com este assunto serão também apagadas se eliminar este assunto, e os dados não podem ser recuperados. Tem a certeza de confirmar a eliminação?`,
"lable_setup_mobilesetup_isEnableValidationRulesForScan":`Activar Regras de Validação ao utilizar Scan`,
"label.salescloud.opportunity.addandedit.contactrole.note":`Note：double clicar no espaço em branco contacts，can adicionar um registo em branco`,
"label.step6.total6":`Passo 6 de 6`,
"label.knowledge.setting.hint.one":`O conhecimento permite ao cliente e ao pessoal de serviço fazer pleno uso dos artigos de Conhecimento.`,
"label.usefieldautoassign":`Atribuir automaticamente um aprovador usando um campo de hierarquia padrão ou personalizado:`,
"label.partnerCloud.orderingPlatform.orderAmount":`Montante da encomenda:`,
"chatter.fieldtrack.operateupdate":`mudou um`,
"chatter.del.com":`Apagar este comentário`,
"report.reportdatasource.label":`Fonte de dados do relatório`,
"label.text":`Texto`,
"label.marketsea.select.member":`Membros opcionais`,
"label.typeofreceivers":`Tipo de destinatário`,
"label.knowledgebase.affect.existing.translations":`Sim, as minhas modificações irão afectar a tradução existente. Marcar como "Expirado".`,
"label.marketing.invitationmail":`Bem-vindo à nossa actividade, a sua ligação de convite é:`,
"label.version.quotation.management":`Gestão de Orçamentos`,
"label.dataimport.insertdata.error.unique":`$fieldName$ viola as restrições de singularidade ao inserir novos dados.`,
"label.emailmerge.list.newtemplate":`Novo modelo`,
"label.salescloud.salescloud.allteam":`Equipa All Opportunity baseada em todas as Equipas`,
"vue_label_commonobjects_detail_record_changes":`Mudanças nos registos de campo`,
"label.file.delete.info":`Eliminar ficheiros`,
"vue_label_calendar_name":`Nome do Calendário`,
"label.version.support":`Apoio`,
"label.event":`Eventos`,
"label.searchlayout.lookup.searchdialog":`Diálogos de Pesquisa que aparecem quando se clica no ícone de pesquisa nos campos de Pesquisa.`,
"label.data.downpage.e_list.desc2":`Após completar, receberá um e-mail a lembrar-lhe que os dados foram exportados com sucesso.`,
"label.partnerCloud.productSet.delIsTrue":`Quer eliminar este produto?`,
"label.tianyancha.businessverify.msg2":`Este acordo é um acordo entre o utilizador (doravante referido como utilizador) e o CloudCC relativamente à utilização da função de verificação de dados comerciais. este acordo descreve os direitos e obrigações da utilização da função de verificação de dados comerciais e serviços relacionados entre o CloudCC e o utilizador. este acordo pode ser actualizado pelo CloudCC em qualquer altura. os termos actualizados do acordo, uma vez publicados, substituirão os termos originais do acordo sem aviso prévio.`,
"label.customobjects.cancleselectallfield":`Cancelar todos os campos seleccionados`,
"image.up.maxsize":`O ficheiro carregado é demasiado grande, por favor não exceda 2M.`,
"label.icon.8":`Ficheiro`,
"label.donot.delete":`Não tem permissão para apagar`,
"label.version.profile.and.layoutpage":`Perfis e Layouts de Página`,
"chatter.coll.s":`Remover este marcador de página`,
"label.icon.163":`Terra`,
"label_chatter_myfollowers":`Os meus seguidores`,
"label.multilang.customforecast.refuse":`Rejeitar qualquer prioridade preditiva de {0}, mas aceitar prioridade preditiva de outros subordinados`,
"label.tabpage.findz":`Pesquisa`,
"label.smstemplate.detailinfo":`Detalhes do modelo de SMS`,
"label.knowledge.setting.hint.nineteen":`Vamos começar`,
"label.mr.tip":`Por favor, complete as regras na linha {0}.`,
"label.icon.132":`Garantia`,
"label.customobjects.track.introduce2":`Lista relacionada com a história. Sempre que um utilizador modificar qualquer um dos campos seleccionados abaixo, os antigos e novos valores dos campos são adicionados à lista relacionada com o Histórico, bem como a data, hora, natureza da alteração, e utilizador que efectua a alteração.`,
"label_emailtocloudcc_redmessage5":`Desconhecido staus, por favor contacte o administrador.`,
"label.must.select.field":`Erro de condição de linha, é necessário seleccionar um campo.`,
"label.tag.manage.modifiedby":`Última modificação por`,
"label.translation.start1":`Seleccione uma língua (se for um tradutor).`,
"label.ccchat.topic.searchs":`Tópico de pesquisa`,
"label.mask.custom.example":`{AAAA}{****}{AAAAA} representa uma visualização encriptada de quinto a oitavo caracteres.`,
"setup_object_field_dependency_label_addtolist":`Acrescentar os valores seleccionados`,
"label.view.total.record":`Total seleccionado 0 recorde.`,
"label.service.without.right":`Nenhum direito associado`,
"template.chart.wxqzkhyy":`Razões para Leads Inválidos`,
"vue_label_dashboard_pleaseenterabreakpoint1value":`Por favor introduza um valor de ponto de quebra 1`,
"message.pleaseinputmouthdistance":`Por favor, introduza o intervalo de mês válido.`,
"label.forgetPsd.tip":`Esqueça a senha, contacte o administrador.`,
"label.projectManagement.planned":`Agendado`,
"lable.Product.conversion.asset.operation":`Transferir Produto para Bens`,
"label.search_forms":`Pesquisa de Formulários`,
"label.sendemail.chat.addPostmainPagesubject":`Mensagem da página inicial do CloudCC CCChat`,
"label_tabpage_viewNamez":`Por favor introduza o nome da vista`,
"label_chatter_addresser":`Remetente`,
"Opportunity_Detailed_Phase_Change_Text_001":`Estágio de Oportunidades de Mudança`,
"label.what":`Página`,
"vue_label_systemSettings_set_android":`Configurar menus e funcionalidades para Android e IOS para o tornar adequado para utilizadores empresariais.`,
"label.sell":`Venda`,
"template.report.folder.case":`Análise de casos`,
"label.customfields.profilefieldsafety":`Segurança de perfil a nível de campo`,
"label.industrialandcommercialverification.label.token":`Token`,
"label.finished":`Concluído`,
"label.sendmail.step3.introduce1":`Actualmente tem`,
"vue_label_calendar_other_calendars":`Outro Calendário`,
"label.donot.know.validate.field":`Campos de validação inválidos`,
"label.exportdetail":`Detalhes de exportação`,
"label.step.filter":`Especificar as condições do filtro`,
"label.campaignmember.main.hasMember":`Membros Existentes`,
"label.updown.suess":`Descarregar com sucesso`,
"label.ems.browse":`Navegar`,
"front-email-payment-Invoice-login-account-describe":`Clique em "Continuar" para completar o pagamento da factura, digitalizando o código QR de Alipay ou iniciar sessão Alipay.`,
"label.copyCustomReportType":`Clonar Fonte de dados do relatório personalizado`,
"label.visualpage.write.class":`Editar código de classe na página com a mesma sintaxe que Java.`,
"label.setsharerule.tip":`<br>Utilizar regras de partilha para fazer excepções automáticas às definições de partilha à escala da sua organização para conjuntos definidos de utilizadores.<br>Nota: "Funções e subordinados" inclui todos os utilizadores numa função, e as funções abaixo dessa função.`,
"label.report.action.addtodashboard9":`Página de listagem do painel de instrumentos`,
"label.cloudccsite.remark":`Descrição do sítio`,
"label_tabpage_noz":`Não`,
"chatter.up.limit":`O ficheiro carregado é demasiado grande, por favor não exceda`,
"label.leadmarketsea.grouplist.title":`Configurações do Grupo de Líderes`,
"label.pc.user.help":`Guia do Utilizador`,
"label.partnerCloud.orderingPlatform.relyOn":`Dependência`,
"label.appointmentpage.wizard.subtitle2":`Escolha o tempo`,
"label.deleteoneormore":`Eliminar um ou múltiplos`,
"january":`Janeiro`,
"label.delete.profile":`Eliminar perfil`,
"label.appointment.wizard.subtitle1-7":`2 h`,
"label.icon.188":`Cosmética`,
"vue_label_file_already_in_lib":`Já existe nesta biblioteca de ficheiros`,
"label.icon.151":`VR`,
"label.withvalue":`Por Valor`,
"label.tianyancha.businseeverify.opererror":`Falha em abrir dados comerciais. por favor tente novamente ou contacte o seu administrador de sistema!`,
"label.tabpage.individual":`Escolha individual`,
"label.layout.editdistribute":`Editar Atribuição`,
"label.smstemplate.lookup":`Ver o modelo de SMS`,
"pagecreator.systemstyle.button.delete":`Estilo de eliminação`,
"label.customer.tab.step2.same.option1":`Padrão`,
"label.knowledgebase.no.results.knowledge":`Nenhum resultado em Conhecimento`,
"label.data.exp.newtemporexp":`Seleccionar o método em que os dados são exportados ou criar um novo modelo`,
"vue_label_chatter_refuse_join":`Recusar-se a aderir`,
"Homepage.News.002":`A componente de notícias não está actualmente disponível.`,
"label.log.requesttype":`Método de pedido`,
"vue_label_dashboard_generatefromreport":`Gerar a partir do Relatório`,
"label.knowledge.create.version":`Criar Versão`,
"label.emailtocloudcc.description2":`Ligue o seu e-mail`,
"label.partnerCloud.partnerAccount.recharge":`O montante da recarga tem de estar entre 0,1 e {limite superior}.`,
"label.customobjects":`Objectos personalizados`,
"label.schedulableprg.endtime":`A data final deve ser posterior à data actual do sistema`,
"message.error.viewreport.confirmdelete":`Existem gráficos que utilizam a visão/relatório actual como fonte de dados. Deseja também apagar o gráfico?`,
"label.marketing.social.seting":`Configuração de Meios de Comunicação Social`,
"chatter.follow.stop":`Pare de seguir este utilizador`,
"label.notification.arketsea.return":`{5} devolvido {0}：{1} a {2}`,
"label.conditionsofnextapprover":`Há um ou mais aprovadores seguintes especificados no seu pedido de aprovação seleccionado. Utilize a seguinte caixa de pesquisa para especificar o próximo aprovador.`,
"label.partner.all.state":`Estado`,
"mobel_web_closed":`Fechado`,
"label.icon.65":`Equipamento`,
"label.stdashbord.xsld.business.jinehj":`Montante total`,
"label.selectobject":`Seleccionar Objecto`,
"label.account.CurrentFQ":`FQ actual`,
"label.workflow.estimaterule":`Avaliar a regra quando se trata de um registo:`,
"label.list.userinterface.shownewrecordssetup":`Definições de registos recentes`,
"label.tianyancha.businessverify.msg3":`1. taxa`,
"label.weixin..xsld.jieduan":`Palco`,
"label.first.quarter":`Primeiro Trimestre`,
"Opportunity.Detailed.Phase.Label.002":`{0} dia(s) na fase actual`,
"label_tabpage_page":`Página`,
"label_emailsync_status_time":`Hora`,
"label.pleaseselectaapprover":`Por favor seleccione um aprovador`,
"label.emailtocloudcc.redmessage5":`Desconhecido staus, por favor contacte o administrador.`,
"label.four.quarter":`Quarto Trimestre`,
"label_chatter_relateList":`Lista relevante`,
"label.customfields.new.step2.opration.exid.info":`Definir este campo como um identificador de registo único para um sistema externo`,
"label.projectManagement.nodata.overdue.tasks":`Óptimo! Nenhuma tarefa atrasada`,
"label.sendemail.activity.task.statuscompleted":`Caro #criatebyidccname Olá! \A tarefa que atribuiu a #belongtoidccname em #createdate é a seguinte: \Assunto: #sujeito: "Duetime": #expireDateDataData: #expireDateDateDateDateDateDateDateDateDateDateDate #relacionardstr{\n Conteúdo: #Por favor, visite o linkfor para mais detalhes: \Caminho #path\n Por favor note: #belongtoidccname está marcado como concluído. \r\n #orgNameCRM System`,
"label.sso.saml.idp.config.issuer":`Emissor`,
"label.cannot.delete":`itens) não são permitidas a eliminação`,
"label.pigeonhole.sel_f":`Escolha as pastas a arquivar`,
"label.customfields.text.tip":`Permite aos utilizadores introduzir qualquer combinação de letras e números.`,
"message.error.user.service.common":`As operações falharam, por favor contacte o administrador para obter ajuda.`,
"label.datamanage.account.information":`Informação de conta`,
"vue_label_homepage_deleteprofilepage":`Eliminar a página inicial do perfil`,
"label.sendmail.step3.introduce3":`destinatário(s) seleccionado(s) para receber este SMS.`,
"label.pc.ui.2018.recentitem":`Artigos recentes`,
"label.report.loading":`À espera de carregamento`,
"vue_label_globalsearch_adjustment":`Método de ajuste`,
"label_report_line_yixuan":`Coluna de relatório seleccionada`,
"label.h5.similar.opportunity.only.view":`Mostrar apenas`,
"label.marketactivitymember":`Membros da Campanha`,
"label.recycle.execute.tip":`O seu pedido foi processado e levará algum tempo a limpar o caixote do lixo da reciclagem. Será notificado pelo emissário quando estiver concluído.`,
"label.permission.detail.system.setting":`Definições de Permissão do Sistema`,
"label.RecordType":`Tipos de registos`,
"label.custom.error.between":`A Data de Início do Ano Personalizado ou a Data de Fim do Ano Personalizado está entre os anos personalizados do histórico, por favor verifique e reinicie`,
"vue_label_dashboard_selectview":`Seleccionar Ver`,
"label.tianyancha.businessverify.cancel":`Desactivar a verificação de dados comerciais`,
"label.partnerCloud.financeSetting.MD5":`Chave Secreta MD5`,
"label.multilang.messagedetail.new.error":`Não conseguimos encontrar um utilizador de Chat com qualquer nome com {0}:`,
"label.callcenter.pleaseenter.private.key":`Por favor introduza a chave secreta de acesso privado`,
"label.umeng.activity.youdistribute":`Atribuiu a`,
"label.weixin.nickname":`Apelido`,
"label.customerinfo.mailusername":`Email Nome de utilizador`,
"label.partnerCloud.orderingPlatform.discountPlan":`Nome do Programa de Descontos:`,
"lable.account.year":`Ano Fiscal`,
"T":`Hora`,
"System.Email.Template.Title":`Bem-vindo à plataforma CloudCC CRM`,
"label.login.type":`Tipos de Login`,
"label.notification.evaluation":`comentário esquerdo de {0} para o caso {1}.`,
"label.turntolist":`Saltar para Listas`,
"label.sort":`Ordenar`,
"vue_label_commonobject_notice_clickcross":`Se precisar de substituir o ficheiro carregado, por favor clique no botão [X] e carregue novamente`,
"label.Select.maximumecords.operate":`Podem ser seleccionados até 200 registos para processar.`,
"label.submission_rate":`Taxa de submissão`,
"label.datadelete.record.sucessfully":`registo(s) com sucesso!`,
"label.version.standard.dashboard":`Painéis de controlo standard`,
"label.task.postunsolve":`Tarefas em atraso`,
"label.Receivables.name":`Nome do destinatário`,
"label_tabpage_noOperationz":`Este conteúdo é um item fixo e não pode ser operado!`,
"label.attendance.onrecord":`Seleccione pelo menos um registo`,
"label.partner.error2":`Erro: O nome de domínio só pode conter número ou letra.`,
"label.account.map":`Mapa de contas`,
"label.dashboardSetup.reference.legend":`Referência do Diagrama`,
"label.Yaxisscope":`Âmbito do eixo Y`,
"label.hierarchy.tree.tip":`Seleccione um registo no campo de pesquisa de cada separador para criar uma hierarquia. E a hierarquia é a seguinte:`,
"label.permission.objlist.columnsize":`Número total do campo`,
"label.setup.mobile.bottombutton.savesuccess":`Definições de página de primeiro nível guardadas`,
"label.mobile.side.tab.selected":`Já seleccionado`,
"label.partner.donotdel.cause":`Porque tem relacionado com a seguinte nuvem de parceiros`,
"label.ccchat.message.new.error4":`Lembrete:`,
"vue_label_systemSettings_setorganization":`Configure aplicações para a sua organização, personalize diferentes menus para várias divisões funcionais.`,
"label.umeng.approval.approvalmes4obj1":`Favor rever a aprovação a tempo`,
"UG_opportunity_010":`Criar uma transacção`,
"label.tag.addtags.public":`Público`,
"System.TAB.SeeViewPageAmount":`Ver Páginas`,
"label.filterconditions":`Filtro`,
"front-personalEmailBox-module-v12-clear-not-associated":`Cancelar a ligação irá limpar todos os emails não associados, tem a certeza de que irá cancelar a ligação?`,
"label.assign":`Atribuir`,
"label.layout.clone.tip":`Pode seleccionar um esquema existente para clonar`,
"label.choose.relatedlist":`Seleccione a lista relacionada que pretende transferir`,
"label_chatter_recordcall":`Chamada gravada`,
"label.product.proofOne":`Em {0}, por favor escolha até {1} opções de produto.`,
"label.layout.availablefield.relatedlist":`Campos disponíveis / Listas relacionadas`,
"label.campaignmember.main.updateleadstatus":`Actualização de Leads Existentes no Estado`,
"label.custom.buttonandlink":`Botões personalizados`,
"label.view.manage":`Ver Gestão`,
"label.search.exp":`Seleccione os objectos para os quais pretende activar as seguintes características e clique em Guardar:`,
"vue_label_appstore_apply_to":`Aplicar a`,
"label.dashboard.message.refreshfail":`Actualização do painel de instrumentos falhou`,
"UG_Case_02":`Os casos permitem-lhe responder e resolver problemas de contas. Os casos são um poderoso registo na Cloud CC que não só rastreia os problemas de conta, mas também mostra uma visão completa da conta.`,
"label.project.hit.three":`Lembrete diário de subtarefa`,
"label.tianyancha.businessverify.tip":`A função de verificação de dados comerciais é activada para ajudar os utilizadores a introduzir as informações correctas de registo comercial do cliente quando introduzem os dados do cliente empresarial.`,
"label_emailsync_status_disconnect":`Cancelar Conncet`,
"label.rule.disabled.successfully":`Desactivar as regras com sucesso`,
"label.custombutton.queryerror":`A consulta falhou, por favor reabrir.`,
"label.customfields.deletecannotresume":`Os dados correspondentes serão apagados permanentemente e não poderão ser recuperados.`,
"label.account.current.M":`Este Mês`,
"label.under.approve.data":`os registos estão a ser verificados(`,
"vue_label_title_remainingdays":`Restantes dias`,
"label.partnerCloud.orderingPlatform.refundable":`Bônus disponível`,
"label.lookup.iscover":`Permitir a sincronização durante a edição`,
"label.recordtype.detail.selectlist":`Listas de selecção disponíveis para edição`,
"label.sso.isActiveYes":`Sim`,
"label.service.appointmentList.canceltheSuccess":`Cancelado com sucesso`,
"label.escalation.setup.newentries.createfirst":`Quando o caso é criado, e desactivar após o caso ser modificado pela primeira vez`,
"label.new.ccpeakfolder":`Classe : Nova Pasta`,
"lable.currencyAdv.exchagecurrency.after":`e depois de`,
"label.majoranddetailrelation":`Relacionamentos Master-Detail`,
"label.appointment.wizard.subtitle4-2-1":`1 h`,
"label.projectManagement.working.hours":`Horário de trabalho`,
"label.forecast.customforecast.button.forehistory":`História Prevista`,
"label.mymasterplate":`Os meus gabaritos`,
"component.setup.tabs.label.memo":`Definir o nome da etiqueta do separador`,
"label.customfields.longtextarea.tip":`Permite aos utilizadores introduzir até 32.000 caracteres em linhas separadas. Pode criar até 10 campos de texto (longo) por objecto.`,
"label.service.miniProgram.fillJumpLink":`Por favor, preencha o link para o salto.`,
"label.british.summer.time":`Tempo Médio de Greenwich`,
"label.nogreate":`<=Menos que ou Igual`,
"label.assignment.setup.detail.sameuser":`O mesmo utilizador`,
"mesage.error.profile.delate.user":`Impossível eliminar o perfil porque o utilizador é atribuído ao perfil actual.`,
"label.tabpage.cownerz":`Mudança de proprietário`,
"label.multilang.dupicatecheck.processedcount":`Duplicados data，{0} grupos foram treated，{1} grupos de dados não foram treated：`,
"vue_label_report_notice_leavecertification":`Tem a certeza de deixar esta página - os dados introduzidos podem não ser guardados`,
"label.master.required":`Ter campos obrigatórios registos de crianças desaparecidas`,
"label.chatter.follow":`Siga`,
"label.dataimport.insertdata.error.repeat":`O registo duplica os dados na base de dados original e o registo foi ignorado.`,
"label.sms.cgid":`Número da Galeria`,
"label.knowledge.article.rator":``,
"label.datamanage.object.field":`Campos de objectos`,
"label.forecast.editshrepage.quanxian":`Nível de Acesso à Peimissão Partilhada`,
"label.weixin.interactive.log":`Registo de Interacção`,
"label.batchedit.remark":`Editar vários registos`,
"label.user.permissions.message":`Sem permissões para definir a informação do utilizador.`,
"label.mobile.phone.month":`mês`,
"chatter.sel.u":`Seleccione os utilizadores que pretende @ mencionar, ou escreva o nome de utilizador que pretende @`,
"label.service.gantt.assigned.work":`Trabalho Atribuído`,
"UG_ST_001":`Pronto`,
"label.edit.select.one":`Lista de drop-down`,
"label.forecast.shrepage.desc0":`Esta página lista os utilizadores, funções e zonas que têm acesso partilhado a {0}.`,
"label.multilingual.confirm.close":`Tem a certeza de que vai desactivar? Não é possível utilizar o multilinguismo após desactivar e a língua do utilizador será alterada para a língua predefinida.`,
"label.setting.intergrationlist.integration":`Integração`,
"label.leadscore.rule.list":`Lidera a lista de Regras de Pontuação`,
"component_telerecord_button_save":`Guardar`,
"label.weixin.save.log":`Guardar Registo`,
"label.validate.function.funcExplain.DAY":`Devolve um dia do mês, deve introduzir um número entre 1 e 31.`,
"label.appointmentdetail.wizard.title1":`Nome`,
"label.multilang.feedtrack.dealkey":`Modificar {0} de {1} para {2}.`,
"label.optional.features":`Características opcionais`,
"vue_label_email_no_email":`Nenhum e-mail`,
"label.sendemail.chat.messagecontent":`O conteúdo da mensagem:`,
"label.tabpage.lessequalz":`Menos ou igual a`,
"setup.layout.label.setupfield":`Propriedades de campo`,
"label.approved.receiveApprovalEmail.option1":`Se eu sou um aprovador ou aprovador delegado`,
"label.chatter.relateList":`Lista relevante`,
"component.sendmail.label.fromuser":`Remetente`,
"label.projectManagement.problem.status":`Situação da emissão`,
"label.weixin.fmu.before.hour":`{0} hora(s) à frente`,
"chatter.feed.menutype.feed.mark":`Marcado`,
"label.addQuoteLineGroup":`Adicionar Grupo de Linha de Citação`,
"label.report.action.addtodashboard6":`Acrescentar`,
"label.url":`URL`,
"lable.account.CurrentandPreviousCQ":`CQ actual e CQ anterior`,
"label.tabpage.emptyz":`Vazio`,
"less":`Menos do que`,
"label.h5.selectmostphotos":`Podem ser seleccionadas no máximo nove fotografias`,
"UG.activity.04":`Caixa de correio Outlook/Gmail, gravar correio`,
"template.chart.qbhtje":`Todos os montantes de contrato`,
"label.tabpage.endz":`Fim`,
"label.partner.workspace.member":`Membro`,
"label.filter.error.filedvaluetoolong":`Erro: O valor do campo excede o limite máximo.`,
"label.months":`Meses`,
"button.partner.workspace.disable":`Cancelar activação`,
"label.visualpage.checkpinyin.grammar":`Por favor verifique a ortografia e a gramática.`,
"label.dashboardSetup.geshihua":`Formatação`,
"label.belongto":`Pertence a`,
"label.upload.cannot.empty":`Deve seleccionar um ficheiro para carregar.`,
"label.number.MaxCheck":`O máximo de {0} é {1}. Por favor, modificar a quantidade e guardar as alterações.`,
"pagecreator.page.message.save.fail":`Salvar página falhou`,
"label.edit.SMS":`Edição de Notificação SMS`,
"UG_Lead_002":`Há muitas maneiras de identificar "pistas" para o seu produto ou serviço.`,
"label.quickcreate.active.quickcreate":`Activar a Criação Rápida`,
"label.recordtypeselect.tip":`Para saltar este passo no futuro, estabelecer tipos de registos por defeito.`,
"label.form_content":`Formulário`,
"workflow.action.tasks.assignortype.related":`Utilizador relacionado`,
"vue_label_allsearch_set_more_items":`Pode definir mais itens de pesquisa na caixa pendente do lado esquerdo da caixa de pesquisa para continuar a pesquisa`,
"label.tianyancha.businessverify.title":`Verificação de negócios`,
"label.errormessage.batchedit.norecord":`Sem dados.`,
"label.permission.appname":`Nome do aplicativo`,
"label.report.action.addtodashboard7":`Cancelar`,
"label.generated.transfer.product":`Gerar bens de acordo com a forma de Conversão de Bens.`,
"vue_label_commonobjects_detail_you":`Você`,
"label.user.captcha":`Verifique a sua identidade`,
"label.notification.event4":`O evento 【事件名】 que designou para 【被分配人】 começa em 【开始时间】`,
"label.version.setup":`Configuração`,
"setup.object.layout.message.selectedlayoutandrecordtype":`Por favor, seleccione o layout e o tipo de registo`,
"label.role.add":`Adicionar papel`,
"label.versiontype.Unlimited":`Ilimitado`,
"label.partnerCloud.financeSetting.developerID":`Por favor, introduza o ID do programador.`,
"front-invoice-online-payment-setup-global":`Aplicar a Contas Globais`,
"vue_label_commonobjects_view_basis":`Base de classificação`,
"label.decimaldigits.tip":`O número de dígitos à direita da vírgula decimal`,
"vue_label_commonobjects_detail_selected":`Marcar como Estágio Actual`,
"label.data.export.page":`Ir para a página de exportação`,
"message.error.serviceresource.servicecrewid":`Cada tripulação de serviço só pode ser acrescentada como um registo de recurso de serviço do tipo de tripulação.`,
"label.loginttime.alltime":`Todo o tempo é`,
"label.requiredinfo":`Informação Requerida`,
"label.forecast.edit.di":`FY`,
"vue_label_calendar_failed_to_remove_calendar":`Falha em remover o calendário`,
"pagecreator_systemstyle_button_delete":`Estilo de eliminação`,
"label.import.page3.continueimport":`Continuar a importar`,
"label.page.width":`Largura de página completa`,
"label.campaignmember.selectmember.addmember":`Adicionar membros de`,
"label.finalreject":`Rejeição final`,
"label.isend":`Está Acabado`,
"front-console-conversation":`Diálogo`,
"label.mr.theLastGroupOfThisPage":`Este é o último conjunto de dados nesta página. Clique [Voltar à Lista de Dados Duplicados] para ver mais dados duplicados.`,
"label.data.dataexpalltype.all_desc":`Exportar dados de todos os objectos que o utilizador actual tem acesso para ler.`,
"label_emailtocloudcc_redmessage7":`Erro de configuração, por favor contacte o administrador.`,
"label.forecast.shrepage.classdes.all":`Acesso total - Os utilizadores podem visualizar e anular os dados de previsão e alargar o acesso a outros utilizadores através da partilha.`,
"market.contacts":`Contacto no mercado`,
"label.weixin.polls.voter":`Lista de Votados por`,
"template.report.industry.distribution.customers":`Distribuição da Indústria de Contas`,
"front-electronic-signature-setup":`Contrato Infor Preenchimento Automático e Configuração de Preenchimento Posterior`,
"vue_label_chatter_removecertification":`Tem a certeza que quer remover o membro "{nome}"?`,
"label.appointment.wizard.subtitle1-2":`15 min`,
"label.sso.saml.idp.config.custattr":`Atributo personalizado`,
"label_tabpage_totalTeamz":`Um total de grupos`,
"lable.outlook.detail.assigned":`Utilizadores e Perfis Atribuídos`,
"label.department.user.delete":`Eliminar`,
"label.customcomponent.check.label.same":`Este rótulo já existe.`,
"label.partner.error1":`Erro: o comprimento do domínio é demasiado longo`,
"label.escalation.setup.entrydetail.escalation.notify":`Notificar`,
"component_todaytask_label_choicestate":`Seleccione o estado`,
"label.customfields.fielddependency.new.step1":`<b>Passo1: </b> Seleccionar um campo de controlo e um campo dependente. Clique em Continuar quando terminar.`,
"chatter.group.anyoneCanSeeTheUpdateAndJoin":`Todos podem ver e candidatar-se a juntar-se a este grupo`,
"label.custom.pixel":`píxel`,
"label.quicksave":`Salvar rapidamente`,
"label.approved.persion":`Aprovador Delegado`,
"lable.info.queue.member":`Membros em fila`,
"label.addattachment.step2.weixin":`Passo 2 Clique em Upload para carregar ficheiros`,
"label.forecast.customforecast.title":`Previsões`,
"mainpage_setup_chosecomponent_leastone":`Deve seleccionar um componente pelo menos na página inicial.`,
"label.appointmentconfirmpage.wizard.title2":`Foi enviado um convite de calendário para o seu e-mail.`,
"label.useallselectedapprover":`Requer que Todos os Aprovadores Seleccionados <forte>Atupidamente </forte>Aprovado`,
"label.ccpeak.current.line.return":`Volta da linha actual e já não é executado para baixo.`,
"label_new_target_model":`Novo modelo alvo`,
"label.saving":`Salvar...`,
"label.mobile.phone.write":`Escreva`,
"label.applt.updown.text":`Também pode descarregar o código QR de um portal de mini programa dedicado à sua empresa e colocar o código QR dentro de uma página web ou artigo público, e os clientes podem digitalizar o código QR para utilizar o mini programa.`,
"label.partner.common.manageSetup":`Configurações administrativas da nuvem de parceiros`,
"label.quickbooks.new":`Novo Cliente`,
"message.error.color":`a cor não pode estar vazia!`,
"label.project.template.two":`Só pode haver um conjunto de configurações sob cada tipo de registo por objecto!`,
"label.approval.input.des1":`Aprovar ou rejeitar nível por nível, e o nível máximo da hierarquia é:`,
"label.x.axis.cannot.empty":`O eixo X não pode ser nulo`,
"label.solomon.isiands.time":`Salomão é. Hora`,
"label.login.access.duedate":`Duração do acesso`,
"label.service.dispatch.booking.order":`Nomeação de Serviço de Atribuição`,
"label_shareme_forecast":`Previsão partilhada comigo`,
"label.custom.page.cuspage.height":`Altura(Pixels)`,
"label.quote.line.group.":`Tem a certeza de apagar o grupo de linhas de citação do {nome do grupo}? As linhas de citação neste grupo também serão eliminadas após a operação.`,
"label.data.downpage.i_title.num6":`Recomenda-se que importe um ficheiro de teste contendo 5 registos antes de importar os dados, para garantir que os dados que pretende importar estão correctos.`,
"label.\u2019s":`s`,
"label.version.contact.management":`Gestão de contratos`,
"label.document.history.user":`Utilizadores`,
"vue_labenl_commonobjects_opportunity_product_edit_notice1":`Por favor, introduza o montante correcto, até duas casas decimais.`,
"label.weixin.target.contract.jine":`Montante do contrato alvo`,
"lable.common":`￥0 no total`,
"front-kefu-moudle-sendemail-success":`O email foi enviado e o pessoal de vendas entrará em contacto consigo o mais rapidamente possível`,
"label.service.no.operation.time":`O registo actual não tem tempo de operação associado!`,
"label.info":`Informação`,
"label.ccchat.zw":`NOON`,
"label.assignment.setup.newentries.title":`Entrada de Regra Editar`,
"label.weixin.report.timeline":`Data Campo`,
"UG.quota.04":`Imprimir citação`,
"label.social.user.exception":`Cinformação anormal do utilizador social.`,
"label.import.index.failed":`Falha`,
"label.common.settings":`Configurações Gerais`,
"label.nullvalue":`Valor Nulo`,
"PageLayout_Search_MultiSearch_002":`Activar a caixa de pesquisa personalizada (Pesquisa de campo único)`,
"message.myselfreport":`Os meus relatórios pessoais personalizados`,
"label.productsales.today.noevttskaddtsk":`Não há eventos abertos e tarefas em curso, pode clicar em " " no canto superior direito para adicionar nova tarefa.`,
"lable.oppdt.noconditionrecrods":`Sem registos para mostrar`,
"label.campaignmember.selectmember.deletelead":`Campanha: retirar membros das pistas`,
"label.marketingactivity":`Campanhas`,
"vue_label_pool_self-built":`Auto-construído`,
"message.textareamaxlength":`O comprimento g não deve exceder 4000 caracteres`,
"label.valadate.must.value":`Deve introduzir um valor`,
"label.tabpage.groupsVisiblez":`Alguns grupos de utilizadores são visíveis`,
"component.button.cancel":`Cancelar`,
"label.emailobject.list.inbox":`Caixa de entrada`,
"label.app.step1.error.labelexist":`ERROR: Este rótulo já existe ou já foi utilizado anteriormente.`,
"front-calendar-V1-Unable-to-display":`O registo não pode ser exibido no calendário para o campo final de um ou mais registos é anterior ao campo inicial.`,
"label.forecast.settings.prompt1":`Deve seleccionar uma Medida Prevista pelo menos:Receita ou Quantidade.`,
"front-kefu-moudle-callout-missphone":`Chamadas perdidas`,
"label.tabpage.editz":`Editar`,
"vue_label_chatter_label_new_team":`Novo grupo`,
"label.version.formulafield":`Campo de Fórmula`,
"label.partner.step1":`Passo 1 seleccionar modelo`,
"label.weixin.perfect.url":`Introduza os detalhes do URL`,
"label.appointmentconfirmail.wizard.subtitle4":`Descrição`,
"label.step7.total7":`Passo 7 de 7`,
"setup.object.layout.label.selectedprofile":`Perfis seleccionados`,
"label.payments.paytip5":`Por favor, introduza o número correcto de utilizadores!`,
"label.visualpage.open.type":`é aberto estilo de página personalizada`,
"lable.Sort.field.tips":`Personalizar a ordem de gravação na lista relacionada, seleccionando os campos a serem classificados. Pode encomendar com base em quaisquer campos numéricos ou de datas de objectos.`,
"label.nosharerules":`Não são especificadas regras de partilha.`,
"label.service.miniProgram.bindSetOwner":`Proprietário de casos definidos`,
"report_label_highlevelreport":`Relatórios avançados permitem-lhe criar as relações entre até 4 objectos.`,
"S":`Texto`,
"label.lastmodifyby":`Última modificação por`,
"label.customerinfo.mailaddress":`Endereço de correio electrónico`,
"vue_label_pool_converted":`Convertido`,
"UG.ST.004":`Não tem a gestão de dados - "permissão de importação de dados, por favor contacte o administrador, clique em confirmar e vá directamente para a interface {0}.`,
"label.view.application.mobile.terminal.filed":`Este ponto de vista foi aplicado na aplicação móvel. Estão disponíveis um máximo de 10 campos; são seleccionados.`,
"chatter.feed.limitentity500":`Pode seguir 500 colegas e registos.`,
"label.starttime":`Início`,
"chatter.emailToMe":`Lembra-me quando alguém:`,
"label.custom.Current.and.PreviousCQ":`CQ actual e CQ anterior`,
"label.my.logout":`Eu`,
"label.quickbooks.searchlist.enddate":`Data de fim`,
"label.ccservice.validate.length":`O comprimento do valor correspondente {2} do campo {1} sob o objecto API {0} é excedido. Por favor, reinicie-o!`,
"label.integrations.installed":`Instalado`,
"label.integrations.mailchimplist":`Lista Mailchimp`,
"label.checkfield.matchothers":`Combinar Outros Registos`,
"label.umeng.activity.event.distributewillbegin":`O evento #evento que atribuiu ao #nome começa em #tempo.`,
"pool.notice.gotolightning":`Por favor, vá ao Menu Relâmpago se quiser utilizar esta funcionalidade.`,
"label.batchtransfer.pleaseselecttransferreddata":`Seleccione os dados que pretende transferir`,
"label.mr.title.mailingAddress":`Endereço de correio`,
"vue_label_approve_no_response":`Sem resposta`,
"component.event.label.title":`Próximos eventos`,
"label.mobile.setup.confirm":`Está a alterar a localização do ícone do separador predefinido na aplicação móvel. Após a alteração ser bem sucedida, toda a configuração anterior do ícone do separador móvel será apagada, terá de reiniciar o ícone do separador utilizado na aplicação móvel. Se não seleccionar, o sistema irá seleccionar aleatoriamente no seu catálogo de definições.`,
"label.tianyancha.approvaltime":`Data de aprovação`,
"label.download_merge_file":`Descarregar ficheiro fundido`,
"label_display_quota":`Mostrar Quota`,
"label.publishreadonly":`Apenas leitura pública`,
"label.campagin.roi.query.roi":`ROI da campanha`,
"label.dashboardSetup.lookup":`Encontrar Painéis`,
"vue_label_notificationcenter_nomessages":`Sem mensagens não lidas`,
"label.create.object":`Criar objecto`,
"label.social.campaign.null":`A informação do Campagin não pode estar vazia`,
"label.console.step6.left":`Fixados à esquerda e as listas são sempre visíveis.`,
"label.line":`Coluna`,
"label.bottonandlink.introduce":`Aqui está uma lista de botões e links. Adicionar botões ou ligações, por favor editar layout.<br/>Buttons and links can be added to the detail page, related list and list view.<br/>`,
"label.layout.list1":`Lista 1`,
"label.mr.title.customerName":`Nome da conta`,
"label.user.text":`Texto`,
"label.nolastestrecord":`Sem último registo`,
"label.emailobject.appointment.urltext1":`Ver a minha agenda e`,
"label.chat.topic.my.favorites":`Marcado`,
"label.select.dashboar.cd0":`O campo de agrupamento não pode estar vazio`,
"label.data.downpage.e_title.num2":`2. Se optar por exportar dados de um único objecto, terá de seleccionar como os dados são exportados: exportação personalizada, exportação por modelo e modelo de exportação.`,
"message.error.user.service.login.unconn":`Rede ocupada, tente novamente ou contacte o administrador.`,
"label.escalation.setup.newentries.title":`Entrada de Regra Editar`,
"label.import.step1.above2000":`Quando o gatilho é executado, um máximo de 2000 registos pode ser importado de cada vez. Por favor dividir em vários ficheiros e importá-los em lotes.`,
"label.ccchat.person.allowinvite":`Permitir que os colegas convidem`,
"label.input.number.between":`Por favor insira um número entre {0} e {1}.`,
"label.forecast.shrepage.wpfmanager":`Gestor de Previsões Delegado`,
"label_server_is_time_out":`O servidor está sem tempo. Por favor, tente novamente mais tarde.`,
"label.indochina.standard.time":`Hora Padrão da Índia`,
"label.cpq.quote.sync.opportunity.failure":`Apenas a citação primária pode ser sincronizada com a oportunidade. Por favor, marque a caixa da citação primária, depois comece a sincronizar.`,
"label.emailobject.send100emails":`Desculpe, só pode enviar 100 emails por dia, por favor re-selecione!`,
"label.dashboard.snapshot.end":`A partir de`,
"label.jiandangfenpei.rightlist":`Perfis Atribuídos`,
"label.input.string.length.between":`Introduza um fio de comprimento entre {0} e {1}.`,
"label.multilang.lookfiltercondition.select":`A condição da linha {0} é incorrecta. É necessário seleccionar um campo!`,
"label.datamanage.lead.namenull":`Nota: Se o nome do ficheiro de chumbo for nulo, o registo não será importado.`,
"label.forecast.detailforecast.button.saveandfresh":`Guardar`,
"label.venezuela.time":`Hora da Venezuela`,
"label.same.analyze.miaoshu1":`Se precisar de mais regras, use por favor "`,
"label.twomb":`Apenas ficheiro jpg/png é permitido carregar com um tamanho máximo de 2MB.`,
"label.event.moveup.7hour":`7 horas à frente`,
"label.weixin.forgot.password":`Esqueceu-se da sua senha?`,
"label.import.page1.diledsizelimited":`2. O tamanho máximo de ficheiro permitido é de 100M`,
"label.file.foldername":`Nome da pasta`,
"label.multilingual.open":`A gestão de multilangiospecção está activada.`,
"label.dashboard.snapshot.refresh.failed":`Actualização do painel de instrumentos falhou`,
"label.marketsea.memberfieldselectone":`Ver campos e os membros podem ver campos Por favor seleccione pelo menos um campo`,
"label.trigger.createdate":`Data de criação`,
"label.ccpeak.operation.sharetab":`Operar na forma de partilha:`,
"label.partner.message.admin.access":`Só os administradores podem entrar no sistema`,
"label.emailsync.status.email":`E-mail com acção executada`,
"chatter.error":`Erro:Por favor seleccione um ficheiro para carregar!`,
"label.role.viewinlist":`Mostrar em vista de lista`,
"label.tag.addtags.title":`Tag`,
"setup.mainpage.label.welcome6":`Os utilizadores podem criar vários tipos de campos em todos os objectos do sistema CloudCC sem qualquer conhecimento de programação ou desenvolvimento de código. Os tipos de campos incluem: relação de pesquisa, campo de selecção única, selecção de itens duplos, fórmula, numeração automática. , URL, telefone, fax, e-mail, caixa de verificação, data, hora, número, texto, área de texto, lista de opções (selecção simples/múltipla), moeda, etc.`,
"label.delete.rule.successfully":`Eliminar as regras com sucesso`,
"label.field.duplicate.error.msg6":`Valor do campo duplicado. O valor sai em registo:`,
"label.stdashbord.xsld.business.jhzsl":`Oportunidades totais (Quantidade)`,
"label.compact.layout":`Layout de informação chave`,
"label.checkfield.merge.introduce":`Seleccione o valor que pretende manter no registo resultante da fusão.`,
"earlieststarttime.duedate.time.illegal":`A hora real de início da marcação do serviço deve ser inferior ou igual à hora real de fim.`,
"label.dataimport.validate.prompt":`Pronta Regra de Validação`,
"message.setuptip":`Pode apagar os pacotes que criou.`,
"template.report.customer.collection.statistics":`Estatísticas de pagamento de contas`,
"vue_label_homepage_dashboardcomponents":`Editar componentes do painel de instrumentos`,
"setup.mainpage.label.welcome30":`A plataforma CloudCC é uma verdadeira plataforma de computação em nuvem. Os atributos abertos da plataforma, métodos de integração padrão, e personalização flexível são aplicáveis a todas as indústrias, integrando software de terceiros, realizando a unificação em tempo real dos dados de gestão empresarial, e maximizando as necessidades de gestão abrangente e profunda dos nossos clientes. A plataforma CloudCC pode ser integrada com qualquer aplicação ou sistema empresarial, incluindo software de terceiros, tais como SAP, Kingdee, e UF. O método padrão de Web Service sob a arquitectura SOA flexível não tem nenhuma dependência destrutiva, técnica ou de fornecedores bloqueados.`,
"label.SMS.new.det":`Criar uma notificação por SMS para associar uma ou mais regras de fluxo de trabalho, processos de aprovação. Se a notificação por SMS for alterada, quaisquer alterações são aplicadas a todas as regras e aprovações a ela associadas.`,
"lable.product.page.previous":`Voltar ao Anterior`,
"label.recordtype.labelname":`Etiqueta de tipo de registo`,
"message.error.system.service.failure":`A execução do serviço falhou, por favor contacte o administrador.`,
"label.visualpagefolder":`Pastas de página`,
"label.username":`Nome de utilizador`,
"label.data.downpage.i.title.num5":`5、Please verificar a exactidão dos dados.`,
"label.permission.manage":`Gerir Atribuições`,
"label_emailsync_status_user":`Utilizadores`,
"label.weixin.voting.least.two":`Há pelo menos duas opções de votação.`,
"label.tabpage.thisrecord":`Este registo`,
"label.icon.119":`Quadro negro`,
"label.partner.common.webSit":`Domínio`,
"label.email.form.html2":`[mudar para apenas texto].`,
"label.appupload.upload.noversion":`Sem versões carregadas`,
"label.appointmentpage.wizard.subtitle1_2":`O Fuso Horário do Inviter é {0}`,
"MR":`Relação de Procura (Multi-Select)`,
"label.partnerCloud.orderingPlatform.availableBalance":`Saldo disponível`,
"label.schedulejob.setup.schedule.st3":`A 3ª`,
"label.reportsSubscriptionPage.email.general":`Geral`,
"label.setsharerule.step4":`Passo 4 Seleccionar o nível de acesso para os utilizadores`,
"front-epwechat-module-v1-info-desc":`Por favor, obtenha informações do backend da WeCom e preencha aqui`,
"message.duplication.label.isactive":`Activo`,
"pagecreator_systemstyle_label_linkcolor":`Cor da ligação`,
"label.import.page1.alertfiledsize":`Os ficheiros carregados não devem exceder 100MB!`,
"tomorrow":`Amanhã`,
"label.publicdashboard":`Painéis de Painel Público não arquivados`,
"label.knowledgebase.same.taborworkspace":`O mesmo separador ou espaço de trabalho`,
"homepage.layout":`Layouts da página inicial`,
"label.emailobject.trackemailopening":`Rastrear a Abertura de Email`,
"label.unlock.tip":`Desbloquear os registos para edição`,
"lable.account.NextzDays":`Próximos 90 dias`,
"vue_label_report_throw":`Descartar`,
"label.icon.102":`Horário`,
"label.payments.paytip2":`Actualizou para a nossa edição paga, clique em Confirmar para fechar a janela e actualizar o seu sistema CRM.`,
"label.customfields.email.tip":`Permite aos utilizadores introduzir um endereço de correio electrónico, que é validado para garantir um formato adequado. Se este campo for especificado para um contacto ou lead, os utilizadores podem escolher o endereço ao clicar Enviar um Email. Note-se que os endereços de correio electrónico personalizados não podem ser utilizados para correio electrónico em massa.`,
"label.test_visitors":`Teste como deve ser o seu formulário quando visto pelos visitantes.`,
"label.workflow.immediatelyoperate":`Acções de Fluxo de Trabalho Imediato`,
"label.approvalstep4.tip":`A página de aprovação é onde o aprovador realmente aprova ou rejeita o pedido. utilize as seguintes opções para seleccionar os campos a exibir nesta página.`,
"label.ccchat.person.invite.failsend":`O convite seguinte não foi enviado. por favor contacte o administrador.`,
"label.import.index.obj":`Objecto`,
"label.multilang.leadscore.countnum":`{0} vezes:`,
"label.report.error.typefind":`Nenhum tipo de relatório encontrado por agrupamento de informação`,
"label.validate.function.funcFormat.SUBSTITUTE":`SUBSTITUTO(texto, antigo_texto, novo_texto)`,
"label_tabpage_unpacketz":`Não há dados de agrupamento disponíveis!`,
"lable.Create.new.template":`Novo modelo de relatório de serviço`,
"label.knowledgebase.display.error":`Mostrar {a} Erros`,
"label.emailobject.template.message2":`O campo inserido no e-mail actual não corresponde ao registo associado, o que pode causar valores nulos.`,
"label.productsales.today.taskcomplete":`Preparar para completar`,
"label.emailobject.selectone":`Por favor seleccione pelo menos um registo como destinatário do e-mail`,
"button_partner_workspace_saveas_memo":`Guardar a actual nuvem de parceiros como "modelo".`,
"vue_label_help_detail":`Detalhes do registo`,
"label.tabpage.minutesagoz":`Acta`,
"label_tabpage_characterz":`Carácter inicial`,
"message.error.accesstoken.null":`O Token não pode estar vazio!`,
"label.textMessageObject.send100":`Desculpe, só pode enviar 100 mensagens de texto por dia, por favor re-selecione!`,
"vue_label_commonobjects_detail_record_call":`Registar uma chamada`,
"label.campaignmember.main.addlead":`Adicionar Leads Existentes de Membros`,
"setup_mainpage_label_welcome30":`A plataforma CloudCC é uma verdadeira plataforma de computação em nuvem. Os atributos abertos da plataforma, métodos de integração padrão, e personalização flexível são aplicáveis a todas as indústrias, integrando software de terceiros, realizando a unificação em tempo real dos dados de gestão empresarial, e maximizando as necessidades de gestão abrangente e profunda dos nossos clientes. A plataforma CloudCC pode ser integrada com qualquer aplicação ou sistema empresarial, incluindo software de terceiros, tais como SAP, Kingdee, e UF. O método padrão de Web Service sob a arquitectura SOA flexível não tem nenhuma dependência destrutiva, técnica ou de fornecedores bloqueados.`,
"label.file.library.deleteprompt":`Remover {0} da Biblioteca de Bens ?`,
"label.wtd.changefields.title":`Configuração da Web para CloudCC`,
"label.sendmail.step1":`Passo 1 Especifique os destinatários a incluir`,
"label.cpq.newquote.createorder.checkbox.selected":`A caixa de verificação de Criar Ordem não pode ser seleccionada durante a criação de uma nova cotação.`,
"label.emailtocloudcc.name":`Nome`,
"message.error.object.nullbinding":`a encadernação está vazia`,
"B":`Caixa de verificação`,
"label.pc.endtime":`A sua licença expirará em menos de 30 dias. por favor renovar a tempo para assegurar a continuação da utilização.`,
"label.visualpage.section.start":`Use a etiqueta no início`,
"label.partnerCloud.basicSetting.available":`O nome de domínio está disponível.`,
"label.data.exportall.all_desc":`Exporta todos os dados para todos os objectos que o utilizador actual tem permissão para ver.`,
"label.editor.layout":`Editar layout de pesquisa`,
"label.send.chatter":`Enviar tagarelice`,
"label.h5.chatter.reply":`A resposta rápida`,
"component_chatter_post_button_file":`Acrescentar anexos`,
"label.emailobject.emaildetail.button.reply":`Resposta`,
"label.eidt.queue.title.desc":`O nome deve ser único, e o nome deve implorar com uma carta. Deve conter apenas letras maiúsculas e minúsculas, números, e sublinhado. Não deve ter mais de 40 caracteres.`,
"label.campaign.channel.input.url":`5.estabelecer a informação que os utilizadores verão após a inscrição, que pode ser uma página de agradecimento, um folheto ou um bilhete:`,
"label.compact.layout.assign.tip":`Esta tabela mostra as principais atribuições de layout de informação para diferentes tipos de registos.`,
"vue_label_fall":`Descer`,
"label.trigger.save.failed":`Salvo falha, os dados não podem ser nulos`,
"label.appupload.upload.tips.report":`NOTA: Os relatórios e relatórios antigos em "Os meus relatórios personalizados" e "Relatórios públicos não arquivados" não podem ser adicionados aos pacotes e não serão exibidos nesta pasta".`,
"label.tianyancha.businessverify.rewriteall":`Preencher todos os dados`,
"label.campaign.channel.step6.remark4":`Note-se que, o proprietário principal pode ser o proprietário da campanha actual ou a pessoa de solicitação do actual canal de marketing.`,
"front-kefu-moudle-called-num":`Número marcado`,
"label.approvalstep4":`Passo 4 Seleccionar os campos a exibir no layout da página de aprovação`,
"label.login.verification.please.scan":`Por favor, digitalize o código utilizando a aplicação AMF no seu smartphone`,
"label.invoice.message.statusupdated":`Estado das facturas actualizado`,
"label.pc.ui.2018.subject":`Tema`,
"label.area.notexist.userinfo":`O Grupo de Utilizadores não existe.`,
"label.newuser":`Novo Utilizador`,
"label.chat.micropost.share":`Partilhar o posto`,
"label.locatedupcurrentvalue":`O valor acima do actual`,
"vue_label_systemSettings_course":`Configuração do trajeto do relâmpago`,
"chatter.group.public":`Público`,
"label.reportsSubscription.entrance":`Subscrever`,
"front-kefu-moudle-v1-online-at":`Agente Online`,
"label.rejectbehaviourselect":`Executar <forte>simplesmente</forte> a rejeição desta etapa e enviar o pedido de aprovação de volta ao aprovador mais recente. (Voltar à etapa anterior)`,
"vue_label_commonobjects_view_currentviewset":`Para cancelar a definição da vista padrão actual, pode definir outra vista como a vista padrão.`,
"lable.currencyAdv.and":`e`,
"label.appexchange.installedpage.publish":`Publicado por`,
"label.tab.profile.ismobile":`Aplicar à aplicação móvel`,
"label.data.setok.t.desc2":`Voltar à página do modelo de dados`,
"label.email_required":`O email é obrigatório.`,
"label.tabpage.fullscreenz":`Ecrã inteiro`,
"chatter.sticker.set":`Rastreamento de alimentação`,
"label.mobile.phone.year":`ano`,
"label.projectManagement.next.page.before":`Página anterior`,
"pagecreator_button_pcpage":`Pc fim`,
"label.dashboard.xsld.percent":`Porcentagem`,
"label.ccpeak.service.checkerror":`Falha na verificação da sintaxe.`,
"label.icon.26":`Pasta`,
"label_partner_common_webSit_memo":`Nome de domínio predefinido:`,
"label.unselectfile":`Nenhum ficheiro seleccionado`,
"label.take.notice":`Aviso`,
"message.error.filename.null":`fileName não pode estar vazio!`,
"vue_label_SMS_nophone":`Sem número de telefone`,
"label.area.assignuser":`Atribuir Utilizadores`,
"label.icon.176":`Pronto`,
"label.icon.21":`Moeda`,
"message.error.system.service.deletedeny":`O Dada está associado e não pode ser apagado.`,
"label.compact.layout.main.tip":`Seleccionar a disposição da informação chave a utilizar quando este registo aparece como um item de lista no CloudCC.`,
"label.emailtocloudcc.delete":`Eliminar`,
"label.dashboardSetup.showdw.d2":`10 Milhões`,
"front-kefu-moudle-hqyyjlsb-admin":`Não conseguiu obter gravação de voz, por favor contacte o administrador para obter ajuda`,
"label.partnerCloud.basicSetting.userCounts":`Papéis totais do parceiro`,
"front-kefu-moudle-calling-num":`Número de chamada`,
"label.alldocument":`Todos os documentos`,
"coderules.nullvalue1":`Falha de geração. Por favor introduza o valor para 【{0}】 utilizado nas regras de geração.`,
"lable.automatically.shared":`Partilhado automaticamente`,
"label.batchadd.newbatchpage.save.emptyselect":`Por favor, verifique se existem opções obrigatórias não seleccionadas.`,
"vue_label_homepage_card_30dayswithout":`Oportunidades não contactadas durante 30 dias`,
"label.multilang.dupicatecheck.onegroupnote":`Escolha pelo menos dois dados, clique no botão [Load selected information] para entrar na página de combinação de dados. Actualmente no grupo de dados {0}--empresa,há um total de {1}records. :`,
"UG.activity.03":`Reservar um horário`,
"label.pc.oldpage":`Página antiga`,
"label.exchange.sync.state.task.m2":`Os registos foram sincronizados nos últimos 60 minutos:`,
"label.setmovable":`Definições de actividades`,
"label.sendemail.send.loginfail":`Falha no login na caixa de correio, por favor reinicie a sua informação de correio electrónico.`,
"label.copy.quote.lines":`Linha de citação clone`,
"label.copying.reward.to.groups":`Cópia para grupos de linhas de citação`,
"label.ems.connect.error":`Falha na ligação do servidor,verifique por favor.`,
"lable.account.Tomorrow":`Amanhã`,
"label.manageAll.sta2":`Aprovado`,
"label.create_form":`Novo formulário`,
"label.ems.saveDetail.error.msg":`Salvar falha.por favor verificar conta e senha da caixa de correio`,
"label.service.gantt.distribution.recommendation":`Atribuição Sugerida`,
"label.email.track.attachment.size.control2":`O tamanho do ficheiro carregado excede 10m,e não pode ser carregado`,
"lable.product.pricebooks.add":`Acrescentar ao Livro de Preços`,
"label.login.time":`Tempo de Login`,
"label.tabpage.yes1z":`Sim1`,
"label.SalesCommitmentKanBan":`Painéis de Compromisso de Vendas`,
"label_partner_workspace_myspace":`O meu espaço de trabalho`,
"chatter.like":`como(s) recebido(s)`,
"lable.PowerProcess.number.input":`Por favor, introduza um número inteiro.`,
"chatter.coll":`Favoritos`,
"label.campaign.channel.img.remark":`Observação: O tamanho da imagem não deve exceder 2M`,
"label.field.duplicate.error.msg7":`Dados duplicados`,
"vue_label_pool_discard":`Descartar`,
"label.service.gantt.total.planned.duration":`Soma da duração prevista para as nomeações de serviço`,
"label.weixin.click.loadmore":`Clique para carregar mais`,
"label.help.new.features.yd":`Novo guia de operação de interface para telemóvel`,
"label":`Etiqueta`,
"label.quickbooks.viewlist.total1":`Existem {0} facturas de um valor total de {1}`,
"front-kefu-moudle-v1-input-publicKey":`Por favor introduza a chave partilhada`,
"label.approval.allowed.reject":`Recusa Permitida`,
"label.visualpage.folder.notdel":`Não se pode apagar esta pasta, porque alguns ficheiros nela contidos.`,
"label.projectManagement.charging":`Carregamento`,
"label.ccservice.validate":`O formato do valor correspondente {2} do campo {1} sob o objecto API {0} está incorrecto. Por favor, introduza o número correcto!`,
"message.unbind.mfadevice.no.permission":`Não tem perimensão para destravar dispositivos de AMF. Por favor contacte o seu administrador.`,
"label.partner.new.step3.meno":`Não tem a certeza do que deve entrar? não se preocupe, pode alterá-lo mais tarde a qualquer momento.`,
"label.import.page3.importsucceedtip":`Comece a importar com sucesso. Após a importação, será enviado um e-mail para a sua caixa de correio associada`,
"label.customsetting.visible.protect":`Protegido`,
"label.publishreadandwrite":`Leitura/escrita pública`,
"vue_label_file_add_most_once":`Adicionar no máximo uma vez`,
"label.salescloud.teamrole.optionlist.group":`Atribuir funções aos membros da equipa de oportunidade e aos membros da equipa de conta.`,
"label.appointment.wizard.subtitle7":`Localização`,
"label.task.dateminus":`Menos`,
"label.data.exp.zippwd":`Introduzir manualmente Senha de ficheiro comprimido`,
"UG_Forcast_09":`Próximo passo`,
"message.duplication.label.allselectlink":`[Seleccionar tudo]`,
"label.file.ccchat.selectfromcloudcc":`Seleccione um ficheiro do CloudCC`,
"label.ems.addaccount3":`Adicionar conta`,
"front-epwechat-module-v1-schedule-sync":`Horários de Sincronização`,
"label.h5.manage":`Gerir aplicações`,
"setup.layout.label.nobutton":`Sem botões disponíveis`,
"label_component_hotdeal":`Negócios escaldantes`,
"template.dashboard.contract.analysis":`Análise de Contratos e Contas a Receber`,
"vue_label_dashboard_editcomponent":`Componente de edição`,
"label.quotationInformation":`Informação sobre a citação`,
"label.data.file.validation_rules":`Executar Regras de Validação`,
"label.ccpeak.construction.shareobj":`Para construir uma forma de partilha objecto de um objecto, é necessário passar no nome da API e na marca de partilha.`,
"label.wei.pollinformation":`Pormenores da Micro Votação`,
"label.quickbooks.viewlist.total3":`Existem {0} pagamentos para um valor total de {1}.`,
"label.paging.totalofpagesnoid":`Um total de {0} páginas`,
"label.unlock":`Desbloquear`,
"front-invoice-online-payment-information":`Informação sobre facturas`,
"label.permission.systempermission":`Permissões de Sistema Atribuídas`,
"message.error.object":`Quando se chama um serviço, verifica-se que o objecto não está definido.`,
"font-trade-module-v1-invoice-intro":`Por favor introduza o número da factura ou o nome da factura`,
"label.userinfo.pwdexpired":`A senha actual expirou. Por razões de segurança, deve alterar a sua palavra-passe agora.`,
"label.userphoto.photo":`Foto`,
"label.tabularreport.filterrecord":`Seleccionar os critérios tge para determinar quais os registos a exibir`,
"label.partnerCloud.orderingPlatform.rechargeIt":`O saldo da sua conta não é suficiente, por favor, complete o formulário.`,
"label.icon.120":`Computador`,
"label.projectManagement.select.new.type":`Seleccione o tipo de criação`,
"vue_label_commonobjects_detail_customer_details":`Carregamento de dados do cliente`,
"label.ems.status":`Estado`,
"label.validate.function.description":`Qualquer função que esteja em conformidade com a sintaxe java pode ser usada na regra de validação, e a expressão precisa de devolver um valor booleano.<br>Pode também usar uma função específica fornecida pelo CloudCC.
Por exemplo, isNew(),isChanged(FieldAPIName__c),priorValue(FieldAPIName__c),priorValue() retorna um objecto, este precisa de ser convertido para o tipo de campo correspondente.`,
"label.escalation.setup.newaction.step2":`Etapa 2 Seleccionar o utilizador para auto-reatribuir casos`,
"label.forecast.customforecast.searchforecast":`Encontrar a previsão`,
"label.the.upper.bound.of.each.level.of.block.pricing.must.be.greater.than.the.lower.bound.":`O limite superior de cada nível deve ser maior do que o limite inferior ao fixar os preços por blocos.`,
"vue_label_commonobjects_view_notice_deletefailreason":`Não apagar dados com id de registo {0}，failed razão: {1};`,
"page.field.masterinput.remark":`O Master-Detail Input activado é utilizado para criar registos de lista relacionados na página de separadores.`,
"lable.SalesCommitmentKanBan.contractName":`Nome do contrato`,
"front-gantt-module-add-milestone":`Adicionar Marco`,
"label.callcenter.save.error":`Por favor não volte a salvar`,
"label.workflow.selectobj":`Passo 1 Seleccionar objecto`,
"label.validate.function.category.all":`-- Todas as categorias de funções...`,
"label.multilang.uploadifupage.select":`Escolheu totalmente os ficheiros {0}:`,
"label.weixin.dragsort":`Arraste os ícones nas Minhas Aplicações para os ordenar.`,
"N":`Número`,
"label.knowledge.article.translation.completed":`Tradução do artigo concluída`,
"label.weixin.myapp":`As minhas aplicações`,
"label.icon.138":`Moeda`,
"vue_label_chat_create_discussion_now":`Criar discussão agora`,
"label.knowledge.recover.article":`Restaurar Artigo`,
"label.ccpeak.use.class.time.map":`Acesso por Passagem na Colecção de Mapas`,
"front-email-payment-error-tips":`Erro de interface`,
"label.service.gantt.ziyuan":`Apenas para`,
"label.upload.error":`Falha`,
"label.staticresource.upload.error":`Erro no carregamento de recursos estáticos!`,
"com.cloudcc.login.error.message.loginfail":`A operação falhou, por favor contacte o administrador`,
"pagecreator_button_back":`Último Passo`,
"label_tabpage_skip":`Saltar para`,
"label.pw.old":`Por favor introduza a palavrapasse antiga`,
"pagecreator.layout.label.modifylayout":`Editor de layout`,
"vue_label_chatter_share_group":`Partilhar com o grupo`,
"label.app.edit":`Edição App`,
"label.user.Email.repeat":`Duplicar o email. Este utilizador não é suportado para encadernação com agente`,
"label.field.quilt":`Este campo é`,
"label.projectManagement.Groupuser":`Agrupamento por Utilizadores`,
"label.deleteall":`Apagar tudo`,
"label.appexchange.download.tiaoguo.mes":`Ignorar a instalação dos seguintes componentes conflituosos:`,
"label.sendemail.recycle.operatehello":`#username hello:\r\n`,
"label.emailmerge.mergeFolder.max20templates":`Pode seleccionar até 20 modelos!`,
"label.campaignmember.main.deleteleaddesc":`Retirar em massa todas as pistas desta campanha`,
"Opportunity_Detailed_Phase_Label_Popup_003":`Dias no Estágio Actual`,
"vue_label_file_no_title":`Sem título`,
"label.data.dataexpalltype.all.desc":`Exportar dados de todos os objectos que o utilizador actual tem acesso para ler.`,
"label.dashboard.unit2":`Unidade: milhões`,
"label.list.userinterface.isrelatedlist":`Habilitar Links para a Lista Relacionada Hover`,
"label.role.tree":`Hierarquia de papéis da sua organização`,
"label.campagin.roi.zcsl":`Inscrição`,
"message.error.forecast.setupchange":`Os dados a que tentou aceder puderam ser encontrados no bot. Poderiam ser apagados por outros utilizadores ou alterados.`,
"label.sendemail.changeowner.dataname":`O nome do documento é: #dataname ficheiro`,
"label.salescloud.opportunity.contactrole.optionlist":`Papéis de contacto de oportunidades Valores da lista de selecção`,
"setup_mainpage_label_welcome1":`Necessidade de permissão correspondente`,
"UG_activity_02":`Atribuir tarefas`,
"label.tabpage.erraddressz":`Formato incorrecto do endereço de correio electrónico, por favor introduza correctamente o endereço de correio electrónico`,
"label.weixin.nicheng":`Apelido WeChat`,
"label.forecast.settings.mrsz":`Medição Prevista`,
"label.campaign.channel.download.size3":`Tamanho pequeno: 300*300 pixels`,
"label.icon.73":`Máquina-ferramenta`,
"label.ServiceCloud.suoxuchanpin":`Produtos Necessários`,
"label.escalation.setup.newrule.description":`Introduza o nome da regra e active-a. A activação desta regra desactivará a regra de escalonamento do caso actual. Para desactivar o escalonamento automático de casos, desactivar todas as regras de escalonamento de casos.`,
"label.data.import.setup.whichfield.cloudccid":`CloudCC ID`,
"label.validate.function.funcExplain.PRIORVALUE":`Devolve o tipo de objecto, o tipo de campo correspondente precisa de ser convertido.`,
"Lead.Scoring.Warning.001":`Marcar um único registo de chumbo automaticamente ao criar ou editar. Mas é necessário pontuar manualmente vários registos de chumbo, ao importar ou criar por interface.`,
"label.tianyancha.businessverify.msg9":`O poder de interpretação do presente acordo será investido na beijing shenzhou yundong science and technology co., ltd.`,
"label.compact.layout.tip":`O esquema de informação chave é utilizado para exibir o campo chave dos detalhes do registo na página de detalhes.`,
"label.visualpage.btype":`Relatórios`,
"label.textmessage.vonage.settings":`Definições`,
"label.field.not.exites":`não existe`,
"label.payment.switch.version":`Mudança para a nova edição`,
"label.ems.hour":`Hora`,
"label.weixin.cannot.edit":`O tipo de ficheiro não pode ser editado`,
"chatter.pt.limit":`O tamanho máximo do ficheiro é`,
"label.quote.detailinfo.add":`Adicionar Itens de Linha de Citação`,
"component.setup.label.displayfield":`Campo de visualização`,
"vue_label_report_reportfolder":`Pasta de relatório`,
"label.gbkencoding":`Chinês (GBK)`,
"front-kefu-moudle-v1-Transfer-to":`Transferência para {TransferName}`,
"label.file.stop.sharing.desc2":`Partilha`,
"label.textmessage.messageCannoutuse":`Unavalible,contacte por favor o Administrador para activar as Mensagens de Texto.`,
"component_newrecords_label_type":`Tipo de armazenamento`,
"label.validate.function.funcFormat.ISNEW":`ISNEW()`,
"lable.product.pricebooks.new":`Novo Livro de Preços`,
"vue_label_newfile":`Novo ficheiro`,
"label.reportTypcrtB":`Objecto associado (b) por favor clique para seleccionar o objecto relacionado`,
"label.knowledgebase.type":`Categoria`,
"label.report.select.format":`Seleccionar formato de relatório`,
"component.todaytask.label.title":`Hoje`,
"message.undelete":`Tem a certeza de que quer cancelar a eliminação?`,
"label.ccdocument.trace.retention":`Função de retenção de vestígios`,
"label.publicgroup.tip":`Um grupo público é um conjunto de utilizadores. Pode conter utilizadores individuais, outros grupos, os utilizadores numa determinada função ou território, ou os utilizadores numa função ou território mais todos os utilizadores abaixo dessa função ou território na hierarquia.`,
"label.forecast.settings.lable2":`Configurar a visualização da Previsão Previsão por Defeito`,
"label.projectManagement.positive.integer":`Por favor introduza um número inteiro positivo dentro de 0-24.`,
"label.projectManagement.one.work.list":`Por favor, preencha pelo menos uma lista de trabalho!`,
"label.or":`|Or`,
"label.projectManagement.no.person.in.charge":`Sem Supervisor`,
"vue_label_commonobjects_detail_an_email":`um email`,
"front-electronic-signature-field-mapping":`Adicionar Mapeamento de Campo`,
"label.marketsea.name.error":`O nome do grupo de chumbo não pode estar vazio`,
"component.setup.button.appurl":`Sistema URL`,
"label.mr.title.button.group1":`O`,
"chatter.contact":`Contacto`,
"vue_label_pool_hasfixed":`canais fixos de cooperação`,
"lable.list.queue.des":`As filas de espera permitem aos grupos de utilizadores gerir mais eficazmente uma carga de trabalho partilhada. Uma fila é um local onde os registos podem ser encaminhados para aguardar processamento por um membro do grupo. Os registos permanecem na fila até que um utilizador os aceite para a sua proeza ou até que sejam trans transferidos para outra fila. É possível especificar o conjunto de objectos que são suportados por cada fila, bem como o conjunto de utilizadores que têm permissão para recuperar registos da fila.`,
"label.reportsSubscriptionPage.condition":`Condições`,
"label.transwork":`Banco de Trabalho de Tradução`,
"label.batch.batchopration.resel":`Por favor, seleccione novamente os dados que deseja transferir, e clique em "OK" para saltar para a página da lista de visualização.`,
"label.cloudccsite.new":`Novo site`,
"label.button.select.page.required.field":`Seleccione os campos necessários para incluir na sua página:`,
"label.pagelayout":`Layouts de página`,
"label.weixin.trace.record":`Registos de Viagem`,
"label.emailtocloudcc.clear":`Limpar`,
"label.checkfield.find":`Encontrar duplicados`,
"message.view.count.title0":`Resumo da página actual`,
"label.reportsSubscriptionPage.schedulereport.frequency":`Frequência`,
"setup.mainpage.label.welcome5":`Campo personalizado`,
"label.implementation.details":`Executar Detalhes`,
"label.attendance.history":`Histórico de presenças`,
"label.is.pigeonhole":`Arquivo`,
"lable.account.CurrentandPreviousFYt":`Actual e Anterior 2 FY`,
"label.forecast.customforecast.tab.opportunity":`Oportunidades`,
"label.version.business.track":`Rastreamento de Oportunidades`,
"label.profilelayoutedit.selectrecordtype.tip":`Seleccionar o tipo de registo para este perfil de utilizadores. É necessário adicionar o campo de tipo de registo à disposição da página associada a este perfil para que possa ser exibido nas páginas de detalhe e nas páginas de edição.`,
"label.campagin.roi.zclzb":`Taxa de inscrição`,
"label.validate.function.funcFormat.WEEKDAY":`SEMANA(data)`,
"label.view.sort.message":`Ordenado por {!sort}`,
"page.field.masterinput.sort":`As entradas de Master-Detail são apresentadas pela ordem em que são guardadas.`,
"label.selected.field":`Campos de Pesquisa Seleccionados`,
"label.product.proofTwo":`Em {0}, por favor escolha pelo menos {1} opções de produto.`,
"vue_label_report_filtercondition":`Condição do filtro`,
"label.forecast.shrepage.desc1":`Esta página enumera os utilizadores, papéis e territórios que têm acesso partilhado a`,
"label.file.copy.link":`Link para cópia`,
"vue_label_chat_movedto":`{nome} moveu {label} para {novo Campo}`,
"label.layout.new.built":`Nova Secção`,
"label_tabpage_crecordtypez":`Mudar tipo de registo`,
"label.report.searchcustominfo":`Introduza as palavras-chave para encontrar relatórios personalizados correspondentes`,
"chatter.feed.menutype.user":`Colegas`,
"label.recordtypeselect":`Seleccionar tipo de registo`,
"label.partner.new.step3":`Passo 3 Introduzir nome e url`,
"label.newCustomReportType":`Nova Fonte de Dados do Relatório Personalizado`,
"label.service.gantt.day.timescale":`Escala de tempo em vista do dia:`,
"label.displaytype3":`Botão Listar`,
"label.weixin.discharge.rate":`Volume de Escape`,
"label.weixin.menu.message":`Menu`,
"label.mask.show.all.characters":`Máscara exibe todos os caracteres`,
"label.quickbooks.fieldlabel.billingaddress":`Endereço para facturação`,
"Dashboard.View.All":`Todos os Dashboards`,
"setup_mainpage_label_welcome22":`Instruções: Clique no menu do lado esquerdo desta página → Manage Settings → Newsletter Template → Email Template.`,
"chatter.group.groupInformation":`Informação sobre o grupo`,
"front-epwechat-module-v1-input-secret":`Por favor, introduza o segredo`,
"lable.Set.value.prompt":`Ou, registos de filtragem exibidos na lista relacionada. Escolha a caixa de verificação, ou os campos da lista de selecção e os valores que gostaria de filtrar. Se introduzir os valores manualmente, separar por favor com vírgulas.`,
"label.appupload.upload.from":`Por`,
"label.weixin.postunsolve":`Vencido`,
"label.cooperation.all":`Toda a cooperação`,
"lable.PowerProcess.close.time":`Com base na hora de fecho do {detailInterestType}`,
"lable.opppdt.selPdt.leastone.fields":`Por favor, seleccione pelo menos um campo.`,
"label.emailtocloudcc.help":`Por favor, introduza a palavra-passe ou o código de autorização correcto do e-mail. Se o seu servidor de e-mail precisar de ligar o serviço IMAP/SMTP para iniciar sessão por uma conta de terceiros, deve iniciar sessão nas definições da conta de e-mail para activar primeiro o serviço, e copiar o código de autorização aprovado para esta caixa de introdução de palavra-passe.`,
"label.attendance.offwork.time":`Fim do dia`,
"front-gantt-module-v1-project-gantt":`Gráfico de Gantt do Projecto`,
"label.chuangming.description":`Configurar a informação do Chuangming para satisfazer as necessidades dos serviços de envio e recepção de SMS da sua organização.`,
"label.custom.lead.notice.account.name":`Há uma pista que, foi convertida, especifica que é o proprietário da conta, contacto e oportunidade. Nome da conta:`,
"label.emailobject.failedtosend1":`O envio falhou: A autenticação de e-mail é inválida, por favor reconnect！`,
"vue_label_ccchat_notice_updaterecordsuccess":`Este registo foi actualizado`,
"label.dayinmonth":`Meses`,
"label.sendemail.chat.follow":`Caro #nome:{\i1}nome: olá! #userName segue-o.`,
"label.emailsync.form.emialpassword":`Senha`,
"component_task_label_subject":`Tema`,
"label.projectManagement.please.enter.a.positive.integer":`Por favor, introduza um número inteiro positivo.`,
"lable.account.NexteDays":`Próximos 7 dias`,
"label.appupload.upload.managed":`Pode ser criado, no máximo, um pacote controlado!`,
"label.data.dataexpalltype.all.desc1":`O 1、You pode empurrar para gerar automaticamente e introduzir manualmente a password do ficheiro das compressas exportadas. A palavra-passe gerada automaticamente será enviada para a caixa de correio dos utilizadores quando os dados forem exportados com sucesso. A palavra-passe introduzida manualmente não será enviada para a caixa de correio, pelo que os utilizadores precisam de se lembrar da palavra-passe que introduziram. Se não for inserida, por defeito não há palavra-passe.`,
"label.step1.total3":`Etapa 1 de 3`,
"label.escalation.setup.detail.section":`Detalhe da Regra`,
"front-gantt-module-drag-task-sorting":`Arrastar tarefas para encomenda`,
"label.isEnableVisualpage.new.title":`Habilitar o acesso à página personalizada`,
"label_tabpage_yesz":`Sim`,
"label.emailobject.emaildetail.button.replyall":`Responder todos`,
"label.knowledge.setting.data.one":`Isto não pode acrescentar mais subcategoria.`,
"label.manageAll.sel.one3":`Itens I Aprovados`,
"UG_contact_01":`Como tirar o máximo partido dos seus contactos?`,
"font-trade-module-v1-invoice-name":`Nome da factura`,
"label.central.daylight.time":`Hora central de luz do dia`,
"label.chatter.pastThirtyday":`Os últimos 30 dias`,
"vue_label_commonobjects_detail_activity_ownevent":`Evento disponível`,
"label.user.modify":`Edição do utilizador`,
"label.uploadTemplate":`Carregar modelo`,
"setup_mainpage_label_welcome14":`Gestão do processo de personalização do fluxo de trabalho, aprovação`,
"label.workmate":`Colegas`,
"label.displaycolumns":`Colunas de exposição`,
"label.emailnoticeintro":`Os alertas por e-mail são os e-mails que as regras de fluxo de trabalho enviam quando são accionadas.`,
"label.knowledge.category.button.five":`Eliminar Categoria`,
"template.report.business.opportunities.type":`Oportunidades por tipos`,
"vue_labenl_applauncher_moreapp":`Mais aplicações`,
"label.captcha.expired":`O código de verificação está expirado, por favor verifique novamente.`,
"template.chart.bnqzkhslmb":`Número Alvo de Leads para o Ano`,
"chatter.up.user.pic":`Carregar foto do utilizador`,
"label.timezone.importtimezone.gmt":`Usar gmt timezone`,
"label.step.type":`Seleccione o tipo de membro que deseja pesquisar`,
"Dashboard.View.RecentlyView":`Visto recentemente`,
"label.reportinthisfolder":`Relatórios nesta pasta`,
"label.product.vies":`Vistas de produtos`,
"pagecreator_systemstyle_message_delete_fail":`A eliminação do estilo falhou`,
"label.multipleactivity.singleUser":`Utilizador único`,
"vue_label_email_enter_subject":`Entrar assunto`,
"label_tabpage_alltabs":`Todos os separadores`,
"label.publicgroup.groupname":`Nome do grupo`,
"template.report.sales.performance":`Desempenho dos vendedores`,
"label.newWindow":`Nova Janela`,
"label.forecast.editopp.forecastedit":`Previsão Editar`,
"label.data.import.setup.whichfield":`Que campo gostaria de utilizar para a correspondência?`,
"label.noadd_dashboard":`Não adicionar ao painel de instrumentos`,
"label.subtotal":`Subtotal`,
"front-email-payment-weichat":`Por favor, use o WeChat "Scan".`,
"label.attendance.position.alert":`Por favor seleccione primeiro a máscara`,
"chatter.follow.me":`Sigam-me`,
"label.mobile.more.details":`Editar detalhe do ficheiro`,
"Dashboard_SelectBoardToDisplay":`Por favor seleccione os painéis de bordo que deseja mostrar na página de separadores dashborad`,
"front-gantt-module-v1-search-project":`Pesquise o seu projecto...`,
"label.paging.totalofpagereport":`Um total de {0} páginas({1})`,
"label.from.phone":`A partir de`,
"lable.Signatory":`Signtory:`,
"label.campagin.roi.query.roi2":`Canais de Marketing ROI`,
"label.tabpage.selectcontentz":`Seleccione por favor o conteúdo`,
"label.multilang.lookfiltercondition.valuetypenotmate":`A condição da linha {0} está incorrecta, o tipo de valor não corresponde!`,
"label.interfaceconstraint.disabled":`A interface foi desactivada, por favor contacte o administrador do seu sistema.`,
"third":`A Terceira`,
"label.quickbooks.viewlist.status":`ESTATUTO`,
"label.emailtocloudcc.select3":`Por favor seleccione o proprietário do disco`,
"label.projectManagement.week.work":`O meu trabalho para esta semana`,
"vue_label_pool_nodemand":`Sem procura`,
"label.version.two.developapi":`API de Desenvolvimento Secundário`,
"label.icon.82":`Impressora`,
"label.batchadd.newbatchpage.suclist":`dados da(s) peça(s) adicionados com sucesso`,
"label.checkfield.chooseatlast":`Por favor seleccione pelo menos dois`,
"label.quotation.deleteTip":`Por favor, seleccione as linhas de cotação a eliminar`,
"label.generatepage.title.desc2":`Clique Guardar para gerar a página Web e a ligação URL da Web que pode ser acedida.`,
"label.licence.total":`Licenças totais`,
"Y":`Relação de pesquisa`,
"label.wuzibiekesitan.time":`Tempo Uzbequistão`,
"label.component.hotdeal.nodata":`Não há dados relacionados com oportunidades de negócio.`,
"label.data.exp.save":`Guardar o modelo`,
"label.appupload.upload.tips.dashboard":`NOTA: Os "dashbords nos Meus Painéis Personalizados" e "Painéis Públicos Não Arquivados" não podem ser adicionados aos pacotes e não serão mostrados nesta lista. Os relatórios antigos relacionados não podem ser carregados".`,
"lable.PowerProcess.new.PowerProcess":`Novo processo de concessão de direitos`,
"label.loginhis.search.download":`Considerando que existem muitos históricos de início de sessão, apenas o histórico dentro de 2 meses pode ser descarregado quando se procura por descarregamentos.`,
"label.tabpage.deleteview":`Apagar a vista`,
"label.chatter.recently":`Recentemente`,
"label.industrialandcommercialverification.title":`Verificação Industrial e Comercial`,
"message.nextapproverlost":`O próximo aprovador especificado é nulo.`,
"front-kefu-moudle-v1-mfsysy-time":`Dias restantes para trilha livre`,
"label.role.assign.tip":`Escolha um utilizador na lista de Utilizadores Disponíveis e adicione-os à lista de Utilizadores Seleccionados para atribuir utilizadores à função`,
"label.addattachment.step2.intruduce":`Repetir os passos 1 e 2 para adicionar vários ficheiros.`,
"vue_label_pool_returnreasondiscription":`Descrição do Motivo de Regresso`,
"label.weixin.report.range":`Gama`,
"label.wei.weiresearchtab":`Escolha do Micro Voto`,
"vue_label_report_setdrill":`Berbequim`,
"page_404_button_back":`Voltar ao passo anterior`,
"label.customfields.autonumber.tip":`Um número sequencial gerado pelo sistema que utiliza um formato de visualização definido por si. O número é automaticamente incrementado para cada novo registo.`,
"label.ccpeak.return.allrecords":`Devolver todos os registos`,
"label.ccchat.notmember.active.group2":`Não está no nome com`,
"label.uniquename":`Nome único`,
"label.emailtocloudcc.filed.ssl":`Ligação segura`,
"chatter.emailFollowMe":`Segue-me`,
"label.allrightsreserved.allrightsreserved.customerServiceHotline":`Direitos de autor. Todos os Direitos Reservados. Linha Directa de Serviço ao Cliente`,
"label.projectManagement.actualworkinghours":`Horas de trabalho efectivas`,
"label.quickbooks.fieldlabel.taxresale":`Revenda Fiscal`,
"label.icon.12":`Serviço`,
"label.data.exp.dataexptemp":`Modelos de exportação de dados`,
"component_setup_tabs_label_add":`Adicionado`,
"label.appointmentdetail.wizard.title10":`Data de início`,
"label.multilingual.close":`A gestão multilingue não está habilitada.`,
"message.error.username.notexist":`Nome de utilizador inválido, por favor reintroduzir.`,
"label.batchadd.newbatchpage.des2":`Se o tipo de campo for Auto Number, o número é automaticamente incrementado para cada novo registo sem introdução manual.`,
"vue_label_SMS_search":`Procura de pistas ou contactos`,
"label.appupload.successWithUrl":`O seu pacote está agora disponível para instalação utilizando o URL de instalação abaixo.`,
"UG_Forcast_06":`Por favor, seleccione os utilizadores que estão autorizados a prever`,
"vue_label_dashboard_secondarygroup":`Por favor seleccione o grupo secundário`,
"label.weixin..xsld.total":`Montante total no funil de vendas`,
"label.setup.mobile.bottombutton.recovery.default.fail":`Falha no restabelecimento do incumprimento`,
"label.addrecurrencetimetrigger":`Acrescentar o Disparador de Tempo Periódico`,
"label.emailsync.connectaccount":`Ligar conta de e-mail`,
"label_fiscal_years":`Ano fiscal`,
"label.icon.164":`Treinador`,
"label.batchadd.mustinput":`Campo com`,
"message.newtabpage.nokeywords":`O seu termo de pesquisa deve ter 1 ou mais caracteres. Ou pode adicionar critérios de pesquisa avançados.`,
"label.login.verification.mfa.desc3":`Se a sua conta tiver sido partilhada por várias pessoas, outras pessoas não vinculadas à AMF não poderão iniciar sessão depois de ter sido vinculado com sucesso à AMF. A solução é ter outra pessoa a instalar a aplicação de AMF e a digitalizar o código QR para esta página, ou guardar a imagem do código QR para posterior digitalização por outras pessoas. No entanto, em termos de melhores práticas de segurança, recomendamos que cancele várias contas partilhadas.`,
"label.partnerCloud.basicSetting.initialize":`Não é possível alterar o nome de domínio após a inicialização.`,
"label.address.county":`Condado`,
"label.validate.function.funcFormat.TODAY":`HOJE()`,
"label.sso.addAKey":`Adicionar Chaves`,
"label.myusergroup":`Os meus Grupos de Utilizadores`,
"label.import.index.time-consuming":`Hora`,
"label_tabpage_systems":`Existem * sistemas`,
"batch.sendemail.s":`, Correio enviado com sucesso.`,
"label.appointment.wizard.subtitle4-1-1":`15 min`,
"label.projectManagement.delete.milestone":`Toda a informação relacionada com este marco será também apagada se apagar este marco, e os dados não podem ser recuperados. Tem a certeza de confirmar a eliminação?`,
"label.umeng.chatter.praise":`gostou do seu posto.`,
"font-evaluate-module-v1-evdetails":`Detalhe de Avaliação:`,
"label.group.filter.resources.and":`Escolher um método de filtragem de recursos, E relação.`,
"label_emailtocloudcc_description":`Ligue a sua conta de correio electrónico empresarial, tal como sales@company.com, info@company.com, support@company.com. Registe automaticamente os e-mails que recebeu como leads e registos de casos no CloudCC para assegurar um acompanhamento atempado das cartas dos clientes.`,
"label.chat.topic.delete.prompt2":`Note-se que os tópicos com o mesmo nome noutras comunidades não serão eliminados.`,
"message.error.group.authorization":`Não tem acesso para criar este grupo`,
"label.attendance.wz":`Localização`,
"vue_label_activity_notice_logacal_success":`Registou uma chamada`,
"label.emailtocloudcc.step1.case1":`Email para o caso`,
"label.h5.chatter.praisenum":`Recebeu elogios`,
"label_time_statistics_basis":`Base estatística de tempo`,
"label.onlyadmincanedit":`Os administradores <fortemente>ONLY</strong> podem editar registos durante o processo de aprovação.`,
"label.fieldtoolongmassage":`Campo`,
"label.sales.team.shared":`Partilha de grupos de oportunidades comerciais`,
"label_emailsync_status_department":`Departamento`,
"label.mobile.quickcreate.default.sellingfunnel":`Funil de vendas`,
"label.tabpage.closez":`Fechar`,
"homepage.components.two":`Passo 2 escolher o local onde os componentes personalizados são exibidos`,
"label.everyday":`Todos os dias`,
"lable.Product.to.asset.BOM":`Produto para Lista Técnica de Bens`,
"label.appointment.wizard.subtitle4-3":`O convidado é capaz de escolher um início em cada`,
"label.customobjects.standardfieldslist":`Lista de campos padrão`,
"label.customfields.suretodelete":`Sim, quero apagar o campo personalizado.`,
"component.chatter.label.to":`Para`,
"label.emailsync.form.seversetting":`Configuração`,
"label.service.gantt.enabled.resources":`Recurso activado`,
"label.tianyancha.h5.weibo":`Microblog`,
"template.chart.dddje":`Montante de Encomendas Perdidas`,
"label.pc.trigger.apiname":`O nome API já existe, por favor tente novamente.`,
"label.icon.34":`Instalação`,
"label.schedulejob.setup.schedule.prgname":`Nome da Aplicação`,
"label.weixin.free.registration":`Inscrever-se gratuitamente`,
"label.placeholder":`Pesquisa rápida`,
"label.emailobject.manage.template":`Gerir os modelos`,
"label.knowledge.article.existsdata":`Existem outros dados não qualificados.`,
"label.campaign.channel.lookup.ticket":`Verifique o bilhete`,
"label.searchlayout.relation.searchfield":`Pesquisar campos de filtros para listas relacionadas.`,
"label.recordid.cannot.empty":`O ID do registo não pode ser nulo`,
"label_partner_workspace_member_choice":`Seleccionar perfil`,
"vue_label_campaign_amount":`Montante do rendimento`,
"label.niue.time":`Tempo Niue`,
"front-homepageobject-module-v1-workload-ranking":`Ranking de carga de trabalho`,
"message.error.datainvalid":`Erro: dados inválidos.`,
"vue_label_helpcenter_salesfunnel":`Utilize a nova versão do funil de vendas para analisar o seguimento de oportunidades de negócio e fornecer referências de dados para o seu processo de vendas.<br> No canto superior esquerdo, os registos serão filtrados de acordo com condições tais como função ou proprietário, e todas as oportunidades de negócio visíveis sob as condições correspondentes serão vistas e analisadas. Clique na fase do gráfico do funil de vendas para visualizar todos os registos sob essa fase.`,
"vue_label_transferownernotice":`O proprietário do registo associado a este item também será alterado`,
"label.monitorsys.operator":`Acted By`,
"label.please.codeNorm":`Escolha por favor o código padrão.`,
"label.campaign.channel.step6.remark2":`Permitir a solicitação de empregados`,
"market.potential.customers":`Liderança de mercado`,
"label.customfields.phone.tip":`Permite aos utilizadores introduzir qualquer número de telefone. Formata automaticamente como um número de telefone.`,
"label.currency.edit":`Currency Edit: Mudar moeda corporativa`,
"label.emailobject.emaildetail.button.markasunread":`Marcar como não lido`,
"label_partner_template_memo":`Título`,
"label.chat.message.search.all":`Pesquisar toda a informação`,
"label_tabpage_hoursagoz":`horas`,
"label.customcomponent.developer.help":`Componentes personalizados Ajuda ao desenvolvedor`,
"setup_mainpage_label_welcome":`Bem-vindo à plataforma CloudCC PaaS, as principais funções da plataforma são as seguintes:`,
"label.h5.similar.opportunity.list":`Os resultados incluem oportunidades fechadas que têm um ou mais campos em comum com a sua oportunidade. Oportunidades de marcador de página adiciona-as à lista relacionada com oportunidades semelhantes na sua página de detalhes de oportunidades.`,
"vue_label_record_count":`Contagem recorde`,
"label.icon.29":`Demonstração`,
"pagecreator.page.label.pagelayout":`Layout da página`,
"label.ggReleaseRange.searchRole":`Procurar uma função`,
"label.campagin.member.field.setup":`Definições de campo dos membros da campanha`,
"augest":`Agosto`,
"label.salescloud.massloss.content":`A desactivação de equipas de oportunidades irá remover irreversivelmente as equipas existentes de todas as Oportunidades e eliminar as equipas de oportunidades por defeito dos utilizadores.`,
"label.customfields.new.step2.opration.unique.info":`Não são permitidos valores em duplicado.`,
"vue_label_email_optional_members":`Membros opcionais`,
"label.emailobject.attachment.download":`Descarregar`,
"label.recordamount":`Contagem de registos`,
"front-kefu-moudle-call-recorder":`Gravação de chamadas`,
"label.more.info":`Detalhes`,
"vue_label_commonobjects_view_secondsbefore":`{segundos} segundos`,
"label.emailsync.status.action":`Acção`,
"label.customfields.totalsummary.collectedfields":`Objecto resumido`,
"label.knowledge.setting.hint.two":`Atenção: Não se pode desactivar o Conhecimento uma vez activado.`,
"label.login.access.yujidao":`Exp.`,
"label.assignment.setup.detail.description":`Adicionar entradas de regras que especifiquem os critérios utilizados para atribuir automaticamente os condutores aos utilizadores.`,
"message.error.marketsea.null":`Não existe Piscina de Chumbo`,
"lable.account.Current.CY":`CY actual`,
"vue_label_salesadvance_lost":`Perda`,
"label.file.ownedbyme":`Propriedade minha`,
"label.component.helper.nodata":`Nada precisa da sua atenção neste momento. por favor, volte a verificar mais tarde.`,
"label.weixin.appr.pending.auditor":`Submetido por`,
"UG_opportunity_004":`Tipo multi-serviços`,
"label.leadscore.setup":`Líderes Definições de Pontuação`,
"label.addtimetrigger":`Acrescentar gatilho de tempo`,
"label.mr.title.match":`Se corresponder exactamente`,
"label.projectManagement.Newmilestone":`Novo marco miliário`,
"label.preview":`Pré-visualização`,
"label.tabpage.issuez":`Edição`,
"label.img.max.size":`A imagem carregada é demasiado grande, e o tamanho máximo da imagem carregada é de 500K, por favor, volte a carregar.`,
"label.mainpageset":`Configurar componentes da homepage`,
"label.user.login.false.lock":`Tentativas de login excedidas. A conta está bloqueada`,
"UG_solution_02":`A solução é uma solução interna da instituição para o problema que as contas encontram.`,
"vue_label_approve_put_away":`Colapso`,
"label.profile.existing":`Perfil Existente`,
"label.ems.logininfo":`Informação de login`,
"label.weixin.location.service":`Objectos que suportam serviços de localização`,
"label.multilang.datamoveaction.totaldata":`Existe um total de {1} registos que satisfazem o condition，maximum 100 registos podem ser transferidos em um time！：`,
"label.ccdocument.cannot.update.set":`Este documento não pertence ao tipo Word ou Excel ou PPT do ficheiro, não é carregado para o modelo de pasta vermelha.`,
"vue_label_fliter_addfliter":`Acrescentar Fliter`,
"label.custom.page.or.trigger":`(Páginas Personalizadas ou Gatilhos)`,
"label.tag.filter1":`Filtrar os registos que contêm todas as etiquetas seleccionadas`,
"UG.homepage.006":`Visibilidade de 360 graus na sua actividade de conta através de inquéritos, conversas ao vivo, e-mails, ordens de trabalho, postos nos meios de comunicação social, e mesmo actividades de vendas (tais como leads, apoio de serviços, e actividades).`,
"SCORE":`Pontuação`,
"label.file.library.managemembers2":`Gerir membros da biblioteca`,
"label.email.template.public.SMS":`Pasta Pública de Modelos de SMS`,
"label.leadscore.donot":`Incapacidade de marcar pistas`,
"label.gaode.map":`Amap`,
"pagecreator_button_preview":`Pré-visualização`,
"UG_contact_04":`Ou`,
"label.ccchat.person.invite.eminfo":`{0} convidou-o a participar {1} no CCChat.Com ccchat pode conversar com os seus colegas, criar equipas para os seus projectos, e partilhar ficheiros.`,
"setup_object_field_dependency_label_actionfieldvalue":`Campo de controlo`,
"lable.Product.options":`Opções de produtos`,
"front-electronic-signature-add-autofill-field":`Adicionar campo de preenchimento automático`,
"label.customfields.totalsummary.selectcollectedfields":`Seleccionar Objecto a Resumir`,
"label.projectManagement.the.maximum.contract.amount.is.10.digits":`Podem ser inscritos até 10 dígitos para o montante do contrato.`,
"label.forecast.shrepage.pagetitle":`Partilha de utilizadores, papéis e territórios`,
"label.login.access.mark":`Para ajudar em questões de apoio, pode conceder ao seu administrador ou pessoal de apoio a capacidade de iniciar sessão à sua medida e aceder aos seus dados.`,
"lable.outlook.edit.zdyout":`Mapeamento de campo de intercâmbio personalizado`,
"label.approveoperate":`Acções de Aprovação`,
"label.tabpage.linknamez":`Nome da ligação`,
"label.report.error.deletehavedashboard":`Este relatório tem um novo painel de instrumentos e não pode ser apagado`,
"label.summaryreport.2018.step1":`Passo 1 Criar um agrupamento`,
"label.campaignmember.main.leadtomember.title":`Configuração do mapeamento de campo`,
"label.select.dashboar.type":`Seleccione por favor o Tipo de Painel de Instrumentos`,
"message.setup.field.picklist.valueexists":`Este valor da lista de selecção já existe.`,
"label.loading":`Carregamento...`,
"label.payments.paytip1":`A sua edição actual subscrita não é uma edição gratuita, por favor clique em Confirmar para actualizar ou re-logar.`,
"label.view.appliedMobile":`Aplicar para a aplicação móvel`,
"label.multilang.forcast.financialyear":`{0} fiscal year：`,
"front-web-module-v1-detail-comment-opinion":`Feedback`,
"UG_Forcast_10":`Completo`,
"label.optionlistset":`Opções da lista de selecção`,
"label.visualpage_list.vpname":`Nome da página personalizada`,
"vue_label_calendar_failed_to_delete_calendar":`Falha em apagar o calendário`,
"label.json.string.null":`Vazio`,
"message.serviceappo.time.violation2":`A violação do tempo disponível de marcação de serviço: A hora marcada para o fim da marcação é anterior à data de vencimento da marcação de serviço`,
"label.productsales.today.noevttsk":`Não há eventos em aberto e tarefas em expiração.`,
"label_tabpage_emptyz":`Vazio`,
"front-kefu-moudle-no-create":`Não criado`,
"label.wedge.shaped.tail.arrow.cannot.empty":`A seta da cauda da cunha não pode ser nula`,
"label.continue.shopping":`Continuar Compras`,
"label.turntomain":`Saltar para o Conteúdo Principal`,
"component.assistant.label.nodata":`Nenhum evento hoje, por favor verifique mais tarde.`,
"label.payments.paytip4":`Por favor introduza o número de users！`,
"label.appupload.upload.versionName":`Nome da versão`,
"label.chatter.endData":`Data de fim`,
"front-kefu-moudle-buytr-tip":`Esperamos que possa ter uma grande experiência com o call center da CloudCC, e que possa adquirir uma conta oficial de call center e que lhe possamos prestar um melhor serviço.`,
"label.repw":`Repetir Palavra-passe`,
"label.tabularreport.intro":`O relatório tabular é uma das formas mais simples e rápidas de listar os dados.`,
"label.selectoperatetype":`Seleccione o tipo de acção`,
"setup.layout.label.required":`Obrigatório`,
"label.default.designee":`Peron Enviado por Defeito`,
"label.ccdocument.cannotdel.folder":`Não se pode apagar esta pasta porque alguns ficheiros nesta pasta.`,
"label.escalation.setup.newentries.inputentries":`Introduzir a regra de entrada`,
"label.emailobject.addnewtemplate":`Adicionar novo modelo`,
"label_chatter_content":`Conteúdo`,
"label.htyj.mubiao":`Objectivo`,
"label.reportsSubscriptionPage.schedulereport.weekly.friday":`Sexta-feira`,
"label_tabpage_fieldoptions":`campo tipo de registo, campo lista de opções, e campo lista de opções (escolha múltipla). recomenda-se introduzir no máximo 10 palavras-chave, separadas por vírgulas para conseguir "ou relação", como por exemplo: "Nova Iorque, Toronto, Tóquio".`,
"label.mobiletablayoutedit.remark2":`Seleccionar os campos apresentados na página inicial do separador em Mobile App.`,
"label.sendemail.chat.addComentsat":`Caro #nome:\n #userName mencionou-o nos comentários.`,
"Z":`Fórmula`,
"label.multilang.batchdeleteaction.movesuccess":`Um total de registos {0} foi apagado successfully！：`,
"label.textmessage.vonage.message2":`Ao criar contas Vonage API, os utilizadores permitem ao CloudCC aceder à sua conta Nexmo API para enviar e receber mensagens de texto.`,
"label.file.use.document":`Utilização do espaço de armazenamento`,
"UG.Lead.011":`Criar uma pista`,
"label.view.name":`Ver Nome`,
"label.data.downtemplate":`Descarregar modelo`,
"vue_label_appstore_get_now":`Obtenha-o agora`,
"label.controlfield":`Campo de controlo`,
"label.dataimport.type.insert":`Inserir`,
"label.customfields.multiselect.tip":`Permite aos utilizadores seleccionar múltiplos valores a partir de uma lista que define.`,
"label.weixin.approval.qxzjl":`Por favor, seleccione o registo`,
"component.salesperformance.label.70finish":`Terminado - não processado (>70%)`,
"Lead_Auto_Scoring_Setting":`Definição da pontuação de chumbo`,
"pagecreator_layout_message_canntdelete":`O layout actual não é permitido apagar`,
"vue_label_report_exprotpage":`Página de exportação: Página {página}`,
"label.campaign.channel.step4":`Passo4: Seleccionar os campos obrigatórios a exibir na página de registo do canal de marketing`,
"label.app.launcher":`Lançador de aplicações`,
"vue_label_campaign_selectedmember":`{member} membros da campanha seleccionados`,
"label.mobile.quickcreate.default.approvals":`Aprovações`,
"label.view.step4":`Passo 4 Restringir a Visibilidade`,
"label.exchange.sync.state.user":`Estado de Sincronização do Utilizador`,
"label.forecast.customforecast.tab.forecast":`Previsões`,
"label.theUserLoginForTheFirstTime":`Primeiro login do utilizador.`,
"label.workflowoperate.tip":`Especificar as acções de fluxo de trabalho que serão desencadeadas quando os critérios da regra forem cumpridos.`,
"font-evaluate-module-v1-ten-points":`Marca Positiva: 10 pontos`,
"label.knowledge.delete":`Erro ao apagar conhecimento`,
"front-console-see-contacts":`Contactos {num} identificados`,
"label.h5.similar.opportunity.add.to.favorites":`Acrescentar aos Favoritos`,
"front-epwechat-module-v1-install-app":`Instalar na WeCom`,
"setup_layout_message_relatedlistbutton":`Seleccionar botões padrão para exibir na lista relacionada.`,
"label.salescloud.massloss.title":`Pode levar a uma grande perda de dados.`,
"front-console-conversation-btn1":`Anel de volta`,
"label.custom.canvasScale":`Balança de lona`,
"label.lead.score.doing":`No processo de pontuação de chumbo`,
"message.approval.step.validation.invalid.number":`Número inválido`,
"chatter.lk":`Como`,
"label.dashboardSetup.showmaxval":`Máximo Exibido`,
"label.keywords":`Palavras-chave`,
"vue_label_helpcenter_SMS":`Ligue a função SMS<br> Se o código do país do sistema CRM que adquiriu é EUA, então a função SMS está disponível no sistema da sua organização. O administrador da organização pode introduzir o número de telefone adquirido pela sua organização no sistema vonage no gateway vonage na aplicação de integração de fundo, e depois utilizar a função SMS no menu da aplicação da nuvem de vendas.<br>caixa SMS<br> A caixa SMS está dividida em duas partes. À esquerda está o registo dos contactos ou leads com SMS. Depois de clicar num registo, os detalhes de envio e recepção serão exibidos à direita. Pode ver os registos de si e dos seus subordinados.<br>enviar mensagem em grupo<br> Pode enviar mensagens de texto em grupo no menu SMS, a lista de leads ou contactos, e o botão para enviar mensagens SMS sobre os membros da campanha. Só pode enviar mensagens de texto a potenciais clientes ou contactos no CRM. Após editar a mensagem de texto, seleccione "Enviar", e será gerado um registo de grupo independentemente do número de destinatários, ou pode seleccionar "Enviar separadamente" para enviar as mensagens de texto separadamente Suporte de mensagens SMS separadas mostrando os campos fundidos inseridos no modelo SMS.`,
"label.emailobject.createnewavailability":`Criar nova disponibilidade`,
"front-kefu-moudle-buytr-send-email":`Ainda não foi associado à caixa de correio do sistema. Envie um email para support@cloudcc.com e escreva a sua intenção, nome da empresa e informações de contacto, o pessoal de vendas entrará em contacto consigo o mais rapidamente possível.`,
"front-kefu-moudle-v1-Put-away-the-chat":`Detalhes do Collapse Chat`,
"label.marketseamemset.lead.maxuser":`Número máximo de membros`,
"label.forecast.forecastroleuserpage.shre.manager":`Só os administradores podem partilhar esta previsão`,
"label.file.noselect":`Nenhum ficheiro é seleccionado`,
"label.notification.task3":`【被分配人】 alterar o estado da tarefa que lhe foi atribuída a 【新状态】`,
"label.dependfield":`Campo Dependente`,
"lable.SalesCommitmentKanBan.receipts":`Recibos`,
"label_partner_workspace_member_search":`Pesquisa`,
"label.share.originally.posted":`Cartaz inicial`,
"label.autonumber":`Número de automóvel`,
"label.view.sortview.name":`Ver Nome`,
"label.h5.add.activity":`Adicionar actividade`,
"label.textmessage.vonage.phone.number":`Número de telefone`,
"label.partnerCloud.financeSetting.enterApiKey":`Por favor introduza a chave secreta API`,
"label.industrialandcommercialverification.enablestatus":`Habilitar Estado`,
"label.reportTypeFocusD1":`Especificar que tipo de registos (linhas) serão o foco dos relatórios gerados pela fonte de dados deste relatório.`,
"vue_label_report_four-levelseriesobjecttree":`Árvore de objectos da série de quatro níveis`,
"label.mobile.default.catalogue":`Catálogo por defeito`,
"label.partnerCloud.partnerAccount.again":`Recarga`,
"label.summaryreport.step2.new":`Passo 2 Seleccionar o método de agrupamento de dados resumidos`,
"label.tabpage.cancel":`Cancelar`,
"label.multilang.datamovelist.datamove":`Transferir vários {0} de um utilizador para outro utilizador:`,
"label.conferloginandvisitlimit":`Acesso concedido para login`,
"vue_label_help_viewhelpcenter":`Ver Centro de Ajuda CloudCC`,
"label.leadscore.norule":`Sem regras de pontuação de chumbo,por favor crie uma regra de pontuação de chumbo ou active uma regra de saída`,
"label.tabpage.exitz":`Saída`,
"label.DeploymentStatus":`Estado de implantação`,
"label.layout.saving":`Poupar layout...`,
"label.emailobject.emaildetail.field.object":`Objecto`,
"label.customfields.searchrelation.fieldtag.tip":`Introduza as etiquetas a utilizar na vista de visualização, vista de layout da página, vista de relatório e vista de lista.`,
"message.huanxin.bindtenant.notfound":`Agente não vinculado`,
"label.referpersonalias":`Submetido por`,
"label.icon.31":`Computador`,
"label.appupload.upload.install.thispackage":`Este pacote`,
"label.appointment.wizard.subtitle1-1":`Personalizado`,
"pagecreator_page_message_save_fail":`Salvar página falhou`,
"label.lastset":`Finalmente, de acordo com`,
"label.version.support.limited":`Apoio Limitado`,
"vue_label_homepage_kanban":`Kanban`,
"label.layout.editsearchdistribute":`Editar layout de pesquisa`,
"template.dashboard.customer.analysis":`Análise de contas`,
"label.continue_editing":`Continuar a edição`,
"label.version.sum.customtab":`separador(s) personalizado(s)`,
"label.validate.function.funcExplain.TIMEVALUE":`Devolve o valor da hora local sem a data`,
"label.import.page1.selectobjfromdata":`Seleccionar objectos para importar dados`,
"label.partnerCloud.basicSetting.success":`Inicializar com sucesso`,
"label.customfields.fielddependency.cannotcreat":`O campo seleccionado depende directa ou indirectamente de si próprio, pelo que não se pode criar uma denpendência.`,
"label.umeng.activity.youhaveatask":`Tem uma nova tarefa.`,
"label.file.folder.create":`Nova Pasta`,
"vue_label_campaign_member_status":`Estatuto de membro`,
"lable.opppdt.addpdt.table.date":`Data`,
"label_partner_workspace_login_buttontext":`Texto do botão`,
"label_other_mistakes":`Outros Erros`,
"label.must.be.configured":`Deve ser configurado`,
"label.customize.memory.function.sorting.enable":`Activar a memória de ordenação de cabeçalhos`,
"setup.layout.label.areaname":`Nome da Secção`,
"label_chatter_pastThirtyday":`Os últimos 30 dias`,
"setup_mainpage_label_welcome25":`Instruções: Clique no menu do lado esquerdo desta página → Manage Settings → Security Control → Sharing Settings.`,
"label.ccchat.person.invite.succsend":`Um convite para se juntar ao CCChat é enviado para`,
"label.select.time.range":`Por favor escolha o intervalo de tempo`,
"label.partnerCloud.orderingPlatform.djustQuantity":`Adicione produtos ao carrinho, onde pode ajustar a quantidade e ver o preço.`,
"label.manageAll.sta1":`Pendente`,
"label.cy.select":`Escolher uma nova moeda a partir da lista disponível.`,
"chatter.lam":`Comentário`,
"label.partner.setup.title":`Definições`,
"component.setup.label.displaybutton":`Botão de exibição`,
"component.salesperformance.label.target":`Objectivo`,
"label.campagin.channel":`Por favor introduza o valor do canal`,
"label.validate.function.funcFormat.ISCHANGED":`ISCHANGED(campo)`,
"UG.homepage.009":`Acesso CRM`,
"label.file.item":`Projecto`,
"label.file.library.addmembprompt":`Os seguintes já são membros.`,
"label.bmap.releasePosition":`Localização`,
"setup_object_layout_label_selectedprofile":`Perfis seleccionados`,
"label_emailsync_message":`Pronto`,
"label.view_submissions":`Ver Submissões`,
"lable.tianyancha.repeated":`Selecção repetida`,
"label.import.index.introduce":`Importe os seus dados para o sistema em três passos simples`,
"label.time.operation.new":`Novo Emprego Programado`,
"label.projectManagement.Pleaseentersettlementtype":`Por favor, introduza o tipo de liquidação`,
"label.icon.169":`Carro de turismo`,
"vue_label_commonobjects_detail_related_listview":`Lista`,
"label.view.step1":`Passo 1 Introduzir nome da vista`,
"label.summaryreport.intro":`Os relatórios sumários mostram tanto o subtotal dos dados como outras informações sumárias.`,
"vue_label_file_input_correct_name":`Por favor preencha o nome correcto`,
"System_Email_Template_Title":`Bem-vindo à plataforma CloudCC CRM`,
"label.tianyancha.province":`Abreviatura provincial`,
"label.deleteall.sure":`Tem a certeza de que quer apagar tudo?`,
"label.passwordPolicy.setup.uppercasealpandnum":`Deve misturar números e letras maiúsculas e minúsculas`,
"front-lightning-module-v1-details-page-chart-select":`Escolher objecto e visualização`,
"setup_mainpage_label_welcome8":`Personalização da interface de arrastar e largar`,
"lable.outlook.edit.lastupc":`Último Contacto Actualizado`,
"label.weixin.registered":`Inscrição`,
"vue_label_file_history_version":`Revisões`,
"vue_label_campaign_earned":`Montante a recolher`,
"label.staticresource.useful.realtion.tip":`Abaixo está uma lista de todas as páginas do CloudCC.com com referências a este recurso estático.`,
"vue_label_file_libraray":`Bibliotecas`,
"label.department.phone":`Número de telemóvel`,
"label.emailtemplate.edit":`Editar modelo de e-mail`,
"label.processsetting.key.information.tips":`Informação chave e dicas`,
"label.summaryreport.step7":`Passo 7 Seleccionar o tipo de gráfico e o item em destaque`,
"label.chat.topic.remove.favorite":`Eliminar dos Favoritos`,
"label.campagin.roi.ksrq":`Data de início`,
"label.data.downpage.e_title.e_btn":`Ir para a página de exportação e começar a exportar`,
"label.approvaldatamove.dname":`Aprovador actual`,
"lable.Partial.attributes":`Atributo Parcial`,
"template.report.enabled.products":`Produtos activados`,
"lable.outlook.detail.cto":`CloudCC.com para Exchange`,
"label.sendemail.activity.newtasktitle":`Notificação de novas tarefas`,
"label.validate.function.funcFormat.DAY":`DIA(data)`,
"label.log.datetime.value":`Por favor introduza o tempo de consulta`,
"label.import.index.updaterecord":`Registo de actualização`,
"label.registration.page.invitation":`Convite de página de registo`,
"pagecreator_systemstyle_label_detailcolor":`Cor do texto de detalhe`,
"label.tabname.cannot.empty":`O nome do separador não pode ser nulo`,
"label.data.newtemplate.savetemp":`Pode guardar como modelo e utilizar os campos e critérios para esta exportação de dados como modelos de exportação de dados. Por favor, introduza cuidadosamente o nome e a descrição do modelo para facilitar a sua utilização.`,
"label.ems.body":`Corpo`,
"enc":`Texto Encriptado(Armazenamento Criptografado)`,
"label.profile.mobile.setup.commonSaler":`Vendas gerais`,
"label.continueselectproduct":`Continuar para escolher produtos`,
"label.event.new":`Novo Evento`,
"label.renametabandtaglib":`Renomear separador e rótulo`,
"label.qrcodelogin.message.exception":`Excepção do servidor, por favor contacte o seu administrador.`,
"label.service.gantt.locationToGantt":`Gráfico de Gantt`,
"label.mr.theLastGroup":`Este é o último grupo. Clique em "Voltar para ver a lista de registos duplicados" para ver os registos duplicados.`,
"label.report.export.format.content":`Exportar o cabeçalho do relatório actual, grupos e detalhes. O número máximo de detalhes que pode ser exportado é`,
"label.version.accountandcontact":`Contas e Contactos`,
"label.partnerCloud.financeSetting.enterMd5Key":`Por favor, introduza a chave secreta do MDS.`,
"label.login.access.quater":`Semana`,
"vue_label_commonobjects_view_searchthisview":`Pesquisar nesta lista`,
"label.import.step1.allobj":`Todos os objectos`,
"front-efficient-project-management":`O Project Cloud proporciona uma gestão completa do ciclo de vida desde o arranque do projecto, planeamento, execução, controlo até ao encerramento, optimizando o processo de gestão do projecto de acordo com as suas necessidades empresariais e ajudandoo a gerir projectos de forma eficiente.`,
"label.includedvalue":`Incluir valores`,
"label.service.newBuildDialog.past.days":`dias passados`,
"vue_label_report_sortup":`Ordenar por ordem ascendente`,
"label.appointment.wizard.subtitle3-2":`Terça-feira`,
"label.dashboard.trend":`Tendência`,
"label.schedulejob.setup.schedule.st2":`A 2ª`,
"label.view.sortview.number":`Número de registos`,
"lable.Please.enable.order":`A ordem não está activada, por favor active.`,
"label.datamanage.immediately.import":`Importação`,
"label.delete.condition":`Limpar`,
"label.dashboard.chooseDispalyOnTheHomePage":`Seleccione a página inicial a mostrar`,
"asset.accountid.contactid.required":`Cada activo precisa de ser associado a uma conta ou contacto.`,
"label.mask.character":`Máscara Carácter`,
"lable.account.Previous.FY":`Ano Fiscal Anterior`,
"chatter.attachment":`Adicionar ficheiros`,
"label.view_only":`Ver apenas`,
"label.tianyancha.name":`Nome da empresa`,
"label.service.gantt.avg.traveltime":`Tempo médio de viagem das nomeações de serviço`,
"vue_label_pool_move":`Mudança`,
"label.import.index.beforeexport":`2、Before importando, certifique-se por favor de importar todos os registos relacionados. Por exemplo, se estiver a importar registos de contacto e quiser preencher o campo de conta, que é um campo de pesquisa, precisa de criar primeiro o registo de conta que está a preencher, depois importar o registo de contacto e preencher o campo de conta com o nome ou ID do cliente correspondente.`,
"label.view.delete":`Eliminar`,
"template.detail.info.link":`Detalhes Ligação`,
"label.sendemail.send.setfail":`A configuração de informação por correio electrónico falhou, por favor preencha a informação correcta do correio electrónico.`,
"label_emailtocloudcc_redmessage11":`autenticação de SMTP fiailed. Por favor, verifique se o endereço de e-mail e a palavra-passe estão correctos.`,
"label.campaigns.memberalert":`Por favor seleccione um membro pelo menos`,
"label.schedulejob.setup.schedule.frequency":`Frequência`,
"component.newrecords.label.all":`Ver tudo`,
"label.mr.caption.opportunity":`Encontrar duplicados e fundir: Códigos para consulta de duplicados de Oportunidades`,
"chatter.group.onlyMembers":`Só os membros podem ver este grupo. E apenas o proprietário do grupo tem permissão para adicionar membros da equipa.`,
"label.recordtype.edit.selectvalue.show":`Os valores da lista de selecção são exibidos pela ordem em que são guardados.`,
"message.textmaxlength":`Comprimento ghould não deve exceder 255 caracteres`,
"label.reportsSubscriptionPage.visibility":`Funcionando como`,
"label.umeng.chatter.addcoments":`O seu posto de nuvem tem 1 nova resposta`,
"chatter.up.f":`Upload Falha,erro desconhecido.`,
"label.icon.146":`Teclado`,
"lable.custom.CY.Ago":`2 CY Ago`,
"label.tabpage.step3":`Passo 3 seleccionar os campos a exibir`,
"label.checkfield.introduce":`Defina os campos do objecto que podem ser usados para verificar duplicados, e encontre os dupilcates na lista de registos pelos campos que definir.`,
"label.tag.addtags":`Adicionar Etiquetas`,
"label.service.newBuildDialog.characterlimit":`O nome excede o limite de 25 caracteres.`,
"font-evaluate-module-v1-evquestions":`Pergunta de avaliação`,
"label.knowledge.only.update.draft":`Actualizar apenas o projecto`,
"label.partnerCloud.basicSetting.defaultCounts":`Número de funções predefinido para adicionar conta de parceiro`,
"label.chat.topic.delete":`Eliminar`,
"label.workflow.contentcondition":`os critérios são cumpridos`,
"vue_label_commonobjects_view_sortby":`Ordenar por {campo}`,
"label.passwordPolicy.setup.pwdremember24":`Lembrete (0) senha`,
"front-kefu-moudle-free-account":`Conta de teste`,
"label.marketsea.isautorecycle":`Permitir a reciclagem automática`,
"label.addattachment.view":`Ver Ficheiros`,
"vue_label_helpcenter_contact":`Nas informações detalhadas, clique no botão do diagrama em árvore junto ao contacto, pode ver o diagrama hierárquico dos contactos, compreender as relações líder-membro dos contactos relacionados, e ver algumas informações de campo de cada contacto.`,
"label.taskevent":`Actividades`,
"label.industrialandcommercialverification.message":`Acabaram-se os inquéritos gratuitos de hoje`,
"label.object.already.delete":`O objecto eliminado`,
"label.project.hit.four":`Aviso de actualização da subtarefa`,
"label.taskpagelayout":`Layouts das páginas de tarefas`,
"label.version.sum.locationfield":`Campos de geolocalização`,
"front-sales-button-toQB":`Sincronização com QuickBooks`,
"label.app.oceanblue":`Azul Oceano`,
"label.operating":`Funcionamento...`,
"label.customfields.formula.dateexample":`Data de Lembrete = FecharData - 7`,
"label.happen_delete":`O que acontece se eu apagar um formulário?`,
"label.service.appointmentList.plansToStart":`Plano de arranque`,
"label.persmets.operate.licence":`Permissão`,
"label.mobile.quickcreate.default.activities":`Calendário`,
"label.australian.eastem.standard.time":`Horário de Verão do Leste australiano （New Sul Wales）`,
"label.emailobject.remove":`REMOVER`,
"label.weixin.vote":`Votação`,
"label.reportsSubscriptionPage.condition.aggregate":`Agregado`,
"front-kefu-moudle-has-unbind":`Tem estado sem restrições`,
"chatter.group.newGroup":`Novo Grupo`,
"label.tabpage.systems":`Existem * sistemas`,
"label.textmessage.vonage.connect":`Ligar à Vonage`,
"label.campaign.channel.input.ticket":`Enviar bilhete de entrada`,
"label.ccpeak.query.sharetab":`Formulários de Partilha de Pesquisa`,
"label.reporttype":`Fonte de dados do relatório`,
"message.duplication.label.isprofiletip":`Se verificados, os dados que o utilizador actual pode ver são verificados quando se encontram duplicados. Caso contrário, verificar todos os dados.`,
"label.tianyancha.businessverify.xieyi":`Contrato de licença de utilizador CloudCC`,
"font-evaluate-module-v1-select-person":`Por favor, seleccione o pessoal de serviço ao cliente`,
"vue_label_chatter_all_groups":`Todos os grupos`,
"label.recordtype.profile.setdefault":`Fazer Default`,
"label.mr.descreption.nocondition":`Nenhuma duplicação de dados que satisfaça as condições.`,
"label.tabpage.askz":`O que gostaria de perguntar`,
"label.marketsea.selectMember":`Seleccione Membro`,
"template.report.stage.possibility.analysis":`Análise de Possibilidade de Estágio`,
"label.data.selectderivedobject":`Seleccionar o objecto a exportar`,
"label.customfields.formula.explain":`Descrição: actualmente suporta o número, percentagem, e outros campos dos quatro princípios, bem como os valores de transporte do campo de pesquisa. Por exemplo: cálculo do número: unidade*unitprice&nbsp;&nbsp;&nbsp;&nbsp;valor de transporte do campo de pesquisa:contacto__r.endereço`,
"vue_label_notice_change_fail":`A mudança falhou`,
"label.customobjects.trackoldandnewvalues":`Rastrear valores antigos e novos`,
"label.h5.leftprompt":`Tem algum conteúdo editado que não tenha sido enviado, tem a certeza de sair?`,
"label.select.field":`Campos disponíveis`,
"label.customobjects.layoutedit":`Atribuição do layout da página`,
"label.false":`FALSO`,
"UG_Forcast_07":`Permitir previsão`,
"vue_label_chatter_team_member":`membro do grupo`,
"label.tabpage.retypez":`Quando o tipo de registo é alterado, os valores da lista de opções existente não serão automaticamente alterados. recomendamos que se actualize o valor da lista de opções existente do registo no mesmo local.`,
"front-epwechat-module-v1-single-desc":`Single Sign On other ends of CloudCC through WeCom; Swift switch among all ends.`,
"label.closeandconverted":`Fechado-Convertido`,
"label.service.confirmed":`Confirmado`,
"label.partner.workspace.member.cloudcc":`Perfil CloudCC`,
"label.star.click":`Clique para limpar`,
"label.icon.135":`Moeda`,
"button_partner_workspace_login_logo_upload":`Carregar imagem`,
"message.error.sql.constraint.recordnotsingle":`Identificação externa configurada com sucesso. Motivo: este campo nos dados originais tem dados duplicados.`,
"label.ccchat.person.invite.errorpwd":`Utilizar pelo menos 8 caracteres e incluir uma combinação de números e caracteres`,
"label_tabpage_isdeleterecord":`Se apagar o registo seleccionado`,
"label.weixin.prompt.message":`Mensagem imediata`,
"vue_label_chatter_view_original_post":`Ver post original`,
"label.multilingual.tip3":`A activação da multilinguagem permite a cada utilizador da organização configurar as línguas que activou.`,
"label.dataimport.error.datetime":`Erro: O formato dos dados e do tempo está incorrecto`,
"label_tabpage_addcondition":`Acrescentar a condição`,
"label.query.detail.manageexcludeuser":`Gerir o utilizador externo`,
"label.tianyancha.creditcode":`Código de crédito social unificado`,
"label.cy.enter":`Introduza a taxa de conversão da sua moeda corporativa para esta nova moeda.`,
"label.textmessage.vonage.message1":`Ao integrarem-se com a Vonage, os utilizadores podem enviar e receber mensagens de texto na Plataforma CloudCC através da Vonage. No entanto, os utilizadores devem registar contas Vonage e comprar números de telefone antes de poderem enviar mensagens de texto.`,
"front-marketing-module-v1-share-invitation":`Convite para partilhar o pessoal`,
"label.file.items":`artigo(s)`,
"label.otherwise":`Caso contrário`,
"label.permission.detail.system":`Sistema`,
"message.success.task.emailsend":`Guardar e enviar mensagens de correio electrónico com sucesso`,
"label.the.reward.group":`Grupo de linhas de citação`,
"setup.layout.label.relatedlistsetup":`Configurações da lista relacionada`,
"label.empty":`Limpar`,
"label.weixin.cloudcc.user.binding":`Encadernação do utilizador CloudCC`,
"label.file.what.change":`O que mudou?(opcional)`,
"label.search":`Pesquisa`,
"label.mobile":`Móvel`,
"template.report.month.potential.customer":`Leads deste Mês`,
"lable.setup.mobilesetup.isEnableValidationRulesForScan":`Activar Regras de Validação ao utilizar Scan`,
"lable.outlook.list.des":`A configuração do Exchange Sync define as definições para que o CloudCC para Exchange se aplique a um grupo de utilizadores específico.`,
"label.appupload.install.error.info":`{0} "{1}" foi utilizado por {2}, por favor renomear o existente {0}.`,
"label.tabpage.addoptionsz":`Adicionar opções`,
"label.arabian.standard.time":`Tempo Padrão da Arábia`,
"label.thefirst":`A 1ª Coluna`,
"label_partner_workspace_login_footertext":`Texto do rodapé`,
"lable.Disabled.successfully":`Desactivar com sucesso.`,
"label.confirm.del":`Os registos de aprovação pendentes, tem a certeza de que quer apagar?`,
"vue_label_normal_reregister":`Login novamente`,
"label_file_img":`Imagem`,
"label.salescloud.salesdashboard.sales.behavior":`Actividades de vendas`,
"label.startdate":`Data de início`,
"label.field.duplicate.error.msg5":`Por favor verifique todos os erros abaixo, tente novamente após a modificação.`,
"setup.main2018.label.managesetup":`Definições de administração`,
"label.forecast.editshrepage.title":`Nova Partilha`,
"UG.solution.01":`Fornecer a solução`,
"label.knowledgebase.data.recovery.successfully":`Recuperar {a} dados com sucesso`,
"label.pc.ui.2018.myccchat":`O meu CCChat`,
"label.attachement":`Notas`,
"message.mobilechooseatmostten":`Seleccionar até 10 campos`,
"label.campagin.roi.bhzeywjh":`Oportunidades totais`,
"label.autoresponserule":`Regras de Auto-Resposta`,
"label.attendance.yuyue":`Não tem uma marcação, registe-se agora`,
"label.insert":`Inserir`,
"label.service.ganttBaiduMap.shutDown":`Quer fechar?`,
"label.icon.194":`TV`,
"message.serviceterritory.violation":`Violação de zona: zona de recursos não é equiparada a zona de serviço de nomeação.`,
"label.appointment.disable.function":`Função de Desactivação`,
"lable.currencyManage.manageexchangeRate.dis":`Para gerir taxas de câmbio datadas para a sua organização, clique em Gerir Taxas de Câmbio Datadas. As taxas de câmbio datadas são utilizadas em oportunidades, produtos de oportunidade, e os relatórios associados a estes dois objectos.`,
"vue_label_file_upload_tip_newmsg":`Menos de {tamanho} Recomenda-se que o ficheiro MB seja carregado, ou podem resultar problemas de carregamento lento.`,
"label.event.next.week":`Semana seguinte`,
"label.datamanage.import.contactfield":`Na tabela seguinte, seleccione os campos no ficheiro importado que devem ser importados para cada contacto. Em seguida, clicar em Next:`,
"label.projectManagement.time.allocated":`Tempo atribuído`,
"label_tabpage_isdeleteview":`Tem a certeza de apagar esta vista?`,
"label.pc.ui.2018.search":`PESQUISA...`,
"label.role.createrolelevel":`Criação da Hierarquia de Papéis`,
"label.tabpage.editview":`Vista de edição`,
"label_partner_common_manageSetup":`Configurações administrativas da nuvem de parceiros`,
"label.service.gantt.noservice.resource":`Não foram encontrados recursos de serviço disponíveis sob o território de serviço seleccionado.`,
"message.numbertoolarge":`O número é demasiado grande`,
"label.sendsms.success":`O texto foi enviado com sucesso`,
"UG.opportunity.009":`Ou`,
"label.ccpeak.construction.dataobj":`para construir um objecto de dados, o nome API do objecto deve ser passado em`,
"front-lighting-module-v1-detail-file-uploadInfo":`O registo está bloqueado e não está disponível para o carregamento de ficheiros. Por favor contactar o administrador para desbloquear.`,
"label.import.page2.newnotmatchfiled":`Um total de campos {{{{csvfiledlength }} no ficheiro. {{{este.csvfiledlength - this.selectlength}}} não mapeado.`,
"label.ems.inputmailss":`Receber servidor de e-mail`,
"label.knowledgebase.data.published.successfully":`Publicar {a} dados com sucesso`,
"label_emailtocloudcc_position":`Posição`,
"label.data.exp.customexp":`Exportação personalizada`,
"component_chatter_post_button_user":`Acrescentar pessoas`,
"label.new.visualpagefolder":`Página Personalizada : Nova Pasta`,
"label.forecast.shrepage.classdes":`Descrição dos níveis de acesso`,
"label.task.overdue.unfinished":`Tarefas não processadas atrasadas`,
"label.ccchat.micropost.isedit.setting.info":`O autor do post ou comentário, o proprietário do registo, o moderador do CCChat, e o moderador desta comunidade têm todos permissão para modificar este texto.`,
"label.recordname":`Nome do registo`,
"label.posted_your":`e afixado no seu`,
"label.globaloperation.operationtype.custom.page":`Página personalizada`,
"label_tabpage_busoppnamez":`Nome da oportunidade de negócio`,
"front-epwechat-module-v1-schedule-desc":`Sincronizar horários e eventos da WeCom e CloudCC`,
"label.escalation.setup.newentries.lastmodifydate":`Com base no tempo de última modificação`,
"setup_layout_label_nofield":`Nenhum campo disponível`,
"label.sendemail.registIMUser.logininfo":`O portal da nuvem de parceiros que pode entrar é como abaixo:<br>`,
"label.weixin..xsld.kehu":`Contas`,
"label.display_thank":`Mostrar página de agradecimento`,
"label.group.no.my.group":`Não há correspondência no meu grupo.`,
"label.partnerCloud.newBuildSite.enterDomain":`Por favor, introduza o nome de domínio`,
"label.step1.total2":`Etapa 1 de 2`,
"label.ccpeak.delete.record":`Apagar os registos:`,
"label.customer.tab.step1.introduce":`Escolha o objecto personalizado para este novo separador personalizado. Preencher outros detalhes.`,
"label_tabpage_newInterfacez":`A nova interface`,
"setup.mainpage.label.manageuser":`Gerir Utilizadores`,
"label.partnerCloud.partnerAccount.completed":`Pagamento concluído?`,
"label.projectManagement.kanban":`Tarefa Kanban`,
"label.operate":`Acção`,
"label.service.dispatchingUnits.selected.time.range":`Mostrar as marcações de serviço dentro do intervalo de tempo seleccionado.`,
"component_setup_label_pagesize":`Números apresentados em cada página`,
"font-evaluate-module-v1-email-evaluation-settings":`Configuração de Avaliação por Email`,
"label.service.dispatchingUnits.skills":`Habilidade`,
"label.editrecurrencetimetrigger":`Edição do Disparador de Tempo Periódico`,
"vue_label_file_edit_lib":`Editar biblioteca de ficheiros`,
"label.campaignmember.selectmember.deleteconc":`Campanha: retirar membros dos contactos`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.monday":`Segunda-feira`,
"front-detail-module-v1-by":`por`,
"label.mobile.home.page.date.signed":`Data de fecho`,
"label.apply.send.success":`Enviar sucesso.`,
"label.app.choseimg":`Escolher logotipo`,
"label.customsetting.visible":`Visibilidade`,
"label.sendemail.activity.task.distributetaskcompleted":`A tarefa que atribuiu a #belongtoidccname foi concluída.`,
"label.dashboard.snapshot.refreshing":`Refrescante`,
"label.document.name.already.exists":`Este Documento Nome Único já existe.`,
"label.ccchat.person.invite.needlastname":`Digite o seu apelido`,
"pagecreator_page_button_copy":`Cópia`,
"label.appointmentpage.wizard.subtitle1-2":`Semana Anterior`,
"label.validate.function.funcFormat.MILLISECOND":`MILLISECOND(data)`,
"label.profile.allowtocreateview":`Criar Vistas`,
"message.error.recordid":`A identificação do registo não pode estar vazia`,
"lable.SalesCommitmentKanBan.returnToTheSuperiorRole":`Voltar ao Papel Superior`,
"label.translation.start3":`Se necessário, seleccionar um objecto. Por exemplo, uma tarefa de fluxo de trabalho tem um objecto (Conta, Contacto, etc.) para filtrar para termos traduzíveis.`,
"label.ccpeak.send.email":`Enviar um e-mail para notificação:`,
"vue_label_commonobjects_detail_activity_noexpirationdate":`Sem data de expiração`,
"label.permission.objectpermission.objpermission":`Definições de Permissões de Objectos`,
"label.version.custom.report":`Relatórios Padrão(Página Personalizada)`,
"label.title.qrcodeOrbarcode":`Gerar Código de Barras/Código de barras/QR`,
"label.emailtocloudcc.step2.name":`Configurar a propriedade do e-mail`,
"label.reportsSubscription.edited.successfully":`Editar a assinatura do relatório com sucesso!`,
"label_tabpage_kanbansetup":`Configuração do painel de visualização`,
"label.tianyancha.regcapital":`Capital registado`,
"front-epwechat-module-v1-web-single":`Sítio único na Web:`,
"label.visualpage.display.top":`exibir cabeçalho, falso - não exibir cabeçalho`,
"label.customfields.fielddependency.selectcell":`Seleccione pelo menos uma célula da lista abaixo`,
"label.paging.addmember.totalofpages":`Um total de {0} artigo(s)`,
"label.email.saveing":`Os dados estão a salvar...`,
"label.userinfo.doublepwd.notnull":`Deve repetir a sua palavra-passe.`,
"label.appointment.wizard.subtitle4-4-2":`2 semanas`,
"label.chatter.BCC":`Bcc (cópia cega de cortesia)`,
"label.emailtocloudcc.description":`Ligue a sua conta de correio electrónico empresarial, tal como sales@company.com, info@company.com, support@company.com. Registe automaticamente os e-mails que recebeu como leads e registos de casos no CloudCC para assegurar um acompanhamento atempado das cartas dos clientes.`,
"label.sendemail.send.atlastone":`Deve seleccionar pelo menos um destinatário.`,
"label.mobile.phone.subordinate":`Incluir os subordinados`,
"label.data.choses.e_desc":`De acordo com as suas necessidades, pode exportar todos os dados ou exportar dados de um objecto.`,
"chatter.new":`Notícias`,
"vue_label_help_back":`Voltar`,
"label.skipwizardintro":`O Jump Start Wizard cria um processo de aprovação de uma etapa para si em apenas alguns minutos.`,
"label.weixin.fmu.before.week":`{0} semana(s) seguinte(s)`,
"label.sendemail.chat.praiseFeedsubject":`CloudCC CCChat gostou do seu posto`,
"lable.currencyAdv.andafterdate":`e depois de`,
"label.sometoprocess":`Se apenas determinados tipos de registos devem entrar neste processo de aprovação, introduza os critérios abaixo. Por exemplo, apenas os relatórios de despesas dos funcionários na sede devem utilizar este processo de aprovação.`,
"label.campaignmember.main.updateleaddesc":`Actualizar o estado de todas as pistas de uma só vez`,
"label_partner_common_roleSetup":`Nuvem de parceiros e definições do utilizador`,
"label.console.step5.no":`Escolha Como os Registos são Mostrados`,
"label.salescloud.teamrole.optionlist.account":`Adicionar membro da equipa de contas a`,
"Report.Delete.Confirm.Title":`Por favor confirme`,
"label.onclick":`Clique`,
"label.weixin.input.identifying.code":`Por favor introduza o código de verificação`,
"label.knowledge.translate":`Apenas o artigo de conhecimento da edição principal no estatuto de Rascunho ou Publicado pode ser traduzido.`,
"label.log.ip":`IP`,
"front-electronic-export-goResult":`Check in Mailchimp`,
"label.escalation.setup.newaction.otheremail.otheremail":`Emails adicionais`,
"label.icon.104":`Horário`,
"label.partnerCloud.exceedTwo":`A foto de perfil carregada não pode exceder os 2MB!`,
"label_tabpage_thevalurofz":`O valor de`,
"front-lightning-module-v1-details-page-chart-maximum":`Podem ser introduzidos até 50 caracteres.`,
"label.data.downpage.i.title.num6":`Recomenda-se que importe um ficheiro de teste contendo 5 registos antes de importar os dados, para garantir que os dados que pretende importar estão correctos.`,
"label.ccpeak.update.record":`Modificar Registos`,
"label.dataimportandexport":`Importação e Exportação de Dados`,
"label.tabpage.notexceed25":`O registo seleccionado não deve exceder 25`,
"label.starting":`Em curso`,
"label.knowledge.language.spanish":`Espanhol`,
"label_emailtocloudcc_set":`Definir informação da caixa de correio`,
"message.oneormoreneedsreport":`Por favor, elimine a montagem do painel de instrumentos de referência para o relatório, e depois tente novamente.`,
"label.attendance.xccheckin":`Check In`,
"label.emailmerge.editfolder.title":`Pastas de modelos para fusão de correio`,
"template.report.year.customer":`Leads deste ano`,
"label.partner.common.webSit.memo":`Nome de domínio predefinido da nuvem de parceiros da sua organização:`,
"label.partnerCloud.financeSetting.onlinePayment":`Pagamento Online`,
"Pagelayout.Setup.001":`Por favor, seleccione as listas relacionadas que seriam exibidas no esquema de flutuação.`,
"front-kefu-moudle-time-length":`Duração`,
"label.deleteObject":`O objecto é eliminado.`,
"label.setup.mobile.homepageshortcuts.select":`Seleccionar 4 fucções rápidas para mostrar na área superior da __ página inicial`,
"setup.mainpage.label.welcome26":`Gestão de dados - Processamento em lote`,
"label.ServiceCloud.yuyuebainhao":`Nomeação de serviço nº.`,
"label.emailobject.emaildetail.button.addtolead":`Adicionar aos Leads`,
"label.event.single.view":`Vista de Utilizador Único`,
"lable.product.pricebooks.ustand":`Escolher Preço Normal`,
"label.emailtocloudcc.department":`Departamento`,
"component_assistant_label_30daysnoact":`30 dias sem qualquer campanha`,
"label.weixin.no.pending.qzkh.qin":`Lamentamos, mas não há pistas para mostrar.`,
"label.vlidaterule.formula":`Fórmula de condição de erro`,
"label.tianyancha.h5.contact":`Informação de contacto`,
"label.button":`Botões`,
"message.checkemail":`<é forte>Error:</strong> há um erro no seu e-mail introduzido, por favor verifique.`,
"lable.account.previous.CY":`CY anterior`,
"label.icon.13":`Serviço`,
"chatter.coll.c":`Remover Bookmark`,
"label.knowledge.category.hint.four":`Atribuição de Categoria de Dados`,
"label.tianyancha.phonenumber":`Número de telefone`,
"label.tablayoutedit.remark":`Seleccionar os campos e páginas personalizadas exibidas na página inicial do separador.`,
"label.shareusers":`Partilhar com os utilizadores`,
"label.endtime":`Fim`,
"label.length":`Comprimento`,
"label.umeng.activity.event.begin":`começar depois de`,
"label.tabpage.alltabs":`Todos os separadores`,
"label.exact.query":`Pesquisa Avançada`,
"label.weixin.skip":`Saltar para`,
"label.ems.cancel":`Cancelar`,
"label.trigger":`Gatilhos`,
"label.exchange.sync.setting":`Configuração do Exchange Sync`,
"label.product.pricebooks.name":`Nome do Livro de Preços`,
"label.relation.list.total":`Seleccionado`,
"label.step2.total7":`Etapa 2 de 7`,
"label.martrixreport.2018.step6.new":`Passo 6 Seleccionar o tipo de gráfico e o item em destaque`,
"label.standard.buttonandlink.override":`Largura de substituição`,
"front-console-conversation-btn4":`Separar como Caso Novo`,
"vue_label_dashboard_range":`gama`,
"label.app.sort.show":`O pedido é apresentado na ordem guardada.`,
"label.salescloud.teamrole.choose.correct":`Duplicar os utilizadores seleccionados, por favor corrigir`,
"label.schedule_post":`Publique`,
"front-kefu-moudle-server-request-num":`Lista de Pedidos de Serviço N.º.`,
"label.h5.logout":`Sair`,
"label.weixin.horse.club.member.message":`Informação aos membros da Aid-Max`,
"label.field.addoptionlist.introduce":`Introduza um ou mais valores da lista de selecção abaixo, com cada valor separado por uma nova linha.`,
"setup_layout_label_setupfield":`Propriedades de campo`,
"label.chatter.nextStep":`Próximo Passo`,
"label.quickbooks.searchlist.total1":`Existem {0} facturas sem ligação para um valor total de {1}`,
"label.tianyancha.h5.regcapital":`Capital registado`,
"label.icon.184":`Consultoria`,
"label.dashboard.message.refreshtoomush":`A fotografia do painel de instrumentos é actualizada com demasiada frequência, por favor actualize-a mais tarde`,
"label.umeng.approval.reject":`#approver rejeitou o seu pedido de aprovação #obj.`,
"label.h5.chatter.newmessage":`Introduzir uma nova mensagem`,
"message.error.relationid":`relationid não pode estar vazio!`,
"label.setup.mobile.offlinecache.selectdefault":`Seleccionar os separadores como os separadores padrão da cache offline`,
"label.setup.mobile.homepageshortcuts.saveprompt":`Por favor seleccione 4 funções rápidas.`,
"label.projectManagement.Selectmonth":`Seleccione o mês`,
"label.version.ultimate":`Edição final`,
"label.validate.remark5":`Os campos de data obrigatórios estão na ordem correcta, por exemplo: a hora de início deve ser menor do que a hora final`,
"label.version.nowis":`A sua versão actual do CloudCC é`,
"front-kefu-moudle-CRM-set":`Configuração de CRM`,
"label.mr.title.customerAddress":`Endereço de conta`,
"label_emailtocloudcc_step1_name":`Escolha Função`,
"label.time.operation.edit":`Modificar os empregos programados`,
"label_tabpage_operationz":`Campo, a operação não pode estar vazia`,
"label.translation.start4":`Faça duplo clique na coluna de tradução para introduzir novos valores.`,
"vue_label_systemSettings_request":`Pedido de Transferência por Lote`,
"label.maintenance.notice":`Nota de manutenção`,
"label.customfields.txet.textlength.tip":`Por favor insira o comprimento máximo para um campo de texto abaixo E o comprimento máximo é de 255 caracteres.`,
"label.ccdocument.select.template.open":`Por favor, seleccione o modelo a abrir.`,
"vue_label_display_date_field":`Mostrar campos de datas`,
"label_partner_workspace_tab":`Tab`,
"lable.account.LasthDays":`Últimos 120 dias`,
"chatter.using.sticker":`Activar o rastreio de alimentação`,
"message.save.dataerror":`Erro: guardar o erro causado por um longo comprimento de dados ou outros problemas. Por favor, modificar os dados para os salvar novamente.`,
"vue_label_commonobjects_view_chart_newchart":`Nova Carta`,
"label.chat.micropost.a.group":`Grupo`,
"lable.currencyManage.advcurrencyunEnabled":`A Gestão Avançada de Moeda não está activada`,
"label.appexchange.workflow":`Regras de fluxo de trabalho`,
"vue_label_calendar_show_details_and_add_events":`Mostrar detalhes e adicionar eventos`,
"label.salescloud.optionlist.inputname":`Por favor introduza o nome do valor da lista de selecção`,
"label.dashboard.folder":`Pastas`,
"label.knowledgebase.permanently.remove.articles":`A eliminação do artigo arquivado provocará também a eliminação permanente de outras versões relavantes.`,
"label.emailtocloudcc.titel":`Email para CloudCC`,
"label.visualpage.sel":`Páginas Personalizadas Nesta Pasta`,
"label.planned.all.work":`Todos os Trabalhos Planeados`,
"label.weixin.agree.agreement":`Concordar com o acordo relevante`,
"label.forecast.customforecast.qsn":`Ano de início`,
"label.appupload.managed":`Controlado`,
"template.report.folder.sale.index":`Análise de indicadores de vendas`,
"UG_opportunity_011":`Transacção de importação`,
"label.validate.function.funcFormat.SECOND":`SEGUNDO(data)`,
"UG_homepage_005":`Inteligência de vendas`,
"label.clicktoreturn":`Clique aqui para voltar`,
"label.collectionofview":`Conjuntos de Vista`,
"com.cloudcc.login.error.message.nonuser":`A sua identificação não existe`,
"vue_label_systemSettings_emailsetting":`Configuração de email`,
"vue_label_email_mark_as":`Marcar como`,
"label.tabpage.customernamez":`Nome do cliente`,
"label.appupload.install.apicannotsame":`O novo nome da api não pode ser o mesmo que o valor original`,
"label.task.all.undealt":`Todas as Tarefas em atraso não processadas`,
"front-lightning-module-v1-dashborad-statistical-indicators":`Índice estatístico`,
"UG.quota.02":`Fase de mudança de oportunidade`,
"label.approve":`Aprovar`,
"vue_label_calendar_remove_calendar":`Remover Calendário`,
"label.mr.title.contactName":`Nome de contacto`,
"label.projectManagement.resource":`Gestão dos recursos`,
"label.rejectbehaviour1":`Permitir que o autorizador escolha manualmente o número do passo de volta.  (voltar ao passo anterior N)`,
"label.publicgroup.relationship":`Adesão em grupo`,
"Lead.Scoring.DetailedPage.Popup.Title":`Insight de chumbo`,
"label.owner.edit":`Proprietário Editar`,
"label.campaign.channel.ticket.mark":`NOTA: Guarde o código QR no álbum de fotografias utilizando a captura de ecrã do telemóvel ou guardeo no telemóvel e introduza a campanha com o código QR.`,
"label.opportunity.setting.showstage.info":`Se mostrar o palco de oportunidades na aplicação CloudCC.`,
"label.emailobject.wizard.desc3":`Poupe tempo utilizando modelos de e-mail`,
"label.cpq.quote.no.product.add":`Nenhum produto adicionado na citação. Por favor adicione produto antes de gerar encomendas.`,
"label.customer.tab":`Separadores personalizados`,
"Opportunity_Detailed_Phase_Label_Popup_002":`Data de encerramento do Estágio Actual`,
"component_telerecord_label_name":`Nomes`,
"label_component_helper_nodata":`Nada precisa da sua atenção neste momento. por favor, volte a verificar mais tarde.`,
"label.dashboardSetup.d2":`Ponto de quebra 2`,
"setup.mainpage.label.welcome4":`Instruções: Clique no menu do lado esquerdo da página → Application Settings → Create → Object.`,
"label.step4.total5":`Passo 4 de 5`,
"label.payment.the.remaining.days":`A sua licença expira dentro de {0} dias`,
"label.encoding":`Codificação`,
"label.setting.intergrationlist.status2":`Esta integração está actualmente instalada.`,
"label.new":`Novo`,
"label.search.searchsetup":`Definições de pesquisa`,
"label_tabpage_printz":`Imprimir`,
"report.type.label.customService":`Apoio ao Cliente`,
"label.notification.addEmailObject.message":`Recebeu um e-mail de {!fromaddress}, clique para ver mais detalhes`,
"label.icon.68":`Máquina`,
"UG.Lead.003":`Social`,
"label_mobile_default_field_service_home":`Página inicial do Service Cloud`,
"label.select.one.group":`Por favor escolha pelo menos um grupo de linhas de cotação.`,
"front-kefu-moudle-trkey-nopower":`O par de chaves de Tianrun não tem permissões atribuídas`,
"label.chatter.cancel":`Cancelar`,
"label.weixin.report.optiondisplay":`Mostrar`,
"front-kefu-moudle-v1-System-version":`Versão do sistema:`,
"lable.product.pricebooks.editall":`Editar Tudo`,
"label.group.no.recent3":`ou`,
"label.knowledge.article.delete":`Erro ao apagar o artigo de conhecimento.`,
"label.relateobj":`Relacionado com`,
"workflow.action.tasks.assignortype.type":`Tipo`,
"label.layout.selectedfields":`Campos Seleccionados`,
"label.role.assign.operate":`Atribua outros utilizadores a esta função:<ul>>li>Clique na lista pendente para ver todos os utilizadores disponíveis.</li>>li>Seleccione um utilizador à esquerda na lista "Utilizadores Disponíveis" e adicione-os à lista "Utilizadores Seleccionados".</li></ul>`,
"label.field.insert":`Inserir Campo`,
"label.icon.11":`Pessoas`,
"label.group.no.recent4":`iniciar um grupo.`,
"front-epwechat-module-v1-input-corpid":`Por favor, introduza Corpld`,
"setup_object_field_dependency_label_actionfieldnotnull":`Por favor, seleccione primeiro um campo de controlo.`,
"setup.mainpage.label.welcome19":`Instruções:  Clique no menu do lado esquerdo desta página → Manage Settings → Manage Users → Users, Roles, Profiles`,
"label.escalation.setup.list.rulename":`Nome da Regra`,
"label.ems.addaccount":`Adicionar conta agora`,
"label.reportsSubscription.details.only":`Apenas detalhes (formato Excel .xlsx)`,
"vue_label_commonobjects_view_groupby":`Agrupar por`,
"label.email.form.text":`Apenas texto`,
"label.weixin.loginname":`Nome de Login`,
"label.forecast.settings.sr":`Receitas`,
"label.chatter.sendEmailToGroupMember.subject.F":`{0} mensagens publicadas para todos em {1}`,
"label.ccchat.enter.subject":`Por favor, introduza o assunto da votação`,
"label.customer.tab.introduce":`Os separadores de objectos personalizados parecem e comportam-se como os separadores padrão fornecidos com o CloudCC.`,
"message.login.mfaverification.wrong":`Erro de código de segurança.`,
"component.newrecords.label.name":`Nome`,
"label.salescloud.opportunity.addandedit.contactrole":`Adicionar e editar funções de contacto`,
"label_emailtocloudcc_button_next":`Próximo`,
"label.console.step5":`Passo 5 Escolher como os registos são exibidos`,
"setup.main2018.label.norole":`Não tem as permissões administrativas`,
"template.chart.ywjhqd":`Fase de Oportunidade de Negócio`,
"label.instrumentPanel.breakpointOneLabelname":`Este valor deve ser maior do que o valor mínimo.`,
"label.qrcode":`Código QR`,
"label_tabpage_no2z":`No2`,
"label.log.search.date.range":`O ciclo de uma consulta não pode ser mais longo do que {c} meses.`,
"label.console.step7":`Passo 7 Atribuir perfil`,
"label.australian.central.standard.time":`Hora Padrão Central Australiana （Northern Territory）`,
"label_tabpage_deleteviewfailed":`Ver apagar falhou`,
"vue_label_commonobjects_view_searchview":`Pesquisar nesta vista`,
"message.error.object.notexists":`O objecto não existe.`,
"label.tablecell":`Células`,
"vue_label_notice_edit_success":`Editar com sucesso`,
"label.customer.language":`Língua por defeito`,
"label.csrf":`Activar a Protecção de Segurança csrf`,
"label.forecast.customforecast.submit.zhi":`para`,
"label.sso.saml.idp.config.desc2":`Clique Enable Identity Provider para permitir a sua organização CloudCC.com como fornecedor de identidade.`,
"label.export_data":`Dados de exportação`,
"component.todaytask.label.all":`Ver tudo`,
"label.h5.chatter.record":`Histórico`,
"front-vew-email-verification":`Ver email e verificar conta. Só pode iniciar sessão depois de confirmar o email.`,
"laber.marketsea.del.error":`O reservatório de chumbo está ocupado e não pode ser apagado`,
"vue_label_notice_homepage_entername":`Por favor introduza o nome modificado`,
"UG.Forcast.01":`Previsão`,
"front-email-payment-tips":`O montante da factura está vazio. Por favor, iniciar o pagamento online após preencher o montante da factura.`,
"setup.mainpage.label.welcome2":`Base de dados personalizada (objecto)`,
"APPIntegration.Social.facebookerror":`Deve introduzir um URL válido para facebook.com`,
"label.profile.mobile.setup.stand":`Página inicial padrão`,
"label.custom.CY":`Ano Personalizado`,
"label.knowledgebase.publishing.conditions":`Puxar {a} os dados falharam, estão fora dos critérios de publicação!`,
"label.tianyancha.description":`Permitir a TianYanCha verificar a verificação de dados industriais e comerciais. Este serviço suporta os dados comerciais registados na China Continental.`,
"label.appexchange.uninstallpage.title":`Desinstalar o pacote irá:`,
"label.currencyRate":`Taxa de Conversão`,
"setup_layout_label_areashow":`Mostrar cabeçalho da secção ligada`,
"label.setup.case.setting":`Mini Programa para o caso`,
"vue_label_commonobjects_view_fixed_at_most":`Apenas três colunas podem ser fixadas, no máximo`,
"template.report.month.income":`Receita deste Mês`,
"label.sms.companyname":`Nome da empresa`,
"label.sendemail.registIMUser.waitmessage":`Infelizmente, não tem um portal na nuvem de parceiros que possa entrar. por favor aguarde, o nosso administrador irá notificá-lo mais tarde. pode visitar o endereço especificado para entrar na página de início de sessão. use o nome de utilizador e palavra-passe acima para entrar.`,
"label.custom.field.task.object":`Uma tarefa atribuída a si. Tarefa sbject:`,
"message.pleaseselectdayinweek":`Por favor, seleccione um dia da semana.`,
"label.chat.topic.favorites":`Favoritos`,
"UG.Campaign.004":`Campanha de importação`,
"label.approval.preview":`Pré-visualização do processo`,
"label.knowledgebase.assign.articles.to.people.or.queues":`Escolher a línguaalvo e atribuir o artigo à pessoa em questão ou fila de espera. A exportação de tradução é normalmente atribuída a uma fila, e os artigos traduzidos internamente vão para uma pessoa.`,
"pagecreator_systemstyle_message_save_success":`Estilo guardado com sucesso`,
"label.outline":`Esboço`,
"label.read.only.field":`Campos só de leitura`,
"front-gantt-module-v1-early-warning":`Alerta Precoce`,
"label.file.ccchat.selectfrompc":`Seleccione um ficheiro a partir do seu computador`,
"vue_label_systemSettings_social":`Meios de comunicação social`,
"label_report_year_last_year":`Ano após Ano`,
"lable.PowerProcess.Meet.the.conditions":`Devem ser cumpridos os seguintes critérios:`,
"label.changemydisplay.list.title":`Mostrar`,
"UG_Forcast_03":`Iniciar o planeamento e executar estratégias empresariais. <br>Desejo-lhe uma boa previsão!`,
"label.sendemail.chat.sendmessage":`Caro #nome:{\i1}nome: olá! #userName:{\i}enviou-lhe uma mensagem.`,
"label.huanxinconfig.secretid.lost":`o segredo não pode estar vazio`,
"label.icon.49":`Geração de energia`,
"chatter.feed.button.publish":`Partilhar`,
"label.power":`^Potência`,
"label.partnerCloud.financeSetting.informationThree":`3. Após entrar na página de gestão de chaves secretas, clique em mapi Gateway Product Key, e adquira a ID do parceiro e a chave secreta MDS.`,
"label.emailtocloudcc.step1.lead2":`Uma vez configurado, os e-mails recebidos nesta caixa de correio serão automaticamente registados como registos de chumbo no CloudCC. Assegure-se de que nenhum negócio é perdido.`,
"label.knowledgebase.delete.draft.succeeded":`Eliminar o rascunho com sucesso`,
"label.dashboardSetup.title":`Editor de componentes`,
"label.trigger.operation.email.template.map":`Voltar à informação do modelo, assunto do e-mail: m.get("assunto"); conteúdo do e-mail: m.get("contexto"); se o tipo de e-mail é texto: m.get("istext")`,
"label.dependencesearchfilter":`Filtros de pesquisa relacionados`,
"label.selected.search.length":`Não mais do que 10 campos de pesquisa seleccionados`,
"label.profile.commonusercontrol":`Permissões gerais do utilizador`,
"lable.Microsoft.YaHei":`Microsoft YaHei`,
"label.appupload.component.type.app":`App`,
"label.customsetting.manage.position":`Localização`,
"vue_label_systemSettings_bindweb":`Ligar Web`,
"label.loginservice.license.notexist":`A licença não existe.`,
"label.icon.43":`Sinos`,
"UG_homepage_003":`Vista de 360 graus`,
"label.file_format":`Formato do ficheiro`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.sunday":`Domingo`,
"vue_label_chatter_post_has_delete":`Post foi eliminado`,
"report_label_searchresult":`Resultados da pesquisa`,
"label.tabpage.justsz":`Apenas`,
"Lead_Scoring_Setting_LevelSetting":`Configurações de Popularidade de Liderança`,
"setup.object.field.dependency.label.selectedfieldvalue":`Valores de campo disponíveis`,
"label.search.morelistview":`Mais vista de lista`,
"vue_label_homepage_won":`Fechado`,
"label.notification.last30days":`Últimos 30 dias`,
"vue_label_helpcenter_pool":`Utilize o pool de leads e o pool de contas para gerir os seus dados de vendas.<br>Criar o pool de contas<br> Criar o pool de contas em segundo plano, configurar os administradores e membros do pool de contas, e configurar as regras de reciclagem automática em atraso, o que é conveniente para gerir a situação de acompanhamento de oportunidades dentro da sua equipa e encorajar os membros da equipa a acompanharem activamente a situação.<br>Gerir manualmente os dados<br> O administrador do pool de contas pode realizar operações tais como distribuição, reciclagem, eliminação e transferência de registos no pool de contas, e gerir os registos no pool de contas de uma forma unificada;<br> Os membros do pool de contas podem receber registos não atribuídos ou visualizar os registos pelos quais são responsáveis.`,
"label.emailsync.status.export":`Exportar como ficheiro em formato Excel_csv`,
"label.service.miniProgram.slideshowTitle":`Carrossel`,
"label.service.miniProgram.slideshowName":`Nome do carrossel`,
"label.fieldupdate.selectobj":`Defina o objecto associado à actualização do campo, depois clique em Next. As actualizações de campo só podem ser associadas a regras de fluxo de trabalho e processos de aprovação do mesmo tipo.`,
"label.ccpeak.take.notice.sharetab":`Nota: os campos na expressão do formulário partilhado não requerem a adição de "__c".`,
"label.log.startdate.after.endate":`A hora de início não deve ser posterior à hora de fim.`,
"label.rememberme":`Recordar-me`,
"label.partner.all.maxNum":`Maiores dados de nuvens de popa:`,
"component.setup.iframe.label.inputurl":`Introduza o endereço url`,
"label.h5.systemmessage":`Mensagem do sistema`,
"label.delete.date":`Apagar Data`,
"front-email-payment-select-month-tips":`Por favor escolha MM`,
"front-kefu-moudle-bind-userinfo":`Informação do Utilizador Bind`,
"label.appointment.wizard.notif2":`您需要在创建日程预约前先设定好一个预约的时长`,
"label.custom.field.maping.number":`O número de dígitos de chumbo não pode ser maior do que o número de dígitos de campo mapeados.`,
"label.event.dayview":`Vista do dia`,
"label.replace":`Substituir`,
"label.knowledgebase.search.knowledge.articles":`Artigo de Pesquisa de Conhecimento`,
"component_event_label_soon":`Imediatamente`,
"label.imgfield.upload":`Carregar imagem`,
"message.printable.view":`Vista para impressão`,
"vue_label_notice_uploadavatar_notice1":`O tamanho da imagem do avatar carregado não pode exceder 2MB`,
"label.visualpage.developer.help":`Ajuda para o criador da página personalizada`,
"label.validate.function.funcFormat.IF":`IF(teste_lógico, valor_se_verdadeiro, valor_se_falso)`,
"label.sso.saml.sp.description1":`Definições de Single Sign-On`,
"vue_label_calendar_step_1":`Passo 1: Nomear o Calendário`,
"component.telerecord.button.save":`Guardar`,
"setup_mainpage_button_manageobject":`Gestão de objectos`,
"label.marketingactivityinfluence":`Influência da campanha`,
"label.quote.bjjsxx":`Informação sobre a aceitação de cotações`,
"label.appupload.upload.install.retry":`Reinstalar`,
"label.layout.assignrules":`Regras de Atribuição`,
"UG.Lead.006":`Visitante do website`,
"label.workmate.searchs":`Pesquisar colegas`,
"label.visualpage_list.no":`Sem permissões de acesso às páginas personalizadas`,
"label.service.miniProgram.slideshowintroduce":`O nome do carrossel só é utilizado para identificar múltiplas entradas de anúncio e não é exibido no anúncio.`,
"label.multilang.messagedetail.search.desc":`Não conseguimos encontrar uma mensagem com {0}:`,
"label.mobile.phone.read.note":`Por favor introduza aqui as notas`,
"label.passwordPolicy.setup.isUsingGotp":`Habilitar Login Verificação Secundária`,
"message.datetypeerror":`<é forte>Error: </strong> Data inválida`,
"label.searchlayout.listview.button":`Botões apresentados em vistas de lista.`,
"label.sectionpart":`Secção`,
"label.partnerCloud.basicSetting.userSetting":`Configuração de funções e utilizadores`,
"System_Data_Import_Warning_MaxCount":`A sua organização só pode importar {0} dados de cada vez, o que agora está fora do limite, por favor ajuste e reimporte.`,
"label.datamove.qualified.record":`registo(s) qualificado(s),cada vez pode transferir no máximo 100 registos`,
"component_task_label_priority":`Prioridade`,
"vue_label_report_me":`Eu`,
"label.college.duplicate.option":`As opções não podem ser repetidas!`,
"label.pw.letter":`Cartas`,
"label.file.sharedwithme":`Partilhado comigo`,
"label.translation":`Traduzir`,
"lable.currencyAdv.exchagecurrency.before":`e antes de`,
"label.file.share":`Partilhar`,
"label.page.next":`Próximo`,
"label.autoRegister.changepwd.setpwd.notmatch":`Duas palavras-passe são inconsistentes`,
"label.tabpage.include":``,
"front-email-payment-thanks":`Obrigado`,
"vue_label_help_helponthispage":`Ajuda nesta página`,
"label.approvepagelayout":`Layout da Página de Aprovação`,
"vue_lightning_help_zero_distance_communication":`O apoio em linha ajudá-lo-á a poupar tempo, contactando especialistas do serviço CloudCC com distância zero.`,
"vue_label_normal_case_sf":`Caso`,
"label.report.line.tuozhuai":`Por favor, arraste e solte, ou faça duplo clique para seleccionar a coluna do relatório e ajustar as suas ordens`,
"template.dashboard.management":`Gestão de Operações`,
"label.customcomponent.params.info.n1":`O valor "args" do "args" na etiqueta "componente" está no formato "json", por exemplo: args="name:'zhang',age:26", Em bloco de código cc, utilizar: String myName = nome; int myAge = idade;`,
"lable.SalesCommitmentKanBan.signedCommitmentRate":`Taxa de Compromisso Assinado`,
"label.add.status":`Adicionar estado`,
"label.loss.customers":`Fechado / Conta Perdida`,
"vue_label_chatter_involving_me":`Envolvido`,
"label.update.input":`Por favor, corrija a entrada`,
"label.import.step1.commonobj":`Objectos gerais`,
"label.appupload.upload.tips.document":`Nota: documentos em "minhas pastas pessoais" e "modelos de pastas vermelhas" não podem ser adicionados ao pacote, nem podem ser exibidos nesta lista.`,
"label.appupload.install.complete":`Completo`,
"label.console.edit":`Editar Consola`,
"setup.object.field.dependency.label.removefromlist":`Remover valores seleccionados`,
"label.textmessage.groupsms.no.phone":`Sem telefone`,
"label.account.Current.and.NextFQ":`FQ actual e FQ seguinte`,
"label.sso.saml.sp.idtype.userid":`Assertion contém o ID de utilizador do objecto do utilizador`,
"label.data.import.setup.operate.update":`Actualizar registos existentes, não inserir novos registos`,
"front-kefu-moudle-v1-jcaws-call-serve":`Call Center Integrado com AWS (Amazon Web Service) para Fornecer Serviços SaaS Mais Abrangentes`,
"label.version.bacheditordel":`Edição/eliminação/transferência em massa`,
"lable.even.higher":`Superior`,
"label.datetime.error":`O formato da data está incorrecto`,
"vue_label_commonobjects_detail_customer_hierarchy":`Hierarquia de clientes`,
"label.startuploadfile":`Iniciar o Upload`,
"label.appointment.wizard.subtitle3-1":`Segunda-feira`,
"label.weixin.relevance":`Oportunidade associada`,
"label.datamanage.field.mapping.information":`Configuração de Mapeamento de Campo`,
"label.brief.lastweek":`Semana passada`,
"label.nextstep":`Próximo Passo`,
"label.listtoshow":`Uma listagem de processos de aprovação activos e inactivos para {0} é apresentada abaixo.`,
"label.partner.ishave":`Erro: o domínio já existe`,
"label.service.miniProgram.name":`Por favor, preencha o nome.`,
"label.view.filterbyaddition":`Filtrar por campos adicionais (Opcional):`,
"label.projectManagement.nodata.task":`Sem registos de tarefas. Vamos adicionar informação sobre tarefas!`,
"label.chooseemailtemplate":`Seleccionar modelo de e-mail`,
"label.page.step4.add.profile":`Passo 4 Adicionar aos perfis`,
"label.ems.mailtype":`Tipo de correio`,
"label.weixin.no.pending.projects.vg":`Bom trabalho, sem itens de aprovação pendentes`,
"label.tabpage.saveviewfailed":`Ver salvar falhou`,
"label.chat.file.upload.cancel":`Cancelar carregamento`,
"com.cloudcc.login.error.message.notenabled":`A sua identificação não activada`,
"label.data.import.setup.operate.insertandupdate":`Actualizar registos existentes e inserir novos registos`,
"label_target_type":`Tipo de objectivo`,
"label.notification.event2":`【被分配人】 visualizou o evento que atribuiu`,
"chatter.feed.menutype.feed.news":`O que eu sigo`,
"label.import.page1.suitedwayofcustomer":`Estilo de correspondência com o cliente`,
"label.import.page2.CloudCCfiled":`Campo CloudCC`,
"label.custom.quarter.start":`Data de início do Trimestre Personalizado`,
"label.page.including.tab":`Incluindo separadores`,
"label.mobile.phone.day.plan2":`Hoje`,
"template.report.lead.conversion.statistics":`Estatísticas de Conversão de Leads`,
"label.show.type":`Tipo de exibição`,
"label.weixin.no.pending.wdgz.qin.week":`Nenhum trabalho agendado para esta semana.`,
"2018UI.Homepage.DataDeleted.Info":`Os dados que deseja visualizar foram eliminados, por favor clique para voltar ao passo anterior.`,
"label.vlidaterule.message":`Mensagem de erro`,
"label.approval.remark":`Parecer de aprovação`,
"label.field.duplicate1":`Único`,
"label.batchtransfer":`Transferência em massa`,
"label.quickbooks.view.allinvoices":`Todas as facturas`,
"vue_label_commonobjects_detail_lead_selectedstatus":`Marcar como estado actual`,
"label_home_page_source":`Por favor, seleccione a fonte de dados.`,
"front-kefu-moudle-v1-opencall-please":`Por favor, active o call center e depois instalese`,
"setup_layout_label_asc":`Ascendente`,
"label.use_tikect":`Utilizar bilhete de entrada?`,
"label.tag.setup":`Definições de etiquetas`,
"label.existinglayout":`Layout de Página Existente`,
"label.productsales.today.noevt":`Não há eventos abertos.`,
"message.error.view.date.validerr":`Introduza por favor o formato da data válida (AAAA-MM-DD、MM/DDD/AAAA) ou caracteres de data especiais`,
"label.mr.descreption.oneGroupReData3":`tem de lidar com o`,
"label.tianyancha.businessverify.msg1":`Com a função de verificação de dados comerciais activada, os utilizadores devem ler cuidadosamente e compreender plenamente os termos deste "acordo de licença de utilização" (adiante designado por "acordo"), incluindo a isenção de responsabilidade da beijing shenzhou yundong customer co., ltd. (doravante referido como "CloudCC") e as restrições do direito do utilizador. leia-o cuidadosamente e opte por aceitar ou não o presente acordo.`,
"label.custom.CQ":`Trimestre personalizado`,
"label.version.custom.dashboard":`Painéis de controlo standard(Página personalizada)`,
"vue_label_commonobjects_detail_dragtoupload":`Arraste o seu ficheiro aqui, ou <em>clique e carregue</em>`,
"label.tabpage.addadvancedoptions":`Adicionar opções avançadas`,
"front-kefu-moudle-v1-Launch-page":`Página de Aterragem:`,
"label.emailobject.tabname":`Email`,
"label.weixin.addmore":`Acrescentar mais`,
"message.error.view.operator.validerr":`Operador Inválido`,
"label.another_page":`Redireccionar para outra página`,
"label.reportTypeFocusD2":`Exemplo: Se reportar sobre "Contactos com Oportunidades com Parceiros", seleccione "Contactos" como o objecto principal.`,
"label.icon.47":`Barómetro`,
"label.task.today":`Hoje`,
"label.service.gantt.weekend.highlight":`Destacar o fim-de-semana`,
"label.customcomponent.referencetagname":`Nome do separador`,
"label.senderemail":`Endereço de e-mail do remetente`,
"label.defaultvalue":`Valor por defeito`,
"label_tabpage_Sdfez":`dias`,
"pagecreator.page.label.pagename":`Nome da página`,
"vue_label_report_pagenumber":`Número de página no intervalo`,
"label.emailsync.connectaccount.description":`Adicione aqui a sua caixa de correio pessoal, e o CloudCC fará corresponder automaticamente os contactos e leads no sistema de acordo com os seus endereços de correio electrónico, sincronizando o conteúdo do correio electrónico com os registos para facilitar o seguimento e a comunicação.`,
"label.schedulableprg.chooseweek":`Por favor seleccione a data de cada semana`,
"lable.edit.queue.membercanuse":`Membros disponíveis`,
"lable.Quick.find":`Olhar rápido`,
"label.daynuminmonth":`Dia(s) do(s) mês(s)`,
"message.error.state":`estado não pode estar vazio!`,
"label.introduction.the.form":`Descrição`,
"label.batchtransfer.pleaseselectcomefromuser":`Transferência de`,
"front-dashboard-module-implemented":`Realizado`,
"label.custombutton.newerror":`Nova criação falhou`,
"label.version.allow.size":`Se necessário, por favor actualize a versão CloudCC.`,
"label.weixin.account.loginpage":`Página de login de segurança da conta`,
"message.pleaseselectfieldtype":`Por favor seleccione o tipo de campo`,
"component.setup.label.parentobject":`Objecto superior`,
"System.TAB.SeeViewAmount":`Ver Totais`,
"label.event.lastmonth":`Último mês`,
"label.taskrecordtype":`Tipos de registo de tarefas`,
"label.layout.selectedpages":`Páginas seleccionadas`,
"label.appointmentdetail.wizard.title19":`Plano de Sábado`,
"label_chatter_endData":`Data de fim`,
"label.appupload":`Pacotes`,
"label.knowledgebase.article.link":`Artigo ligado`,
"label.licence.enddate":`Data de Expiração`,
"chatter.fieldtrack.record":`registo`,
"label.reportsSubscriptionPage.schedulereport.weekly":`Semanalmente`,
"label.forecast.editshrepage.title2":`Partilhar Editar`,
"label.attendance.onwork.time":`Início do dia`,
"label.appointment.wizard.subtitle1-8":`3 h`,
"pagecreator.layout.button.upload":`Esquema de Upload`,
"label.input.notless.than.number":`Por favor introduza um número maior ou igual a {0}.`,
"setup.mainpage.label.welcome13":`Instruções: Clique no menu superior → Relatórios → Novo`,
"label.forecast.settings.data.opp":`Data de encerramento da oportunidade`,
"vue_label_display_checkbox_field":`Mostrar campos da caixa de verificação`,
"label.summaryreport.2018.step5":`Passo 5 Seleccionar o tipo de gráfico e o item em destaque`,
"front-lightning-module-v1-dashborad-one-statistic":`Por favor escolha pelo menos um valor estatístico e tipo estatístico`,
"label.home.standard.dashboard.forcase":`Não é permitida a previsão e não é possível visualizar o painel de compromisso de vendas.`,
"page.field.track":`Histórico do Rastreio de Campo`,
"label.dataimport.format.datetime.error":`Erro de formato, usar por favor yyyy/MM/dd HH:mm:ss ou yyyyy-MM-dd HH:mm:ss.`,
"lable.opppdt.selPbk.title":`Escolher Livro de Preços`,
"pagecreator_systemstyle_label_stylename":`Nome do estilo`,
"label.projectManagement.nodata.project":`Sem dados relacionados. Porque não criar projectos relacionados comigo?`,
"label.start_below":`Comece a partilhar o seu formulário com os contactos. O seu formulário foi publicado com segurança e está pronto a ser utilizado no endereço web abaixo.`,
"label.campaignmember.main.delete":`Membros da Campanha de Retirada em Massa`,
"label.modifyall":`Modificar tudo`,
"label.homepage":`Página inicial`,
"vue_label_pool_adoptedbyme":`I Recolha`,
"label.email.clearItem":`Apenas os e-mails sem itens associados são limpos.`,
"label.callcenter.login.Amazon.connect":`Iniciar sessão na Amazon Connect`,
"label.import.page1.selectimportfiled":`Seleccione o ficheiro a importar`,
"message.error.id":`id não pode estar vazio!`,
"label.ggReleaseRange.searchUsers":`Pesquisar utilizador parceiro`,
"label.changemypwd":`Alterar a minha palavra-passe`,
"label.ccpeak.reference.parameters":`Os parâmetros que podem ser referências directas são:`,
"chatter.share.success.tip":`Sucesso! partilhou este post para`,
"label.message.checkfailed":`A verificação da sintaxe falhou, o nome da classe existe.`,
"label.shangqing.introduction":`Integrar e analisar os recentes eventos quentes de leads ou clientes para ajudar o vendedor a compreender os clientes de forma mais abrangente`,
"label.allemailnotice":`Todos os alertas por e-mail`,
"vue_label_report_copy":`Copiar relatório`,
"label.exchange.sync.state.setting":`Definições de configuração`,
"label.merge.result.error1":`O seguinte registo é bloqueado, e não é permitida nenhuma operação de "fusão".`,
"label.process.des":`Clique no link da esquerda para ver detalhes do registo actual.`,
"label.textmessage.vonage.create.lead.setting":`Criar novos contatos quando receber texto de números não incluídos no sistema`,
"label.views":`Vistas`,
"label.notification.tip1":`Notificações`,
"label.forecast.detailforecast.returnforecast":`Voltar a Previsões`,
"label.knowledgebase.target.framework.name":`Nome da armação alvo`,
"label.brief.close.opportunities":`Fechado - ganho`,
"label.appointment.wizard.subtitle4-2":`O tempo mais curto para reparar em si`,
"vue_label_systemSettings_set_record":`Configurar o modo dispaly da lista relacionada, tentando alternar entre o Modo Cartão e o Modo Lista.`,
"pagecreator_page_message_publish_fail":`A publicação da página falhou`,
"vue_label_homepage_name":`Nome da página inicial`,
"label.weixin.no.pending.wdgz.qin.month":`Não tem nenhuma marcação marcada para esta semana.`,
"label.campagin.register.page":`Página de registo de membro da campanha`,
"label.campaign.channel.edit":`Campanha: Canal de Marketing Editar`,
"label.folder":`Pasta`,
"label.umeng.chatter.follow":`seguiram-no.`,
"label.sso.theKeyToEdit":`Edição chave`,
"label.deletelayout":`Eliminar layouts de página`,
"label.same.analyze.miaoshu":`A relação entre as condições acima é: "Nome da oportunidade" ou "Nome da conta" ou ("Contacto móvel" e "Email de contacto");`,
"label.ccpeak.sel":`Aulas nesta pasta`,
"label.tabpage.addtoworkbench":`Adicionar à bancada de trabalho da página inicial`,
"label.forecast.shrepage.classdes.r":`Read Only - O utilizador pode ler dados de previsão.`,
"homepage.custompagename":`Nome da página inicial personalizada`,
"label.sendemail.batchapprovalinfo":`Olá #nome:{\r}a operação de aprovação do lote que realizou foi bem sucedida, com um total de #successnum aprovado com sucesso e #errornum falhado.`,
"front-email-payment-Invoice-alipay-describe":`Pagamento seguro e fiável`,
"setup.object.field.dependency.label.configured":`Layouts de página atribuídos ao Perfil`,
"label.potentialcustomers":`Líderes`,
"label.timetrigger.button":`O botão de disparo de tempo adicional não está disponível nos seguintes casos:`,
"label.category.10":`Advogado`,
"label.selectall":`Seleccionar tudo`,
"message.field.id.not.null":`A identificação do campo não pode estar vazia.`,
"CloudCCCRM.ST.Info.TypeIn.001":`Por favor, introduza`,
"label.author":`Autor`,
"label.import.step1.csvonly":`1. Só é suportado o ficheiro em formato csv, e podem ser importados registos até {recordnumlimit} por uma vez. Podem ser importados até 2.000 registos, se for necessário executar o gatilho. Os registos que excederem o limite serão automaticamente ignorados pelo sistema. Se quiser importar mais dados, divida-os primeiro em vários ficheiros e importe-os em momentos diferentes. .`,
"label.assignment.setup.newrule.name":`Nome da Regra`,
"label.campaignmember.selectmember.chosestatusdesc":`Por favor, seleccione a campanha a que pretende adicionar membros, e edite o Estatuto de Membro da Campanha. Crie uma nova campanha, deve sair deste processo.`,
"label_tabpage_operation":`Operação`,
"label_tabpage_datatyoez":`Tipo de dados`,
"UG_product_04":`Criar produto`,
"label_emailtocloudcc_step1_case2":`Uma vez configurado, os e-mails recebidos nesta caixa de correio serão automaticamente registados como registos de casos no CloudCC. De acordo com a caixa de envio, relacionar o caso com o contacto e a conta correspondentes, de modo a facilitar a aceitação e o seguimento dos casos.`,
"workflow.action.tasks.assignortype.role":`Papel`,
"vue_label_notice_refreshi_success":`Actualizar com sucesso`,
"label.notification.arketsea.abandon":`{5} descartados {2} {0}：{1}`,
"label.icon.36":`Computador`,
"chatter.group.cancelToJoin":`Cancelar para aderir`,
"label.publicgroups.edit":`Edit Public Group`,
"message.duplication.label.letternum":`Correspondência de partes de caracteres`,
"label.brief.lost.opportunities":`Perdido`,
"setup.layout.label.nofield":`Nenhum campo disponível`,
"label.dataimport.isSharingRule":`Aplicar regras de partilha de força`,
"vue_label_opportunity_contactrole_synctocontacts":`Sincronizar informação aos contactos`,
"attachment_button_massdownload":`Descarregar em massa`,
"label.weixin.agreement.remark":`Este serviço WeChat é a ferramenta auxiliar do serviço de consultoria Aid-Max aos clientes, não é a base final para as companhias de seguros regularizarem os sinistros, e os sinistros dos clientes devem ser regularizados de acordo com os requisitos de actuação das companhias de seguros.`,
"label.partnerCloud.basicSetting.introTwo":``,
"pagecreator_layout_funcpath":`/ construtor / biblioteca de layout`,
"label.ccdocument.online.edit":`Documento Edição Online`,
"label.partner.setup.Enable":`Verifiquem`,
"label.log.state":`Estado da acção`,
"label.lower.bound":`Limite inferior`,
"label.timezone.isenable":`Activar o utilizador fuso horário múltiplo, depois permitir ao utilizador definir o fuso horário, e exibir data/hora por fuso horário do utilizador.`,
"label.martrixreport.setrowtitle":`Especificar os cabeçalhos das colunas`,
"label.bottom":`Fundo`,
"label.multilang.ccchat.groupnotcontainsname":`Não é membro de nenhum grupo de camaradagem que tenha {0} no seu nome`,
"label.step1.of.step5":`Etapa 1 de 5`,
"message.report.error.FieldListIsAmbiguous":`Há uma fórmula arquivada que foi referenciada no relatório, que causa uma excepção, por favor remova o ficheiro:&nbsp;`,
"label.monitorsys.operator.ip":`IP`,
"ccchat.fieldtrack.fieldchange":`Mudar de {0} para {1}`,
"label.report.export.print.content":`Exportar actuais cabeçalhos de relatórios, grupos e primeiros registos de 2000`,
"message.thanksusing":`Obrigado por utilizar o CloudCC.com`,
"label.reportexport.allobject":`Exportar todos os Objectos`,
"label.projectManagement.working.hours.per.day":`Horário de trabalho diário`,
"label.partnerCloud.financeSetting.enterCollaborator":`Por favor introduza o ID do colaborador`,
"label.defineReportRecords":`Definir Conjunto de Registos de Relatórios`,
"greate":`maior do que`,
"label.sure_discard":`Tem a certeza de desistir das mudanças?`,
"label.escalation.setup.newaction.notifyowner":`Notificar o proprietário do caso`,
"label.icon.28":`Chapéu de Doutor`,
"lable.PowerProcess.see.page":`Ver Marcos`,
"message.error.object.relogin":`Login falhou, por favor tente entrar novamente`,
"label.chatter.activity":`Actividades`,
"label.query.clone.detail.choose.canChoose":`Itens de linha disponíveis`,
"chatter.using.object":`Permitir o rastreio de alimentação de objectos para que os utilizadores possam seguir registos desse tipo de objectos. Seleccionar campos para rastrear para que os utilizadores possam ver actualizações de alimentação quando esses campos são alterados nos registos que seguem.`,
"UG.opportunity.001":`Como é que controla as suas vendas?`,
"label.ServiceCloud.fuwuziyuan.distributionMap":`Mapa de distribuição de recursos de serviço`,
"vue_label_email_current_email":`A inserção deste modelo irá sobregravar o e-mail actual`,
"label.h5.approval.page.layout":`Pode definir a disposição da página de aprovação: <br>Configuração>Criar>Fluxo de trabalho&Aprovação>Processos de aprovação<br>selecionar o processo de aprovação, clique no nome da aprovação<br>clicar Editar>Definir o layout da página de aprovação`,
"component.hots.label.title":`Negócios escaldantes`,
"mail.foldername.notOnly":`Este ficheiro já existe`,
"label.customer.tab.step1":`Passo 1 Introduzir os Detalhes`,
"label.delete.persion":`Eliminado por`,
"chatter.changed0":`Alterar {0} de {1} para {2}.`,
"homepage.components.type":`Tipo de Componente`,
"label.norfolk.isiands.time":`Tempo de Norfolk`,
"label.product.pricebooks.view":`Vistas do Livro de Preços`,
"label.forecast.customforecast.director":`Subordinados directos`,
"label.emailtocloudcc.step3total3":`Etapa 3 de 3`,
"label.cloudccsite.end":`Página Inactiva do Site`,
"label.login.verification.mfa.device":`Verificar o Dispositivo AMF Virtual`,
"chatter.follow":`Siga`,
"label.month's":`Meses`,
"label.sendmail.step1.introduce":`Seleccione uma vista abaixo que contenha os destinatários a serem incluídos neste e-mail.`,
"label.shangqing.title":`Ambiente de Informação Empresarial`,
"label.rejectrecords":`Registos Rejeitados`,
"label.selectupdatevalue":`Valor que muda de`,
"vue_label_pricebook_disabled":`A lista de preços está desactivada`,
"component.chatter.label.title":`Último post`,
"label.partner.all.workspace":`Espaço de trabalho`,
"label.querydetailservice.delete.message":`Dados apagados ou inexistentes.`,
"label.objectRelationshipWithout":`com ou sem registos relacionados`,
"nocontain":`não contém`,
"label.partnerCloud.financeSetting.accountSettings":`Criação de Fundo de Parceiros`,
"label.file.sharetype.owner":`Proprietário`,
"label.open.multilingual":`Habilitar Multilínguas`,
"label.searchresult.field":`Campos de resultados da pesquisa`,
"label.tabpage.selectdate":`Seleccione uma data`,
"label.h5.logouting":`Sair`,
"label.quickbooks.fieldlabel.payment":`Pagamento`,
"label.chatter.leaveword":`Comentário`,
"label.customfields.majoranddetailrelation.tip":`Criar uma relação pai-filho especial entre este objecto (filho ou details）and outro objecto (pai ou mestre), onde: <br>● os campos de relação para todos os registos de detalhes devem ser preenchidos. <br>● Uma vez guardado o valor do campo relacional, este não pode ser alterado. </li><br>● a propriedade e partilha do registo de detalhes é determinada pelo registo principal. </li><br>● quando o utilizador apaga o registo mestre, todos os detalhes são apagados. </li><br>● é possível criar campos de resumo cumulativo no registo mestre para resumir registos detalhados. </li><br> O campo de relação permite ao utilizador clicar no ícone de procura para seleccionar um valor da lista pop-up. O objecto principal é a fonte do valor na lista. "`,
"label.batchapproveorrefuse":`Aprovação/Rejeição em massa`,
"label.copy.success":`Copiar com sucesso`,
"vue_label_show_record_count":`Mostrar Contagem de registos`,
"label.ems.delete.false":`Falha em apagar`,
"label.new.Product.Goals":`Novo Objectivo do Produto`,
"label_chatter_BCC":`Bcc (cópia cega de cortesia)`,
"label.knowledgebase.data.archived.successfully":`{a} arquivo de dados com sucesso`,
"label.chuangming.title":`Chuang Ming SMS`,
"label.notification.arketsea.recovery":`O seu {0}:{1}foi reciclado até {2} por {5}.`,
"label.partnerCloud.orderingPlatform.paymentAmount":`Montante do pagamento:`,
"label.martrixreport.2018.step5.new":`Passo 5 Seleccionar os critérios do relatório`,
"label.testing":`Verificação...`,
"chatter.poll.option4":`Escolha 4`,
"lable.outlook.detail.otc":`Troca para CloudCC.com`,
"label.startuploadfile.batch.step2":`Passo 2 Clique no botão "iniciar carregamento",carregar ficheiros`,
"lable.outlook.edit.outdes":`Introduza os campos personalizados que já criou em Exchange. Antes de mapear este campo personalizado do Exchange para um campo CloudCC.com, o CloudCC.com verificará a existência do campo Exchange aquando da primeira sincronização.`,
"hour":`Hora`,
"label.appointmentpage.wizard.notif4":`Formato de e-mail inválido`,
"label.import.index.state":`Estado`,
"label.integrations.mailchimp.massage6":`Os dados seleccionados mostrados na página actual poderão ser exportados para a sua lista Mailchimp`,
"label.file.share.email.subject":`#sharedBy partilhou consigo um ficheiro em #orgname`,
"label.assignment.setup.newentries.noassignment":`Não Reatribuir Proprietário`,
"label.dashboard.unit1":`Unidade: 10,000`,
"label.forecast.customforecast.foretype.commit":`Comprometido`,
"label.type":`Tipo`,
"label.partner.workspace.login.logo":`Logotipo de cabeçalho`,
"pagecreator_systemstyle_button_edit":`Estilo de edição`,
"label.displaytype2":`Botão Página de Detalhe`,
"email.one":`Caro utilizador: \Bemvindo ao CloudCC. Pediu para redefinir a sua palavrapasse em {!operatetime}, por favor inicie sessão com o código de verificação abaixo dentro de 15 minutos: \Código de Verificação Aleatória: {Clique no link abaixo para redefinir a sua palavrapasse: \n{!URL}/authcodecheck.jsp?username={!username}&lang={!lang}n Importante: Se não solicitou isto, ou se pensa que esta mensagem não deve chegar até si, por favor contacte imediatamente o seu administrador!`,
"label.partnerCloud.orderingPlatform.unavailable":`Não há produtos disponíveis`,
"vue_label_email_save_the_signature_successfully":`Guardar a assinatura com sucesso`,
"label.reportsSubscriptionPage.email.detailed":`Detalhado`,
"chatter.group.query":`Consulta`,
"label.translation.unsupported.format":`Formato não suportado, suporte de importação em várias línguas Formato de propriedade`,
"message.operateexception":`Pronta(Por favor contacte o seu Administrador).`,
"label.sendemail.chat.praiseFeedcomment":`Caro #nome:{\i1}nome: olá! #userName gostou do seu comentário (#href).`,
"label.recycle.clearmy":`Esvazie o seu caixote do lixo da reciclagem`,
"label_tabpage_choose":`Seleccione`,
"#label.importstep2tip":`Se quiser carregar mais do que um ficheiro, pode comprimir todos os ficheiros juntos e importá-los.`,
"label.batchedit":`Edição Mas`,
"label.integrations.mailchimp.export":`Exportar para Mailchimp`,
"label.cloudccsite.name":`Nome do sítio`,
"serviceterritory.serviceappointment.iscontain.contain":`Não se pode apagar o território de serviço, pois está associado a uma marcação de serviço. Pode desactivar este território de serviço.`,
"label.sum":`Soma`,
"setup.mainpage.label.welcome29":`Integração padrão API com produtos de terceiros`,
"label.tabpage.nothingz":`Nada`,
"label.weixin.actual.contract.jine":`Montante real do contrato`,
"label.tabpage.emailaddressz":`De?Endereço`,
"label.dashboard.unit4":`Unidade: 10 milhões`,
"label.dashboard.data.labels":`Etiquetas de dados`,
"label.import.page2.oneonone":`Um campo CloudCC só pode corresponder a campos num único ficheiro.`,
"homepage.components.name":`Componentes Nome`,
"template.report.task.theme":`Assunto da tarefa`,
"component.setup.label.setupsaveok":`Definições de componentes guardadas com sucesso`,
"front-epwechat-module-v1-add-selfapp":`Adicionar Seflcreated App`,
"label.to.save.the.current.page.information.button.":`Se quiser guardar a informação da página actual, por favor clique no botão "Guardar Rápido".`,
"vue_label_file_not_support_preview":`O ficheiro não suporta pré-visualização, por favor descarregar e visualizar`,
"label.object.reached.limit":`O número de objectos que se pode criar atinge o limite superior.`,
"label.partnerCloud.basicSetting.online":`Activar o pagamento online`,
"label.app.step1.error.nameexist":`Este nome de grupo já existe ou já foi utilizado anteriormente. Por favor, escolha um nome diferente.`,
"label.workflowandapprove":`Fluxo de trabalho e aprovações`,
"label.recordtypeselect.change.tip":`Quando se altera o tipo de registo de um registo, os valores da lista de selecção existente não se alteram automaticamente. Recomenda-se que actualize os valores da lista de selecção existente no mesmo local.`,
"label.summaryreport.step6":`Passo 6 Seleccionar os critérios do relatório`,
"Pagelayout.Setup.004":`Podem ser definidos até 4 campos`,
"label.file.attached":`Em anexo`,
"front-invoice-online-payment-setup-configure":`Clique em "Configurar Agora", Configurar {nome} Interface de Pagamento.`,
"label.approvaldatamove.submitdate":`Data de apresentação`,
"label.emailobject.time.from":`De:`,
"label.dataimport.insertdata.error.fieldrepeat.insert":`O campo $schemefield_name$ no registo já existe na base de dados e já não está inserido. O registo foi ignorado, importado.`,
"assetbom.copy.notpermission":`Não tem autoridade para clonar a lista técnica de bens. Por favor contacte o administrador.`,
"lable.outlook.mcto.autoallocation":`Atribua-os automaticamente aos registos relacionados com o CloudCC.com.`,
"label.dataimport.but.datalength":`mas o comprimento dos dados é`,
"label.setuserstocommit":`Usando as opções abaixo, especificar que utilizadores estão autorizados a submeter o pedido inicial de aprovação.`,
"component_telerecord_label_related":`Artigos relacionados`,
"front-lighting-module-v1-detail-file-lockInfo":`O registo está bloqueado e não está disponível para adicionar ficheiros. Por favor contacte o administrador para desbloquear.`,
"pagecreator_layout_button_edit":`Editar layout`,
"label.app.step3.tabcanuse":`Separadores disponíveis`,
"label.ems.delete.sure":`Tem a certeza de apagar esta informação de conta de correio electrónico?`,
"label.email.show":`Mostrar`,
"label.checkbox.unchecked":`Não seleccionado`,
"message.error.operation":`Falha de funcionamento, por favor contacte o administrador.`,
"label.template.set.folder.only.upload.type.file":`As pastas marcadas a vermelho no modelo só podem ser utilizadas para carregar ficheiros do tipo Word,Excel e PPT.`,
"label.knowledgebase.select.publish.status":`Por favor escolha um estado de publicação`,
"label.recordtype.tabname.edit":`Introduza o novo nome para o tipo de registo seleccionado, e depois clique em "Guardar".`,
"label.tabpage.exportview":`Vista de exportação`,
"label.dataimport.insert.sharetab":`Falha em inserir formulário de partilha`,
"vue_label_dashboard_penetrateto":`Penetrar para`,
"label.weixin.group.member":`Pessoal`,
"vue_label_systemSettings_customadd":`Extensão personalizada`,
"UG_Account_03":`Verificar e fundir proactivamente as contas duplicadas`,
"label.singapore.standard.time":`Tempo Padrão de Singapura`,
"label.weixin.captcha":`Código de Verificação`,
"Account_News_Setting_004":`Activar Notícias`,
"label_emailtocloudcc_select1":`Por favor escolha`,
"label_ring_ratio":`Mês a Mês`,
"label.industrialandcommercialverification.button.save":`Guardar`,
"label.approvalstep5.tip":`A página de aprovação é onde o aprovador realmente aprova ou rejeita o pedido. utilize as seguintes opções para seleccionar as propriedades de edição dos campos a exibir nesta página.`,
"label.import.page1.maxrecord{{30000}}":`1. Pode importar registos {{{30000}} uma vez`,
"setup_object_layout_label_profileoptions":`Perfis disponíveis`,
"label.emailtemplate.type":`Tipo de gabarito`,
"label.searchlayout.tab.field":`Campos apresentados na página inicial do separador.`,
"chatter.news":`Mensagens`,
"label.pw.small.letter":`Caixa minúscula`,
"label.notification.group3":`A sua candidatura para se juntar ao grupo público foi rejeitada`,
"label.ccchat.day.before.yesterday":`Anteontem`,
"component.chatter.post.label.title":`Publicar`,
"label.tianyancha.type":`Tipo de representante legal`,
"label.detail.searchlayout":`Ver Layout de Pesquisa`,
"vue_label_pool_deleteconfirm":`Tem a certeza de que quer apagar o(s) registo(s) seleccionado(s)?`,
"label.import.index.maxmb{{100}}，maxitem{{30000}}":`1. Só suporta ficheiros em formato csv, o suporte máximo é {{100}}mb, e um máximo de {30000}} registos podem ser importados uma vez; por favor dividir em ficheiros múltiplos e importá-los por fases se o limite for ultrapassado,`,
"label.h5.similar.opportunity.lookup":`Encontrar Oportunidades Semelhantes`,
"template.report.customer.list.opportunity":`Lista de Contas com Mais Oportunidades`,
"component_setup_iframe_label_memo":`Clique no ícone de definições e introduza o endereço url incorporado.`,
"label.version.allemail":`Email em massa`,
"lable.product.editp":`Edição de preços`,
"label.weixin.plate.number":`Número da placa`,
"font-evaluate-module-v1-disabled-successfully":`Opção de avaliação de deficiência "Neutra" com sucesso`,
"label.multilingual.tip1":`Utilize esta página para definir a língua da sua organização.`,
"label.japan.standard.time":`Hora Padrão do Japão`,
"lable.product.notdel.use":`Eliminar tentativas,porque ainda está associado aos seguintes registos,neste caso,é recomendável desactivar.`,
"label.appointment.wizard.subtitle4-2-4":`4 h`,
"label.queue.edit":`Editar`,
"label.partnerCloud.financeSetting.informationTwo":`2. No Centro de Comerciantes, Clique Gestão de Conta  Gestão de Conta  PIDIKEY de Produto  Gestão de Chave Secreta`,
"label.partnerCloud.partnerOrdering.permission":`Permissão de Encomenda de Parceiros`,
"vue_label_commonobjects_detail_company_hierarchy":`Hierarquia da empresa`,
"label.forecast.settings.sl":`Quantidade`,
"label.partner.workspace.tab.memo":`Seleccionar separadores para esta nuvem de parceiros. podem ser seleccionados separadores padrão ou personalizados.`,
"label.mr.mainRecord":`Registo mestre`,
"setup_mainpage_label_welcome20":`Correio, modelo SMS`,
"front-email-payment-select-date-tips":`Por favor escolha YY`,
"label.dependencelisttag":`Rótulo da lista relacionada`,
"label.umeng.activity.eventof":`evento de`,
"label.sales.dashboard.collection":`Objectivo dos recibos`,
"report_label_folder":`Pastas`,
"label.assignment.setup.newentries.step1":`Passo 1 Estabelecer a ordem em que esta entrada de regra será processada`,
"label.quote.shrname":`Nome do destinatário`,
"label.newreport.group.sum":`O número de agrupamentos`,
"label.number.MinCheck":`O mínimo de {a} é {0}. Por favor, modificar a quantidade e guardar as alterações.`,
"label.chatter.save":`Guardar`,
"vue_label_email_all_email_templates":`Todos os modelos de e-mail`,
"message.summaryconditionnototal":`Condição de condições resumidas não pode usar campos Roll-Up!`,
"label.callboard":`Anúncios`,
"label.step2.total5":`Etapa 2 de 5`,
"vue_label_homepage_custom_homepage_page":`Página inicial personalizada`,
"label.data.newtemplate.e_seltype":`Seleccionar o método de exportação de dados`,
"label.data.dataexpalltype.all.desc2":`2、It leva algum tempo a exportar todos os dados. Quando a exportação estiver concluída, receberá um email de lembrete de que a exportação de dados foi bem sucedida.`,
"lable.account.CalenderYear":`Ano Calendário`,
"message.error.data":`Os dados aprovados não podem estar vazios, por favor verifique os parâmetros aprovados`,
"label.from_user":`Do Utilizador`,
"label.parentdepartment":`Departamento superior`,
"template.dashboard.product.analysis":`Análise de produtos`,
"label.tabpage.unpacketz":`Não há dados de agrupamento disponíveis!`,
"label.icon.107":`Comunicação`,
"label.monitorsys.operator.username":`Utilizadores`,
"label.serchreport":`Relatórios de pesquisa`,
"label.payment.upgrade":`Actualização`,
"setup_layout_button_ok":`Confirme`,
"label.please.select.channel":`Por favor, seleccione o supervisor do canal.`,
"template.chart.txdrw":`Lembrete de tarefa`,
"chatter.group.accept":`Aceitar`,
"pagecreator_systemstyle_message_canntdelete":`O estilo actual não é permitido apagar`,
"label_tabpage_ctbtsftcz":`Clique no verso para pesquisar o conteúdo`,
"label.datamanage.select.accountfield":`(Seleccione os campos correspondentes à conta importada)`,
"label.schedulejob.setup.list.title":`Empregos programados`,
"label.visualpage_list.title":`Acesso à página personalizada activa`,
"label.mr.selectTwoData":`Por favor, seleccione pelo menos dois registos para serem fundidos.`,
"label.customer.tab.step2.different":`Aplicar uma visibilidade de separador diferente para cada perfil`,
"label.mobile.side.tab.can":`Disponível em`,
"label.log.url":`URI`,
"label.weixin.cloudccnumber.isgoon":`A conta CloudCC foi vinculada, se continuar, ao WeChat que anteriormente estava vinculado a esta conta CloudCC não poderá utilizar o sistema micro CloudCC. Quer continuar?`,
"label.applet.to.case":`Portal de serviço ao cliente do miniprograma`,
"lable.outlook.detail.cmaping":`Campos de Contacto do Mapa`,
"label.theUserActiveTime":`Período activo do utilizador`,
"label.event.moveup.9hour":`9 horas à frente`,
"vue_label_pool_other":`outros`,
"label.fieldname":`Nome do campo`,
"vue_label_notice_add_success":`Adicionado com sucesso`,
"label.conditiontag.lookup.insertbutton":`Inserir Seleccionado`,
"label.identifying":`Identificação`,
"label.tabpage.uploadingz":`Carregamento`,
"label.view.introduce":`Editar Ver`,
"vue_label_dashboard_sortingmethod":`Por favor seleccione o método de ordenação`,
"label.quote.number.introduce":`Introduza o número de e descontos, e clique em Guardar.`,
"front-kefu-moudle-which-missphone-case":`Criar casos para os quais as chamadas não foram atendidas`,
"label.sendemail.chat.response":`Resposta do CCChat:`,
"label.productsales.refreshTime":`Actualização mais recente`,
"lable.SalesCommitmentKanBan.phase":`Palco`,
"label.version.sum.object":`objecto(s)`,
"label.defineReportStep2":`Passo 2`,
"message.duplication.label.returnDuplications":`Voltar à Lista de Filtros de Duplicação`,
"label.lookover":`Ver`,
"label.quickbooks.button.copy2":`Copy CloudCC Detials To QuickBooks`,
"label.checkbox.true":`Sim`,
"label.profilename":`Nome do perfil`,
"label.finalapproveoperate":`Acções de Aprovação Final`,
"label.SMS.detailed":`Os alertas por SMS são enviados por regras de fluxo de trabalho quando são accionados.`,
"label.lasttimemodifier":`Última modificação por`,
"label.sso.summary":`Resumo`,
"label.customfields.encd.tip":`Permite aos utilizadores introduzir qualquer combinação de letras e números e armazená-los em forma de texto claro que pode ser encriptado e pesquisado.`,
"vue_label_report_formulacolumn":`Coluna de fórmula a nível de linha`,
"vue_label_systemSettings_transfer":`Registos de Transferência de Lotes`,
"lable.product.ecm":`Por favor, introduza o montante correcto.`,
"label.partner.setup":`Configurações de nuvens de parceiros`,
"label.same.analyze.miaoshu2":`função`,
"label.mobile.phone.day.summary":`Resumo diário`,
"label.ccchat.person.error.illdomain":`Erro: formato de domínio incorrectamente preenchido`,
"label.knowledgebase.edit.as.draft":`Editar como Rascunho`,
"message.duplication.label.newfilterule":`Nova duplicata e regra de correspondência`,
"vue_label_salesfunnel_notice1":`Resumo das oportunidades`,
"label.partnerCloud.partnerAccount.order":`Número de encomenda :`,
"label.account.Current.and.PreviousFQ":`FQ actual e FQ anterior`,
"label.customfields.formula.dateandtimeexample":`Próximo = AGORA() 1`,
"label.area.unassign":`Utilizadores não atribuídos`,
"label.at.my":`Conteúdo que mencionei (@)`,
"vue_label_calendar_notice_stopsharingfail":`Falha em deixar de partilhar`,
"label.data.file.validation.rules":`Executar Regras de Validação`,
"label.escalation.setup.entrydetail.escalation.hour":`Horas`,
"vue_label_ccchat_notice_pleaseentercontent":`Por favor introduza o conteúdo e as opções`,
"label.forecast.edit.error1":`Erro: Moeda inactiva`,
"label_emailtocloudcc_exists1":`Esta caixa de correio foi configurada para "Email to Lead". Não repetir as definições.`,
"label.trigger.send.email":`Notificações por Email via Triggers`,
"label.setmysafetysignagain":`Repor a minha marca de segurança`,
"label.callcenter.pleaseenter.access.keyID":`Por favor introduza a chave de identificação secreta`,
"chatter.poll.option10":`Escolha 10`,
"vue_label_systemSettings_mobelbottonsetting2":`Configuração Unificada do Menu Inferior`,
"label.quickbooks.searchs":`Pesquisa`,
"label.section":`Segmento`,
"label.customfields.fielddependency.new.tip":`Criar uma relação dependente que faz com que os valores numa lista de selecção ou numa lista de selecção múltipla sejam filtrados dinamicamente com base no valor seleccionado pelo utilizador noutro campo.<ul ><li>O campo que conduz a filtragem é chamado "campo de controlo". As caixas de verificação padrão e personalizadas e as listas de selecção com pelo menos um e menos de 300 valores podem ser campos de controlo. </li><li>O campo que tem os seus valores filtrados é chamado de "campo dependente". Listas de selecção personalizadas e listas de selecção múltipla podem ser campos dependentes.</li></ul>`,
"label.customobjects.track.introduce3":`Atenção: apenas parte dos campos diapositivos são rastreados e "Edited" será mostrado ao rastrear os campos.`,
"front-kefu-moudle-all-hidden-phone":`Ocultar o número de telefone globalmente`,
"vue_label_calendar_share_calendar_with_others":`Partilhar calendário com outros`,
"label.case.copre":`Descarregar o Código QR do Portal Web`,
"label.conditiontag.lookup.pagetitle":`Seleccionar valores da lista de selecção`,
"UG.opportunity.004":`Tipo multi-serviços`,
"label.event.moveup.1day":`1 dia à frente`,
"label.industrialandcommercialverification.enablestatus1":`Habilitar a Verificação de Dados Industriais e Comerciais`,
"label.ccpeak.newrecord.getorpost":`Novo Registo: há duas formas de construir um CCObject usando CCObject.`,
"frame.personinfo.label.resizeimage":`Para fazer ajustes à sua imagem em miniatura, arraste e redimensione as linhas pontilhadas na sua foto de perfil acima.`,
"label.optional.searchresultfield":`Campos de resultados de pesquisa disponíveis`,
"UG.Contract.02":`O contrato é um acordo escrito entre as partes. Muitas empresas utilizam contratos para definir os termos de fazer negócios com outras empresas. Utilize o CloudCC para estabelecer e documentar os seus contratos existentes com as suas contas e oportunidades de negócio. Acompanhe o contrato através do processo de aprovação. Utilize lembretes de fluxo de trabalho para o lembrar do prolongamento do contrato.`,
"label.group.activity":`Grupos activos`,
"label.tabpage.characterz":`Carácter inicial`,
"label.globalsearch.tip":`Por favor introduza o conteúdo da pesquisa`,
"label.campaign.channel.download.size2":`Tamanho médio: 500*500 pixels`,
"label.step3.total4":`Etapa 3 de 4`,
"label.partnerCloud.payForFailure":`O pagamento falhou`,
"label.ggReleaseRange.editSuccess":`Editar com sucesso`,
"label.summaryinforelyon":`Dados resumidos por`,
"label.productsales.htyj":`Execução do contrato`,
"label.newpagelayout":`Novo layout da página`,
"front-gantt-module-input-task-name":`Por favor introduza a tarefa name！`,
"label.c_d_without":`Os registos "C" podem ou não ter registos "D" relacionados.`,
"label.licence":`Licenças`,
"setup.layout.button.selectall":`Seleccionar tudo`,
"label.app.step1.error.appnameexist":`Este nome de aplicação já existe.`,
"label.cpq.quote.item.no.record":`Apenas os produtos encomendados com registos podem ser transferidos para contratos.`,
"label.knowledgebase.noaffect.existing.translations":`Não, as minhas modificações não irão afectar a tradução existente.`,
"label.schedulejob.setup.schedule.editjob":`Edição de trabalhos agendados`,
"lable.PowerProcess.Tips":`O processo de direito é uma linha temporal personalizável contendo todas as etapas (marcos) que poderiam apoiar o serviço ao cliente e outro pessoal a completar todas as etapas a fim de resolver um caso apoiado ou registo de ordem de trabalho. Após a instalação estar completa, pode ser aplicado ao direito.`,
"label.campaignmember.selectmember.step2":`Passo 2 Seleccione os membros que deseja adicionar`,
"vue_label_calendar_stopsharing":`Tem a certeza de que vai deixar de partilhar o calendário`,
"vue_label_notice_savemenu_fail":`O menu salvar falhou`,
"message.error.getitems.id":`getItems: id não pode estar vazio`,
"label.return.currencylist":`Voltar à lista: Gestão de Moeda`,
"label.wtd.detail.p":`PC`,
"label.knowledgebase.publish.now":`Publicar agora`,
"label.appupload.install.explain":`Instruções de Instalação`,
"label.visualpage.folder.all":`Todas as Pastas de Página`,
"message.passwordPolicy.validate.complexReq2":`Erro:A sua palavra-passe deve ter uma mistura de letras maiúsculas e minúsculas e números.`,
"label.umeng.chatter.at":`mencionou-o.`,
"label.mobile.phone.month.report":`Notas de Trabalho Mensais`,
"label.describableEditeSelectedFields":`Seleccione os campos que são exibidos nas colunas do relatório por defeito quando cria um novo relatório personalizado.`,
"component.event.label.subject":`Tema`,
"label.knowledgebase.edit.draft":`Editar Draft?`,
"label.customer.tab.step1.selectoneobject":`Seleccionar um objecto personalizado existente`,
"label_partner_step2":`Passo 2 confirmar modelo`,
"label_starting_annual":`Ano de início`,
"X":`Área de texto`,
"label.customer.tab.style":`Estilo Tab`,
"vue_label_commonobjects_detail_book":`Um Livro de Preços Padrão`,
"chatter.email.referredToMe":`Menciona-me num post`,
"label.enable.both.barcode.qrcode":`Activar o código de barras e o código QR`,
"front-market-form-quired-choose":`Campos Obrigatórios`,
"noinclude":`exclui`,
"label.sms.template.select":`Por favor seleccione o modelo SMS`,
"label.weixin.optionten":`Escolha 10`,
"message.duplication.label.matchlastletters":`Últimos N caracteres`,
"label.webtocloudcc.submit.success":`Apresentação bem sucedida`,
"label.sales.dashboard.number":`Número`,
"label.custom.field":`Mapear este campo personalizado`,
"label.dataimport.of.field":`campo(s)`,
"label.view.new":`Criar Nova Vista`,
"UG_activity_03":`Reservar um horário`,
"label.customfields.image.tip":`Permite aos utilizadores carregar imagens.`,
"label.startexport":`Iniciar Exportação`,
"vue_label_commonobjects_view_chart_verticalbar":`Gráfico de Barras Verticais`,
"label.ccchat.person.invite.allexist":`Todas as pessoas que convidar já estão a utilizar o CCChat`,
"label.fielddependence":`Dependências de campo`,
"label.scan.tip":`Por favor utilize o IE7, IE8, Chrome ou Firefox browser, e recomenda-se a utilização de uma resolução superior a 1024×768.`,
"label.wei.weiactor":`Votado por`,
"label.service.miniProgram.quantity":`Podem ser criados até 20 registos carrosséis~`,
"vue_label_homepage_new_homepage_page":`Nova página inicial`,
"label.apply.telphone.validate.error":`Número de validação errado.`,
"component.assistant.button.newevent":`Novo Evento`,
"System_TimeField_Format_Warning":`Tempo inválido`,
"chatter.feed.publishfeed":`Correio`,
"label.setting.intergrationlist":`Lista de integração`,
"label.object.prefix":`Prefixo do objecto`,
"label.tippage.confirmed":`Sim, quero eliminar a fonte de dados do relatório personalizado e todos os relatórios dependentes.`,
"label_emailsync_form_signin":`Login`,
"label.delete.cancel":`Não seleccionar`,
"label.dashboard.myHomePage.des":`Seleccionar o painel de instrumentos para diaplay em cada aplicação.`,
"lable.account.FY.Ago":`2 FY Ago`,
"label.umeng.approval.reassign":`#aprovador reatribuiu o seu pedido de aprovação #obj.`,
"label.data.exp.zippwd2":`Gerar Senha de Arquivo Comprimido Automaticamente`,
"label.tabpage.contentz":`Por favor introduza o conteúdo`,
"label.callcenter.batch.add.number":`Adicionar Números em Lote`,
"label.tabpage.deleteviewsuccess":`Ver apagar sucesso`,
"setup_layout_group_field":`Campos`,
"label.appupload.component.addobj.scheme.label.suoshu":`Objecto`,
"front-project-module-v1-market-is-template":`Marcar como modelo`,
"label.service.gantt.one.esource.types":`e um dos seguintes tipos de recursos`,
"label.emailtocloudcc.search":`Pesquisa`,
"label.mobile.home.page.myyj":`O meu desempenho`,
"vue_label_normal_invoice_sf":`Factura`,
"label.permission.detail.app.fenpei.tip":`Especificar que aplicações são visíveis no menu de aplicações.`,
"label.login.access.month":`Mês`,
"label_tabpage_retypez":`Quando o tipo de registo é alterado, os valores da lista de opções existente não serão automaticamente alterados. recomendamos que se actualize o valor da lista de opções existente do registo no mesmo local.`,
"label.ems.private.company.message":`As versões em nuvem privadas não suportam a edição online da caixa de correio electrónico da empresa.`,
"label.dataimport.length.check":`Comprimento superior a 18 bits, por favor rever cuidadosamente o registo e modificar.`,
"label.batchtransfer.type1":`Transferir as oportunidades em aberto que não pertencem ao titular da conta corrente`,
"vue_label_calendar_are_you_sure_to_remove":`Tem a certeza de remover este calendário`,
"label.icon.117":`Saco escolar`,
"vue_label_systemSettings_downloadapp":`Descarregar aplicação móvel`,
"label.approval.project":`Itens a aprovar`,
"template.organization":`Nível Organizacional`,
"label.weixin.return.research":`Voltar à página de detalhe do Micro Inquérito`,
"label.ccchat.person.invite.addsay":`Adicionar uma mensagem opcional...`,
"UG.Case.02":`Os casos permitem-lhe responder e resolver problemas de contas. Os casos são um poderoso registo na Cloud CC que não só rastreia os problemas de conta, mas também mostra uma visão completa da conta.`,
"label_emailtocloudcc_step1":`Passo 1`,
"workflow.action.tasks.assignortype.owner":`Proprietário`,
"label.data.import.page":`Ir para a página de importação`,
"label.cache":`Cache`,
"label.custom.page.cuspage.width":`Largura(Pixels)`,
"label.customcomponent.referencetag":`Etiqueta de referência`,
"label.tabpage.search":`Pesquisa`,
"label.knowledge.searcharticle.casefields":`Campos de casos para pesquisa de artigos sugeridos`,
"setup_layout_message_relatedlistfield":`Seleccione os campos a exibir na lista relacionada. Também é possível reordenar os campos seleccionados.`,
"label.relationobject.type":`Tipo de objecto relacionado`,
"UG_Account_02":`Algumas empresas prestam serviços a outras empresas, algumas colaboram directamente com os utilizadores finais, e outras servem ONG.`,
"UG_homepage_006":`Visibilidade de 360 graus na sua actividade de conta através de inquéritos, conversas ao vivo, e-mails, ordens de trabalho, postos nos meios de comunicação social, e mesmo actividades de vendas (tais como leads, apoio de serviços, e actividades).`,
"chatter.poll.option1":`Escolha 1`,
"label.ccdocument.fieldforld":`O nome da pasta de documentos pertence a`,
"label.wei.result":`Resultado`,
"label.recentview.new":`O mais recente`,
"label.martrixreport.setsumfield":`Seleccione o campo a utilizar como linha de resumo no seu relatório de matriz`,
"label.reportsSubscriptionPage.schedulereport.weekly.monday":`Segunda-feira`,
"label.marketsea.button.recycle":`Reciclar`,
"label.standard.buttonandlink.info2":`Seleccione a página personalizada CloudCC.com para utilizar no lugar do URL CloudCC.com para este botão padrão ou link.`,
"label.reportsSubscription.select.two.months":`Por favor, seleccione um intervalo de datas no prazo de dois meses para esta frequência!`,
"label.standard.buttonandlink.page":`CloudCC Clássico`,
"vue_label_commonobjects_view_chart_horizontalbar":`Gráfico de barras horizontais`,
"label.Remove":`Remover`,
"label.mobile.phone.receivable":`Pagamentos`,
"label.appupload.uploaddetail.goback":`Voltar ao Pacote`,
"label.select.role":`Por favor escolha um papel`,
"label.file.sharetype":`Tipo de partilha`,
"label.app.chosetab":`Seleccionar separadores`,
"label.case.other.phone":`Outro número de telefone`,
"chatter.edit.cancel":`As suas alterações foram canceladas.`,
"label.html":`HTML`,
"message.auth2cn.acquisition.failed":`Falha em obter o auth2cn!`,
"message.error.system.service.permissiondeny":`Desculpe, não lhe é permitido ser servido este serviço, por favor contacte o seu administrador.`,
"label.chatter.mygroups":`Os meus grupos`,
"label.umeng.approval.approvalpass":`O pedido de aprovação para o #obj é aprovado. #objnome`,
"label.chatter.owner":`Proprietário`,
"vue_label_commonobjects_view_kanban_view":`Vista Kanban`,
"message.please.choose.group.role":`Por favor, seleccione o papel do grupo`,
"label.icon.136":`Moeda`,
"label_tabpage_selectdate":`Seleccione uma data`,
"chatter.emailInformation":`Informação geral`,
"front-lightning-module-v1-dashborad-bubble-size":`Tamanho da bolha`,
"label.stdashbord.xsld.business.wan":`miríade`,
"label.datamanage.field.notexist":`O campo correspondente ao objecto não existe.`,
"UG.Forcast.04":`Iniciar o julgamento`,
"UG.contact.02":`Envolver contactos através de múltiplos canais, chamada, e-mail, social`,
"vue_label_pool_selecttransferinto":`Seleccione o pool de chumbo a transferir para`,
"label.quote.xingming":`Nome`,
"label.customerinfo.userlicencenum":`Licenças de utilização`,
"label.group.no.my.archived":`Não foram encontrados grupos de arquivo correspondentes.`,
"label.weixin.add.activity.tel":`Adicionar chamada de actividade`,
"label.partner.setup.address":`Endereço da nuvem de parceiros`,
"label.data.file.i_title.num3":`3.O sistema lê previamente o ficheiro de dados para o servidor, depois inicia o importador de massa back-end, cujos resultados serão notificados aos utilizadores por correio, e não terá de esperar nesta página.`,
"label_sum_up":`SUM`,
"label.searchall.title":`Pesquisa global`,
"label.bind.chooseone":`Escolher Proprietário`,
"label.campaign.channel.input.owner.select1":`Proprietário actual da campanha`,
"front-kefu-moudle-v1-Expand-chat":`Expandir Detalhes do Chat`,
"label.component.hotdeal":`Negócios escaldantes`,
"component_event_label_title":`Próximos eventos`,
"No.planed.activity":`Nenhuma actividade planeada`,
"label.searchlayout.result.field":`Colunas de resultados de pesquisa para pesquisa e etiquetagem.`,
"label.leadscore.value":`Valor`,
"vue.dashboard.linkage.is.set.successfully":`Ligação estabelecida com sucesso!`,
"PersonalInfo.LoginHistory.001":`A Broswer valida o link de registo na sua caixa de correio`,
"front-gantt-module-v1-problem-number":`Números de problemas`,
"label.page.step5.of.step5":`Passo 5 de 5`,
"label.sendemail.chat.sendmessagesubject":`CloudCC Alerta de mensagem CCChat`,
"label.Linkedin_accounts":`Conta LinkedIn`,
"label.qrcode.useful.life":`Data de validade do Código QR`,
"deleterow":`Remover Fila`,
"label.forecast.settings.future1":`Futuro 1 ciclo`,
"message.error.group.operation":`Erro de preenchimento de grupo`,
"label_tabpage_loadz":`Carregamento da página, por favor aguarde...`,
"label.brackets.left":`(Parênteses abertos`,
"label.source.code":`Ver código fonte`,
"setup_layout_label_areasetup":`Propriedades da Secção`,
"component.assistant.label.todaylead":`As pistas que lhe foram hoje atribuídas`,
"label.qrcode_signin":`O Código QR está limitado a aplicações que requerem leitura e entrada de código no local`,
"label.calendarshare":`Partilha de Calendário`,
"IMG":`Imagem`,
"label.use.rule.when.both":`Aplicar esta regra ao activar o código de barras e o código QR ao mesmo tempo.`,
"label.ccpeak.addshare.record":`Novos registos de formulários partilhados:Registos Adicionados Recentemente`,
"label.enable.email.tracking":`Permitir o seguimento de emails`,
"label.top.plsinput":`Pesquise esta lista...`,
"vue_label_helpcenter_case":`Os casos são perguntas, feedback ou problemas dos clientes. Os agentes de apoio podem rever os casos para compreender como prestar um melhor serviço. Os representantes de vendas podem utilizar casos para compreender o impacto no processo de vendas. A resposta a casos individuais pode satisfazer os seus clientes e melhorar a imagem da sua marca.`,
"label.useonly":`Particular`,
"label.displaytype":`Tipo de exibição`,
"label.most.user.group":`Os utilizadores podem juntar-se até 100 Grupos de Utilizadores, e já se juntaram aos 100º Grupos de Utilizadores.`,
"label.umeng.activity.yourevent":`O seu evento`,
"label.forecast.shrepage.classdes.w":`Leitura/escrita - O utilizador pode ver e anular os dados de previsão.`,
"label.defaultaccess":`Acesso por defeito`,
"label.partner.new.step2":`Passo 2 confirmar modelo`,
"component_setup_iframe_label_title":`Personalizar página`,
"label.sso.saml.sp.idenitytype":`Tipo de identidade SAML`,
"label.dashboard.this.folder":`Painéis de controlo nesta pasta`,
"label.data.newtemplate.e.seltype.desc":`Existem dois tipos de dados derivados</li>> classeli`,
"label.forecast.customforecast.submit.tip1":`Submeta a sua previsão a partir:`,
"label.version.workflow.and.approval":`Automatização do Processo de Aprovação e Fluxo de Trabalho`,
"label.tianyancha.tip":`O texto de entrada está incorrecto, por favor volte a entrar!`,
"label.report_details":`Detalhes do relatório`,
"template.report.folder.contract.product":`Contrato e Análise de Produto`,
"label.all":`Todos`,
"label.version.area.long.rich":`{0} campos de texto rico ou de área de texto longo`,
"label.enc":`Armazenamento encriptado`,
"vue_label_pricebook_enterproductname":`por favor introduza o nome do produto`,
"label.edit.quote.line":`Editar Linha de Citações`,
"label.edit":`Editar`,
"M":`Relação Master-Detail`,
"front-kefu-phonenumber-exists":`Lugar nº.{a} já existe`,
"label.standardplatformuser":`Utilizadores da Plataforma Padrão`,
"label.custom.page.configuration":`Editar Componente de Consola Personalizada`,
"url.error.contact.null":`O endereço do Microservice está vazio.`,
"label.sethelp":`Configurações de ajuda`,
"setup.mainpage.label.welcome23":`Definições de segurança`,
"label.sales.page.dashboard.fenxi":`Painéis de Análise de Vendas`,
"label.limit":`Acesso`,
"maintenanceasset.asset.contractlineitem.illegal":`Deve seleccionar o activo na rubrica do contrato antes de associar a rubrica do contrato com o activo de manutenção.`,
"UG.contact.04":`Ou`,
"Opportunity.Detailed.Phase.Label.004":`Dia(s)`,
"label.emailobject.receive":`Para`,
"label.brief.new":`Recentemente Novo`,
"label.marketsea.button.adopt":`para recolher`,
"label.select.up.to.three.fields":`Pode ser seleccionado um máximo de três campos.`,
"vue_label_allsearch_noresults":`Procurámos pelas suas definições de pesquisa personalizadas, nenhum resultado correspondente encontrado com {userInput}.`,
"Report_CantDelete_Info":`O relatório {0} é a fonte de dados para o painel de bordo {1} e não pode ser apagado!`,
"label.chile.summer.time":`Horário de Verão do Chile`,
"label.partnerCloud.menu.selectedMenu":`Menu seleccionado (os menus verificados serão sincronizados com a aplicação)`,
"vue_label_report_onlysummary":`Apenas resumo`,
"front-template-V1-Applicable-object":`Por favor, escolha o objecto aplicável.`,
"label.invoice.message.sendfailed":`A factura não foi enviada, por favor tente novamente mais tarde`,
"front-kefu-moudle-v1-use-free":`TRY FOR FREE`,
"label.rule.updated.successfully":`Actualizar as regras com sucesso`,
"label.owner.lastone":`A Grã-Bretanha tem pelo menos uma condição`,
"label.appointment.wizard.subtitle1":`Duração da Reunião`,
"template.report.opportunities.closed.month":`Oportunidades Fechadas deste Mês`,
"label.tabpage.choosecontent":`Seleccionar o conteúdo do valor`,
"template.chart.jbnddxl":`Encomendar vendas no último semestre`,
"label.fieldsecurity.detail":`Detalhes de segurança no terreno`,
"label.knowledgebase.data.deleted.successfully":`{a} dados apagados sucessivamente`,
"label.sso.saml.idp.config.nameidfmt":`Nome Formato de ID`,
"label.emailobject.prompt":`Pronto`,
"label.marketsea.isgetbyself":`Permitir que os membros se auto-recolham`,
"label.winxin.cancelprompt":`Tem a certeza de sair? a sua operação actual não está salva.`,
"label.appexchange.installedpage.message2":`As aplicações e os componentes são instalados em pacotes. Quaisquer aplicações, separadores e objectos personalizados são inicialmente marcados como "Em Desenvolvimento" e não são implantados para os utilizadores, o que lhe permite testar e personalizar antes de serem implantados. Pode implementar os componentes individualmente utilizando as outras características na configuração ou como um grupo, clicando em Deploy.`,
"vue_label_import_importtype":`Tipo de importação`,
"label.data.importef.des":`Os ficheiros que não foram importados serão guardados no servidor durante 48 horas e serão automaticamente apagados após 48 horas.`,
"chatter.email.reply":`Comentários sobre os meus posts`,
"label.stdashbord.xsld.business.sdl":`Taxa de Perdidos`,
"labal.emailtemplate.namemessage":`O nome único do modelo de e-mail existe, por favor reintroduza-o.`,
"vue_label_email_Please_select_file":`Por favor seleccione o ficheiro`,
"label.event.modify":`Edição de eventos`,
"label.projectManagement.isnmber":`Por favor, introduza um número com até uma casa decimal.`,
"lable.outlook.detail.emailst":`Configurações de e-mail`,
"label.partnerCloud.priceOfManual.isUsed":`Esta configuração determina se os parceiros podem ou não utilizar este livro de preços para encomendar.`,
"setup_mainpage_label_welcome26":`Gestão de dados - Processamento em lote`,
"label.file.version":`Versão`,
"pagecreator_systemstyle_label_bordercolor":`Cor da fronteira`,
"label.approval.isallowed.reject.prompt":`Quer permitir a rejeição ao aprovar dados únicos?(A aprovação em massa pode sempre ser rejeitada).`,
"label.myinfo":`Informação pessoal`,
"front-template-V1-fontSize":`Tamanho de letra`,
"lable.outlook.edit.alpreo":`Troca sempre preferida`,
"front-email-payment-card-number":`Número do cartão`,
"label.cpq.quote.pricebook.no.change":`Uma vez que o livro de preços para uma cotação tenha sido determinado, não pode ser alterado. É favor criar 1 novo registo de cotação para a utilização de um novo livro de preços.`,
"vue_label_file_size_limit_tip":`O tamanho do ficheiro excede o limite`,
"lable.PowerProcess.worktime":`Tempo de trabalho do processo de concessão de direitos`,
"label.monthly.month.report":`Relatório Mensal YoY e MoM`,
"front-kefu-moudle-v1-sydq-buyuser":`O seu rasto é devido. Por favor, compre o Easemob para continuar a utilizar`,
"label_tabpage_Rolesz":`Papéis e subordinados`,
"chatter.f.n":`Siga este registo`,
"UG.Forcast.02":`As previsões são estimativas de vendas esperadas para um determinado período, e os modelos de previsão podem ajudá-lo a determinar a procura de produtos e receitas de vendas num determinado período. Os gestores podem utilizar previsões para estabelecer objectivos e medir o progresso da equipa. A previsão global da organização pode reflectir o resumo de todas as vendas por representante de vendas (independentemente da fase de conclusão das vendas desde a fase de pipeline até à fase de encerramento).`,
"label.productsales.contract.phb":`Lista de contratos`,
"label.umeng.insert.approval.submit":`#O requerente submete #obj para a sua aprovação`,
"message.duplication.label.matchfirstletters":`Primeiros N caracteres`,
"label.partnerCloud.partnerAccount.toPay":`Ir para Pagamento`,
"label.model.un":`Modelo nº: UN6786`,
"label.save.c1":`O nome de "Web To CloudCC" deve ser único.`,
"week":`Semana`,
"Pagelayout.Setup.003":`O campo Nome deve ser seleccionado`,
"label.query.detail.openpartnermessage":`Uma vez que o cliente esteja habilitado como parceiro, aparece nos relatórios filtrados e vistas de lista no campo ispartner. além disso, os utilizadores parceiros podem criar a partir de contactos associados a este cliente. tem a certeza?`,
"label.validate.function.funcFormat.DATEVALUE":`DATEVALUE(data)`,
"label.apply.send.false":`Enviar falha`,
"label.recordtype.edit.selectvalue":`Valores da lista de selecção`,
"label.chosesubject":`Seleccione um assunto abaixo`,
"label.validate.function.funcExplain.YEAR":`O ano da data de regresso é um número entre 1900 e 9999`,
"component.chatter.button.more":`Ver mais detalhes`,
"label.top.class.smallest":`O nível mínimo da hierarquia é 1.`,
"label.startingvalue":`Número inicial`,
"label.multi.layout.remark":`Layout que se aplica ao Master-Detail Input frontal e ao Mass Add`,
"label.role.availableuser":`Utilizadores disponíveis`,
"label.weixin.iebrowser":`A versão do navegador que está actualmente a utilizar é o IE6, que foi lançado pela Microsoft em 2001. Uma vez que a versão do navegador é demasiado baixa para que o CloudCC seja desenvolvido utilizando nova tecnologia, não é garantido que todas as funções sejam utilizadas correctamente. Por favor, carregue e actualize o seu programa de navegação a tempo.`,
"Homepage_News_004":`Nenhuma notícia recente.`,
"vue_label_normal_task_sf":`Tarefa`,
"label.version.nonsupport.trigger":`Gatilhos não suportados por enquanto.`,
"pagecreator_page_label_pagelayout":`Layout da página`,
"label_tabpage_step3":`Passo 3 seleccionar os campos a exibir`,
"label.canOnlyUploadCSVFormatFile":`Carregar apenas ficheiros em formato CSV`,
"label.b.c.least":`Cada registo "B" deve ter pelo menos um registo "C" relacionado.`,
"label.list.userinterface.sales.enable":`Os quadros de vendas da página inicial permitem a visualização de dados`,
"label.umeng.approval.approvalreject":`O pedido de aprovação para o #obj é rejeitado. #objnome`,
"vue_labenl_normal_notice_share_fail":`A partilha falhou`,
"label_emailtocloudcc_tip":`Pronto`,
"label.h5.touchselect":`Clique para seleccionar`,
"label.tabularreport":`Relatório Tabular`,
"label.app.defaulttab":`Separadores por defeito`,
"label.validate.function.category.Datetime":`Data e Hora`,
"vue_label_pricebook_editdetail":`Editar entradas da lista de preços`,
"vue_label_commonobjects_view_no_selected_record":`Nenhum registo seleccionado`,
"chatter.changed":`Alterado`,
"label.asset.bom.based":`Gerar lista técnica de activos de acordo com a estrutura do produto da encomenda`,
"label.appointmentdetail.wizard.title8":`Comece em Cada`,
"label.area.query.user.error":`Os dados do utilizador correspondentes ao território de consulta falharam, e a identificação do território estava vazia.`,
"page.field.masterinput":`Definições de entrada Master-Detail`,
"chatter.selads":`Seleccionar Destinatários`,
"label.data.exp.please.savebutton":`Por favor, verifique "Guardar como modelo".`,
"label.members.activity":`Membros da Campanha`,
"label.weixin.click.searchs":`Clique para pesquisar o registo`,
"label.input.least.two":`Por favor introduza pelo menos dois caracteres`,
"label.marketing.seting":`Configurações da Nuvem de Marketing`,
"label.approveprocess.tip":`As aprovações são processos empresariais complexos que requerem a recolha e planeamento de informação antes de serem implementados. Recomenda-se que se siga as instruções abaixo antes de iniciar a implementação.`,
"front-email-payment-Invoice-login-account":`Conta de login`,
"label.selectmulti.mes":`Demasiados destinatários seleccionados.`,
"label.workflow.gotolist":`Voltar à lista: Fluxo de trabalho`,
"label.profile.fieldsafety":`Segurança a nível de campo`,
"front-project-module-v1-no-selectemplat":`Nenhum modelo disponível`,
"label.sendemail.queue.assigntitle":`O e-mail da fila de notificação de atribuição de objectos`,
"label.approval.mobile.comments.placeholder":`Por favor introduza aqui um comentário, até 1000 palavras`,
"vue_label_report_given":`específico`,
"vue_label_dashboard_groups":`Por favor seleccione o grupo`,
"label.service.gantt.popoverTip":`Distância de viagem/tempo de viagem`,
"label.mr.title.characters":`De acordo com o comprimento dos caracteres`,
"label.passwordPolicy.setup.day":`dias`,
"label_tabpage_personvisible":`Visível ao pessoal relevante`,
"ct":`Multi-moeda`,
"label.chatter.newEvent":`Novo Evento`,
"vue_label_systemSettings_id":`Identidade de login`,
"label.page.preview.web.tab":`Pré-visualização do separador Web`,
"label_emailsync_button_sure":`Confirme`,
"front-template-V1-Modification-time":`Tempo de modificação`,
"vue_label_homepage_edit_fixed_components":`Editar componentes fixos`,
"label.apply":`Aplicar`,
"Main.Menu.Mobiledownload":`LIGUE-SE`,
"vue_label_salesfunnel_notice6":`A quantidade total de oportunidades com uma probabilidade de 100%.`,
"label.chosesubject.sendemail":`Enviar Email`,
"label.changemydisplay.chagetab.des":`Escolha os separadores que irão aparecer em cada uma das suas aplicações.`,
"label.attendance.setting.checkUser":`já existe em outras presenças.`,
"label.list.projectSetting.setup":`Definições de Gestão de Projectos`,
"label.app.introduce2":`Pode personalizar aplicações existentes para corresponder à forma como trabalha, ou construir novas aplicações agrupando separadores padrão e personalizados.`,
"label_emailsync_form_emialpassword":`Senha`,
"label.Lightning.Setting":`Configuração do relâmpago`,
"label.print.preview":`Vista para impressão`,
"label_vue_create_edit_obj_create_event_dialog_desc_alert":`Ainda quer criar o evento neste período de tempo?`,
"label.mobile.phone.report.type":`Tipo de relatório`,
"lable.account.CalenderWeek":`Semana do Calendário`,
"label_emailtocloudcc_step3total3":`Etapa 3 de 3`,
"label_tabpage_emailaddressz":`Endereço de e-mail do remetente`,
"label.data.is_woking":`Em funcionamento`,
"label.knowledge.cancelattach.case":`Cancelar Anexar ao caso`,
"label.sendemail.chat.chatcontent":`O conteúdo do post principal:`,
"label.timezone.set":`Configurações do território`,
"label_tabpage_uploadingz":`Carregamento`,
"front-epwechat-module-v1-home-url":`URL da página inicial:`,
"label.reportsSubscription.select.subscription.frequency":`Por favor, seleccione a frequência de subscrição!`,
"label.validate.function":`função`,
"label.partnerCloud.orderingPlatform.quantity":`Quantidade`,
"label.compact.layout.chatter":`CCChat`,
"label.sso.saml.sp.description2":`Configurar o single sign-on a fim de autenticar os utilizadores no CloudCC a partir de ambientes externos.`,
"label.ccchat.message.new.error1":`Não conseguimos encontrar nenhum utilizador de chat com {0} no seu nome.`,
"label.file.share.email.content3":`Para mais detalhes, por favor faça o login no sistema CRM CloudCC.`,
"label.file.cancel.sharing":`Cancelar a partilha`,
"label.changemydisplay.showalltabs.add":`Adicionar separadores à sua exibição predefinida`,
"label_chatter_incident":`Evento`,
"label.file.folder.delete3":`Tem a certeza de que quer apagar {nome？}`,
"label_tabpage_delsuccessz":`Eliminar o sucesso`,
"label.view_contact":`Ver Contacto`,
"label.deactivate":`Desactivar`,
"label.Horizontal.Date":`Filtrar a marcação do serviço de acordo com a data do nível.`,
"label.forecast.tree.title":`Hierarquia das Previsões`,
"vue_label_dashboard_dategruop":`Favor seleccionar a base de agrupamento de datas`,
"label.version.nonsupport.custompage":`As páginas personalizadas não são temporariamente suportadas.`,
"label.tabpage.personvisible":`Visível ao pessoal relevante`,
"message.error.unknown":`Erro Desconhecido`,
"label.down":`Para baixo`,
"label.multilang.customforcast.financialyear":`{0} fiscal year：`,
"label.dataimport.type.error":`Digite o erro, por favor verifique o registo e modifique.`,
"label.batchadd.newbatchpage.save.num":`Formato numérico incorrecto`,
"front-Dev-V12.2.8-calendar-endField":`Campo final`,
"label.tabpage.rtemptyz":`O tipo de registo não pode estar vazio`,
"vue_label_dashboard_maximum":`Por favor introduza o máximo`,
"label.expiredate":`Data de vencimento`,
"label_emailtocloudcc_button_view":`Ver`,
"label.event.future":`Eventos futuros`,
"label.mobile.app.layout":`Layout da aplicação móvel`,
"label.emailobject.contacts":`  contacto(s)`,
"label.approvalstep2.tip":`Especificar se um registo deve cumprir determinados critérios antes de entrar nesta etapa de aprovação.`,
"label.usefollowtoset":`Usando as opções abaixo, especificar o utilizador a quem o pedido de aprovação deve ser atribuído.`,
"label.dashboard.summary.editPageHeader":`Editar cabeçalho`,
"label_partner_workspace_tab_memo":`Seleccionar separadores para esta nuvem de parceiros. podem ser seleccionados separadores padrão ou personalizados.`,
"front-lightning-module-v1-details-page-chart-title-supports":` O Título suporta a inserção de um nome de registo com um formato de {recordname}, tal como "Quantidade de oportunidade de {recordname}". Se o nome do registo actual for CloudCC, então será exibido como "Quantidade de Oportunidade de CloudCC".`,
"label.enable.generate.location.service":`Permite a geração de serviços de dados de latitude e longitude do cliente com base no endereço do cliente`,
"label.loginsystem":`Login`,
"label.email.template.edit.template":`Editar modelo`,
"vue_label_commonobjects_detail_share":`Quota de receitas`,
"label.icon.142":`Casa`,
"label.maintype":`Mestre`,
"label.step2.total4":`Etapa 2 de 4`,
"label.select.intended.tablayout":`Escolha o layout da página do separador da web que deseja criar.`,
"label.custom.unit":`Unidade`,
"label.mr.title.phone":`Telefone`,
"label.compact.layout.frame.showtype":`Método de exibição:`,
"label.associations":`Objecto associado`,
"label.potentialcustomers.name":`Nome de chumbo`,
"label.edit.profile":`Editar Perfil`,
"label.tabpage.allvisible":`Todos os utilizadores são visíveis`,
"label.login.verification.confirmation.enabled":`Confirmar para permitir`,
"vue_label_norm_recordselected":`{selectNum} registo(s) seleccionado(s)`,
"label.partner.workspace.member.selectedprofile":`Perfil seleccionado`,
"label.divide":`/Divide`,
"label.version.case.control":`Gestão de casos`,
"label.attendance.nocheckin":`Não Check-In`,
"vue_label_helpcenter_report2.1":`2.remover o agrupamento de filas: <br> A. Após encontrar o campo "agrupamento de linhas" que pretende remover na lista "linha de grupo" à esquerda, clique no "×" na caixa de campo. <br> B. Ou encontre o campo "agrupamento de linhas" que pretende remover no cabeçalho do relatório de pré-visualização à direita, clique no botão "drop down", e clique em "delete group row".<br> Remove column grouping: <br> A. Depois de encontrar o campo "Agrupamento de Colunas" que pretende remover na lista "Colunas de Grupo" à esquerda, clique em "×" na caixa de campo. <br> 1. B. Ou encontre o campo "Agrupamento de Linhas" que deseja remover no cabeçalho da tabela do relatório de pré-visualização à direita, clique no botão "drop-down", e clique em "Apagar linha de grupo". <br> Para remover um agrupamento de colunas:<br> A. Encontre o campo Agrupamento de Colunas que pretende remover na lista de Colunas de Grupo à esquerda, e clique no "x" na caixa de campo. <br> B. Ou encontre o campo Agrupamento de Colunas que pretende remover no cabeçalho da tabela do relatório de pré-visualização à direita, clique no botão drop-down, e clique em Eliminar Coluna de Grupo. <br>? Personalizar granularidade de data para agrupar registos<br> Passo 1: Após agrupar os campos por data, também pode personalizar a granularidade de data. Primeiro, seleccione o campo de data pelo qual pretende agrupar o relatório. Depois clique no botão Dropdown junto a este campo no cabeçalho do relatório de pré-visualização e clique em Date Grouping Basis (Base de agrupamento de datas). <br> Passo 2: Seleccione como pretende agrupar: Dia, Mês, Ano, Trimestre Contabilístico, Ano Contabilístico, Trimestre Personalizado, Ano Personalizado. <br>? Passo 1: Após encontrar a coluna que deseja resumir no cabeçalho do relatório de pré-visualização, clique no botão "drop-down" e clique em "Resumo". <br>?`,
"label.payment.renew":`Renovar`,
"vue_label_file_wrong_type":`Há um erro no tipo de carregamento do ficheiro, o formato do ficheiro que está a carregar agora é {type}!`,
"UG_opportunity_005":`Processo de vendas múltiplas`,
"label.knowledge.language.korean":`Coreano`,
"label.customobjects.inputrecordtagandformat":`Introduzir etiqueta e formato do nome do registo`,
"label.h5.chatter.commentednum":`Receber uma resposta`,
"label.quickbooks.button.unlink":`Desbloqueio`,
"label.step5.total5":`Passo 5 de 5`,
"label.projectManagement.Selweek":`Seleccione Semana`,
"label.optional.searchfield":`Campos disponíveis para pesquisa`,
"label.mobile.quickcreate.default.signin":`Fazer o check in`,
"label.visualpage.unable.parse":`Incapaz de resolver o marcador.`,
"mesage.error.role.delete":`Não se pode apagar o papel ao qual o papel de criança foi atribuído.`,
"label.role.user":`Utilizadores na Função`,
"button_partner_workspace_saveas":`Salvar como`,
"label.file.no.public.link.created":`Nenhuma ligação pública criada`,
"label.login.access.shenyu":`Restante`,
"label.ccchat.group.section":`Grupo`,
"label.weixin.object.notnull":`O tema não pode estar vazio`,
"label.accmarketsea.add.title":`Novo Pool de Contas`,
"label.sales.funnel.layout":`Venda de Funil Layout`,
"pagecreator.page.button.edit":`Editar`,
"label_tabpage_entercontent":`Por favor introduza o conteúdo`,
"component_event_label_begindate":`*Tempo de arranque`,
"label.file.versionhref":`Mudar para a nova versão da página`,
"label_chatter_send":`Enviar`,
"setup_layout_label_buttonlist":`Seleccionar botões`,
"label.custom.Current.and.NexttCQ":`Corrente e Próxima 3 CQ`,
"pagecreator_page_label_pagedesc":`Descrição da página`,
"label.appupload.upload.uploader":`Carregado por`,
"label.console.step5.tab.primary":`Como separador principal`,
"vue_label_globalsearch_expandlist":`Expandir lista`,
"label.forecast.edit.userqu":`Alvo`,
"label.step1.total5":`Etapa 1 de 5`,
"label.multilang.dupicatecheck.onegroupredata":`Progresso da verificação de duplicado e o total de combination：a de {0} groups：`,
"vue_label_systemSettings_repeat":`Gerir Duplicações`,
"label.mobile.side.tab.error1":`Por favor, seleccione os leilões comuns e os separadores de aplicação que precisam de ser exibidos.`,
"label.knowledgebase.reduction":`Restaurar`,
"label.standard.buttonandlink.override.usedefault":`Sem anulação(utilizar por defeito)`,
"dateandtime":`Data/Hora`,
"label.group.activate.info":`Activar o grupo`,
"label.triggertotask":`Desencadeadores de tarefas`,
"label.emailobject.save.template":`Guardar rascunho como modelo`,
"label.audit.objInfo":`Detalhe do processo de aprovação`,
"label.callcenter.successfully.logged.account":`Conectese com sucesso!`,
"label_new_customer_target":`Novo objectivo da conta`,
"label.campaign.channel.step5":`Passo 5: Pré-visualizar a página de registo do canal de marketing e o código fonte.`,
"label.log.type":`Tipos de operação`,
"front-template-V1-noTemplate":`Não foram encontrados modelos disponíveis sob o objecto comutado.`,
"label_report_line_daixuan":`Coluna de relatório pendente`,
"label.tianyancha.businessverify.relation.tip":`Escrever os campos devolvidos por tianyancha aos campos do cliente`,
"label.default.value":`Utilize este valor como valor por defeito para a lista de selecção principal`,
"label.weixin.campaign.attendance":`Participação na Campanha`,
"message.duplication.label.check":`Verifique`,
"label.salescloud.salescloud.yes2forbidden":`Sim, quero desactivar a Venda em Equipa.`,
"lable.currencyAdv.exchagecurrency.rate":`Taxas de câmbio para:`,
"lable.Hide.title":`Ocultar títulos`,
"label.finishedreport":`Relatórios Gerados`,
"vue_label_account_business":`Transferência de oportunidades de negócio fechadas de proprietários de clientes`,
"vue_label_pool_assigned":`Atribuído`,
"label.report.export.error":`A operação de exportação encontrou uma excepção. Por favor, tente novamente.`,
"label.layout.availablefield":`Campos disponíveis`,
"label.licence.remainder":`Restantes licenças`,
"label.approval.idea.required":`É necessário o parecer de aprovação.`,
"front-kefu-moudle-needhand-createcase":`É necessária confirmação manual antes de criar o caso`,
"label.dashboard.snapshot.Data.change":`Fonte de dados alterada,por favor reconfiguração`,
"label.partner.workspace.login.footertext":`Texto do Rodapé`,
"vue_label_chatter_upload_link_type":`Carregamento seleccionado de linha tipo post`,
"front-dialog-module-v1-error-detail":`Detalhes do erro`,
"label.emailobject.sendgroupemail":`Enviar e-mail de grupo`,
"lable.newtabpage.allviews":`Todas as vistas`,
"label.khdd":`Localização da conta`,
"vue_label_dashboard_sortfield":`Ordenar Campo`,
"label.form.sample":`Exemplo de formulário`,
"component_setup_button_cancel":`Cancelar`,
"vue_label_salesfunnel_notice5":`Quantidade de oportunidades de negócio com uma probabilidade de 1% - 99% * probabilidade`,
"pagecreator_systemstyle_label_modifystyle":`Editor de estilo`,
"UG_homepage_001":`Ganhar mais negócios em menos tempo`,
"label.campaign.pc":`PC`,
"label.visualpage.lightning":`Versão relâmpago`,
"label.knowledge.category.hint.two":`Utilize esta página para seleccionar o grupo para Relâmpago depois de criar o grupo de categoria.`,
"label.south.africa.standard.time":`Tempo Padrão da África do Sul`,
"label.service.gantt.reservation.number":`Número de encomenda`,
"label.weixin.report.period":`Período`,
"label.leadtomap.exp":`Utilize os separadores para mapear cada um dos campos de chumbo personalizados da sua organização para um dos campos de conta personalizada, de contacto, ou de oportunidade. Estes mapeamentos são utilizados quando converte leads para contas, contactos, ou oportunidades.`,
"label.currency.d":`Pode mudar a sua moeda corporativa para outra moeda da sua organização suportada. Todas as taxas de conversão de moeda já definidas no CloudCC.com serão modificadas adequadamente para reflectir a mudança.`,
"label.forecast.detailforecast.oppyclb":`Categorias de Previsões de Oportunidades`,
"label.reportsSubscriptionPage.email.selected":`Membros seleccionados`,
"vue_label_homepage_componentname":`Por favor introduza o nome do componente`,
"lable.account.Previous.FYt":`Anterior 2 FY`,
"label.appupload.success":`Upload Completo`,
"label.customer.newtab":`Novo separador Página Personalizada`,
"label.value.notnull":`É necessário introduzir um valor.`,
"label.case.miniprogram.layout":`A paginação da página de relatório da applet é a paginação utilizada para o pedido de serviço que foi submetido do final da applet, e esta paginação só pode ser editada e não pode ser apagada.`,
"label.partnerCloud.partnerAccount.twoDecimal":`Por favor, introduza no formato correcto.  Podem ser mantidas duas casas decimais.`,
"UG.Lead.004":`Formulário Web`,
"label.umeng.activity.event.eventwillbeginnew":`Notificação de eventos: #evento começa em #begintime`,
"label.projectManagement.subtasks":`Sub-taks`,
"vue_label_checkduplicate_repeat_conditions":`Decidir condições repetidas`,
"label.subject":`Assunto`,
"label_search_otherusers_forecast":`Pesquisa de previsões de outros utilizadores`,
"label_tabpage_namemandatory":`O nome da vista é obrigatório`,
"label.timezone.importtimezone":`A definição do fuso horário para a importação de dados`,
"label.mobile.buttom.team.init":`Inicialização do utilizador da equipa`,
"label.checkfield.choosefield":`Seleccione os campos para encontrar as duplicatas`,
"label.b_c_least":`Cada registo "B" deve ter pelo menos um registo "C" relacionado.`,
"label.knowledge.setting.hint.five":`Seleccione um autor de Conhecimento`,
"label.h5.similar.opportunity.step2":`Etapa 2 Especificar Critérios de Partida`,
"label.page.style.imbedded.cloudcc":`O estilo de página inteira dá-lhe o maxmium screen real estate para o conteúdo que incorpora na janela do CloudCC.com.`,
"label.sendemail.marketactivity.invitecode":`O código de inviolabilidade da campanha #campaignname`,
"label.block.pricing":`Fixação de preços por blocos`,
"message.error.field.number.zero":`O formato de comprimento do erro introduzido, não pode ser 0.`,
"pagecreator.systemstyle.message.save.success":`Estilo guardado com sucesso`,
"pagecreator_systemstyle_label_styledesc":`Descrição de estilo`,
"APPIntegration_Dropbox_setting_01":`Habilitar`,
"label_emailtocloudcc_redmessage2":`Por favor introduza a palavra-passe correcta da sua conta de e-mail`,
"label.user.special.operations":`Utilizado apenas em funcionamento, não pode ser utilizado temporariamente, por favor contacte o administrador!`,
"pagecreator_page_label_layoutpreview":`Pré-visualização do layout`,
"APPIntegration_Dropbox_setting_03":`Activar Dropbox para lhe permitir seleccionar ficheiros da Dropbox e adicioná-los como anexos.`,
"label.sure_leave":`Tem a certeza de partir?`,
"label.applt.copylink":`Copiar ligação do miniprograma`,
"label_tabpage_allpotentialcustomers":`Todas as pistas`,
"label.rulestrikedate":`Tempo de activação de regras`,
"label_tabpage_justsz":`Apenas`,
"label.customize.memory.function.sorting.title":`Personalizar a função de ordenação da minha memória`,
"message.duplication.label.mergebutton":`Fundir`,
"chatter.group.cancelRequest":`Pedido de cancelamento`,
"label.campaign.channel.step6.remark":`Se tiver confirmado a página de registo, clique em Gerar botão para gerar a página de registo.`,
"label.appupload.upload.install.abort":`Cancelar Instalação`,
"label.emailobject.proposetimes":`Propor tempos`,
"label.probability.cannot.empty":`Deve introduzir um número na sua possibilidade de oportunidade.`,
"vue_label_homepage_editkanban":`Editar Kanban`,
"lable.Related.template":`Modelos relevantes`,
"label.cloudccclass.list.cls.time":`Classes programadas`,
"component.task.label.enddate":`Data de expiração`,
"label.sendmail.step3":`Passo 3 Rever e confirmar`,
"label.projectManagement.Gridview":`Vista de Grelha`,
"label.emailobject.time":`Hora`,
"label.applt.address":`Portal de Atendimento ao Cliente do Miniprograma`,
"label.searchfield":`Campos de Pesquisa`,
"vue_label_calendar_please_enter_the_name":`Por favor introduza o nome`,
"label.list.userinterface.default.page.setup":`Página predefinida do sistema`,
"label.detail.2018":`Detalhes`,
"label.webtocloudcc.success":`A sua informação foi submetida com sucesso. Muito obrigado pela sua participação, servi-lo-emos de todo o coração.`,
"component_telerecord_label_title":`Gravar telefone`,
"label.setting.sureDelete.rules":`Tem a certeza de que quer eliminar esta regra?`,
"vue_label_email_current_theme":`A inserção deste modelo cobrirá o assunto actual do e-mail.`,
"lable.Order.product":`Encomendar Produto`,
"UG_product_02":`Os produtos referem-se a produtos ou serviços que são vendidos ou comprados.`,
"label.appexchange.task":`Tarefas de fluxo de trabalho`,
"label.selectprocesscondition":`Especificar condições para a etapa`,
"label.mobile.quickcreate.default.scan":`Scan`,
"label.tabpage.prepagez":`Mostrar em todas as páginas`,
"label.query.error":`Erro de consulta.`,
"label.tabularreport.2018.step1":`Passo 1 Escolha as colunas do relatório`,
"pagecreator.systemstyle.label.modifystyle":`Editor de estilo`,
"label.app.step3":`Passo 3 Escolha a fonte da imagem para o logótipo da aplicação personalizada`,
"label_tabpage_rowsz":`Eliminar filas`,
"label.validate.function.funcExplain.SUBSTITUTE":`Substitui texto_novo por texto_antigo numa cadeia de texto. Utilize SUBSTITUTO quando quiser substituir texto específico numa cadeia de texto.`,
"vue_label_checkduplicate_select_data_to_merge":`Seleccionar dados para fundir`,
"vue_label_commonobjects_view_chart_displaymode":`Modo de exibição`,
"label.industrialandcommercialverification.servicesetiings":`Configurações de serviço`,
"label.refresh":`Actualizar`,
"label.taskfield":`Campos de Tarefas`,
"label.notification.approval4":`【提交人】 está a solicitar a aprovação para 【对象】`,
"label.group.isusing":`Activo`,
"label.language.settings":`Definição da língua`,
"front-kefu-moudle-please-login":`Por favor, faça o login primeiro`,
"label.page.double.line.cloudcc":`2 Colunas com a Barra Lateral do CloudCC.com`,
"folder.error.delete":`1. A pasta actual contém relatórios e não pode ser apagada! 2. A pasta actual contém relatórios escondidos e não pode ser apagada! Relatório oculto é um relatório criado com base num objecto logicamente apagado (definições-criação-deleted objects under the object), porque o objecto não é realmente apagado, por isso o relatório é oculto`,
"eight":`Oito`,
"label.marketseamemset.user":`Membro`,
"label.recordnum":`Número de registo`,
"page.404.button.back":`Voltar ao Passo Anterior`,
"label.mobile.phone.month.plan":`Planos do próximo mês`,
"label.marketseamemset.account.title2":`É favor estabelecer um limite superior para o número de clientes que afectam todos os membros. O limite não está relacionado com o grupo de clientes principais.`,
"vue_label_chatter_current_avatar":`Avatar actual`,
"label.mobile.side.tab.remark3":`Mantenha premido o botão shift, clique ou clique em arrastar para seleccionar uma série de itens adjacentes. mantenha premido o botão ctrl e clique para seleccionar vários itens não aderentes.`,
"component.sendmail.label.touser":`Destinatário`,
"label.homeitems.noobject":`Sem Temas`,
"template.report.overall.sales":`Período global de vendas (Por fonte principal)`,
"label.partner.donotdel":`não pode apagar`,
"label.service.miniProgram.bindCopyDesc":`Depois de ligar a sua organização à conta oficial da sua empresa ou mini programa, pode usar este endereço como o seu próprio portal de serviço ao cliente, copiando e saltando para este endereço.`,
"UG_Contract_01":`Gerir contrato`,
"UG_quota_06":`Criar uma citação`,
"vue_label_report_deletereport":`Eliminar relatório`,
"front-epwechat-module-v1-input-appname":`Por favor introduza o nome da candidatura`,
"label_tabpage_deleteviewsuccess":`Ver apagar sucesso`,
"component_chatter_label_mygroup":`O meu grupo`,
"label.campagin.roi.leixing":`Tipo de campanha`,
"label.dashboard.myHomepageDashboard":`Os meus Painéis de Homapage`,
"UG_solution_04":`Solução de importação`,
"label.knowledge.setting.hint.four":`Activar o conhecimento`,
"label.campaign.channel.add.field":`Clique no botão para adicionar campos`,
"label.eastem.european.time":`Tempo da Europa de Leste`,
"label.partner.workspace.member.partner":`Perfil do parceiro CloudCC`,
"label.campaignmember.main.backtocampaign":`Voltar a Campanhas`,
"label.reportsSubscriptionPage.schedulereport.monthly.time.absolute":`Absoluto`,
"label.task.unsolve":`Todas as Tarefas Abertas`,
"label.multilang.chatterservice.vote":`{0} bilhete(s)`,
"label.console":`Consola`,
"label.emailsync.message1":`Se cancelar a ligação, não conseguirá sincronizar o conteúdo da caixa de correio com os contactos e os contactos, tem a certeza de que quer cancelar?`,
"pagecreator.systemstyle.label.stylename":`Nome do estilo`,
"setup_mainpage_label_welcome16":`Instruções: Clique no menu do lado esquerdo da página → Application Settings → Create → Workflow, Approval Process, Tasks, Email Notification, Field Update, e muito mais.`,
"message.duplication.label.editfilterule":`Encontrar Regras de Filtro Duplicado`,
"Account.News.Setting.004":`Activar Notícias`,
"label_tabpage_saveviewsuccess":`Vista guardada com sucesso`,
"label.forecast.forehistory.replacecommit":`Comprometa-se a Substituir`,
"pagecreator_button_cancel":`Cancelar`,
"label.knowledge.article.nomatch":`Não é possível arquivar este artigo para o projecto associado. Por favor, elimine o rascunho e tente novamente.`,
"vue_label_combined_field":`Nenhum campo a somar.`,
"label.batchadd.save.prompt":`registo(s)`,
"label.tabpage.summaryway":`Resumo por`,
"label.check.input.condition.two":`SQL não é suportado`,
"mail.apiCode.notOnly":`O único nome já existe`,
"UG.quota.01":`Gerir citações de contas`,
"label.approved.receiveApprovalEmail.option3":`Só se eu for um aprovador delegado`,
"label.stdashbord.xsld.business.img5":`Quantidade Total de Probabilidade 0%`,
"vue_label_chat_movedfromto":`{nome} moveu {label} de {oldField} para {newField}`,
"label.customfields.new.step2.opration":`Opções Gerais`,
"label.dashboardSetup.isurl":`Adicionar ligações`,
"label.forecast.settings.mrfwqj":`Ciclo de Previsões`,
"label.campaign.channel.field":`Campos`,
"label.weixin.optionthree":`Escolha 3`,
"label.safetystatement":`Declaração de segurança`,
"label.useskipwizard":`Use o Jump Start Wizard`,
"label.projectManagement.completion":`Estado de Conclusão`,
"label.customfields.fielddependency.new.step2":`<b>Passo 2: </b> Na página seguinte, editar as regras de filtragem que controlam os valores que aparecem no campo dependente para cada valor no campo de controlo.`,
"setup.mainpage.label.welcome8":`Personalização da interface de arrastar e largar`,
"label.emailobject.list.outbox":`Caixa de saída`,
"label.app.default.login.tab":`Separador de início de sessão predefinido`,
"label.follow_emails":`O email de acompanhamento é uma óptima forma de contactar rápida e facilmente os seus visitantes uma vez que estes enviem formulários.`,
"vue_label_homepage_application_page":`Página inicial da aplicação`,
"label.confirm.template":`Confirme`,
"lable.product.not":`Não pôde ser completamente apagado`,
"label.multilang.feedtrack.dispalyinfo":`Pode escolher o máximo de campos {0}:`,
"label.weixin.plz.inputsrhkey":`Por favor introduza uma palavra-chave de pesquisa`,
"label.projectManagement.service.appointment":`Nomeação de serviço`,
"label.list.userinterface.watermark.enable":`Activar marcas de água na página inicial, vistas, páginas de detalhes, relatórios, e painéis de instrumentos no PC e na aplicação móvel.`,
"label.confirmDelete":`Tem a certeza de que quer apagar estes dados?`,
"label.sso.description":`Os utilizadores podem aceder ao sistema CloudCC.com sem fazer login de acordo com o nome de utilizador e código de autorização.<br>Clique no URL abaixo para aceder ao sistema CloudCC.com: _COPY7@dev.com&authCode=dcc5c192facd7c08e124fbe93d8950b9 .<br>Utilize os links acima,'http://localhost:8080' substitua por favor o acesso da sua organização ao link.'admin@dev.com' substitua por favor o nome de utilizador da organização.<br>'dcc5c192facd7c08e124fbe93d8950b9' substitua por favor o seu código de autorização da organização.`,
"errormessage_email_atleastonereceiver_z":`Deve seleccionar ou editar um endereço de recepção.`,
"C":`Resumo do Roll-Up`,
"label.service.major.event.edit":`Editar Marco`,
"label.icon.9":`Serviço`,
"label.visualpage.notvalidate.check":`Páginas personalizadas inválidas, consulte por favor o Texto de Ajuda para verificar a página.`,
"label.audit.todo.from":`a partir de`,
"label.directboss":`Este papel reporta a`,
"label.manageAll.selpage":`Página`,
"label.console.step6.all":`Ecrã inteiro, não fixo e as listas só são visíveis quando o separador de navegação é seleccionado.`,
"vue_label_pool_expiredate":`Data de expiração`,
"lable.no.matching.record":`Sem registo de correspondência`,
"label.standard.redirecterror":`Saltar para página personalizada através de botões padrão falhou.`,
"label.Platform.Setting":`Configurações da plataforma`,
"lable.outlook.edit.havenewc":`Contactos com actividades recentemente criadas`,
"label.partnerCloud.partnerAccount.choosePayment":`Por favor seleccione um método de pagamento`,
"label.weixin.optionsix":`Escolha 6`,
"lable.SalesCommitmentKanBan.allCommitments":`Gasoduto`,
"page_404_button_toknowmore":`Saiba mais`,
"label.customfields.number.tip":`Permite aos utilizadores introduzir qualquer número. Os zeros principais são removidos.`,
"label.import.index.processimport":`Importação`,
"label.quote.phone":`Telefone`,
"label.insert.approval":`Inserir Aprovação`,
"label.tabpage.printview":`Vista de Impressão`,
"lable.product.price":`Preço`,
"front-kefu-moudle-call-detail":`Detalhes da chamada`,
"label.umeng.approval.apply":`aplicar`,
"label.background.the.form":`Fundo do formulário`,
"chatter.f":`Seguidores`,
"label.quickbooks.searchresault.company":`Empresa`,
"vue_label_systemSettings_platformutils":`Ferramenta da Plataforma`,
"front-quotation-v1-nofilles-tocreate":`Por favor, clique em Generate Quote e envie após a geração.`,
"label.category.6":`Tratamento médico`,
"label.attendance.choose.positon":`Seleccionar Pontos de Referência`,
"label.batchadd.newbatchpage.save.pho":`Formato de telefone inválido`,
"UG.Account.01":`Quem é a sua conta?`,
"label.marketseamemset.addspecialuser":`Adicionar membros especiais`,
"label.query.detail.forbidpartneruser":`Proibir o utilizador parceiro`,
"label.stdashbord.xsld.business.ydzhl":`Taxa de Vitórias`,
"vue_label_SMS_mymessagebox":`A minha caixa de mensagens`,
"label.knowledgebase.data.publishing.failed":`Publicar {a} os dados falharam. Por favor, escolher artigo com estatuto igual a Rascunho para publicar.`,
"label.wholestate":`Estado geral`,
"label.selectedline":`Colunas seleccionadas`,
"label.validate.function.funcExplain.LEFT":`Devolve o número especificado de caracteres desde o início de uma cadeia de texto`,
"label.emailmerge.edittemplate.detail":`Detalhes do modelo de fusão de correio`,
"vue_label_checkduplicate_checkduplicate":`Verificar duplicado`,
"label.knowledgebase.assign.articles":`Artigos de Assing`,
"label.tabpage.recordsz":`Registo`,
"label.field.img.validate.error":`O nome da variável após $User está mal escrito ou é uma referência ilegal $User, por favor verifique a ortografia.`,
"workorderlineitem.worktype.isnot.father.worktype":`O tipo de trabalho associado ao seu registo principal deste item da ordem de trabalho deve ser seleccionado.`,
"label.ccchat.group.name.noexist":`O nome do grupo que introduziu não existe, por favor reintroduza-o.`,
"label.weixin.sign.type":`Tipo de erro de entrada (saída).`,
"label.nowvaluereplace":`Substituir por Existente`,
"report_label_report":`Relatórios`,
"label.knowledge.setting.plus":`Mais Definições de Conhecimento`,
"label.event.moveup.2day":`2 dias à frente`,
"label.translation.start":`Para começar no Workbench de Tradução:`,
"lable.PowerProcess.created.time":`Com base no tempo de criação do {detailInterestType}`,
"label.ems.step2":`Passo 2`,
"label.tabpage.groupingemptyz":`Os artigos de agrupamento não podem estar vazios`,
"pagecreator.layout.button.new":`Novo layout`,
"label.tabpage.listshow":`A lista mostra`,
"label.partnerCloud.productSet.optionName":`Nome da opção`,
"label.service.without.cycle":`Sem ciclo`,
"label.chatter.sendEmailToGroupMember.subject.V":`{0} votos publicados para todos em {1}`,
"label_target_model_dimension":`Dimensão do modelo alvo`,
"component.task.label.subject":`Tema`,
"label.custom.field.login.query.information":`Por favor, introduza o sistema e veja os detalhes.`,
"label.validate.function.funcExplain.NOT":`Mudar FALSO para VERDADEIRO ou mudar VERDADEIRO para FALSO`,
"pagecreator_layout_button_horizontal":`Desmontagem lateral`,
"lable.Returned.to.successful":`Regressar com sucesso`,
"label.campaign.channel.ticket.title":`Bilhete de entrada`,
"label.ruleName.supportMaximum.50Characters":`É suportado um máximo de 50 caracteres para o nome das regras.`,
"label.email.track.attachment.size.control1":`O tamanho total do anexo excede os 20m, não pode ser carregado`,
"template.report.folder.opportunities":`Análise de Oportunidades`,
"label.knowledge.setting.data.eight":`Vai eliminar o grupo de categorias {flzmc} e as suas categorias. Esta categoria não estará disponível para atribuição aos registos. Tem 15 dias para cancelar a eliminação do grupo de categorias. Após 15 dias, será definitivamente apagado e não poderá ser recuperado. Tem a certeza de que pretende apagar este grupo de categorias e as suas categorias?`,
"mail.id.notNull":`O ID não pode estar vazio quando se apaga o modelo`,
"vue_label_normal_product_sf":`Produto`,
"vue_label_report_superiortothisrelationship":`A relação entre o objecto superior e este objecto`,
"label.leadscore.operation":`Operador`,
"label.customfields.formula.percentexample":`Desconto = (Montante - Desconto_Amount__c) / Montante`,
"component.setup.iframe.label.inputurlmemo":`Por favor, introduza a url da página a importar`,
"label.icon.177":`Logótipo`,
"label.tabpage.myz":`O meu`,
"label.leadmarketsea.add.title":`Criação de um grupo de chumbo`,
"label.partnerCloud.partnerAccount.thePage":`Página {skippageNum}`,
"label.visualpage.some.size":`Capacidade de código: suporte máximo para 300KB caracteres, aproximadamente 300.000 bytes.`,
"label.setwxpay.null":`As informações necessárias para configurar o pagamento WeChat estão vazias.`,
"label.icon.74":`Máquina-ferramenta`,
"font-evaluate-module-v1-evbad":`O tipo de avaliação é Negativa`,
"System.TimeField.Format.Warning":`Tempo inválido`,
"label.captcha":`Código de Verificação Aleatória`,
"label.payment.assessment":`Consultar Outras Edições`,
"message.error.not.taskevent":`Objecto de evento não-tarefa`,
"font-evaluate-module-v1-evaluation":`Avaliação`,
"vue_label_commonobject_view_updatedago":`Actualizado {timeInterval} atrás`,
"label.sendemail.birthday.newevent":`Caro {!ownerName}：\r{!objectLable} {!recordName} O aniversário do {!recordName} será em 3 dias. Por favor seja aware！{!orgName}`,
"label.laststep":`Passo Anterior`,
"message.duplication.label.matchoption":`Opção de Correspondência`,
"label.setupmultplerecordtype":`Tipos de registos múltiplos`,
"vue_label_account_unprocessed_oppprtunities":`Oportunidades não processadas`,
"KeyInformationLayout.DefaultLayout.Name":`Default do sistema`,
"label.partner.all":`Todas as nuvens de separação`,
"label.datamanage.export.error":`A exportação falhou`,
"label.standard.buttonandlink":`Botão Padrão ou Ligação`,
"label.reportsSubscriptionPage.email":`Relatório por e-mail`,
"message.nogrammarfaultinformula":`Sem erros de sintaxe.`,
"front-kefu-moudle-nofind-instance":`Nenhum caso encontrado`,
"label.is.delete.data":`Os registos que pretende apagar contêm os registos que estão a pedir aprovação, tem a certeza de que pretende apagar?`,
"label.partner.error":`Erro: erro no formato do domínio`,
"label.notification.time2":`{0} minutos atrás`,
"label.ccchat.person.invite.needfirstname":`Introduza o seu nome`,
"label.mr.title.URL":`URL`,
"chatter.norecord":`Sem Registos.`,
"label.readwrite":`Leitura/escrita`,
"label.partnerCloud.orderingPlatform.orderPayment":`Pagamento de encomendas`,
"label.accesslimittype":`Nível de acesso`,
"label.preciew_tab":`Ligação de prévisualização em novo separador`,
"label.attachment":`Anexo`,
"label_tabpage_helpNavigationz":`Ajuda e navegação`,
"label.dataimport.select":`Verificar esta informação,realizar os dados de importação`,
"chatter.en.info":`Introduza informação para que as pessoas possam saber mais sobre si.`,
"label.ccservice.validate.date":`O formato do valor correspondente {2} do campo {1} sob o objecto API {0} está incorrecto. Por favor introduza o formato correcto de data ou hora!`,
"label.social.posts.send":`Falha no correio`,
"label.emailobject.time.to":`Para:`,
"label.defineReportStep1":`Passo 1`,
"savefail":`Salvar falhou`,
"label.mr.descreption.title":`Fundir dados duplicados`,
"label.share.info.by":`Por`,
"label.list":`Lista`,
"label.event.select":`Seleccionado`,
"message.accountmap.cannotfind":`O endereço da conta não pôde ser encontrado, por favor actualize o endereço da conta.`,
"label.choosefield":`Campos da Página de Aprovação`,
"label.forecast.settings.title":`Previsões Definições`,
"label.setup.log.datetime":`Registo de comportamento de download dentro do intervalo de tempo de pesquisa(Excel.xls)`,
"button_partner_new":`Nova nuvem de parceiros`,
"label.umeng.approval.dlsp.reject":`#aprovaçãonome rejeitou o pedido de aprovação do #actorname' de #objAPIName #recordname para si.`,
"label.tabpage.totalTeamz":`Um total de grupos`,
"label.lead.score.prompt3":`Isto pode levar vários minutes. Você receberá um e-mail de confirmação uma vez concluído.`,
"label.schedulejob.setup.schedule.name":`Nome do trabalho`,
"vue_label_report_advanced":`Quando o filtro avançado estiver activado, escrever manualmente o estado do filtro na caixa de filtro avançado abaixo, o formato é mostrado na figura.`,
"label.emailsync.form.connecttime":`Tempo Relacionado`,
"front-gantt-module-v1-project-status":`Estado do projecto`,
"label.field.for.example":`Por exemplo`,
"label.marketsea.manager.notnull":`O administrador não pode estar vazio.`,
"label.click.here":`&lt&lt Clique aqui para voltar`,
"UG.solution.04":`Solução de importação`,
"label.validate.function.funcExplain.IF":`Quer a condição seja verdadeira ou não, e se a condição for VERDADEIRA devolve um valor e a condição é FALSA, outro valor é devolvido.`,
"label.profile.settab":`Definições do separador`,
"front-email-payment-weichat-tips":`Digitalizar Código QR a pagar`,
"label.task.next.week":`Semana seguinte`,
"label.operatedata.selectobjectfields.tip":`Seleccione os campos que deseja exportar, e deve seleccionar pelo menos no campo para exportar.<font color="red">Attention:Text Area(Rich) can not be export.</font>`,
"label.recalculate.alert":`Por favor, seleccione a regra de partilha que pretende recalcular.`,
"label.marketsea.noopportunitydays":`Dias sem criação de oportunidades de negócio (precisa de ser superior ao número de dias sem seguimento após a obtenção)`,
"label.chat.likeperson":` Pessoa(s)`,
"label.selectedFields":`Campos disponíveis`,
"label.App":`Aplicações`,
"label.file.type":`Tipo de ficheiro`,
"permissionService.error1":`Licença de candidatura insuficiente.`,
"front-detail-module-v1-chart-display":`Visualização de gráficos`,
"label.audit.status":`Estado de Aprovação`,
"UG.activity.05":`Telefone de gravação`,
"label.connectOtherObject":`( Clique para relacionar outro objecto )`,
"lable.currencyManage.unEnabledadvcurrency":`Desactivar a Gestão Avançada de Moeda`,
"label.ccpeak.getthree.function":`Existem três funções, e`,
"label.weixin.new.weitoupiao":`Por favor, crie uma nova micro votação, os utilizadores podem participar na votação e aceder aos resultados da votação em micro eventos no WeChat.`,
"label.tag.manage.prompt":`Tag já exsits！`,
"label.goon":`Continuar`,
"label.addworkflowoperate":`Adicionar Acção de Fluxo de Trabalho`,
"label.weixin.click.search":`Clique para pesquisar o registo`,
"vue_label_report_deletecolumn":`Eliminar coluna`,
"label.ordercondition":`Ordenar por`,
"message.error.group.notallow":`O grupo não permite o arquivamento`,
"label.unread":`Emails não lidos`,
"vue_label_report_notice_namerequired":`O nome da coluna é obrigatório`,
"label.tabpage.entercontent":`Por favor introduza o conteúdo`,
"label.schedulejob.setup.schedule.startdate":`Data de início`,
"component_assistant_button_newtask":`Nova tarefa`,
"vue_label_report_notice_filter1":`Tem de preencher manualmente o(s) filtro(s) avançado(s) abaixo, como se mostra na figura ao activar o filtro avançado`,
"value":`Valores`,
"label.icon.70":`Serviço`,
"label.knowledgebase.delete.draft.t":`Apagar rascunho`,
"label.setup.mini.bind":`Programas Bind Mini`,
"component_timeline_button_more":`Mais passos`,
"label_emailtocloudcc_redmessage4":`Por favor introduza os detalhes da porta`,
"label.field.input.number":`Por favor introduza os números válidos`,
"front-invoice-online-payment-setup-title":`Iniciar Pagamento Online`,
"front-kefu-moudle-called-user":`Chamada Pessoa`,
"label.currency.disable":`Moedas inactivas`,
"label.user.alias":`Alias`,
"UG_quota_04":`Imprimir citação`,
"label.chatter.delete":`Eliminar`,
"label.addtocurrentcustomer":`Em anexo às contas existentes`,
"message.error.recordid.null":`recordid não pode estar vazio!`,
"label.merge.records":`Fusão de registos`,
"report_label_norole":`Não tem permissão para o fazer, por favor contacte o seu administrador.`,
"label.pqrs":`.`,
"label.email.attach.button":`Clique no botão "anexar`,
"label.tabpage.selrecordtypez":`Seleccione o tipo de registo`,
"label.ServiceCloud.purchase.date":`Data de compra`,
"label.customreporttype.delete.prompt":`Por favor, elimine o seguinte relatório antes de excutar a operação de eliminação`,
"label.brief.total.page":`Um total de {total} página(s)`,
"label.reportsSubscription.unsubscribe":`Anular a subscrição`,
"label.ccpeak.take.notice.exp.order":`Notas: deve acrescentar "__c" após o nome API dos campos nas condições de expiração e de encomenda.`,
"report_type_label_quote":`Citações`,
"label.file.norecord":`Nenhum item a expor`,
"vue_label_checkduplicate_all_processed":`Todos os dados foram processados`,
"label.next":`Próximo`,
"label.icon.10":`Pasta`,
"label.lanxin.title.setting":`Informação integrada`,
"label.h5.chatter.business":`Oportunidades associadas`,
"lable.are.you.sure.to.delete.this.view":`Quer apagar esta vista?`,
"vue_group_no_operation_permission":`Sem permissão para operar!`,
"label.knowledge.archive.article":`Artigo de Arquivo`,
"vue_label_lead_":`Não há regras de pontuação activas disponíveis, por favor contacte o administrador do sistema`,
"label.fiscal.error.between":`A Data de Início ou a Data de Fim do Ano Fiscal está entre os anos fiscais históricos, por favor verifique e reinicie`,
"label.stdashbord.xsld.business.qdzje":`Montante Total(Oportunidades Fechadas - Oportunidades Ganhas)`,
"label.calendar.day.view":`Vista do dia`,
"label.emailtocloudcc.tip":`Pronto`,
"label.schedulejob.setup.schedule.st1":`O 1o.`,
"label_tabpage_addtoworkbench":`Adicionar à bancada de trabalho da página inicial`,
"label.umeng.approval.waitapproval":`aguardar aprovação`,
"label.justcheckingwebsite":`Verificar apenas o Website`,
"homepage.components":`Página inicial Componentes`,
"label.audit.remark":`Notas de Aprovação`,
"label.searchs.labelname":`Pesquisa {fielabelName}`,
"label.remarkofreport":`Nota de relatório`,
"label.weixin.isno":`se`,
"label.currencyCode":`Código da moeda`,
"label.service.resources":`Recursos`,
"label.clone_form":`Formulário de Clone`,
"label.weixin.view.information":`Ver Detalhes`,
"UG_activity_05":`Telefone de gravação`,
"chatter.feed.menutype.user.recentuser":`Pessoas que viram recentemente`,
"label.marketsea.notfollowdays2":`Dias sem seguimento`,
"label.tabpage.namemandatory":`O nome da vista é obrigatório`,
"message.demo.nosupport":`Esta característica será implementada no próximo lançamento.`,
"label.mail.merge.template":`Fusão dos modelos de e-mail......`,
"label.sendemail.marketactivity.sign":`Notificação do sinal de campanha`,
"setup_layout_group_relatedlist":`Listas relacionadas`,
"label.pc.ui.2018.all.tabs":`Todo o menu`,
"label.field.lost.right.bracket":`Perde-se o parêntesis de fecho`,
"label.datamanage.contact.novalue":`Nota: O campo do nome de contacto é nulo,os registos de contacto não serão importados.`,
"label.version.unlimited.edition":`Edição Ilimitada`,
"vue_label_dashboard_selectsortfield":`Por favor seleccione o campo de ordenação`,
"label.partnerCloud.productSet.instructions":``,
"front-kefu-moudle-v1-canuse-obj":`Visível a`,
"thursday":`Quinta-feira`,
"label.nextapprover":`Próximo Autorizador`,
"setup_mainpage_label_manageuser":`Gerir Utilizadores`,
"label.saveandcontinue":`Guardar`,
"label.top.userCenter":`Centro Pessoal`,
"component.chatter.file.button.save":`Publicar`,
"label_emailsync_setting":`Configurações pessoais de e-mail`,
"label.usableshareuser":`Disponível Partilhado Para`,
"label.customfields.optionlist.fieldvaluelist.letterrank":`Mostrar valores em ordem alfabética, não na ordem introduzida`,
"label.list.button":`Atribuição de Perfil`,
"chatter.up.m":`Erro:Os ficheiros carregados são demasiado grandes. O tamanho máximo do ficheiro é de 20 MB.`,
"label.knowledgebase.filters":`{a} filtros`,
"label.sso.saml.sp.idtype.username":`Assertion contém o nome de utilizador do CloudCC do Utilizador`,
"vue_label_file_size_limit":`O tamanho do ficheiro não excede {tamanho}Mb`,
"label.appupload.install.error.choice4":`Saltar componentes conflituosos, não instalar componentes conflituosos`,
"label.currencyDecimalDigits":`Lugares decimais`,
"label.weixin.customer.details":`Detalhes da conta`,
"component.timeline.label.7daysahead":`7 dias antes`,
"label.sendsms.batch.step1":`Passo 1 Especifique os destinatários a incluir`,
"label.brief.opportunity1":`Oportunidades`,
"label.datamanage.click.importbutton":`Clique <b>Importar</b> e os dados serão importados para o sistema CloudCC.`,
"label_filter_benchmark_objects":`Filtrar objecto de referência`,
"label.area.record.notexist":`O registo não existe.`,
"label.event.overdue.unfinished":`Eventos em atraso`,
"label.file.publicview.errortype":`O tipo de ficheiro dos não suporta pré-visualização`,
"label.setup.mobile.bottombutton.profile.setting":`Personalizar o menu inferior do perfil`,
"label.campaignmember.main.addleaddesc":`Acrescentar todas as pistas existentes a esta campanha`,
"vue_label_approve_actual_operator":`Operador real`,
"label.version.essential":`Edição essencial`,
"lable.SalesCommitmentKanBan.commitments":`Gasoduto`,
"label.chatter.pastEvents":`Actividades passadas`,
"vue_label_calendar_choose_calendar_type":`Escolha o tipo de calendário`,
"label.service.dispatchingUnits.batch.send":`Atribuição de lotes`,
"chatter.poll.option8":`Escolha 8`,
"label_tabpage_summaryway":`Método sumário`,
"front-kefu-moudle-trindex-copy-num":`Por favor copie o nº da empresa na página inicial do sistema Tianrun`,
"lable.quote.syncing.syncfinish":`Sinc Concluído`,
"label.home.task.finish":`Tarefa concluída`,
"label.toleadfield":`Campos de chumbo do mapa`,
"label.everyone":`Todos`,
"label.multilang.databatchadd.success":`{0} foram acrescentados dados successfully：`,
"label.quote.createdate":`Criar data`,
"email.template.nopermission":`Apenas os administradores podem editar os modelos nesta pasta`,
"label.report.action.addtodashboard2":`Adicionar Painel de instrumentos`,
"label.campaign.name":`Nome da campanha`,
"label.check.input.condition":`Erro de sintaxe, por favor verifique os critérios de filtragem que introduziu`,
"front-epwechat-module-v1-upload-file":`Carregar documento de crédito:`,
"label.batchadd.newbatchpage.button.add":`Adicionar uma fila`,
"label.partnerCloud.footer":`Rodapé`,
"lable.Enter.template.name":`Por favor, introduza o nome do tamplate.`,
"label_tabpage_last":`Último passo`,
"label.setup.mobile.bottombutton.setting":`Definições de página de primeiro nível da aplicação móvel`,
"label_emailtocloudcc_filed_emailto":`Envie um e-mail para`,
"label.data.downpage.e_title.num3":`3. Os utilizadores podem criar modelos de exportação de acordo com as suas necessidades e seleccionar o item "Export By Template", o que pode tornar a operação de exportação mais conveniente.`,
"startwith":`Começa com`,
"vue_label_normal_cancel":`Cancelar`,
"label.reportTypcrtD":`Objecto associado (d) por favor clique para seleccionar o objecto relacionado`,
"label.globalselect.disabledvalue":`Valor inválido`,
"vue_label_commonobjects_view_notice_deletecertification":`Tem a certeza de que quer apagar o(s) registo(s) seleccionado(s)?`,
"front-epwechat-module-v1-bound-role":`Papéis encadernados`,
"label.partnerCloud.financeSetting.gaofilter":`Condições do Filtro Avançado (por exemplo, 1 e 2 ou 3 )`,
"label.quote.sprname":`Nome de facturação`,
"lable.asset.successfully":`Transferir produto para activo com sucesso.`,
"label.projectManagement.service.appointment.work.noedit":`Incapaz de editar a hora de trabalho de prestação de serviço`,
"lable.tianyancha.h5.inputandsearch":`Introduzir palavras-chave para pesquisar empresas relevantes`,
"label.customcomponent.check.tag.firstrow":`A primeira linha deve ser`,
"label.knowledgebase.published.translations":`As traduções publicadas serão também arquivadas e a tradução em estado de rascunho será eliminada.`,
"vue_label_wang_yi":`Tom`,
"label.step3.total3":`Etapa 3 de 3`,
"label.stdashbord.xsld.business.img6":`Quantidade total de fases oportunas com probabilidade 100%/(Quantidade total de fases oportunas com probabilidade 100% Quantidade total de fases oportunas com probabilidade 0%)`,
"component_button_cancel":`Cancelar`,
"label.delete.false.not.exists":`A eliminação falhou, porque os dados não existem.`,
"label.appupload.install.error.choice1":`Por favor não instalar`,
"label.Days.After.Horizontal.Date":`data de nível após`,
"setup_layout_button_additem":`Adicionar os artigos seleccionados`,
"UG.contact.05":`Criar um contacto`,
"label.form.title":`Título do formulário`,
"label.horizontalbar-group":`Agrupamento de Linhas Horizontais - Fileiras`,
"component_sendmail_label_title":`Enviar e-mail`,
"label.passwordPolicy.setup.neverexpires":`Nunca expira`,
"label.sso.saml.idp.config.desc1":`Activar CloudCC.com como fornecedor de identidade para que possa usar o single sign-on com outros sítios web`,
"label.chat.topic.desc.null":`Aprender alguma informação sobre este tópico? No menu pendente do canto superior direito, seleccione editar detalhes.`,
"label.movablecustomerfield":`Campos Personalizados de Criatividade`,
"label.trigger.folder":`Pastas de Gatilho não arquivadas`,
"label.selectuploadfile":`Por favor, seleccione um ficheiro para carregar.`,
"front-email-payment-card-tips":`Por favor introduza o número do cartão`,
"label.tabpage.addcondition":`Acrescentar a condição`,
"label.number.MinAndMaxCheck":`O mínimo de {0} é {1}, o máximo é {2}. Por favor, modificar a quantidade e guardar as alterações.`,
"vue_label_dashboard_dashboard":`Redenominado com sucesso o painel de instrumentos`,
"label.objectDeleteList":`Eliminar lista de objectos`,
"lable.service.gantt.and":`E`,
"label.emailtocloudcc.step2":`Passo 2`,
"label.chatter.postup":`Afixar`,
"label.personalsetting":`Configurações pessoais`,
"message.please.choose.permission":`Por favor seleccione o acesso`,
"label.mobile.move":`Aplicação móvel`,
"label.Choose":`Escolhas`,
"label_chatter_vote":`Sondagem`,
"label.weixin.user.select.one":`Seleccione um utilizador`,
"pagecreator.page.label.modifypage":`Editor de páginas`,
"label.select.partOrField":`Escolher secções ou campos a serem controlados`,
"vue_label_helpcenter_chat":`1. Mensagens instantâneas<br> Equipa pode substituir o WeChat empresarial, etc., permitindo-lhe enviar mensagens de texto, ficheiros, etc. aos seus colegas de empresa enquanto trabalha no sistema CRM. Quando cada departamento da organização necessita de estabelecer um grupo de discussão departamental, o líder do departamento pode iniciar um chat em grupo na Equipa e adicionar membros do departamento ao chat do grupo.<br> 2. Criar chats em grupo para clientes e registos de oportunidades de negócio<br> Abra a página de detalhes do registo de clientes ou oportunidades de negócio e clique no botão "Equipa" no canto superior direito para criar um chat em grupo sobre este registo na Equipa. Se o chat em grupo não for criado pelo proprietário do disco, o proprietário do disco também será automaticamente puxado para o chat em grupo. Outros podem entrar no chat em grupo clicando no botão "Equipa" no canto superior direito da página de detalhes do registo ou após terem sido adicionados pelo proprietário do grupo.<br> 3. Registos de registos no chat em grupo<br> Criar um chat em grupo para clientes e registos de oportunidades de negócio de acordo com o método em 4.2, e pode acompanhar a dinâmica dos registos no chat em grupo enviando cartões. Se o utilizador tiver acesso para ver os registos no cartão, quando o utilizador clica no cartão, pode saltar directamente para a página de informação detalhada do objecto correspondente.<br>Track record field changes in group chat<br> Quando o registo é configurado com a lista relacionada com o "Field Tracking" e os campos que precisam de ser rastreados são configurados, quando o campo rastreado muda, o assistente de estratégia em grupo no chat em grupo enviará um cartão com a informação de mudança de campo para o grupo .<br> Quando o dono do registo muda, o assistente de estratégia em grupo no chat em grupo enviará um cartão com a informação de alteração do dono para o grupo.<br>Rastrear actividades nos chats em grupo<br> Após a criação do chat em grupo de registo, se for criada uma nova tarefa ou evento sobre este registo, o assistente de estratégia em grupo no chat em grupo enviará um cartão com informação básica sobre a tarefa ou evento para o grupo.<br> Após a criação do chat em grupo, quando o registo da lista relacionada com o registo for adicionado, o assistente de equipa no chat em grupo enviará um cartão com as informações básicas do registo recentemente adicionado ao grupo. Por exemplo: quando um novo contacto é adicionado à lista de registos de clientes, um cartão de "Novo Contacto" será recebido no chat do grupo de clientes, e as informações básicas do novo registo podem ser vistas no cartão.`,
"label.tianyancha.business":`Informação sobre o registo de empresas`,
"chatter.group.groupMembersToFind":`Pesquisa de membros do grupo`,
"label.pc.ui.2018.pin.top":`Pino para cima`,
"label.forecast.forehistory.submitor":`Submetido por`,
"vue_label_email_send_emails_separately":`Enviar e-mails com sucesso`,
"vue_label_homepage_select_display_field":`Seleccionar Campo`,
"label.partnerCloud.partnerAccount.accountBalance":`Balanço`,
"label.sendemail.template":`Seleccionar modelo de e-mail`,
"label.service.violated":`Violado`,
"label.manageAll.title":`Centro de Aprovação`,
"label.forecast.settings.qy":`Activar a Partilha de Previsões`,
"label.detailofshare":`Detalhes da Regra de Partilha`,
"label.multilang.passwordpolicy.chechlength":`Erro: A senha não deve ser inferior a {0} caracteres:`,
"label.visualpage.filesave.error":`Ficheiro guardado falhou, por favor tente novamente.`,
"vue_label_campaign_please_select_member_status":`Por favor, seleccione o estatuto de membro`,
"homepage.components.sort":`Encomendar os componentes`,
"label.brief.thismonth":`Este Mês`,
"label_emailsync_connectaccount_description":`Adicione aqui a sua caixa de correio pessoal, e o CloudCC fará corresponder automaticamente os contactos e leads no sistema de acordo com os seus endereços de correio electrónico, sincronizando o conteúdo do correio electrónico com os registos para facilitar o seguimento e a comunicação.`,
"label.sms.csid":`Número de Assinatura`,
"label.ccdocument.remark":`Descrição do documento`,
"label.forecast.customforecast.disdw":`Unidade de exposição`,
"label_tabpage_field":`Campo`,
"label.logintime.all":`Todo o dia`,
"UG_Account_06":`Criar uma conta`,
"label.login":`Login`,
"label.dupicate.data.error":`Encontrar registos duplicados e fundir erros, verificar por favor.`,
"label.monitorsys.recent.logs":`Os últimos 200 registos são exibidos por defeito.`,
"message.chooseatleastonefield":`Escolha pelo menos um campo`,
"lable.PowerProcess.name1":`Nome do processo de concessão de direitos`,
"label.processdetail":`Detalhes da definição do processo`,
"label.upload.file.size.limit":`Os ficheiros carregados não devem exceder 2MB!`,
"label.forecast.userenablepage.desc":`Utilizadores activados para Previsões aparecem na lista de Utilizadores Activados. Para activar os utilizadores disponíveis, adicione-os à lista de Utilizadores Activados. Para desactivar utilizadores, removê-los.`,
"label.visualpage.type.detailembed":`Instrução de utilização da página personalizada (o estilo da página é "detalheEmbed")`,
"label.textmessage.vonage.configurations":`Configurações`,
"label.report.select.chart.and.item":`Seleccione o gráfico e o item em destaque`,
"label.data.downpage.i.title.num1":`O sistema 1、The suporta apenas o formato CSV comum.`,
"label.mobileapp.scansetting":`Definições de Leitura de Aplicações Móveis`,
"chatter.emailFollow":`Segue`,
"label.weixin.businformation":`Detalhes do veículo`,
"label.import.index.recentrecord":`Recente registo de importação`,
"label.case.update":`Actualização`,
"label.isEnableVisualpage.new.desc":`Seleccione uma página personalizada disponível nas páginas personalizadas Disponíveis e adicione-a às Páginas Personalizadas Seleccionadas, clique Guardar. Depois, os utilizadores com este perfil têm acesso às páginas personalizadas activas.`,
"label.emailobject.wizard.title":`Ligue o seu e-mail`,
"vue_label_ccchat_notice_deletepostsuccess":`Post suprimido com sucesso`,
"label.deleteQuoteLine":`Eliminar linha de citação`,
"label.integrations.export.failed.Mailchimp":`A exportação falhou, por favor verifique a sua ligação à rede e tente novamente mais tarde`,
"label.increase":` Mais`,
"label.setup.mobile.homepageshortcuts.setunable":`O módulo não aparece na página inicial`,
"label.ccchat.person.invite.toolong":`Não se pode introduzir texto que exceda 255 caracteres`,
"label.knowledge.setting.help":`Ajuda de auto-atendimento ao cliente`,
"label.is_pigeonhole":`Arquivo`,
"message.atleastonecommitter":`Pelo menos um apresentado por quem`,
"label.emailobject.wizard.desc4":`Inserir um tempo de proposta para facilitar a nomeação de várias pessoas`,
"APPIntegration_Dropbox_setting_02":`Deficientes`,
"template.report.open.opportunities":`Oportunidades não fechadas`,
"label.goonwork":`Continuar a trabalhar`,
"label.isiands.time":`Tempo de Isiands`,
"label.enable.rules.enableOnlyOneqrcodeOrbarcode":`Regras activadas (cada objecto suporta apenas um Código QR ou Código de Barras)`,
"label.summaryreport.2018.step2":`Passo 2 Resumir a informação por:`,
"pagecreator.systemstyle.message.delete.success":`Estilo eliminado com sucesso`,
"label.standarduser":`Utilizadores padrão`,
"label.reportsSubscription.succeeded":`Subscrever relatório com sucesso!`,
"lable.Select.a.template":`Seleccionar um modelo existente como base do novo modelo.`,
"label.file.library.addfile2libsuccess":`{0} ficheiro(s) carregado(s)!`,
"label.searchfield.instruction":`O campo de pesquisa é um campo que é usado para a pesquisa global ou pesquisa de um único objecto. Se não for seleccionado por defeito, a pesquisa por campo de resultados de pesquisa seleccionado é seleccionada campos de resultados de pesquisa.`,
"U":`URL`,
"label.Time.slot.overlap":`Uma ou várias faixas horárias têm intervalos de tempo sobrepostos. Por favor, actualizar para um intervalo de tempo que não se sobreponha.`,
"vue_label_chat_opportunity_details":`Detalhes da oportunidade`,
"label.knowledge.category.hint.seven":`Grupo de Categoria seleccionado`,
"label.chatter.list":`Lista`,
"front-email-payment-Invoice-preview":`Prévisualização de facturas`,
"label_emailsync_message1":`Se cancelar a ligação, não conseguirá sincronizar o conteúdo da caixa de correio com os contactos e os contactos, tem a certeza de que quer cancelar?`,
"label.summaryreport.step5":`Passo5 Especificar a ordem das colunas no relatório`,
"component_newrecords_label_name":`Nome`,
"label.appointment.wizard.subtitle4-4-5":`2 meses`,
"component_salesperformance_label_title":`Desempenho de vendas`,
"label.ccchat.person.invite.says":`Digamos:`,
"label.fax":`Fax`,
"label.knowledge.modify.article":`Modificar o artigo`,
"label.componenteditor.Limit.number.components":`Podem ser adicionados até 15 componentes numa única página.`,
"label.multilang.forecast.shrepage.desc":`Esta página listará os utilizadores, funções e regiões que têm acesso partilhado a {0}.`,
"label.chat.micropost.write.comment":`Escrever comentários`,
"Lead.Scoring.Setting.Rule.Setup.Active":`Activo`,
"label.ccpeakfolder.time":`Pastas de classe agendadas`,
"label.partnerCloud.financeSetting.filter":`Condições de filtragem:`,
"label.knowledge.delete.topicassignment":`Erro ao apagar a atribuição de assunto`,
"label.file.orderbyname":`Ordenar por título`,
"vue_label_chat_activelater":`Activo mais tarde`,
"chatter.reply":`comentário`,
"label.setup.profile.accordtext":`De acordo com o texto`,
"label.encd.plaintext":`Mostrar texto claro`,
"label.h5.approval.cannotreassignmark":`Os projectos de aprovação delegados não podem ser reatribuídos, por favor re-selecione os projectos de aprovação`,
"label.version.area.lookup":`{0} campos de área de texto ou relação de pesquisa (multi-selecção)`,
"approval.request.email.body":`Os seguintes itens solicitam approval：\n clique no link abaixo para approve：\n`,
"label.user.mass.emails.select":`Email em massa: Seleccione o modelo`,
"lable.quote.syncing.title":`Citações de Sincronização e Oportunidades`,
"vue_label_dashboard_dashboardaccess":`Acesso ao painel de instrumentos`,
"label_emailtocloudcc_filed_owner":`Proprietário`,
"label.brief.page":`Página`,
"label.isEnableVisualpage_new.desc":`Seleccione uma página personalizada disponível nas páginas personalizadas Disponíveis e adicione-a às Páginas Personalizadas Seleccionadas, clique Guardar. Depois, os utilizadores com este perfil têm acesso às páginas personalizadas activas.`,
"label.service.shift.view":`Vista dos turnos de trabalho`,
"label.emailsync.addnewaccount":`Adicionar nova conta`,
"label.forecast.settings.prompt":`A desactivação da partilha de previsões irá remover todo o acesso partilhado manualmente.`,
"front-electronic-signature-explain-second":`Ao vincular a assinatura electrónica, preparar a fotografia da Enterprise Business License e o código de crédito social unificado.`,
"label.emailtocloudcc.redmessage3":`Por favor introduza o endereço do servidor`,
"message.confirmgiveupedit":`Se sair desta página, perderá todas as alterações não guardadas. Quer continuar?`,
"label.gantt.plan.success":`Programado com sucesso`,
"label.monitorsys.type.error":`Por favor, seleccione o tipo de pesquisa.`,
"label.industrialandcommercialverification.button.setup":`Instalar`,
"today":`Hoje`,
"label.attendance.setting.position":`Marcos de referência`,
"chatter.mynews":`As minhas mensagens`,
"label.recycle.dis.tip1":`O sistema manterá os dados no caixote da reciclagem durante 15 dias, e os registos serão permanentemente apagados 15 dias após a introdução dos registos no caixote da reciclagem.`,
"label.icon.81":`Refrigeração`,
"label.customer.tab.page.prompt":`Por favor, configure pelo menos uma página!`,
"label.globalselect.use":`Usar o conjunto de valores da lista global de opções`,
"template.report.customer.sales.order":`Ordem de venda de contas com diferentes níveis`,
"vue_label_dashboard_lastruntime":`Último Tempo de Funcionamento`,
"label.edit.ccpeakfolder":`Classes：Folder Editar`,
"vue_label_lead_be_converted":`Foi convertido e não pode ser convertido`,
"label.tabpage.filenamez":`Nome do ficheiro`,
"label.please.click.add.products.":`Por favor clique em "Adicionar Produto" para adicionar produto ao livro de preços.`,
"label.followup_emails":`Uma vez que um visitante tenha enviado um formulário, o seguimento com um email é a你easy maneira de se ligar rapidamente a eles`,
"label.indochina.time":`Tempo Indochina`,
"message.error.task.email":`Anomalia de tarefa de correio`,
"label.dynamic.copy":`Copiar de forma sincronizada as regras de layout`,
"label.log.d":`Descarregar registo de auditoria dentro do intervalo de tempo de pesquisa (ficheiro Excel.csv)>>`,
"pagecreator_layout_label_layoutname":`Nome do layout`,
"template.chart.htsktj":`Estatísticas de Cobrança de Contratos`,
"label.appointment.wizard.subtitle4-2-5":`1 Dia`,
"label.view_form":`Ver Formulário`,
"label.tablet":`Tablet`,
"label.campaignmember.main.addcontact":`Adicionar Membros - Contactos Existentes`,
"message.get.userinfo.error":`Falha em obter informação do utilizador`,
"label.department.username":`Nome do Utilizador`,
"label.ems.verifysuccess":`Conta de e-mail verificada com sucesso!`,
"label.batchedit.copyValue":`Aplicar a esta coluna`,
"label.trigger.triggerVersion":`Versão`,
"label.mr.descreption.oneGroupReData5":`grupos de dados não processados.`,
"label.appointmentconfirmpage.wizard.subtitle5":`Descrição`,
"label.weixin.inbetween":`Multi-Select`,
"label.salescloud.contactrole.relatelist.customnize":`Não é possível personalizar esta lista`,
"label.data.exp.please.nameanddes":`Por favor, introduza o nome e a descrição do modelo.`,
"label_partner_workspace_login":`Página de login`,
"label.notification.approval7":`【被委派人名称】rejected o pedido de aprovação de 【提交人】 do 【对象】【对象名称】for.`,
"message.send.posts.image.error":`O upload de imagens falhou!`,
"message.fieldtrack.operateupdate":`Alterado`,
"label.sharerule.grantuselevelconstructureaccess":`Conceder acesso usando Hierarquias`,
"label.translation.setup":`Configuração Multilingue`,
"PageLayout.Search.MultiSearch.003":`Seleccionar pelo menos um campo.`,
"label.ccchat.person.emaildomain":`Domínio e-mail da empresa`,
"pagecreator.systemstyle.label.bordercolor":`Cor da fronteira`,
"label.submit":`Submeter`,
"UG.Lead.001":`Como introduzir as pistas?`,
"label.icon.172":`Mapa`,
"label_chatter_owner":`Proprietário`,
"vue_label_systemSettings_Currency":`Gestão Monetária`,
"page.layout.binfo":`Informação Essencial`,
"label.version.date":`{0} campos de data`,
"label.data.is.woking":`Em funcionamento`,
"label.customfields.searchrelation.dependobjectDefault.tip":`Pode seleccionar um registo no item relacionado como o valor por defeito para este campo`,
"label.partnerCloud.orderingPlatform.configuration":`Produtos Confugure`,
"lable.currencyManage.Enabledadvcurrency":`Activar a Gestão Avançada de Moeda`,
"label.event.moveup.3hour":`3 horas à frente`,
"label.reportexport.object":`Objectos de exportação`,
"front-dialog-module-v1-requestid":`Solicitar ID`,
"label.pw.symol":`Símbolos`,
"label_group_field":`Especificação do campo de agrupamento`,
"label.recallapprove":`Pedido de Aprovação de Rechamada`,
"vue_label_pool_deal_done":`Negócio fechado`,
"label.shangqing.description":`Esta é uma descrição da situação comercial`,
"label.view.allcansee":`Visível a <b>todos os utilizadores</b>`,
"chatter.poll.addOption":`Acrescentar mais`,
"label.icon.112":`Alimentação`,
"label.ignorecase":`Tratar "ABC" e "abc" como valores duplicados (insensível a maiúsculas e minúsculas)`,
"label.email.track.edit":`Editar Email`,
"label_tabpage_erraddressz":`Formato incorrecto do endereço de correio electrónico, por favor introduza correctamente o endereço de correio electrónico`,
"label_tabpage_viewz":`Imprimir vista actual`,
"component.timeline.label.future":`Próximo Passo`,
"label.b_c_without":`Os registos "B" podem ter ou não registos "C" relacionados.`,
"label.version.autonumberfield":`Campo de número automático`,
"label.appointmentdetail.wizard.title5":`URL do convite`,
"label.weixin.addoption":`Adicionar Opção`,
"label.b.c":`Relação de B a C`,
"chatter.group.complete":`Completo`,
"label.must.numeric.value":`O custo deve ser numérico.`,
"lable.edit.queue.memberdes":`Para adicionar membros a esta fila, seleccionar um tipo de membro, depois escolher a função ou utilizador de entre os "Membros Disponíveis" e movê-los para os "Membros Seleccionados". Se o modelo de partilha para todos os objectos da fila for Leitura/escrita/transferência pública, não é necessário atribuir utilizadores à fila, pois todos os utilizadores já têm acesso aos registos para esses objectos.`,
"label.staticresource.chose.limit":`Os ficheiros neste formato não são temporariamente suportados. Por favor, aguarde com expectativa a melhoria desta função.`,
"vue_label_commonobjects_view_kanban_unset":`Por favor, seleccione a base de agrupamento nas definições de visualização Kanban`,
"label.appexchange.download.merge.mes":`Os seguintes componentes conflituosos são instalados através de uma fusão:`,
"label.sharerule.baseofowner":`Com base no proprietário do disco`,
"label.email.template.manage.SMS":`Gerir o modelo de SMS`,
"label.imgfield.example.tip":`O ícone verde significa aprovado e o ícone vermelho significa rejeitado.`,
"template.report.potential.customer.industry":`Líderes da Indústria`,
"component_hots_label_title":`Negócios escaldantes`,
"label_file_use_document":`Utilização do espaço de armazenamento`,
"label.input.path":`Introduza o caminho do ficheiro`,
"label.partnerCloud.financialSetup":`Configuração Financeira de Parceiros`,
"label_tabpage_myz":`O meu`,
"vue_label_pool_discard1":`{1}{2}`,
"label_emailtocloudcc_tip2":`Depois de apagar, não poderá utilizar o Email to CloudCC, tem a certeza de que quer apagar?`,
"label.customfields.fielddependency.sure":`O campo de controlo não inclui o valor do campo dependente. Quer continuar?`,
"label.project.task.date":`A data da tarefa deve situar-se dentro do intervalo de datas do marco a que pertence.`,
"Report.CantDelete.Info":`O relatório {0} é a fonte de dados para o painel de bordo {1} e não pode ser apagado!`,
"label.assignment.setup.title":`Regras de Atribuição`,
"image.pt.most.maxsize":`O tamanho máximo do ficheiro é de 2 MB.`,
"label.appupload.introduce":`Um pacote contém componentes tais como aplicações, objectos, separadores, triggers, ou páginas. Estes pacotes podem ser afixados na CloudCC App Store para partilhar publicamente. A lista abaixo mostra todos os pacotes criados pela sua organização. Para criar um novo pacote, clique em Novo.`,
"label.import.page2.confirm":`Confirme`,
"label.console.step2.introduce":`Preencha os campos abaixo para definir a consola.`,
"label.extendsfather":`Controlado pelos Pais`,
"front-homepageobject-module-v1-year":`Este Ano`,
"front-grasp-sales-opportunities":`CRM ajudao a dominar com precisão as oportunidades de vendas, adquirir mais leads, fornecer cotações rápidas e fechar mais negócios, ao mesmo tempo que alcança o marketing omnichannel e melhora continuamente o ROI empresarial.`,
"label.tab.oldpage":`Página da versão antiga`,
"label.service.miniProgram.intro":`Introdução`,
"label.data.import.setup.operate.insert":`Não actualizar os registos existentes, apenas inserir novos registos.`,
"label.ccpeak.direction.for.use":`Descrição da Utilização da Plataforma CloudCC [Versão 2.0]`,
"label.sendemail.chat.addComentsmyFeedsubject":`CloudCC CCChat resposta micropost`,
"label.campaignmember.main.importmember.contacts":`Importar Membros - Contactos`,
"setup.mainpage.label.welcome20":`Correio, modelo SMS`,
"label.newbatcheditor.remark":`Para registos diferentes, existem diferentes tipos de registos. Por defeito, a disposição das linhas se o tipo de registo do primeiro registo for utilizado como a disposição do pafe para edição em massa.`,
"label.step4.total7":`Passo 4 de 7`,
"label.campagin.roi.tzhbl":`Retorno do investimento`,
"label.emailmerge.mergepage.step3":`Registar uma actividade`,
"label.marketsea.isrecyclecreatebyself":`Quer reciclar uma conta auto-construída`,
"message.mobilechooseatmost.five":`Um máximo de 5 campos pode ser seleccionado no menu em dispositivos móveis.`,
"label.icon.171":`Casa de hóspedes`,
"label.saveandnext":`Salvar & Próximo`,
"label.import.page1.selectcodingtype":`Escolha o tipo de codificação`,
"label.searchlayout.displaybutton":`Botões Mostrados`,
"label.approvalstep5":`Passo 5 seleccionar as propriedades de edição dos campos a exibir no layout da página de aprovação`,
"label.passwordPolicy.setup.enforcePswHis":`Aplicar histórico de senhas`,
"vue_label_commonobjects_detail_contact_hierarchy":`Hierarquia de contactos`,
"front-kefu-moudle-v1-trythjzx-intelligent":`TRRT(tinet) Centro de chamadas de serviço inteligente`,
"label.select.statistical.indicators":`Por favor escolha o índice estatístico`,
"label.callcenter.Tianrun.RONGTONG":`TRRT(tinet)`,
"label.file.library":`Bibliotecas`,
"lable.completion.rate.color.setting":`Definição da cor da taxa de conclusão`,
"label.name.firstname":`Primeiro nome`,
"setup_layout_label_readonly":`Read-Only`,
"label.chatter.recordcall":`registou uma chamada`,
"label.service.appointmentList.service.empty":`A marcação de serviço está vazia.`,
"component_milestones_label_choicestate":`Confirmar este estado`,
"label.approved.receiveApprovalEmail.option2":`Só se eu for um aprovador`,
"label.marketseamemset.account.title":`Configurações dos membros do grupo de liderança`,
"label.changemydisplay.list.custom":`Personalizar os meus separadores`,
"label.emailtemplate.selecttype":`Escolha o tipo de modelo de e-mail que gostaria de criar.`,
"component_timeline_label_title":`Linha do tempo`,
"chatter.group.addRemoveMembers":`Adicionar/remover membros`,
"label.console.step6.width":`Largura`,
"pagecreator.systemstyle.message.delete.fail":`A eliminação do estilo falhou`,
"label.partnerCloud.orderingPlatform.productPrice":`{productQuantity}products，{totalCount} pieces, original price：{currency} {originalPrice}，discount：{currency} {Redução}`,
"label.h5.share":`Partilhar`,
"label.schedulejob.setup.list.tip":`Configuração de trabalhos de cheduled para serem realizados automaticamente em intervalos semanais ou mensais.`,
"message.intheapproving":`O registo pede aprovação e não pode voltar a ser apresentado.`,
"vue_label_commonobjects_detail_real_time":`Após a adesão, a Equipa será exibida na sua lista de equipas, e a dinâmica da equipa ser-lhe-á afixada em tempo real.`,
"label.autoRegister.changepwd.setpwd.too.weak":`Demasiado curto`,
"label.salescloud.forbiddenteamsales":`Proibir a equipa de vendas`,
"component.chatter.link.label.title":`Ligação`,
"label.layout.editsearchdistribute.page":`Seleccionar as páginas personalizadas deve incluir na página inicial do separador`,
"label.dashboard.show.value.percent":`Mostrar valores ou mostrar %, por favor escolha pelo menos um`,
"label.everymonth":`Por Mês`,
"label.campaign.channel.download.size1":`Tamanho grande: 1000*1000 pixels`,
"permissionService.error2":`Falha em adicionar permissões de pedido de licença.`,
"button.partner.workspace.manage.memo":`Gerir a nuvem do seu parceiro e configurar as propriedades da nuvem do parceiro.`,
"label.forecast.forehistory.commit.remark":`Notas de submissão`,
"six":`Seis`,
"label.datamanage.donot.export.object":`Objectos que não são autorizados a exportar dados.`,
"label.schedulejob.setup.schedule.execute":`Executar`,
"lable.account.CurrentandPreviousCY":`CY actual e CY anterior`,
"label.temp.SMS":`Modelos de SMS`,
"label_partner_all_state":`Estado`,
"label.editdocument":`Editar Propriedades`,
"front-epwechat-module-v1-ios-single":`iOS Single Sign On`,
"lable.redo":`Redo`,
"vue_label_SMS_alltemplates":`Todos os modelos`,
"label.allfolderreport":`Todas as Pastas de Relatórios`,
"label.layout.alltab":`Todos os separadores`,
"lable.account.Yesterday":`Ontem`,
"label.formula.to.evaluate":`Avaliação da Fórmula`,
"component_setup_label_setupsaveok":`Definições de componentes guardadas com sucesso`,
"pagecreator_page_message_canntdelete":`A página actual não é autorizada a apagar`,
"label.tab.message.failtotp":`Falhou no topo da tabela`,
"label.h5.chatter.location":`Inserir a localização`,
"vue_label_commonobjects_view_chart_gotodashboard":`Ir para Painel de controlo`,
"label.data.exp.conf":`Tem a certeza de que quer exportar dados?`,
"label.currency.e":`Tipo de moeda Editar`,
"message.matrixReportSetupStage.column":`Seleccione 【Specify Coluna Headers】 base subtotal, e deve seleccionar uma base subtotal pelo menos em duas bases subtotal.`,
"font-evaluate-module-v1-have-comment":`Deixou uma avaliação`,
"chatter.feed.dao":`Para`,
"label.import.index.notice":`Nota:`,
"label.weixin.information":`Detalhes`,
"label.multilingual.tip5":`O estado multilingue não está correcto. Por favor, actualize e tente novamente!`,
"label.appointment.wizard.subtitle3-7":`Domingo`,
"label.emailobject.groupemail.fail.content":`Caro(a), o seguinte é o endereço de e-mail que não foi enviado.1`,
"vue_label_notice_uploadavatar_fail":`Falha no carregamento de avatar`,
"chatter.group.myGroup":`Os meus grupos`,
"label.ccpeak.object.fieldapi.name":`é o nome do campo API do objecto`,
"lable.activeCurrency":`Moedas Activas`,
"label.file.save.to.send":`Salvar&Enviar`,
"label.emailmerge.list.editfolder":`Edição de pastas`,
"label.Path.Setting":`Configuração do caminho`,
"label.validate.function.funcFormat.DATE":`DATA(ano,mês,dia)`,
"message.objapiexists":`Este objecto API já existe.`,
"label.sendmail.batch.confirm":`Email em massa: Confirmar`,
"message.approval.cannotsubmit.detail":`Este registo não preenche as condições ou submissão inicial para qualquer processo de aprovação válido. Por favor, contacte o seu administrador para obter assistência.`,
"setup.layout.button.deleteitem":`Retirar os artigos seleccionados`,
"label.end.loginipIP":`Endereço IP final`,
"component_event_label_subject":`Tema`,
"message.500":`Ocorreu erro interno do servidor`,
"label.wei.polltype":`Tipos`,
"vue_label_norm_duplicate":`Duplicado`,
"label.addcycletrigger":`Adicionar gatilho periódico`,
"DetailedInfo.Activity.EmailMessage.01":`{0} enviar um e-mail para {1}.`,
"No.Activity":`Sem actividade`,
"label.chat.topic.add.topic":`Clique para adicionar um tópico`,
"label.schedulejob.setup.schedule.morning":`AM`,
"chatter.save.al":`As suas alterações foram salvas.`,
"label.setsharerule.step3":`Passo 3 Seleccionar os utilizadores com quem partilhar`,
"label.tabpage.Sdfez":`Dias atrás`,
"label_submit_forecast":`Submeter previsão`,
"label.version.sum.formulafield":`campos de fórmula`,
"lable.weixin.you.invitation":`O seu convidado`,
"label.stacked.horizontalbar":`Linhas Horizontais Empilhadas-Horizontais`,
"label.file.anyone.can.link":`Qualquer pessoa com o link pode ver e descarregar o ficheiro.`,
"label.campaignmember.main.importmember.lead.desc":`Importar pistas dos ficheiros.`,
"UG_activity_01":`Como é que rastreia os seus registos para interagir com as suas contas/equipas?`,
"label.reason":`Motivo`,
"label.version.free.createmax":`Permite a criação de 2000 registos, o limite superior foi atingido.`,
"label.brief.thisweek":`Esta Semana`,
"label.deleteobjinapprove":`Por favor, introduza o comentário antes de poder eliminar este objecto do processo de aprovação.`,
"calendar.tips.event":`dia(s) sem eventos`,
"label.customerinfo.mailinfo":`Endereço de e-mail para toda a organização`,
"lable.electronic.signature":`Esignature`,
"label_emailsync_addnewaccount":`Adicionar nova conta`,
"label.layout.exampleoftesgobj":`Exemplo de objecto de teste`,
"label.happen_submit":`O que deve acontecer depois de um visitante submeter este formulário`,
"label.forecast.customforecast.button.submit":`Submeter`,
"label_right_click_notice":``,
"font-trade-module-v1-invoice-no-price":`Para ser reparado`,
"lable.opppdt.selPdt.morecondtions":`Mais filtros`,
"label_invalid_token":`Ficha inválida`,
"label_chatter_postup":`Afixar`,
"label.escalation.setup.newaction.step1":`Etapa 1 Especificar os critérios de tempo para esta regra`,
"label.sendmail.step3.dealoption2":`Armazenar uma actividade para cada mensagem`,
"front-kefu-moudle-v1-yesornoBatch-delete-templete":`Tem a certeza de que quer apagar os modelos em lote?`,
"vue_label_appstore_enter_website":`Entrar no site oficial`,
"label.when":`Tempo de publicação`,
"label.linellae":`Linhas`,
"label_chatter_detailinfo":`Informação detalhada`,
"lable.SalesCommitmentKanBan.receivingTaskRate":`Taxa de conclusão da tarefa de recibos`,
"vue_label_homepage_dashboard_deleted":`O tablier foi removido`,
"pagecreator.layout.button.vertical":`Desmontagem longitudinal`,
"label.redistribution1":`Seleccionar até 5 itens`,
"pagecreator_page_label_modifypage":`Editor de páginas`,
"label.Service.Cloud.Setting":`Configuração da nuvem de serviços`,
"setup_layout_label_pagename":`Nome do layout da página`,
"label.ems.send":`Enviar`,
"vue_label_commonobjects_view_kanban_notice1":`A vista Kanban mostra apenas os primeiros 200 registos`,
"lable.outlook.detail.maping":`Mapeamentos de Campo`,
"vue_label_pool_abandonorrestore":`{1}{2}`,
"label.mobile.side.tab":`Ajuste do deslizador lateral móvel`,
"label.trigger.operation.email.template.param":`Parâmetros de passagem: língua, ID do modelo de e-mail, e ID do registo`,
"front-objectTemplate-V1-Select-a-template":`Seleccionar um modelo existente como base do novo modelo.`,
"label.email.template.delete.template":`Tem a certeza de que vai apagar este modelo?`,
"label.reportsSubscription.cancel":`Cancelar`,
"lable.quote.syncingfrom.firstsync.description":`Os produtos de oportunidade irão substituir os itens da linha de cotação`,
"label.weixin.no.pending.xsld.qin":`Lamentamos, não há dados de funil de vendas para mostrar.`,
"template.dashboard.sales.indicators":`Indicadores de vendas`,
"label.field.new":`Proporcionar aos utilizadores operações de avaliação e pontuação.`,
"label.generatepage.title.desc1":`Gerar versão móvel ou PC do código HTML com base nos campos seleccionados, os utilizadores podem modificar o código conforme necessário.`,
"template.report.source.potential.customers":`Fonte de Leads`,
"label.mr.title.queryData":`Encontrar duplicados`,
"button_partner_workspace_enable":`Activar a nuvem de parceiros`,
"V":`Número de automóvel`,
"label.icon.19":`Pasta`,
"vue_label_report_summaryformula":`Fórmula sumária`,
"label.appointment.wizard.subtitle2":`Gama de datas disponíveis`,
"label.stdashbord.xsld.business.bjdzhl":`Taxa de Conversão de Etapas`,
"label.forecast.forehistory.deopportunity":`Oportunidades`,
"chatter.email.referredToMeLeaveMessage":`Menciona-me num comentário`,
"label.dategrouprelyon":`Critérios de agrupamento de datas`,
"label.sendmail.batch.finish":`Email em massa: Concluído`,
"label.weixin.allexpired":`Tudo Atrasado`,
"label.dashboardSetup.showdw.d4":`10 Mil`,
"message.duplication.label.masterRecord":`Registo mestre`,
"vue_label_calendar_availability":`Disponibilidade`,
"vue_label_chat_approval_message":`Mensagem de aprovação`,
"vue_label_zhang_er":`Jenny`,
"label.select.options":`Por favor seleccione as opções`,
"label.israel.daylight.time":`Hora Padrão de Israel`,
"front-sales-search-QB":`0 dados no total, se deve criar uma nova conta no QuickBooks`,
"vue_label_account_change_customer":`Mudança de proprietário do cliente`,
"label.integrations.mailchimp2":`Ver mais sobre CloudCC e Mailchimp`,
"lable.product.pricebooks.onisu":`Livros de Preços Inactivos`,
"front-electronic-signature-backfill-field":`Campo de aterro`,
"label.document.myself.folder":`As minhas Pastas Pessoais`,
"label.event.moveup.10hour":`10 horas à frente`,
"report.label.report":`Relatórios`,
"label.validate.function.funcFormat.CONTAINS":`CONTAINS(text, compare_text)`,
"label.usermanage.query.false":`A consulta falhou, o utilizador não existe.`,
"front-epwechat-module-v1-input-EncodingAESKey":`Por favor introduza EncodingAESKey`,
"label.event.multi.view":`Vista Multi-Utilizador`,
"label.h5.similar.opportunity.setup":`Definições de Oportunidades Semelhantes`,
"label.setting.intergrationlist.button.install":`Instalar`,
"label.event.monthview":`Vista do Mês`,
"label.version.weixin":`Versão WeChat`,
"label_emailtocloudcc_redmessage6":`A autenticação IMAP/SMTP falhou, por favor verifique se o endereço de correio electrónico e a palavra-passe estão correctos.`,
"UG.homepage.003":`Vista de 360 graus`,
"vue_label_calendar_shared_calendar":`Calendário de Partilha`,
"label.select.hope.merge.num1.record":`Por favor seleccione os registos que pretende fundir num só registo. Escolha um máximo de 3 registos de cada vez.`,
"label.createnewprocess":`Criar Novo Processo de Aprovação`,
"font-trade-module-v1-invoice-status":`Estado de pagamento`,
"label.customerinfo.introduce":`Informação sobre a empresa`,
"label.objectname":`Nome do objecto`,
"label.chosen.field":`Campos Seleccionados`,
"label_target_name":`Nome do modelo de golo:`,
"label.appointment.wizard.subtitle4-4-4":`1 mês`,
"label.emailobject.groupemail.msg1":`Sem endereço de correio electrónico`,
"label_component_hotdeal_nopermission":`Para ver os seus dados relacionados com oportunidades de negócio, contacte o seu administrador do CloudCC.`,
"label.appointmentdetail.wizard.title13":`Descrição`,
"front-web-module-v1-detail-comment-title":`Por favor comente sobre este serviço`,
"label.visualpage.component.n1":`1.Método de chamada.  `,
"lable.outlook.mcto.erecord":`os registos mais antigos criados`,
"label.weixin.del.log":`Registo de eliminação`,
"setup_mainpage_label_welcome23":`Definições de segurança`,
"label.selectreportline":`Por favor, seleccione as colunas do relatório`,
"label.chatter.following":`A seguir`,
"seven":`Sete`,
"message.error":`Erro:`,
"label.mobile.phone.reporter":`Submetido por`,
"label.valadate.telphone.false":`Número de telefone introduzir erro, por favor reintroduzir`,
"label.linkedin.setting":`Integrar a MiniApp LinkedIn H5`,
"label.mobile.side.tab.success":`Guardar com sucesso a configuração do controlo deslizante do lado móvel.`,
"label.notification.approval3":`Pedido de aprovação para o 【对象】is reatribuído para 【重新审批人】`,
"label.channel.invites.employees":`Convite ao pessoal deste canal`,
"label.assignment.setup.detail.assigner":`Atribuir a`,
"label.campaignmember.main.updatecontactdesc":`Actualizar o estado de todos os contactos de uma só vez`,
"label.permission.detail.app.fenpei":`Atribuir candidaturas`,
"label.copydown":`Copiar para baixo`,
"label_emailsync_status_action":`Acção`,
"lable.Please.switch":`Por favor mude para o menu horizontal ou vertical para utilizar esta função.`,
"label_adjust_remark":`Observações sobre o ajustamento`,
"label.weixin.newspaper.coverage.list":`Fichas de risco`,
"label.datamanage.contact.field":`Campos de Contacto`,
"label.partner.workspace.login.headerfooter":`Cabeçalho e Rodapé`,
"lable.account.quarter.ovdate":`Dia de Fim de Trimestre Fiscal`,
"pagecreator.systemstyle.label.textcolor":`Cor do texto`,
"label.industrialandcommercialverification.fieldmappingsettings":`Configurações de Mapeamento de Campo`,
"component_chatter_button_message":`Comentário`,
"label.partnerCloud.enterAddress":`Por favor introduza o endereço`,
"label.email.template.recently.used":`Utilizado recentemente`,
"component.event.label.calendar":`Ver Calendário`,
"label.setup.mobile.offlinecache.setting":`Definições de cache offline do lado móvel`,
"label.custom.PreviousCQ":`CQ anterior`,
"lable.total.of.payments":`0 pagamento no total`,
"label.ccpeak.use.class.time.trigger":`Se o gatilho chamar a classe, pode utilizar directamente os métodos no CCService.`,
"label_tabpage_addresswrongz":`O formato do endereço da caixa de correio está errado, por favor introduza correctamente o endereço da caixa de correio!`,
"vue_label_homepage_select_components":`Seleccione Componente`,
"front-kefu-moudle-v1-secretID-reinput":`Por favor introduza secretID`,
"label.ccdocument.select.template.red":`Por favor, seleccione um conjunto de modelos.`,
"vue_label_email_public_template":`Modelo público`,
"label.eowechat.openid":`WeCom ID`,
"label.user.ip.notlogin.range":`Este IP não se encontra na gama de IPs.`,
"chatter.email.reply.collection":`Comentários sobre um item que eu bookmarquei`,
"label.integrations":`Integrações`,
"label.permission.modifyAppPermission.selectedapp":`Aplicações seleccionadas`,
"label.privacystatement":`Declaração de Privacidade`,
"label.specificvalue":`Um valor específico`,
"label.appointmentconfirmpage.wizard.subtitle2":`Data e hora`,
"label.message.ispartner.delete":`Como o contacto já está associado ao utilizador parceiro, o cliente não pode ser eliminado`,
"report_button_go":`Ir para`,
"label.h5.similar.opportunity":`Oportunidades semelhantes`,
"UG_Lead_005":`Caixa de correio`,
"label.num.length.not.overstep":`o comprimento do valor não pode exceder 18 bits`,
"label.profile.mobile.setup.CEOandDirector":`Director executivo e de vendas`,
"label.addfield":`Adicionar campo`,
"template.dashboard.institutional.overview":`Visão Geral da Agência`,
"label_tabpage_datefield":`Quando o campo de data é igual, pode usar o formato "ontem", "hoje", "amanhã", "mês passado", "este mês", "mês seguinte", "semana passada", "esta semana", "semana seguinte" ou "AAAA-MM-DD、MM/DDD/AAAAA".`,
"label.category.7":`Turismo`,
"UG_contact_02":`Envolver contactos através de múltiplos canais, chamada, e-mail, social`,
"chatter.feed.menutype.feed.mecom":`Novo posto para mim`,
"vue_label_systemSettings_calltemplate":`Modelo de carta`,
"approval_process_errore":`Ocorreu um erro durante o salvamento, por favor contacte o administrador.`,
"label.tabpage.choosefilez":`Seleccionar ficheiro`,
"label.changemydisplay.chagetab.cusapp":`Aplicações personalizadas`,
"clearadvancedoption":`Lógica de filtro clara`,
"front-epwechat-module-v1-binding-user":`Utilizadores vinculados`,
"label.customfields.fielddependency.null":`Não há dependências definidas.`,
"label.enterprise":`Edição Empresarial`,
"font-evaluate-module-v1-five-points":`Marca Neutra: 5 pontos`,
"lable.Synchronize.from.QuickBook":`Sincronia de QuickBook`,
"front-gantt-module-v1-task-number":`Montante da tarefa`,
"label.currency.edit.newexchagecurrency":`Taxas de Câmbio Datadas`,
"label.partnerCloud.partnerSite":`Sítio parceiro`,
"label_tabpage_unequalz":`Desigual a`,
"label.version.solutions":`Soluções`,
"label.setting.intergrationlist.button.installed":`Instalado`,
"label.h5.chatter.share":`Partilhar ficheiros`,
"front-epwechat-module-v1-unbound-item4":` vinculação de contas externas`,
"label.textmessage.vonage.accessibility.setting":`Configuração da acessibilidade`,
"font-evaluate-module-v1-evaluation-set":`Definições de avaliação`,
"message.servicecrew.time.violation2":`Fora do tempo de trabalho`,
"label.processinfo":`Informação sobre o Processo de Aprovação`,
"label.knowledgebase.last.modified":`Última modificação`,
"label.to.phone":`Para`,
"label.baseoffirsttimereply":`Aprovar ou Rejeitar com base em < forte> Primeiro </forte>resposta`,
"label.projectManagement.startingEndingTime":`Hora`,
"label.licence.enable":`Activo`,
"label.partnerCloud.basicSetting.cshua":`Inicializar a Nuvem de Parceiros`,
"APPIntegration.Dropbox.setting.03":`Activar Dropbox para lhe permitir seleccionar ficheiros da Dropbox e adicioná-los como anexos.`,
"label.account.contact":`Contactar a IA`,
"label.many.dayline.tab":`Marca`,
"label.weixin.input.username":`Por favor introduza o seu nome`,
"label.logintime.pagecue.invalido":`O tempo final deve ser todo o dia.`,
"label.icon.30":`Livro`,
"label_tabpage_advancedscreening":`Filtro avançado`,
"lable.currencyManage.unEnabledadvcurrency.agree":`Sim, eu quero desactivar a Gestão Avançada da Moeda.`,
"label.tab.web.new":`Novo separador Web`,
"label.bmap.tiananmen":`Tiananmen`,
"label.disabled":`Deficientes`,
"error.currencyAdv.deleteprecodedate":`Não é possível eliminar a taxa de câmbio da data de uma moeda.`,
"message.error.view.checkbox.validerr":`Erro: por favor use verdadeiro ou falso`,
"UG_ST_006":`Entrar directamente`,
"label.dongshifang.title":`DongShiFang SMS`,
"label.data.dataexpalltype.all.desc3":`3、Exported Dados bem sucedidos irão gerar um ficheiro comprimido que os utilizadores podem descarregar da página da lista de sucesso da exportação de acordo com a informação contida no correio.`,
"vue_label_pool_returnreason":`Motivo do regresso`,
"label.list.userinterface.des":`Modificar a interface do utilizador com as seguintes configurações:`,
"label.notification.approval2":`Pedido de aprovação para the【对象】is rejeitado por 【审批人】`,
"label.service.dispatchingUnits.the.level":`Nível`,
"front-email-payment-Invoice-preview-tips":`Todos os modelos de facturas estão actualmente desactivados. Por favor contacte o administrador para activar o modelo antes de gerar facturas.`,
"label.dashboard.isAvailableFieldOfComponentGroupInTheReport":`Erro:um ou mais dos campos seleccionados na componente já não está disponível no relatório. <br>utilizar o editor de componentes do painel de instrumentos para seleccionar um dos campos disponíveis.`,
"label.import.step2.chooseidorother":`2、You pode escolher usar o ID ou nome para corresponder ao registo e preencher o campo de pesquisa. Se precisar de adquirir o ID do registo correspondente e outras informações, pode criar um relatório e definir o nome do registo e o ID do registo como colunas de grupo, e depois exportar o relatório.`,
"label.customobjects.introduce":`Os objectos personalizados são tabelas de base de dados que lhe permitem armazenar dados específicos da sua organização no CloudCC. Pode utilizar objectos personalizados para ampliar a funcionalidade CloudCC ou para construir novas funcionalidades de aplicação.`,
"label.visualpage.oldsystem":`Versão antiga`,
"label.icon.94":`Livro`,
"label.setup.log.desctiption":`Pode descarregar o traço de comportamento da sua organização (Excel.xls)`,
"label.dynamicpage.layout":`Regras de disposição`,
"lable.list.queue.objct":`Objectos Suportados`,
"label.customfields.placeholder.tip":`A amostra de texto será exibida na caixa de entrada e desaparecerá depois de ganhar foco`,
"label.ems.activationtime":`Tempo de activação`,
"label.detailinfo":`Detalhes`,
"label.icon.17":`Relatório`,
"label_emailtocloudcc_button_complete":`Terminar`,
"label.visualpage.component.n2":`2. Note-se que as "etiquetas de componentes" não podem ser aninhadas dentro de "<cc>tags".`,
"label.object.name.one":`Nome do objecto 1`,
"label.summaryreport.step2":`Passo 2 Escolha os dados resumidos`,
"thisisanew":`New!`,
"label.query.detail.editpartneruser":`Editar utilizador parceiro`,
"label.tabpage.newview":`Criar uma nova visão`,
"label.partnerCloud.productSet.addNew":`Nova opção`,
"label.appupload.upload.new.remark":`Este é um novo componente`,
"label.case.ptext":`Ligámos a sua empresa à versão do portal do sítio web. Copie o endereço da versão web do portal de serviço ao cliente dedicado à sua empresa e adicione o portal no seu sítio web oficial.`,
"lable.PowerProcess.name":`Processo de concessão de direitos`,
"label_tabpage_choosefilez":`Seleccionar ficheiro`,
"homepage.components.place":`Posição Componente:`,
"lable.Synchronization.failure":`Failed to Sync`,
"label.dashboard.snapshot.get.data":`Obtenha os seus dados`,
"label.input.invalid.format":`Por favor, introduza o formato válido`,
"label.quickbooks.view.openinvoices":`Facturas Abertas`,
"label.weixin.seating":`Lugares`,
"label.searchlayout.remark":`Os layouts de pesquisa permitem-lhe seleccionar os campos padrão e personalizados que são exibidos nas seguintes características de pesquisa:`,
"label.escalation.setup.entrydetail.escalation.assiner":`Atribuir a`,
"vue_label_calendar_availability_view":`Calendário-Avisibilidade`,
"label.country":`País`,
"label.campagin.roi.zl":`Visão geral`,
"lable.currencyManage.advcurrencyEnabled":`A Gestão Avançada de Moeda está activada`,
"label.projectManagement.project.task":`Tarefa do projecto`,
"label.appointmentpage.wizard.subtitle3-2":`Email`,
"label.input.invalid.date":`Por favor introduza as datas válidas`,
"vue_label_chatter_my_followers":`Os meus seguidores`,
"label.setupdevelop":`Desenvolver`,
"label.sendemail.send.checksend":`Verificar se o e-mail foi enviado com sucesso`,
"label.eventfield":`Campos de Eventos`,
"label.ccpeak.ccobject.put":`utilização colocada para atribuir ao CCobject, por exemplo:`,
"label.campaignmember.main.addMemberDesc":`Pode pesquisar os contactos e leads existentes, adicioná-los a esta campanha, ou gerir os membros da campanha existente.`,
"label.knowledge.setting.hint.eleven":`Introduzir categoria de dados`,
"label.knowledge.category.button.four":`Adicionar categoria de irmãos`,
"label.icon.27":`Aprenda`,
"vue_label_chatter_certification":`Tem a certeza que quer {isStatus} "{títuloNome}"?`,
"label.data.downpage.i.title.btn":`Ir para a página de importação e começar a importar`,
"label.campaign.channel.step6.pc":`Gerar Página PC`,
"label.mr.caption.rule":`Regras:deve seleccionar uma ou mais regras para encontrar duplicados`,
"label.service.gantt.resourcestype":`Tipo de recurso`,
"label.searchfitconditions":`Encontrar que correspondam aos seguintes critérios:`,
"label.partner.template.name":`Nome do modelo`,
"setup.mainpage.label.welcome15":`As regras de fluxo de trabalho da plataforma CloudCC Cloud automatizam o processo de apoio às suas vendas, marketing, e muito mais. Dependendo de um conjunto de regras predefinidas, os registos podem ser automaticamente atribuídos aos utilizadores ou convertidos de um utilizador para outro. A principal vantagem da gestão do fluxo de trabalho é melhorar a eficiência do trabalho, eliminando muitas operações desnecessárias ao actualizar registos, e melhorar os níveis de processamento do negócio e optimizar processos de controlo através da padronização de métodos de trabalho e da redução de custos operacionais. Suporta aprovação infinita ilimitada para qualquer objecto, e pode activar email de lembrete, SMS de lembrete, tarefa, actualização de campo e outras funções.`,
"vue_label_commonobjects_view_chart":`Gráfico`,
"label.salescloud.teamrole.choose":`Por favor, seleccione o papel da equipa`,
"lable.outlook.mcto.emailrel":`Associações de correio electrónico`,
"front-invoice-online-payment-setup-describe":`Acesso rápido, acesso com um clique. Serviço de pagamento em linha simples, seguro e rápido.`,
"label.korean.standard.time":`Hora Padrão da Coreia`,
"label.lord.howe.standard.time":`Lord Howe Horário de Verão`,
"setup_layout_group_button":`Botões`,
"label.editdefaultshare":`Padrões de partilha a nível de organização Editar`,
"label_fiscal_year":`Ano fiscal`,
"label.appointmentdetail.wizard.title2":`Proprietário`,
"label.email":`Email`,
"label.city":`Cidade`,
"label.knowledgebase.data.recovery.failed":`Recuperar {a} dados falhados`,
"setup_mainpage_label_welcome6":`Os utilizadores podem criar vários tipos de campos em todos os objectos do sistema CloudCC sem qualquer conhecimento de programação ou desenvolvimento de código. Os tipos de campos incluem: relação de pesquisa, campo de selecção única, selecção de itens duplos, fórmula, numeração automática. , URL, telefone, fax, e-mail, caixa de verificação, data, hora, número, texto, área de texto, lista de opções (selecção simples/múltipla), moeda, etc.`,
"label_emailtocloudcc_button_enable":`Activo`,
"label.account.custom":`Trimestre Fiscal Personalizado`,
"label.custompublish_time":`Tempo de publicação do cliente`,
"label.dashboardSetup.selwz":`Posição mostrada`,
"component_todaytask_label_all":`Ver Tudo`,
"label.service.resource.group.tip":`Os recursos de serviço relativos aos tipos de tripulação devem utilizar o tipo de tripulação.`,
"label.tianyancha.legalpersonname":`Nome da pessoa colectiva`,
"component.setup.label.titlefield":`Campo de título`,
"label.email.template.public.mail":`Pasta Pública de Modelos de Email`,
"front-template-V1-DeleteTempalte":`Tem a certeza de apagar "{currentTelmplateName}"?`,
"pagecreator.layout.label.layoutdesc":`Descrição do layout`,
"vue_label_file_singel_upload":`Apenas um ficheiro pode ser carregado. Se precisar de substituir o ficheiro, por favor eliminar primeiro o ficheiro carregado`,
"label.view.hierarchy":`Ver Hierarquias`,
"label.file.owner.settings":`Configurações do proprietário`,
"label.sales.dashboard.name":`Nome`,
"label.offfer.filer.name":`Nome do ficheiro de citação`,
"label.quickbooks.view.recentlypaid":`Recentemente pago`,
"label.step1.select.merge.records":`Passo 1 seleccionar os registos a fundir`,
"message.recordtype.assignprofile.tip":`Seleccione a caixa de verificação Habilitar para Perfil para tornar o novo tipo de registo disponível para um perfil. Os utilizadores atribuídos a este perfil poderão criar registos deste tipo de registo, ou atribuir este tipo de registo aos registos existentes. Para tornar o novo tipo de registo o padrão para um perfil, seleccione a caixa de verificação Tornar Padrão.`,
"label.appointmentdetail.wizard.title9":`Tempo de viagem`,
"label.group":`Grupos`,
"label.deltorecycle":`Apagar para Lixeira`,
"label.import.index.numlimit":`1. Só são suportados ficheiros em formato csv, e até 30.000 registos podem ser importados por uma só vez (<estilo de var var="cor: vermelho">até 2.000 registos podem ser importados se for necessário executar o trigger</span>). Os registos que excederem o limite serão automaticamente ignorados pelo sistema. Se quiser importar mais dados, divida-os primeiro em vários ficheiros e importe-os em alturas diferentes. .`,
"label.file.delete.desc":`A eliminação de um ficheiro também o removerá de quaisquer registos ou mensagens adicionais.`,
"UG_activity_04":`Caixa de correio Outlook/Gmail, gravar correio`,
"label.event.all.undealt":`Todos os eventos não processados`,
"label.appupload.upload.install.error":`Esta aplicação não pode ser instalada. por favor termine a instalação ou modifique a api do sistema e reinstale-a!`,
"template.chart.yqydcpsl":`Número de Produtos Activados`,
"label.import.index.advancepreparation":`Preparativos preliminares`,
"label.eowechat.epdeptnamee":`Nome do Departamento WeCom`,
"front-kefu-moudle-please-input-servernum":`Por favor, introduza a lista de pedidos de serviço nº.`,
"label.lookup.autocmp.nodata":`Sem dados de correspondência`,
"vue_label_pool_assign":`Atribuir`,
"label.knowledge.timing.publish":`A publicação atempada é falhada`,
"label.selected.groups":`Grupos de linhas de citação seleccionadas`,
"front-epwechat-module-v1-removesele-desc":`Após a eliminação, toda a configuração desta aplicação será removida. Tem a certeza de que vai apagar?`,
"label.batchtransfer.type2":`Transferência Oposição Fechada`,
"label.richtext":`Área de texto (Rich)`,
"label.icon.174":`Aeronaves`,
"vue.please.select.grouping.basis":`Por favor, seleccione Agrupar por opções.`,
"label.matrixreport":`Relatório Matrix`,
"label.jiandangfenpei.leftlist":`Perfis não atribuídos`,
"label_chatter_card":`Cartão`,
"label.file.enter.title":`Por favor introduza o título`,
"label.the.record.is.locked.and.cannot.be.selected.":`Este registo está bloqueado, não seleccionável.`,
"label.partner.success":`O domínio Sucesso! está disponível`,
"label.selectreporttype":`Seleccionar fonte de dados do relatório`,
"report.type.label.productPricebooks":`Produtos e Livros de Preços`,
"label.texttemplate.mergefields.tip":`Adicionar campos incorruptos durante a edição de conteúdos SMS. Quando o SMS é enviado, os campos incorporados podem ser substituídos por texto correspondente. Por exemplo, {!Contact.name} pode ser substituído pelo nome do contacto ao enviar o SMS.`,
"label.publicgroup.detail.showallusers":`Ver todos os utilizadores`,
"label.brief.follow":`Acompanhamento`,
"label.forecast.settings.qijian.p":`Previsão Trimestral`,
"label.sms.url":`URL`,
"setup_layout_group_custompage":`Personalizar Página`,
"label.validate.function.funcFormat.BEGINS":`BEGINS(text, compare_text)`,
"label.umeng.chatter.sendmessage":`enviou-lhe uma mensagem`,
"label.pc.layout":`Layout do PC`,
"label.currency.v":`Introduza as casas decimais ( número de dígitos à direita da vírgula decimal ) permitidas ao exibir dados nesta nova moeda. Deve ser um número inteiro com valor entre 0 e 6.`,
"label.projectManagement.kanbantask":`Tarefa Kanban`,
"component_recdetail_label_title":`Informação detalhada`,
"label.isremider":`Lembrete`,
"front-epwechat-module-v1-input-home-url":`Por favor introduza o URL da página inicial`,
"label.usefullife":`Prazo de validade`,
"label.visualpage.ptype":`Comum`,
"label.quote.name":`Nome da citação`,
"vue_label_report_addtocomponent":`Tem a certeza de que quer adicionar { nome } à biblioteca de componentes?`,
"label.dashboardSetup.showdw.d1":`100 Milhões`,
"label.validate.function.funcFormat.OR":`OU(lógico1,lógico2,...)`,
"label.component.helper.potentialcustom":`Leads que lhe foram atribuídos hoje`,
"label.autoRegister.changepwd.setpwd.tip.number":`Pelo menos um número`,
"label.data.setok.e.desc3":`， descarregue os seus dados exportados.`,
"label.data.downpage.e.title.num4":`4、 Os ficheiros de exportação têm dois formatos: o formato CSV e o formato de compressão. O formato de compressão é dividido em dois tipos: um é gerar automaticamente a palavra-passe do ficheiro comprimido, o outro é introduzir manualmente a palavra-passe do ficheiro comprimido.`,
"lable.quote.editqtpdt.description":`Seleccione um livro de preços para este orçamento. Só pode adicionar um produto de um único livro de preços, e alterar o livro de preços seleccionado removerá todos os produtos existentes do orçamento.`,
"front-kefu-moudle-edit-userinfo":`Editar Informação do Utilizador`,
"label.please.ChooseMinAndMax":`Escolha pelo menos {0} opções de produtos, e até {1} podem ser seleccionadas.`,
"label.knowledgebase.archive.an.article":`Arquivar um Artigo?`,
"label.multilang.customforcast.submit":`Apresenta uma previsão de {0}ano fiscal{1} a {2}ano fiscal{3}?`,
"label.import.index.filename":`Nome do ficheiro`,
"front-console-no-reco-contact":`O contacto não pode ser identificado`,
"label.quantity.greater.than0":`A quantidade deve ser superior a 0.`,
"label.codeNorm":`Código Padrão`,
"label.average":`Média`,
"label.multilang.page1":`Página`,
"label.data.exp.save.ok":`Salvar modelo com sucesso`,
"message.error.delete.record":`O registo a ser apagado não foi encontrado!`,
"label.newvaluereplaceoldvalue":`Substituir globalmente um valor existente numa lista de selecção por um novo valor. Certifique-se de que criou primeiro o novo valor no campo da lista de selecção.`,
"label.tabpage.saveviewsuccess":`Vista guardada com sucesso`,
"label.partnerCloud.productSet.parentOptions":`Opção dos Pais`,
"label.emailtemplate.availablemergefields":`Campos de fusão disponíveis`,
"label.data.import.setup":`Configurações de importação de dados`,
"label.escalation.setup.entrydetail.escalation.action":`Acções de Escalada`,
"System.TimeField.Description":`Permite aos utilizadores entrar a uma hora local. Por exemplo, "14:40 PM", "14:40" e "14:40:00" são todas horas válidas para este campo.`,
"front-additional-products":`Comprar outros produtos`,
"label.appointment.wizard.subtitle4-4-1":`1 semana`,
"label.chatter.colleagues.list":`Lista de colegas`,
"label.log.invalid.data":`Data inválida`,
"label.file.preview.unconvert":`Não é gerada informação de pré-visualização,por favor clique nos detalhes de pré-visualização`,
"label.customer.detailed":`Escolha a página para este novo separador. Introduzir outros detalhes.`,
"label.sendsms.content":`O conteúdo é o seguinte:`,
"label.exported_to":`O ficheiro exportado será enviado por email para`,
"label.attendance.checkin":`Check In`,
"Dashboard.NoAccessRightToSee.Warning":`Não tem permissão para ver os dashboads {0} que estão definidos como defualt aberto, por favor reiniciar.`,
"message.choosedelete":`Por favor, seleccione os dados que pretende apagar`,
"label_tabpage_choosecontent":`Seleccionar o conteúdo do valor`,
"label.no_responses":`Sem respostas`,
"report_type_label_customService":`Apoio ao Cliente`,
"label.report.select.condition":`Condições`,
"label.umeng.activity.distributeevent":`atribuiu-lhe um evento.`,
"label.knowledge.language.portuguese":`Português`,
"label.knowledgebase.published":`Publicado em`,
"UG_opportunity_001":`Como é que controla as suas vendas?`,
"label.mr.caption.scope":`Âmbito: consultar todos os dados se não forem seleccionados`,
"message.login.mfaverification.to.pclogin":`A sua organização permitiu a verificação do login secundário, o primeiro login requer a ligação ao dispositivo móvel, por favor utilize o lado do PC para ligação ao login`,
"vue_label_dashboard_pleaseenterthecolorrange":`Por favor, introduza a gama de cores`,
"label.emailsync.status.time":`Hora`,
"chatter.putup":`Partilhar um ficheiro`,
"vue_label_report_drillcondition":`Condição de Perfuração`,
"label.emailobject.list.myemail":`O meu e-mail`,
"label_tabpage_andz":`E`,
"label.share_link":`Ligação de partilha`,
"label.emailtocloudcc.exists2":`Esta caixa de correio foi configurada para Enviar por e-mail para Case. Não repetir as definições.`,
"label.icon.89":`Consultoria`,
"front-kefu-moudle-v1-qdygbzx-chat":`Tem a certeza de desligar o chat online?`,
"label.approval.selectone":`Por favor, seleccione pelo menos uma acção.`,
"chatter.group.groupName":`Nome do grupo`,
"label_chatter_relateitem":`Relacionado com`,
"label.file.folder.delete1":`Eliminar pasta?`,
"Pagelayout_Setup_003":`O campo Nome deve ser seleccionado`,
"setup_mainpage_label_welcome2":`Base de dados personalizada (objecto)`,
"pagecreator.systemstyle.label.linkcolor":`Cor da ligação`,
"label.task.this.week":`Esta Semana`,
"message.custom.field.donotdelete.report":`O campo é referenciado pelo relatório`,
"pagecreator.layout.button.delete":`Apagar layout`,
"label.reportsSubscriptionPage.condition.operator":`Operador`,
"label.location.display.type.degrees":`Graus,minutos,segundos`,
"label.appupload.upload.url":`URL de instalação`,
"label.logical.relation":`Relação lógica`,
"label.knowledge.publish.article":`Publicar Artigo`,
"vue_label_commonobjects_detail_activity_commingtask":`Próxima tarefa disponível`,
"vue_label_pool_reason":`{0} razão`,
"front-gantt-module-subtasks-cannot-subtasks":`As subtarefas não podem aparecer sob subtarefas!`,
"label_tabpage_filesizez":`Tamanho do ficheiro`,
"label.customfields.formula.returntype.monry.tip":`Calcular um valor em dólar ou outra moeda e formatar automaticamente o campo como um valor em moeda.`,
"label.tabpage.allapplications":`Todas as aplicações`,
"message.duplication.label.matchcontainletters":`Conter`,
"maintenanceplan.workorder.type.asset.workorderlineitem":`Por favor, escolha "Um item de ordem de trabalho para cada bem" como o tipo de ordem de trabalho de geração.`,
"label.preview_post":`Antevisão do posto`,
"chatter.p.data":`Data de lançamento`,
"label.isnot.right.number":`Número inválido`,
"label.contentsource":`Fonte de conteúdo`,
"message.groupandsummaryconditionsame":`As condições usadas para agrupar não podem ser as mesmas que as condições sumárias`,
"label.weixin.wdyj.nodata.qin":`Desculpe, {0} não tem dados.`,
"chatter.vote":`Votação(ões)`,
"label_partner_workspace_tab_option":`Separadores disponíveis`,
"chatter.changeVote":`Voto de Mudança`,
"label.data.file.i_title.num2":`2. Recomenda-se que os dados sejam exportados quando os dados são importados, para que o documento de exportação seja utilizado como um modelo para recolher os dados a importar, e depois importar. (Se os dados importados contiverem uma vírgula, substitui-la pelo símbolo @).`,
"label.relation.list.error":`Erro`,
"label.validate.function.funcExplain.MILLISECOND":`Devolver milissegundo de dia (Dos campos de data/hora)`,
"label.emailobject.emaildetail.button.relateto":`Relacionado com`,
"label.dashboard.dataSource":`Mostrar fonte de dados`,
"label.marketseamemset.lead.title":`Configurações dos membros do grupo de liderança`,
"label.appupload.addobj":`Adicionar ao pacote`,
"lable.outlook.mcto.domain":`Acrescentar o meu domínio (gmail.com) à lista de domínios excluídos.`,
"label.input.right.url":`Por favor introduza o URL válido`,
"label.newprocessstep5.tip":`A página de aprovação é onde um aprovador irá realmente aprovar ou rejeitar um pedido. Utilizando as opções abaixo, escolha os campos a exibir nesta página.`,
"label.schedulejob.setup.schedule.st4":`A 4ª`,
"label.emailsync.status.user":`Utilizadores`,
"front-kefu-moudle-v1-jymm-reinput":`Introduza uma palavrapasse de 12 dígitos, combinando dois ou mais caracteres maiúsculos, minúsculos, numéricos e caracteres`,
"Lead_Scoring_Setting_Rule_Setup_RuleName":`Nome da Regra de Pontuação`,
"label.mr.title.fieldName":`Nome do campo`,
"label.data.deriall":`Exportar tudo`,
"label.tianyancha.businessverify.step2":`Activar a etapa 2 de verificação de dados comerciais`,
"label.submissions":`Envios`,
"vue_label_calendar_removed_successfully":`Calendário removido com sucesso`,
"label.eventrecordtype":`Tipos de registo de eventos`,
"lable.outlook.detail.syndire":`Sync Direction`,
"label.mobile.bind.fail":`Falha na ligação, por favor tente novamente mais tarde`,
"label.notification.task2":`【被分配人】 visualizou a tarefa que lhe foi atribuída`,
"label.partnerCloud.orderingPlatform.paymentMethod":`Pagar por:`,
"label.escalation.setup.newaction.step3":`Passo 3 Seleccionar o utilizador a notificar`,
"label.summaryreport.selectsum":`Escolher os dados resumidos e o tipo resumido`,
"label.components.setup":`Definições de componentes`,
"label.taskevent.introduce":`A sua lista de actividades`,
"label.assignment.setup.detail.conditon":`Critérios`,
"front-lightning-module-v1-details-page-chart-select-statements":`Seleccionar Relatório`,
"lable.Song.typeface":`SimSun`,
"label.formulassesstrue":`a fórmula avalia a verdadeira`,
"label_partner_common_setup":`Configuração geral`,
"label_chatter_dateRange":`Intervalo de datas`,
"label.partner.workspace.tab.mobile.using":`Afixação na aplicação móvel`,
"message.servicecrew.time.violation1":`Violação do tempo de atribuição: há um membro da equipa.`,
"report_label_projectcount":`itens, ordenar pelo nome do relatório`,
"label.file.uploadfile":`Carregar ficheiros`,
"vue_label_commonobjects_detail_correct_email_address":`Por favor introduza o endereço de e-mail correcto`,
"lable.account.CurrentandNextCQr":`Corrente e Próxima 3 CQ`,
"setup.layout.label.order":`Ordenar por`,
"label.service.major.event.independent":`Independente`,
"label.icon.38":`Posicionamento`,
"label.knowledge.draft.record":`O registo que está a tentar apagar não é encontrado.`,
"label_quota_percentage":`Mostrar Percentagem de Conclusão da Quota`,
"label.escalation.setup.entrydetail.escalation.minute":`Acta`,
"label.knowledgebase.edit.article.category":`Categoria de Artigo de Edição`,
"Homepage_News_003":`Não é possível exibir notícias sem dados de contas, por favor crie uma nova conta e as notícias relacionadas serão exibidas.`,
"label.mr.descreption.oneGroupNote3":`registos.`,
"label.customsetting.touse.getListCustomSetting":`Consultar os dados do tipo "list" de definições personalizadas, devolver todos os dados correspondentes ao Nome API. Mapa do mapa = cs.getListCustomSetting(String apiName);`,
"message.error.view.cannotbenull":`Erro: é necessário introduzir um valor`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.friday":`Sexta-feira`,
"message.error.view.badprevilege.qin":`Desculpe, não tem acesso a {1}, por isso não há dados mostrados</br>`,
"label.dashboard.distribution":`Distribuição`,
"label.field.value.save":`É sempre necessário um valor neste campo para guardar o registo.`,
"label_custom_year":`Ano personalizado`,
"label.code.error":`O código contém comandos ou funções que não são permitidos como os seguintes:`,
"label.appexchange.uninstallpage.message2":`Remova permanentemente todas as suas configurações personalizadas para estes componentes`,
"label.global.search.obj":`Objecto de pesquisa global`,
"label.emailobject.from":`A partir de`,
"lable.opppdt.selPdt.byconditions":`Por Campo`,
"chatter.p.note":`Notas sobre este posto`,
"label.hiddenformulaedit":`Editor de Fórmula Oculta`,
"label.editQuotation":`Editar Citação`,
"label.notification.arketsea.collection":`{5} colectados{2}{0}{0}:{1}:{1}{2}{2}{3}{3}{3}{3}{4}{4}{5} colectados`,
"label.timzone.tip.info1":`Quando se trata de guardar dados do tipo java.util.Date （insert e update）in uma base de dados, por exemplo, Quando se trata de guardar (inserir e actualizar) uma base de dados do tipo java.util.Date, por exemplo, TpSysTask task=new TpSysTask () ；task.setBeginTime (nova Data () ）；......dbman.insert (task) ou dbman.update (task); deve alterar a nova data () para chamar TimeUtil.getNowDate (userInfo), pelo que a declaração relevante no exemplo acima deve ser alterada para task.setBeginTime (TimeUtil.getNowDate (userInfo);)`,
"label_tabpage_transformationsz":`Converta`,
"front-kefu-moudle-IP-phone":`Telefone IP`,
"label.emailobject.list.draft":`Esboços`,
"label.tianyancha.businessverify.readandconfirm":`Li o acordo e concordo com ele`,
"label.win.customers":`Contas Fechadas-Vertidas`,
"vue_label_commonobjects_view_switch_display":`Os seus registos são agrupados por tipo de registo, pode clicar no nome do tipo de registo correspondente para mudar de visualização.`,
"pagecreator_systemstyle_label_textcolor":`Cor do texto`,
"label.autosearch.keywords":`Pesquisa automática de palavras-chave completa`,
"label.knowledge.setting.data.six":`Vai apagar a categoria {lbmc}, tem a certeza de que vai continuar?`,
"front-console-sort-field":`Caso nº.`,
"label.bangladesh.time":`Hora do Bangladesh`,
"label.dashboardSetup.number":`Valores numéricos`,
"lable.account.LastbDays":`Últimos 30 dias`,
"label.layout.searchdialog":`Diálogo de Pesquisa`,
"label.newprocessstep4.tip":`Seleccionar o modelo de correio electrónico que será utilizado para notificar os aprovadores de que lhes foi atribuído um pedido de aprovação. Note-se que este modelo será utilizado para todas as etapas deste processo.`,
"label.nousing":`Inactivo`,
"vue_label_report_detailline":`Linha de detalhe`,
"label.emailobject.template.message3":`O máximo de modelos de correio é atingido!`,
"label.c.d":`Relação C a D`,
"message.report.error.fail":`Carga falhou, por favor tente novamente`,
"label.edit.ccdocument.content":`modificou o cumprimento.`,
"label.textmessage.exceeded":`O número dos seus modelos de texto ultrapassou o limite!`,
"label.saveas":`Salvar como`,
"label.visualpage.an.inline.style":`Incorporar tipo de página personalizada à página de detalhes e página inicial do separador`,
"label.pagelayout.remark2":`dados. Após criar o layout da página, clicar no botão Page Layout Assignment para controlar qual o layout da página que os utilizadores vêem por defeito.`,
"label.notification.approval1":`Pedido de aprovação para the【对象】is aprovado by【审批人】`,
"label.h5.chatter.image":`Carregar o formato da imagem não é correcto`,
"vue_label_dashboard_displayunit":`Por favor seleccione uma unidade de visualização`,
"label.knowledge.default.language":`Língua de Conhecimento por omissão`,
"label.chatter.publish":`Publicar`,
"label.companyprofile.serveraddress":`Esta sincronização apenas sincroniza o servidor actual.`,
"label.chatter.groups":`Grupo`,
"label_set_successfully":`Definido com sucesso!`,
"label.quote.zongjia":`Preço total`,
"label.project.notice.endingdatelater":`A data final deve ser posterior ou igual à data de início.`,
"label.customfields.fielddependency.info":`Esta página permite-lhe definir as dependências entre campos (por exemplo, listas de selecção dependentes).`,
"vue_label_lead_successful_conversion":`Conversão bem sucedida`,
"label.icon.93":`Livro`,
"shift.serviceresource.illegal":`O recurso de serviço não é relativo ao membro do território de serviço ou a data de mudança não se encontra dentro do intervalo de filiação.`,
"label.integrations.action.addnewlead":`Adicionar novas pistas`,
"label_display_all_zeros":`Mostrar todas as filas com valores zero`,
"canlendaryear":`Ano civil`,
"label_tabpage_selrecordtypez":`Seleccione o tipo de registo`,
"vue_label_commonobjects_view_chart_funnel":`Carta do Funil`,
"label.layout3":`Esquema 3`,
"label.logintime.cue":`Sem tempo de login especificado.`,
"label.service.miniProgram.lastDate":`Data da última modificação`,
"label.emailobject.view.fromcrm":`Emails de Contactos/Leads`,
"pagecreator.button.mobilepage":`Lado móvel`,
"lable.oppt.jieduan.signcur":`Marcado como a fase actual`,
"label.fullaccess":`Acesso completo`,
"homepage.layout.pagename":`Nome do layout da página`,
"label.appointment.wizard.subtitle4-2-3":`3 h`,
"label.knowledgebase.please.check.record":`Por favor, seleccione pelo menos um registo.`,
"label.view.sortview.closepage":`Fechar Janela`,
"label_forecast_type":`Tipo de previsão`,
"all.day":`Todo o dia`,
"label.view.sortview.printpage":`Imprimir esta página`,
"message.integration.configure":`A configuração integrada está vazia!`,
"label.forecast.customforecast.foretype.close":`Fechado-Ganho`,
"label_chatter_like":`Como`,
"template.report.folder.customer.potential":`Análise de Leads`,
"label.umeng.approval.dlsp.approve":`#aprovação nome aprovado o pedido de aprovação #actorname' de #objAPIName #recordname para si.`,
"vue_label_normal_movedown":`Descer`,
"chatter.group.groupAccessPermissions":`Acesso de Grupo`,
"label.visualpage.tip":`Pode criar a sua própria página aqui`,
"message.validation.isnotdate":`Data inválida`,
"label.icon.173":`Barco à vela`,
"label.icon.124":`Injecção`,
"label.import.page2.csvfiled":`Campo CSV`,
"setup_layout_component_area":`Área`,
"label.visualpage.workability.standard":`Classes padrão disponíveis na página`,
"label_emailtocloudcc_redmessage9":`Erro na base de dados, por favor contacte o administrador.`,
"label_tabpage_contactsz":`Contactos`,
"label.multilang.workflow.everydayinmonth":`{1} dias a cada {0} mês`,
"APPIntegration.Social.linkedinerror":`Deve introduzir um URL válido para linkedin.com`,
"button_partner_workspace_manage_memo":`Gerir a nuvem do seu parceiro e configurar as propriedades da nuvem do parceiro.`,
"template.chart.bnsrmb":`Meta de receitas para o ano`,
"chatter.follow.now":`A seguir`,
"label.entitlement.process.condition.repeat":`Estabelecer repetição de marco miliário`,
"label.relationobject.isdl":`Delegado`,
"label.lasttimemodifieralias":`Último Modificador Alias`,
"vue_label_commonobjects_detail_task_name":`Editar nome da tarefa`,
"vue_label_homepage_quarterlyperformance":`Desempenho trimestral`,
"pagecreator.layout.message.delete":`Apaga o esquema actual seleccionado?`,
"component_sendmail_label_cc":`Cc`,
"vue_label_email_enable_signature":`Habilitar assinatura`,
"label.partnerCloud.financeSetting.create":`Criar fundos para utilizadores elegíveis automaticamente quando novos parters são activados.`,
"label.data.file.i.title.num1":`1. O ficheiro importado deve ser um ficheiro em formato CSV. O ficheiro tem de conter um título e não pode ser importado sem título.`,
"label_efine_assessment":`Ciclo de avaliação`,
"message.duplication.label.sectionTitle":`Seleccione o valor a reter`,
"front-electronic-export-buttonExport":`Continuar a exportar`,
"message.submitpage.email":`Parabéns, e-mail enviado com sucesso.`,
"after":`Depois de`,
"label.version.nonsupport":`Sem apoio`,
"label.icon.105":`Horário`,
"label.quickcreate.titledesc":`Activar o Quick Create permite aos utilizadores criar registos a partir do diálogo de pesquisa.`,
"label.quote.number":`Introduza a quantidade`,
"label.view.sortview.setdefault.prompt":`Fixar esta lista de visualização`,
"label.refertime":`Data de apresentação`,
"frame.personinfo.label.minipic":`Imagem em miniatura`,
"label.mobile.home.page.newopp":`Líderes recentemente criados`,
"label.address":`Endereço`,
"front-pay":`Pague`,
"label.chat.serviceAppointment":`Aviso de serviço`,
"label.umeng.activity.eventviewed":`O evento que atribuiu a #name é visto`,
"label.validate.function.funcExplain.DATE":`Criar data até ao ano, mês e dia`,
"label.commiterselectapprover":`Deixar o apresentante escolher o autorizador manualmente.`,
"label.appointmentconfirmpage.wizard.subtitle3":`Localização`,
"vue_label_display_text_field":`Mostrar campos de texto`,
"label.salescloud.teamrole":`Papel da equipa`,
"maintenanceplan.workorder.generate.limit":`A ordem de trabalho deve estar dentro do intervalo do calendário de manutenção.`,
"label.campaignmember.selectmember.description":`selcet uma vista, depois adicionar os membros à Campanha, e o Status da Campanha Menmeber é`,
"label.ismodify":`Permitir a edição`,
"label.height":`Alto`,
"label.tabpage.thevalurofz":`O valor de`,
"label.create_successful":`Criar formulário com sucesso`,
"front-invoice-online-payment-setup-configure-dialog":`Configurar interface de pagamento`,
"label.customerinfo.smsEid":`SMS Gateway EID`,
"label.visualpage.list.no":`Sem permissões de acesso às páginas personalizadas`,
"look.trigger.in":`Ver instruções`,
"label.setting.disable":`Desactivar`,
"chatter.group.name":`Grupos`,
"label.solutionadministrator":`Gestor de soluções`,
"label.vlidaterule.top":`Início da página`,
"pagecreator.layout.message.save.fail":`Falha no layout`,
"label.partnerCloud.orderingPlatform.noZero":`A quantidade não pode ser 0.`,
"label.customfields.suretodeleteprompt":`Confirmar os avisos de eliminação de campos personalizados`,
"button_partner_viewdetail":`Ver`,
"label.icon.122":`Casa`,
"label.customer.tab.step2.introduce":`Escolher os perfis de utilizador para os quais o novo separador personalizado estará disponível. Pode também examinar ou alterar a visibilidade dos separadores a partir dos detalhes e editar as páginas de cada perfil.`,
"label.task.delegated":`Delegado`,
"vue_label_salesadvance_averageamount":`Por transacção do cliente`,
"vue_label_chat_invitedtojoin":`convidou-o a juntar-se ao chat do grupo`,
"label.data.downpage.e_title.num1":`1. Seleccionar os objectos que deseja exportar, ou optar por exportar todos.`,
"label_display_options":`Opções de visualização`,
"vue_label_chatter_more_comments":`Mais comentários`,
"label.ggReleaseRange.publish":`Publicar Lista`,
"label.valuetype.notmate":`Erro de condição da linha, o tipo de valor não corresponde.`,
"label.chatter.chatter":`CCChat`,
"label.exchange.sync.state.contact.m1":`Última actividade sincronizada:`,
"label.dataimport.duplication.filter":`Encontrar Prompts de Filtro Duplicado`,
"label.appdownload.uninstall":`Desinstalar`,
"message.error.task.add":`Nova anomalia de tarefa`,
"UG.Account.07":`Conta de importação`,
"label_tabpage_lastone":`Seleccionar pelo menos uma operação`,
"front-console-holdTime":`Tempo de atraso`,
"label.emailobject.schedule":`Veja a minha agenda e marque uma hora aqui.`,
"label.lookup.locked.data":`Este registo está bloqueado, não eletivo`,
"label.assignment.setup.newentries.ifcondtions":`Execute esta regra se o`,
"label.magadan.time":`Hora de Pietro Pavlov`,
"message.error.serviceterritorymember":`Por favor definir o recurso de serviço seleccionado como membro do território de serviço dentro do intervalo de tempo do plano de nomeação de serviço.`,
"label_chatter_delete":`Eliminar`,
"label.partner.workspace.member.permission":`Conjunto de permissões disponíveis`,
"label.notification.task5":`A sua tarefa já devia ter sido cumprida`,
"mary":`Maio`,
"label.homepagemodule":`Página inicial Componentes`,
"label.compact.layout.frame.error1":`O ecrã direito não pode ter nenhum conteúdo`,
"chatter.error.refresherror":`A actualização falhou, por favor tente novamente.`,
"label.login.rememberPsd":`Recordar-me`,
"Lead.Scoring.Setting.Rule.Setup.01":`Lista de regras de pontuação de chumbo`,
"label.reportsSubscriptionPage.schedulereport.weekly.sunday":`Domingo`,
"label.visible":`Visível`,
"label.console.new":`Nova Consola`,
"label.mr.descreption.reDataList4":`milissegundos. por página.`,
"vue_label_notice_uploadavatar_notice2":`A imagem de avatar carregada só pode ser em formato JPG/PNG/GIF`,
"label.operation.error":`A operação falhou, por favor tente novamente.`,
"label.sendsms.context":`Conteúdo de SMS`,
"label.least.show.line":`(mostrar pelo menos 4 linhas)`,
"label.tabpage.newWizardz":`Novo assistente de funções acrescentado`,
"label.tippage.li2":`Eliminar todos os relatórios com base em fonte de dados de relatório personalizada`,
"label.customfields.new.step2.opration.unique":`Único`,
"label.listofshare.remark":`Os utilizadores seguintes podem ver os registos`,
"label.address_information":`Informação sobre o endereço`,
"label.projectManagement.overdue.tasks":`Tarefa vencida`,
"lable.account.PreviousCQ":`CQ anterior`,
"label.service.miniProgram.advertising":`O nome do anúncio é apenas utilizado para identificar múltiplas entradas de anúncio e não é exibido no anúncio.`,
"label.integrations.mailchimp.exportlead":`Exportação seleccionada leva ao Mailchimp`,
"label.payments.paytip3":`Por favor seleccione um endereço de facturação`,
"label.mobile.phone.screen":`Filtro`,
"label.h5.tome":`Sobre mim`,
"label.mobile.side.tab.remark1":`Adicionar o separador CloudCC e o objecto ao menu de navegação do selector do lado móvel.`,
"vue_label_calendar_choose_a_custom_color":`Escolha a cor personalizada deste calendário`,
"label.lastname":`Sobrenome`,
"vue_label_dashboard_selectreport":`Por favor, seleccione relatório`,
"label.lanxin.setting.appid":`AppID`,
"vue_label_report_information":`Exportar o relatório tal como apresentado no Cloud CC, incluindo o cabeçalho do relatório, grupo e informação do filtro.`,
"label_chatter_default":`Por defeito`,
"label.globalSearch.info":`Pesquisa de todos os objectos seleccionados`,
"label.integrations.mailchimp.massage2":`Exportar os contatos selecionados para Mailchimp e poderá ver os contatos na lista Mailchimp mais tarde`,
"label.tabpage.addresswrongz":`O formato do endereço da caixa de correio está errado, por favor introduza correctamente o endereço da caixa de correio!`,
"label.mobile.phone.customer.call":`Visitar Cliente`,
"vue_label_email_linkrecordfail":`Registo desvinculado`,
"lable.account.LastfDays":`Últimos 90 dias`,
"label.cpq.order.status.delete":`Esta ordem está activa e não pode ser apagada`,
"label.ccchat.notmember.active.group":`Não é membro`,
"label.savepayset.failure":`Falha em salvar a conta de pagamento online`,
"label.version.createlimitbyobject":`A sua edição actual do CloudCC é {0}, e pode criar {1}. {2} para cada objecto. Agora, o número de {2} é excedido o máximo do seu plano de assinatura, por favor actualize a sua edição CloudCC.`,
"approval.process.errore":`Ocorreu um erro durante o salvamento, por favor contacte o administrador.`,
"label.stdashbord.xsld.business.reportanalysis":`Análise de gráficos`,
"label.login.verification.please.enter":`Por favor, introduza o código de segurança que recebe da aplicação AMF`,
"label.tabpage.cue":`Lembrete de informação`,
"vue_label_salesadvance_converserate":`Taxa de conversão`,
"label.marketsea.recyclereminddays1":`Antes da reciclagem automática`,
"label.import.page1.update":`Actualização`,
"label.document.folder":`Pastas de documentos`,
"label.h5.similar.opportunity.feature":`Esta característica permite a um utilizador procurar oportunidades que partilham campos comuns com a oportunidade. Uma vez activada, uma lista relacionada com Oportunidades Semelhantes aparece no registo de oportunidades.`,
"label.myanmar.time":`Tempo de Mianmar`,
"monday":`Segunda-feira`,
"vue_label_account_shareholder":`Accionista`,
"button.partner.search":`Inquira`,
"label.partnerCloud.partnerAccount.topUpAmount":`Montante de recarga`,
"label.tabpage.refreshz":`Actualizar`,
"lable.PowerProcess.complete":`Minas de conclusão de marcos`,
"front-kefu-moudle- normal-phone":`Telefone geral`,
"label.user.unauthorized.organization":`Organização não autorizada, por favor contacte o administrador.`,
"label.area.canot.save.nulldata":`Não é possível guardar os dados nulos`,
"label.version.role.management":`Gestão de papéis`,
"label.recordtype.batchaddattachments.batch.remark":`Passo 1 Escolher ficheiro, Passo 2 Clicar no botão "iniciar carregamento", carregar ficheiros, Passo 3 Clicar no botão para terminar.`,
"label_tabpage_contentz":`Por favor introduza o conteúdo`,
"label.partner.workspace.member.all":`Todos`,
"label.validate.function.funcFormat.LEFT":`LEFT(texto, num_chars)`,
"vue_label_SMS_notice_selectatleastone":`Por favor seleccione pelo menos uma pista ou contacto`,
"label.appupload.install.error.choice5":`Parar imediatamente a instalação e produzir componentes conflituosos`,
"label.version.lookupmdfield":`Campo de Relacionamento Master-Detail`,
"setup.layout.label.desc":`Descendente`,
"vue_label_report_addsummaryformula":`Adicionar fórmula resumida`,
"label.done":`Feito`,
"label.input.samevalue":`Introduzir o mesmo valor`,
"label.SMS.next":`Seleccione os objectos para as notificações SMS e clique em "Next" (Seguinte). As notificações por SMS só podem ser associadas ao mesmo tipo de regras de fluxo de trabalho e processos de aprovação.`,
"label.role.allunselectuser":`Todos os Utilizadores Não Atribuídos`,
"label.loginhistory":`Histórico de Login`,
"vue_label_report_addpublicreportstofolder":`Adicionar relatórios públicos a esta pasta`,
"label.email.track.no.attachment":`Sem anexos`,
"label_network_connection_failure":`A ligação à rede falhou.`,
"vue_label_file_delete_lib_member":`Eliminar membro da biblioteca de ficheiros`,
"label_partner_step1":`Passo 1 seleccionar modelo`,
"label.password":`Senha`,
"label.select.the.fields.around.code":`Escolher campos a serem exibidos em torno do código QR/Código Bar.`,
"label.file.share.limit":`Para além do limite de acções, nenhuma nova acção pode ser adicionada!`,
"label.desktop":`Ambiente de trabalho`,
"label.sendmail":`Enviar Email`,
"label.quote.detail":`Itens da linha de citação`,
"label.approvalstep2":`Etapa 2 Especificar os Critérios da Etapa`,
"label_component_hotdeal_nodata":`Não há dados relacionados com oportunidades de negócio.`,
"lable.reset":`Reinicialização`,
"label.eventpagelayout":`Layouts de páginas de eventos`,
"label.icon.100":`Papelaria`,
"UG.quota.03":`Modelo de citação`,
"label.calendar.week.view":`Vista da semana`,
"component_chatter_file_button_save":`Publicar`,
"label.as":`Como`,
"template.chart.yqxypjz":`Média Esperada de Resposta`,
"UG.Contract.03":`Criar contrato`,
"label.projectManagement.gantt":`Gráfico de Gantt`,
"label.forecast.edit.error0":`Erro: Deve seleccionar pelo menos uma moeda orporativa.`,
"label.ccpeak.delete.sharetab":`Eliminar o formulário de partilha`,
"label.account.contact.goback":`Voltar às contas`,
"vue_label_email_insert_field":`Por favor seleccione o campo a inserir`,
"setup_object_field_dependency_label_fieldvalueoptions":`Valores de campo disponíveis`,
"label.salescloud.opportunity.contactrole.optionlist.main":`A seguinte é a lista principal de valores da lista de opções para o campo de funções de contacto sobre oportunidades`,
"label.huanxinconfig.tenantid.lost":`tenântida não pode estar vazia`,
"label.mask.show.last_4":`Máscara com os quatro últimos caracteres`,
"label.targer.name":`Nome do Indicador`,
"vue_label_commonobjects_detail_unlocksuccess":`Desbloqueado com sucesso`,
"front-kefu-moudle-length-min":`Duração (minutos)`,
"label.chat.topic.my.favorite":`Os meus Tópicos Favoritos`,
"chatter.upload":`Carregar`,
"message.cannotapproveit":`O pedido de aprovação não pode ser processado.`,
"label.weixin..xsld.order.by.jine":`Ordenar por Montante de Contrato`,
"label.projectManagement.wait.test":`À espera de testes.`,
"template.report.customer.contact.list":`Lista de Contacto de Contas`,
"label.empty.recycle.bin":`Lixeira transparente`,
"label.detail.approveprocess":`Ver Processos de Aprovação`,
"label.appexchange.uninstallpage.message4":`Eliminar permanentemente todos os relatórios, vistas e separadores personalizados dos objectos personalizados neste pacote`,
"label.weixin.linkreport":`Relacionado com→Relatório`,
"label.tianyancha.orgnumber":`Código de organização`,
"Q":`Lista de selecção (Multi-Select)`,
"pagecreator_systemstyle_message_save_fail":`Salvar estilo falhou`,
"label.partner.new":`Nuvem de parceiros: novo`,
"label.ems.accounttype":`Tipo de conta (a)`,
"label.weixin.next":`Próximo`,
"label.weixin.coach.interpret":`A Aid-Max reserva-se o direito de revisão e interpretação final no âmbito da lei do serviço WeChat.`,
"label.some":`registo(s)`,
"label.currency.rate":`Currency Edit: Taxas de Conversão`,
"label.emailobject.template.name":`Nome do modelo`,
"UG.Campaign.001":`Campanhas de planeamento`,
"label.mr.descreption.reDataList3":`grupos de dados,tempo de consulta`,
"label.project.hit.nine":`Lembrete diário de emissão`,
"lable.PowerProcess.golist":`<<Back list：Entitlement Processo`,
"label.viewbuttonedit.remark":`Seleccionar os botões padrão e personalizados apresentados em primeiro plano.`,
"label.component.helper":`Assistente`,
"lable.SalesCommitmentKanBan.contractAndReceipts":`Pagamento assinado`,
"chatter.group.userName":`Nome de utilizador`,
"label.mobile.phone.business":`Oportunidades`,
"label.quickbooks.payments":`PAGAM`,
"label.step6.total7":`Passo 6 de 7`,
"label.forecast.detailforecast.revenue":`Previsão de receitas`,
"vue_label_commonobjects_view_chart_displayas":`Mostrar como`,
"label.recordeditoption":`Propriedades de edição de registos`,
"label.sendemail.send.sendfailstandby":`O envio de e-mail falhou, por favor contacte o seu administrador(caixa de saída de reserva).(código de erro:`,
"label.knowledgebase.reset.filter":`Filtro de reinicialização`,
"label.icon.111":`Alimentação`,
"label.standard.buttonandlink.firstsetting":`Substituir Propriedades`,
"front-filter-module-v1-filter-description":`O filtro Flash não pode ser guardado. Aplicase apenas à operação actual sem qualquer influência sobre as vistas ou outros utilizadores.`,
"label.showmore":`Ver mais`,
"UG_Lead_001":`Como introduzir as pistas?`,
"label.exchange.sync.state.setting.m1":`Conta do serviço de câmbio Miscrosoft:`,
"label.please.enter.channel.name":`Por favor, introduza o nome do canal.`,
"label.emailtocloudcc.edit":`Editar`,
"label.layout.tabdialog":`tabs`,
"label.Emoji":`Emoji`,
"template.report.completed.tasks":`Tarefas concluídas`,
"label.tabpage.enterviewname":`Passo 1 por favor introduza o nome da vista`,
"label.mobile.phone.not.to.choose":`Nenhum Seleccionado`,
"label.datamanage.contact.namenull":`Nota: Nota: Se o nome do contacto for nulo, o registo não será importado.`,
"LT":`Geolocalização`,
"label.exchange.sync.state.task.m3":`Registos sincronizados nas últimas 24 horas:`,
"lable.SalesCommitmentKanBan.contractOwner":`Proprietário do Contrato`,
"vue_label_chatter_write_review":`Escrever um comentário`,
"label.h5.approval.enter.content":`Por favor, introduza as notas de aprovação`,
"label.location.display.type":`Latitude e longitude exibem methode`,
"label.numberscannotnull":`O número não pode estar vazio`,
"label.icon.3":`Moeda`,
"setup_object_field_dependency_label_linkedfieldvalue":`Campo Dependente`,
"label.task.future":`Tarefas Futuras`,
"label.look.more.record":`Mostrar mais`,
"vue_label_account_cases":`Transferir todos os casos de proprietários de clientes`,
"label.emailobject.emaildetail.title.ccaddress":`CC:`,
"label.setHistoryTrack":`Rastreamento do histórico do conjunto`,
"ObjectDetailed.ViewKeyInformation.Layout":`Editar informação chave`,
"label.layout.editsearchdistribute.tip":`Seleccione os campos a incluir neste esquema de pesquisa. Note que as suas escolhas apenas determinam a exibição dos resultados da pesquisa e não afectam os campos que são efectivamente pesquisados.`,
"label.emailtoall":`Enviar e-mails a todos os utilizadores.`,
"label_partner_new":`Nuvem de parceiros: novo`,
"label.direct.dashboard.me.not.approval":`Os meus artigos a aprovar`,
"label.platform.customize.customizeui":`IU personalizada`,
"label.userinfo.pwderror.againinput":`A palavra-passe introduzida duas vezes não é a mesma. Por favor, reentrar.`,
"label.customsetting.introduce":`Utilizar configurações personalizadas para criar e gerir dados personalizados a nível da organização, perfil, e utilizador. Os dados das configurações personalizadas são armazenados na cache da aplicação. Isto significa que se pode aceder a ela de forma eficiente, sem o custo de consultas repetidas.`,
"label.file.owner":`Proprietário`,
"label.icon.7":`Pessoas`,
"label.document.query.button":`Clique em browse para encontrar o ficheiro`,
"label.tabpage.turnoffsz":`Fechado  Convertido`,
"message.error.appid.appsecret.failed":`Falha na obtenção das chaves de secrest!`,
"vue_label_commonobjects_view_to_display_fields":`Seleccionar até 10 campos de visualização`,
"label.martrixreport.setlinetitle":`Especificar Cabeçalhos de Fileiras`,
"vue_label_chatter_applycertification":`Concordar "{nome}" para se juntar ao chat do grupo?`,
"front-electronic-export-success":`Exportar com sucesso, por favor verificar na lista Mailchimp`,
"label.emailsync.status.enable":`Ligação Activa`,
"label.c_d":`Relação C a D:`,
"PageLayout_Search_MultiSearch_003":`Seleccionar pelo menos um campo.`,
"label.tabpage.newInterfacez":`A nova interface`,
"label.cutomsummaryfieldedit":`Edição de Campo Resumo Personalizado`,
"label.usermanage.view.field.notexist":`O campo correspondente à vista não existe.`,
"label.list.userinterface.dashboard.setup":`Configuração do painel de instrumentos`,
"label.knowledgebase.delete.article":`Apagar artigo`,
"label.dataimport.type.update":`Actualização`,
"label.marketsea.new":`Nova Piscina`,
"label_tabpage_newlybuildz":`Novo`,
"vue_label_helpcenter_report1":`1.Construir um relatório<br> O relatório Lightning no sistema de gestão de vendas Cloud CC é uma poderosa ferramenta de análise de dados. Muitos problemas de vendas podem ser resolvidos agrupando, filtrando e resumindo registos. Por exemplo: "Quantas receitas as novas oportunidades de negócio da empresa criaram no último trimestre?" Gráficos de relatórios podem ser adicionados com base no preenchimento da síntese de dados. Após a conclusão do relatório, clicar Run para ver os resultados completos dos dados. <br> Passo 1: No separador do relatório, clique em "Novo Relatório";<br> Passo 2: Seleccione a fonte de dados do relatório, e depois clique em "Seguinte";<br> A fonte de dados do relatório que escolher pode determinar quais os registos ou campos que podem ser utilizados no relatório. Seleccione ou procure por um objecto como objecto principal. Pode seleccionar até 4 objectos que tenham corelação com o objecto principal, e pode seleccionar a relação entre os objectos. <No modo de edição, pode personalizar o relatório, adicionar campos como colunas ao relatório, agrupar linhas e colunas, e utilizar filtros para filtrar os dados do relatório até que os dados necessários sejam exibidos com precisão<br>Adicionar ou remover colunas e ajustar a ordem<br>Adicionar coluna: No modo de edição do relatório, clique na caixa de entrada "Column" no "Summary" no lado esquerdo da página, e adicione colunas do relatório após pesquisar o campo ou percorrer a lista pendente de campos e seleccionar o campo de destino. <br> Remover coluna: <br> A. Depois de encontrar a "coluna" que deseja remover na lista "coluna" à esquerda, clique no "×" na caixa de campo. <br> B. Ou encontre a "coluna" que deseja remover no cabeçalho da visualização prévia do relatório à direita, clique no botão "drop-down", e clique em "apagar coluna".<br> A remoção da coluna do relatório não elimina o campo. Se desejar restaurar a coluna depois de a remover, basta adicioná-la novamente. <br> Ajustar a ordem da coluna: Arraste o campo "Column" (Coluna) na lista "Column" (Coluna) à esquerda, para cima e para baixo, para ajustar a ordem de disposição "Column" (Coluna). <br>Adicionar e remover o agrupamento de linhas e agrupamento de colunas<br> Adicionar agrupamento de linhas: Clique na caixa de entrada "Agrupar linha" no "Resumo" no lado esquerdo da página, e adicione campos de agrupamento de linhas de relatório para filtrar dados após pesquisar o campo ou percorrer a lista de campos drop-down e depois seleccionar o campo alvo. <br> Sem adicionar agrupamento de colunas, é possível adicionar até três agrupamentos de linhas. <br> Adicionar agrupamento de colunas: quando o agrupamento de linhas existe, é possível adicionar agrupamento de colunas. Clique na caixa de entrada "Coluna de grupo" no "Resumo" no lado esquerdo da página, seleccione o campo após pesquisar ou percorrer a lista pendente de campos e seleccione o campo desejado Formas de adicionar campos de agrupamento de colunas de relatórios para filtrar dados. <br> É possível adicionar até dois grupos de colunas. No caso de adicionar grupos de colunas, é possível adicionar até dois grupos de linhas. Os campos adicionados como grupos de linhas não podem ser adicionados como grupos de colunas. <br>`,
"label.notification.event1":`【分配人】 atribuiu-lhe um evento`,
"chatter.field":`Campo(s)`,
"chatter.feed.menutype.feed.newscom":`Tudo o que eu sigo`,
"label.attendance.range":`Gama de presenças`,
"vue_label_calendar_deleteconfirm":`Tem a certeza de que vai apagar o calendário {nome}`,
"label.ems.createTask":`Novo {tarefaNome}`,
"label.visualpage.wgd":`Páginas personalizadas não arquivadas`,
"label.multilang.product.deleterederect1":`A sua tentativa de apagar <font style="font-weight:bold;">{0}</font> não pôde ser completada porque ainda está associada com o seguinte registo. Neste caso, recomendamos a sua desactivação.`,
"label_emailtocloudcc_filed_servertype":`Servidor de Email`,
"label.umeng.insert.approval.dlsp.approvenew":`#actorname submete #objAPIName#recordname para a sua aprovação`,
"label.tabpage.queue":`Fila`,
"label.approval.step":`Etapas de aprovação`,
"label.approvaldatamove.approvalprocessname":`Nome do processo`,
"label.actualapprovedpeople":`Aprovador real`,
"label.systemlog.f":`FALHA`,
"front-template-V1-addText":`Adicionar texto`,
"label.chat.like":`Como`,
"label.userinfo.oldpwd.notnull":`A palavra-passe antiga não pode estar vazia.`,
"label.service.all.done.major.event":`Completou todos os marcos importantes.`,
"label_chatter_to":`Para`,
"message.toomuchlinecannotoutput":`Demasiadas colunas de relatório são seleccionadas e o relatório não pode ser produzido.`,
"maintenanceasset.assetid.maintenanceplanid.unique":`O plano de manutenção foi atribuído ao activo. Por favor, não atribuir repetidamente.`,
"lable.quote.syncing.firstsync.description":`Os itens da linha de citação substituirão os produtos de oportunidade`,
"lable.outlook.mcto.saveemail":`Não se esqueça de guardar os anexos do e-mail`,
"label.passwordPolicy.setup.pwdremember2":`2 palavras-passe lembradas`,
"label.project.hit.five":`Aviso de actualização de tarefas`,
"label.linkedin.setting.appid":`Chave secreta`,
"label.dataimport.error.name.notnull":`Erro: o nome não pode ser nulo`,
"label.knowledge.case.field.selected":`Campos de casos seleccionados`,
"label.version.datetime":`{0} campos de data/hora`,
"Dashboard_NoAccessRightToSee_Warning":`Não tem permissão para ver os dashboads {0} que estão definidos como defualt aberto, por favor reiniciar.`,
"label.login.access.permission":`Conceder acesso a`,
"label.operatedata.import.tip":`1. O ficheiro importado deve ser um ficheiro em formato CSV. O ficheiro tem de conter um título e não pode ser importado sem título. 2. Recomenda-se exportar antes de importar, recolher os dados que pretende importar para o modelo de dados com o documento de exportação, e depois importar.`,
"workflow.action.tasks.assignortype.rolename":`Nome do papel`,
"vue_label_account_quotations":`Transferir todas as cotações do proprietário do cliente`,
"lable.account.CurrentCQ":`CQ actual`,
"label.user.database.error":`Erro na base de dados!`,
"label_emailtocloudcc_titel":`Email para CloudCC`,
"label_file_content":`Conteúdo do texto`,
"label.button.behavior":`Comportamento`,
"message.recordtype.new.tip":`Introduza os detalhes`,
"label.ccchat.message.new.error3":`Erro: não se pode seleccionar mais de 9 destinatários`,
"vue_label_commonobject_notice_lessthanwords":`O nome do ficheiro deve ser inferior a {FILE_NAME_COUNT} palavras!`,
"label.stacked.verticalline":`Colunas Empilhadas-Verticais`,
"vue_label_SMS_messagebox":`Caixa de mensagens`,
"label.appexchange.installedpage.message3":`</b>Dependente dos links ao lado de um pacote instalado, pode tomar diferentes acções a partir desta página. Para apagar um pacote, clique em <b>Desinstalar</b>. Para gerir licenças de pacotes, clique em <b>Manage Licenses</b>.`,
"label.unusedapproveprocess":`Processos de Aprovação Inactivos`,
"label.onlywithspecificconditions":`Só devem ser incluídos no cálculo registos que satisfaçam determinados critérios`,
"lable.outlook.mcto.formaterror":`Erro de formato`,
"label.area.parent":`Território dos Pais`,
"vue_label_chat_activesuccess":`Activado com sucesso`,
"label.setting.intergrationlist.button.upgrade":`Actualização`,
"label.page_hidden":`Campos ocultos para a página de registo`,
"label.customsetting.manage.belong":`Configuração Proprietário`,
"label.appointment.wizard.subtitle4-2-8":`7 Dias`,
"template.chart.ydywjhxsje":`Montante mensal de vendas de oportunidades de negócio`,
"label.multilang.currencylist.after":`Depois de {0}`,
"vue_label_commonobjects_view_chart_countby":`Contar por`,
"label.week":`Semana`,
"label.emailtemplate.name":`Nome do modelo`,
"label.umeng.sign":`assinado em`,
"label.appupload.upload.details":`Detalhes`,
"label.file.loading":`Carregamento`,
"label.newdetail.orgTitle":`Papéis de contacto`,
"label.salescloud.field.addoptionlist":`Adicionar valores da lista de selecção`,
"pagecreator.page.funcpath":`/ construtor / lista de páginas`,
"Account.News.Setting.001":`Definições de conta`,
"label.marketsea.getnoconversiondays":`Dias não convertidos (devem ser mais do que o número de dias sem seguimento após a obtenção)`,
"message.error.event.add":`Nova anomalia de evento`,
"front-electronic-export-choseChimp":`Por favor, seleccione a lista Mailchimp exportada`,
"vue_label_report_personothers":`Outros`,
"label.hierarchy.diagram":`Estrutura Hierárquica`,
"label.stdashbord.xsld.business.yqsr":`Receitas esperadas`,
"label.chat.topic.max.count":`Atingiu o número máximo de tópicos.`,
"label.sendemail.send.sendfail":`O envio de e-mail falhou, por favor contacte o seu administrador.`,
"registration.page.body.title":`Página de registo`,
"label.userphoto.back":`Voltar`,
"label.service.without.timeslot":`Não parece haver qualquer espaço de tempo, vamos acrescentar!`,
"label.processsetting.remaining.quantity":`Podem ser introduzidos até 255 caracteres, permanecendo:`,
"label.sure.delete":`Confirmar para apagar`,
"front-epwechat-module-v1-callback":`Configuração de retorno de chamada`,
"front-email-payment-failed":`Desculpe, o pagamento falhou!`,
"label.icon.67":`Máquina`,
"UG_Forcast_01":`Previsão`,
"label.escalation.setup.newentries.step3":`Passo 3 Especificar como são definidos os tempos de escalonamento`,
"lable.account.NextCY":`Próximo CY`,
"report.type.label.quote":`Citações`,
"label.area.name":`Nome do território`,
"component.setup.label.object":`Objectos`,
"label.customsetting.type":`Tipo de configuração`,
"label.showdetail":`Mostrar Detalhes`,
"label.department.prev":`Página Anterior`,
"label.select.data.source.report":`Por favor, seleccione o relatório de fonte de dados`,
"UG_homepage_002":`Gerir as suas pistas, leads, funis de transacções de vendas, e informação de contas com ferramentas empresariais integradas`,
"vue_label_report_notice_exprot1":`Apenas as linhas de detalhe são exportadas. Utilizar estes dados para mais cálculos ou carregar para outros sistemas. Exportação por página, até 5000 itens numa página`,
"message.error.task.phonecreate":`Anomalia de criação de tarefas telefónicas`,
"label_chatter_day":`Dia`,
"label.setinitialcommiter":`Passo 6 Especifique os Submetedores Iniciais`,
"message.huanxinconfig.notfound":`A configuração Easemob não é encontrada`,
"label.customfields.file.count.tip":`Por favor introduza o número de ficheiros que podem ser introduzidos neste campo, o valor por defeito é 1`,
"label.weixin.appmanage":`Gestão de aplicações`,
"label.approverautoconfirm":`Aprovador Automático Determinado por`,
"vue_label_CCChat_followers":`Seguidores`,
"label.usermanage.notselect":`Nenhum utilizador é seleccionado.`,
"label.item":`Artigo(s)`,
"label.sendemail.chat.linkurl":`O URL da ligação:`,
"label.sendmail.step3.deliveroptions":`Opções de Entrega`,
"homepage.components.creationtime":`Data de criação`,
"label.pc.ui.2018.ccchat.setting":`Definição de CCChat`,
"label.knowledge.search.result.highlight":`Destacar Artigos Relevantes nos Resultados da Pesquisa`,
"label.data.downpage.e.title.num2":`2、If se optar por exportar dados de um único objecto, terá de seleccionar como os dados são exportados:exportação personalizada, exportação por modelo e modelo de exportação.`,
"label.field.duplicate.error.msg1":`Aqui estão os dados duplicados, verificar primeiro os duplicados, e depois configurar propriedade única.`,
"label.campaign.channel.input.number.error":`Erro de formato dos números`,
"label.goto.dashboard":`Ir para Painéis de Controlo`,
"com.cloudcc.login.error.message.invalid.ip":`O seu IP não se encontra na faixa de IP.`,
"label.selectnewfieldvalue":`Especificar novo valor de campo`,
"label.appointmentdetail.wizard.title11":`Data de fim`,
"Opportunity_Detailed_Phase_Label_Popup_001":`Data de Início da Etapa Actual`,
"front-dynamiclayout-module-v1-readonly":`O campo de {required} está definido como Read Only.`,
"vue_label_calendar_start_field":`Campo para começar`,
"label.weixin.recalculate.shared.failed":`O recálculo da regra de partilha de objectos falhou.`,
"label.sendmail.step3.dealoptions":`Opções de processamento`,
"setup_layout_label_modifypage":`Editar layout da página`,
"homepage.components.select.wide":`Seleccione Componentes Amplos para Mostrar`,
"label.import.page1.laststep":`Anterior`,
"label.weixin.donot.permission":`Não tem autorização para realizar esta operação.`,
"message.error.name.null":`o nome não pode estar vazio!`,
"label.salescloud.teamrole.optionlist":`Valores da lista de selecção de papéis da equipa`,
"component_setup_label_titlefield":`Campo de título`,
"vue_label_commonobjects_detail_have_been":`Tem sido`,
"label.textmessage.vonage.setup":`Configuração de Vonage`,
"label.recordtype.profile.enableit":`Habilitar para Perfil`,
"UG.product.04":`Criar produto`,
"label.knowledge.No.related.articles":`Nenhum artigo relacionado...`,
"label.chat.muted":`Não Perturbar`,
"registration.page.field.selection":`Seleccione o campo da página de registo`,
"label.project.hit.eleven":`Aviso de Atribuição de Emissões`,
"lable.newtabpage.advsearch":`Pesquisa Avançada`,
"label.report.share.roleandsub":`Papéis e subordinados internos`,
"component.salesperformance.label.nodata":`Adicione a sua oportunidade de negócio e volte aqui para ver o gráfico de desempenho.`,
"label.submitted_on":`Submetido em`,
"label.file.create.link":`Criar link`,
"label.contact":`Contactos`,
"label.tab.message.failtoopenleft":`A operação de fusão não conseguiu abrir a coluna da esquerda`,
"label.replaces":`Substituir`,
"label.customcomponent.check.tag.startwith":`Componente deve começar com o rótulo &lt;cc:component&gt;.`,
"label.tab.web":`Separadores Web`,
"message.success.task.add":`Salvar com sucesso a nova informação de tarefa`,
"label.chatter.addresser":`Remetente`,
"label.mobile.homepage":`Página inicial`,
"label.data.imp.su.ok":`Importação`,
"label.knowledge.category.hint.one":`O grupo de categorias é a hierarquia das categorias de dados. Por exemplo, um grupo de categorias denominado "Localização" pode conter a hierarquia geográfica do continente, país, região e estado. Utilize esta página para gerir grupos e sub-categorias de categorias.`,
"label.schedulejob.setup.schedule.weekly":`Semanalmente`,
"label.tag.manage.description":`Todas as etiquetas de {0} são as seguintes. É possível renomear ou apagar as etiquetas disponíveis.`,
"label.tabcontrol":`Tabs`,
"label.field.duplicate3":`Tratar "ABC" e "abc" como valores duplicados __(insensível a maiúsculas e minúsculas)`,
"label.customsetting.type.list":`Lista`,
"lable.account.ovdate":`Data final do Trimestre Fiscal`,
"label_chatter_pastSevenday":`Os últimos 7 dias`,
"front-kefu-moudle-v1-lxndxsdb-free":`Por favor contacte o seu representante de vendas e habilite o serviço de agente gratuito`,
"label.termsforusage":`Termos de utilização`,
"label.forecast.settings.qijian.m":`Previsão do mês`,
"label_tabpage_viewname":`Ver nome`,
"label.report.action.addtodashboard1":`Adicionar ao Painel de instrumentos`,
"label_vue_create_edit_obj_create_event_dialog_desc":`O utilizador que designou já está envolvido em horários:`,
"vue_label_report_standardfilter":`Filtro Padrão`,
"label.umeng.approval.submit":`#O requerente submeteu um registo #obj para aprovação.`,
"label.tab.mobile.sign":`Ícone do lado móvel`,
"vue_label_commonobjects_detail_check_the_content":`Há um erro de verificação, por favor verifique o conteúdo`,
"UG_Campaign_001":`Campanhas de planeamento`,
"chatter.group.baseInformation":`Informação básica`,
"label.sendemail.send.noreceiver":`Nenhum destinatário ou endereço de destinatário está vazio.`,
"template.chart.yskje":`Montante a receber`,
"label.textarea":`Área de texto`,
"vue_label_statistics_value":`Valor Estatístico`,
"font-evaluate-module-v1-select-img":`Seleccionar imagem`,
"label.totalof":`É um total de`,
"label.hangye":`Indústrias`,
"label.partner.common.setup":`Definições comuns`,
"label.icon.78":`Agricultura`,
"lable.outlook.detail.addemail":`Adicionar Email`,
"label.ServiceCloud.fuwuquyu":`Território de serviço`,
"label.gb2312encoding":`Chinês (GB2312)`,
"label.appointment.wizard.subtitle4-3-1":`10 min`,
"label_emailtocloudcc_reauthorization":`Reautorização`,
"label.approval.message":`Os pareceres de aprovação podem ser introduzidos até 1000 caracteres.`,
"label_component_helper":`Assistente`,
"label.editRate":`editar taxas de câmbio`,
"label.setuptemplate":`Modelos de automatização`,
"label_emailsync_button_cancel":`Cancelar`,
"label.marketseamemset.account.maxuser":`Número máximo de clientes`,
"label.someerror":`Por razões de segurança,a sua sessão CloudCC está prestes a esgotar o tempo.<br>>br>O que vai fazer a seguir?`,
"label_person_in_charge":`Supervisor`,
"label.visualpage.reference.standard.style":`Invocar o estilo padrão de Plataforma, estilo customiza-padrão`,
"errormessage_email_relatedorreceivermusthaveone_z":`Deve seleccionar um destinatário ou um assunto relacionado, pelo menos.`,
"label.insert.field.empty.continue":`Existem registos com valor nulo de 【{resDataField}】, pelo que o código não pode ser gerado. Quer continuar a gerar?`,
"component.newrecords.label.title":`Registos recentes`,
"template.detail_info_link":`Detalhes Ligação`,
"component_setup_tabs_label_default":`Página predefinida`,
"label.emailobject.template.name.null":`O nome do modelo de correio não pode ser empty！`,
"label.knowledge.field.changed":`{1} é alterado`,
"homepage.components.select.narrow":`Seleccione Componentes Estreitos para Mostrar`,
"label.mobile.phone.week":`Semana`,
"component_chatter_button_like":`Como`,
"label.brief.won":`Ganhou`,
"label.setup.profile.replaceme":`Substituir as coisas sobre mim`,
"label.knowledge.setting.enable.lightning":`Activar o conhecimento sobre relâmpagos`,
"label.middle":`Médio`,
"label.icon.109":`Pessoas`,
"vue_label_normal_activity_sf":`Actividade`,
"chatter.poll.option6":`Escolha 6`,
"label.lanxin.setting":`Integrar Lanxin H5 MiniApp`,
"label.stdashbord.xsld.business.totals":`Oportunidades totais`,
"label.emailobject.emaildetail.promptbutton1":`Confirme`,
"Opportunity.Detailed.Phase.Label.001":`Palco`,
"label.customcomponent.params.info":`Como utilizar os parâmetros.`,
"label.emailtocloudcc.button.next":`Próximo`,
"front-email-payment-billing-date":`Data de facturação`,
"label.ems.with3day":`Dentro de 3 dias`,
"label.project.subtask.date":`A data da sub-tarefa deve estar dentro do intervalo de datas da tarefa a que pertence.`,
"label.role.allunselectanduseduser":`Todos os Utilizadores Não Atribuídos e Activos`,
"front-kefu-moudle-yes-wantbuy":`Sim, quero comprar`,
"label.looking_for":`Conseguiu o que procurava?`,
"page.404.label.noresource":`Desculpe, o recurso a que pretende aceder não existe.`,
"vue_label_ccchat_notice_deletecommentcertification":`Tem a certeza de que quer apagar este comentário?`,
"label.data.setok.e.desc1":`Exportar com sucesso, receberá um sistema de alertas de mensagens,os dados derivados são temporariamente armazenados no servidor, o sistema apenas para poupar 48 horas, por favor, o mais rápido possível para`,
"label.weixin.confirm.delete":`Tem a certeza de que quer apagar estes dados?`,
"A":`Área de texto (rich text)`,
"template.report.sales.cycle":`Duração do ciclo de vendas`,
"label.service.shift":`Turnos de trabalho`,
"label.visualpage.display.side.bar":`exibir barra lateral,falso não exibir barra lateral`,
"label.list.userinterface.chatter.showall":`A página inicial do CCChat mostra todos os posts por defeito`,
"vue_label_systemSettings_set_course":`Configurar o caminho adicionando dicas para cada etapa para guiar os utilizadores passo a passo.`,
"label.icon.156":`Pessoas`,
"label.marketsea.button.move":`Mudança`,
"front-email-payment-select-email":`Por favor introduza o Código Postal`,
"front-electronic-signature-service-provider":`Prestador de serviços`,
"label.h5.add.checkin":`Fazer o check in`,
"vue_label_amount_total":`Montante total`,
"label.campaign.channel.new":`Campanhas: Novo Canal de Marketing`,
"label.knowledgebase.restore.creates.draft":`Restore irá gerar um rascunho a partir da versão actual. É necessário publicar o rascunho para que todos o vejam.`,
"UG_Case_01":`Caso`,
"label.validate.function.funcExplain.CONTAINS":`Verifique se o texto contém um carácter específico, e se assim for devolva VERDADEIRO, caso contrário devolva FALSO`,
"label.data.exp.savetemp":`Guardar como modelo`,
"front-project-module-v1-template-newcreate":`Criar Projecto a partir de Modelo de Projecto`,
"label.field.default.count":`Número de linhas por defeito`,
"page.note.acc":`Notas`,
"label.close":`Fechar`,
"label.app.detailbeforeedit":`Detalhes da aplicação personalizada abaixo. Clique em "Editar" para modificar as aplicações personalizadas.`,
"label.profile.standardfieldsafety":`Segurança de Nível de Campo Padrão`,
"vue_label_report_notice_deletefilter":`Por favor, elimine primeiro o filtro avançado`,
"label.multilang.datamoveaction.movesuccess":`Um total de {0} registos foram transferidos com sucesso! ：`,
"label.emailmerge.edittemplate.descirption":`Introduza informação sobre o seu modelo de fusão de correio.Note que a descrição é apresentada apenas em CloudCC.com, não em Word.`,
"label.visualpage.at.the.end":`Utilize a etiqueta no final`,
"label.exchange.sync.state":`Estado de Sincronia de Troca`,
"label.newdashboardpage.new":`Adicionar uma fila`,
"label.querydetailservice.profile.notsetup":`O perfil da sua conta não está definido.`,
"label.escalation.setup.detail.description":`Acrescentar entradas de regras que especifiquem os critérios utilizados para escalar os casos. Pode reordenar as entradas de regras nesta página depois de as criar.`,
"lable.setup.mobilesetup.isenbaleh5newandedit":`Se activar h5 no seu lado móvel e editar`,
"vue_label_file_upload_tip_msg":`Recomendamos que o ficheiro carregado seja inferior a 30MB, caso contrário pode fazer com que a página seja carregada lentamente`,
"label.eowechat.epdeptid":`Identificação do Departamento WeCom`,
"label.adminorapprover":`Administradores <forte>OR</strong> o aprovador actualmente designado pode editar registos durante o processo de aprovação.`,
"label_emailtocloudcc_email":`Email`,
"setup_main2018_label_norole":`Não tem as permissões administrativas`,
"label.onlyone":`Único`,
"label.sso.saml.idp.config.nameidtype":`Tipo de Assunto`,
"vue_label_normal_campaign_sf":`Campanhas`,
"label.icon.61":`Guindaste`,
"label.datatype":`Tipo de dados`,
"label.mobile.home.page.today.work":`Os meus empregos`,
"label.sendemail.chat.praiseFeedcommentsubject":`CloudCC CCChat gostou do seu comentário`,
"chatter.sel.p":`0 seleccionado.`,
"label.b_c":`Relação de B a C:`,
"label.tabcontrolnameandtaglib":`Nomes e Etiquetas de Separadores`,
"label.globaloperation.tip":`Criar, editar e visualizar operações globais, que podem ser utilizadas para páginas de detalhe.`,
"R":`Tipos de registos`,
"label.initcommiteoperate":`Acções de Submissão Inicial`,
"front-kefu-moudle-v1-Operation-without0-permission":`Sem permissão para operar este registo, por favor contacte o administrador`,
"button_partner_create":`Novo`,
"label.document.name.length.cannot.than":`O comprimento do nome do documento não pode exceder 255 caracteres.`,
"label.area.donot.delete":`Não pode eliminar este território, porque o território actual tem um sub-território.`,
"label.currency.activation":`Activar`,
"label.connect":`&Concatenate`,
"button.partner.viewdetail":`Ver`,
"setup_object_field_dependency_label_mustsetup":`Por favor, configure primeiro a dependência do campo e guarde.`,
"label.SalesCommitmentKanBan.task":`Montante da Tarefa de Recebíveis`,
"lable.quote.syncing.finishbutton":`Feito`,
"label.weixin.group.type":`Tipo de acesso`,
"vue_label_commonobjects_detail_relationship":`Grau de relacionamento`,
"vue_label_email_cc":`Bcc`,
"setup.object.field.dependency.label.fieldvalueoptions":`Valores de campo disponíveis`,
"label.sso.lookAtTheKey":`Ver chave`,
"UG.opportunity.008":`Equipa de oportunidade`,
"label.customfields.new.step1":`Passo 1 Escolha o tipo de campo`,
"lable.qrcodeOrbarcode.rule":`Gerar Regras do Código QR/Código Bar`,
"vue_label_notice_nopermission_delete":`Lamentamos que não tenha acesso para apagar este registo, por favor contacte o administrador.`,
"label.customerobj.tab":`Separadores de objectos personalizados`,
"com.cloudcc.login.error.message.nolicens":`A licença não existe`,
"label.sendsms.batch.confirm":`SMS em massa: Confirmar`,
"label.forecast.settings.sos":`Receitas e Quantidade`,
"label.calendar.addevent.notice.opencalendarfirst":`Por favor abra o meu calendário ou outros calendários antes de adicionar eventos`,
"message.success.task.phonerecord":`Guardar registos telefónicos com sucesso`,
"label.knowledgebase.create.new.subtab":`Novo Sub-tab`,
"label.knowledge.article.recordid":`O artigo de identificação do conhecimento não pode ser nulo`,
"Opportunity.Detailed.Phase.Label.Popup.003":`Dias no Estágio Actual`,
"homepage.layout.nowpage":`Layout de Página Existente`,
"template.chart.khslph":`Número de Contas Ranking`,
"front-epwechat-module-v1-android-single":`Android Single Sign On:`,
"serviceresource.assignedresource.islacksr.lack":`Não é possível eliminar o recurso de serviço por lhe ter sido atribuído um nomeador de serviço. Pode desactivar este recurso de serviço.`,
"label.email.only.display.info":`Apenas contactos ou colegas com endereços de correio electrónico armazenados são apresentados na caixa abaixo`,
"label.weixin..xsld.yjhtje":`Montante esperado do contrato`,
"label.permission.delete.permsets.error.prompt":`O conjunto de permissões não pode ser apagado porque tem utilizadores a ele atribuídos.`,
"label.ccchat.enter.two.choices":`Por favor, introduza pelo menos duas opções`,
"label.edit.field.select.style2":`Uma opção por linha`,
"vue_label_email_please_enter_email_subject":`Por favor introduza o assunto do e-mail`,
"batch.sendemail.f":`, o correio falhou.`,
"label.sms.senderr":`O envio de SMS falhou`,
"label.batchadd.newbatchpage.save.em":`Formato de e-mail inválido`,
"label.icon.96":`Bússola`,
"message.recordtype.deleterecord.tip":`Utilize esta página para substituir todos os tipos de pecord existentes por novos tipos de registos. Seleccionar o tipo de registo abaixo para reimplementar quaisquer registos que contenham os tipos de registos apagados. Se apenas desejar apagar o tipo de registo de um tipo de registo existente sem o substituir por um novo tipo de registo, seleccione "Nenhum".`,
"label.field.edit.max":`Pontuação máxima`,
"label.partnerCloud.orderingPlatform.preferential":`Desconto`,
"label.callcenter.login.later":`Entrar mais tarde`,
"batch.change.owner":`Por favor seleccione o proprietário`,
"label.version.allow.upload.size":`edição,arquivo de carregamento máximo permitido`,
"setup.mainpage.label.welcome17":`Definições de permissões`,
"label.tag.sectionname":`Informação da etiqueta`,
"label_partner_workspace_setup":`Definições`,
"label.managecontrol":`Permissões administrativas`,
"label.timetrigger.condition":`A condição de avaliação é definida para cada vez que o registo é criado ou editado.`,
"label.reportsSubscriptionPage.schedulereport.monthly.week":`Semana`,
"front-verkoop-bywerking-error":`Actualização falhada`,
"label.allowcommittercallback":`Permitir que os apresentadores apresentem pedidos de aprovação de retirada`,
"vue_label_commonobjects_detail_lead_finishistatus":`Marcar o estado como completo`,
"message.error.object.lookupmd":`o Campo de Relação Mater-Detail é criado neste objecto`,
"label.stdashbord.xsld.business.img7":`Número de Etapas com Probabilidade 0% / (Número de Etapas com Probabilidade 100%   Número de Etapas com Probabilidade 0%)`,
"label.checkruleofevent":`Regras de validação de eventos`,
"front-epwechat-module-v1-single":`Sinal Único Ligado`,
"label.tabpage.save":`Guardar`,
"label_emailtocloudcc_search":`Pesquisa`,
"label.tianyancha.h5.registeredPlace":`Local de registo(encurtamento)`,
"label.field.addoptionlist":`Acrescentar valor à lista de selecção: Lista de selecções`,
"label.schedule_anotherpost":`Planear outros Postos`,
"label.customfields.searchrelation.tip":`Cria uma relação que liga este objecto a outro objecto. O campo de relação permite aos utilizadores clicar num ícone de pesquisa para seleccionar um valor de uma lista popup. O outro objecto é a fonte dos valores da lista.`,
"label.partnerCloud.partnerAccount.prepaidPhone":`Recarga de conta`,
"label.projectManagement.view.details":`Ver detalhes`,
"label.sendemail.chat.praiseFeed":`Caro #nome:{\i1}nome: olá! #userName gostou do seu micropost.`,
"label.validate.function.category.Text":`Texto`,
"component.task.label.newevent":`Nova Tarefa`,
"label.data.import.setup.operate":`O que quer fazer se encontrar um registo existente?`,
"label.salescloud.salesdashboard.clear.option":`Opções claras`,
"lable.account.PreviousCY":`Anterior 2 CY`,
"label.appointment.wizard.subtitle8":`Nome da Empresa Visível para o Convidado`,
"label_emailsync_status_viewlog":`Ver Registo`,
"message.duplication.label.filtertitle":`Encontrar Filtros Duplicados`,
"label.custom.quarter.description":`Esta página permite-lhe definir e editar o trimestre personalizado. A data do trimestre personalizado será gerada com base nas escolhas que fizer abaixo.`,
"label_tabpage_filenamez":`Nome do ficheiro`,
"lable.currencyAdv.andbefordate":`e antes de`,
"label.version.nonsupport.sharerule":`As Regras de Partilha não são suportadas temporariamente.`,
"front-epwechat-module-v1-unbound":`Desobstruir`,
"label.division":`Divisão`,
"label.data.import.setup.repeat":`Quer evitar que sejam criados registos duplicados?`,
"label.callcenter.makesure.Amazon.connect":`Nota: Certifiquese de ter criado uma instância de Amazon Connect`,
"label.version.lead.control":`Gestão de Chumbo`,
"label.copying.reward.groups":`Grupo de Linha de Citação de Clone`,
"#label.severalorone":`Zip ou ficheiro individual#`,
"label.mailinginfo":`Endereço de correio`,
"component.telerecord.label.title":`Registar uma chamada`,
"label.godocumentlist":`Voltar à lista: Documentos`,
"APPIntegration.Dropbox.setting.01":`Habilitar`,
"label.tianyancha.website":`Sítio Web`,
"label_tabpage_greaterequalz":`Maior ou igual a`,
"vue_label_campaign_influencedopportunity":`Oportunidade de negócio influenciada`,
"message.save.param.null":`O parâmetro está vazio, salvo falha`,
"front-epwechat-module-v1-domain":`Nome de domínio de confiança  JSSDK：`,
"label.allowreport":`Permitir Relatórios`,
"label.service.major.event":`Marco histórico`,
"label.import.index.selectobjectandfiles":`Seleccionar objecto e ficheiro`,
"label.chatter.task":`Tarefa`,
"label.knowledge.setting.hint.twelve":`Introduzir categoria de dados`,
"lable.account.CurrentandPreviousFY":`Ano Fiscal Actual e Anterior`,
"label.martrixreport.step3":`Passo 3 Seleccionar os dados resumidos`,
"front-console-select-cases":`O número do processo seleccionado não pode exceder 10`,
"label.partnerCloud.partnerAccount.backHome":`Voltar à página inicial`,
"label.me.assign":`Atribuído por mim`,
"label.appointment.wizard.subtitle3":`Hora da reunião`,
"label.edit_columns":`Editar Colunas`,
"label.partnerCloud.orderingPlatform.useRebates:":`Use o Rebate:`,
"label.projectManagement.enter.up.to.10.digits":`Podem ser introduzidos até 10 dígitos.`,
"label.integrations.description.mailchimp":`Ao integrar o CloudCC com MailChimp, poderá importar leads e contactos seleccionados da sua conta CloudCC para MailChimp e enviar o e-mail para os destinatários pretendidos. Os seus utilizadores também poderão acompanhar os resultados no MailChimp.`,
"label.ccchat.person.error.requiredomain":`Erro: é necessário pelo menos um domínio`,
"label.projectManagement.Pleaseselectitem":`Por favor seleccione o projecto`,
"label.netaccess":`Acesso à rede`,
"vue_label_SMS_searchobject":`Pesquisar Objecto`,
"label.role.viewintree":`Mostrar em vista de árvore`,
"lable.SalesCommitmentKanBan.accountName":`Nome da conta`,
"label.please.contact.your.administrator":`Por favor contacte o administrador para activar as regras de geração de código QR/Código Bar`,
"label.sso.saml.sp.idenitysource":`SAML Localização de Identidade`,
"label.queue.delete":`Eliminar`,
"label.service.miniProgram.jumpLink":`Ligação de saltar`,
"label_set_ forecast_scope":`Estabelecer intervalo de previsão`,
"label.weixin.success.sign":`Conectou-se com sucesso,saiba, por favor.`,
"front-dialog-module-v1-error-code":`Código de erro`,
"label.projectManagement.nodata.problem":`Óptimo! Não é preciso resolver problemas complicados.`,
"label.myhomepage":`A minha página inicial`,
"label.exchange.sync.state.task.m1":`Última actividade sincronizada:`,
"label.pw.config":`Por favor, confirme a sua palavrapasse`,
"front-console-new-contact":`Novo Contacto`,
"label.customfields.fielddependency.editexplain":`<li>Clicar duas vezes numa célula para alternar a sua visibilidade para o valor do Campo de Controlo mostrado no título da coluna.</li><li>Para alterar várias células ao mesmo tempo, seleccionar várias células e depois clicar no botão Incluir Valores ou Excluir Valores para alterar a visibilidade de todas as células seleccionadas ao mesmo tempo.</li><li>Utilizar SHIFT   clicar para seleccionar um intervalo de células adjacentes. Use CTRL   clique para seleccionar múltiplas células que não são adjacentes.</li><li>Use o botão Preview para testar os resultados.</li>`,
"setup_mainpage_label_welcome7":`Instruções: Clicar no menu do lado esquerdo da página → Configurações da aplicação → Criar → Objecto → Nome do objecto → Campo personalizado.`,
"message.validation.sum":`Há demasiados campos mostrados na página de aprovação, é possível seleccionar até 190 campos.`,
"label.knowledge.attach.case":`Anexar ao caso`,
"front-electronic-signature-custom-field-type":`Tipos de campos personalizados`,
"vue_label_pricebook_activated":`A lista de preços é activada`,
"vue.schedule.pre":`Esta é a minha agenda, por favor`,
"Lead_Tools_BatchScoring":`Pontuação de Lotes de Chumbo`,
"front-lightning-module-v1-details-page-chart-screening-based-on":`Filtrar por`,
"label.report.no.recently":`Nenhum registo recente.`,
"label.service.gantt.dangerous.sum":`Número de nomeações de serviço em perigo.`,
"label.main.field":`Campo Primário`,
"label.weixin.optionfive":`Escolha 5`,
"homepage.wide":`Coluna Larga (direita)`,
"vue_label_notice_confirmdelatehomepage":`Está a mudar para eliminar a página inicial?`,
"vue_label_report_exportpages":`Páginas de exportação: Não.`,
"label.select_compaign":`Escolha uma Campanha`,
"attachment.button.massdownload":`Descarregar em massa`,
"label.chatter.incident":`Evento`,
"label_partner_new_step1":`Passo 1 Seleccione o modelo de que gosta`,
"button.partner.workspace.saveas.memo":`Guardar a actual nuvem de parceiros como "modelo".`,
"vue_label_pricebook_edit":`Editar lista de preços`,
"label.weixin.privacy.rights":`Privacy Permissions: Approximate location(web-based),Precise location(GPS).`,
"label.please.codeType":`Por favor, escolha o tipo de código.`,
"label.approveorrefuserequest":`Aprovar / Rejeitar`,
"message.error.sharemember":`O sharemember aprovado não pode estar vazio, por favor verifique os parâmetros aprovados!`,
"label.file.folder.edit":`Editar Pasta`,
"label.data.import.setup.repeat.yes":`Sim-Prevenir a criação de registos duplicados. Nota: Se quiser actualizar um registo existente, deve seleccionar esta opição.`,
"label.approveBeforeTheOperation":`Operar antes de aprovar`,
"vue_label_file_already_checked_file":`Foram seleccionados ficheiros {CheckedWork}, podem ser adicionados até 10 ficheiros de cada vez`,
"vue_label_hidden_record_count":`Contagem de registos ocultos`,
"UG_product_01":`Listar produtos/serviços`,
"label.tabpage.clearoptionsz":`Opções avançadas claras`,
"label.partnercloud.num.overstep":`O número máximo de nuvens de parceiros excedeu.`,
"label.tianyancha.businessverify.msg8":`Actualmente, esta função apenas apoia as empresas registadas para negócios na China continental, e tem um certo atraso.`,
"Lead_Scoring_DetailedPage_Popup_Title":`Insight de chumbo`,
"label.emailtocloudcc.email":`Email`,
"vue_label_pool_highcost":`Custo elevado do produto`,
"label.callcenter.enterprise.configuration":`Por favor copie o par chave na Interconexão do Sistema de Configuração Empresarial no sistema da Tianrun`,
"label.view.edit.search.prompt":`Por favor introduza as palavras-chave`,
"label.ems.sms":`Enviar um texto`,
"label.emailobject.list.new":`Compor`,
"label.salescloud.forenableteamsales":`Activar a equipa de vendas`,
"pagecreator.systemstyle.funcpath":`/ construtor / biblioteca de estilo de marca`,
"label.partnerCloud.basicSetting.domain":`O domínio de nível superior não pode estar vazio`,
"label.projectManagement.Posttask":`Pós-tarefa`,
"label.tianyancha.businessverify":`Permitir a verificação de dados comerciais`,
"label.tianyancha.h5.info":`Informação básica`,
"september":`Setembro`,
"chatter.poll.option9":`Escolha 9`,
"label.department.firstpage":`É a primeira página`,
"label.reportsSubscriptionPage.condition.button":`Adicionar Condição`,
"label.exchange.sync.state.task":`Tarefas`,
"pagecreator.layout.button.splitall":`Dividir tudo`,
"vue_label_calendar_please_select_the_start":`Por favor seleccione o campo para começar`,
"label.tab.message.failtogettop":`Falha em obter o separador superior`,
"label.sharerule.organizationscopesetshare":`Defaults de toda a organização`,
"label.delete.rules":`Eliminar Regras`,
"label.recordtype.tabname.detail":`Clique em "Editar" para alterar as propriedades deste tipo de registo. Seleccionar os valores disponíveis da lista de selecção para este tipo de registo, clicando no link editar na lista de valores da lista de selecção relacionada.`,
"label.knowledge.setting.hint.ten":`Incerto do modo de orgnização? Não há problema. Pode executar mais tarde.`,
"vue_label_norm_undone":`Esta operação não pode ser retirada`,
"label.trigger.line":`linha:`,
"lable.info.queue.reason":`Razão para se tornar um membro`,
"label.validate.function.funcExplain.HOUR":`Reutrn Retorna hora do dia(De campos de Data/Hora), variando de 0 -11`,
"label.update.document.content":`motificou o conteúdo do documento`,
"lable.Existing.template":`Modelos disponíveis`,
"label.summaryreport.step3":`Passo 3 Seleccionar o método de agrupamento de dados resumidos`,
"label.emailmerge.list.filetype":`Tipo de documento`,
"label.customfields.helptext.tip":`O texto é exibido na página de detalhes e na página de edição quando o utilizador paira sobre o ícone de informação junto a este campo.`,
"label.setting.intergrationlist.description":`As integrações CloudCC permitem-lhe visualizar e partilhar dados entre aplicações empresariais sem sair do seu CRM. Algumas das integrações, como QuickBooks e Zapier, requerem permissões para as tornar disponíveis aos seus utilizadores. Outras integrações, como o Gmail, o Outlook pode ser configurado por cada utilizador individual na sua própria conta.`,
"component_milestones_label_title":`Marco histórico`,
"label.custom.AntiRevocation":`Cancelar Desfazer`,
"label.mobile.app.new.task":`Permitir criar nova tarefa e evento na aplicação móvel`,
"vue_label_opportunity_related_chooseproduct":`Escolha pelo menos um produto`,
"label.standardguest":`Convidado padrão`,
"label.icon.125":`Instrumento`,
"label.skipsomeset":`Porque este é o Assistente de Início de Salto, o CloudCC escolhe automaticamente algumas definições para si.`,
"label.forecast.shrepage.fmanager":`Gestor de Previsões`,
"label.mobile.quickcreate.default.work":`Escritório`,
"label.projectManagement.nodata.team.members":`Não consigo encontrar o meu membro do projecto`,
"label_social_media_account_settings":`Configuração de conta nos meios de comunicação social`,
"UG.quota.05":`Bisync com Oportunidades`,
"label.partner.workspace.tab.selectedoption":`Separadores seleccionados`,
"front-kefu-moudle-v1-clientID-reinput":`Por favor introduza clientID`,
"label.mobile.home.page.contract.value":`Montante esperado do contrato`,
"december":`Dezembro`,
"label.campagin.roi.dcrs":`Presença`,
"label.currency.edits":`Edição Moeda`,
"label.currency.company":`Moeda da empresa`,
"label.customfields.newformula.nogrammererror":`Sem erros de sintaxe nos campos ou funções de fusão.`,
"label.version.nonsupport.api":`O Interfate API não é suportado temporariamente.`,
"label.data.file.i.title.num2":`2. Recomenda-se que os dados sejam exportados quando os dados são importados, para que o documento de exportação seja utilizado como um modelo para recolher os dados a importar, e depois importar. (Se os dados importados contiverem uma vírgula, substitui-la pelo símbolo @).`,
"front-console-conversation-title":`Avaliação de Serviços`,
"front-kefu-moudle-call":`Chamada`,
"vue_label_systemSettings_pagefooter":`Configuração do Rodapé`,
"label.newRule.successfully.added":`Novas regras acrescentadas com sucesso.`,
"label.trigger.direction.for.use":`Instruções para Accionadores de Plataforma [Versão 2.0]`,
"label.instrumentPanel.maxLabelname":`Este valor deve ser superior ao valor mínimo, o valor do ponto de quebra 1 e o valor do ponto de quebra 2.`,
"label.same.month.report":`Relatório YoY e MoM`,
"label.knowledge.language.american":`Americano`,
"label.paging.totalof":`Um total de {0}`,
"label.tianyancha.businessverify.enable.error":`Para saber se a verificação dos dados empresariais está activada, contacte por favor o administrador do sistema!`,
"vue_label_commonobjects_detail_email_template":`Use o modelo de e-mail`,
"message.error.save.failed":`Salvar failed！`,
"advancedoptions":`Adicionar Lógica de Filtro...`,
"setup_object_layout_message_selectedlayoutandrecordtype":`Por favor, seleccione o layout e o tipo de registo`,
"label.sendemail.recycle.operatesuccess":`esvaziou com sucesso o seu caixote da reciclagem, apagando os dados de tamanho #.`,
"J":`Área de Texto (Longo)`,
"message.validation.isnotmail":`Por favor introduza o endereço de correio electrónico inválido.`,
"label.timetrigger.before.lasttime":`1 hora antes da Data da Última Modificação`,
"label.tabpage.arecordtypez":`Tipo de registo disponível`,
"label.reportoption":`Opções de Relatório`,
"pagecreator.button.next":`Próximo passo`,
"assetbom.transferowner.notpermission":`Não tem autoridade para transferir lista técnica de bens. Por favor contacte o administrador.`,
"label.toptitle.lightning":`Relâmpago`,
"label.copy.target":`Valor do Indicador Clone`,
"label.productsales.oppor.approach":`Oportunidades iminentes`,
"label.email.template.select":`Por favor, seleccione um modelo de e-mail.`,
"label.edit.lower.bound.of.discount.per.tier.is.required.":`O limite inferior para editar cada nível de desconto é necessário.`,
"label.tabularreport.step3":`Passo3 Definir a ordem das colunas no relatório`,
"label.multilang.cchttpservice.signin":`Caro {0}, o seu convidado {1} de {2} foi registado com sucesso.`,
"label.appexchange.uninstallpage.message3":`Apagar permanentemente todos os dados dos objectos personalizados deste pacote`,
"label_tabpage_ownedz":`Totalmente`,
"label.tabularreport.2018.step2":`Passo 2 Seleccionar os critérios do relatório`,
"label.object":`Objecto`,
"template.report.contracted.customers":`Análise da Indústria de Contas Contratadas`,
"label.field.remark3":`Note-se que a eliminação de um campo personalizado irá eliminar quaisquer filtros que utilizem o campo personalizado. Também pode alterar o resultado das Regras de Atribuição ou Escalação que se baseiam nos dados do campo personalizado.`,
"label.eventview.issms":`Aviso SMS`,
"label.knowledge.language.brazilian":`Português (Brasil)`,
"vue_label_norm_viewfilter":`Aplicar um filtro`,
"label.forecast.settings.qijian":`Período de Previsão`,
"label.startuploadfile.step.intruduce":`Clique em "Seleccionar ficheiro" para encontrar o ficheiro e exibir os ficheiros seleccionados na região inferior.`,
"label.smstemplate":`Modelo SMS`,
"vue_label_chatter_no_permission":`Não tem acesso para ver este ficheiro`,
"label.callcenter.Incorrect.data.filling":`Há um erro no preenchimento dos dados`,
"label.tag.search.button":`Pesquisa por etiquetas`,
"label.multiplyselectoptions":`Opções da caixa de verificação`,
"lable.outlook.detail.mutual":`Bidirectional Sync`,
"label.workflow.estimatecondition1":`criado, e sempre que for editado para posteriormente cumprir os critérios`,
"label.validate.globalvariable.user.profileId":`Identificação do perfil`,
"UG.Campaign.003":`Criar uma campanha`,
"label.validate.function.funcExplain.ISNULL":`A expressão é nula e retorna VERDADEIRO, caso contrário, contém um valor e retorna FALSO.`,
"label.setting.intergrationlist.status0":`ESTATUTO DE INTEGRAÇÃO`,
"label.copy_error":`Falha na cópia`,
"label.connectOtherNone":`O objecto seleccionado não tem mais objectos relatáveis.`,
"label.bmap.beijing":`Pequim`,
"front-kefu-moudle-v1-hxzxybsc-again":`Easemob é apagado. Por favor, voltar a ligar!`,
"label.wei.pollsubject":`Votação Assunto`,
"APPIntegration_Social_twittererror":`Deve introduzir um URL válido para o twitter.com`,
"label.appupload.install.apicannotuse":`O nome api ainda não está disponível`,
"label.returntolist":`Voltar à lista`,
"label.translation.start2":`Seleccionar um componente de configuração.`,
"lable.edit.queue.alter":`Seleccione os objectos que deseja atribuir a esta fila.`,
"label.campaign.channel.step3":`Passo3: Seleccionar campos a mostrar na página de registo do canal de marketing`,
"label.data.newtemplate.e.seltype":`Seleccionar o método de exportação de dados`,
"front-kefu-moudle-hangup":`Desligar`,
"label.forecast.forecastroleuserpage.shre.managerandother":`Os administradores e os gestores das previsões podem partilhar esta previsão`,
"label.knowledgebase.mark.as.new.version":`Marcar como Novo Lançamento`,
"label.conditiontag.lookup":`Pesquisa`,
"label.import.page3.importsucceed":`Importar com sucesso`,
"label.stdashbord.xsld.condtion":`Configurações do estado`,
"label_emailtocloudcc_redmessage10":`A informação expirou, por favor faça novamente o login.`,
"label.event.moveup.1hour":`1 hora à frente`,
"label.chat.topic.page.add.favorite":`Guardar como favoritos na página do CCChat`,
"label.icon.88":`Consultoria`,
"page_404_label_noresource":`Desculpe, o recurso a que pretende aceder não existe.`,
"label.quickbooks.refresh":`Actualizar`,
"front-kefu-moudle-which-getphone-case":`Regras para a criação de casos após responder a uma chamada`,
"label.objecttab.edit":`Ficha Objecto Editar`,
"label.data.file.the.trigger":`Executar Trigger`,
"frame.personinfo.label.personimage":`Foto de perfil`,
"label_tabpage_turnoffsz":`Desligar - convertido`,
"label.sendmail.batch.chose":`Email em massa: Seleccionar Destinatários`,
"label.data.downpage.i_title":`Passos de Importação de Dados:`,
"label.recycle.clearconfirm":`Tem a certeza?`,
"chatter.using":`Este utilizadord`,
"label.batchadd.newbatchpage.list":`Lista de dados de adição em massa`,
"pagecreator.systemstyle.button.new":`Novo estilo`,
"label.notification.serviceappointment.changestate":`Estado de {1}{0} alterado para{2}{3}.`,
"label.weixin.weipollname":`Nome do Micro Voto`,
"label.tabpage.skip":`Saltar para`,
"label.edit.field":`Campos de edição`,
"label.edit.new.rule":`Editar Regras de Geração`,
"label.approved.receiveApprovalEmail":`Receber Emails de Pedido de Aprovação`,
"label.dashboard.refreshNow":`Actualizar agora`,
"label.lookup.introduce":`Por favor introduza pelo menos 1 carácter para uma pesquisa difusa.`,
"homepage.components.newdes":`Certifique-se de que o código HTML introduzido abaixo é válido e bem formado. A escrita de código HTML inadequado num componente ay faz com que todo o separador da página inicial seja exibido incorrectamente.`,
"label.role.giveuserrole":`Atribuir papéis aos utilizadores`,
"lable.opppdt.selPbk.subtitle":`Livro de preços`,
"setup_mainpage_label_welcome19":`Instruções:  Clique no menu do lado esquerdo desta página → Manage Settings → Manage Users → Users, Roles, Profiles`,
"setup.mainpage.label.welcome22":`Instruções: Clique no menu do lado esquerdo desta página → Manage Settings → Newsletter Template → Email Template.`,
"label.tianyancha.h5.zipcode":`Código Postal`,
"label_tabpage_allapplications":`Todas as aplicações`,
"label.chatter.like":`Como`,
"label.licence.noremainder":`Número insuficiente de licenças`,
"lable.outlook.edit.dataset":`Definições de dados`,
"D":`Data`,
"label.detail":`Leia`,
"label.globaloperation.operationtype.custom_page":`Página personalizada`,
"label.addattachment.down":`Descarregar o ficheiro`,
"label.data.exportall.all_btn":`Exportar todos os dados`,
"label.recordtypeselect.current":`Tipo de registo actual`,
"label.tabpage.entercusnamez":`Por favor introduza o nome do cliente`,
"label.location.valunit.km":`Km`,
"label.mobile.phone.week.plan":`Semana seguinte`,
"vue_label_report_everyday":`Todos os dias`,
"label.weixin.broadcasting":`Envio...`,
"label.input.search.string":`Por favor, introduza a cadeia de pesquisa`,
"label.picandreporttype":`Tipo de gráfico`,
"label.setmulti":`Transferência múltipla`,
"label.visualpage.component.t":`Como utilizar componentes?`,
"label.knowledge.designate":`Só pode ser atribuído um artigo de conhecimento com estatuto de Rascunho.`,
"label.enable.barcode.only":`Activar apenas o código de barras`,
"vue_label_commonobjects_detail_a_group_strategy":`Estes dados carecem de proprietário e não podem criar uma Equipa`,
"setup.layout.group.button":`Botões`,
"label.mini.layout.remark":`é o layout utilizado na janela de flutuação na página.`,
"setup.mainpage.label.welcome3":`A criação de formulários na plataforma cloudCC baseia-se em bases de dados personalizadas (objecto), os objectos definidos pelo utilizador são tabelas de bases de dados que armazenam dados específicos da sua organização. As relações tabela-a-tabela podem ser facilmente estabelecidas sem qualquer desenvolvimento de programa.`,
"label.knowledge.draft.status":`O estatuto dos artigos de pós-conhecimento será Rascunho!`,
"label.manageAll.sel.one1":`Itens a aprovar`,
"label.campagin.roi.bhydkhywjh":`Quantidade de Oportunidades Fechadas Ganhas`,
"label_partner_template_thumbnail":`Miniatura`,
"label.loginip.setup":`Login Gama IP`,
"label.data.downpage.e.title.e.btn":`Ir para a página de exportação e começar a exportar`,
"vue_label_appstore_project_management":`Gestão de Projectos`,
"assetbom.delete.notpermission":`Não tem autoridade para eliminar a lista técnica de bens. Por favor, contacte o administrador.`,
"vue.dashboard.setdrill.inThe":`sujeito a`,
"label.mobile.more.savephoto":`Guardar foto`,
"label.customerinfo.PageTriggerFag":`Tradução: Equipa PT-Subs`,
"label.commonobjects.Nopermission":`Desculpe, não tem permissão para editar estes dados, por favor contacte o administrador do sistema.`,
"label.searchlayout.opperationtab.xsldfield":`Os campos apresentados quando clica no link do Funil de Vendas na página inicial do separador de oportunidades.`,
"label.emailsync.form.disconnect":`Cancelar Conncet`,
"label.document.nofile.upload":`Sem carregamento de ficheiros.`,
"label.appointmentpage.wizard.subtitle3-3":`Telefone`,
"message.custom.field.donotdelete":`O campo é utilizado e não pode ser apagado.`,
"chatter.using0":`{0}ms tem sido utilizado neste momento`,
"label.tabpage.multiple":`Múltipla escolha`,
"label.attendance.setting.sy.alert":`Deve seleccionar os utilizadores adequados para o atendimento.`,
"label.refuse":`Rejeitar`,
"label.log.button":`pesquisa por nome de utilizador`,
"component_chatter_link_label_title":`Ligação`,
"template.report.contract.collection":`Pagamento do contrato`,
"label.campaignmember.selectmember.step1":`Passo 1 Seleccionar a campanha e o estatuto dos membros da campanha`,
"label.datamanage.warn.owner":`Aviso: se continuar esta importação, todos os registos serão importados consigo como proprietário dos registos.`,
"label.a.b":`Relação de A a B`,
"label.app.step3.homeisfrist":`A página inicial deve ser a primeira.`,
"UG_Lead_003":`Social`,
"label.partner.workspace.member.choice":`Seleccionar perfil`,
"lable.outlook.detail.emaping":`Campos de Eventos do Mapa`,
"label.service.appointmentList.gantt.chart.shows":`Data da exposição de Gantt`,
"label.mr.caption.account.result":`Encontrar duplicados e fundir: Resultados para consulta de duplicados de contas`,
"vue_label_chatter_approve_members_join":`Aprovar membros para se juntarem ao grupo`,
"label.reportsSubscriptionPage.schedulereport.monthly.day":`Dia`,
"pagecreator.systemstyle.label.modifycolor":`Editar cor`,
"label.tabpage.yesz":`Sim`,
"label.fieldtoolongmessage":`Campo excede o limite`,
"lable.account.year.name":`Nome do Ano Fiscal`,
"label.mini.layout":`Disposição do Hover`,
"label.icon.97":`Ensinar`,
"vue_label_chat_smart_assistant":`Assistente inteligente`,
"label.marketingmanagementuser":`Utilizador de Marketing`,
"label_emailtocloudcc_description2":`Ligue o seu e-mail`,
"label.campaign.channel.input.name":`1.Por favor introduza o nome do canal de marketing`,
"UG.homepage.007":`Desde o envio de e-mails de acompanhamento até à automatização de campanhas de vendas, desde a criação de fluxos de trabalho utilizando a nossa tecnologia Blueprint até à activação de macros personalizadas, automatizar tarefas diárias e concentrar-se mais na construção de relações.`,
"label.share":`Partilha`,
"label.step2.total6":`Passo 2 de 6`,
"label.sendemail.chat.addComentspraise":`Caro #nome:{\i1}nome: olá! #userName respondeu ao micropost que gostou`,
"label.icon.20":`Ficheiro`,
"label.service.gantt.absenteeism":`Absenteísmo`,
"message.error.color.nagatice":`O número de páginas actuais não pode ser negativo.`,
"chatter.group.applyToJoin":`Candidate-se a aderir`,
"pagecreator_layout_message_delete":`Apaga o esquema actual seleccionado?`,
"label.multilang.viewlist.count":`Um total de {0} records：`,
"message.notdesable.type":`Este tipo de registo não pode ser apagado porque o perfil seguinte utiliza este tipo de registo como valor por defeito.`,
"label.standard.time":`Tempo padrão`,
"label_chatter_newpost":`Último posto`,
"front-epwechat-module-v1-binding":`Bind WeCom`,
"label.recent":`Recente`,
"label.globaloperation.createfeeditem":`Criar um projecto de resumo`,
"label_partner_common_roleNum":`Número de papéis`,
"front-template-V1-quikSearch":`Introduza o nome do campo e encontre`,
"label_tabpage_haschangedz":`Este chumbo foi convertido`,
"label.service.work.order.line":`Itens de Ordem de Trabalho`,
"label.lead.score.ok":`OK`,
"Account_News_Setting_003":`Configurações Gerais`,
"label.event.moveup.15minutes":`15 minutos à frente`,
"vue_label_all_selected_objects":`Todos`,
"label.visualpage.an.inline.style.relatedlist":`Incorporar tipo de página personalizada a listas relacionadas`,
"label.umeng.approval.approvaling":`O requerente pede aprovação para #obj #objnome do #objnome do #proprietário`,
"lable.SalesCommitmentKanBan.digital":`Dígito`,
"label.appupload.img.max.size":`A imagem que carregou é demasiado grande, o tamanho máximo da imagem não deve exceder os 20K, por favor carregue novamente.`,
"vue_label_normal_top":`Início`,
"label.knowledge.language.traditional":`Chinês Tradicional`,
"homepage.layout.edit":`Editar layout de casa`,
"label.campagin.qrcode":`Código QR Campagin`,
"label.emailmerge.merge.emailmerge":`Fundir Email`,
"label.icon.18":`Relógio`,
"vue_label_homepage_taskview":`Vista de Tarefa`,
"label.search.related.record":`Não foram encontrados registos.`,
"label.report.reports":`Relatórios`,
"label.appointment.wizard.subtitle4-3-2":`15 min`,
"label.forecast.condition":`Critérios de Previsões`,
"label.westem.indonesia.time":`Hora da Indonésia Ocidental`,
"front-epwechat-module-v1-callback-desc":`Copie as seguintes informações para o backend da WeCom.`,
"label.version.group":`Edição de equipa`,
"label.allReportType":`Todas as fontes de dados de relatórios personalizados`,
"label.trigger.lastmodifydate":`Data da última modificação`,
"message.layout.unique.sectionfield":`A restrição de singularidade do campo na disposição da página foi violada. Por favor, verifique e guarde-o novamente.`,
"vue_label_systemSettings_mobelbottonsetting":`Configuração do Menu Inferior para aplicação móvel`,
"label.recordtype.selectonefield":`Seleccione pelo menos um campo que deseja adicionar`,
"label.notification.group1":`【申请人】 está a candidatar-se para se juntar ao seu grupo público`,
"component_todaytask_label_title":`Hoje`,
"label.assignment.setup.list.description":`Atribuir automaticamente leads aos utilizadores com base em critérios por si definidos. Pode criar várias regras com condições diferentes.`,
"label.project.resource.data":`Este recurso de serviço foi atribuído a uma marcação de serviço, por favor não adicionar repetidamente.`,
"label.emailmerge.newtemplate.file":`ficheiro`,
"label.notification.task1":`【分配人】 atribuiu-lhe uma tarefa`,
"label.ServiceCloud.Overlapping":`Despacho de Sobreposição de Exibição`,
"label.globalselect.used":`A posição da utilização do campo`,
"setup_layout_button_layoutprop":`Adequações`,
"label.quickbooks.retrivingdata":`Recuperar dados...`,
"component.button.ok":`Confirme`,
"message.pleaseinputformula":`Por favor, introduza a fórmula`,
"label.h5.whatifollow":`O que eu sigo`,
"label.new.crew.target":`Novo Objectivo do Pessoal`,
"label_chatter_task":`Tarefa`,
"label.knowledge.setting.data.four":`Podem ser seleccionados, no máximo, grupos de categorias {count}.`,
"label.rule.not.enabled":``,
"label_in_scope":`Dentro do intervalo`,
"label.partnerCloud.orderingPlatform.bundle":`Pacote`,
"label.emailtocloudcc.redmessage10":`A informação expirou, por favor faça novamente o login.`,
"label.knowledgebase.data.assignment.succeeded":`{a} dados atribuídos com sucesso`,
"vue_label_commonobjects_view_nokanban":`Ainda não foi criada uma visão kanban`,
"label.knowledgebase.article.cancelled.attaching.case":`O artigo {nome} foi cancelado para anexar a case！`,
"label.brief":`Resumo`,
"label.version.sum.app":`aplicações`,
"label.commoninfo":`Informação comum`,
"vue_label_SMS_nodata":`Sem dados`,
"label.icon.153":`Informação`,
"label.conditiontag.lookup.false":`FALSO`,
"label.emailobject.view.unread":`Emails não lidos`,
"label.staticresource.useful":`Onde é que isto é utilizado?`,
"label.ems.connect.test":`Teste`,
"vue_label_chat_group_assistant_notification":`Notificação de assistente de grupo`,
"label.multipleactivity.total":`Um total de`,
"vue_label_report_addtocomponentlibrary":`Adicionar à biblioteca de componentes`,
"font-evaluate-module-v1-following-personnel":`Notificar os utilizadores seguintes quando receberem avaliação inferior a 3:`,
"label.setup.mobile.bottombutton.change.fail":`Falha na mudança`,
"front-epwechat-module-v1-unbound-item5":`e os dados não podem ser recuperados, tem a certeza de que vai desvincular?`,
"label.customerinfo.smsUid":`SMS Gateway UID`,
"label.list.isOpenApprovalQueue":`Activar a Fila de Aprovação (não disponível em Aprovador de Selecção Manual)`,
"label.leadscore.setup.scorenumber":`Tempo(s)`,
"label.workflow.selectobj.introduce":`Seleccionar o objecto ao qual se aplica esta regra de fluxo de trabalho.`,
"label.visualpage.label.for.example":`Etiquetas de página, tais como:`,
"label.appointmentdetail.wizard.title17":`Plano de quinta-feira`,
"label.projectManagement.timeFrame":`A hora de início e de fim da tarefa deve estar dentro do intervalo de tempo do marco.`,
"lable.product.pricebooks.list":`O Price Book é uma lista de produtos com um preço especial e uma moeda definida. O Livro de Preços pode ser definido para múltiplas moedas. Ao introduzir um produto num livro de preços, as oportunidades ou cotações só podem incluir produtos num único livro de preços. Para editar o produto no livro de preços, clicar no nome do livro de preços.`,
"font-trade-module-v1-delete-invoice":`Verificar a factura`,
"vue_label_salesadvance_winamount":`Montante bruto de Won`,
"component.salesperformance.label.nopermission":`Para ver dados relacionados com oportunidades de negócio, contacte o administrador do seu sistema.`,
"vue_label_report_formatreport_desc":`Exportar o relatório com cabeçalhos de relatório, grupos, e definições de filtro.`,
"label.enable.qrcode.only":`Activar apenas o código QR`,
"label.smstemplate.edit":`Editar modelo SMS`,
"label.qrcodeSetting.detailed.information":`O código QR pode armazenar mais dados do que o código de barras e a leitura linear não é necessária. Assim, o código QR é amplamente aplicado, incluindo o rastreio de produtos, identificação de itens, gestão de documentação, e marketing, etc.`,
"label.event.moveup.1week":`1 semana à frente`,
"label.customize.memory.function.sorting.disable":`Desactivar memória de ordenação de cabeçalhos`,
"label.icon.195":`Banheira`,
"label.compact.layout.assign":`Atribuição de layout de informação chave`,
"label.icon.183":`Casa`,
"front-kefu-moudle-v1-jchxzxzi-chat":`Integrar o batepapo em linha de assento da Easemob para fornecer um serviço SaaS mais abrangente.`,
"label.mycontact":`Os meus contactos`,
"label.tabularreport.2018.step3":`Passo 3 Seleccionar os critérios do relatório`,
"chatter.group.uploadGroupPicture":`Carregar foto de grupo`,
"label.total.forecast.setup":`prever no início e defini-la como`,
"label.weixin.group.description":`Nota`,
"label.edit_emailfooter":`Editar Rodapé de Email`,
"label.ems.create":`Novo`,
"label.weixin.optionseven":`Escolha 7`,
"font-evaluate-module-v1-continue-work":`A sua avaliação encorajounos! Continuaremos os nossos esforços para fazer melhor!`,
"label.close.multilingual":`Desactivar Multilinguagem`,
"component.chatter.post.button.user":`Acrescentar pessoas`,
"label.use_QRcode":`Use o Código QR`,
"label.operatedata.exportsuc":`A exportação é bem sucedida. Por favor, veja o e-mail para obter o link de descarga. Por favor, descarregue os seus ficheiros exportados dentro de 48 horas. Recomenda-se que elimine o e-mail que contém o link de descarga dos seus ficheiros exportados.`,
"label.page.step2.define.content":`Passo 2 Definir conteúdo e propriedades de exibição`,
"label_tabpage_groupingitem":`Artigo de agrupamento`,
"label.customfields.placeholder":`Preencher a amostra`,
"vue_label_commonobjects_detail_enter_subject":`Por favor, introduza o tema`,
"label.multilang.workflow.everyotherdayinmonth":`{1} dias a cada {0} mês`,
"label.knowledgebase.data.archiving.failed":`{a} o arquivo de dados falhou`,
"vue_label_notice_nopermission_view":`Lamentamos que não tenha acesso para ver este registo, por favor contacte o administrador.`,
"vue_label_calendar_calendar_view":`Vista do calendário`,
"lable.outlook.edit.des":`Se um contacto Exchange corresponder a múltiplos contactos CloudCC.com, sincronize-o com um contacto CloudCC.com que preencha os seguintes critérios.`,
"label.custom.NextCQ":`Próximo CQ`,
"label.emailsync.form.stutas":`Estado`,
"label.nameandintro":`Nome e Descrição`,
"label.dashboardSetup.showdw":`Unidade de exposição`,
"label.tianyancha.actualcapital":`Capital recebido`,
"front-kefu-moudle-info-delete-calluser":`A informação foi modificada, por favor contacte o administrador`,
"label.emailobject.list.all":`Todos`,
"label.campaign.channel.step7.send":`Por favor, seleccione os utilizadores a receber correio electrónico`,
"label.formulafield.type":`Tipo de Retorno de Fórmula`,
"label.reportsSubscriptionPage.schedulereport.weekly.thursday":`Quinta-feira`,
"label.chosesubject.eat":`Jantar programado`,
"label.back":`Voltar`,
"label.h5.allcompany":`Todos os postos de nuvem`,
"label.location.display.type.digital":`Digital`,
"label.datamanage.error.csv":`Formato de ficheiro inválido, o sistema apenas suporta o formato CSV comum, por favor tente novamente.`,
"label.emailobject.mark":`Marca`,
"setup_mainpage_label_welcome9":`Os utilizadores podem realizar a exibição de classificação e o ajuste de layout de todos os elementos da página e a definição de campos só de leitura e obrigatórios dos campos da página, arrastando e largando o rato sem desenvolvimento de código.`,
"label.icon.56":`Instrumento de medição`,
"label.forecast.edit.fwcd":`Comprimento de alcance`,
"vue_label_email_Please_select_related_items_first":`Por favor, seleccione primeiro os itens relacionados`,
"label.icon.87":`Livro`,
"label.knowledgebase.recovery.was.successful":`A recuperação foi bem sucedida`,
"label.emailobject.emaildetail.promptcontent":`Tem a certeza de que quer apagar isto email？`,
"label.delete.role":`Apagar funções`,
"label.multiselect":`Lista de selecção (Multi-Select)`,
"label.customerinfo.mailisnull":`Não foi criado um endereço de correio electrónico da empresa.`,
"label.waitforamoment":`Carregamento da página, por favor aguarde...`,
"lable.edit.queue.tip":`Introduzir o nome da fila e o endereço de correio electrónico a utilizar ao enviar notificações (por exemplo, quando um caso foi colocado na fila). O endereço de correio electrónico pode ser para um indivíduo ou uma lista de distribuição. Quando um objecto é atribuído a uma fila, apenas os membros da fila serão notificados.`,
"lable.custom.y.d":`Esta página permite-lhe definir um registo anual personalizado. As datas para o ano personalizado serão geradas com base nas escolhas que fizer abaixo.`,
"chatter.feed.content.user.searchbutton":`Pesquisa`,
"label.data.downpage.i.list.desc3":`Os utilizadores podem ver a razão da importação falhada na última coluna do ficheiro após os downloads.`,
"label.tag.manage.createdby":`Criado por`,
"label.h5.similar.opportunity.last.months3":`Últimos 3 meses`,
"chatter.group.members":`Membros`,
"label.knowledgebase.data.translation.failed":`Traduzir {a] dados falhados`,
"label.log.look":`Verificar as pistas de auditoria de definições`,
"label.service.gantt.week.timescale":`Escala de Tempo na Vista da Semana:`,
"label.userLicence":`Licença de Utilizador`,
"label.file.library.managemembers.permission":`Acesso`,
"label_emailtocloudcc_name":`Nome`,
"label.mr.mrSuccess":`Fusão completa`,
"vue_label_commonobject_view_notice_selectadd":`Por favor, seleccione os dados a adicionar`,
"vue_label_commonobjects_detail_level":`Nível`,
"CloudCCCRM_ST_Info_TypeIn_001":`Por favor, introduza`,
"label_chatter_list":`Lista`,
"label_tabpage_optionsz":`Opções`,
"UG_homepage_008":`Compreender o estado actual do negócio (briefings de vendas, quadros de liderança, funis de vendas, etc.), visualizar oportunidades de negócio que possam ser problemáticas, prever o desempenho futuro, aceitar e atribuir atempadamente questões importantes, e tomar decisões informadas.`,
"label.myselfdashboard":`Os meus Painéis de Controlo Pessoal`,
"label.globaloperation.operationtype.record_phone":`Gravar telefone`,
"label.field.standard":`Campos padrão`,
"label.changemydisplay.appedit.check":`Sobreescrever configurações pessoais personalizadas de aplicações personalizadas`,
"label.tianyancha.h5.legalpersonnames":`Representante legal`,
"label.tabpage.sorttypez":`Tipo de ordenação`,
"label.newdashboard.folder":`Novo Dashboard Folder`,
"label.campaign.channel.step6":`Passo 6: Gerar página de registo do canal de marketing`,
"label.ems.composeemail":`Enviar e-mail`,
"label.app.step4.tabcanuse":`Separadores disponíveis`,
"label.sendmail.batch":`Email em massa`,
"label.process.execute.title":`Pendente`,
"lable.outlook.detail.lastup":`Última Actualização`,
"label_emailtocloudcc_delete":`Eliminar`,
"lable.opppdt.selPdt.leastone":`Por favor seleccione pelo menos uma fila`,
"label.customfields.new.step2.opration.exid":`Identificação externa`,
"label.assignment.setup.newrule.description":`Introduza o nome da regra, e depois seleccione a caixa de verificação activada para utilizar esta regra para atribuição automática. A activação desta regra irá desactivar a regra de atribuição actual.`,
"label.campaign.channel.input.to.isactivity":`7.Active o canal de marketing`,
"label.document.return":`Voltar aos documentos`,
"label.data.downpage.i_title.num5":`5. Verifica por favor a exactidão dos dados.`,
"label.taskinto":`As tarefas são os modelos que as regras de fluxo de trabalho utilizam quando se atribuem tarefas automaticamente aos utilizadores.`,
"label.customfields.formula.textexample":`Nome completo = Sobrenome`,
"label.appointmentpage.wizard.subtitle1-1":`Semana seguinte`,
"label.weixin.radio":`Selecção única`,
"vue_label_file_replace_reason_check":`Motivo da substituição (opcional)`,
"label.sendemail.recycle.operateexception":`esvaziar o seu caixote da reciclagem falhou, por favor tente novamente.`,
"label.vlidaterule.formulaerror":`Mostrar um erro se o Desconto for superior a 30%`,
"vue_label_campaign_existing_member_status":`Manter o estatuto de membro existente`,
"label.service.miniProgram.fillSlideshowName":`Por favor, preencha o nome do carrossel.`,
"label_partner_workspace_login_headerfooter":`Cabeçalho e Rodapé`,
"label.quickbooks.viewlist.total2":`Existem {0} estimativas para um valor total de {1}.`,
"chatter.viewingResults":`Ver Resultados`,
"label_tabpage_allvisible":`Todos os utilizadores são visíveis`,
"label.quote":`Citações`,
"label.changemydisplay.list.des":`Personalize os separadores de acordo com as suas necessidades`,
"label.leadscore.notimes":`Não há mais tempo para marcar pistas`,
"label.icon.51":`Geração de energia`,
"component.assistant.label.title":`Assistente`,
"label.emailobject.emailsent":`Email Sent！`,
"label.group.nofile":`Nenhum ficheiro foi enviado a este grupo.`,
"label.foldervisitlimit2":`Todos os utilizadores não podem aceder a esta pasta`,
"label.dataoperate":`Funcionamento dos dados`,
"label.addattachment.size":`Tamanho`,
"label.not.double":`Não são permitidos valores em duplicado.`,
"label.customfields.formula.number.tip":`Calcular um valor numérico.`,
"lable.opppdt.addpdt.table.description":`Descrição da linha`,
"label.sms.isactivity":`Activo`,
"label.campaign.channel.input.owner":`4.Quem será o principal proprietário deste canal:`,
"label.visualpage.notfound.error":`Ocorreu um erro desconhecido, por favor contacte o administrador.`,
"label.mr.title.button.group3":`registos`,
"label_tabpage_beginz":`Comece em`,
"label_tabpage_queue":`Fila`,
"label.tabpage.advancedscreening":`Filtro avançado`,
"nogreate":`menor ou igual`,
"chatter.fields":`Campos em`,
"button_partner_workspace_manage":`Gestão`,
"label.partnerCloud.orderingPlatform.search":`Pesquisar produtos`,
"message.password.isnull":`Por favor, introduza a sua palavra-passe.`,
"label.fenbeitong.title":`Cenário FenBeiTong`,
"label.salescloud.contactrole.message.chooseatleastone":`Por favor, seleccione pelo menos um contacto.`,
"label.knowledge.delete.election":`Erro ao apagar a selecção da categoria de dados`,
"front-console-status-hoided":`Colocação`,
"label.lastmodifydate":`Data da última modificação`,
"vue_label_chat_deleting_chat":`Depois de apagado, o histórico do chat será apagado e removido da lista da Equipa. Ao receber uma nova mensagem, ela aparecerá novamente na lista de Equipas.`,
"label.timeframe":`Prazo`,
"UG.opportunity.002":`Defina o seu ciclo de vendas, configure a fase`,
"label.templates.merge":`Por favor, seleccione os modelos a fundir. Pode ser seleccionado um máximo de 20.`,
"label.generatepage.c2":`O comprimento máximo é de 30.`,
"label.appointment.wizard.subtitle4-1-6":`2 h`,
"label.passwordPolicy.setup.pwdremember3":`3 palavras-passe lembradas`,
"button.partner.workspace.enable":`Activar a nuvem de parceiros`,
"vue_label_pool_nopool_notice":`Ainda não se juntou a nenhuma piscina, por favor contacte o administrador para criar ou juntarse a uma piscina.`,
"label.layout.required.field.select":`Campos obrigatórios seleccionados`,
"label.loginhis.date":`Digite a data de início e a data final.`,
"vue_label_commonobjects_detail_and_overdue":`Próximos e Vencidos`,
"label_tabpage_advancedsearch":`Pesquisa avançada`,
"label.custom.field.login.home.query":`Por favor, vá para a página inicial e veja os detalhes da tarefa.`,
"page":`Página`,
"label_tabpage_onlymevisible":`É apenas visível para mim`,
"label.weixin.optionfour":`Escolha 4`,
"label.confirm.to.remove":`Confirmar para remover`,
"label.event.moveup.30minutes":`30 minutos à frente`,
"label.mail.merge.template.finish":`Fundir os modelos de e-mail preenchidos`,
"label.multilang.currencylist.before":`Antes de {0}`,
"label.goback":`para ir ao anterior`,
"label.unknown.prefix":`Prefixo inválido, por favor reintroduzir.`,
"lable.account.CurrentandPreviousCYt":`Actual e Anterior 2 CY`,
"label.product.dent":`Introduza a sua palavra-chave e critérios de filtragem, depois clique em Pesquisar para iniciar a sua pesquisa. Clique em Mais filtros para utilizar mais do que um filtro. Os resultados da pesquisa incluem todos os registos que correspondem tanto à sua palavra-chave como às entradas do filtro.`,
"label.ems.bcc":`Bcc`,
"label.import.index.operation":`Operação`,
"label.knowledge.setting.hint.eight":`Mantenha tudo em ordem!`,
"label.sso.saml.sp.idtype.fid":`Assertion contém o ID da Federação do objecto do utilizador`,
"vue_label_chat_voice":`Voz`,
"label.config.pw":`Confirmar nova senha`,
"lable.newtabpage.closesearchresult":`Resultados da pesquisa de colapso`,
"lable.account.NextWeek":`Semana seguinte`,
"label.ems.username":`Nome de utilizador (u)`,
"vue_label_email_emails_from_potential":`Os e-mails de contactos e leads no seu CRM, e os e-mails que os contêm nos destinatários, serão categorizados aqui`,
"lable.approval.shared":`Quota de aprovação`,
"label.tabpage.allz":`Todos`,
"label.file.uploadfiles":`Carregar ficheiros`,
"label.emailobject.text":`Texto:`,
"label.version.allow.create":`Permitir criar novos`,
"label.empty.field":`O campo não pode estar vazio.`,
"label.emailsync.status.department":`Departamento`,
"label.pw.str":`5 caracteres`,
"label.attendance":`Presenças`,
"label_mobile_buttom_team":`Equipa`,
"label.campaignmember.main.addcontactdesc":`Acrescentar todos os contactos existentes a esta campanha`,
"label.search.result":`Resultados da pesquisa`,
"label.weixin.activity.account":`Convidados da actividade`,
"label_tabpage_clearoptionsz":`Opções avançadas claras`,
"UG.activity.01":`Como é que rastreia os seus registos para interagir com as suas contas/equipas?`,
"serviceappointment.new.status.limit":`Falha na criação de uma nova marcação de serviço com estatuto de agendado ou expedido.`,
"label.notice.higher":`Enviar Email ao Gestor`,
"label.passwordPolicy.setup.gletters":`carácter(es)`,
"label.data.exportsf.des":`Os ficheiros exportados com sucesso serão automaticamente apagados após 48 horas de poupança no derver.`,
"label.view.onlymecansee":`Visível apenas para<b> me</b>`,
"UG.Lead.005":`Caixa de correio`,
"label.umeng.approval.approvalfail":`submetida a faild.`,
"label.huanxinconfig.clientid.lost":`clientid não pode estar vazio`,
"label.campaignmember.main.updatecontactstatus":`Actualização de Contactos Existentes no Estado`,
"component_chatter_button_delete":`Eliminar`,
"label.weixin.no.pending.projects.qin":`Não há itens a aprovar.`,
"front-electronic-signature-auto-fill-field":`Campo de preenchimento automático`,
"message.resetpw":`Tem a certeza de que quer redefinir a sua palavra-passe?`,
"label.service.ganttBaiduMap.service.resourname":`Nome do Serviço de Recursos`,
"vue_label_pricebook_deleted":`Lista de preços eliminada`,
"label.icon.193":`Banheira`,
"label.validate.function.funcFormat.NOT":`NOT(lógico)`,
"label.address.city":`Cidade`,
"label.pc.ui.2018.searchs":`PESQUISA...`,
"label.yard":`Código de Convite`,
"label.data.downpage.i_title.btn":`Ir para a página de importação e começar a importar`,
"label.useablereceivers":`Recipientes disponíveis`,
"label.cloudccsite.name.length":`Permite aos utilizadores introduzir até 255 caracteres`,
"label.secrecy":`Confidencial`,
"label.campagin.roi.ydkhywjhzz":`Montante total de oposições fechadas`,
"vue_label_report_conditiondesc_one":`Com excepção da assinatura, pode estabelecer condições para este relatório. Será notificado se todas as condições forem cumpridas. Isto é opcional`,
"label.datamanage.select.contactfield":`(Seleccionar o campo correspondente ao contacto de importação)`,
"label.emailtocloudcc.filed.action":`Acção`,
"label.smstemplate.new":`Novo modelo de SMS`,
"label.mobile.side.tab.app":`Apps`,
"label.icon.118":`Relógio`,
"label.customfields.selectcontainfieldlayout.tip":`O campo será acrescentado como o último campo na primeira secção de 2 colunas destas páginas. O campo não aparecerá em nenhuma página se não seleccionar um layout. Para alterar a localização deste campo na página, terá de personalizar o layout da página.`,
"Lead_Homepage_Tools_BatchScoring":`Pontuação do Lote`,
"lable.quote.syncing.quote":`Citações`,
"pagecreator.button.preview":`Pré-visualização`,
"label.ccchat.am":`AM`,
"chatter.feed.menutype.user.nullrecent":`Nenhum registo recente`,
"lable.info.queue.showallmember":`Ver Membros em Fila`,
"label.multilang.campaign.selelctmember.desc":`Seleccione uma vista e seleccione o membro a acrescentar à campanha. O estatuto de membro é {0}.`,
"label.notification.ccchat3":`【评论用户名】commented no seu posto.`,
"UG.product.03":`Manual de preços com suporte multi-divisas`,
"label.sso.saml.idp.config.pksize":`Tamanho da chave`,
"label.defineCustomReportType":`Definir a fonte de dados do relatório personalizado`,
"component.timeline.button.filter":`Filtro`,
"label.mr.nextGroup":`Saltar o grupo e ir para o grupo seguinte`,
"label.quote.sprdz":`Endereço para facturação`,
"label.total.refuse.forecast.have.priority":`Recusar todas as prioridades da Previsão`,
"lable.product.peep":`Por favor, introduza um preço válido.`,
"label.file.who.can.access":`Quem pode aceder`,
"label.page.last":`Última página`,
"label.icon.180":`Pessoas`,
"font-evaluate-module-v1-enabled-successfully":`Activar com sucesso a opção de avaliação "Neural".`,
"label.appointment.wizard.subtitle4-2-2":`2 h`,
"label.passwordPolicy.setup.oneyear":`Um ano`,
"label.login.bound.mfadevice.title":`Activar dispositivos de AMF virtuais`,
"vue_label_dashboard_statisticalvalue":`Por favor seleccione o valor estatístico`,
"label.ishistory":`História`,
"component.timeline.label.title":`Linha do tempo`,
"label.page.step3.of.step5":`Etapa 3 de 5`,
"label.assignment.setup.detail.section":`Detalhe da Regra`,
"label.salescloud.opportunity.nothave.main.contactrole":`Nenhum contacto importante`,
"label.import.page1.limitedcsv":`formato CSV APENAS para carregamento de ficheiros`,
"label.icon.187":`Martelo`,
"label.emailobject.wizard.desc5":`Personalize a sua assinatura para que o seu correio fique melhor.`,
"vue_label_report_notice_copy_success":`Copie o relatório com sucesso!`,
"label.dupicatecheck.repeatcondition.chooserulemsg":`Não escolheu a regra da verificação em duplicado.`,
"label.componentEditor.upper.limit":`Até 100`,
"label.validate.function.funcExplain.ISNEW":`Verifique se o registo é novo, e devolve VERDADEIRO se é novo, caso contrário, devolve FALSO`,
"label.postalCode":`Código Postal`,
"label.dashboard.snapshot.enable.flag":`Habilitar instantâneos do painel de instrumentos`,
"vue_label_file_upload_type_size":`Apenas ficheiros {fileType} podem ser carregados, e não mais do que {tamanho}Mb`,
"label.appointment.wizard.subtitle3-6":`Sábado`,
"homepage.narrow":`Coluna Estreita (Esquerda)`,
"chatter.addmute.confirm":`Tem a certeza de que quer manter este posto "não perturbe"?`,
"label.lookup.account":`Pesquisar contas`,
"message.lostthemanager":`Esta submissão requer a aprovação do gestor do utilizador, e o valor do gestor do utilizador é nulo. Por favor contacte o seu administrador para saber mais.`,
"label.exchange.sync.state.contact.m3":`Registos sincronizados nas últimas 24 horas:`,
"label.version.phone.app":`Aplicação móvel`,
"label_tabpage_search":`Pesquisa`,
"vue_label_helpcenter_campaign":`Na informação detalhada, clique no botão do diagrama em árvore junto à campanha para ver o diagrama da estrutura hierárquica da campanha e compreender a hierarquia Pai-filho da campanha.<br>Gerir os contactos ou leads envolvidos na campanha através da lista relacionada de membros da campanha.`,
"front-lightning-module-v1-dashborad-last-year":`Ano passado`,
"label.campaign.channel.value":`Valores`,
"vue_label_opportunity_contactrole_primarycontact_notice":`Para seleccionar o seu contacto principal, guarde esta etapa e escolha entre a Gestão`,
"label.biaoqingfaxian.title":`Descoberta de Licitações e Concursos`,
"label.approved":`Aprovado`,
"label.hong.kong.time":`Hora de Hong Kong`,
"label.customfields.file.cannotopen":`Não é possível abrir o ficheiro`,
"lable.New.tips":`Clique em "Novo" para criar um novo modelo de relatório de serviço com base num modelo padrão ou em qualquer modelo seleccionado. Por favor, activar o modelo e começar a utilizar.`,
"component.setup.tabs.label.add":`Adicionado`,
"label.forecast.forehistory.replacebest":`Melhor Caso Anulado`,
"front-kefu-moudle-v1-jctrrt-call-serve":`Call Center Integrado com TRRT para Fornecer Serviços SaaS Mais Abrangentes`,
"label.workflow.configrule":`Passo 2 Configurar Regra de Fluxo de Trabalho`,
"label.dashboard.snapshot.refresh.frequently":`Snapshots do painel de instrumentos actualizam-se com demasiada frequência, por favor tente novamente mais tarde`,
"label.ems.editsetting":`Editar configuração de e-mail`,
"message.confirmdeleteAPP":`Tem a certeza de que quer apagar esta aplicação?`,
"label_chatter_activity":`Actividades`,
"label.editsharerules":`Regras de Partilha Editar`,
"label.loginservice.license.notuse.must":`A licença não está actualmente disponível,deve`,
"label.import.step2.beforeexport":`1、Before importando, certifique-se por favor de importar todos os registos relacionados. Por exemplo, se estiver a importar registos de contacto e quiser preencher o campo de conta, que é um campo de pesquisa, precisa de criar primeiro o registo de conta que está a preencher, depois importar o registo de contacto e preencher o campo de conta com o nome ou ID da conta correspondente.`,
"label.chat.mute":`Não Perturbar`,
"label.icon.128":`Casa`,
"label.give":`&&E`,
"label.hide":`Não Mostrar`,
"label.relationobject.wpr":`Aprovador Delegado`,
"label.summation":`Soma`,
"label.layout.availabletab.details":`Detalhes`,
"label.circle":`Mapa de Donuts`,
"vue_label_opportunity_contactrole_add":`Adicionar funções de contacto`,
"label.file.library.file2libsuccess":`Adicionado com sucesso!`,
"label.weixin.report.reportgenerated":`Relatório Gerado`,
"label.icon.91":`Pessoas`,
"report.label.pleaseinput":`Introduza o que pretende pesquisar`,
"label.escalation.setup.newaction.otheremail.tip":`Pode introduzir até cinco (5) endereços de correio electrónico para ser notificado. Cada endereço de correio electrónico é separado por ",".`,
"label.area.donot.have.data":`Sem dados`,
"label.customcomponent.btn.reference":`Referência Componente`,
"label.appointmentdetail.wizard.title7":`Tempo de Lembrete`,
"label.ccchat.with":`Ter`,
"label.file.size":`Tamanho`,
"label.product.sort.beyond":`Pode ser definido um máximo de 10 níveis !`,
"label.ccchat.2018":`CCChat`,
"label.report.select.column":`Seleccione as colunas`,
"label.appointmentpage.wizard.subtitle1_1":`Escolher data e hora`,
"label.passwordPolicy.setup.uppercasealpandnumsymbol":`Deve misturar números e letras maiúsculas e minúsculas, e caracteres especiais`,
"label_chatter_addressee":`Destinatário`,
"label.profile.remark2":`Se a sua organização utiliza Tipos de Registo, utilize as ligações Editar na secção Definições de Tipo de Registo abaixo para disponibilizar um ou mais tipos de registo aos utilizadores com este perfil.`,
"UG_Account_01":`Quem é a sua conta?`,
"label.dataimport.error.contact.notnull":`Erro: o nome do contacto não pode ser nulo.`,
"lable.account.CalenderQuarter":`Trimestre Calandra`,
"vue_label_commonobjects_detail_empty":`O preço de venda não pode estar vazio`,
"label.approveassigntemplate":`Aprovado para atribuir modelos de e-mail.`,
"label.objectRelationshipDescription1":`Esta fonte de dados do relatório irá gerar relatórios sobre`,
"vue_label_email_insertmergefield":`Inserir campo Merge`,
"label.mobile.home.page.check.team":`Equipa`,
"lable.edit.queue.edit":`Edição em Fila`,
"label.campagin.roi.query":`Ver ROI da campanha`,
"label.dataimport.field.allow.access.to":`Não é permitido o acesso aos campos de dados, por favor apagar manualmente o registo correspondente e tentar novamente.`,
"pagecreator.systemstyle.message.canntdelete":`O estilo actual não é permitido apagar`,
"label.searchkey":`Por favor introduza palavras-chave`,
"chatter.showall":`Mostrar tudo`,
"show":`Mostrar`,
"label.quote.choseproduct":`Seleccionar Produto`,
"label.report.selected.field":`Campos Seleccionados`,
"label.globaloperation.operationtype.create_data":`Criar registo`,
"label.knowledge.setting.data.seven":`Eliminar Grupo de Categorias: {flzmc}`,
"chatter.email.mentionOrMessage":`Menções ou Mensagens`,
"label_tabpage_exclusivez":`Excluir`,
"chatter.en.userinfo":`Introduza a informação sobre si.`,
"label.log.orgid":`Organização`,
"label.dataimport.insertdata.error.fieldrepeat.update":`O campo $schemefield_name$ no registo não pode ser encontrado na base de dados e não pode ser actualizado. O registo ignorou a importação.`,
"vue_label_chatter_add_link_success":`Adicionado link com sucesso`,
"label.sender_details":`Para adicionar novos detalhes do remetente, crie um utilizador no seu`,
"label.ccpeak.addwhere.condition":`Um critério "onde" pode ser acrescentado`,
"label.datamove.total":`Total`,
"label.tianyancha.businessverify.warning":`É favor notar que esta verificação apenas suporta os dados comerciais registados na China continental.`,
"label.emailmainbody":`Email do corpo`,
"label.justadmin":`Apenas Administradores`,
"label.data.downpage.e.list.desc1":`Esta página mostra ficheiros exportados com sucesso. Por favor, descarregue os ficheiros exportados a tempo de adicionar a gravação ao link de descarga no seu e-mail.`,
"label.reportsSubscriptionPage.email.value":`Valores Existentes`,
"message.error.serviceappointment":`Por favor, preencha a hora de início e a hora de fim programada na marcação do serviço.`,
"label.textMessageObject.selectone":`Por favor seleccione pelo menos um registo como destinatário da mensagem de texto`,
"label.schedulejob.setup.schedule.plan":`Horário`,
"label.assignment.layout.field.isassigned":`Atribuir de acordo com as regras de atribuição activas.`,
"label.captcha.error":`Erro de verificação!`,
"mobel_web_not_more_data":`Não há mais dados`,
"label.emailsync.form.emailaddress":`Endereço de correio electrónico`,
"label.loginservice.error":`Erro de login, por favor contacte o administrador.`,
"label.integrations.description":`Ligue a sua conta CloudCC a outras aplicações`,
"vue_label_homepage_notice_selectone":`Por favor seleccione pelo menos uma pista ou contacto`,
"label.chatter.default":`Por defeito`,
"label.tabpage.datefield":`Quando o campo de data é igual, pode usar o formato "ontem", "hoje", "amanhã", "mês passado", "este mês", "mês seguinte", "semana passada", "esta semana", "semana seguinte" ou "AAAA-MM-DD、MM/DDD/AAAAA".`,
"front-kefu-moudle-myzdhsc-file":`Ficheiro de registo não encontrado ou não gerado`,
"label.createname":`Criador`,
"label.mobile.phone.enter.plan":`Introduza o seu plano`,
"report.label.highlevelreport":`Relatórios avançados permitem-lhe criar as relações entre até 4 objectos.`,
"label.edit.select.label":`Modo de edição`,
"label.partnerCloud.financeSetting.deduction":`Após activação, os divertimentos serão adicionados à conta de descontos, rendimentos de descontos, e objectos de gastos de descontos. Os utilizadores parceiros podem utilizar a conta de desconto para deduzir o montante a ser pago.`,
"message.duplication.label.updateoption":`Acção sobre Actualização`,
"label.custom.CurrentCQ":`CQ actual`,
"front-kefu-moudle-wait":`À espera`,
"sunday":`Domingo`,
"label.service.timezone":`Fuso horário`,
"setup.layout.label.selectfield":`Seleccionar campos`,
"label_emailtocloudcc_filed_action":`Acção`,
"label.forecast.customforecast.mycommit":`O meu compromisso`,
"label.uploadsuc":`Upload com sucesso`,
"vue_label_commonobjects_view_notice_atleast1field":`Seleccionar pelo menos 1 campo de visualização`,
"label.dataimport.khmc.length":`Erro: o comprimento da conta é demasiado longo.`,
"label.isemailnotification":`Enviar Email de Notificação`,
"label.addAPPexchange":`Adicionar aplicações da CloudCC App Store`,
"label.partnerCloud.orderingPlatform.currency":`Moeda:`,
"UG_quota_02":`Fase de mudança de oportunidade`,
"label.customer.tab.step2.same.option3":`Separador Escondido`,
"H":`Telefone`,
"label_tabpage_searchz":`Pesquisa`,
"vue_label_homepage_deleted":`Eliminado`,
"label.weixin.recent.view":`Vistas recentes`,
"template.report.opportunity.sales":`Volume de Vendas de Oportunidades`,
"label.customfields.new.step2.opration.unique.info.v1":`Tratar "ABC" e "abc" como valores duplicados (insensível a maiúsculas e minúsculas)`,
"savesuccess":`Salvo com sucesso`,
"label.partner.workspace.member.memo":`Todos os utilizadores com perfil e permissão seleccionados podem aceder a esta nuvem de parceiros.`,
"label.icon.23":`Droga`,
"lable.batchadd.service.cfq.before":`Gatilhos (Antes de inserir)`,
"label.instrumentPanel.breakpointTwoLabelname":`Este valor deve ser maior que o valor mínimo e o valor do ponto de quebra 1.`,
"message.selectgsummaryinformation":`Por favor, seleccione os dados que deseja resumir`,
"label.tianyancha.businessverify.msg6":`Esta função utiliza serviços de terceiros e pode ter um desempenho instável ou um serviço impossível devido ao uso simultâneo elevado. O CloudCC não é responsável por qualquer responsabilidade.`,
"vue_label_helpcenter_report3":`3.A. Clique na caixa de pesquisa de campo, seleccione o campo que pretende pesquisando ou rolando pela lista de campos, seleccione o operador do campo, introduza ou seleccione um valor, clique em Aplicar e o filtro de campo entra em vigor. <br> B. Clique no sinal " " acima da caixa de pesquisa de campo e introduza a condição de filtragem avançada que consiste em números e letras na "Caixa de entrada da condição de filtragem". Por exemplo, (1 e 2) ou 3.<br>? Edit Filters<br> Para editar os filtros, inclua os filtros padrão, e clique nos filtros. <br>? Remover filtros<br> clicar no ícone "x" num filtro para o remover. <br>? Execute o relatório<br> Clique no botão Executar no canto superior direito da página de edição para ver os resultados completos do relatório. <br>? Guardar o relatório<br> Clique no botão "Guardar" no canto superior direito da página de edição, preencha o nome do relatório, seleccione a pasta do relatório e guarde-o. <br>2. Criar pasta de relatórios<br> Antes de criar uma pasta de relatórios, o sistema gera por defeito A Minha Pasta de Relatórios Personalizada e Pasta de Relatórios Pública Não Arquivada. <br> Passo 1: A partir do separador Relatórios, clique em Nova Pasta de Relatórios<br> Passo 2: No pop-up Nova Pasta de Relatórios, pode escolher transferir relatórios da pasta Relatórios Públicos Não Desarquivados para esta pasta. Pode seleccionar quais os utilizadores que podem aceder a esta pasta e os direitos de acesso. <br>3. Visualização de Relatórios<br> Passo 1: A partir do separador Relatórios, vá à página de listagem de Relatórios e encontre o relatório que pretende visualizar, alternando "Visualizado Recentemente", "Criei", "Todos os Relatórios", ou a pasta Relatórios. ou a pasta Relatórios para encontrar o relatório que pretende visualizar. <br> Passo 2: Clique no nome do relatório para ver o relatório. Ou clique no botão pendente na extrema direita do relatório e seleccione Executar para ver o relatório. <br>Se é um perfil de administrador, a partir do separador Relatórios, vá à página da lista de Relatórios e clique no ícone da engrenagem junto ao botão Nova Pasta para seleccionar os campos a exibir no cabeçalho da tabela da lista de relatórios em cada pasta. <br>4. Exportar Relatórios<br> Passo 1: Da tabulação Relatórios, vá à página de listagem de Relatórios, encontre o relatório que pretende exportar, e clique no botão pendente na extrema direita do relatório. <br> Passo 2: Seleccione o tipo<br> Formatar relatório: contém os cabeçalhos dos relatórios, agrupamento, filtragem de detalhes. <br> Relatório apenas com detalhes: Linhas de detalhes não formatadas. <br> Etapa 3: Clicar Exportar. O relatório apenas de detalhes precisa de ser exportado em páginas, com um máximo de 2000 dados por página.  `,
"label.batchdelete.success":`Eliminação em massa com sucesso`,
"label.newprocess5.seq":`Encomenda`,
"label.knowledgebase.data.translated.successfully":`Traduzir {a] dados com sucesso`,
"label_enable_range":`Activar o intervalo`,
"label.ccchat.and":`E`,
"label.assignment.setup.list.norule":`Não há regras especificadas.`,
"vue_label_report_summaryformulacolumn":`Coluna de fórmula resumida`,
"label.field.edit.change1":`A pontuação máxima não deve exceder 100`,
"syntaxerror":`Erro de sintaxe,verifique por favor os critérios que introduziu.`,
"label.icon.116":`Casa`,
"lable.asset.BOM.according.to.product":`Gerar lista técnica de activos de acordo com a estrutura do produto`,
"chatter.like.post":`as pessoas gostaram deste posto`,
"label.trigger.page":`Páginas de activação`,
"vue_label_email_contact_adminstrator":`O sistema é anormal, por favor contacte o administrador.`,
"label.workreport":`Notas de trabalho`,
"vue_label_homepage_edit_card_view":`Editar Vista de Cartão`,
"label_emailsync_status_disabel":`Inactivo`,
"label.icon.54":`Escavadora`,
"message.error.view.validerr.common":`A verificação falhou.`,
"label.exchange.sync.account.username":`Conta de serviço Nome de utilizador(Domínio Nome de utilizador ou UPN):`,
"label.dataimport.error.date":`Erro: Data:`,
"label.orgname":`Organização`,
"label.weixin.group.owner":`Proprietário`,
"vue_label_dashboard_colorrange":`Gama de cores`,
"label.forecast.shrepage.tableth":`Acesso Previsto`,
"label.related.disabled":`As listas relacionadas não estão activadas, por favor contacte o administrador do sistema para activar as listas relacionadas na disposição da página.`,
"label.version.product.management":`Gestão de Produtos`,
"label.knowledge.new.article.published":`O artigo é publicado como um novo artigo.`,
"label.sendsms.batch.step4":`Passo 4 Os seus SMS foram submetidos.`,
"vue_label_commonobjects_detail_and_tasks":`Parabéns, todos os eventos e tarefas são processados`,
"label.salescloud.ci":`tempo(s)`,
"label.ccpeak.getapi.name.time":`Se quiser utilizar os métodos da classe CCService, precisa de instanciar.`,
"label.escalation.setup.detail.conditon":`Critérios`,
"label.lbs.isUseLbs":`Habilitar Serviços de Localização`,
"front-lightning-module-v1-dashborad-color-depth":`Profundidade da cor`,
"date":`Data`,
"label.select.personnel":`Seleccionar Pessoal`,
"label.appointmentpage.wizard.notif3":`O e-mail é obrigatório!`,
"label.import.page1.pleaseselectwayofdealdata":`Por favor seleccione o modo de processamento`,
"label.partner.all.memo":`A lista mostra todas as nuvens de parceiros na sua organização. clique em url para iniciar sessão.`,
"label.appointment.wizard.subtitle4-3-3":`30 min`,
"component_telerecord_label_subject":`Assunto`,
"label.sendsms.batch.finish":`SMS em massa: Concluído`,
"label.login.access.myusername":`O meu nome de utilizador`,
"label.weixin.wechatnumber":`WeChat ID`,
"label.eowechat.status":`Estado do utilizador`,
"Lead_Scoring_Setting_Rule_Setup_Value":`Pontuação`,
"label.appexchange.oldreport.noupload":`Relatórios Antigos-Do Não Carregar`,
"label.approverfieldediting":`Campo de Aprovação e Registos Capacidade de Edição`,
"label_tabpage_customernamez":`Nome do cliente`,
"vue_label_dashboard_linkagesettings":`Definição da ligação`,
"vue_label_ccchart_notice_deletecomment":`Tem a certeza de que quer apagar este comentário?`,
"label.allprofile":`Todos os Perfis`,
"label.campaignmember.main.addMember":`Adicionar membros - Pesquisar`,
"label.projectManagement.subtask.list":`Lista de sub-tarefas`,
"label.code.some.size":`Capacidade de código: máximo 200KB caracteres, aproximadamente 20,0000 bytes.`,
"front-custom-service":`Service Cloud fornece serviços personalizados eficientes e ágeis aos clientes, reduz o tempo de resolução do serviço e aumenta as taxas de resolução com o sistema inteligente de ordens de serviço, melhora a lealdade dos clientes e aumenta as taxas de recompra.`,
"label.SMS.det":`Detalhes da Notificação SMS`,
"setup_layout_label_nobutton":`Sem botões disponíveis`,
"vue_label_email_Could_not_save_template":`Não foi possível salvar o modelo`,
"label.imgfield.height":`Altura`,
"label.leadscore":`Pontuação de chumbo`,
"setup_object_field_dependency_label_removefromlist":`Remover valores seleccionados`,
"message.error.code.null":`O código de autorização não pode ser nulo!`,
"label.tianyancha.businessscope":`Âmbito de negócio`,
"vue_label_chat_empty_message":`Mensagem vazia`,
"label.total":`Total`,
"label.delerror.list":`Lista de ficheiros não apagados`,
"label.selectedreceivers":`Recipientes seleccionados`,
"label.layout.availablepages":`Páginas disponíveis`,
"label.pc.ui.2018.personalinfo":`Informação pessoal`,
"label.chat.topic.edit.detial":`Editar detalhes`,
"label.mr.descreption.reDataList1":`Na consulta para satisfazer as condições de um total de`,
"label.document.value.too.long":`Este ficheiro tem um tamanho superior a 5M!`,
"lable.opppdt.addpdt.table.listprice":`Preço de Lista`,
"label.selectoperate":`Seleccione a acção`,
"label.icon.5":`Moeda`,
"label.icon.126":`Cama de hospital`,
"label.hiddensearch":`Pesquisa oculta`,
"label.view.sortview.exportble":`Exportável`,
"vue_label_homepage_noassignee":`Sem cessionário`,
"label.knowledgebase.close.and.resolve":`Fechado e resolvido`,
"label.licence.used":`Licenças usadas`,
"label.newprocessstep5":`Passo 5 Seleccionar Campos a Exibir na Página de Aprovação Layout`,
"vue_label_appstore_all_applications":`Todas as aplicações`,
"label.no.edit.permission":`Não é possível seleccionar. Não há permissão para editar os registos seleccionados.`,
"vue_label_calendar_calendar_added_successfully":`Calendário adicionado com sucesso`,
"report_line":`Campo de dados`,
"component.chatter.link.label.name":`Nome da ligação`,
"label.data.expnode.e_desc1":`1. Exportação personalizada: os utilizadores podem seleccionar campos a exportar e definir condições de filtragem de acordo com as suas necessidades.`,
"label.tabularreport.step4":`Passo 4 Escolha os critérios do relatório`,
"Opportunity.Detailed.Phase.Change.Text.001":`Estágio de Oportunidades de Mudança`,
"label.quickbooks.searchresault.action":`Acção`,
"component_timeline_label_today":`Hoje`,
"label.callboard.remark":`Por favor, introduza o anúncio da sua empresa abaixo.`,
"label.campagin.field.choose":`Seleccionar os campos a incluir na página de registo de membros da campanha`,
"front-gantt-module-rolling-temporary-tasks":`Passar para a tarefa temporária`,
"label.file.des":`Descrição`,
"Dashboard_View_RecentlyView":`Visto recentemente`,
"UG_Account_04":`Filtragem de contas de consulta passiva`,
"chatter.refresh":`Actualizar`,
"label.tianyancha.companyorgtype":`Tipo de empresa`,
"label.chatter.dateRange":`Intervalo de datas`,
"label.campagin.step3":`Passo 3: Gerar páginas`,
"label.appointmentdetail.wizard.title14":`Plano de segunda-feira`,
"setup.object.field.dependency.button.setdependency":`Configurações de Dependência de Campo`,
"serviceterritorymember.serviceterritory.isactive.notactive":`Este território de serviço não está habilitado. Só se pode adicionar membros sob um território de serviço habilitado.`,
"template.chart.ygydyj":`Empregado ganha desempenho de encomenda`,
"label.tag.edittags":`Editar Etiquetas`,
"label.clone":`Clone`,
"front-electronic-signature-setting-intro1":`Antes de vincular a sua conta, recomendase que primeiro se registe e autentique na plataforma DocuSign.`,
"label_reach":`Desempenho`,
"label.tabpage.havez":`Em anexo`,
"label.email.clearCase":`Apenas e-mails vazios não associados a casos`,
"label.customer.tab.all":`Todos os separadores`,
"label.direct.dashboard.day.report":`Nova Nota de Trabalho Diário`,
"label_tabpage_exportview":`Vista de exportação`,
"label.passwordPolicy.setup.maxFailTimes":`Máximo de tentativas de login inválido`,
"label.processsetting.complete.enable":`Completar e activar`,
"label.marketsea.memberfield":`Os campos podem ser viciados por membros`,
"label.report.export.format.title":`Relatórios de formato`,
"label.recycle.execute.title":`Limpeza do caixote do lixo da reciclagem.`,
"label.file.use.most.user":`Utilizadores com o espaço de armazenamento mais utilizado`,
"report_type_label_systemReport":`Relatórios do sistema`,
"label.customobjects.majorobject":`Objecto principal`,
"label.file.delete.public.link":`Eliminar a ligação pública`,
"front-epwechat-module-v1-id":`WeCom ID`,
"label.partner.common.roleNum":`Número de papéis`,
"label.sendtonextapprover":`Enviado para a Próxima Aprovação`,
"label.notification.tip3":`Carregar mais 10 Notificações`,
"label.tabpage.placeenterz":`Por favor, entre?`,
"label.mobile.phone.cc.people":`Cc`,
"component_setup_iframe_label_inputurlmemo":`Por favor, introduza a url da página a importar`,
"label.umeng.activity.statuschange":`O estado da tarefa que atribuiu a #name é alterado para #newstatus`,
"label.step3.restricted.visibility":`Passo 3 Restringir a Visibilidade`,
"label.multilang.datadelete.approvedata":`Registos a serem aprovados ({0}):`,
"label.reportsSubscription.save":`Guardar`,
"label.emailobject.template.visibility":`Visibilidade`,
"label_partner_step3":`Passo 3 Informação básica`,
"label.product.across":`Livros de preços cruzados`,
"label.same.analyze.opportunity.name":`Nome da oportunidade`,
"label.chatter.memotel":`Memo-telefone`,
"label.recentview.seloption2":`Criado recentemente`,
"label.ccchat.message.search.desc1":`Não conseguimos encontrar nenhuma notícia com`,
"label.reportexport":`Exportação`,
"label.service.gantt.drop.tip":`Permissão negada: Não tem permissões suficientes para operar. Por favor contacte o administrador.`,
"label.australian.westem.standard.time":`Hora padrão ocidental australiana （Australia）`,
"label.emailobject.email":`Email`,
"Homepage_Contract_FieldMissed_DoesntSupport":`Não existem campos "qdrq" e "htje" no objecto do contrato, pelo que os dados não podem ser mostrados.`,
"label.email.cancel.upload.info":`Isto irá cancelar o processo de carregamento em curso`,
"label.page.copy.merged.field.value":`Valor do campo de fusão de cópias`,
"UG.ST.006":`Entrar directamente`,
"label.trigger.service.connot.access":`Declaração inacessível`,
"label.projectManagement.new.tasks":`Nova Tarefa`,
"lable.SalesCommitmentKanBan.receiptsRate":`Taxa de conclusão dos recibos`,
"label.productsales.oppor.overdue":`Oportunidades vencidas`,
"vue_label_pool_convertedbyme":`Convertido por mim`,
"label.loginip.pagecue.invalidt":`O endereço de início da Internet está mais longe do que o endereço final da Internet ou o endereço inválido da Internet.`,
"label.campagin.roi.xyzj":`Resposta total`,
"label.visualpage.list.title":`Acesso à página personalizada activa`,
"chatter.feed.searchinitvalue":`Introduza o nome...`,
"label.export_submission":`Exportar Dados Submetidos`,
"this.season":`Este trimestre`,
"label.forecast.settings.gx":`Partilha de Dados Prevista`,
"label.tag.addtags.tagcolour":`Cor da etiqueta`,
"label.api":`Nome API`,
"label.bulk.delete":`Eliminação em massa (Permanentemente)`,
"label.reportsSubscriptionPage.condition.emailoption":`Opções de e-mail`,
"vue_label_dashboard_newdashboardsuccessfully":`Criar novo painel de instrumentos com sucesso`,
"three":`Três`,
"label.prompt":`Pronto`,
"label.same.analyze.contact.phone":`Móvel`,
"label.icon.62":`Gasoduto`,
"label.forecast.shrepage.tableth.isnable":`Permitir a submissão`,
"label.multilang.polloption.vote":`{0} bilhete(s)`,
"label.customfields.totalsummary.selecttotaltype":`Seleccionar Tipo de Roll-Up`,
"lable.SalesCommitmentKanBan.receivingCommitmentRate":`Taxa de Compromisso de Recibos`,
"label.areaAndSub":`Território e Sub-Território`,
"vue_label_pool_recycle":`Reciclar`,
"lable.outlook.detail.synset":`Definições de Sincronização`,
"label.quote.detail.introduce":`Introduza as palavras-chave, clique em "Pesquisar" para pesquisar, quando a pesquisa estiver concluída, clique em "Seleccionar" para saltar para o passo seguinte.`,
"label.profile.customappset":`Definições de aplicações personalizadas`,
"label.changemylanguage":`Mudar Idioma`,
"message.approval.plzcapppor":`Escolher aprovador`,
"vue_label_pool_operatecertification2":`{0}{1}{2}{3}？`,
"label.publiccalendarandresource":`Calendários e Recursos Públicos`,
"label.wtd.changefields.title.desc1":`Seleccione os campos a incluir no seu formulário Web-to-CloudCC, introduza o URL de retorno especificado, depois clique em "Gerar".`,
"label.weixin.voting.not.empty":`As opções de votação não podem estar vazias`,
"label.campaign.channel.equal":`Igual a`,
"label.emailobject.emaildetail.button.back":`Voltar`,
"label.ccchat.person.invite.allowemails":`Para segurança, introduza por favor o endereço de correio electrónico apenas terminado com o seguinte`,
"label.notEdit.message":`Desculpe, não tem acesso para editar estes dados, por favor contacte o administrador do sistema.`,
"label.layout.selectedfields.relatedlist":`Campos Seleccionados / Listas Relacionadas`,
"label.weixin.voting.deadline":`Prazo de entrega`,
"label.document.upload":`Ficheiro para carregar`,
"label.import.page2.notmatchfiled":`{csvfiledlength} campos no ficheiro no total. Os campos {difflength} estão por mapear.`,
"label.data.exp.selzippwd":`Se não preencher, não há password comprimida por defeito.`,
"label.user.step2.select.email.template":`Passo 2 Seleccionar o modelo de e-mail`,
"label.currency.effective":`Moedas Activas`,
"label.version.control.type":`Edição Organização`,
"label.projectManagement.Taskorproblem":`Tarefa/assessoria`,
"label.everyweek":`Semanalmente`,
"label.passwordPolicy.setup.pwdremember4":`4 palavras-passe lembradas`,
"label.emailobject.groupemail":`Email do grupo`,
"label.approvepagelayout1":`Todos têm a mesma disposição`,
"label.integrations.mailchimp.massage5":`Importe os contactos e leads seleccionados da sua conta CloudCC para o MailChimp e envie o e-mail para os destinatários pretendidos`,
"label.icon.22":`Acrescentar a`,
"Dashboard_View_All":`Todos os Dashboards`,
"label.import.page2.example":`Exemplo`,
"label.send.letter":`Enviar Carta Convite`,
"label.mobilesectionpart":`Parte móvel`,
"component_setup_tabs_label_title":`Paginação de separadores`,
"label.knowledgebase.results":`{a} resultados`,
"label.field.remark":`Esta página permite-lhe especificar os campos que podem aparecer no`,
"vue_label_systemSettings_url":`Configuração do nome de domínio`,
"vue_label_SMS_failed_find_view_list":`Falha em encontrar a lista de visualização`,
"setup_layout_label_order":`Ordenar por`,
"label.customsetting.touse":`Usar configurações personalizadas`,
"label.product.enter":`Introduzir palavras-chave para encontrar os produtos correspondentes.`,
"label.email.template.private.SMS":`Pasta Exclusiva de Modelos de SMS`,
"vue_label_homepage_chart_deleted":`O gráfico ou painel de instrumentos foi removido`,
"label.conversion_pages":`Página de Conversão`,
"label.compact.layout.select":`Seleccionar campos chave de layout de informação`,
"report_label_folderandreport":`Relatórios e Pastas`,
"label.product.entry":`Lista de Preços`,
"label.campaignmember.main.manageMember":`Gerir Membros`,
"front-QBtoCC-changing":`Actualização...`,
"vue_label_pool_abandonreason":`Motivo de descarte`,
"template.report.customer.contract.statistics":`Análise contratual das contas`,
"label.invoice.message.sendsuccessully":`Factura enviada com sucesso`,
"label.addcurrentoperate":`Adicionar Acção de Saída`,
"label.customerinfo.mailpwd":`Senha da caixa de correio`,
"batch.nochange.owner":`Sem permissão para mudar o proprietário do disco!`,
"label_tabpage_uploadfailez":`Upload falhou, por favor, reupload.`,
"vue_label_systemSettings_mobelqrsetting":`Configuração de digitalização de aplicações móveis`,
"label.regular_field":`Formulário Domínio`,
"label.tabpage.delsuccessz":`Eliminar o sucesso`,
"label.Days.Before.Horizontal.Date":`data de nível antes`,
"label.evaluation.general":`Está bem`,
"chatter.notlike.p":`Pare de gostar deste posto`,
"label.chatter.send":`Enviar`,
"label.emailsync.button.cancel":`Cancelar`,
"label.notification.task4":`A sua tarefa está prestes a expirar hoje`,
"vue_label_helpcenter_detail1.2":`Alterar rapidamente o estado da tarefa: assinalar a caixa de verificação em frente da tarefa no módulo "atrasada e próxima", e clicar no botão actualizar para alterar rapidamente o estado da tarefa para "concluída".<br> Antes de actualizar, cancelar a marcação e o estado da tarefa não será alterado.<br> As tarefas com alta prioridade serão marcadas com um ícone "bandeira vermelha" na linha de tempo da actividade.<br>A sequência de apresentação da linha temporal da actividade<br> Dispor em ordem inversa de acordo com a data de vencimento da tarefa, a data de vencimento da chamada registada, a data de início do evento, a data de envio e recepção de emails, e a data de envio e recepção de SMS. Se as datas acima forem as mesmas, serão ordenadas pela ordem inversa do tempo de criação do registo.<br>?Filtro da linha temporal da actividade<br> Utilizar os filtros na linha temporal do evento para restringir o âmbito dos itens visíveis, concentrar-se nos itens importantes, e encontrar itens alvo. O filtro da linha do tempo inclui três tipos de filtros: intervalo de datas, actividade a ser exibida, e tipo de actividade.<br> Actividades a exibir: todas as actividades, as minhas actividades<br> No filtro da linha do tempo do evento, esta opção pode reduzir o intervalo de exibição do evento.<br> As minhas actividades: Mostrar as actividades em que participou, quer como proprietário quer como participante. Por exemplo, é o proprietário que envia e-mails ou organiza eventos. Por exemplo, quando é o destinatário do campo Cc ou Bcc do e-mail, significa que está a participar no evento.<br>`,
"component_chatter_post_label_title":`Publicar`,
"label.data.dataexptemplate.desc":`O modelo de exportação de dados criado pelos utilizadores é utilizado para exportar dados, e pode tornar a exportação de dados mais conveniente.`,
"label.helptext":`Texto de ajuda`,
"vue_label_norm_removecomponent_certify":`Confirmar componente de eliminação`,
"front-template-V1-Click-new-template":`Clique em "Novo" para criar um novo modelo. Activar e começar a utilizar este modelo`,
"label.optional_fields":`Campos opcionais`,
"label.delete_about":`Vai apagar`,
"chatter.feed.initvalue":`Em que está a trabalhar?`,
"label.mail.configure":`Configure o seu endereço de correio electrónico pessoal para poder enviar e receber mensagens na página principal de correio electrónico da CloudCC, e sincronize o seu histórico de correio electrónico com os contactos e contactos.`,
"label.project.hit.seven":`Lembrete de expiração de tarefas`,
"label.button.upgrade":`UPGRADE ou CHANGE EDITION`,
"lable.PowerProcess.event.name":`Nome do marco miliário`,
"label.weixin.confirm":`Confirme`,
"label.customfields.new.inputformula":`Introduza a fórmula`,
"label.standard.buttonandlink.edit":`Substituir Botão ou Ligação Padrão`,
"workflow.action.tasks.assignortype.createdtype":`Tipo de Criador`,
"front-email-payment-paypal-describe":`Clique em "Continuar", pode entrar no sítio Web do PayPal ou criar uma conta PayPal para completar o pagamento da factura.`,
"label.selectexistingoperate":`Seleccionar Acções Existentes`,
"label.workflow":`Fluxo de trabalho`,
"label.assignment.setup.detail.ruleentries":`Entradas de Regra`,
"label.data.file.i.title.num3":`3.O sistema lê previamente o ficheiro de dados para o servidor, depois inicia o importador de massa back-end, cujos resultados serão notificados aos utilizadores por correio, e não terá de esperar nesta página.`,
"label.use.view":`Utilização Vistas Existentes`,
"label.forecast.settings.moren":`Família de produtos por defeito`,
"vue_label_calendar_add_share":`Adicionar parte`,
"label_tabpage_newview":`Criar uma nova visão`,
"label.recycle":`Contentor da reciclagem`,
"UG_solution_03":`Criar uma solução`,
"label.customfields.formula.text.tip":`Criar uma cadeia de texto, por exemplo, através da concatenação de outros campos de texto.`,
"vue_label_file_single_file_size":`Máximo suporte de ficheiro único`,
"label.a.b.least":`Cada registo "A" deve ter pelo menos um registo "B" relacionado.`,
"label.validate.function.addtoformula":`Inserir Função Seleccionada`,
"label_tabpage_pleaseSelectz":`Por favor seleccione`,
"label.account.NextFQ":`Próximo FQ`,
"label.project.project.name":`O nome do projecto não pode ser repetido.`,
"label.emailtocloudcc.filed.owner":`Proprietário`,
"label.textmessage.template.message2":`O campo inserido no e-mail actual não corresponde ao registo associado, o que pode causar valores nulos.`,
"label.icon.92":`Livro`,
"label.trailerpage":`Página da cauda`,
"component_event_label_noevent":`Parece que completou o seu trabalho hoje.`,
"label.trigger.tip":`Sobre Gatilhos`,
"label.knowledge.case.field.usable":`Campos de casos disponíveis`,
"label.group.isusing.success":`Activar com sucesso`,
"label.marketsea.nextnotfollowdays":`Desde o último seguimento`,
"component.todaytask.label.choicestate":`Seleccione o estado`,
"label.recordtype.main":`--Master--`,
"label.sendletter.step1":`Passo1: Especificar os destinatários dos convites`,
"label_tabpage_saveviewfailed":`Ver salvar falhou`,
"vue_label_report_notiec_selectone":`Cada registo de objecto pai deve ter pelo menos um registo de objecto relacionado`,
"UG_opportunity_003":`Acompanhe os seus canais de venda, crie painéis de controlo`,
"#label.importsourcestep4":`Passo 4 Importar os seus ficheiros#`,
"front-kefu-moudle-v1-trrt-tip":`É necessário associar os utilizadores (agentes de serviço ao cliente) às extensões do TRRT para obter a função de "Click to Dial".`,
"UG.Forcast.09":`Próximo passo`,
"label.ggReleaseRange.subordinates":`Procurar papel e subordinado`,
"label.log.desctiption":`Pode descarregar o rastreio de auditoria que contém mais informações (ficheiro Excel.csv).`,
"label.submitted":`Submetido`,
"label.validate.function.funcExplain.BEGINS":`Verifica se o texto começa com caracteres especificados, e se assim for devolve VERDADEIRO, caso contrário devolve FALSO.`,
"label.campaign.channel.code":`Canal de Marketing Código QR`,
"chatter.group.theLastActivityDate":`Data da última actividade`,
"vue_label_dashboard_pleaseenterabreakpoint2value":`Por favor introduza um valor de ponto de quebra 2`,
"label.labeltranslation":`Traduzir rótulo`,
"label.multilang.product.deleterederect":`A sua eliminação de {0} não pôde ser concluída porque ainda está associada a registos em outros livros de preços. O registo associado é o seguinte.`,
"lable.currencyManage.manageRate.dis":`Para gerir taxas de câmbio para outros objectos, para adicionar novas moedas, para activar ou desactivar moedas, ou para alterar a moeda corporativa, clique em Gerir Moedas.`,
"setup.layout.label.modifypage":`Editar layout da página`,
"label.import.page2.editforname":`Por favor edite a cartografia para o campo {necessaryName} .`,
"label.searchlayout":`Layouts de pesquisa`,
"label.chatter.loadmore":`Carregar mais`,
"label.trigger.folder.all":`Todas as Pastas de Gatilho`,
"label.export_submissions":`Submissão de Formulários de Exportação`,
"lable.SalesCommitmentKanBan.allsignedTaskRate":`Taxa total de conclusão da tarefa assinada`,
"KeyInformationLayout_DefaultLayout_Name":`Default do sistema`,
"label.h5.chatter.great":`como(s)`,
"label.call.center.configuration.enable":`Utilize as seguintes definições para activar a função de Chamada ao Centro da sua organização`,
"label.overdate":`Data de fim`,
"chatter.poll":`Sondagem`,
"label.login.input.verification.code":`Por favor introduza o código de segurança:`,
"label.file.sharetype.cooperation":`Colaborador`,
"label.app.step5":`Passo 5 Atribuir a Perfis`,
"front-gantt-module-save-order":`Guardar a encomenda`,
"label.globalselect.toallrecord":`Adicionar novos valores de lista de opções a todos os tipos de registos que utilizam este conjunto de valores globais`,
"setup.mainpage.label.welcome24":`A plataforma CloudCC fornece definições de acesso de segurança para todos os dados dos objectos no sistema. A partilha de dados e os direitos de acesso podem ser controlados através da definição de várias regras e condições.`,
"homepage.layout.desctiption":`Esta página permite-lhe criar diferentes layouts de separadores para o separador Home.`,
"vue_label_SMS_notice_send_sussess":`SMS Enviados`,
"label.projectManagement.overdue":`Vencido`,
"label.assignment.setup.list.lead.description":`Atribuir automaticamente leads aos utilizadores com base nas regras de atribuição de leads definidas por si. Pode criar várias regras com condições diferentes.`,
"label.list.projectSetting.des":`Deseja enviar e-mails nas definições abaixo:`,
"setup.mainpage.label.welcome18":`As definições de permissões de nível empresarial do CloudCC permitem-lhe controlar os direitos de utilização de utilizadores individuais enquanto trabalha com dados e módulos. As definições de permissões baseadas em funções incluem também posições de utilizador, grupos, funções, regras de partilha de dados, e controlos de segurança a nível de campo para permitir a partilha de dados entre diferentes pessoas e departamentos da empresa.`,
"label.ratio":`YoY e MoM`,
"label.Xaxis":`Eixo X`,
"label.google.map":`Mapa Google`,
"Dashboard.SelectBoardToDisplay":`Por favor seleccione os painéis de bordo que deseja mostrar na página de separadores dashborad`,
"label.data.newtemplate.e_conditions":`Condições de exportação`,
"label.emailtocloudcc.description3":`Ligue a sua conta de correio electrónico empresarial, tal como sales@company.com, info@company.com, support@company.com. Registe automaticamente os e-mails que recebeu como leads e registos de casos no CloudCC para assegurar um acompanhamento atempado das cartas dos clientes.`,
"label.page.select.profile":`Escolher os perfis de utilizador para os quais o novo separador personalizado estará disponível. Pode também examinar ou alterar a visibilidade dos separadores a partir dos detalhes e editar as páginas de cada perfil.`,
"label.chosen.button":`Botões seleccionados`,
"front-epwechat-module-v1-info":`Informação de retaguarda da WeCom`,
"label.translation.select":`Critérios de filtragem`,
"ten":`Dez`,
"label.barcode":`Código de barras`,
"lable.product.nextdel":`Continue e apague o record， mostrado ou clique`,
"label.default":`Por defeito`,
"label.chatter.theme":`Tópicos`,
"vue_label_commonobjects_view_split_screen_view":`Vista de ecrã dividida`,
"label.ems.myemails":`Os meus e-mails`,
"label.email.clearPersonalEmail":`Quer esvaziar todos os e-mails sincronizados a partir da caixa de e-mail pessoal?`,
"label.login.access.admin":`O Administrador da sua empresa`,
"label.emailobject.wizard.desc":`Depois de ligar a sua conta de email no CloudCC, pode enviar email directamente do CloudCC enquanto os liga automaticamente a contactos, oportunidades e contactos relacionados. O histórico de comunicação está claramente organizado por linha temporal.`,
"label.passwordPolicy.setup.minpwdlength":`Comprimento mínimo da palavra-passe`,
"choserow":`Escolher colunas a expor`,
"front-epwechat-module-v1-role-binding":`Funções de encadernação`,
"lable.outlook.edit.newdata":`Tem a data de criação mais antiga`,
"label.schedulejob.setup.schedule.enddate":`Data de fim`,
"label.quickbooks.view":`Ver`,
"font-evaluate-module-v1-not-inform":`Notificação`,
"chatter.poll.option3":`Escolha 3`,
"setup_layout_label_selectfield":`Seleccionar campos`,
"label.partner.common.roleSetup":`Função do parceiro e definições do utilizador`,
"label_partner_new_step3":`Passo 3 introduzir nome e url`,
"label.transfer":`Transferência`,
"label.bmap.myaddress":`A minha localização`,
"label_tabpage_individual":`Escolha individual`,
"label.autoRegister.changepwd.setpwd.repassword":`Por favor, introduza novamente a palavra-chave`,
"vue_label_commonobjects_detail_and_before":`Anteriormente`,
"front-kefu-moudle-v1-single-Login-area":`Nome de domínio com um único sinal`,
"label.replacedocument":`Substituir Documento`,
"label.validate.function.category.Logical":`Lógica`,
"label.companyprofile.syncsuccess":`Sync Sucesso`,
"template.chart.rwzthyxj":`Assunto e Prioridade da Tarefa`,
"label.product.clearcondition":`Condições claras`,
"component_task_label_person":`* Pessoa designada`,
"label.tabpage.as":`Como`,
"message.error.calendar.add":`O calendário já foi adicionado`,
"label.marketsea.isrecycleleadcreatebyself":`Quer reciclar chumbo auto-construído`,
"label.icon.57":`Barómetro`,
"UG.Lead.010":`Ou`,
"setup_object_field_dependency_label_configured":`Layouts de página atribuídos ao Perfil`,
"label.tianyancha.regnumber":`Código registado`,
"front-kefu-moudle-v1-Opened-chats":`Activar o Chat`,
"label_tabpage_converstatez":`Estado convertido`,
"label.bmap.beijing.haidianqu":`Rua Shangdi 10, distrito de Haidian, Pequim`,
"label.startimport":`Iniciar Importação`,
"label.knowledgebase.application.default.settings":`Ajuste por defeito da aplicação do relâmpago`,
"lable.account.year.custom":`Anos Fiscais Personalizados`,
"label.event.nextmonth":`Próximo mês`,
"label.email.body":`Corpo`,
"setup.object.field.dependency.label.mustsetup":`Por favor, configure primeiro a dependência do campo e guarde.`,
"label_tabpage_multiple":`Múltipla escolha`,
"label.task.this.month":`Este Mês`,
"label.customfields.formula.moneyexample":`Margem Bruta = Montante - Custo__c`,
"label.tonewemailnotice":`Seleccionar o objecto para esta tarefa e clicar em Seguinte. As tarefas só podem ser associadas a regras de fluxo de trabalho e processos de aprovação do mesmo tipo.`,
"setup.mainpage.label.welcome11":`Relatório personalizado`,
"label.layout.availabletab":`Separadores disponíveis`,
"label.data.importef":`Importação de Ficheiros Falhados`,
"label.appupload.upload.alert":`Estas definições determinam que requisitos devem ser cumpridos para instalar este pacote.`,
"label.sales.accountteam.shared":`Partilha de contas pela equipa`,
"lable.currency.addexchageRate":`Adicionar taxas de câmbio`,
"label.page.simplified.chinese":`Chinês (Simplificado)`,
"label.service.dispatchingUnits.search.service.area":`Pesquisar território de serviço`,
"lable.list.queue.name":`Nome da fila`,
"pagecreator.button.save":`Guardar`,
"label.ccpeak.support.function":`Apoiar todos os tipos de funções de forma única`,
"label.tianyancha.legalpersonid":`Identificação de pessoa colectiva`,
"label.sendemail.chat.addPostmainPage":`Caro #nome:{\i1}nome: olá! #userName posts na sua página inicial do CCChat.`,
"batch.no.change":`Nenhuma permissão para transferir os dados.`,
"label.the.referenced":`invocado em`,
"label.input.webtab.information":`Preencher informação sobre o separador web.`,
"vue_label_systemSettings_subscription":`Tipo de Assinatura`,
"label.login.access.title":`Acesso à conta de concessão Login`,
"label.schedulejob.setup.schedule.lastday":`o último dia`,
"label.synchronize.department":`Sincronizar utilizadores`,
"label_tabpage_lessequalz":`Menos ou igual a`,
"label.file.library.successmanagemember":`Salvo com sucesso`,
"label.service.major.event.oreder":`Sequência`,
"label.desktopintegration":`Integração do ambiente de trabalho`,
"label.a_b":`Relação de A a B`,
"every":`Cada`,
"label.tabpage.bar":`Bar`,
"label.filecontentsnotnull":`O conteúdo do ficheiro não pode estar vazio.`,
"label.layout.detailoftestobj":`Detalhes do objecto de teste`,
"label.summaryreport.2018.step3":`Passo 3 Escolher cabeçalhos de coluna`,
"UG.Lead.002":`Há muitas maneiras de identificar "pistas" para o seu produto ou serviço.`,
"label_partner_workspace_member_selectedprofile":`Perfil seleccionado`,
"label.newdescription":`Nova nota`,
"vue_label_normal_moveup":`Subir`,
"label.mobile.quickcreate.default.logacall":`Histórico de chamadas`,
"userterritory.serviceterritory.user.unique":`A este utilizador já foi atribuído este território de serviço. Por favor, não o reatribua.`,
"label.weixin.record":`Registo`,
"front-kefu-moudle-connecting":`Ligando`,
"label.monitorsys.recent.operation.log":`Registo de operações recentes`,
"lable.outlook.detail.lmaping":`Campos de chumbo do mapa`,
"lable.account.year.ovdate":`Data de Fim do Ano Fiscal`,
"vue.homepage.auditcard.record":`{registoTotal} registos`,
"label.processsetting.delete.process.succeeded":`Apagar processo com sucesso!`,
"label.customerinfo.smsPwd":`Palavra-passe do SMS Gateway`,
"label.tolead.object":`Objectos de importação`,
"label.data.downpage.i.list.desc2":`Após a importação dos dados, receberá um e-mail lembrando-o da importação com sucesso.`,
"label.sharerule.ruletype":`Tipo de Regra`,
"label.reportsSubscriptionPage.email.toothers":`Enviar-me a mim e a certos grupos de utilizadores`,
"label.emailobject.templates":`Modelos`,
"vue_label_checkduplicate_":`Análise de colisão`,
"label.campaign.channel.lookup.example":`Ver Amostra`,
"label.login.verification.please.note":`Por favor note:`,
"label.version.charge":`Carga`,
"label.ccdocument.show.trace":`Mostrar vestígios`,
"label.sendemail.approval.submit":`Olá, #nome:\n #actorname the #objLabel-#recordname submitted by #actordate is waiting for your approval. please click the following link or log in to the crm system to enter the approval center for approval:\n #path#appPath/query.action?id=#recordid&m=query\n#orgName`,
"setup.mainpage.label.welcome12":`O utilizador pode completar a definição do relatório clicando no rato, sem programação, e seguindo os passos rápidos do sistema. O sistema tem um relatório de lista, um relatório de resumo e um relatório de matriz para escolher. Estão também disponíveis opções de visualização para todos os campos. Remover informação desnecessária do campo. Ao mesmo tempo, fornece uma variedade de exibições gráficas incluindo tiras, linhas de dobra, anéis, funis, e bolos, para que os utilizadores possam ver num relance.`,
"UG_contact_06":`Contactos de importação`,
"message.success.event.add":`Salvar com sucesso novas informações sobre eventos`,
"report.line":`Campo de dados`,
"label.approvepagelayout2":`Todos têm um layout diferente`,
"vue_label_normal_contract_sf":`Contrato`,
"label.tabpage.tpcustomersz":`Converter pistas`,
"label.ccchat.message.new.error5":`Erro, a sua mensagem não pode exceder os 10000 caracteres.`,
"label.severalorone":`Ficheiro individual`,
"pagecreator_systemstyle_label_buttonfontcolor":`Texto do botão`,
"label.customer.tab.step3.introduce":`Escolher as aplicações personalizadas para as quais o novo separador personalizado estará disponível. Também pode examinar ou alterar a visibilidade dos separadores a partir dos detalhes e editar as páginas de cada aplicação personalizada.`,
"chatter.group.groupEdit":`Edição de grupo`,
"label.partnerCloud.partnerAccount.spending":`Despesas de Rebate`,
"label.slip":`item)`,
"label.field.master.class":`O nível de relação de detalhe principal está para além do nível 3`,
"label.sendemail.chat.addComentsmyFeed":`Caro #nome:{\i1}nome: olá! #userName respondeu ao seu micropost.`,
"label.service.ganttBaiduMap.selectingDispatchTime":`Seleccionar Intervalo de Despacho`,
"label.knowledgebase.remove.article":`Tem a certeza de apagar os arquivos do formulário do artigo?`,
"label.appupload.notmanaged":`Incontrolado`,
"label.report.goto.step":`Ir para o Passo`,
"label.publicgroup.save.mustbeselect":`Deve seleccionar os membros`,
"label.data.expnode.e.desc2":`2、Export por modelo: os utilizadores podem seleccionar o modelo para exportar dados.`,
"UG.product.02":`Os produtos referem-se a produtos ou serviços que são vendidos ou comprados.`,
"label.sendemailtouser":`Tem a certeza de que quer enviar correio electrónico aos utilizadores seleccionados?`,
"label.knowledge.setting.hint.nine":`Se não souber como é que o Conhecimento o beneficiará? Ordene artigos semelhantes como a única categoria de dados e acumule a uma categoria mais ampla. Agora, vamos adicionar uma categoria de dados. Pode adicionar mais categorias mais tarde.`,
"front-asset-module-v1-view-asset-bom":`Ver lista técnica de activos`,
"label_partner_all_enable":`Habilitar`,
"label.processsetting.disable.process.successfully":`Desactivar o processo com sucesso`,
"label.call.center.enable":`Activar o Call Center`,
"message.recordtype.applyitseparatly":`Aplicar um layout de página diferente para cada perfil.`,
"label.weixin.report.customize":`Personalizar`,
"label.file.mongdb.file.is.not.exist":`O ficheiro não existe`,
"label.chat.edit.topics":`Editar tópico`,
"label.knowledge.delete.searchterm":`Erro ao apagar o termo de pesquisa promovido`,
"label_emailtocloudcc_redmessage3":`Por favor introduza o endereço do servidor`,
"use":`Utilização`,
"label.batchtransfer.transferfrom":`Transferência de`,
"label.recycle.my":`O meu contentor de reciclagem`,
"label_json_string_null":`Vazio`,
"label.version.lookupfield":`Campo de Relacionamento Lookup`,
"lable.tianyancha.h5.searchf":`Não encontrado`,
"label.validate.globalvariable.description":`$Usuário[Field API] eg: $Usuário.id <br>Os valores que pode usar são: id,nome,funçãoId,roleName,perfilId,profileName,departamento,título,email`,
"UG.opportunity.006":`Génio de oportunidade`,
"label.applt.copy":`Clone de uma tábua`,
"chatter.emailMessageOrReply":`Posts ou comentários sobre o meu post`,
"label.newreport.self":`Campos seleccionados`,
"label.visualpage.checkpinxie":`Por favor, verifique a ortografia da página.`,
"label.knowledgebase.article.attaching.case":`O artigo {nome} foi anexado ao caso!`,
"label.dialogbox":`Caixa de Diálogo`,
"label.summaryreport.step3.new":`Passo 3 Selcetar os dados para resumir`,
"label.confirm":`Confirme`,
"label.mobile.buttom.team":`Equipa`,
"label.quickbooks.action.link":`Ligação`,
"vue_label_commonobjects_view_support_to_datas":`A operação suporta até 10 dados`,
"vue_label_helpcenter_homepage":`Cada utilizador tem duas homepages desde o início, uma homepage padrão e uma homepage pessoal. O administrador pode atribuir uma homepage de perfil correspondente ao utilizador, de acordo com o perfil do utilizador. Note-se que a página inicial da versão relâmpago e a página inicial da versão antiga não são interoperáveis.<br> 1. Homepage padrão<br> O conteúdo da homepage padrão é uniforme e não editável. Incluindo componente de desempenho trimestral, componente recentemente visualizado, componente do centro de aprovação, componente do evento de hoje, componente de tarefa, componente de oportunidade de negócio atrasada, componente de oportunidade de negócio de 30 dias, e componente de oportunidade de negócio futura<br> componente de desempenho trimestral: todos podem definir os seus próprios objectivos trimestrais<br> Componente recentemente visualizado: Mostrar os 10 registos de objectos vistos mais recentemente<br> componente de oportunidade de negócio sem contacto de 30 dias: Mostrar 5 oportunidades de negócio cujos dias sem contacto são superiores a 30 dias e a probabilidade não é 0 ou 100<br>br> 2. Homepage pessoal<br> Todos têm uma homepage pessoal, e o conteúdo da homepage pessoal pode ser personalizado para adicionar ou apagar componentes, ou arrastar e largar para ajustar a posição e tamanho dos componentes<br> Haverá um componente de briefing, componente de centro de aprovação, componente de oportunidade de negócio em atraso, e um próximo componente de oportunidade de negócio por defeito ao abrir uma conta na homepage pessoal<br> A homepage pessoal permite até 15 componentes<br> 3. Página inicial de perfil<br> Os administradores podem criar/editar/apagar páginas iniciais de perfil personalizando a página inicial, e podem atribuir diferentes páginas iniciais a diferentes perfis, para que os utilizadores com diferentes perfis possam ver diferentes páginas iniciais<br> Até 15 componentes por página inicial de perfil<br> 4. Adicionar componentes<br> Homepages pessoais e homepages de perfil podem ser personalizadas para adicionar componentes, pode adicionar componentes de painel de instrumentos, componentes de gráfico de painel de instrumentos e componentes de visualização de cartões<br> Componentes de painel de instrumentos: adicionar todo o painel de instrumentos do sistema à homepage. O número de sub-componentes no painel representa quantos componentes o componente do painel ocupa (a página inicial suporta até 15 componentes), e os dados do componente do painel após a adição não serão associados ao painel original (ou seja, se o painel original for apagado, o componente do painel ainda pode funcionar) <br> Componente do painel no painel: É possível adicionar um componente gráfico específico no painel de instrumentos do sistema à página inicial, e a função de ligação do componente será inválida neste momento<br> Componente de visualização do cartão: Pode optar por adicionar uma determinada visão de um objecto como fonte de dados à página inicial, e os campos e itens de operação podem ser personalizados. Mas note que se a visualização da fonte de dados da visualização do cartão for eliminada, a visualização do cartão não terá dados`,
"label.usersandlimit":`Utilizadores e Permissão`,
"label.sendmail.step3.introduce2":`destinatário(s) seleccionado(s) para receber este e-mail.`,
"label.setupcustomfield":`Campos personalizados`,
"label.layout.last.notdel":`O último não está autorizado a apagar o layout.`,
"label.emailtocloudcc.redmessage7":`Erro de configuração, por favor contacte o administrador.`,
"label.includedIn":`Contido em {parentproductname}`,
"label.permission.detail.app.pagesetting":`Definições de página personalizadas`,
"label.addfile.tips":`{selectedNum} files have been selected. Até {originNum} podem ser adicionados ficheiros por uma única vez.`,
"label.fieldinformation":`Detalhes do campo`,
"label.campagin.roi.sjcb":`Custo real`,
"label.email.all.works.company":`Todos os colegas de empresa`,
"label.currencyDesc":`Utilize esta página para definir todas as moedas utilizadas pela sua organização. A Moeda da empresa deve ser definida para a moeda em que a sede da sua empresa reporta as receitas. Se designar uma moeda diferente como moeda corporativa, todas as taxas de conversão serão modificadas para reflectir a mudança.`,
"label.file.details":`Detalhes`,
"label.foldervisitlimit3":`Apenas os utilizadores seguintes podem aceder a esta pasta:`,
"label.account.next.M":`Próximo mês`,
"label.oweralias":`Proprietário Alias`,
"label.projectManagement.entryname":`Nome do projecto`,
"label.customcomponent.page.add.title1":`Informação sobre componentes`,
"label.projectManagement.PleaseenterCreator":`Por favor, introduza um criador`,
"label.multipleactivity.memberselected":`Membros seleccionados`,
"label_chatter_memotel":`Memo-telefone`,
"lable.Confirm.customers":`Confirmar para recuperar {num} leads.`,
"front-email-payment-Invoice-number":`N.º de facturação`,
"label.not.appoint.validation":`Nenhum objecto é especificado para a regra de validação, por favor especifique.`,
"label.peru.time":`Hora do Peru`,
"label.setting.intergrationlist.status3":`Login QuickBooks necessário`,
"vue_label_display_number_field":`Mostrar campos de números`,
"label_productline_count":`Montante da série de produtos`,
"label.data.downpage.i_title.num2":`2. Antes de começar a importar, certifique-se de que o nome do campo no ficheiro que pretende importar corresponde ao nome do campo objecto no CloudCC.`,
"label.field.duplicate4":`Tratar "ABC" e "abc" como valores diferentes __(case sensitive)`,
"message.approval.step.validation.invalid.levels":`Pelo menos 1 nível`,
"label.tianyancha.businessverify.step1":`Activar a etapa 1 de verificação de dados comerciais`,
"label.hidedetail":`Ocultar detalhes`,
"UG_Lead_009":`Histórico de chamadas APP`,
"label.partnerCloud.newProductSeries":`Nova Família de Produtos`,
"label.brief.opportunities":`Total`,
"label.user.mfa.unbind.remind":`Está prestes a desvincular o AMF aos utilizadores seleccionados e precisa de voltar a ligar o dispositivo AMF após o próximo login, tem a certeza?`,
"vue_label_report_grouprow":`Fila de grupo`,
"setup.layout.label.newarea":`Nova área`,
"label.nostart":`Não Iniciado`,
"UG_Lead_010":`Ou`,
"label.emailmerge.mergepage.record.requeired":`Por favor, seleccione os registos que pretende fundir.`,
"label.appointmentpage.wizard.notif1btn1":`Confirme`,
"UG.Account.02":`Algumas empresas prestam serviços a outras empresas, algumas colaboram directamente com os utilizadores finais, e outras servem ONG.`,
"label.address.country":`País`,
"label.userinfo.updatepwd":`Alterar Palavra-passe`,
"label.salescloud.teamrole.optionlist.opportunity":`Adicionar membro da equipa de oportunidade a`,
"lable.account.Current.FY":`Ano Fiscal actual`,
"chatter.coll.p":`Marcar este post nos favoritos`,
"label.setupsms":`SMS`,
"label.atlantic.daylight.time":`Horário de Verão do Atlântico`,
"label.recordslock":`Fechadura de registo`,
"button_partner_search":`Inquira`,
"vue_label_salesfunnel_notice4":`Quantidade de oportunidades de negócio com uma probabilidade de 1% - 99%`,
"vue_label_report_statistics":`Estatísticas`,
"label.ccchat.notmember.active.group0":`Não é membro de nenhum grupo de actividades com {0} no seu nome`,
"label.tag.manage.newtag":`Nova etiqueta`,
"label.customfileds.formula.dateandtime.tip":`Calcular uma data/hora, por exemplo, adicionando um número de horas ou dias a outra data/hora.`,
"label.weixin.mobile.fly.ios":`Partilha a partir de dispositivo móvel (IOS)`,
"vue_label_file_over_file_size":`O tamanho do ficheiro file.name  'name excede a predefinição do sistema!`,
"label.schedulejob.setup.schedule.last":`último`,
"label.ccchat.whose.name.contains":`de qualquer grupo activo cujo nome contenha`,
"label.project.milestone.name":`Não se podem ter dois marcos com o mesmo nome num só projecto.`,
"message.passwordPolicy.validate.reuse":`Erro:Não é possível reutilizar esta senha antiga.`,
"label.stdashbord.xsld.business.img3":`O montante da probabilidade de 1%-99% * Probabilidade`,
"label.event.view.list":`Ver Lista`,
"label.workflow.ruletriggertime":`Tempo de activação de regras`,
"label.campaign.channel":`Canais de Marketing`,
"label.appexchange.emailnotice":`Alerta de e-mail de fluxo de trabalho`,
"label.icon.77":`Agricultura`,
"label.visualpage.display.value":`Introduza os valores a serem exibidos, e note que não há espaços antes ou depois.`,
"label.forecast.customforecast.type.user":`Por Utilizador`,
"label_tabpage_lessz":`Menos de`,
"label.same.analyze.contact.email":`Email`,
"vue_label_report_range":`gama`,
"lable.product.pricebooks.nr":`Pode clonar conteúdos de livros de preços existentes, seleccionando a partir da lista de selecção abaixo.`,
"label_mobile_buttom_team_setUp":`Configurações da equipa`,
"label.email.bcc.recipients":`Destinatários do Bcc`,
"vue_label_ccchat_notice_deletepostfail":`Falha em apagar correio`,
"label_file_type":`Tipo de ficheiro`,
"label.multilang.feedtrack.operateupdate":`Um registo {0} tem sido modified：`,
"label.contractmanager":`Gestor de Contrato`,
"front-gantt-module-drag-one-task-sorting":`As tarefas só podem ser classificadas dentro do mesmo marco!`,
"label.partner.step2":`Passo 2 confirmar modelo`,
"front-epwechat-module-v1-again-binding":`Rebind`,
"label.service.miniProgram.imageSize":`Não mais do que 2MB de imagem podem ser carregados!`,
"setup_main2018_label_managesetup":`Definições de administração`,
"component_salesperformance_label_nopermission":`Para ver dados relacionados com oportunidades de negócio, contacte o administrador do seu sistema.`,
"lable.account.stadate":`Data de início do Trimestre Fiscal`,
"label.service.gantt.and.resourcestype":`e tipo de recurso é`,
"label.ems.attachfiles":`Acrescentar anexo`,
"label.data.expnode.e.desc1":`1、 Exportação personalizada: os utilizadores podem seleccionar campos a exportar e definir condições de filtragem de acordo com as suas necessidades.`,
"vue_label_systemSettings_analyse":`Analisar`,
"label.project.all.date":`A data final deve ser posterior ou igual à data de início!`,
"vue_label_commonobjects_view_summary_basis":`Base de Agregação`,
"template.chart.yywjhdschd":`Campanhas com Oportunidades`,
"vue_label_pool_notmeet":`Não satisfaz os requisitos do cliente`,
"label.attendance.manager":`Gerir a assistência`,
"vue_labenl_normal_current":`Actual`,
"label.projectManagement.completed.quantity":`Quantidade de conclusão`,
"label.layout.testfield":`Campos de teste`,
"label.customfields.selectcontainrelatelistlayout":`Seleccionar os layouts de página que devem incluir esta lista relacionada`,
"label.fiji.time":`Hora de Fiji`,
"message.error.domain.already.exists":`O nome de domínio já existe.`,
"label.accountandcontact":`Contas/Contactos`,
"label.dashboardSetup.right":`Certo`,
"label.view.appliedMobile.xgry":`Verifique este item, os utilizadores relevantes podem ver a vista na bancada de trabalho da página inicial`,
"label.file.share.all":`Qualquer utilizador na sua empresa`,
"vue_label_pool_summary":`Total {0} registos(s), actualizados em {1}`,
"label.emailtemplate.new":`Novo modelo de e-mail`,
"label.tag.manage.button1":`Criar nova etiqueta`,
"label.data.exp.tempexppage":`Página de modelo de exportação de dados`,
"font-trade-module-v1-invoice-total":`Montante total da factura`,
"label.folder.sort":`Classificar pasta`,
"label.multilang.campaign.countnum":`{0} tempo(s)`,
"label.homepagelayout":`Layouts da página inicial`,
"setup_layout_button_cancel":`Cancelar`,
"lable.Search.in.QuickBook":`Pesquisa no QuickBook`,
"setup_fielddependency_label_pleaseclick":`Clique em Control Field value para editar`,
"setup.fielddependency.label.pleaseclick":`Clique em Control Field value para editar`,
"label.version.sum.field":`campo(s) personalizado(s)`,
"label.form.is.submitted.successful":`Prontidão de submissão de forma bem sucedida`,
"label.campaignmember.main.batchaddmember":`Membros da Campanha "Mass Add`,
"label.sendemail.activity.newevent":`Caro #belongtoidccname, olá:o teu colega #criatebyidccname atribuiu-te um novo evento em #createdate, que diz o seguinte:rr{r{n assunto: #subjectar por nome:#subjectar por nome: #begintime\r #n hora de fim: #tempo final: #tempo final: #tempo final #conteúdos relacionados: #conteúdos relacionados: #conteúdos relacionados #Para mais detalhes, visite este link:rr:n Caminho:rn #orgNameCRM system`,
"label.knowledgebase.select.target":`Por favor escolha um alvo`,
"setup.layout.label.buttonlist":`Seleccionar botões`,
"pagecreator.page.label.pagedesc":`Descrição da página`,
"label.version.professional":`Edição Profissional`,
"UG.Forcast.10":`Completo`,
"template.chart.schdyqsr":`Receitas Esperadas das Campanhas`,
"front-filter-module-v1-quick-filter":`Filtro Flash`,
"label.notification.group2":`Juntou-se com sucesso à equipa pública`,
"label.ServiceCloud.statistics.by.serviceArea":`Estatísticas por Território de Serviço`,
"label.validate.function.funcExplain.TIMENOW":`Retorna um tempo representando o momento actual`,
"label.brief.lastmonth":`Último mês`,
"label.weixin.member.states":`Estatuto de Membro`,
"template.chart.ljxsje":`Montante de vendas acumulado`,
"label.eidt.queue.label.hasused2":`Este nome de fila já existe ou já foi utilizado anteriormente.`,
"label.textmessage.nophonenumber":`Este contacto não tem um número de telemóvel registado!`,
"label.task.new":`Nova Tarefa`,
"label.tabpage.grid":`A exibição da grelha`,
"label.workbanch.setup.viewname":`Ver Nome`,
"front-gantt-module-temporary-tasks":`Tarefa Temporária`,
"label.reportTypeDescripe":`Com fonte de dados de relatório personalizada, pode permitir aos utilizadores criar relatórios a partir dos objectos predefinidos, relações de objectos, e campos que especificar.`,
"setup_layout_label_fieldlist":`Campos disponíveis`,
"label.ggReleaseRange.searchforRole":`Procurar papel de parceiro`,
"label.datamanage.account.field":`Campos de Conta`,
"label_tabpage_groupingemptyz":`Os artigos de agrupamento não podem estar vazios`,
"label.permission.edit.insertinfo":`Introduzir informação sobre o conjunto de permissões`,
"label.back_forms":`Voltar à lista de formulários`,
"vue_label_calendar_step_2":`Passo 2: Criar um calendário a partir de um objecto padrão ou personalizado.`,
"lable.outlook.mcto.out":`Domínios Excluídos`,
"label.workflow.accessnext":`Utilize este processo de aprovação se o seguinte`,
"label.data.exp.temppage":`Exportação de dados e criação de modelos de página`,
"label_tabpage_printview":`Vista de Impressão`,
"vue_label_report_preview":`Para ver as últimas edições, actualize para visualização.`,
"frame_personinfo_label_personimage":`Foto de perfil`,
"component.chatter.button.like":`Como`,
"label.ems.drafts":`Esboços`,
"front-lightning-module-v1-details-page-chart-report-name":`Nome do relatório`,
"label.partner.workspace.login":`Página de login`,
"include":`inclui`,
"label_length_20":`Limitar o comprimento a 20 caracteres.`,
"component_event_button_save":`Guardar`,
"label.weixin.recalculate.shared.success":`Regra da partilha de objectos êxito no recálculo.`,
"message.duplication.errorinscript.lessthan2":`É necessário seleccionar pelo menos dois registos para fundir.`,
"label_my_forecast":`A minha previsão`,
"label.ems.to":`Receptor`,
"label_mobile_buttom_team_init":`Inicialização do utilizador da equipa`,
"label.sendemail.send.codeerror":`A conversão do código falhou, por favor introduza a codificação correcta.`,
"lable.quote.syncing.and":`e`,
"label.campaignmember.selectmember.step1oftotal":`Etapa 1 de 2`,
"label.ems.step3":`Etapa 3`,
"lable.PowerProcess.detail.message":`Informação sobre o Processo de Marcos`,
"chatter.poll.option2":`Escolha 2`,
"front-view-module-v12-verify-number":`Erro de formato numérico. Verificar os dados introduzidos.`,
"label.setup.mobile.homepageshortcuts.savesuccess":`As definições de funções rápidas guardadas.`,
"lable.outlook.edit.zdyoutfi":`Nome do campo de intercâmbio personalizado`,
"label.assignment.setup.newentries.inputentries":`Introduzir a regra de entrada`,
"label.customfields.money.tip":`Permite aos utilizadores introduzir um valor em dólares ou outra moeda e formatar automaticamente o campo como um valor em moeda. Isto pode ser útil se exportar dados para Excel ou outra folha de cálculo.`,
"label.service.appointmentList.cancelThePlan":`Plano de cancelamento`,
"label.chat.topic.suggest.add.topic":`Sem sugestão, acrescente o seu próprio tópico.`,
"vue_label_commonobjects_detail_tips":`Dicas`,
"message.error.view.nameexists":`Erro: O nome único da vista já existe.`,
"label_emailtocloudcc_step2_name":`Configurar a propriedade do e-mail`,
"label.field.validation.apiname":`Deve começar com uma letra. Deve conter apenas letras maiúsculas e minúsculas, números, e sublinhado. E o comprimento máximo é de 50 caracteres, o comprimento mínimo é de 2 caracteres. Note-se que não pode ser uma palavra-chave de base de dados.`,
"page.field.masterinput.remark2":`Por exemplo, quando se cria uma nova encomenda, é necessário activar esta funcionalidade para introduzir as entradas da linha de encomenda na mesma página. (esta funcionalidade é bem adequada para objectos na relação mestre-detalhe).`,
"label.rule.enabled.successfully":`Habilitar as regras com sucesso`,
"label.role.createrolelist.tip":`Abaixo está uma lista dos papéis da sua organização. Pode ver mais informações clicando no link dos papéis.`,
"label.multilang.datamanage.dataimport.redundantmsg":`O comprimento do título é &nbsp;{0}&nbsp;, mas o comprimento dos dados é &nbsp;{1}&nbsp;, o sistema não pode determinar quais &nbsp;{2}&nbsp; os campos são redundantes.`,
"label.visualpage.staticresource":`Introduzir Recurso Estático`,
"chatter.group.members01":`Membros`,
"label.planned.workname":`Nome do trabalho`,
"label.service.dispatchingUnits.gantt.data":`Data do jogo Gantt`,
"label.data.newtemplate.t.conditions":`Condições do modelo`,
"label.accmarketsea.edit.title":`Edição do pool de contas`,
"label_chatter_priority":`Prioridade`,
"label_mobile_buttom_team_open":`Habilitar a equipa no PC & App`,
"front-gantt-module-no-tasks-available":`Sem tarefas disponíveis`,
"component.newrecords.label.type":`Tipo de armazenamento`,
"label.version.ccdocument.and.remark":`Notas & Anexos`,
"label.martrixreport.step2":`Seleccione o modo de agrupamento utilizado para calcular os dados que pretende transferir`,
"label.projectManagement.Scheduleinformation":`Informação sobre o calendário`,
"label.emailmerge.mergeFolder.description":`Nesta página pode criar um documento do Microsoft Word que contém os seus dados de contacto. Por favor, seleccione os modelos de fusão de correio, até 20.`,
"label.autoRegister.changepwd.setpwd.tip":`A palavra-passe tem de satisfazer as seguintes condições`,
"label.partnerCloud.orderingPlatform.shoppingEmpty":`O carrinho está vazio, por favor clique em "Adicionar Produtos" para adicionar.`,
"label.marketcloud_seminar":`Seminário Marketing Cloud`,
"label.knowledgebase.no.results.knowledge.search":`Nenhum resultado sobre "{a}" em Conhecimento`,
"label.createdate":`Data de criação`,
"vue_label_systemSettings_bazaar":`Mercado`,
"report_type_label_contractPayment":`Contratos e Contas a Receber`,
"label.myemailset":`As minhas definições de e-mail`,
"label.emailtype":`Tipo de Email`,
"label.appexchange.uninstallpage.message5":`Eliminar permanentemente todas as relações e listas relacionadas associadas aos objectos personalizados deste pacote`,
"label.customerinfo.applicationlicencenum":`Número de licença de recurso`,
"label.product":`Produtos`,
"lable.opppdt.selPdt.subtitle":`Selecção de produtos para`,
"label_emailtocloudcc_step1_lead1":`Email para liderar`,
"label.multilang.recentview.query":`Veja o seu último {0}`,
"label.cumstom":`Personalizado`,
"lable.product.pep":`Por favor, introduza o preço.`,
"label.suggestion":`Ideias`,
"vue_label_email_sentto":`enviado`,
"label.email.cancel":`Depois da associação ser cancelada, a caixa de correio não pode ser utilizada para enviar ou receber emails. Tem a certeza de que vai cancelar a associação?`,
"component_timeline_label_1monthahead":`1 mês antes`,
"setup_mainpage_label_welcome31":`Instruções: Clique no menu do lado esquerdo desta página → Gerir Configurações → Criar Aplicação →`,
"label.weixin.settlement.rate":`Taxa de realização da liquidação`,
"front-lightning-module-v1-details-page-chart-add-report":` Pode ser acrescentado um máximo de 4 gráficos de relatório.`,
"label_related_list_types":`Lista relacionada tipo de versão de Relâmpago`,
"label.tabpage.converstatez":`Estado convertido`,
"label.chatter.ok":`Confirme`,
"lable.SalesCommitmentKanBan.contractRate":`Taxa de assinatura`,
"component.setup.label.setupsavefail":`Falha em salvar as definições dos componentes`,
"label.email.form.text2":`[mudar para html]`,
"UG.Lead.009":`Histórico de chamadas APP`,
"label.escalation.setup.newrule.title":`Regra de Escalada do Caso`,
"label.field.available.value":`Valores de campo disponíveis`,
"label.cannotuseaddtimetrigger":`<b>`,
"vue_label_chat_activefail":`Falha activada`,
"label.dashboard.show.total.percent":`Mostrar total ou mostrar %, por favor escolha pelo menos um`,
"label.schedulejob.setup.schedule.jobprg":`Programas de Emprego`,
"label.select.email.type":`Por favor, seleccione o tipo de email!`,
"chatter.group.allTheMembers":`Todos os Membros`,
"label.webtab.validation.apiname":`Deve começar com uma letra. Deve conter apenas letras maiúsculas e minúsculas, números, e sublinhado. E o comprimento máximo é de 20 caracteres, o comprimento mínimo é de 2 caracteres.`,
"label_partner_new_step3_name":`Nome`,
"vue_label_chatter_remove_member":`Remover membro`,
"label.customobjects.majorobject.tip":`Se seleccionar um objecto de relação não detalhada de princípios, o resumo dos dados não aceita permissões`,
"label.forecast.edit.kjjd":`FQ`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.three":`Três`,
"label.weixin.senderror":`O envio falhou`,
"label.visiturl":`Visitar URL`,
"label.apply.img.error":`A introdução de caracteres no grafite é incorrecta`,
"label.been.detained":`Desconto de reinicialização`,
"vue_label_helpcenter_dashboard2":`<br> No painel de instrumentos recentemente criado, é necessário adicionar primeiro os componentes, e seleccionar a fonte de dados do relatório ou visualizar a fonte de dados da lista. Depois determinar o tipo de gráfico utilizado e seleccionar o agrupamento e dados estatísticos correspondentes para criar o gráfico<br> Depois de adicionar os componentes, pode clicar no botão "Reordenar" no tablier para ajustar a posição e tamanho dos componentes. <br> Se precisar de definir condições de filtragem de tempo para alguns componentes, pode clicar em "Filter Condition Settings" para seleccionar o componente para definir o campo de tempo que o componente precisa de filtrar. Após definir, pode filtrar por tempo no painel de instrumentos e seleccionar o intervalo de tempo correspondente para actualizar os dados seleccionados. <br>Nota: Um painel de instrumentos suporta até 10 componentes. <br> 2. Penetração e ligação de componentes<br> No mesmo painel, o componente A pode definir os componentes B e C a partir da mesma fonte de dados que os seus objectos de ligação. Após a definição estar concluída, clicar numa área de dados do componente A, componente B e componente C irá simultaneamente efectuar a recontagem de dados com base nas condições da área de dados do componente A. <br> Note que clicar na área de dados do componente B ou do componente C não fará com que o componente A volte a contar. Se precisar de conseguir este efeito, é necessário definir o componente A como o seu objecto de ligação no componente B/C. <br> Para cada componente do gráfico no painel de instrumentos, os dados vêm da vista ou do relatório. Portanto, é fornecida uma função de penetração, ou seja, clicar na área de dados do componente pode saltar para a visualização do relatório e da lista correspondentes. Note-se que se a fonte de dados original falhar, o componente não terá dados e a função de penetração também falhará. <br> Uma vez que tanto a penetração como a ligação são a área de dados do componente para clicar, não podem ambas ter efeito ao mesmo tempo. Se o componente tiver ambas as funções de penetração e de ligação, então o componente só pode ter uma função a ter efeito ao mesmo tempo, e pode escolher a função em efeito alterando os estados de ligação e de penetração.`,
"vue_label_commonobject_view_notice_delete_false":`Os dados {0} não foram apagados, a razão é {1};`,
"label.weixin.newspaper.coverage.information":`Detalhes da Ficha de Risco`,
"label.you.do.not.have.permission.to.operate.":`Não tem acesso para operar.`,
"label.checkfield.match":`Jogo`,
"message.custom.field.donotdelete.ref":`Este campo é referenciado por outros campos`,
"label.version.maxsum":`atingiu o limite superior.`,
"System.ChangeUser.Info.001":`O proprietário mudou e clique para voltar à página anterior.`,
"label.target":`Alvo`,
"template.dashboard.behavior.analysis":`Análise de Acções`,
"label.login.verification.enter.prompt":`Por favor introduza um código de segurança digital de 6 dígitos`,
"label.am":`AM`,
"chatter.emailSetUp.remark":`Permitir que os utilizadores recebam e-mails CCChat quando alguém o seguir, comentar o seu post, e muito mais.`,
"label.accmarketsea.grouplist.title":`Definição do grupo de contas`,
"label.stdashbord.xsld.business.danwei":`Unidade: 10 Mil`,
"label.app.step1.error.namenull":`É necessário introduzir o nome do grupo público.`,
"label.login.button.verification":`Submeter-se para verificar`,
"label_tabpage_newWizardz":`Novo assistente de funções acrescentado`,
"label.addattachment.step1.intruduce":`Introduza o caminho do ficheiro ou clique no botão para encontrar o ficheiro.`,
"pagecreator.layout.funcpath":`/ construtor / biblioteca de layout`,
"fourth":`O Quarto`,
"label.timetrigger.after.lasttime":`Um dia depois da data da última modificação.`,
"vue_label_report_showme":`Mostre-me`,
"label.h5.similar.opportunity.end.date.in":`A data final está dentro do seguinte período`,
"label.turntonextstep":`Passar ao passo seguinte`,
"label.icon.106":`Horário`,
"label.user.receivenewsbulletin":`Receber emissão de notícias`,
"label.mask.card.number":`Número do cartão de crédito`,
"setup.object.layout.label.profileoptions":`Perfis disponíveis`,
"vue_label_systemSettings_obj":`Objectos e Campos`,
"label.call.center.history.open":`Abrir automaticamente a página do histórico de chamadas`,
"label.attendance.cityname":`Por favor introduza o nome da cidade`,
"label.newemailnotice.tip":`Criar um alerta por correio electrónico para associar a uma ou mais regras de fluxo de trabalho ou processos de aprovação. Ao alterar um alerta por correio electrónico, quaisquer modificações serão aplicáveis a todas as regras ou aprovações associadas a ele.`,
"label.app.step1.error.labelnull":`Error: Label não pode estar vazio.`,
"front-kefu-moudle-connect-free-account":`Associar os utilizadores do CloudCC às contas de ensaio do TRRT`,
"label.biaoqingfaxian.description":`Com o bid&tender discovery activado, um menu de bid&tender discovery pode ser adicionado ao front-end, onde os utilizadores podem ver a informação de licitações de indústrias relevantes e converter dados de licitações em leads no sistema.`,
"label.filter":`Filtro`,
"label.data.downpage.e.title.num1":`1、Select os objectos que deseja exportar, ou opte por exportar todos.`,
"label.h5.similar.opportunity.last.months12":`Últimos 9-12 Meses`,
"label.chatter.name":`Nome`,
"vue_label_helpcenter_email":`1. Enviar correio<br> Deixar o sistema para ir à sua caixa de correio para comunicar com os contactos está desactualizado. No Cloud CC, pode ligar o seu endereço de correio electrónico pessoal para enviar e-mails directamente do Cloud CC. Quando introduz o endereço de correio electrónico ou nome do destinatário, este pode corresponder ao seu contacto ou registo de contactos para si. Pode também associar registos de correio electrónico com registos relacionados que tenham sido configurados, e as mensagens que enviar serão sincronizadas na página de detalhes do registo.<br> 2. 4 funções comuns ao enviar e-mails<br> Ao enviar um e-mail, pode usar as 4 funções abaixo do texto do e-mail para ajudar o seu trabalho.<br>Mail tracking<br> Quando ligar o rastreio de e-mail, ajudá-lo-emos a monitorizar o número de vezes que este e-mail foi aberto e quando foi aberto pela última vez. Pode passar o rato sobre o ícone "olho" na lista da caixa de saída para o visualizar.<br>Upload Attachment<br> Clique em Upload attachment, pode seleccionar o ficheiro que foi carregado para o sistema, ou pode escolher carregar o ficheiro. Pode seleccionar vários anexos, desde que o tamanho do anexo seja inferior a 20M.<br>Inserir campos fundidos<br> Quando o e-mail é associado a um registo de objecto, pode clicar para inserir o campo fundido, seleccionar o objecto associado, seleccionar o campo que deseja inserir, e inserir o texto de substituição após a vírgula no campo fundido, tal como {!Contact.FirstName,Sir ou Madam }. Ao guardar o modelo, os campos fundidos serão exibidos no texto de e-mail do modelo. Utilize os campos fundidos para personalizar o conteúdo do e-mail. É possível adicionar texto de substituição a qualquer campo fundido. O texto de substituição é exibido apenas quando o registo fundido não contém os dados do campo.<br>Editar e activar assinatura<br> Quando estiver a enviar e-mails de trabalho, uma assinatura que possa representar a sua identidade ajudará a melhorar o seu profissionalismo de trabalho. Clique no botão "Editar Assinatura", pode editar as suas informações básicas, e apoiá-lo para inserir imagens. Se marcar "Activar Assinatura", a sua assinatura será anexada ao corpo da mensagem cada vez que escrever uma mensagem de correio electrónico. Pode desactivar a assinatura em qualquer altura.<br> 3. Filtrar a caixa de entrada<br> Pode filtrar todas as mensagens não lidas na sua caixa de entrada para facilitar o seu trabalho. Quando quiser descarregar ficheiros via correio electrónico, pode filtrar todos os e-mails com anexos na sua caixa de entrada, para que possa localizar rapidamente o e-mail de que necessita. Além disso, pode ver rapidamente os registos de clientes no sistema que rastreia através de e-mails, seleccionando e-mails com oportunidades de negócio abertas ou seleccionando e-mails enviados por contactos ou leads.<br> 4. Envio em massa<br> Existe um botão para envio em grupo no canto superior direito da lista de leads e contactos. Pode enviar correio em massa para potenciais clientes ou registos de contactos com endereços de correio electrónico. Quando tem um registo de actividades de marketing, pode enviar e-mails aos membros das actividades de marketing em lotes, o que também é conveniente para enviar convites para eventos.`,
"front-kefu-moudle-auto-callphone":`Autocriar novos casos para chamadas ligadas`,
"label.fiscal.FQ":`Trimestre Fiscal`,
"label_tabpage_groupsVisiblez":`Alguns grupos de utilizadores são visíveis`,
"UG.product.01":`Listar produtos/serviços`,
"vue_label_commonobjects_view_members":`Membros opcionais`,
"label.organization.id":`ID da organização`,
"label.tyle_preview":`Previsão de Estilo`,
"label.campaign.channel.input.to.owner":`6. Por favor, estabeleça se deve notificar os seus proprietários quando os membros da campanha assinarem:`,
"label.appointmentconfirmpage.wizard.notif1":`A marcação foi cancelada!`,
"lable.tianyancha.maping":`Cartografia de campo`,
"front-kefu-moudle-v1-noadd-online-chats":`O agente online não é adicionado`,
"vue_label_commonobjects_detail_group_strategy":`Tem a certeza de entrar na equipa do cliente?`,
"vue_label_report_deletegrouprow":`Eliminar fila de grupo`,
"lable.account.y.d":`Esta página permite-lhe definir um registo de ano fiscal personalizado. As datas para o ano fiscal personalizado serão geradas com base nas escolhas que fizer abaixo.`,
"label.visualpage.lllegal.definitions":`Definição Inválida`,
"label.tabpage.enterrecordnamez":`Por favor, introduza o proprietário do disco`,
"vue_label_report_howmuchlines":`{comprimento} linhas`,
"homepage.components.custom":`Componentes personalizados`,
"label.campaign.channel.upload.img":`Carregar imagem`,
"UG_Case_03":`Actualização automática de casos`,
"label.approved.receiveApprovalEmail.option4":`Nunca`,
"System.Data.Import.Warning.MaxCount":`A sua organização só pode importar {0} dados de cada vez, o que agora está fora do limite, por favor ajuste e reimporte.`,
"label.sent.sms":`enviou um SMS`,
"vue_label_dashboard_statistictype":`Tipo de estatística`,
"label_report_last_year_same":`Mesmo período no ano passado`,
"lable.Examle":`Exemplos`,
"label.customerinfo.PageTriggerFagTitle":`São necessárias duas horas para sincronizar.`,
"label.mobile.phone.read":`Revise`,
"label.product.gopage":`Ir para a página`,
"label.a_b_without":`Os registos "A" podem ter ou não registos "B" relacionados.`,
"front-kefu-moudle-callin-missphone":`Chamadas não atendidas`,
"label.sso.saml.sp.idsource.attrname":`Nome do Atributo`,
"label.h5.chatter.colleagues2":`Colegas`,
"label.approveprocess":`Processos de Aprovação`,
"label.dataimport.error.name.null":`Erro: o nome é nulo`,
"label.paging.countitems":`{0}`,
"vue_label_report_notice_filter":`Quando a filtragem avançada não está activada, as diferentes condições de filtragem são "e", ou seja, os registos que satisfazem as características comuns de 1 e 2 são exibidos no relatório. Por exemplo: 1 é uma oportunidade de negócio com um montante superior a 1 milhão, e 2 é uma data de contrato estimada igual a este mês, pelo que o resultado do relatório é mais de 1 milhão de oportunidades de negócio este mês.`,
"front-lightning-module-v1-dashborad-export-picture":`Exportar imagem`,
"label.activity.disabled":`Nenhuma actividade activada, por favor contacte o administrador do seu sistema para activar o histórico de actividades e actividades não processadas na disposição da página.`,
"message_chooseatleastonefield":`Por favor seleccione pelo menos um campo para exibir.`,
"label.case.text":`Os formulários de pedido de serviço apresentados através do sítio web podem gerar registos de casos no sistema. Por favor, seleccione o utilizador como criador do registo do caso, e o utilizador seleccionado precisa de ter permissão de criação para o objecto do caso. A página web está disponível para computadores e telemóveis.`,
"label.sendmail.step3.dealoption1":`BCC me em uma mensagem`,
"label.forecast.settings.title.remark":`A melhor estimativa da receita estimada para o utilizador, que fornece uma visão completa do negócio para os utilizadores`,
"label.apply.youxiaotime.finish.opperation":`Tem 5 minutos para completar as acções. Por favor, ignore esta mensagem se a operação não for presencial.`,
"label.user":`Utilizador`,
"pagecreator.page.button.copy":`Cópia`,
"label.userinfo.pwdupdate.or.reset":`A sua palavra-passe foi alterada pela última vez ou reiniciada em`,
"label.fieldupdata":`Actualizações de campo`,
"label.sendemail.chat.followsubject":`CloudCC CCChat tem alguém a seguir`,
"component_task_label_enddate":`Data de expiração`,
"label.campaign.channel.step6.remark5":`Pode ser reatribuído através das Regras de Atribuição de Chumbo. Saiba mais sobre as Regras de Atribuição de Chumbo.`,
"label.mr.title.mobilePhone":`Móvel`,
"label.notice":`Lembrete`,
"message.serviceappo.time.violation":`Violação do tempo disponível de marcação de serviço: A hora de início da marcação de serviço é posterior à hora de início disponível mais cedo.`,
"label.account":`Contas`,
"front-kefu-moudle-callcenter-user":`Utilizadores do Call Center`,
"label.usermanage.query.notexist":`O utilizador da consulta não existe.`,
"label.forecast.userinfo.isnable":`Permitir Previsões`,
"label_partner_workspace_member":`Membro`,
"vue_label_dashboard_penetrationsetting":`Definição da Penetração`,
"chatter.fieldtrack.operatecreate":`criou um`,
"label_tabpage_tpcustomersz":`Converter pistas`,
"label.emailtocloudcc.redmessage6":`A autenticação IMAP/SMTP falhou, por favor verifique se o endereço de correio electrónico e a palavra-passe estão correctos.`,
"label.customfields.file.upload":`Carregar`,
"label.forecast.isforecast":`Sem Previsão activada`,
"label_benchmark":`Referência`,
"label.exchange.sync.state.system":`Estado de Sincronização do Sistema`,
"UG.opportunity.003":`Acompanhe os seus canais de venda, crie painéis de controlo`,
"label.campaign.matchway.select.error":`Para actualizar os dados, seleccione por favor o método de correspondência`,
"vue_label_dashboard_located":`Dashboard Folder`,
"front-electronic-signature-enter-object":`Por favor, introduza o objecto`,
"vue_label_systemSettings_mobelquick":`Aplicações móveis Configuração rápida`,
"lable.outlook.list":`Configurações de Sincronização de Troca`,
"label.sendemail.approval.dlsp":`Olá, #dlspr:\n #actorname#objapiname-#recordname submetido por #actordate foi definido como o seu aprovador proxy pelo aprovador original #spr e está à espera da sua aprovação.\n#please click no link abaixo ou faça login no sistema crm para entrar no centro de aprovação para aprovação:\n#url#url! \n#n#orgname`,
"label.service.deleteCustomView.wanttoremove.filter":`Tem a certeza que quer remover o filtro "{nome}"?`,
"component_task_label_newevent":`Nova tarefa`,
"vue_label_commonobjects_view_chart_groupby":`Grupo Por`,
"front-kefu-moudle-v1-edit-chats":`Agente de edição`,
"pagecreator_page_message_delete_fail":`A eliminação da página falhou`,
"label.file.search":`Ficheiros de Pesquisa...`,
"label.projectManagement.Addpredecessors":`Adicionar pré-tarefa`,
"label_tabpage_norecordtypez":`Tipo de registo inutilizável`,
"label.come.recycle.bin":`Ir para Lixo de Reciclagem`,
"label.reportsSubscriptionPage.schedulereport.monthly.time.relative":`Relativo`,
"label.customfields.address.tip":`Permite ao utilizador seleccionar província,cidade,campos de condado,e introduzir informações específicas de endereço que podem ser utilizadas para calcular a latitude e longitude.`,
"label.weixin.optioneight":`Escolha 8`,
"label.recordtypeselect.modify":`Editar Tipo de Registo`,
"label.forecast.settings.future3":`Futuros 3 ciclos`,
"label.rename":`Renomear`,
"label.emailtocloudcc.button.complete":`Terminar`,
"chatter.new.at":`Actividade mais recente`,
"component.setup.label.milestonesfield":`Campo de marco miliário`,
"vue_label_commonobjects_detail_email_newaddress":`Enviar para`,
"lable.PowerProcess.big.event":`Marco miliário:`,
"label.appexchange.uninstallpage.confirm":`Sim, I quer desinstalar este pacote e apagar permanentemente todos os componentes associados`,
"label_mobile_buttom_homepage":`Página inicial`,
"label.sso.saml.idp.config.logouturl":`URL único de logout`,
"lable.quote.pdf.button.savetoquote":`Guardar à Citação`,
"label.page.select.application":`Seleccione as aplicações personalizadas nas quais pretende utilizar os novos separadores personalizados. Também pode ver ou modificar se um separador aparece na página de detalhes e página de edição de cada aplicação personalizada.`,
"chatter.down":`Descarregar`,
"label.tabpage.searchz":`Pesquisa`,
"label.emailsync.form.action":`Acção`,
"label.campaignmember.setup.campaignmember.field":`Campos de membros da campanha`,
"label.version.remark":`Nota: A Edição Gratuita só permite criar 5 utilizadores, 2000 registos e não é possível importar ou exportar dados.`,
"label.selectoperateobject":`Seleccionar o objecto.`,
"label.appointmentdetail.wizard.title12":`Tempo de livro`,
"label.submitforapproval":`Submeter para aprovação`,
"label.the.lower.bound.of.each.layer.of.editing.discount.must.be.equal.to.the.upper.bound.of.the.upper.level.":`O limite inferior para editar cada nível de desconto é igual ao limite superior do último nível.`,
"label.appupload.install.component.view":`Vistas Componentes`,
"label.profile.customobjcontrol":`Permissões de objectos personalizados`,
"label.customfields.configprofilefieldsafety.tip":`Seleccione os perfis aos quais pretende conceder acesso de edição a este campo através de segurança de nível de campo. O campo será escondido de todos os perfis se não o adicionar à segurança a nível de campo.`,
"label.service.gantt.service.resources":`Recursos de Serviços`,
"label.input.right.emailaddress":`Por favor introduza o endereço de correio electrónico inválido.`,
"label.ccdocument.folder.notedit":`A pasta não é editável.`,
"label.data.choses.i.desc":`De acordo com as suas necessidades, importar dados de um único objecto.`,
"label.icon.75":`Automóvel`,
"label.summaryreport.step4":`Passo 4 Escolha as colunas do relatório`,
"label.appupload.upload.install":`Instalar`,
"label.reportlist.newfolder":`Nova pasta de relatórios`,
"label.projectManagement.myproject":`O meu projecto`,
"label.true":`VERDADEIRO`,
"label.tabpage.reallproplez":`Proprietário do disco`,
"label.change.lead.share.error":`Sem direito de editar cliente`,
"F":`Data/Hora`,
"lable.account.CurrentandNextCQ":`CQ actual e CQ seguinte`,
"UG.activity.06":`Deseja acompanhar com contas`,
"UG.contact.03":`Rastrear contactos num só local, sinais de venda`,
"label.field.duplicate.error.msg2":`Falha na definição da propriedade única`,
"label.sales.dashboard.reality":`Pagamentos reais`,
"lable.PowerProcess.type":`Tipos de processo de concessão de direitos`,
"batch.selected.data":`Dados seleccionados:\uff1a`,
"#label.importsourcefilestep2":`Passo 2 Comprimir o seu ficheiro(Opcional)#`,
"label.emailtemplate.select":`Por favor, escolha o modelo de e-mail que deseja utilizar.`,
"chatter.most.w":`Pode introduzir até 500 caracteres`,
"vue_label_calendar_new_object_calendar":`Novo Calendário de Objectos`,
"label.aggregated_formsdata":`Dados Agregados de Formulários`,
"label.knowledge.language.french":`Francês`,
"label.customfields.enc.tip":`Permite aos utilizadores introduzir qualquer combinação de letras e números e armazená-los de forma encriptada. E não podem ser pesquisadas.`,
"label.icon.158":`Nuvem`,
"font-evaluate-module-v1-bad-review ":`Quando o tipo de avaliação é Negativa`,
"UG_quota_03":`Modelo de citação`,
"label.eidt.queue.label.hasused":`O rótulo já está a ser utilizado`,
"label.lookupfilter":`Filtros de Pesquisa`,
"label.callcenter.Instance.name":`Nome da instância`,
"label.commitertype":`Tipo de apresentador`,
"vue_label_checkduplicate_any_one":`Conheça qualquer um`,
"label.campaign.channel.input.img":`Por favor, seleccione a imagem do seu computador local como página de agradecimento`,
"vue_label_dashboard_pleaseenterafoldername":`Por favor introduza o nome de uma pasta`,
"label.tianyancha.look":`Ver`,
"label.tabpage.lastone":`Seleccionar pelo menos uma operação`,
"label.sendemail.approval.submit.title":`{!objLabel} - {!recordName} está à espera da sua aprovação`,
"label.chat.topic.delete.prompt1":`A eliminação de um tópico leva tempo, o tópico continuará a ser preservado em posts e registos até que o processo esteja completo.`,
"component_setup_label_displaybutton":`Botão de exibição`,
"label.partnerCloud.backgroundImage":`Imagem de fundo`,
"label.mobile.phone.time.range":`Intervalo de tempo`,
"label.page.url.address.remark":`Introduza o endereço da página web no campo "Link URL". Pode introduzir um URL simples tal como aparece na barra de endereço do navegador, ou pode usar um ou mais campos de fusão para inserir dados específicos da organização do CloudCC.com nos parâmetros do URL. Alguns sites podem não funcionar num separador Web devido às definições de segurança do navegador, ou porque o site se impediu de ser exibido num frame.`,
"label.h5.copyemail":`O e-mail foi copiado`,
"label.view.step3":`Passo 3 Seleccionar os campos a mostrar`,
"label.quickbooks.view.moneyreceived":``,
"label.emailobject.attachment.preview":`Pré-visualização`,
"label.selectapprover":`Seleccionar Autorizador`,
"vue_label_normal_opportunity_sf":`Oportunidade`,
"label_emailtocloudcc_filed_port":`Porto`,
"mesage.errorinsaving":`Ocorreu um erro durante o salvamento. Por favor contacte o seu administrador.`,
"label.partnerCloud.partnerCloudName":`Por favor introduza o nome da nuvem de parceiros`,
"lable.edit.queue.checkemail":`Erro: Endereço de e-mail inválido.`,
"label_builder":`Construtor de páginas`,
"component_setup_label_setupsavefail":`Falha em salvar as definições dos componentes`,
"label.icon.76":`Automóvel`,
"label.reportsSubscriptionPage.schedulereport.monthly":`Mensal`,
"message.nopermession":`Sem permissões`,
"label.view.groupscansee":`Visível a <b>certer grupos de utilizadores</b>`,
"label.leadscore.rule.new":`Lead Scoring Rule: Nova Regra`,
"label.new.ccpeakfolder.time":`Aulas agendadas: Nova Pasta`,
"label.record":`Registos`,
"message.error.flabel":`As etiquetas de campo que forneceu não podem conter aspas simples ou duplas em inglês.`,
"label.emailobject.emaildetail.promptbutton2":`Cancelar`,
"label.h5.phone":`Chamada`,
"label.visualpage.error.deal.with":`Ocorreu um erro, por favor contacte o seu administrador`,
"label.button.step1.select.field":`Passo 1 Seleccionar os campos`,
"label.setsharerule.step1":`Passo 1 Seleccione o seu tipo de regra`,
"component.chatter.file.label.title":`Carregamento de ficheiros`,
"front-epwechat-module-v1-appname":`Nome do aplicativo`,
"chatter.error.notsel":`Erro:Por favor seleccione uma imagem para carregar.`,
"label.updatevalue":`Valor exacto que muda de`,
"label.chatter.sendEmailToGroupMember.subject.D":`{0} documentos publicados para todos em {1}`,
"label_tabpage_grid":`A exibição da grelha`,
"homepage.components.standard":`Componentes padrão`,
"label.movable":`Actividades`,
"label.report.selected.field.cannot":`Os campos seleccionados não podem exceder 50.`,
"label.projectManagement.distribution.by.excess":`Atribuir por horas extraordinárias`,
"addrow":`Adicionar Fileira`,
"label.approvaldatamove.p":`Utilize as seguintes opções para gerir múltiplos pedidos de aprovação. Clique em "Procurar" para filtrar os pedidos de aprovação. Quando os resultados são apresentados numa vista de lista, por favor especifique a acção.`,
"label.passwordPolicy.setup.title":`Políticas de Senha`,
"label.appointmentpage.wizard.title1":`{0} ({1}) está a convidá-lo a`,
"label.tippage.li1":`Eliminar permanentemente a fonte de dados do relatório personalizado`,
"label.campagin.roi.dcl":`Taxa de frequência`,
"label.h5.new.errorbody":`Estes campos obrigatórios com * devem ser preenchidos.`,
"label.cy.enable":`Habilitar moeda`,
"label.currency.rate.e":`Edite as taxas de conversão para as moedas da sua organização.`,
"or":`Ou`,
"lable.custom.Previous.CYt":`Anterior 2 CY`,
"front-epwechat-module-v1-unbound-desc":`A remoção da encadernação irá limpar a conta vinculada. Tem a certeza de desvincular?`,
"pagecreator_button_publish":`Publicar`,
"font-evaluate-module-v1-case-owners":`Notificar o proprietário do caso:`,
"label.pw.new":`Por favor introduza uma nova palavrapasse`,
"message.tabsearch.nokeywords":`Por favor introduza uma palavra-chave com pelo menos um caracter`,
"label.sendemail.send.erroruser":`Utilizador incorrecto`,
"label.personalinfo":`As minhas informações pessoais`,
"label.case":`Casos`,
"lable.product.pricebooks.now":`Livros de Preços Existentes`,
"label.ccpeak.take.notice":`Nota: ID, Número automático, Criado por, Data de criação e outros campos do sistema não precisam de introduzir os valores.`,
"label.page.first":`A 1ª página`,
"label.icon.168":`Visitas`,
"label.choices":`Seleccione`,
"label.is.delete.document":`Tem a certeza de que quer apagar este ficheiro?`,
"homepage.layout.custom":`Layouts personalizados`,
"label.emailobject.template.insert.field":`Campos`,
"label.ccpeak.folder.all":`Todas as Pastas de Classe`,
"front-console-conversation-btn3":`Encaminhar email`,
"label.ems.port":`Porto`,
"label.app.introduce":`Um aplicativo é um grupo de abas que funciona como uma unidade para fornecer funcionalidade. Os utilizadores podem alternar entre aplicações utilizando o menu pendente da aplicação no canto superior direito de cada página.`,
"label.file.library.managemembers.admin":`Administrador da Biblioteca`,
"vue_label_salesadvance_win":`Ganhou`,
"label.email.click.complete.info":`Clique no botão "terminar" para voltar à página anterior.`,
"label.umeng.activity.event.willbegin":`O seu evento #evento começa em #tempo.`,
"label.mobile.phone.week.summary":`Resumo Semanal`,
"label.quickbooks.fieldlabel.terms":`Termos`,
"lable.currencyManage.advcurrencyEnabled.dis":`Permite-lhe gerir taxas de câmbio datadas que mapeiam uma taxa de conversão cambial para um intervalo de datas específico. As taxas de câmbio datadas são aplicadas aos campos de moeda sobre oportunidades, produtos de oportunidade, e os relatórios associados a estes dois objectos.`,
"label.weixin.data.save.failed":`Falha em guardar dados.`,
"label.service.gantt.filter.logic":`Lógica de filtragem:`,
"vue_label_pool_adopt":`recolher`,
"label.emailobject.markasunread":`Marcar como não lido`,
"label_please_select_a_member":`Por favor, seleccione os membros.`,
"label.salescloud.unit.ci":`Unidade(Tempo)`,
"vue_label_pool_obsolete":`descartado`,
"label.cancelall":`Desmarcar tudo`,
"label.exchange.sync.state.setting.m2":`Utilizadores em configurações activas do CloudCC Exchange:`,
"vue_label_pool_claimtime":`Tempo de reclamação`,
"label.forecast.forehistory.history":`História Prevista`,
"label.knowledge.article.record":`O artigo de conhecimento é inqualificável.`,
"label.setting.intergrationlist.button.uninstall":`Desinstalar Integração`,
"label_tabpage_gotit":`Já o tenho`,
"label.data.exp.csvform":`Válido apenas para dados exportados.`,
"UG.Forcast.06":`Por favor, seleccione os utilizadores que estão autorizados a prever`,
"vue_label_report_savereport":`Guardar relatório`,
"setup.object.field.dependency.label.mustone":`Deve seleccionar pelo menos 1 valor do campo dependente.`,
"label.batchadd.newbatchpage.des1":`O campo do nome do registo é obrigatório, e se não o for, o registo não é guardado.`,
"lable.custom.CurrentandPreviousCYt":`Actual e Anterior 2 CY`,
"label.versiontype.Professional":`Edição Profissional`,
"label.customfields.configprofilefieldsafety":`Estabelecer a segurança a nível de campo`,
"label.ccpeak.wgd.time":`Aulas programadas não programadas`,
"component.telerecord.label.subject":`Tema`,
"label_year":`Ano`,
"pagecreator_layout_label_modifylayout":`Editor de layout`,
"label.compact.layout.frame.splitline":`Linha de separação do ecrã direito e do ecrã esquerdo`,
"lable.PowerProcess.enter.the.process":`{describeName} Processo de entrada`,
"label.emailobject.cc":`Cc:`,
"front-electronic-export-choseCount":`Por favor, seleccione os dados importados`,
"label.setup.mobile.bottombutton.recovery.default.success":`Estado? Estado?`,
"label.datamanage.import.accountfield":`Seleccione os campos no ficheiro de importação que devem ser importados para cada conta a partir da lista abaixo. Depois clique em "Próximo Passo":`,
"vue_label_opportunity_related_list":`Acrescentar à lista relacionada`,
"label.group.recent":`Grupos recentemente vistos`,
"vue_label_pool_finalclaimtime":`Tempo de reclamação final`,
"vue_label_homepage_30daysnocontact":`Oportunidades de negócio sem contacto durante 30 dias`,
"label.tianyancha.field.error":`Não foram encontrados dados de Tianyancha, por favor contacte o administrador do sistema para realizar a inicialização`,
"label.product.go":`Ir para Relatórios`,
"label.customsetting.manage.introduce":`Se a configuração personalizada for uma lista, clique em Novo para adicionar um novo conjunto de dados. Por exemplo, se a sua aplicação tivesse uma definição para os códigos de país, cada conjunto poderia incluir o nome do país e o código de marcação.`,
"label.task.dateadd":`Mais`,
"label.email.recipients.select":`Por favor, seleccione os destinatários`,
"chatter.emailListMyChat":`Gosta de um post ou de um comentário que tenha feito`,
"label.batchadd.newbatchpage.save.name":`Se o nome for nulo, o sistema não adicionará este registo por defeito, certifique-se de que o nome não é nulo, e depois guarde-o.`,
"UG_Lead_011":`Criar uma pista`,
"vue_label_salesfunnel_notice2":`Oportunidades totais em curso`,
"APPIntegration_Social_linkedinerror":`Deve introduzir um URL válido para linkedin.com`,
"label.industrialandcommercialverification.enablestatus2":`Nome da Conta de Consulta em Tempo Real`,
"label.stdashbord.xsld.business.ajssx":`Por Função`,
"lable.info.queue.showalluser":`Ver todos os utilizadores`,
"label.generatepage.c1":`Tem de implorar com uma letra. Deve conter apenas letras maiúsculas e minúsculas,números,e sublinhado.`,
"label.thenset":`E depois, de acordo com`,
"label.salescloud.salescloud.defaultteam":`Grupo de utilizadores com oportunidades por defeito`,
"label_partner_workspace_tab_selectedoption":`Separadores seleccionados`,
"label.tippage.li":`Eliminar fonte de dados do relatório personalizado will：`,
"lable.quote.syncingfrom.syncingto":`Os produtos de oportunidade foram sincronizados para citar itens de linha`,
"label.emailobject.delete":`Eliminar`,
"label.data.selectimportobject":`Seleccionar os objectos a importar`,
"label.knowledge.language.dutch":`Holandês`,
"message.campaign.page.overtime":`A página expirou.`,
"label.ccchat.message.search.desc4":`Verificar a ortografia das palavras de pesquisa.`,
"label.login.forgetPsd":`Esqueça a senha`,
"vue_label_title_order":`Encomenda`,
"template.report.contract.follow.status":`Situação do seguimento do contrato`,
"label.forecast.edit.kjnd":`Ano Fiscal`,
"front-electronic-export-listTitle":`Lista de chimpanzés por correio`,
"label.dataimport.error.khmc.notnull":`Erro: é necessário introduzir o nome da conta`,
"label.testobject":`Objecto de teste`,
"label_chatter_nextStep":`Próximo Passo`,
"label.file.public.link.share":`Partilha da ligação pública`,
"label.weixin.organization.name":`Nome da Organização`,
"label.quote.email":`Email`,
"label.reg_field":`Campo regular`,
"font-evaluate-module-v1-response":`Resposta após avaliação:`,
"label.chatter.sendmail":`Enviar e-mail`,
"label.weixin.start.incorrect":`Formato inválido da data de início`,
"component_chatter_link_label_url":`Link url`,
"vue_label_pool_operatecertification1":`{0}{1}{2}`,
"lable.currencyManage.Enabledadvcurrency.agree":`Sim, eu quero permitir a Gestão Avançada de Moeda.`,
"label.east.africa.time":`Tempo da África Oriental`,
"label.product.proof.Three":`Em {0}, por favor escolha um mínimo de {1} opções de produtos, mas até {2}.`,
"label_emailtocloudcc_filed_password":`Senha`,
"component.task.label.person":`* Pessoa designada`,
"pagecreator_systemstyle_label_buttonareacolor":`Cor da área de operação`,
"label.clearrule":`Regras claras`,
"lable.customer.access":`Permissão de acesso à conta`,
"label.finish.wait":`O seu pedido foi processado, por favor tenha o cuidado de verificar a notificação de conclusão na sua caixa de correio.`,
"label.weixin.appr.auditor":`Aprovador`,
"label.tabpage.systemz":`Sistema(s)`,
"label.file.nocan.process.desc":`Incapaz de processar pedidos. não podemos tratar da entrega de conteúdos`,
"label.relationobject.name":`Nome do objecto relacionado`,
"setup.layout.group.relatedlist":`Listas relacionadas`,
"label.generatepage.title":`Página Web para CloudCC`,
"label.page.step3.input.url.information":`Passo 3 Introduzir os detalhes do URL`,
"label.change.to":`Alterar o estatuto de membro da campanha para`,
"label.validate.function.funcFormat.TIMEVALUE":`HORAVALOR(data)`,
"label.partnerCloud.seriesSettings":`Configuração da Família de Produtos`,
"component.timeline.label.1monthahead":`1 mês antes`,
"label.batchadd.senumberpage.selnum":`Seleccionar o número de registos a adicionar`,
"label.downloadapp":`DISPONÍVEL ON`,
"label.dashboardSetup.showmainpage":`Afixado na página inicial`,
"label.h5.nophoneprompt":`O colega não introduziu o número de contacto`,
"label.service.deleteCustomView.wanttoremove.theFilter":`Quer apagar o filtro "{nome}"?`,
"label.appupload.state1":`Carregado em`,
"component_timeline_button_filter":`Filtro`,
"label.passwordPolicy.setup.subtitle":`Definir as restrições de senha e políticas de bloqueio de login para todos os utilizadores.`,
"vue_label_normal_quote_sf":`Citação`,
"label.productsales.today.noevttskaddall":`Não há eventos abertos e tarefas em curso, pode clicar em " " no canto superior direito para adicionar novos eventos e tarefas.`,
"label.projectManagement.no.end.date":`Sem data final`,
"label.sendmail.batch.chosetemplate":`Email em massa: Seleccione um modelo`,
"serviceterritorymember.serviceresource.isactive.notactive":`Este recurso de serviço não está activado. É possível atribuir os territórios de serviço a um recurso de serviço activado.`,
"label.notification.event.overlapEvent.continue":`Continuar`,
"label.appupload.component.type.obj":`Objecto personalizado`,
"label.partnerCloud.financeSetting.basicConfiguration":`Caminho de acesso: Plataforma Pública  Desenvolvimento  Configuração Básica`,
"lable.outlook.detail.info":`Detalhes da Configuração da Sincronização de Troca`,
"vue_label_commonobjects_detail_activity_commingevents":`Próximo evento disponível`,
"coderules.nullvalue2":`Falha de geração. Por favor introduza o valor para 【{0}】,【{1}】 utilizado nas regras de geração.`,
"label.version.sum.workflowrule":`regra(s) de fluxo de trabalho`,
"label.sso.saml.idp.config.enable":`Habilitar o Provedor de Identidade`,
"label.temp.exp.conf":`Tem a certeza de que quer exportar o modelo?`,
"label.department":`Departamento`,
"label.trigger.operation.email.template":`Obter informação sobre modelos de e-mail`,
"label.page.content.frame.height":`Altura da moldura do conteúdo (pixels)`,
"label.ServiceCloud.jinengyaoqiu":`Requisitos de Competências`,
"PageLayout.Search.MultiSearch.001":`Seleccionar até 3 campos.`,
"label.error500":`Oops!Erro...<br />Por favor contrate o administrador...`,
"label.appexchange.download.stop":`Parar a instalação com conflito`,
"label.service.dispatchingUnits.left.right.totalAll":`Actualmente, {esquerda}-{direita} registos, {totalCount} registos no total.`,
"label.tabpage.haschangedz":`Este chumbo foi convertido`,
"label.industrialandcommercialverification.button.cancel":`Cancelar`,
"label.edit.role":`Edição de Papel`,
"label.mr.descreption.condition2":`Regras - de acordo com os primeiros caracteres: por favor introduza um número, encontre as duplicações de acordo com os primeiros caracteres do número introduzido.`,
"label.testgrammer":`Verificar Sintaxe`,
"label.age":`Idade`,
"lable.real.time.chat":`O apoio técnico de conversação em tempo real é fornecido pela Easemob. Por favor, configure configuração avançada em Easmob.`,
"vue_label_opportunity_selected":`{sum} seleccionado`,
"label.weixin.optionone":`Escolha 1`,
"label.file.delete.public.link.desc":`Eliminar a ligação pública significa que ninguém pode aceder ao ficheiro com essa url.se se criar uma nova, será uma URL diferente.`,
"label_tabpage_cancel":`Cancelar`,
"template.report.opportunity.analysis":`Análise da Fase de Oportunidade`,
"label.escalation.setup.newrule.inputrule":`Introduza o nome da regra`,
"label.ccpeak.getapi.name":`Directar o nome API do campo enquanto se obtém o valor recorde:`,
"second":`A Segunda`,
"label_tabpage_uploadsz":`Carregar`,
"label.description":`Notas`,
"label.ccchat.person.invite.notsamepwd":`Palavra-passe incoerente`,
"label.mobile.app.isEnableAblumWatermark":`Adicionar marca de água à fotografia seleccionada a partir de álbuns móveis no checkin`,
"vue_label_allsearch_searchable_items":`Itens Pesquisáveis`,
"lable.outlook.detail.react":`Actividades recentes`,
"label.sales.team":`Equipa de Oportunidade`,
"label.guif.standard.time":`Tempo Padrão do Golfo`,
"label.emailobject.emaildetail.button.forward":`Avançar`,
"label.refused":`Rejeitado`,
"homepage.components.one":`Passo 1 Introduzir o nome do componente personalizado`,
"day":`Dia`,
"label.dataimport.error.number":`Erro: Número`,
"label.customer.tab.step2.same.option2":`Default Off`,
"component_button_ok":`Confirme`,
"label.allrecordmeetprocess":`Todos os registos devem entrar nesta etapa`,
"label.version.onefile.size":`Tamanho de cada anexo carregado`,
"label.partnerCloud.orderingPlatform.allProducts":`Todos os produtos`,
"pagecreator.page.message.publish.success":`Página publicada com sucesso`,
"lable.currencyAdv.exchagecurrency.rate.pro":`Gama Anterior`,
"label.attendance.persons":`Utilizadores Adequados`,
"label.send.an.email":`Enviar um e-mail`,
"registration.page.browser.title":`Registo do Canal de Marketing Campagin`,
"label.importfilestep3":`Passo 2 Seleccionar e carregar o(s) seu(s) ficheiro(s)`,
"lable.currencyAdv.exchagecurrency.rate.next":`Gama seguinte`,
"label.ems.no.sync.msg":`Ainda não configurou a informação de sincronização de correio.`,
"label.total_views":`Prévisualização da submissão do formulário`,
"label.knowledge.article.notnull":`Por favor, escolha pelo menos um artigo.`,
"message.error.view.lastview.delete":`Não é possível apagar a última vista da lista pública</br> Não é possível apagar a última vista da lista pública que é visível para todos os utilizadores.<br>>br>>br>`,
"label.integrations.second.half":`peça(s) de dados, seleccionar os dados importados`,
"vue_label_systemSettings_mobelparams":`Configuração de parâmetros de aplicações móveis`,
"message.choose.maximum":`Pode escolher até 150 registos para partilhar, agora`,
"vue_label_homepage_won&unprocessed":`Aberto Não processado`,
"UG.contact.01":`Como tirar o máximo partido dos seus contactos?`,
"label.data.import.setup.remark":`O administrador pode definir as regras a executar na importação de dados, incluindo se deve executar regras de validação, gatilhos e duplicações e regras de correspondência.`,
"pagecreator_layout_message_delete_success":`Layout apagado com sucesso`,
"lable.account.name":`Nome do Trimestre Fiscal`,
"label.userinfo.must.updatepwd":`Para segurança, deve alterar a sua palavra-passe.`,
"label.mobile.phone.subordinate.setup":`Não é possível definir para conter subordinados, por favor seleccione todos e defina-os para permitir previsões.`,
"label.monitorsys.delete.date":`Apagar Data`,
"label_emailsync_form_emailaddress":`Endereço de correio electrónico`,
"label.projectManagement.cancelled":`Cancelado`,
"label.partnerCloud.partnerAccount.rechargeAmount":`O montante da recarga tem de estar entre 0,1 e 100000000.`,
"label.select.relatedlist.approval.layout":`Seleccionar Listas Relacionadas para exibir no Layout da Página de Aprovação`,
"label.userphoto.thumbnail":`Miniatura`,
"label.assignment.setup.list.rulename":`Nome da Regra`,
"label.emailtemplate.usemergefields":`Fusão de campos em modelo de e-mail`,
"label.tabpage.enabletomobile":`Se deve activar o lado móvel`,
"setup_layout_label_desc":`Descendente`,
"vue_label_pool_abandonreasondiscription":`Descrição do motivo do descarte`,
"label.ems.outputmails":`Enviar servidor de e-mail (smtp)`,
"font-evaluate-module-v1-evall":`Todas as avaliações`,
"front-epwechat-module-v1-unbound-tips":`Os seguintes dados serão esclarecidos após a desobrigação:`,
"label.weixin.number.data":`Dados`,
"front-objectTemplate-V1-UseObject":`Objecto aplicável`,
"label.call.center.configuration":`Configurações do Call Center`,
"vue_label_systemSettings_website":`Portal Web do Serviço ao Cliente`,
"lable.currencyAdv.foreverdate":`Data Permanente`,
"label.globalselect.view":`Ver lista de valores da opção definida`,
"component_newrecords_label_title":`Registos recentes`,
"component_assistant_label_title":`Assistente`,
"label.equals.deletebut.bulk.delete":`Inclui botão apagar, apagar em massa (para Reciclar Lixeira)`,
"label.field.duplicate.error.msg4":`Erro:Dados inválidos.`,
"label.input.right.date":`Por favor introduza o formato da data válida`,
"file.error.notsel":`Erro: por favor seleccione o ficheiro a carregar`,
"label.customcomponent.page.add.title":`Novo Componente Personalizado`,
"message.chooseatleastthreefield":`Escolha pelo menos 3 campos`,
"label.dataimport.system.unnecessary":`o sistema não pode determinar vários`,
"message.login.wrong":`Nome de utilizador ou palavra-passe incorrectos.`,
"label.appupload.install.recheck":`Verifique novamente`,
"label.ems.option":`Opção`,
"label.wei.subject.img":`Ícone de assunto`,
"chatter.emailReceiveOrNotAccept":`Seleccionar esta opção permite o lembrete CCChat, desmarcando esta opção impede-o de receber o lembrete ccchat.`,
"label.icon.46":`Fornalha`,
"label.newpw":`Nova Palavra-passe`,
"font-evaluate-module-v1-praise":`O tipo de avaliação é Positivo`,
"label.help.user":`Guia do Utilizador`,
"label.callcenter.no.searchs":`Nenhuma pergunta relevante para a informação`,
"UG_homepage_007":`Desde o envio de e-mails de acompanhamento até à automatização de campanhas de vendas, desde a criação de fluxos de trabalho utilizando a nossa tecnologia Blueprint até à activação de macros personalizadas, automatizar tarefas diárias e concentrar-se mais na construção de relações.`,
"label.saveandnew":`Guardar`,
"component_salesperformance_label_70finish":`Terminado - não processado (>70%)`,
"lable.account.dp":`Esta página permite-lhe definir anos fiscais personalizados.`,
"label.notification.serviceappointment.injeopardy":`{1}{0} está em estado crítico. Por favor, processar o mais depressa possível`,
"label.workflow.edit.esimaterule":`Erro: não é possível alterar os critérios de avaliação para "sempre que criar ou editar registos" enquanto tiver tempo de disparo associado a esta regra.`,
"label.partnerCloud.basicSetting.feature":`Configurações funcionais`,
"label.sms.companyname.gm.infor":`C.M.W.L.SMS Info (Este serviço apenas suporta a China continental)`,
"vue_label_homepage_components":`Por favor, seleccione os componente`,
"label_chatter_allactivity":`Todas as actividades`,
"label.quickcreate.title":`Criação Rápida de Layouts`,
"label.tabpage.exclusivez":`Excluir`,
"front-service-cloud-transfer-desc":`Ao transferir o proprietário da lista técnica do activo, o activo actual e o próprio activo sob o activo serão mudados de proprietário`,
"label.data.downpage.i.list.desc1":`Durante a importação, os dados que não são importados com sucesso porque os dados estão formatados incorrectamente, ou porque a regra de activação ou validação falha, gera o ficheiro CSV a ser exibido na página actual. Os dados importados com sucesso não serão mostrados na página actual.`,
"template.report.individual.case.status":`Situação dos casos`,
"label.report.export.file.format":`Formato: formato Excel .csv`,
"vue_label_filternotice1":`Ou seja, cada condição de filtro é cumprida ao mesmo tempo, por exemplo: 1 oportunidade de negócio com um montante superior a 1 milhão de oportunidades de negócio, 2 é uma oportunidade de negócio com uma data de contrato estimada igual a este mês, e o resultado da filtragem mostra oportunidades de negócio superiores a 1 milhão este mês; quando <estilo de varrimento="cor: vermelho">o filtro avançado é activado</ varrimento> Quando é necessário filtrar manualmente as condições para a caixa do filtro avançado`,
"label.lead.score.confirm1":`Isto pode levar vários minutes. Receberá um e-mail de confirmação uma vez concluído.`,
"label.scores":`Pontuações`,
"label.dashboard.message.mainnoset":`O painel de bordo doméstico não está configurado`,
"label.customfields.optionlist.fieldvaluelist":`Por favor introduza valores, com cada valor separado por uma nova linha`,
"label.autosearch.title":`Pesquisa Automática de Títulos Completa`,
"label.knowledge.setting.hint.seventeen":`Criar alguns artigos`,
"label_tabpage_closez":`Fechar`,
"label.partnerCloud.orderingPlatform.shoppingCart":`Carrinho`,
"label.recalculate":`Recalcule`,
"label.umeng.approval.approvalmes4obj":`#numsucc records were approved in #obj, #numfailed reocrds were failed failed to approve.`,
"label.appointment.wizard.subtitle2-2":`Para`,
"label.validate.function.funcExplain.AND":`Verificar se todos os parâmetros são verdadeiros. Devolver TRUE se todos os parâmetros são verdadeiros.`,
"label.recordtype.batchaddattachments.remark":`Passo 1 Escolher ficheiro, Passo 2 Arquivo, Passo 3 Clique no botão "iniciar carregamento", carregar ficheiros, Passo 4 Clique no botão para terminar.`,
"label.reportlist.findreport":`Encontrar relatórios`,
"label.partnerCloud.financeSetting.enterAppsecret":`Por favor introduza o Appsecret`,
"label.campagin.roi.query2":`Ver Canais de Marketing ROI`,
"label.sendmail.notice.immediately":`Enviar notificações por e-mail`,
"label.file.library.managemembers1":`Gerir Membros`,
"label.forecast.customforecast.foredis.yclb":`Categoria Previsão`,
"label.no.target.model.available.":`Nenhum modelo indicador disponível. Por favor, criar primeiro o modelo indicador, ou contactar o administrador do sistema.`,
"label.quote.contactname":`Nome de contacto`,
"label.customer.tab.step2.same":`Aplicar um separador de visibilidade a todos os perfis`,
"UG_product_03":`Manual de preços com suporte multi-divisas`,
"label.pc.system.prompt":`Pronta do sistema`,
"homepage.components.description":`Descrição do componente`,
"front-email-payment-safety-code":`Código de Segurança`,
"label.the.extra.reward.group.describes":`Adicionar descrição do grupo de linhas de cotação`,
"label.isEnableVisualpage.new.rightlist":`Páginas Personalizadas Ativas`,
"label.icon.84":`Transformador`,
"label.chat.message.to":`Receptor`,
"lable.product.pricebooks.edit":`Edição do Livro de Preços`,
"label.partner.workspace.member.belong":`Pertence a`,
"pagecreator_systemstyle_message_delete_success":`Estilo eliminado com sucesso`,
"label.salescloud.teamrole.message.chooseatleastone":`Por favor, seleccione pelo menos um utilizador.`,
"label.knowledgebase.self.window":`Janela Idêntica`,
"label.product.cost":`Custo`,
"label.imgfield.remove":`Fotos Claras`,
"label.event.lastweek":`Semana passada`,
"template.report.today.statistics":`Vendas de Hoje`,
"label.emailobject.recipients":`Destinatários({0})`,
"vue_label_commonobjects_view_successfully":`Definir a vista por defeito com sucesso`,
"label.uploadfail.typeerror":`O carregamento falhou, o tipo de ficheiro é inválido.`,
"vue_label_lead_required_fields":`Por favor preencha os campos obrigatórios`,
"front-console-reopen":`Reabrir`,
"message.layout.unique.relatedlist":`Por favor, voltar às restrições únicas da lista relacionada na disposição da página, confirmar e guardar novamente.`,
"label.emailobject.emaildetail.nextactivity":`Próximas Actividades`,
"label.publicgroup.save.error":`Erro: um dos seguintes grupos já é o grupo mãe deste grupo`,
"label.editdefaultshare.tip":`Edite abaixo os seus padrões de partilha em toda a organização. A alteração destas predefinições fará com que todas as regras de partilha sejam recalculadas. Isto pode exigir recursos e tempo significativos do sistema, dependendo da quantidade de dados na sua organização.`,
"label.icon.53":`Automóvel`,
"label.exchange.sync.state.setting.m3":`Utilizadores com endereços de correio electrónico Microsoft Exchange e CloudCC ligados:`,
"label.currency.enable":`Moedas: Activar Moeda`,
"component.timeline.label.past":`Actividades passadas`,
"workflow.action.tasks.assignortype.user":`Utilizador`,
"setup_layout_label_relatedlistsetup":`Configurações da lista relacionada`,
"label.systemadmin":`Administrador de sistema`,
"label_tabpage_allz":`Todos`,
"label.ems.subject":`Assunto`,
"message.recordtype.selectlayout.tip":`Seleccionar a disposição da página que os utilizadores com este perfil vêem para registos com este tipo de registo. Depois de guardar, escolher os valores da lista de selecção que estão disponíveis com este tipo de registo.`,
"label.current.version":`Versão actual do programa`,
"label.sourceoffile":`Sem tradução - Produz um conjunto de ficheiros, por língua, com texto que ainda não foi traduzido`,
"label.file.versionerror":`Por favor, utilize o separador de características do ficheiro na nova versão da interface`,
"label.validate.function.funcExplain.MINUTE":`Minuto de retorno do dia (Dos campos Data/Hora)`,
"abel.setup.mobile.bottombutton.profile.setting":`Personalizar o menu inferior do perfil`,
"label.recycle.dis.tip3":`Seleccione A Minha Lixeira a partir da lista pendente para ver os itens que eliminou. O administrador pode seleccionar Todas as Lixeiras para ver todos os dados da organização que foram eliminados.`,
"message.selectnothing":`Nenhum Seleccionado`,
"label.develop":`Desenvolver`,
"label.tab.lightningpage":`página da versão relâmpago`,
"label.chat.micropost.share.info":`Partilhar`,
"label.block.pricing.editor":`Editor de preços de blocos`,
"label.ccchat.file.unavailable":`Este ficheiro não está disponível`,
"label_component_helper_businesschange_0UntreatActivity":`Oportunidades sem actividade não processada`,
"label.search.setup.obj":`Pode colocar no máximo 100 objectos.`,
"component.setup.button.cancel":`Cancelar`,
"message.longtextareamaxlength":`O comprimento não pode exceder 32.000 caracteres`,
"vue_label_chat_removedby":`Foi retirado do chat de grupo pelo "Administrador".`,
"label.autoRegister.changepwd.setpwd.tip.morechar":`Não pode ser inferior a 8 caracteres`,
"label.informassigner":`Notificar a Pessoa Atribuída`,
"font-evaluate-module-v1-not-received":`Nunca receber qualquer avaliação de satisfação dos contactos`,
"label.trigger.triggertime":`Tempo de disparo`,
"label.attendance.cannot.make":`Incapaz de marcar`,
"label.shouldallrecords":`Todos os registos devem ser incluídos no cálculo`,
"label.eidt.queue.alter1":`Por favor, seleccione os membros da fila`,
"L":`Lista de selecção`,
"label_emailtocloudcc_filed_email":`Email`,
"label.productsales.contract.badversion":`A sua edição actual não suporta a visualização de objectos contratuais, pelo que não pode visualizar os montantes contratuais.`,
"label.tabpage.operation":`Operação`,
"label.file.copy.public.link":`A ligação pública foi copiada`,
"label.all.SMS":`TODOS os alertas SMS`,
"UG_opportunity_008":`Equipa de oportunidade`,
"UG.Campaign.002":`Planear, executar e monitorizar a eficácia das actividades do mercado.`,
"label.jiandangfenpei.title":`Atribuição de Perfil`,
"pagecreator.systemstyle.message.delete":`Apaga o actual estilo seleccionado?`,
"lable.outlook.mcto.repeat":`Se forem encontrados registos duplicados, o e-mail é associado com o`,
"label.user.field":`Campos de utilizador`,
"vue_label_commonobjects_detail_market_hierarchy":`Hierarquia do mercado`,
"label.ems.emails":`Emails`,
"label.tabpage.deleteviewfailed":`Ver apagar falhou`,
"label.data.exp.new.expobjtemp":`Criar o modelo do objecto exportado`,
"label.useformulassetval":`Usar fórmulas para definir novos valores`,
"label.service.newBuildDialog.six.fields":`Podem ser seleccionados até 6 campos.`,
"error":`Erro`,
"template.chart.sdyyfx":`Análise da Razão Perdida`,
"label.icon.191":`Bigode`,
"label.app.step3.tabused":`Separadores seleccionados`,
"label.user.level":`Nível do utilizador`,
"label.custombutton.querydata.notexist":`Os dados não existem.`,
"label.executestate.calculating":`Calculando...`,
"label.visualpage.folder.notdel2":`1.Esta pasta contém ficheiros e não pode ser apagada.2.Esta pasta contém ficheiros escondidos e não pode ser apagada. Um ficheiro oculto é tratado a partir de um objecto de eliminação lógica (eliminar de Setup-Create-Obkects), que está oculto porque o objecto não é realmente eliminado.`,
"vue_label_report_conditiondesc_three":`Será notificado se todas as condições forem cumpridas`,
"approval.request.email.subect":`Pedido de Aprovação`,
"label.log.user.value":`Por favor, introduza o nome de utilizador para pesquisa!`,
"label.isCompanyCurrency":`Empresa`,
"label.related.2018":`Listas relacionadas`,
"label.tonga.time":`Tempo Tonga`,
"message.actionfailed":`A acção falhou`,
"label.’s":`'s`,
"label.custombutton.queryobj.notnull":`A identificação do objecto da consulta não pode ser nula.`,
"label.list.userinterface.setup":`Interface do utilizador`,
"front-kefu-moudle-v1-yxgsbzq-reinput":`O formato do email é incorrecto. Por favor, reentrar`,
"label.chatter.content":`Conteúdo`,
"label.projectManagement.Addnotes":`Adicionar Notas`,
"label.service.newBuildDialog.reservation":`Mostrar encomendado`,
"label.ccchat.pm":`PM`,
"vue_label_chat_cannot_invite_users":`Os não membros do grupo não podem convidar os utilizadores a participar em chats de grupo`,
"label_partner_workspace_member_belong":`Pertence a`,
"label.task.modify":`Edição de tarefas`,
"label.tabpage.transformationsz":`Converta`,
"label.new.password.no.indexof":`A nova palavrapasse não pode conter caracteres e espaços chineses.`,
"label.ji.quarter":`No. {a} Trimestre`,
"label.sso.isActiveNo":`Não`,
"label.mobile.phone.week.report":`Notas de trabalho semanais`,
"label.email.template.please.select.folder":`Por favor escolha uma pasta`,
"label.pc.ui.2018.tab.groups":`Grupo de menu`,
"label.h5.approval.status":`Estado de Aprovação`,
"setup.mainpage.label.welcome27":`A plataforma CloudCC fornece funções como a importação, exportação, eliminação de lotes e transferência de lotes de todos os dados de objectos no sistema.`,
"vue_label_systemSettings_setHomePage":`Configuração Casa`,
"label.select.button":`Botões disponíveis`,
"label_emailsync_status_enable":`Ligação Activa`,
"label.trigger.triggerVersion.detail":`Este campo não é editável. Existem actualmente duas versões de gatilhos, 1.0 e 2.0, e todos os novos gatilhos são 2.0, a versão 1.0 foi proibida de ser criada.`,
"pagecreator_layout_message_save_fail":`Falha no layout`,
"label.salescloud.salesdashboard.10big":`Top 10 Oportunidades nos próximos 3 meses`,
"label.file.share.size":`A quota maxinum e publiclink de cada ficheiro é`,
"label.page.simple":`Simples`,
"pagecreator.page.message.delete":`Apaga a página actualmente seleccionada?`,
"label.weixin.newspaper.coverage.detailinfo":`Informação detalhada da Ficha de Risco`,
"label.list.userinterface.chattersetup":`Definições de CCChat`,
"lable.opppdt.addpdt.table.quantity":`Quantidade`,
"label.product.description":`Descrição do produto`,
"button_partner_back":`Regresso`,
"label.user.current.loginuser.sessionid":`O SessionID do utilizador actualmente registado é o SessionID:`,
"label.otherreport":`Outros relatórios`,
"pagecreator_button_mobilepage":`Lado móvel`,
"label.mobile.phone.state":`Estado`,
"lable.currencyManage.unenableCurrencyAdv":`Desactivar a Gestão Avançada de Moeda.`,
"lable.product.addp":`Acrescentar Preço`,
"label.field.validate.notpass":`Sem erros de sintaxe.`,
"label.app.global.search.obj":`Até 10 objectos que pode configurar para utilizar na pesquisa global.`,
"label.group.archived":`Arquivo`,
"vue_label_approve_to_submit":`Para submeter`,
"showfrom":`Mostrar a partir de`,
"chatter.emailNotification":`Notificações por e-mail`,
"label.callcenter.pleaseenter.enterprise.number":`Por favor, introduza o nº de empresa.`,
"label.forecast.customforecast.forecastnumber":`Números Previstos`,
"label.vlidaterule.messagelocation":`Localização do erro`,
"label.h5.similar.opportunity.step3.conment":`A coluna Relevância, que representa o número de campos correspondentes, será sempre exibida.`,
"label.ccchat.group.gd.setting.info":`Modificar as definições do grupo CCChat`,
"label.knowledgebase.delete.article.succeeded":`Eliminar artigo com sucesso`,
"message.layout.edit":`A gestão da disposição da página é uma função separada de valor acrescentado. Se a sua organização confirmar que adquiriu o módulo de função, peça a password ao administrador do sistema. Contacte o CloudCC.com para saber mais.`,
"label.case.create":`O caso ({0}) é criado`,
"label.icon.170":`Compras`,
"message.error.contact.null":`O contacto não pode estar vazio`,
"label.appupload.install.error.hasinstalled":`Este pacote de software já está instalado na sua organização. antes de instalar a nova versão, é necessário desinstalar primeiro a versão instalada.`,
"label.service.miniProgram.imageType":`São suportados os formatos PNG, JPG e JPEG. São recomendadas imagens de 750*349 pixels. Passe o rato sobre a imagem para a recarregar ou apagar.`,
"label.leadscore.rule.edit":`Lidera a regra da pontuação: Regra de edição`,
"vue_label_commonobject_anytime":`A qualquer momento`,
"label.clearing.conditions":`Condições claras`,
"label.campagin.roi.ydkhjhze":`Quantidade total de oportunidades de clientes ganhas`,
"Lead_Auto_Scoring_Setting_001":`Pontuação automática ao editar ou guardar (excepto os cabos que são importados em lote ou criados por interface)`,
"pagecreator.systemstyle.label.buttonareacolor":`Cor da área de operação`,
"label.batchregist.huanxinuser.finish":`A inscrição de utilizadores em massa foi concluída`,
"UG_opportunity_006":`Génio de oportunidade`,
"message.serviceappo.violation":`Violação do período de atribuição: está em conflito com outras nomeações de serviço.`,
"label.recordtypeselect.selectnew":`Seleccionar novo tipo de registo`,
"Lead.Tools.BatchScoring":`Pontuação de Lotes de Chumbo`,
"label.partnerCloud.financeSetting.enterWechat":`Por favor, introduza a conta de comerciante WeChat.`,
"label.philippine.time":`Hora das Filipinas`,
"five":`Cinco`,
"label_average_value":`AVERAGEM`,
"message.realdelete":`Tem a certeza?`,
"label.currency.note":`Introduzir informação para a nova moeda. Note que não pode eliminar uma moeda depois de a activar.`,
"label.projectManagement.delete.prompt":`Eliminar Pronto`,
"label.approval.present":`(Actual)`,
"label.escalation.setup.newrule.name":`Nome da Regra`,
"label.edit.list":`Lista de dados editável`,
"label.partnerCloud.financeSetting.informationOne":`1. Visite o centro comercial Alipay (b.alipay.com) e inicie a sessão com o assinante Alipay.`,
"label.customfields.numberText":`2.A soma do comprimento do número introduzido e o número de casas decimais não deve exceder 18 casas.`,
"label.biaoqing.businessverify.relation.tip":`Escreve o valor devolvido do proponente no campo de chumbo`,
"label.icon.149":`Robô`,
"System.btn.SaveAndCommit":`Guardar & Submeter`,
"label.calendar.many":`Multi-Utilizador`,
"label.ccchat.create.email":`O Email foi criado`,
"template.report.income.marketing.activities":`Relatório de receitas da campanha`,
"label.ccchat.person.invite.needemail":`Introduzir um endereço de correio electrónico.`,
"template.report.open.amount":`Montante não fechado`,
"label.currentoperate":`Acções seleccionadas`,
"label.finalapprove":`Aprovação final`,
"label.emailmerge.mergepage.step2":`2. Seleccionar o modelo de fusão de correio, até 20:`,
"label_tabpage_sorttypez":`Tipo de ordenação`,
"label.workbanch":`A minha bancada de trabalho`,
"font-evaluate-module-v1-disable":`Tem a certeza de desactivar this？`,
"label.ServiceCloud.distributionMap":`Mapa de distribuição`,
"lable.Confirm.potential.customers":`Confirmar para recolher {num} leads.`,
"label.mobile.quickcreate.default.nearby":`Perto de`,
"label.isremider.noremider":`Sem Lembrete`,
"label.approval.select.step":`Seleccionar qual o passo de aprovação a devolver`,
"chatter.error.pm":`Erro:O tamanho do ficheiro é demasiado grande.`,
"UG_activity_08":`Reservar um horário`,
"label.marketsea.notwinopportunitydays":`Número de dias sem negócio (tem de ser maior do que o número de dias sem criar uma oportunidade de negócio)`,
"label.selectpage":`Seleccione uma página existente`,
"label.dashboard.dispalyOnTheHomePage":`Página de entrada despalhada`,
"front-lightning-module-v1-details-page-chart-set-report":`Elaborar relatório`,
"vue_label_pool_mydeal":`O meu acordo`,
"vue_label_report_lastone":`Último`,
"label.tabpage.potentialcustomersz":`Líderes`,
"font-evaluate-module-v1-more-satisfied":`Nós não somos bons enough。 Vamos deixálo mais satisfeito da próxima vez!`,
"label.trigger.instructions":`<p>Instruções Para Use：</p>>p><li>Parametros podem ser directamente citados:(DataContext)context,(UserInfo)userInfo,(Map)record_old,(Map)record_new</li>>li>Quando quiser obter o valor do registo, por favor "obtenha" directamente o nome do campo API do campo</li><li>Se criar um novo registo,use "String id = IDGenerator".generateID("ID Prefixo")"</li><li>>If Need Return Error Message:Please Use "trigger.addErrorMessage("")";trigger Will Return At Current Line,No Longer Execut Down！</li></p><font color="red">Note:Maximum Support 200KB Characters,About 200,000 Bytes.</font><font size=3 color="red">【Key：Must Add Notes!】</font>`,
"lable.SalesCommitmentKanBan.commitmentToCompletionRate":`Taxa de Conclusão de Compromisso`,
"label.umeng.approval.dlsp.approvenew":`Aprovação delegada: #actorname pede aprovação #objapiname#recordname`,
"label.edit.visualpagefolder":`Página Personalizada : Editar Pasta`,
"label.pc.flash.teach":`Ensino de vídeo`,
"label.showsearch":`Mostrar Pesquisa`,
"label.reportsSubscriptionPage.condition.title1":`Será notificado quando todas as condições forem cumpridas(AND)`,
"label.h5.search.result":`Conde`,
"vue_label_commonobjects_view_chart_pie":`Gráfico de tartes`,
"label_please_enter_currency":`Por favor, introduza a moeda`,
"chatter.share.to.profile":`O seu perfil`,
"label.mykeeptouchset":`As minhas definições de "Keep In Touch`,
"label.profile.mustcopyaprofile":`É necessário seleccionar um perfil existente para clonar.`,
"label.managereport":`Gerir Relatórios`,
"label.total.choice":`ficheiros, seleccionados`,
"label_emailtocloudcc_help":`Por favor, introduza a palavra-passe ou o código de autorização correcto do e-mail. Se o seu servidor de e-mail precisar de ligar o serviço IMAP/SMTP para iniciar sessão por uma conta de terceiros, deve iniciar sessão nas definições da conta de e-mail para activar primeiro o serviço, e copiar o código de autorização aprovado para esta caixa de introdução de palavra-passe.`,
"label.trigger.sel":`Gatilhos nesta pasta`,
"label.dashboardLookUp":`Ver Painéis de controlo`,
"label.batchadd.newbatchpage.save.emptytext":`Por favor, verifique se existem informações necessárias não preenchidas.`,
"setup.mainpage.label.welcome16":`Instruções: Clique no menu do lado esquerdo da página → Application Settings → Create → Workflow, Approval Process, Tasks, Email Notification, Field Update, e muito mais.`,
"vue_label_email_mark as":`Marcar como`,
"label.customobjdel.cannot.delete.try":`O objecto não pode ser apagado porque está associado com a seguinte relação de outros objectos.`,
"label.customsetting.visible.public":`Público`,
"label.log.bit":`Bits`,
"label.data.exportall.all.desc":`Exporta todos os dados para todos os objectos que o utilizador actual tem permissão para ver.`,
"message.login.mfadevice.already.bound":`O utilizador já vinculou o dispositivo AMF.`,
"label.campaign.channel.please.img":`Por favor, carregue a imagem`,
"assetbom.manage.notpermission":`Por favor contacte o seu administrador para permitir o acesso à gestão de lista técnica de activos.`,
"schedstarttime.schedendtime.time.illegal":`A hora programada de início da marcação do serviço deve ser inferior ou igual à hora real de fim.`,
"label.referperson":`Proprietário`,
"front-email-payment-area":`Distrito`,
"label.c.d.least":`Cada registo "C" deve ter pelo menos um registo "D" relacionado.`,
"label.weixin.longitude.isnull":`Longitude e latitude estão vazias ou inválidas`,
"setup.layout.button.ok":`Confirme`,
"vue_label_fiter_component_date_customdate":`Data personalizada`,
"label.enable.case.createarticle":`Permitir aos utilizadores a criação de artigos a partir de casos.`,
"label.event.moveup.8hour":`8 horas à frente`,
"label.input.most.string":`Por favor introduza até {0} caracteres`,
"lable.SalesCommitmentKanBan.contractEndDate":`Data de fim do contrato`,
"label.visualpage.function.name":`Nomear a função a ser:`,
"label_emailtocloudcc_redmessage1":`Endereço de e-mail inválido`,
"message.aliasnameinput":`Erro: O nome deve ser único, e implorar com uma carta. Deve conter apenas letras e números.`,
"label.data.exp.selectedtemp":`Seleccionar o modelo utilizado para a exportação de dados`,
"label.import.page1.suitedwayoflinkman":`Estilo de correspondência de contacto`,
"label.customsetting":`Configurações personalizadas`,
"label.versiontype.Free":`Plano Livre`,
"setup.layout.label.norelatedlist":`Nenhuma lista relacionada`,
"label.forecast.edittotal.de.leiji":`Rollup a partir de`,
"label.customfields.file.max":`O ficheiro carregado é demasiado grande,por favor não exceda 5m`,
"label_partner_all_workspace":`Espaço de trabalho`,
"label.searchrelation":`Relação de pesquisa`,
"label.icon.185":`Consultoria`,
"label.service.gantt.effective":`Válido`,
"label.newreportstp1":`Passo 1 Seleccionar formato tabular`,
"label.category.9":`Fabrico`,
"label.zuowei":`Como`,
"front-quotation-v1-select-quota":`Seleccionar citação`,
"label.dashboard.refresh":`Actualizar`,
"label.weixin.saveandnew.log":`Guardar`,
"label.report.list":`Listas de relatórios`,
"FL":`Ficheiro`,
"label.h5.followingcolleagues":`Colegas em pousio`,
"template.report.conversions.number":`Número de conversões de leads (Por Proprietário)`,
"label.validate.function.funcFormat.MONTH":`MÊS(data)`,
"front-kefu-moudle-v1-tenant-ID":`Identificação do locatário`,
"label.reportsSubscriptionPage.schedulereport.monthly.time":`Hora`,
"label.multilang.workflow.everyotherday":`Todos os {0} dias`,
"label.chat.message.send.message":`Enviar informação`,
"label.knowledgebase.fast.operation.error":`Erro de Funcionamento Rápido`,
"label.multilang.dupicatecheck.dumplicatedata":`Nos registos {0}, foi encontrado um total de {1} grupos de dados duplicados que satisfazem a condição, e a consulta demorou {2} milissegundos. Cada página mostra {3} grupos de dados.`,
"vue_label_report_addFile_detail_Information":`Exportar apenas 2000 linhas de detalhe. Utilizar estes dados para cálculos adicionais, ou carregar para outros sistemas.`,
"label.ccchat.message.search.desc3":`Dicas de pesquisa`,
"message.deletereport.prompt":`Não é possível apagar este relatório`,
"pagecreator.page.message.save.success":`Página guardada com sucesso`,
"vue_label_rise":`Ascender`,
"label.appupload.install.error.choicehead":`Como lidar com se os componentes existentes no sistema entram em conflito com os componentes a serem instalados?`,
"message.dispatch.violation":`Violação do tempo de atribuição: o período de atribuição não está dentro do intervalo de tempo de trabalho dos recursos.`,
"label.tool":`Ferramentas`,
"label.sso.saml.idp.downloadcert":`Descarregar Certificado`,
"label.chatter.detailinfo":`Informação detalhada`,
"label.area.tree":`Territórios Hierachy Tree View`,
"label.partnerCloud.priceOfManual.notEnabled":`Não Activar`,
"label.chosesubject.call":`Chamada`,
"label.leadscore.rule.detail":`Leads Scoring: Pormenores de Regra`,
"front-welcome-to-try":`Bemvindo ao Julgamento`,
"label.umeng.activity.event.willbegin1":`O evento #evento começa em #tempo.`,
"component.event.label.noevent":`Parece que completou o seu trabalho hoje.`,
"label.document.templatesetof.folder":`Conjunto de pastas modelo`,
"label.quickbooks.none":`Sem correspondência found，Please digite um nome para pesquisar ou criar um novo cliente`,
"label.assignment.setup.newrule.inputrule":`Introduza o nome da Regra de Atribuição`,
"label.appointmentdetail.wizard.title4":`Nome da empresa`,
"label.malaysia.time":`Hora da Malásia`,
"label.partnerCloud.partnerAccount.way":`Método de recarga`,
"label.roleoflinkman":` Função de contacto`,
"mesage.error.role.delate.user":`A função não pode ser eliminada porque atribuiu os utilizadores.`,
"chatter.warning":`Advertência: Se seleccionar um objecto diferente, as suas alterações não serão guardadas. Tem a certeza de que quer fazer isto?`,
"label.service.gantt.violations.sum":`Nomeações de serviço com violações`,
"label.permission.objectpermission.recordfenpei1":`Tipos de registos atribuídos`,
"label.mobile.phone.required.plan":`O plano é necessário`,
"label.after_leaving":`Os dados actuais não serão guardados após a saída`,
"label.cpq.opportunity.mainquote.trasnfer.order":`Houve uma citação primária sob a oportunidade e transferida para encomenda.`,
"component.setup.iframe.label.title":`Personalizar página`,
"visit.dispatchplatform.nopermission":`Permissão negada: Não está autorizado a aceder à consola de despacho. Por favor contacte o administrador.`,
"label.validate.function.funcExplain.RIGHT":`Retorna o número especificado de caracteres a partir do fim de um texto`,
"component.chatter.link.button.save":`Publicar`,
"label.knowledge.selection":`Cada Conhecimento tem um máximo de 8 grupos de dados que podem ser seleccionados.`,
"chatter.email.homePage":`Envie-me uma mensagem na minha página inicial do CCChat`,
"vue_label_commonobjects_view_copy_view":`Vista de cópia`,
"label.documentmessage":`Detalhes do documento`,
"label.emailtocloudcc.step1":`Passo 1`,
"label.user.mfa.unbind":`Desobrigar a AMF aos utilizadores seleccionados`,
"label.stdashbord.xsld.business.sdzje":`Montante Total(Oportunidades Fechadas-Perdidas)`,
"vue.please.select.the.total.method":`Por favor, seleccione o modo de somatório.`,
"label.stdashbord.xsld.business.img1":`Número de etapas com uma probabilidade de 1%  99%`,
"label.reportsSubscriptionPage.condition.title":`Para além de subscrever, pode estabelecer condições sobre este relatório. Será notificado quando as condições forem cumpridas. Isto é opcional.`,
"chatter.sel.field":`Erro: São seleccionados mais de 20 campos.`,
"label.login.access.year":`Ano`,
"label.dashboard.all":`Todos os painéis de bordo`,
"label.approver":`Aprovador`,
"Lead.Homepage.Tools.BatchScoring":`Pontuação do Lote`,
"lable.opppdt.selPdt.lesscondtions":`Menos filtros`,
"label.integrations.action.export":`Exportação`,
"label.datamanage.lookupandsure":`(Ver e confirmar)`,
"label.email.attach.to.mail":`Anexar ao e-mail`,
"message.nodataordeleted":`Os dados não existem ou foram apagados`,
"component_newrecords_label_all":`Ver tudo`,
"lable.currencyAdv.startdate.rate":`Mostrar todas as tarifas definidas para a data de início no seguinte intervalo`,
"label.callbackoperate":`Acções de recall`,
"label.knowledge.setting.hint.eighteen":`Começar a criar um artigo para o conhecimento`,
"label.user.step4.submit.email":`Passo 4 O seu e-mail enviado reuest foi submetido`,
"label.appointment.wizard.subtitle4-1":`Tempo de viagem entre eventos`,
"component.assistant.button.newtask":`Nova Tarefa`,
"label.icon.129":`Cartão`,
"label.relatedlist":`listas relacionadas`,
"label.report.recently":`Visto recentemente`,
"label.batchadd":`Adição em massa`,
"front-template-V1-Delete-succeeded":`"{currentTelmplateName}" é apagado com sucesso`,
"label.appupload.upload.otherdetail":`Detalhes adicionais`,
"label.emailobject.link":`Ligação:`,
"label.quickbooks.createcustomer":`Criar Cliente no QuickBooks`,
"report.label.projectcount":`itens, ordenar pelo nome do relatório`,
"vue_label_normal_contact_sf":`Contacto`,
"chatter.group.groupActivities":`Todos os Grupos`,
"label_tabpage_addoptionsz":`Adicionar opções`,
"label.knowledgebase.submit.for.translation":`Submeter para tradução`,
"vue_label_pool_notallowed":`A natureza do negócio não é permitida`,
"label.icon.80":`Fabrico de papel`,
"label.readonlys":`Apenas leitura`,
"label.recordsediting":`Capacidade de edição de registos`,
"label.mr.title.email":`Email`,
"label.partner.all.enable":`Habilitar`,
"label.customsetting.manage.errmessage":`Manter campos personalizados antes de gerir os dados.`,
"label.cloudccclass.list.cls":`Classe`,
"label.weixin.click.loadall":`Clique para carregar tudo`,
"label.weixin.appr.initialtime":`Tempo Submetido`,
"UG_ST_002":`Determinar`,
"setup_mainpage_label_welcome17":`Definições de permissões`,
"label.appupload.state0":`Não Carregado`,
"label.icon.115":`Casa`,
"setup_mainpage_label_welcome5":`Campo personalizado`,
"lable.custom.year.ovdate":`Data de fim de ano personalizada`,
"label_tabpage_findz":`Pesquisa`,
"label.appupload.uploading":`Carregamento...`,
"setup.mainpage.label.welcome1":`Necessidade de permissão correspondente`,
"label.file.folder.delete2":`Eliminar biblioteca?`,
"2018UI_Homepage_DataNoAccess_Info":`Não tem permissão para ver este registo, por favor clique para voltar ao passo anterior.`,
"label.ems.google":`Google`,
"label.hawaii.aleutian.standard.time":`Havai-Aleutian Standard Time`,
"template.report.unfinished.tasks":`Tarefas inacabadas`,
"vue_label_calendar_add_calendar":`Adicionar calendário`,
"label.button.sel.useremail":`Enviar e-mail a utilizadores seleccionados`,
"user.email.template":`Caro{nome do utilizador}：<br>O código de convite de [{Campaign.name}] mostra o seguinte<br>{Campaign.ColleagueInvitationLetter}<br>e o URL is：<br>{Campaign.ColleagueInvitationLetterLink}<br>Registo do código QR e registo do link URL são suportados para a presente campanha! Obrigado pelo vosso apoio! <br>Marketing Executive:{Campaign.Owner}`,
"label.forecast.settings.shouru":`Receitas`,
"label.casesensitive":`Tratar "ABC" e "abc" como valores diferentes (sensível a maiúsculas e minúsculas)`,
"message.pleaseinputrightdistanceweek":`Por favor preencha a semana de intervalo correcta.`,
"label.linellae-group":`agrupamento de colunas`,
"label.showdefault_times":`Mostrar tempo de publicação por defeito`,
"label.smstemplate.finishmessagedetailinfo":`Completar os detalhes do modelo SMS`,
"label.service.miniProgram.backgroundImage":`Imagem de fundo`,
"label.recentview.news":`Registos mais recentes`,
"label.reportType.chose.and.form":`Seleccionar a fonte de dados do relatório e um formato de relatório`,
"setup.layout.button.additem":`Adicionar os artigos seleccionados`,
"front-epwechat-module-v1-auto-mate":`Automatch`,
"vue_label_helpcenter_contract&plan":`? Um contrato é um acordo escrito entre as partes. Muitas empresas utilizam contratos para definir termos para a realização de negócios com outras empresas. Utilize o Cloud CC para estabelecer e documentar os seus contratos existentes com os seus clientes e oportunidades de negócio. Acompanhe o contrato através do processo de aprovação.<br>?Assista à função de contrato e administre as suas transacções através do plano de recolha.`,
"label_mobile_version_nonsupport_feature":`Esta característica não é suportada na versão actual. Por favor, actualize para a versão mais recente.`,
"label.icon.44":`Incêndio`,
"label.data.downpage.i.title.num3":`3、BBefore importando, certifique-se de importar todos os registos relacionados. Por exemplo: se houver uma relação de pesquisa entre os objectos que está actualmente a importar e os contactos, deve importar primeiro os contactos e depois importar os seus dados.`,
"label.mr.object.customer":`Contas`,
"label.social.user.null":`A informação do utilizador de Social não pode estar vazia`,
"front-epwechat-module-v1-unbound-item2":` todos os dados das definições da aplicação`,
"label.partnerCloud.partnerAccount.noempty":`O montante da recarga não pode estar vazio.`,
"label.weixin.myapproval":`As minhas aprovações`,
"label.data.setok.e_desc1":`Exportar com sucesso, receberá um sistema de alertas de mensagens,os dados derivados são temporariamente armazenados no servidor, o sistema apenas para poupar 48 horas, por favor, o mais rápido possível para`,
"lable.batchadd.service.cfq.after":`Gatilhos (Após Inserção)`,
"label.umeng.activity.youhaveanevent":`Tem um novo evento.`,
"label_emailsync_status_connectaccounts":`Conta de e-mail conectada`,
"label.multilang.shenpi.count":`Um total de {0} records：`,
"pagecreator.page.message.delete.fail":`A eliminação da página falhou`,
"label.version.sum.lookupmdfield":`Campos de Relacionamento Master-Detail`,
"vue_label_pool_clueduplication":`Dica Duplicada`,
"label.system.setup.log":`Registo de Comportamento do Sistema`,
"label.globaloperation.operationtype.send.e-mail":`Enviar e-mail`,
"vue_label_pricebook_entry":`Nova entrada na lista de preços`,
"label.forecast.forehistory.submit.date":`Data/Hora de entrega`,
"chatter.handle":`Em que está a trabalhar?`,
"lable.SalesCommitmentKanBan.complete":`Montante Completado`,
"label.weixin.upload.pictures":`Carregar imagem`,
"label.create.document":`Novo Documento`,
"vue_label_commonobjects_detail_unlockconfirm":`Confirmar para desbloquear?`,
"label.customer.page":`Separadores de páginas personalizados`,
"button.partner.workspace.saveas":`Salvar como`,
"setup.layout.label.asc":`Ascendente`,
"label.ccpeak.folder.time":`Pastas de Classe Programadas não arquivadas`,
"label_tabpage_includez":`Incluir`,
"label.custom.button":`Botões personalizados`,
"label.weixin.binding":`Bind`,
"P":`Porcentagem`,
"chatter.stop.n":`Pare de seguir este registo`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.wednesday":`Quarta-feira`,
"template.report.revenue.marketing.activities":`Receitas da campanha`,
"lable.SalesCommitmentKanBan.theActualReceipts":`Recibos reais`,
"vue_label_popularresults":`Resultados Populares`,
"label.log.belongs":`Parte subordinada`,
"label.profile.remark":`Os utilizadores com este perfil têm as permissões e layouts de página listados abaixo. Os administradores podem alterar o seu perfil editando informações pessoais dos utilizadores.`,
"label.appupload.component.type.button":`Botão`,
"label.partner.all.operate":`Operação`,
"vue_label_notice_modify_fail":`Não editar`,
"label.icon.137":`Terra`,
"front-dialog-module-v1-nosupport-copy":`O clone não é suportado`,
"label.integrations.mailchimp.massage3":`Integração desinstalada com sucesso`,
"UG.opportunity.010":`Criar uma transacção`,
"front-lightning-module-v1-details-page-chart-selecting-reports":` Só pode escolher relatórios públicos, ou seja, relatórios com acesso para todos os utilizadores, e relatórios públicos não arquivados.`,
"System_btn_SaveAndCommit":`Guardar e Submeter`,
"vue_label_dashboard_statisticaltype":`Por favor seleccione o tipo estatístico`,
"label.mr.object.opportunity":`Oportunidades`,
"label.area.detail.remark":`Ver Utilizadores neste Território`,
"label.view.sortview.index":`Encomenda`,
"label.mobile.quickcreate.default.events":`Eventos`,
"label.product.price":`Preço de venda`,
"label.leadmarketsea.edit.title":`Edição do grupo de líderes`,
"pagecreator.layout.button.edit":`Editar layout`,
"label.addressee":`Destinatários`,
"label.movablesearchlayout":`Layouts de Pesquisa de Actividade`,
"label.ems.confirm":`Confirme`,
"vue_label_file_save_to_file":`Guardar em ficheiro`,
"component_chatter_button_more":`Ver mais detalhes`,
"label.ccdocument.hidden.trace":`Vestígios ocultos`,
"label.partnerCloud.maximumTwo":`É suportado um ficheiro máximo de 2M.`,
"label.event.moveup.4hour":`4 horas à frente`,
"label.batchadd.save":`Adicionar falha na partilha`,
"label.passwordPolicy.setup.expireDate":`A palavra-passe do utilizador expira em`,
"label.workflowrule":`Regras de fluxo de trabalho`,
"vue_label_notice_pleaseselecview":`Por favor seleccione uma vista`,
"label.h5.chatter.colleagues":`Sobre os colegas`,
"lable.opppdt.addpdt.subtitle":`Adicionar Produto a`,
"label.data.import.setup.repeat.no":`Não inserir todos os registos no meu ficheiro de importação.`,
"label.changeCorporate":`Mudança de moeda da empresa`,
"label.customfields.dateandtime.tip":`Permite aos utilizadores introduzir uma data e hora, ou escolher uma data a partir de um calendário popup. Quando os utilizadores clicam numa data no popup, essa data e a hora actual são introduzidas no campo Data/Hora.`,
"label.integrations.mailchimp.massage1":`Por favor seleccione 1 registo pelo menos para exportar`,
"lable.PowerProcess.custom":`Com base em condições personalizadas`,
"label.service.editDialog.displays.service.appointmentsFordays":`Mostrar nomeações de serviço de {} dias antes da data de nível e {} dias após a data de nível.`,
"label.Receivables.ActualMoneyTime":`Data de Recepção Real`,
"label.matrixreport.intro":`Os Relatórios Matrix mostram dados resumidos calculados em termos horizontais e verticais em forma de grelha.`,
"message.validation.isnotnumber":`Por favor, introduza o número inválido.`,
"label.partner.workspace.member.search":`Pesquisa`,
"label.customfields.deletewill":`A eliminação de um campo personalizado irá:`,
"label.content":`Conteúdo`,
"component.setup.button.weburl":`URL externa`,
"setup.mainpage.label.welcome28":`Instruções: Clique no menu do lado esquerdo desta página → Gerir Configurações → Gestão de Dados → Importação e Exportação de Dados, Transferência de Lote, Eliminar Lote.`,
"label.related.setup":`Definição de tarefas e eventos`,
"label.weixin.sign":`Caro,já assinou,não há necessidade de o fazer novamente`,
"label.norecord":`Sem Registos`,
"label.emailmerge.detail.emailtempldatemerge":`Modelos de fusão de correio`,
"label_emailsync_status_role":`Papel`,
"label.mobileapp.modelsetting2":`Seleccione módulos que satisfaçam as suas necessidades empresariais<br>Activate：allows módulos seleccionados para mostrar em More Standard Function<br>Deactivate: os módulos seleccionados não poderão ser mostrados em More  Standard Function.`,
"component.sendmail.label.title":`Enviar e-mail`,
"component_assistant_button_newevent":`Novo evento`,
"label.chatter.input":`Por favor introduza o conteúdo`,
"message.error.view.operate.rtnlink":`Clique<a href='javascript:history.back();'>here</a> para voltar.`,
"lable.new.profile":`Novo perfil`,
"label.custom.field.null":`Não há disponível`,
"label.reportsSubscriptionPage.schedulereport.weekly.saturday":`Sábado`,
"label.stdashbord.xsld.business.img4":`Montante total das fases com probabilidade de 100%`,
"pagecreator_layout_button_splitall":`Dividir tudo`,
"label.mobile.phone.total.amount":`Montante total (dez mil)`,
"label.ratifyhistory":`Histórico de Aprovação`,
"label.projectManagement.Antecedents":`Pré-tarefa`,
"label.projectManagement.Newserviceappointment":`Nova Marcação de Serviço`,
"label.delete.record.is.approval":`Os registos que pretende apagar são pedidos para aprovação, tem a certeza de que pretende apagar?`,
"front-gantt-module-no-tasks-describe":`Pode ver como os itens de trabalho estão organizados ao longo do tempo, como se sobrepõem e como estão relacionados no diagrama de Gantt.`,
"vue_label_visualize_data":`Os dados de TianYanCha são preenchidos. Por favor, guardar as alterações.`,
"UG.activity.02":`Atribuir tarefas`,
"label.field.duplicate2":`Não são permitidos valores duplicados`,
"label.cloudccclass.list.tip":`Permite aos programadores desenvolver classes na plataforma CloudCC.com que podem ser utilizadas para personalizar páginas e triggers.`,
"before":`Antes de`,
"UG.ST.001":`Pronto`,
"label_tabpage_userGuidez":`Guia do utilizador`,
"vue_label_account_looking_for":`Por favor, introduza o que procura`,
"vue_label_calendar_notice_timecantmove":`A hora do calendário não pode ser alterada por arrastamento`,
"label.mobile.phone.enter.summary":`Introduza o seu resumo`,
"label.object.api.existed":`Este nome API objecto já existe, por favor mude outro nome API.`,
"label.weixin..xsld.order.by.time":`Encomendar por data próxima`,
"label.h5.chatter.whether":`Quer se trate ou não de`,
"label.file.delete.success":`Ficheiro apagado com sucesso`,
"label.imgfield.type.url.tip1":`O utilizador pode introduzir a ligação que faz referência à imagem, e definir o tamanho da imagem adicionando`,
"label.tomanyrecords":`Mais de 5.000 artigos no formulário.`,
"label.save.partnercloud":`Erro ao salvar a Partner Cloud`,
"vue_label_homepage_fliteritems":`Itens de configuração do filtro`,
"pagecreator_page_button_new":`Nova página`,
"label.sharerule.baseofcondition":`Com base em critérios`,
"label.dashboard.snapshot":`Snapshots do painel de instrumentos`,
"label.appointmentpage.wizard.subtitle1.1":`Escolher data e hora`,
"label.reportsSubscriptionPage.condition.emailsummary":`Apenas resumo`,
"chatter.group.showAll":`Mostrar tudo`,
"label.tabpage.helpNavigationz":`Ajuda e navegação`,
"label.emailtocloudcc.button.back":`Cancelar`,
"approval_request_email_subect":`Pedido de Aprovação`,
"label.lookup.error":`Ocorreu um erro durante a pesquisa`,
"label.publicgroup.save.groupisnull":`Os dados do grupo são nulos durante o salvamento. Por favor, guarde-os novamente. Se houver um erro, por favor contacte o seu administrador.`,
"label.pie":`Gráfico de tartes`,
"chatter.feed.is":`é uma rede corporativa que permite aos seus utilizadores trabalharem em conjunto, falarem uns com os outros e partilharem informações, tudo em tempo real.`,
"label.customfields.file.max5m":`O tamanho máximo do ficheiro é de 5m`,
"com.cloudcc.login.error.message.vaildauthfail":`Autenticação de login inválida`,
"label.profile.appsetuppermission":`Gestão de ajustes de aplicações`,
"label.customfields.file.totalmax":`O ficheiro carregado é demasiado grande,por favor não exceda 500m`,
"label.sms.list":`Lista de interfaces SMS`,
"message.error.referencedcolumnIdnotexist":`Os campos de referência do relatório foram eliminados e não podem ser exibidos correctamente. Por favor contacte o seu administrador para obter ajuda.`,
"front-lightning-module-v1-details-page-chart-setting-chart":`Elaboração de um plano de relatório`,
"label.recordtype.profile.enables":`Tipos de registos actualmente disponíveis`,
"chatter.this.n":`este registo`,
"label.only.upload.file":`Apenas ficheiro jpg/png é permitido carregar e não mais do que 500kb.`,
"vue_label_lead_conversion_failed":`A conversão falhou`,
"label.file.share.file.success":`Partilhar ficheiros com sucesso`,
"label.processsetting.delete.process":`Tem a certeza de que quer apagar o processo?`,
"message.uniquenamevalidate":`Deve mendigar com uma letra. Deve mendigar com uma letra. Deve conter apenas letras,números,e sublinhado.`,
"label.group.archived.desc.info":`Este grupo foi arquivado para que não possa criar novos posts ou partilhar ficheiros com este grupo. enabling group permite todas as funcionalidades.`,
"label.customer.maincontact":`Contacto principal`,
"label.appointment.wizard.subtitle1-9":`4 h`,
"label_productline_income":`Receitas das séries de produtos`,
"label.dashboardSetup.tz.ybb":`Saltar para Painel de Controle`,
"label.recordowner":`Proprietário do disco`,
"message.approval.othersdoing":`Alguém está a trabalhar neste processo, por favor actualize para obter os dados mais recentes.`,
"Opportunity_Detailed_Phase_Label_002":`{0} dia(s) na fase actual`,
"label.field.validating.rule.isnot.passed":`A regra de validação compilada falhou, por favor verifique a sintaxe.`,
"label.textmessage.fieldskong":`Alguns dos campos inseridos na mensagem são nulos, por favor editar e reenviar!`,
"com.cloudcc.login.error.message.islocked":`A sua identificação está bloqueada`,
"label.forecast.customforecast.foredis.debfb":`% Quota`,
"lable.opppdt.selPbk.changepbk.worning":`Modificar o livro de preços para esta oportunidade, e o produto de oportunidade associado a esta oportinidade será eliminado. Tem a certeza?`,
"label.mr.backLookReData":`voltar, Ver a lista de dados duplicados`,
"label.quickbooks.searchqb":`Pesquisa QuickBooks`,
"label.service.gantt.searchSkills":`Habilidades de Pesquisa`,
"label.account.Current.and.NexttFQ":`Actual e Próxima 3 FQ`,
"customer.notopen.chat":`A organização não activou a função de chat, por favor contacte o administrador`,
"vue_label_commonobjects_view_sum":`Total {total} registo(s)`,
"label.partnerCloud.orderingPlatform.adjust":`Ajustar produto de encomenda`,
"label.emailmerge.mergeFolder.tips":`Um ficheiro Microsoft Word com os dados de contacto pode ser gerado nesta página. Por favor, escolha os modelos de email a fundir, e um máximo de 20 modelos podem ser seleccionados.`,
"vue_label_ccchat_notice_deletecommentfail":`Falha em apagar comentários`,
"label.emailsync.status":`Estado do e-mail do utilizador`,
"label.forecast.forecastroleuserpage.desc":`Atribuir um gestor de previsões a esta função. As previsões dos seus subordinados serão agregadas em previsões do seu director .`,
"label.step1.total4":`Etapa 1 de 4`,
"front-kefu-moudle-confirm-fjcase":`Tem a certeza de que vai dividir este caso`,
"label.icon.60":`Guindaste`,
"label.appointmentpage.wizard.subtitle3":`Introduza as suas informações`,
"label.loginservice.license.exceed.time":`A licença expirou.`,
"label.customcomponent.check.tag.lastrow":`A última linha deve ser`,
"label.product.code":`Código do produto`,
"label.salescloud.salesdashboard.phone":`Telefone`,
"label_please_input_price_list_price":`Por favor, introduza o preço de tabela.`,
"label.multilang.page3":`página(s)`,
"label.file.lastmodifydate":`Tempo modificado`,
"label.icon.121":`Computador`,
"message.error.system.service.unknow":`Serviços desconhecidos, por favor contacte o seu administrador.`,
"label.thesecond":`A 2ª Coluna`,
"vue_label_report_conditiondesc_two":`Acrescentar condições a este relatório`,
"label.exchange.serverUrl":`Endereço do servidor`,
"RL":`referência`,
"label.emailobject.emailsend.sendindividuallyprompt":`Cada recibo receberá uma mensagem apenas enviada a ele. É você sure？`,
"label.appointmentconfirmpage.wizard.subtitle4":`Calças de treino`,
"message.save.opportunity.team.save.failed":`Grupo de oportunidades de negócio falhado`,
"vue_labenl_normal_notice_share_success":`Partilhado com sucesso`,
"label.triggerfolder":`Pastas de Disparo`,
"label.more":`Mais`,
"label.file.num":`Quantidade`,
"label.dashboard.list.sortBy":`artigo(s), ordenar por tempo de acesso`,
"c":`Moedas`,
"label.weixin.detail.edit":`Editar`,
"label.escalation.setup.newentries.step2":`Passo 2 Seleccionar os critérios para esta entrada de regra`,
"label.report.error.prompt":`A configuração falhou. Apenas o relatório de série com conjunto de linhas é suportado. Por favor certifiquese de que se trata de um relatório público e não eliminado!`,
"label.notification.new":`Novo`,
"label_tabpage_releaseTourz":`Publicar guia`,
"label.icon.41":`Posicionamento`,
"label.sendsms.hello.new":`Olá, tem um novo`,
"label.custom.combination":`Combinar`,
"label.project.hit.fifteen":`Aviso de Atribuição de Marcos`,
"label.campaign.channel.step6.mobile":`Gerar página móvel`,
"label.goback.N.step":`Voltar ao passo anterior N`,
"label_partner_all_name":`Nome da nuvem de parceiros`,
"label.usermanage.loginusername.exist":`O nome de utilizador já existe.`,
"template.chart.cpxse":`Venda de produtos`,
"chatter.feed.deletecomments":`Tem a certeza de que quer apagar este comentário?`,
"label.list.userinterface.show.newrcords.enable":`Desactivar o último registo`,
"label.sso.saml.idp.config.enablelogout":`Activar logout único`,
"label.file.library.create":`Nova Biblioteca`,
"label.event.moveup.half.day":`0,5 dia pela frente`,
"label.stdashbord.xsld.business.jhzje":`Montante total de oportunidades`,
"label.partnerCloud.orderingPlatform.unitPrice":`Custo unitário`,
"label.recordtype.edit.attribute":`Propriedades gerais`,
"front-template-V1-TemplatePreview":`Prévisualização do modelo`,
"label.tabpage.personalCenterz":`Centro pessoal`,
"label.setuplookuplayout":`Layouts de pesquisa`,
"label.no.merge.records":`Nenhum registo pode ser fundido`,
"label.attachementNew.set2":`Passo 2 Arquivo`,
"label.publicgroup.detail.showmembers":`Ver Membros do Grupo`,
"UG.Forcast.03":`Iniciar o planeamento e executar estratégias empresariais. <br>Desejo-lhe uma boa previsão!`,
"label.h5.manageprompt":`Seleccione um separador para adicionar a página inicial, ou clique no separador para o abrir.`,
"label.icon.145":`Relacionado`,
"label.select":`Seleccione`,
"label.publicgroup":`Grupos Públicos`,
"label.customcomponent.usewhere.title":`Onde é que este componente é utilizado:`,
"label.custom.page.button.name":`Nome do Botão`,
"pagecreator_layout_button_vertical":`Desmontagem longitudinal`,
"label.marketsea.autorecyclerule":`Regras de reciclagem automática`,
"label.reportsSubscription.entrance.attachment":`formato Excel .xlsx`,
"component_chatter_button_collect":`Favoritos`,
"label.page.step2.of.step5":`Etapa 2 de 5`,
"label.reportsSubscription.addfile.helptext":`Pode definir se deve ou não adicionar anexos de relatórios nos e-mails de subscrição, e o formato dos relatórios anexos.`,
"label.oldpw":`Palavra-passe antiga`,
"lable.SalesCommitmentKanBan.contractAmount":`Montante assinado`,
"lable.Bundle":`Pacote Superior`,
"label.weixin.unit.million":`Unidade (dez mil yuan)`,
"label.app.choseprofile":`Atribuir Perfil`,
"label_tabpage_editz":`Editar`,
"label.email.attachement.size.info":`O ficheiro não pode ser maior do que`,
"label.chatter.pastSevenday":`Os últimos 7 dias`,
"label.weixin.end.later.start":`A data de fim deve ser posterior à data de início.`,
"label.passwordPolicy.setup.lockoutPeriod":`Período de bloqueio efectivo`,
"pagecreator_page_funcpath":`/ construtor / lista de páginas`,
"label.emailobject.apperror":`Não há serviço de correio disponível, por favor contacte o administrador.`,
"label.custom.page.button.broadband":`Tamanho do Botão (Pixel)`,
"label.weixin.contract.rate":`Taxa de realização do contrato`,
"label.brief.payments":`Pagamentos`,
"lable.approvaldatamove.transfermsg":`Transferência em massa de todos os pedidos de aprovação pendentes para um novo utilizador`,
"label.datamanage.account.namenull":`Nota: Se o nome da conta for nulo, o registo não será importado.`,
"lable.SalesCommitmentKanBan.allTotalPaymentAmount":`Montante total de Recibos Rollup`,
"Opportunity_Detailed_Phase_Label_001":`Palco`,
"vue_label_helpcenter_calendar2":`<br> Calendários de objectos: Os calendários que se criam com objectos exibem os dados do registo como entradas de calendário no campo de data na vista de calendário. Pode editar ou apagar calendários de objectos, e personalizar a cor para cada calendário de objectos. <br>Novo Evento<br> É possível criar um novo evento na vista de calendário de duas maneiras. <br> (1) Clique no botão Novo Evento no canto superior direito da vista de calendário para criar um novo evento. Num novo evento pode associar o evento a outros objectos, tais como oportunidades de negócio, seleccionando outros objectos nos campos Itens Relacionados e Nome. Os registos de eventos que estão associados a outros objectos são sincronizados no módulo Actividade da página de detalhes dos outros objectos. <br> (2) Ou pode criar um novo evento, clicando na grelha do calendário. <br> Novo Calendário de Objectos<br> Passo 1: Clique no separador Calendário no menu de navegação para ir para a página de visualização do Calendário. <br> Passo 2: Encontre os Meus Calendários no lado direito da vista, clique no ícone junto aos Meus Calendários, e prossiga na janela de pop-up do Novo Calendário de Objectos. <br> Passo 3: Comece por nomear o Calendário de Objectos criado. Seleccione o objecto que é a base do calendário, e seleccione os campos que determinam o conteúdo da exibição do calendário, "Start field", "View filter", "Display field". O campo Iniciar determina o intervalo de tempo ao longo do qual os dados são exibidos, pode filtrar os dados por filtros de visualização, e o campo Exibir determina o que é exibido na entrada do calendário. <br> Outros calendários<br> Outros calendários contêm os calendários de outros utilizadores adicionados. Pode adicionar calendários de pessoas que são subordinadas a si e partilhar consigo o calendário. <br> Partilhar o Meu Calendário de Eventos<br> Passo 1: Clique no separador Calendário do menu de navegação para ir para a página de visualização do Calendário. <br> Passo 2: Encontre Os Meus Eventos no lado direito da vista do calendário em Os Meus Calendários, clique no botão pendente à direita de Os Meus Eventos, e seleccione Partilhar Calendário. <br> Passo 3: No pop-up do Calendário Partilhado, seleccione os utilizadores e os direitos de acesso com os quais deseja partilhar o calendário. Além disso, também pode ver os seus registos de calendário partilhados clicando em "Quem tem actualmente acesso" e remover os registos partilhados clicando no ícone "x" à direita dos registos partilhados. <br> Assim que o calendário for partilhado, os seus colegas subordinados podem adicionar o seu calendário de eventos a outros calendários e depois ver o seu calendário de eventos. <br> Adicionar um calendário<br> Passo 1: Clique no separador Calendário no menu de navegação para ir para a página de visualização do Calendário. <br> Passo 2: Clique no botão descendente para outros calendários no lado direito da vista do calendário e seleccione Adicionar Calendário. <br> Passo 3: No pop-up de Calendários Partilhados, seleccione os calendários de eventos das pessoas que pretende adicionar. Pode seleccionar os calendários de eventos dos seus subordinados, bem como os calendários de eventos que lhe são partilhados. Clique em Adicionar para adicionar com sucesso. <br> Remover o calendário adicionado <br> Clique no botão pendente à direita do calendário que pretende remover abaixo dos outros calendários e seleccione Remover.`,
"label.callcenter.Seat.number":`Número do assento`,
"vue_label_commonobjects_view_change_all_selected_records":`Alterar todos os registos seleccionados`,
"label.user.notinuse":`O utilizador está inactivo, por favor contacte o seu administrador.`,
"label.usermanage.hasbeen.reached":`O número máximo de utilizadores licenciados foi atingido, por favor contacte o fornecedor de serviços para mais licenças.`,
"vue_label_help_list":`Vista de lista`,
"label.infomation.edit":`Informação Essencial Editar`,
"label.ccchat.person.setting.info":``,
"label.sso.isDelete":`É Eliminar`,
"label.unique.identification.number":`Código de Identificação Único`,
"label.weixin.no.pending.projects":`Não há itens a aprovar`,
"label.projectManagement.Pleaseenteramember":`Por favor, introduza um membro`,
"label.salescloud.salesdashboard.visit":`Visite`,
"label.weixin.user.registered":`Registo do utilizador`,
"message.loginhistory.downloadcsv":`Descarregar o histórico de login dos últimos seis meses. ( CSV )`,
"label.icon.37":`Posicionamento`,
"template.chart.schdyqyx":`Resposta Esperada das Campanhas`,
"label.tel.ten":`Pode introduzir até 10 números de telefone a serem notificados por SMS, e cada número de telefone é separado por um ";".`,
"label.data.exp.objdata":`Exportará os dados para este objecto de acordo com as seguintes condições`,
"label.loginservice.after.use":`depois disso,pode usar o.`,
"pagecreator_systemstyle_message_delete":`Apaga o actual estilo seleccionado?`,
"label.globalselect.deleteerror":`Uma vez que este conjunto de valores da lista de opções é utilizado pelos seguintes campos, não pode ser apagado temporariamente.`,
"label.department.add":`Adicionar novo departamento`,
"label.attendance.dingwei":`Localização`,
"label.workflow.editrule":`Editar Regra`,
"lable.product.pecm":`Por favor, introduza o montante correcto.`,
"label.icon.182":`Briefcase`,
"label.help.release.notes":`Notas de Lançamento do CloudCC R7.1`,
"UG.product.05":`Produto de importação`,
"label.email2":`Email`,
"label.weekrepeat":`Repetição da semana`,
"label.mr.descreption.oneGroupReData2":`conjunto(s)`,
"chatter.at.d":`Contribuição`,
"label.mr.descreption.oneGroupReData1":`Encontrar Duplicações e Processo de Fusão: um total de`,
"label.weixin.mobile.fly.android":`Partilhar no Android Mobile App`,
"label.brackets.right":`)Fechar Parênteses`,
"message.recordtype.applytoAllProfiles":`Aplicar um layout de página a todos os perfis`,
"label.customcomponent.page.index.tip":`Semelhante à forma como a função funciona numa linguagem de programação, os componentes personalizados permitem encapsular padrões de design comuns e depois reutilizá-los em uma ou mais páginas personalizadas.`,
"lable.List.properties":`Atributos da lista`,
"label.fieldinfo":`Detalhes do campo`,
"label.ems.error.fail":`A carga falhou, por favor tente novamente ou contacte o administrador do sistema.`,
"label_emailsync_form_email":`Email`,
"lable.currencyManage.button.manageRate":`Gerir Moedas`,
"component_salesperformance_label_100finish":`Terminado`,
"label.knowledgebase.data.assignment.failed":`{a} a atribuição de dados falhou`,
"label.custom.buttonandlink.remark":`Seleccionar o comportamento: Mostrar na janela existente/exibir na nova janela (Janela existente:despalhar na janela actual. Nova janela: exibir em nova janela)`,
"label.list.userinterface.watermark.setup":`Definição da marca de água`,
"component_timeline_label_7daysahead":`7 dias antes`,
"label.sendemail.chat.replyinchat":`Comentários do correio:`,
"component.salesperformance.label.title":`Desempenho de vendas`,
"label.data.downpage.e.list.desc2":`Após completar, receberá um e-mail a lembrar-lhe que os dados foram exportados com sucesso.`,
"vue_label_campaign_fromclosedopprotunities":`De {sjcb} oportunidades de negócio fechadas`,
"label.umeng.activity.taskviewed":`A tarefa que atribuiu a #name é vista`,
"vue_label_salesadvance_retentions":`Número de retenção`,
"label.fieldtag":`Etiqueta de campo`,
"label.quickbooks.button.searchinquickbooks":`Pesquisa em QuickBooks`,
"label.quickbooks.viewlist.action":`ACÇÃO`,
"label.weixin.sysapp":`Aplicações do sistema`,
"label.approval.examine.level":`Aprovar e rejeitar pelo utilizador level， O nível máximo de utilizador é`,
"label.appupload.upload.error":`Esta aplicação não pode ser instalada. Por favor, cancele a instalação ou modificação da API dentro do seu sistema, e instale novamente.`,
"label.emailtemplate":`Modelo de e-mail`,
"front-email-payment-Invoice-amount":`Montante da factura`,
"label.viewselectedproducts":`Ver Produtos Seleccionados`,
"label.tianyancha.businessverify.openfirst":`Permitir por favor a verificação de dados comerciais`,
"lable.SalesCommitmentKanBan.returnAList":`Voltar à lista: Colegas`,
"label.knowledgebase.nopublished.draft.translations":`Nenhuma versão publicada ou rascunho de tradução`,
"vue_label_calendar_day_view":`Vista do dia do calendário`,
"label.globalselect.remark":`O conjunto de valores da lista global de opções permite-lhe partilhar valores entre objectos.`,
"label.orderby":`Ordenar por`,
"lable.weixin.LastaDaysFinished":`Concluído nos últimos 7 dias`,
"lable.currencyManage.Enabledadvcurrency.discripation":`Permite-lhe gerir taxas de câmbio datadas que mapeiam uma taxa de conversão cambial para um intervalo de datas específico. As taxas de câmbio datadas são aplicadas aos campos de moeda sobre oportunidades, produtos de oportunidade, e os relatórios associados a estes dois objectos. Não são aplicadas a campos sobre outros objectos ou outros tipos de relatórios. Por exemplo, a taxa de câmbio a 1 de Janeiro era de 1 USD para 6,68 CNY, mas a 6 de Fevereiro, mudou para 1 USD para 6,70 CNY. As oportunidades que fecharam entre 1 de Janeiro e 6 de Fevereiro utilizam a primeira taxa de câmbio (1 = 1,68), enquanto que as oportunidades que fecharam após 6 de Fevereiro utilizaram a segunda taxa de câmbio (1 = 6,70).`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.one":`Um`,
"label.leadtoobjectfield":`Mapa Campos de chumbo personalizados`,
"label.dashboardSetup.shujuyuan":`Fontes de dados`,
"label.tabpage.userz":`Utilizadores`,
"label.sms.companyname.dsf":`Definição de SMS-1`,
"label.step2.total3":`Etapa 2 de 3`,
"front-gantt-module-Drag-dropt- reorder-tasks":`Arraste para reordenar tarefas!`,
"label.dashboard.snapshot.no.enabled":`Função de fotografia do painel de instrumentos não activada`,
"label.dashboard.unit3":`Unidade: unidade inteira`,
"label.forecast.shrepage.desc2":`Utilizadores, papéis e territórios com acesso partilhado.`,
"label.commonobjects.new":`Novo {eventName}`,
"label.view.nameonlyone":`Ver Nome Único`,
"label.assignment.setup.newentries.user":`Utilizadores`,
"label.otheremails":`Emails adicionais`,
"component_sendmail_button_send":`Enviar`,
"vue_label_accountpool":`Pool de contas`,
"label.h5.approval.actortime":`Data de apresentação`,
"message.approval.cannotsubmit":`Incapaz de se submeter à aprovação`,
"vue_label_pool_createdbyme":`Criado por mim`,
"label.change.event":`Vista do evento`,
"vue_label_homepage_personalpage":`Página pessoal`,
"label.new.collect.target":`Novo Indicador de Agregado`,
"label.ServiceCloud.zichanxuhao":`Nº de bens`,
"label.product.userl":`Colunas para todos os utilizadores`,
"label.syslog":`Registo do sistema`,
"label.reportcreatestatus":`Situação da geração de relatórios`,
"label.datamanage.account.novalue":`Nota: O campo do nome da conta é nulo,os registos da conta não serão importados.`,
"label.letter.body":`Texto do convite`,
"label.select.please":`Por favor seleccione`,
"label.escalation.setup.entrydetail.description":`1.Clique em Editar para alterar as entradas das regras. <br/>2.Clicar em Novo para adicionar a operação de actualização.`,
"label.component.salesDashboard.nodata":`Adicione a oportunidade de negócio que está a utilizar, depois volte aqui para ver o desempenho.`,
"vue_label_helpcenter_account":`?Nas informações detalhadas, clique no botão do diagrama em árvore junto ao cliente para visualizar o diagrama hierárquico do cliente, compreender a relação filho-pai dos clientes relacionados, e visualizar algumas informações de campo de cada cliente.<br>?Ao mudar o proprietário de um cliente, pode optar por mudar o proprietário das oportunidades de negócio relacionadas com o cliente, casos e outras informações ao mesmo tempo.`,
"front-kefu-moudle-v1-awshjzx-intelligent":`AWS Intelligent Service Call Center (Centro de Atendimento Inteligente AWS)`,
"label.productby":`Gerado por`,
"label.operation.date":`Data de funcionamento`,
"label.name.donot.delete":`O nome não pode ser removido`,
"label.validate.function.funcFormat.DATETIMEVALUE":`DATETIMEVALUE(data)`,
"label.escalation.setup.entrydetail.howescalationtime":`Como são definidos os tempos de escalada`,
"label.view.step2":`Passo 2 Especificar os critérios de filtragem`,
"lable.outlook.edit.notnull":`É necessário introduzir o nome do campo.`,
"label.knowledgebase.createnewbrowser":`Novo separador Browser`,
"label.partner.all.name":`Nome da nuvem de parceiros`,
"chatter.group.groupSetUp":`Definições de grupo`,
"label.reportlist.findfolder":`Encontre uma pasta...`,
"component.setup.tabs.label.title":`Paginação de separadores`,
"label.passwordPolicy.setup.pswComplexReq":`Requisitos de complexidade da palavra-passe`,
"label.emaildocument":`Enviar um documento sob a forma de um emai`,
"message.selectgsummaryconditon":`seleccione os critérios sumários`,
"component_todaytask_label_notask":`Hoje em dia não há tarefa de expiração, tomar um café.`,
"label.user.organization.notexists":`A organização não é encontrada.`,
"label.isEnableVisualpage.new.leftlist":`Páginas Personalizadas Disponíveis`,
"label.mobile.phone.write.week.report":`Novas notas de trabalho semanais`,
"label.emailmerge.edittemplate.edit":`Edição de modelos de fusão de correio`,
"template.dashboard.folder.sales.manage":`Gestão de Vendas`,
"label.confirm.order.productsToassets":`Tem a certeza de que quer converter o produto encomendado em activo?`,
"label.service.dispatchingUnits.leftRight.total":`Actualmente {{{esquerda }}-{{direita }} registos, {{{conto total }}} registos no total.`,
"label.import.step1.chooseidorother":`2、You pode escolher usar o ID ou nome para corresponder ao registo e preencher o campo de pesquisa. Se precisar do ID do registo correspondente e de outras informações, pode criar um relatório e definir o nome do registo e o ID do registo como colunas de grupo, e depois exportar o relatório.`,
"label_tabpage_completez":`Marcar o estado seleccionado para completar`,
"chatter.c.adr":`Endereço`,
"label.account.d":`Esta página permite-lhe definir e editar o trimestre fiscal personalizado. A data do trimestre fiscal personalizado será gerada com base nas escolhas que fizer abaixo.`,
"label.tag.more50":`Criar até 50 etiquetas`,
"setup.layout.label.areashow":`Mostrar cabeçalho da secção ligada`,
"label.partnerCloud.basicSetting.rebate":`Activar o Rebate`,
"label.tabpage.greaterequalz":`Maior ou igual a`,
"vue.please.select.the.aggregate.basis":`Por favor, seleccione as opções SUM BY.`,
"label.form":`Formulários`,
"label.chatter.colleagues.list.beizhu":`Habilitar`,
"label.priority":`Prioridade`,
"vue_label_checkduplicate_set_repeat_rules":`Definir regras de repetição`,
"label.share_form":`Partilhe o seu formulário`,
"label_relation_shareholder":`Os accionistas e as filiais não podem ser os mesmos.`,
"label.project.hit.sixteen":`Lembrete de expiração de emissão`,
"label.service.miniProgram.imageFormat":`Apenas imagens PNG, JPG e JPEG são suportadas para carregar.`,
"label.summary.mode":`Método sumário`,
"vue_label_beforeverification":``,
"label.data.newtemplate.desc":`Guardar os campos e critérios seleccionados pelos utilizadores como modelo e os utilizadores podem exportar dados directamente através do modelo de exportação de dados.`,
"lable.evaluation.badreview":`Mau`,
"label.total.tabs":`{0} Total {1}`,
"label.emailmerge.mergeFolder.foldertemplate":`Modelos nesta pasta`,
"vue_label_normal_notice_repeated":`Por favor não adicione repetidamente`,
"label.icon.140":`Dados`,
"label.fromonetoanother":`de um utilizador para outro`,
"label.user.list":`Todos os Utilizadores`,
"label.file.prevent.share.operate":`Impedir que outros partilhem e não partilhem`,
"label.app.detail":`Detalhes da aplicação`,
"label.h5.similar.opportunity.correlation":`Relatividade`,
"label_emailtocloudcc_filed_username":`Endereço de correio electrónico`,
"vue_labe_account_shareholdingratio":`Taxa de participação`,
"label.data.dataexpalltype.all_desc3":`3. Exported Dados bem sucedidos irão gerar um ficheiro comprimido que os utilizadores podem descarregar da página da lista de sucesso da exportação de acordo com a informação contida no correio.`,
"label.callcenter.please.select .seatID":`Por favor escolha o número do assento`,
"label.remark.length.cannot.than":`A descrição não pode incluir mais de 255 caracteres.`,
"label.batchtransfer.dateandtimetype.tip":`Para campos de data/hora, introduza o valor no seguinte formato:`,
"label.component.helper.businesschange.0UntreatActivity":`Oportunidades sem actividade não processada`,
"front-project-module-v1-plase-input-start-time":`Por favor introduza a data de início`,
"label.event.moveup.6hour":`6 horas à frente`,
"label.data.exp.tempexp":`Exportação por modelo`,
"label.schedulejob.setup.schedule.afternoon":`PM`,
"label.ems.format":`Formato`,
"label.objectHasBeenDeleted":`Objectos eliminados`,
"label.ServiceCloud.chaxunchenggong":`Pesquisado com sucesso`,
"label.campaign.channel.input.notice.owner":`Notificar Proprietário`,
"label.bajisitan.time":`Tempo Paquistão`,
"label.warnMes":`Objecto referenciado, apagar falhou.`,
"lable.Up.to.ten.fields":`Escolher um objecto e somar até 10 campos ao gráfico. Clicar nas setas para cima e para baixo para ordenar os campos.`,
"label.approverule":`Regras de Aprovação`,
"message.error.specific":`Devolver mensagem de erro específica`,
"front-template-V1-saveUse":`Guardar & Prévisualizar`,
"label.uploadfile.success":`carregado com sucesso`,
"label.tabname.donot.database.key":`O nome do separador não pode ser uma palavra-chave de base de dados`,
"message.recordtype.selectlayout.select":`--Selecione a página Layout--`,
"front-detail-module-v1-list-cardview":`Vista de Lista/Cartão`,
"label.product.maintenance":`Manutenção`,
"vue_label_helpcenter_approve":`1. Itens a aprovar<br> Liste todos os itens que necessitam da sua aprovação. Pode procurar registos a serem aprovados até à data de início, data final, apresentador, tipo de registo, e itens relacionados do registo de aprovação.<br>processar um único registo: Clique no botão esquerdo de cada registo.<br> A. Aprovação<br> Passo 1: Clique em "Aprovar" para abrir a página de pedido de aprovação<br> Passo 2: Clique em "Aprovar" ou "Rejeitar" para completar a operação de aprovação.<br> Se a próxima etapa de aprovação na configuração do processo de aprovação precisar de seleccionar manualmente um aprovador, a etapa 3 é executada após "Aprovação".<br> Etapa 3: Seleccione o próximo aprovador para completar a operação de aprovação.<br> Se precisar de seleccionar a etapa de retorno após a aprovação ser rejeitada na configuração do processo de aprovação, vá para a etapa 4 após "Rejeitar".<br> Etapa 4: Seleccione a etapa de aprovação a ser devolvida para completar a operação de aprovação.<br> B. Redistribuição<br> Etapa 1: Clique em "Reatribuir"<br> Etapa 2: Encontre o reatribuidor<br> Etapa 3: Clique em "Reatribuir Pedido de Aprovação" para completar a reatribuição dos aprovadores.<br>Nota: Se for o aprovador adjunto de um registo, não pode realizar a operação de reatribuição.<br> Processar vários registos em lote: Após seleccionar vários itens a serem aprovados, clique no botão de operação acima da lista.<br> C. Aprovação<br> Passo 1: Seleccione vários registos a serem aprovados<br> Passo 2: Clique em "Aprovar"<br> Passo 3: Clique em "Aprovar" ou "Rejeitar" para completar a operação de aprovação.<br> Se precisar de seleccionar o passo de retorno após a aprovação ser rejeitada na configuração do processo de aprovação, vá para o passo 4 após "Rejeitar".<br> Etapa 4: Seleccione a etapa de aprovação a ser devolvida para completar a operação de aprovação.<br> D. Redistribuição<br> Etapa 1: Seleccione vários registos a serem aprovados<br> Etapa 2: Clique em "Reatribuir"<br> Etapa 3: Encontre reatribuidores<br> Etapa 4: Clique em "Reatribuir Pedido de Aprovação" para completar a reatribuição de aprovadores.<br> 2. Projectos submetidos<br> Lista todos os itens aprovados que submeteu. Pode procurar rapidamente o registo que deseja ver através da data de início, data final, apresentador, tipo de registo, itens relacionados, e estado de aprovação do registo de aprovação.<br> 3. Os meus projectos aprovados<br> Lista todos os artigos aprovados que aprovou. Pode pesquisar rapidamente o registo que pretende visualizar através da data de início, data final, apresentador, tipo de registo, itens relacionados, e estado de aprovação do registo de aprovação.<br> 4. Rejeitar itens <br> Lista todos os itens aprovados que tenha rejeitado. Pode pesquisar rapidamente o registo que deseja visualizar até à data de início, data final, apresentador, tipo de registo, itens relacionados, e estado de aprovação do registo de aprovação.`,
"label.knowledgebase.knowledge.article":`Artigo de conhecimento`,
"march":`Março`,
"label.accraditation":`Aprovar`,
"vue_label_pool_cantreach":`Não se consegue chegar ao cliente`,
"label.service.appointmentList.startOf.maturityPeriod":`Início do período de vencimento`,
"message.huanxin.closed":`Função de conversa inativa`,
"label.implementation.time.operation":`Executar trabalhos agendados`,
"label.setting.intergrationlist.permissions":`PERMISSÕES DE INTEGRAÇÃO`,
"label.translation.norecord":`Sem Registos`,
"label.lack.expression":`Perde-se a expressão`,
"setup.layout.message.relatedlistfield":`Seleccione os campos a exibir na lista relacionada.`,
"label.group.file":`Ficheiros de grupo`,
"message.error.id.null":`Nenhuma informação de identificação`,
"label.a_b_least":`Cada registo "A" deve ter pelo menos um registo "B" relacionado.`,
"label.addattachment.step3":`Passo 4 Clique em "Completar" para voltar à página anterior.`,
"label.data.exportsf":`Ficheiros Exportados`,
"label.callcenter.call.out":`Chamada`,
"front-electronic-export-exportIntro":`Os dados seleccionados serão exportados para a lista Mailchimp que seleccionou`,
"label.custombutton.deletedata.notnull":`Os dados apagados não podem estar vazios.`,
"UG.homepage.002":`Gerir as suas pistas, leads, funis de transacções de vendas, e informação de contas com ferramentas empresariais integradas`,
"label.globaloperation":`Operação global`,
"label.icon.58":`Trabalhador`,
"vue_label_salesadvance_lostrate":`Taxa de rotatividade`,
"chatter.from":`a partir de`,
"front-epwechat-module-v1-account-binding":`Ligar por conta`,
"label.list.userinterface.old.page.setup":`Página antiga`,
"label.forecast.settings.periods":`&nbsp;ciclo(s)`,
"label.file.share.email.content":`#sharedBy partilhou consigo um ficheiro em #orgname`,
"label.knowledge.category.hint.five":`Definição da categoria de dados`,
"setup.layout.label.selectedfield":`Seleccionar campos`,
"label_business_income":`Receitas de Oportunidades de Negócio`,
"vue_label_display_options_field":`Mostrar campos da lista de selecção`,
"label.emailtocloudcc.set":`Definir informação da caixa de correio`,
"label.knowledge.setting.data.five":`Eliminar Categoria: {lbmc}`,
"front-epwechat-module-v1-bound-enterprise":`Empresa de ligação`,
"label.ccpeak.delete.recycle":`O registo será retirado para o caixote do lixo da reciclagem`,
"label.leadconvers.tip":`As pistas não podem ser convertidas em contas, contactos, oportunidades, e tarefas de seguimento. Só deve converter uma pista depois de a ter identificado como qualificada.`,
"label.rsa.key.invalid":`A chave pública é inválida, por favor faça novamente o login.`,
"label.mobile.bind.success":`Ligar com sucesso`,
"label.emailtocloudcc.filed.servertype":`Servidor de Email`,
"label.user.new":`Novo Utilizador`,
"label.setup.mobile.homepageshortcuts.remark":`As organizações podem definir as funções rápidas a nível organizacional mostradas na área superior da página inicial, de acordo com o cenário empresarial.`,
"label_emailtocloudcc_select2":`Seleccione o tipo de visualização`,
"page.send.email":`Enviar Email`,
"label.service.newBuildDialog.field.display":`Campos a mostrar`,
"vue_label_homepage_card_impending":`Oportunidades iminentes`,
"label.message.contactispartner.delete":`Um utilizador parceiro está associado a este contacto, não pode ser apagado`,
"label.attendance.checkout":`Confira`,
"label.emailmerge.newtemplate.description":`Introduza informação sobre o seu modelo de fusão de correio.Note que a descrição é apresentada apenas em CloudCC.com, não em Word.`,
"laebe.data.exp.success":`Após a exportação bem sucedida, receberá um lembrete por e-mail. Os dados exportados serão guardados no servidor durante 48 horas. Por favor, descarregue da página da lista de dados exportados o mais depressa possível.`,
"lable.Maximum.number":`É permitido um máximo de 50 caracteres para o nome do modelo.`,
"label.projectManagement.drag.and.drop.existing.tasks":`Arrastar uma tarefa existente para a categoria actual`,
"label.forecast.tree.desc":`A hierarquia de previsões determina como as previsões se desenvolvem dentro da organização, e quem pode visualizá-las e ajustá-las. É gerada automaticamente com base na sua hierarquia de funções, mas pode ser necessário adicionar ou editar gestores, representantes de vendas, ou outros utilizadores.`,
"vue_label_chatter_upload_file_type":`Carregamento seleccionado de ficheiro tipo post`,
"front-lightning-module-v1-dashborad-analysis-dimension":`Dimensão da análise`,
"vue_label_homepage_custom_homepage":`Página inicial personalizada`,
"label.icon.39":`Posicionamento`,
"label.appointmentpage.wizard.notif1":`Por favor, escolha uma hora primeiro!`,
"vue_label_report_filterby":`Filtrar por {screenCondition}`,
"label.argentina.time":`Tempo argentino`,
"label.role.assign.notremove":`Não é possível remover os utilizadores de <b>Selected Users</b> para "All Unassigend And Active Users" ou "All Unassigned Users".`,
"label.sharerule.detailsetshare":`Detalhes da Regra de Partilha`,
"label.file.publicview.error1":`O ficheiro é apagado ou a ligação pública não é activada`,
"label.data.downpage.e_title.num4":`4. Os ficheiros de exportação têm dois formatos: o formato CSV e o formato de compressão. O formato de compressão é dividido em dois tipos: um é gerar automaticamente a palavra-passe do ficheiro comprimido, o outro é introduzir manualmente a palavra-passe do ficheiro comprimido.`,
"label.knowledge.case.article":`Artigo de caso`,
"label.data.newtemplate.e.conditions":`Condições de exportação`,
"front-object-change-owner":`O proprietário do registo das listas relacionadas que corresponde a este proprietário da conta será também alterado para o novo proprietário`,
"label.newdashboardpage.edittitle":`Editar título`,
"label.datamove.end.query.no.record":`Fim da consulta, sem registos qualificados.`,
"lable.SalesCommitmentKanBan.receiptsTarget":`Recebimentos Alvo`,
"label.orderagain":`Reordenar`,
"vue_report_dashboard_transfer":`Mover pasta`,
"label.view.sortview.default":`Vista por defeito`,
"label.brasilia.time":`Horário de Verão de Brasília`,
"label.industrialandcommercialverification.instructions":`Permitir a Verificação de Dados Industriais e Comerciais para ajudar o utilizador a introduzir as informações correctas de registo industrial e comercial do cliente.`,
"label.chatter":`Posto de nuvem`,
"label.sso.goBackToList":`Voltar à lista: key Management`,
"label.mobile.side.tab.state":`Iniciar o selector personalizado`,
"label.weixin.addbus":`Adicionar Veículos`,
"label.dropbox.description":`Ligue a sua conta DropBox para a utilizar no CloudCC.`,
"label.service.newBuildDialog.available.tousers":`Definir este filtro disponível a todos os utilizadores.`,
"label.knowledge.language.thai":`Thai`,
"label.passwordPolicy.setup.foreverlock":`Para sempre(deve ser reposto por admin)`,
"label.bmap.unreported.location":`Não partilhou a sua informação de localização. Por favor, crie a sua conta oficial no WeChat .`,
"label.tag.field":`Etiquetas`,
"label.addyourlanguage":`Clique em Adicionar para adicionar as línguas que a sua organização suporta.`,
"label.chat.topic.my.use":`Tópicos que utilizo`,
"UG.contact.06":`Contactos de importação`,
"label.embed_code":`Código Embedar`,
"label.campaign.channel.input.chenben":`3. Custo real:`,
"label.quickbooks.estimates":`Estimativas`,
"label.report.items.i.created":`Relatórios que eu criei`,
"label.forecast.edit.fwqd":`Início do alcance`,
"label.validate.function.funcExplain.DATEVALUE":`Criar uma data a partir da sua data/hora`,
"vue_label_helpcenter_calendar1.1":`Os eventos são uma ferramenta poderosa para garantir que compreende sempre as relações com os clientes e os negócios fechados. Pode associar eventos a oportunidades, leads, clientes, e contactos. A vista do calendário exibe principalmente registos de eventos.<br> 1. Vista do calendário e vista de lista<br>Ver calendário<br> Clique no separador calendário do menu de navegação para aceder à página do calendário. <br>Vista de calendário<br> Classificação das vistas de calendário: As vistas de calendário estão divididas em vista do mês, vista da semana, vista do dia e vista da disponibilidade. Os dados registados de diferentes intervalos de tempo podem ser exibidos separadamente através de diferentes estilos de grelha. A vista de disponibilidade exibe os dados de registo diários com cada calendário como dimensão, incluindo o meu calendário e outros calendários. Clique no ícone "botão calendário" no canto superior direito da página do calendário para mudar de visualização. <br> O que pode ser visualizado na vista de calendário: O calendário inclui o meu calendário e outros calendários. Pode ver o meu calendário na vista de calendário, incluindo todos os dados registados do meu calendário de eventos e calendário de objectos. Referimo-nos a estes registos como "entradas de calendário". <br> Pode ver todos os eventos que tem na vista de calendário. O calendário que criar com o objecto exibirá os dados como entradas de calendário na vista de calendário, no campo de data. Também pode ver outros calendários na vista de calendário, ou seja, pode ver quaisquer entradas de calendário partilhadas pelos seus colegas que tenha adicionado à vista. <br>`,
"label.tabpage.rowsz":`Eliminar filas`,
"label.file.library.managemembers.memberlist":`Membros actuais`,
"label.report.action.addtodashboard4":`Adicionar ao Dshboard de Saída`,
"label.chat.send.voice":`Enviar uma mensagem de voz`,
"label.home.dashboard.add":`Adicionar à página inicial Painel de controlo`,
"front-dialog-module-v1-copied-requestid":`Pedido de ID é clonado`,
"label.customfields.exportdata":`Exportação de dados`,
"label.emailobject.signature":`Assinatura`,
"label.hide.source":`Ocultar código fonte`,
"label.icon.71":`Serviço`,
"vue_label_help_whatslightning":`O que é um Relâmpago`,
"report.type.label.systemReport":`Relatórios do sistema`,
"front-kefu-moudle-v1-input-email":`Por favor introduza o endereço de email`,
"label.event.moveup.5minutes":`5 minutos à frente`,
"message.error.postsid.null":`A identificação do correio não pode estar vazia!`,
"UG.Account.05":`Diagrama da estrutura de contacto`,
"label_emailtocloudcc_description3":`Ligue a sua conta de correio electrónico empresarial, tal como sales@company.com, info@company.com, support@company.com. Registe automaticamente os e-mails que recebeu como leads e registos de casos no CloudCC para assegurar um acompanhamento atempado das cartas dos clientes.`,
"report.label.searchresult":`Resultados da pesquisa`,
"vue_label_report_detailsonly_desc":`Exportar apenas linhas de detalhe. Utilizar estes dados para cálculos adicionais ou para carregar para outros sistemas.`,
"label.partnerCloud.partnerAccount.payment":`Montante do pagamento:`,
"vue_label_commonobjects_view_select_member":`Seleccionar membro`,
"label.emailtocloudcc.step1.lead1":`Email para liderar`,
"label.forecast.settings.current":`Período actual`,
"label.canceluploadfile":`Cancelar carregamento`,
"label.manual.shared":`Partilha Manual`,
"label.document.uniquename.length.cannot.than":`A extensão do nome único do documento não pode exceder 255 caracteres.`,
"vue_label_lead_notcreateopportunity":`Não criar oportunidades`,
"APPIntegration.Social.twittererror":`Deve introduzir um URL válido para o twitter.com`,
"message.duplication.label.errormessage":`Mensagem de erro`,
"label.file.img":`Imagem`,
"label.tabpage.sum":`Contagem total?`,
"label.permission.systempermission.fenpei":`Atribuição de Permissões`,
"template.dashboard.folder.data":`Análise de dados`,
"label.sms.account":`Conta de utilizador`,
"label.product.filter":`Filtro de produto`,
"label.file.content":`Conteúdo do texto`,
"label.percent":`Porcentagem`,
"label.single.attachment":`Único`,
"label.processsetting.failed.enable.process":`Falha em activar o processo`,
"label.view.modify":`Editar`,
"label.knowledgebase.enter.keywords.filter":`Por favor introduza palavraschave para filtrar`,
"label.tabpage.uploadfailez":`Upload falhou, por favor, reupload.`,
"label.please.enter.the.target.model.name":`Por favor, introduza o nome do modelo alvo.`,
"label.layout.availabletab.related":`relacionado`,
"label.label":`Etiqueta`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.saturday":`Sábado`,
"label.addattachment.unit":`byte`,
"vue_label_commonobjects_view_selected":`{checkedLength} record(s) seleccionado(s)`,
"label.view.sortview.printble":`Pode ser impresso`,
"label.umeng.insert.approval.approvaling":`O requerente submete #obj#objnome#objnome#do proprietário para a sua aprovação`,
"label.forecast.customforecast.tztotal":`Montante Total Ajustado`,
"label.ccchat.failtoset":`erro de configuração ccchat`,
"label.ccchat.message.new.error2":`Utilizador de CCChat`,
"label.validate.function.category.Advanced":`Avançado`,
"label.projectManagement.team.members":`Membros da equipa`,
"vue_label_report_clickcrosstofliter":`Clique nas intersecções da tabela acima para filtrar os detalhes.`,
"lable.opppdt.selPdt.leasttwenty":`Pode seleccionar até 25 linhas`,
"label.campaign.channel.download":`Descarregar o Código HD QR`,
"component_event_label_person":`Pessoa nomeada`,
"vue_label_homepage_new_homepage":`Nova página inicial`,
"label.version.sum.vlidaterule":`Regras de Validação`,
"vue_label_chat_click_for_details":`Clique para mais detalhes`,
"label.fold":`Dobrar`,
"label.readonly":`Apenas leitura`,
"label.h5.similar.opportunity.result":`Oportunidades semelhantes`,
"label.yourimportsuc":`O seu pedido de importação foi processado, por favor veja o seu e-mail.`,
"label.report.line.yixuan":`Coluna de relatório seleccionada`,
"setup_layout_label_areaname":`Nome da Secção`,
"label.forecast.edit.title":`Alvo`,
"label.chatter.allweather":`Para todas as condições meteorológicas`,
"label.service.ganttBaiduMap.scheduled.endtime":`Data de fim prevista`,
"lable.create.new.list":`Nova Lista`,
"label.emailobject.groupemail.msg3":`{0}mail`,
"lable.opppdt.selPdt.description":`Introduza a sua palavra-chave e critérios de filtragem.depois clique em Pesquisar para iniciar a sua pesquisa Clique em Mais filtros para utilizar mais do que um filtro. Os resultados da pesquisa incluem todos os registos que correspondem tanto à sua palavra-chave como às entradas do filtro.`,
"label.file.versionerror1":`Pode clicar no link abaixo para mudar directamente para o novo separador de ficheiro de interface, ou pode utilizar a função de separador de ficheiro depois de mudar manualmente para o novo interface`,
"label.under.approve.record":`Pendente`,
"front-epwechat-module-v1-open":`Habilitar`,
"label.projectManagement.delete.task":`Toda a informação relacionada com esta tarefa será também apagada se apagar esta tarefa, e os dados não podem ser recuperados. Tem a certeza de confirmar a eliminação?`,
"label.reportforms":`Relatórios`,
"label.tabpage.onlymevisible":`É apenas visível para mim`,
"label.customer.tab.please.name":`Por favor introduza o nome do separador`,
"label_emailsync_form_stutas":`Estado`,
"message.recordtype.nolist":`Não há tipos de registos definidos.`,
"label.version.forecasting.sales":`Previsões`,
"chatter.sel.mostfield":`Pode seleccionar até`,
"label.data.derived":`Exportação de dados`,
"label.component.helper.businesschange.expiredtask":`Oportunidades com Tarefas Vencidas`,
"label.cycle":`Ciclo`,
"lable.product.standp":`Preço padrão`,
"label.sendemail.batchapproval":`Operação de aprovação de lotes`,
"message.organization.not.open.mffverification":`A organização não permite a certificação secundária.`,
"label.icon.131":`Guarda-chuva`,
"UG.activity.08":`Reservar um horário`,
"label_partner_workspace_member_choicepermission":`Seleccione o conjunto de permissões`,
"label.reportTypeCategory":`Fonte de dados do relatório`,
"label.exporttwotype":`Pode exportar dois tipos de texto`,
"message.oppdt.selectpricebook":`Por favor seleccione o livro de preços`,
"vue_label_dashboard_generatefromlistview":`Gerar a partir da Vista de Lista`,
"label.quote.title":`Título`,
"label.tianyancha.businessverify.cancel.sure":`Depois de desactivar a verificação dos dados comerciais, é impossível preencher a informação de registo comercial ao criar/editar um cliente. está confirmado?`,
"label.save":`Guardar`,
"label.mobile.quickcreate.default.appstore":`Apps`,
"label.partnerCloud.orderingPlatform.configure":`{a} os produtos não estão configurados, por favor guardar após a configuração.`,
"front-epwechat-module-v1-unbound-role":`Papéis não vinculados`,
"label.partnerCloud.financeSetting.enterAlipay":`Por favor, introduza a acocunt da empresa Alipay.`,
"label.validate.function.funcExplain.TODAY":`Voltar à Data Actual`,
"label.visualpage.parameter.values":`Mostrar os valores dos parâmetros directamente na página:`,
"label.version.task.and.activity":`Tarefas e Actividades`,
"label.audit.history":`Histórico de Aprovação`,
"setup.object.field.dependency.label.addtolist":`Acrescentar os valores seleccionados`,
"vue_label_report_exportquantity":`Quantidade exportada:`,
"label_tabpage_havez":`Em anexo`,
"label.partnerCloud.partnerAccount.amountOfRebate":`Montante de Rebate Disponível`,
"label.createralias":`Criado por Alias`,
"label.created_followup":`Criar email de acompanhamento`,
"label_chatter_mygroups":`Os meus grupos`,
"label.chat.topic.no.display":`Sem tópicos afixáveis`,
"vue_label_calendar_month_view":`Vista calendário-mês`,
"label.service.gantt.resources.assigned.work":`Recurso com Trabalho Designado`,
"UG_activity_07":`Criar uma tarefa`,
"label.quote.xsjg":`Preço de venda`,
"message.toomanyrows":`Demasiados registos para consultar.`,
"label.importsourcestep1":`Passo 1 Preparar o separador traduzido Ficheiro separado`,
"vue_label_normal_appointment_sf":`Nomeação`,
"lable.list.queue.message":`A fila não pode ser apagada, porque há registos de objectos que pertencem à fila.`,
"label.service.major.event.desc":`O marco histórico representa etapas dependentes do tempo no processo de apoio. Pode ser acrescentado ao início do processo de concessão de direitos. Pode então aplicar o processo ao direito a contas e criar caso ou ordem de trabalho a partir delas.`,
"label.ems.hostorport.null":`Tanto o servidor como a porta não podem estar vazios.`,
"chatter.group.private":`Particular`,
"label.icon.192":`Barra de sabão`,
"vue_label_systemSettings_list":`Configuração de exibição de lista relacionada`,
"label.activity.saveobj.notnull":`O objecto guardado não pode estar vazio.`,
"vue_label_chatter_current_no_people_approval":`Actualmente não há pessoas a necessitar de aprovação`,
"label.tianyancha.reglocation":`Endereço registado`,
"UG_ST_005":`Já o tenho, não me volte a mostrar esta página e da próxima vez faça o login directamente.`,
"label.vlidaterule.example.truetodisplay":`Esta mensagem aparecerá quando a fórmula de Condição de Erro for verdadeira`,
"label.icon.99":`Notas`,
"label.whenselectmoreapprover":`Quando se selecciona mais do que um aprovador`,
"label.forecast.customforecast.directorbest":`Melhor caso de Subordinado Directo`,
"label.customsetting.view.introduce":`Forneça valores para os campos que criou. Estes dados são armazenados em cache com a aplicação.`,
"label.there.are.no.unenabled.rules":`Todas as regras estão activadas.`,
"front-project-module-v1-plase-selectemplat":`Por favor seleccione o modelo do projecto`,
"label.campaignmember.selectmember.from":`A partir de`,
"setup_layout_button_quicksave":`Salvar rapidamente`,
"label.setup.service.report":`Configuração do modelo de relatório de serviço`,
"label.visualpage.direction.for.use":`Instruction Of Custome Pages [versão 2.0]`,
"message.modify":`Tem a certeza de que quer modificar?`,
"label.sms.inside":`Interior`,
"label.category.3":`Educação`,
"label.login.mfadevice.verification.title":`Verificação de dispositivos AMF`,
"UG_Forcast_08":`Passo anterior`,
"label.projectManagement.unable.to.complete":`Incapaz de completar`,
"front-kefu-moudle-all-missphone":`Todas as chamadas perdidas`,
"font-evaluate-module-v1-emergency":`Advertência`,
"label.sso.saml.sp.idsource.attr":`A identidade está num elemento Atributo`,
"chatter.not.meg":`Não é possível enviar uma mensagem vazia.`,
"label.chatter.startDate":`Dados de início`,
"label.emailobject.track.times":`Abertura total: {0}`,
"label.customsetting.fieldhasbeendeleted":`Campos eliminados`,
"label.knowledge.setting.hint.thirteen":`Adicionar outra categoria de dados`,
"message.duplication.label.newfiltertitle":`Nova Regra Duplicada`,
"setup_object_field_dependency_label_selectedfieldvalue":`Valores de campo disponíveis`,
"vue_label_calendar_who_currently_has_access":`Quem tem actualmente acesso`,
"message.passwordPolicy.validate.minlengthe":`carácter(es)`,
"label.emailsync.status.disconnect":`Cancelar Conncet`,
"label.applt.down.one":`Descarregamento de um toque`,
"label.manageAll.sel.one2":`Itens que submeti`,
"message.error.SQLTimeout":`Devido à configuração incorrecta do sistema ou consultas SQL personalizadas não optimizadas, o sistema excedeu a capacidade de consulta permitida, o que causou a falha da consulta. Por favor contacte o administrador do sistema para afinação do sistema.`,
"label.global.search.obj.setup":`Definições globais de objectos pesquisáveis`,
"vue_label_commonobjects_view_chat":`Equipa`,
"vue_label_systemSettings_startSet":`Iniciar Configuração`,
"label.quickbooks.viewlist.balance":`BALANÇO`,
"message.error.fieldid.null":`fieldid não pode estar vazio! Id do conteúdo do ficheiro`,
"label.replaceallnullvalue":`Substituir todos os valores em branco`,
"label.georgia.time":`Hora da Geórgia`,
"label.hastransfer":`Contém convertido`,
"label.partner.all.description":`Descrição`,
"font-evaluate-module-v1-following-peopple":`Quando receber a revisão negativa, notifique os seguintes utilizadores`,
"label_business_count":`Valor da Oportunidade de Negócio`,
"vue_label_ccchat_closedetail":`Fechar`,
"label.partner.all.disable":`Desactivar`,
"label.view.relationship":`Relacionamentos de objectos`,
"label.noless":`>=Mais grandioso que ou igual`,
"label.sendsms.batch.step2":`Passo 2 Seleccione um modelo ou personalize o seu conteúdo SMS`,
"label.stdashbord.xsld.business.jieduan":`Nome do palco`,
"label.appupload.component.type.trigger":`Gatilho`,
"label.knowledge.setting.data.two":`O nome da categoria é obrigatório.`,
"label.color.display.of.completion.rate":`Exibição a cores da Taxa de Cumprimento`,
"label.loginhis.default":`Lista os últimos 200 históricos por defeito`,
"vue_label_pricebook_book":`Lista de preços actual`,
"label.knowledgebase.data.deletion.failed":`{a} o apagamento de dados falhou`,
"label_partner_workspace_member_permission":`Conjunto de permissões disponíveis`,
"label.list.userinterface.approval.setup":`Configuração de Aprovação`,
"label.weixin.binding.effect":`Encadernação inválida, por favor, faça novamente o login.`,
"label.appupload.install.newapicannotnull":`O novo nome da api não pode estar vazio`,
"chatter.feed.menutype.feed.company":`Toda a empresa`,
"label.assignment.setup.detail.email":`Email`,
"label_tabpage_selectcontentz":`Seleccione por favor o conteúdo`,
"template.report.converted.leads.campaign":`Leads Convertidos de Campanhas`,
"label.forecast.season":`Este trimestre`,
"label.post":`Correio`,
"label.knowledge.setting.hint.fifteen":`As fundações foram lançadas. Agora você e a sua equipa podem escrever e organizar os seus artigos de Conhecimento.`,
"front-kefu-moudle-v1-Seats-name":`Apelido de Agente`,
"label.weixin.leadname":`Nome de chumbo`,
"label.account.quarter":`Trimestre`,
"label.detail.field":`Ver Campos`,
"label.icon.189":`Cosmética`,
"label.appointment.disable.reappointment":`Desactivar reprogramar`,
"label.appointmentconfirmpage.wizard.subtitle1":`Nome do evento`,
"label.campaign.channel.step6.remark3":`O sistema irá gerar um código QR único para solicitação, que pode ser utilizado pelos empregados e as solicitações realizadas podem ser contadas para os seus desempenhos pessoais.`,
"System.AddressFieldType.Post":`Código Postal`,
"label_partner_new_step2":`Passo 2 Confirmar modelo`,
"vue_label_helpcenter_file":`Ver e gerir os seus ficheiros<br> Utilize a nova versão do objecto de ficheiro para ver e gerir ficheiros que lhe pertencem ou que são partilhados por outros. Pode visualizar os ficheiros em alguns formatos online. <br>Biblioteca de ficheiros<br> Use a função de biblioteca de ficheiros para estabelecer uma base de conhecimentos de equipa, configurar diferentes administradores e membros para uma gestão conveniente; use a função de pasta para classificar os ficheiros.`,
"label.locateddowncurrentvalue":`O valor abaixo do actual`,
"label.tianyancha.businessverify.msg5":`2. fiabilidade do serviço`,
"label.setup.mobile.bottombutton.change.success":`Mudanças bem sucedidas`,
"label.appointmentconfirmail.wizard.subtitle2":`Hora`,
"label.email.address.lookup":`Pesquisar endereço de correio electrónico`,
"setup.mainpage.label.welcome":`Bem-vindo à plataforma CloudCC PaaS, as principais funções da plataforma são as seguintes:`,
"label.icon.55":`Bulldozer`,
"label_tabpage_enterrecordnamez":`Por favor, introduza o proprietário do disco`,
"label.tabpage.andz":`E`,
"label.selectfiletoimport":`Seleccionar ficheiro a importar`,
"label.version.sum.trigger":`gatilho(s)`,
"label.multi.layout":`Layouts compactos`,
"pagecreator.button.back":`Último Passo`,
"label.imgfield.truetype":`Por favor, carregue o tipo de imagem correcto`,
"front-kefu-moudle-v1-publicKey":`Chave Partilhada`,
"label.data.exp.newtemp":`Criar modelo`,
"label.martrixreport.2018.step4.new":`Passo 4 Escolha os cabeçalhos das colunas`,
"label.sendemail.chat.addComentsatsubject":`Fui mencionado na mensagem do CloudCC CCChat`,
"vue_label_applauncher_description_leadpool":`Utilizar o Lead Pool para gerir convenientemente o estado de seguimento dentro da organização e motivar o pessoal para completar as transacções.`,
"label.knowledgebase.archive.published.articles.without.drafts":`Só se podem arquivar artigos publicados que não tenham rascunhos.`,
"label.projectManagement.bar.chart":`Gráfico de barras`,
"label.ccpeak.condition.return.sort":`Devolução e classificação por condições`,
"label.salescloud.opportunity.contactrole":`Oportunidade Função de Contacto`,
"label.language":`Idioma`,
"message.error.view.badprevilege":`Desculpe, não lhe é permitido ser servido este serviço, por favor contacte o seu administrador.`,
"label.textmessage.managetemplates":`Gerir os modelos`,
"message.error.type.null":`O tipo não pode ser nulo!`,
"setup.mainpage.label.welcome9":`Os utilizadores podem realizar a exibição de classificação e o ajuste de layout de todos os elementos da página e a definição de campos só de leitura e obrigatórios dos campos da página, arrastando e largando o rato sem desenvolvimento de código.`,
"label.appupload.component.type.page":`Páginas personalizadas`,
"label.textmessage.bookschedule":`Clique no link abaixo para ver e reservar a minha agenda:`,
"component_chatter_post_button_save":`Publicar`,
"lable.oppt.jieduan.signcomplete":`Marcar a etapa como concluída`,
"label.help.notes":`AJUDA E GUIA`,
"label_tabpage_reallproplez":`Registar todas as pessoas`,
"label.obtain.authorization.failure":`Falha na aquisição do código de autorização. Por favor, reautorize.`,
"label.account.FiscalQuarter":`Trimestre Fiscal`,
"label.customsetting.savecustomvalue":`Os dados para este local já existem, por favor modifique-os e guarde-os novamente.`,
"label.maximum":`Máximo`,
"component_chatter_file_label_maxsize":`O tamanho máximo do ficheiro é de 20m`,
"c218":`O seu posto foi guardado como um rascunho`,
"c875":`Novo posto para conversação`,
"c183":`Filtro de etiquetas`,
"c366":`Configurar a piscina`,
"c91":`Pontuação de Interacção de Email`,
"c184":`Avanço de Palcos`,
"c750":`Iniciador:`,
"c619":`As mensagens no Twitter devem ter 280 caracteres ou menos. Tente usar contracções para encurtar as coisas.`,
"c69":`A pagar`,
"c675":`Alinhado à esquerda`,
"c533":`Contagem de casos melhorados`,
"c167":`O comprimento da encomenda é necessário`,
"c682":`Praça`,
"c960":`Super Edição`,
"c850":`Isto mostra o número actual de seguidores para cada uma das suas contas sociais, excepto para o Facebook que mostra o número actual de páginas de que gosta.`,
"c343":`Adicionar membros do projecto`,
"c8":`Escolha o formulário`,
"c157":`Modo de tomada de encomenda aberta`,
"c397":`Tripulação de serviço`,
"c556":`as imagens não são publicadas`,
"c563":`Tempo Activo`,
"c179":`Logotipo de parceiro`,
"c147":`Regras de tomada de encomenda`,
"c303":`Obrigação legal`,
"c885":`Esconder a barra lateral`,
"c808":`Inserir imagem`,
"c718":`Continuar a criação`,
"c414":`Obrigado pelo seu tempo para o completar.`,
"c9":`Solicitação de empregados`,
"c15":`Foi facturado. Por favor, seleccione novamente`,
"c59":`Por favor, liguese primeiro como administrador Easemob e depois introduza a configuração avançada.`,
"c504":`Planear projectos, atribuir trabalho, gerir recursos e colaborar com a sua equipa para alcançar os objectivos do projecto, controlar o progresso do projecto, entregar o projecto dentro do prazo e do orçamento.`,
"c836":`Conta Bind Fadada`,
"c187":`Página de agradecimento`,
"c208":`Descarregar pacote`,
"c952":`Brasil`,
"c104":`Responder uma vez`,
"c346":`Cálculo de Recursos de Tarefas`,
"c913":`Expandir a barra lateral`,
"c571":`{foi seleccionado o(s) formulário(s)`,
"c44":`Escolha uma rede para ligar`,
"label.social.posts.content.null":`O conteúdo do correio está vazio`,
"c852":`Nome da empresa (Não preenchido)`,
"c561":`Aplicar filtro`,
"obtain.contract.envelopeid.fail":`Falha na obtenção de informação sobre envelopes ou informação sobre mensagens não vinculadas`,
"c465":`Só as encomendas que utilizam a mesma moeda podem gerar uma factura`,
"c982":``,
"c350":`Classificação de tarefas`,
"c352":`Calendário de Recursos Humanos`,
"c670":`Ícones gráficos`,
"front-electronic-signature-given":`Entrega`,
"c542":`Avaliação da Satisfação`,
"c314":`Gerar ficheiro de facturação`,
"c148":`Configuração de Notificação por Email`,
"c47":`Ligar Domínio`,
"c754":`Preencher`,
"c326":`Lista técnica de activos`,
"c289":`Preferência`,
"c196":``,
"c63":`Aberto {objName}`,
"c769":`O documento de tarefa iniciado, assinado, será limpo após a revogação. Continuar a desfazer?`,
"c216":`O seu posto foi agendado`,
"c842":`Enviar Notificação de Envio de Email`,
"c389":`Território de Serviço aos Pais`,
"c7":`Proprietário da Promoção`,
"c981":``,
"c143":`Seleccionar o utilizador para receber notificações. Esta configuração pode ser alterada em qualquer página de destino em que o formulário seja utilizado.`,
"c930":`Interruptor de posicionamento de empregados`,
"c515":`Adicionar Resumo do Trabalho`,
"c393":`Membro do Território de Serviço`,
"c357":`Taxa`,
"c597":`Bitola Alvo`,
"front-electronic-signature-cancelIntro1":`A assinatura E de DocuSign não estará disponível após a desobrigação. Tem a certeza de desvincular?`,
"c271":`Tem um tempo limite para aceitar a encomenda, número: {0}. Por favor, trateo prontamente e esteja ciente dos atrasos do trabalho. Clique para ver mais >`,
"label.gaode.map.cannot.work.normally.please.check.whether.the.secret.key.is.correct":`O Amap não funciona correctamente. Por favor, verifique se a chave secreta está correcta!`,
"c424":`Serviço de Gestão do Território`,
"c711":`Ligue as suas contas sociais e alcance um mundo totalmente novo de fãs.`,
"c197":`Atingiu o número máximo de submissões. Obrigado pela sua participação!`,
"front-electronic-signature-save-success":`Salvar a cartografia com sucesso`,
"c765":`Bloqueado`,
"c286":`Nãoconformidade`,
"c145":`As horas de trabalho submetidas para uma/múltiplas tarefas por pessoa por dia não podem exceder 24 horas.`,
"c264":`Gerir os campos pessoais`,
"label.china":`China`,
"label.no.bind.mobile":`Sem telemóvel. Por favor, vá para informação pessoal e vincule`,
"c95":`Eliminar produtos seleccionados`,
"front-electronic-signature-open-signInfo1":`A Esignature&stamp of DocuSign está activada. Por favor, desligueo e active o Esignature&stamp de Fadada.`,
"c391":`Ver Comentário`,
"c106":`Interacções`,
"c519":`Toda a informação relacionada com esta folha de tempos será também apagada se apagar esta folha de tempos, e os dados não podem ser recuperados. Tem a certeza de confirmar a eliminação?`,
"c528":`Folha de tempos de registo`,
"c78":`N.º de encomenda`,
"c41":`Desobstruir com sucesso`,
"c517":`Por favor, introduza uma taxa de imposto válida`,
"c774":`Assinar progresso`,
"c296":`Preencha por favor o nome do campo`,
"c757":`Para aceitar`,
"front-electronic-signature-confirmintro":`Ligar com sucesso. Pode iniciar agora a assinatura a partir do objecto dos Contratos.`,
"c446":`Estado da tarefa`,
"c238":`{!ServiceResource.name} acedeu à encomenda. Conta: "{!ServiceApontamento.responstid.nome}", Assunto: "{!ServiceAppointment.subject}", Número: "{!ServiceAppointment.name}".`,
"c980":``,
"c802":`Cada utilizador só pode ser adicionado como um recurso de serviço`,
"c387":`Habilidades de Recursos de Serviço`,
"c965":`O serviço EaseMob não está activado`,
"c480":`A que lista devemos enviar?`,
"c937":`Alterar número de telefone`,
"c632":`Ver no Facebook`,
"c131":`O campo de conta da factura está vazio, por favor adicione a informação.`,
"c680":`Branco`,
"c806":`Quando`,
"c649":`Já leu tudo na sua caixa de correio.`,
"c797":`Contactos recentes`,
"c616":`Abrir link em nova janela`,
"c169":`Desculpe, não tem autorização para ver este quadro`,
"c21":`O número do produto não pode ser inferior ao montante facturado`,
"c231":`Não pode ser inferior ao número de produtos que foram embalados`,
"c555":`A sua imagem de correio não foi publicada.`,
"c583":`Mapa da China`,
"front-electronic-signature-open-signInfo2":`A Esignature&stamp de Fadada está activada. Por favor, desligueo e active o Esignature&stamp do DocuSign`,
"c822":`Novos Contactos Externos`,
"c600":`Carta numérica`,
"c442":`Sistema completo de gestão de projectos`,
"c762":`Para assinar`,
"label.user.not.permission":`O utilizador actual não tem permissão para operar`,
"c35":`Nome da Subscrição`,
"c921":`função(ões)`,
"c305":`Interesses Públicos`,
"c730":`Não é possível reutilizar a antiga palavrapasse`,
"c525":`Desactivar Utilizador do Portal`,
"c942":`América`,
"c780":`Processo de Assinatura`,
"c447":`Fonte Final do Canal`,
"c369":`Enviar Ficheiro de Citações`,
"c702":`Fazer rascunho`,
"c22":`O montante pago na factura será superior ao valor total se continuar a criar este detalhe de pagamento. Por favor, reajuste o montante e poupe novamente.`,
"c79":`Data de encomenda`,
"c785":`Nome Real (Opcional)`,
"label.insert.approval.reassign.error":`A aprovação na inserção do estatuto de aprovação não pode ser reatribuída`,
"c273":`Aceitação de tempo limite de encomenda. Cancelar o despacho.`,
"c3":`Apagar gráfico com sucesso`,
"c448":`Sessão de Conversa`,
"c495":`Tudo o que precisa para vender mais depressa e com mais inteligência`,
"c429":`Despacho de KPI`,
"c16":`Existem mais do que uma encomenda facturada. Por favor, seleccione novamente`,
"c128":`Podem ser acrescentadas até 5 filas`,
"c955":`A largura mínima de {label} é {minWidth}px`,
"c716":`Está pronto para começar a publicar directamente do CloudCC`,
"c638":`Opções de publicação`,
"c746":`Pedido de revogação de destruição`,
"c534":`Contagem de casos encerrados`,
"c948":`Itália`,
"c317":`Enviar ficheiro de pedido de compra`,
"c426":`Serviço de Gestão de Recursos`,
"c457":`Valor Agregado do Contrato Ranking`,
"c263":`Campos pessoais`,
"c372":`Gerar ordem`,
"c907":`Disponível apenas na versão relâmpago`,
"c771":`Progresso de preenchimento`,
"c408":`Aplicação de serviço de campo personalizável`,
"c12":`Taxa de crescimento`,
"c379":`Detalhes de pagamento`,
"c410":`Tipo de trabalho`,
"c510":`Encomendas de parceiros`,
"c701":`Campanha de Atribuição`,
"c617":`O texto é necessário para publicar um post`,
"c213":`Formato EPS`,
"c473":`O sistema irá gerar um código de convite único para os funcionários, que podem utilizar o código de convite para fazer convites e contar como desempenho pessoal. Notese que o proprietário principal será o actual proprietário da campanha ou do convite do canal de marketing.`,
"c975":``,
"c168":`Por favor escolha uma tabela!`,
"c121":`Uncategorized`,
"label.send.invoice":`Enviar Factura`,
"c792":`Confirmar Iniciar`,
"c686":`Tamanho`,
"c652":`Isto mostra o número de postos de trabalho que foram publicados nas suas contas dentro do período seleccionado. Isto também inclui os posts que foram publicados nas suas contas ligadas fora do CloudCC.`,
"c136":`Por favor introduza aqui uma breve introdução`,
"c662":`Ícone personalizado`,
"label.invoice.customer.is.error":`A geração de facturas só é suportada para encomendas feitas pelo mesmo cliente.`,
"c580":`Gráfico de bolhas`,
"c894":`Atribuir campanha pelo correio e pode rever todos os postos relacionados na mesma campanha. Isto é utilizado para um esforço de marketing anlyazing.`,
"c570":`Desenho`,
"c133":`exceder`,
"c564":`Caro utilizador: \Bemvindo ao sistema CloudCC. Pediu para redefinir a sua palavrapasse em {!operatetime}, por favor inicie sessão com o código de verificação abaixo dentro de 15 minutos: \Código de Verificação Aleatória: {!authcode}n Importante: Se não solicitou esta operação, ou se pensa que esta mensagem não deve chegar até si, por favor contacte imediatamente o seu administrador!`,
"c854":`Parece que não há nada pubilizado.`,
"c775":`Interrompido`,
"c105":`Reproduzir mais de uma vez`,
"c729":`Por favor confirme que configurou ou não a plataforma social. Ir para configurações backend  Integrações  Habilitar (Twitter/Facebook/LinkedIn)`,
"c491":`Desactivado`,
"c609":`Marca registada`,
"c611":`Link para`,
"c843":`Ver Submissão`,
"c933":`Página de Conversão`,
"c383":`Produtos de Oportunidade`,
"c186":`A identificação única já existe. Por favor, não adicionar repetidamente`,
"c608":`Substituir`,
"c149":`Activar a notificação do Outlook (apenas suporta parte dos serviços de correio electrónico)`,
"c486":`Responder ao endereço de email:`,
"c598":`Mapa de Donuts`,
"c726":`Pedido de destruição com sucesso`,
"c645":`Aprovar Projecto`,
"label.verificationCode.is.invalid":`O código de verificação era inválido. Por favor, readquirao`,
"c904":`Entre`,
"c594":`Gráfico de linhas 2D`,
"c103":`Clique mais de uma vez`,
"c188":`comentário(s)`,
"c891":`O registo não pode ser um contacto, oportunidade, chumbo ou conta`,
"c902":`Distância entre o endereço de início de sessão e o visitante`,
"c484":`Emails:`,
"c421":`Método de Geração de Ordens de Trabalho`,
"c406":`Gestão automatizada de vendas`,
"c739":`Campanha: Solicitação de Empregados`,
"c329":`Substituição de bens`,
"c351":`Frequência de recorrência`,
"c622":`As estatísticas da rede são actualizadas pela última vez em`,
"2":`Configurar as opções de filtragem com sucesso`,
"c463":`As Minhas Oportunidades`,
"c268":`Fundir informação com sucesso`,
"label.mobile.no.letter.blankcharacter":`O número de telefone não pode conter letras e caracteres em branco`,
"c438":`Transferência`,
"c581":`Tabela MoM&YoY`,
"c953":`Coreia do Sul`,
"c90":`Assunto`,
"c2":`Eliminar o painel de instrumentos com êxito!`,
"c897":``,
"c444":`Fonte do Primeiro Canal`,
"c242":`{!ServiceResource.name} rejeitou a encomenda. Conta: "{!ServiceApontamento.conta.nome}", Número: "{!ServiceApontamento.nome}".`,
"c135":`Modelo em branco`,
"c659":`Sigamme`,
"c773":`Finalizando`,
"c11":`Promoção do marketing de forma`,
"c799":`Contactos externos`,
"c880":`editar postos sociais`,
"c890":`Enviar email de convite com sucesso`,
"c846":`Por favor, seleccione uma marcação de serviço elegível`,
"front-electronic-signature-sucessSign":`Comece a assinar com sucesso`,
"c472":`Escolha um formulário para aplicar o cartaz em`,
"c963":`O campo do nome é obrigatório`,
"c390":`Território de Serviço à Criança`,
"c248":`A aceitação da transferência da ordem está pendente`,
"c646":`Fluxo de caixa de entrada`,
"c308":`Seleccionar pelo menos um dado`,
"c858":`Tem a certeza de que quer guardar as mensagens {a} como rascunhos? Estes posts não serão publicados, a menos que os marque novamente.`,
"c152":`Número de nomeações de serviço concluídas no intervalo de tempo actualmente seleccionado / Número de todas as nomeações de serviço no intervalo de tempo actualmente seleccionado`,
"c316":`Ver Progresso do Caso`,
"c435":`Ver versão`,
"c362":`Restrições de produtos em anexo`,
"c800":`Por favor introduza o nome ou o nome da empresa`,
"c415":`Início programado`,
"c735":`O nome não pode ser repetido`,
"c903":`Seleccionar Ícone de Aplicação`,
"label.insert.approval.massreassign.error":`Aprovações de lotes existentes A aprovação de inserção não pode ser reatribuída. O sistema irá autofiltrar para si`,
"c354":`Editar folha de tempos`,
"c409":`Plataforma de serviço ao cliente de uma paragem`,
"c651":`Isto mostra o número de Seguidores actuais para cada uma das suas contas sociais, excepto para o Facebook, que mostra o número de páginas actuais que gosta.`,
"c582":`Mapa mundial`,
"c826":`Tem a certeza de que quer descartar as suas alterações?`,
"c781":`Empresa: Por favor, introduza o nome da empresa na licença comercial. A verificação será feita aquando da assinatura.`,
"c873":`Mais detalhes`,
"c837":`Após a desobrigação, a função Fadada Esignature não pode ser utilizada, e a função de autopreenchimento e de campo de preenchimento que tenham sido definidos serão eliminados. Tem a certeza de desobstruir a conta?`,
"label.diedirect.sale":`Reduções directas de preços`,
"c798":`Contactos Internos`,
"c368":`Gerar ficheiro de citações`,
"c770":`Iniciado`,
"c882":`Termos de Serviço`,
"front-setting-dialog-title-two":`Configurado a partir da página de informações pessoais, se não for introduzido desta vez. Ligar à medida que se introduz o número`,
"c535":`Não resolvido`,
"front-electronic-signature-look-account":`Ver conta`,
"c19":`Modo de exibição de detalhes de gravação`,
"c52":`Nome fiscal`,
"c388":`Direito de Associar e Utilizar`,
"c18":`Existem mais do que uma encomenda inactiva, por favor, seleccione novamente`,
"c820":`Por favor introduza o número de telefone/caixa de correio`,
"c285":`Visão geral`,
"c478":`Autenticar o Mailchimp`,
"c164":`Por favor introduza um valor inteiro de 060`,
"label.tip.excess.quota":`A utilização deste recurso foi excedida`,
"c318":`Gerar ficheiro de pedido de compra`,
"c698":`Rede Social`,
"c312":`Encomendas múltiplas ainda não são efectivas, por favor seleccione novamente`,
"c110":`Agrupar por projectos`,
"c549":`O intervalo de datas não pode exceder 31 dias!`,
"c845":`Por favor seleccione pelo menos uma marcação de serviço`,
"c282":`Gerir os dados pessoais dos clientes no âmbito do CRM`,
"c270":`Aceitar tempo limite de encomenda`,
"c288":`Alteração da Base de Processamento de Dados`,
"c878":`Endereço actual`,
"c324":`Adicionar filas de espera aos processos`,
"c129":`Esta acção irá apagar permanentemente o ficheiro. Quer continuar?`,
"c339":`Dados GDPR Destroy`,
"c405":`Tamanho da tripulação`,
"c848":`Contas Linkedin`,
"c345":`Modelo do Projecto`,
"c591":`Mapa da Austrália`,
"c180":`Idioma na página de Login`,
"c126":`Entregue em`,
"c311":`Não eficaz, por favor seleccione novamente`,
"c587":`Mapa do México`,
"c37":`Este é o texto a ser visto na página de preferência de comunicação do seu cliente`,
"c840":`Viva! Nada de posts sem graça.`,
"c241":`{!ServiceResource.name} rejeitou a encomenda. Conta: "{!ServiceApontamento.de.conta.nome}", Assunto: "{!ServiceAppointment.subject}", Número: "{!ServiceAppointment.name}".`,
"c141":`A mensagem de agradecimento é necessária`,
"obtain.contract.fail":`Falha na aquisição de informações contratuais`,
"c945":`Rússia`,
"c454":`Montante do Contrato Mensal`,
"c34":`Tem 100 produtos no seu carrinho de compras. Por favor, limpe pelo menos um item antes de adicionar um novo produto.`,
"c243":`{!ServiceResource.name} rejeitou a encomenda. Assunto: "{!ServiceAppointment.subject}", Número: "{!ServiceAppointment.name}".`,
"c548":`Tarefa/assessoria, subtarefa e projecto não podem ser editados a partir de uma folha de tempos`,
"c807":`Publicar agora`,
"c590":`Mapa da Alemanha`,
"c831":`Certifica`,
"c198":`O seu formulário é publicado com segurança e pode ser utilizado no seguinte URL para partilhar o seu formulário como um link público.`,
"c977":``,
"c66":`A informação logística do produto é actualizada para Delivered`,
"label.twitter.title.setting":`Informação integrada no Twitter`,
"c922":`Por favor contacte o administrador para activar a Equipa`,
"front-email-payment-Invoice-Tips":`Por favor contacte o administrador para activar PayPal ou VISA e depois iniciar o pagamento online`,
"c605":`	
Endereço de facturação por defeito`,
"c403":`Projectos`,
"c156":`Regras de tomada de encomenda para o lado móvel`,
"c635":`Agendar outro posto`,
"c753":`Participante`,
"c647":`Toda a actividade`,
"c295":`Após desligar, todos os campos pessoais de marcação, base de processamento de dados e outras informações para cumprir com a DGPR serão removidos, excepto o histórico de operações para registos. Tem a certeza de que desligará?`,
"c915":`Piscina aberta`,
"front-electronic-signature-signStatus":`Começou a assinar em linha. O estatuto do contrato é {signStauts}.`,
"c568":`Ajustar o Layout`,
"c744":`Por favor introduza um número válido entre 0 e 100`,
"c464":`o(s) correio(s) é(são) eliminado(s)`,
"c385":`Resumo do trabalho`,
"c392":`Escolha a solução que necessita`,
"c418":`Recursos de Serviços Atribuídos`,
"c256":`A mudança de conta limpará a encomenda com itens seleccionados. Tem a certeza de que vai mudar?`,
"c690":`Carregamento de imagem`,
"c261":`Destruir dados`,
"c62":`Solicitação de empregados`,
"c892":`O registo actual não foi encontrado`,
"c909":`Foram acrescentadas definições de preços para esta moeda. Por favor, não volte a adicionar!`,
"c883":`&`,
"c134":`Limite superior dos membros da piscina`,
"c896":`O registo bloqueou e não suporta a adição de ficheiros. Por favor contacte o administrador para desbloquear`,
"c974":``,
"c209":`Tamanho médio`,
"c185":`Estatísticas nesta página`,
"c796":`Por favor contacte o administrador para criar um modelo de contrato na plataforma Fadada antes de iniciar a assinatura.`,
"c60":`Contagem de projectos`,
"c866":`Aplicação de configuração`,
"c666":`Mostrar`,
"c219":`O seu posto foi eliminado`,
"c732":`Cartaz`,
"c155":`{nome} Nome`,
"c511":`Econtrato`,
"c240":`Rejeitado`,
"c468":`O tipo de ordenação está vazio`,
"c961":`Q{quarter} {ano}`,
"c404":`Uma ferramenta de marketing e de geração de leads`,
"c586":`Mapa de Singapura`,
"c694":`Largura/Altura`,
"c297":`Por favor, introduza o tipo de dados pessoais`,
"c860":`Alterar endereço`,
"c58":`Página inicial do projecto`,
"c920":`Se as regras de autoreciclagem estiverem configuradas, o sistema fará a autoreciclagem dos registos para a piscina quando o chumbo não tiver sido convertido após o limite de tempo. Isto melhora a eficiência do seguimento do chumbo.`,
"c27":`Por favor insira a quantia flutuante para ajustar a quantia bruta, por exemplo,  10 ou 10.`,
"c94":`3 vezes acima`,
"c1":`Apenas móvel`,
"c557":`Casos Recebidos`,
"c294":`Desligar as definições de conformidade do GDPR`,
"c970":``,
"c565":`Atribuir esta tarefa a`,
"c668":`Alinhamento`,
"c972":``,
"c660":`Direitos de autor`,
"c433":`Rastreio de campo do reservatório de chumbo`,
"c443":`Arquivo Todos`,
"c275":`{0} tem um tempo limite de aceitação da encomenda, e o despacho é cancelado. Número: {1}. Clique para ver mais >`,
"c691":`Link(Opcional)`,
"c956":`Ainda não activou a sua conta Mailchimp. Por favor, vá a definições>Integração>Lista de integração para activar a sua conta Mailchimp ou contacte o administrador.`,
"c910":`Nova Ordem de Trabalho`,
"c692":`Navegador predefinido`,
"c355":`Batch Adicionar Timesheets`,
"c122":`Imagem do produto`,
"c395":`Tipo de território`,
"c689":`Altura máxima`,
"c344":`Ver Projecto com Mapa de Gantt`,
"c656":`Tempo de Actualização`,
"c943":`Japão`,
"front-electronic-signature-outerSinger":`Signatário externo`,
"front-generate-v1-invoiceDetail":`Detalhe de facturação`,
"front-electronic-signature-open-vertify":`Por favor introduza o código de verificação`,
"c291":`Tipo de dados pessoais`,
"front-setting-phone-message":`Por favor introduza o número de telefone`,
"c559":`Casos Escalados`,
"label.google.map.cannot.work.normally.please.check.whether.the.secret.key.is.correct":`O Google map não funciona correctamente. Por favor, verifique se a chave secreta está correcta!`,
"c259":`Noções básicas de processamento de dados`,
"c488":`Tempo Convidado`,
"c6":`Nome da promoção`,
"front-electronic-signature-signerInfo":`Configurar Informação Signatária`,
"c512":`Membros do projecto`,
"c507":`Cultivo de chumbo`,
"c760":`Rejeitado`,
"c756":`Não enviar`,
"c321":`Requerido ou não`,
"c817":`Ver definições de permissão do menu de páginas personalizadas`,
"c949":`Espanha`,
"label.biaoqing.field.relation.tip":`Campo de descoberta de licitações e concursos`,
"c382":`Pontuação da Rede de Relações`,
"c265":`Esta ordem não pode ser alterada, pois ainda não é eficaz`,
"c417":`Informação de trabalho de recursos de serviço`,
"c847":`Contas Facebook`,
"c494":`Conseguir uma gestão unificada de todos os canais no CloudCC Marketing Cloud. Construa ligações e confiança duradoura com os seus clientes, impulsione o ROI com análises, e transforme o alcance em receitas.`,
"c86":`Campanha: Edit Employee Referal`,
"c776":`Desfazer com sucesso`,
"c709":`Escolha uma rede para ligar`,
"label.mobile.orVerificationCode.is.error":`O número de telefone ou o erro do código de verificação`,
"c579":`Mapa de radar`,
"c413":`Estado da nomeação de serviço`,
"c950":`Países Baixos`,
"c573":`Gráfico de barras 2D`,
"label.choose.is.tax":`Escolha o tipo de imposto`,
"c768":`A tarefa de assinatura do contrato iniciado ainda não foi concluída. Favor descarregar o documento após a assinatura do contrato.`,
"c604":`O endereço de facturação já existe, excepto o actual como novo endereço de facturação`,
"c160":`Tratamento em atraso`,
"c239":`Aceite`,
"c834":`Preliminar Aprovado`,
"c113":`Enviar {nome}`,
"c146":`Os produtos relevantes serão limpos após a mudança da moeda. Quer continuar a mudar?`,
"c313":`Enviar ficheiro de facturação`,
"c140":`Escolher objecto e modelo`,
"c298":`Não conforme`,
"c681":`Círculo`,
"c870":`Tem a certeza de que vai apagar o lote?`,
"c551":`<span style="fontsize: 16px; fontweight: bold; color: #fe8a14">{days} </span> dias restantes no julgamento`,
"c88":`Dias que faltam para o julgamento`,
"c175":`Falha em obter informações detalhadas`,
"c64":`Abrir ou não {objName}`,
"c319":`Configuração do Estilo do Formulário`,
"label.pay.online":`Iniciar o pagamento online`,
"c941":`China  Taiwan`,
"c550":`Por favor escolha a data de início ou de fim`,
"c365":`Sync Quote Line to Opportunity Product`,
"c908":`Seleccionar Ícone`,
"c260":`Pedido para Destruir`,
"c50":`Taxa de imposto`,
"c869":`Tem a certeza de arquivar todos os dados`,
"c93":`Aberto Repetidamente`,
"c280":`Eliminar email`,
"c23":`O montante pago na factura será superior ao montante da encomenda se continuar a criar este detalhe de pagamento. Por favor, reajuste o montante e poupe novamente.`,
"front-console-v1-see-contacts":`Identificou múltiplos contactos. Por favor seleccione`,
"c607":`O endereço de envio já existe, excepto o actual como novo endereço de facturação`,
"c229":`Eliminar marco`,
"front-filter-v1-filter-by-name":`Filtrar por '{nome}'.`,
"c125":`Em trânsito`,
"c513":`Folhas de horas`,
"c80":`Endereço para facturação`,
"c648":`Conversas`,
"c521":`Contagem de Encomendados`,
"c560":`Casos encerrados`,
"c973":``,
"c509":`Lista de embalagem`,
"c685":`Adicionar novo endereço`,
"c178":`O formato da imagem carregada não é suportado. Por favor carregue as imagens no formato de png, jpg, e jpeg.`,
"c436":`Detalhes do Visitante`,
"front-electronic-signature-prepareTemplate":`Por favor contacte o administrador para predefinir o modelo de contrato no sistema antes de começar a assinar.`,
"c749":`Processo de assinatura`,
"c114":`Por favor clique no botão Gerar {nome} para gerar {nome} antes de enviar.`,
"c898":``,
"c279":`Vendas`,
"c232":`Não pode exceder o número de produtos a serem embalados`,
"c911":`Despacho Cancelado`,
"c901":`O seu número de submissões atingiu o limite.`,
"c663":`Texto alternativo`,
"c541":`Estatísticas de casos actuais`,
"c536":`Recebido`,
"front-project-v1-batch-deletion-confirmation-information":`A eliminação em lote dos registos seleccionados também eliminará toda a informação associada aos seleccionados, e os dados não podem ser recuperados. Tem a certeza de que vai apagar?`,
"c893":`O utilizador actual não pode ter acesso ao campo de endereço para editar detalhes da conta`,
"c623":`Monitor`,
"c493":`Shape Digital Marketing, Aproveite Todas as Oportunidades`,
"c327":`Hierarquia de bens`,
"c747":`O seu número total de produtos está cheio. Por favor, elimine primeiro alguns produtos e depois continue a adicionar produtos.`,
"c728":`Privacidade de dados`,
"front-reportlist-v1-optimizedReport":`os relatórios são optimizados após consulta. Por favor, não modificar aleatoriamente.`,
"c741":`Por favor, preencha o conteúdo do correio!`,
"c643":`Detalhes do posto`,
"c537":`Tempo de resposta Avg`,
"front-electronic-signature-add-field":`Adicionar Campo de Enchimento`,
"c626":`Todos os Utilizadores`,
"c199":`Ligação ao formulário`,
"c917":`Utilizar a piscina para estimular o potencial da equipa e melhorar a eficiência do acompanhamento das contas. O administrador do pool faz uma gestão unificada para contas e atribuições de lotes. O pessoal de vendas também pode seleccionar leads e receber acompanhamento.`,
"c159":`A duração da encomenda não excede um máximo de`,
"c640":`Posto de horário`,
"c192":`Layout actual da página:`,
"c978":``,
"c969":``,
"c871":`É assim que o seu posto será exibido em {a}. Podem ocorrer ligeiras diferenças se {a} fizer quaisquer ajustes de layout.`,
"c814":`1{0} seleccionado`,
"c235":`{!ServiceResource.name} acedeu à encomenda. Assunto: "{!ServiceAppointment.subject}", Número: "{!ServiceAppointment.name}".`,
"c215":`O seu posto foi publicado`,
"c425":`Gestão de Nomeações de Serviço`,
"c182":`A ordem de trabalho e o registo do caso não podem ser ligados de uma só vez`,
"c194":`Número limite de envios`,
"c657":`Sem permissão para operate， por favor contacte o administrador`,
"c855":`Parece que não há nada agendado.`,
"c333":`Custo orçamental`,
"c338":`Fornecedor  Destroy`,
"c431":`Hierarquia da campanha`,
"c374":`Produto do Livro de Preços`,
"c506":`Horário automatizado`,
"font-trade-module-invoice-totalMoney":`Total de Facturas a Receber`,
"c203":`Partilhe os seus formulários através do Mailchimp`,
"c962":`{mês} {ano}`,
"c786":`Número de telefone/caixa de correio`,
"c469":`A página está em estado de edição. Os dados actuais não podem ser guardados se deixar a página`,
"c137":`Escolha um modelo para o formulário`,
"c483":`Informações sobre a campanha`,
"c947":`França`,
"c190":`A moeda dos itens de pagamento deve ser consistente com a moeda de encomenda, factura e pagamento. Por favor, refinar a moeda e guardar novamente.`,
"c386":`Preenchido`,
"c803":`Contas: Todas as contas`,
"c759":`Para preencher`,
"c823":`Definição de encomendas`,
"c422":`Método de Geração de Nomeações de Serviço`,
"c782":`Como Participar`,
"c416":`Relatório de Serviço Push Record`,
"c758":`Aceite`,
"c407":`Membro da Tripulação de Serviço`,
"c51":`Novo Imposto`,
"c844":`Conta Bind DocuSign`,
"c361":`Menu Editar`,
"c602":`Gráfico Matricial`,
"c191":`É necessária a permissão de edição da vista actual`,
"c299":`Seleccionar pelo menos um objecto`,
"c432":`História da campanha`,
"c650":`Publicar um novo post para iniciar uma nova conversação`,
"c531":`Contagem dos casos recebidos`,
"c13":`O utilizador actual não tem a permissão para editar`,
"c162":`Informar simultaneamente o cedente e o cessionário`,
"c171":`Accionista`,
"c230":`Eliminar Tarefa`,
"c470":`Campos de preenchimento automático`,
"c367":`Gerar Contrato`,
"c26":`Estabelecer Desconto`,
"c705":`Posts Publicados`,
"c613":`Página externa`,
"front-electronic-signature-openSign":`Comece a assinar`,
"c349":`Arrastar e largar`,
"c683":`Carregar mais`,
"c679":`Cinzento`,
"c914":`Colapso da barra lateral`,
"c224":`Ir para Milestone`,
"c220":`O seu posto foi publicado sem sucesso`,
"c498":`O CloudCC Inventory apoia eficazmente os negócios online e offline omnicanal, realizando o fluxo e a gestão de bens e fundos. Vários módulos são eficazmente combinados, e os utilizadores podem alcançar uma gestão de encomendas refinada para criar situações vantajosas para ambas as partes com parceiros.`,
"c566":`Autorecuperação do endereço da conta depois de guardar`,
"front-electronic-signature-ContractTemplate":`Escolher modelo de contrato`,
"c540":`Resolver o Tempo por Canais`,
"c793":`Modelos de documentos`,
"c293":`Definir objectos para permitir o cumprimento do GDPR`,
"front-invoice-online-pay-again":`Já iniciou um pagamento em linha. Por favor, não tente novamente.`,
"front-electronic-signature-open-password":`Por favor introduza a palavrachave`,
"front-v1-partner-background-tooltip":`É suportado um ficheiro máximo de 2M. Recomendase o carregamento de imagens claras.`,
"c449":`Histórico do Chat`,
"c30":`Clássico`,
"c245":`{!oldServiceResource.name} transferiu a ordem de trabalho numerada {!ServiceApontamento.name} para {!newServiceResource.name}`,
"c923":`Aqui está a sua equipa`,
"c24":`Mostrar Mapa`,
"c872":`Nome (Não preenchido)`,
"c886":`Barra lateral aberta`,
"c485":`Nome do formulário:`,
"c101":`pc(s)`,
"c816":`Ver post`,
"c445":`Papel do Projecto`,
"c853":`Isto mostra o número de gostos e comentários para os seus posts publicados.`,
"c398":`Comece Agora`,
"c522":`Contagem de Facturados`,
"c287":`Conformidade`,
"c578":`Carta Numérica MoM&YoY`,
"c40":`Por favor introduza a palavrachave`,
"c631":`Ver no Twitter`,
"c489":`Tempo desactivado`,
"c819":`Número de telefone/caixa de correio`,
"c935":`Tipo de formulário`,
"c625":`Todas as Campanhas`,
"c471":`Campanha: Indicação de Empregados`,
"front-electronic-signature-writen":`Preenchido`,
"c889":`Desactivar a conta de utilizador com sucesso`,
"c201":`Partilhe este formulário através das suas redes sociais`,
"c467":`O campo de classificação está vazio`,
"label.mobile.no.null":`O número de telefone não pode estar vazio`,
"c307":`Direito`,
"front-kefu-moudle-wait-calling":`Chamada em progresso, por favor tente novamente mais tarde`,
"c784":`Por favor, introduza o nome da empresa na licença comercial`,
"c490":`Hora do último Login`,
"c790":`Assinatura manuscrita`,
"c336":`Líderes  Destroy`,
"c453":`Página inicial Kanban`,
"c530":`Por favor, crie primeiro a caixa de correio da empresa`,
"c610":`O ícone ligarseá ao domínio principal se não tiver especificado o URL`,
"c359":`Gráfico`,
"c193":`Limitações`,
"label.mobile.verificationCode.exceeded.times":`A contagem de repetições foi excedida. Por favor solicite novamente`,
"c138":`Modelo de empresa`,
"c821":`Novos Contactos Internos`,
"c381":`Pedir Pagamento Online`,
"c761":`Assinatura`,
"c964":`O campo de relação mestredetalhe é obrigatório`,
"c585":`Mapa do Reino Unido`,
"c500":`Forneça soluções de serviço ao cliente de uma só paragem com processos padronizados e gestão eficiente, coordene recursos de serviço para fornecer o melhor apoio aos seus clientes.`,
"c214":`Incluir bitmaps em três tamanhos e gráficos vectoriais em todos os formatos`,
"c714":`Agendar postos a publicar no momento certo.`,
"c552":`Rejeitado`,
"c684":`{sumTotalCount} mais`,
"c54":`Preencha por favor o tipo de imposto`,
"c320":`Seleccione os campos do formulário`,
"c236":`{!ServiceResource.name} acedeu à encomenda. Conta: "{!ServiceApontamento.conta.nome}", Número: "{!ServiceApontamento.nome}".`,
"c123":`Informação logística`,
"c654":`Voltar à Lista de Painel`,
"c335":`Margem de lucro`,
"c267":`Não foram cometidas alterações ao critério não foi cumprido`,
"c226":`Ir para Subtarefa`,
"c102":`Clique uma vez`,
"c637":`Guardar como Rascunhos`,
"c633":`Criar Novos Postos Sociais`,
"c777":`Configurar Informação do Participante`,
"c223":`Acrescentar ao projecto`,
"c592":`Mapa da cascata`,
"c315":`Só encomendas válidas podem gerar facturas`,
"c89":`Nome do Evento por Email`,
"c108":`Automatch com sucesso`,
"c402":`Campo`,
"c748":`Por favor seleccione um livro de preços para {título}. Só é possível adicionar produtos de um único livro de preços. A alteração do livro de preços seleccionado resultará na eliminação de todos os produtos existentes.`,
"c501":`Prestar um serviço de campo de qualidade aos seus clientes`,
"c269":`Falha em fundir informação`,
"front-electronic-signature-open-confirm":`Conta Bind Account`,
"c584":`Mapa dos Estados Unidos`,
"c437":`Reprovado`,
"c738":`Data Envio`,
"c274":`Tem um tempo limite para aceitar a encomenda, e o despacho é cancelado. Número: {0}. Clique para ver mais >`,
"c83":`Pesquisar dados`,
"c206":`Formato PNG`,
"c309":`Enviar ficheiro de encomenda`,
"c539":`Proporção mais elevada de fontes`,
"c304":`Principais Interesses`,
"c151":`Descrever brevemente o conteúdo principal da forma`,
"c639":`Publicar agora`,
"c720":`No，thanks`,
"c801":`Novos Contactos`,
"c900":`Não há informação de endereço disponível para o visitante, pelo que a distância de checkin não pode ser calculada.`,
"c695":`Tamanho original`,
"c864":`Escolha um formulário`,
"c881":`Eu li e concordei`,
"c794":`Modelo de assinatura`,
"c543":`Avaliações Recebidas`,
"c466":`Só as encomendas que utilizam o mesmo livro de preços podem gerar uma factura`,
"c867":`{userName} receberá um email de convite que lhe pedirá para criar uma palavrapasse para aceder ao seu Centro de Ajuda.
Continuar?`,
"c529":`Não há formas disponíveis de recarga, por favor contacte o administrador`,
"c742":`Podem ser seleccionadas um máximo de 4 imagens e cada uma delas não pode exceder 200K. Clique na imagem para seleccionar.`,
"c430":`Termo de pesquisa de desempenho`,
"c553":`Última Hora Convidada`,
"c575":`Tabela de Colunas`,
"c124":`Entrega Pendente`,
"c629":`Reprovado`,
"c554":`Primeiro Tempo Convidado`,
"c547":`Últimos 7 dias`,
"c599":`Tabela de quadros`,
"c588":`Mapa do Canadá`,
"c703":`Via`,
"c713":`Criar postos sociais a partir de dentro do CloudCC.`,
"c142":`Esta é a acção que será tomada depois de um visitante submeter o formulário no seu sítio`,
"c153":`Depois de limpar os produtos associados com o registo actual, pode alterar a moeda.`,
"c253":`Cumprimento do GDPR`,
"c612":`Página Interna`,
"c400":`Localização dos Recursos de Serviços`,
"c671":`Ícone e Palavra`,
"c20":`Não pode exceder a quantidade a ser facturada da respectiva encomenda.`,
"c514":`Gráficos do relatório`,
"c946":`Reino Unido`,
"c717":`Novo posto`,
"c174":`Todos editados com sucesso`,
"c940":`China  Hong Kong`,
"c743":`Por favor introduza números válidos`,
"c441":`Gestão empresarial e financeira inteligente`,
"c423":`Plataforma de expedição`,
"c723":`Confirmar para solicitar a destruição`,
"c664":`Nenhuma rede social`,
"c859":`Por favor introduza {0}`,
"c356":`Custo planeado`,
"c221":`Ir para Projecto`,
"front-email-payment-Invoice-Tips1":`Por favor contacte o administrador para permitir o WeChat, Alipay, PayPal ou VISA e depois iniciar o pagamento online`,
"c99":`Produto QTY`,
"c278":`Quer apagar os seguintes emails?`,
"c364":`Linha de citação`,
"c572":`Os campos seleccionados não podem estar vazios, por favor adicione o(s) campo(s)`,
"c310":`Gerar ficheiro de encomenda`,
"c247":`Transferido`,
"c158":`Atribuir Limiar de Tempo`,
"c325":`Modelo de Notificação de Atribuição de Caso`,
"c877":`Preencher Nãoordenado`,
"front-filter-v1-press":`Imprensa`,
"c505":`Rastreio de Visitantes`,
"c523":`Adicionar como Utilizador do Portal`,
"c727":`Destruir dados com sucesso`,
"front-electronic-signature-sended":`Enviado`,
"c150":`Por favor preencha as informações necessárias`,
"c700":`ÚLTIMA HORA ACTUALIZADA`,
"c824":`Assine por ordem`,
"c710":`Uma casa para gerir todas as suas redes sociais`,
"c358":`Orçamento`,
"c544":`Canais`,
"c212":`Formato SVG`,
"c165":`Por favor introduza um valor inteiro de 024`,
"c932":`Spam`,
"c888":`Activar a conta de utilizador com sucesso`,
"c838":`Operador`,
"c98":`Categoria de produto`,
"c830":`CRIADOS POR`,
"c661":`Rede`,
"c818":`Configurações personalizadas do menu da página`,
"c861":`Escolher no mapa`,
"c736":`Publicado por`,
"c204":`Norma`,
"c839":`Parece que não há nada agendado.`,
"c456":`Quantia paga`,
"c341":`Contas finais`,
"c724":`Confirmar para destruir dados`,
"c865":`Li e concordo com {0} e {1}.`,
"c332":`O montante não pode exceder a encomenda a facturar`,
"c520":`O pagamento falhou. O abatimento disponível é insuficiente`,
"c906":`Menos`,
"c482":`Dê um nome ao seu Compagin:`,
"c49":`Actualização de Segurança Configuração de Domínio`,
"c725":`Pedido de revogação de destruição com sucesso`,
"c76":`PAGAM`,
"c558":`Em casos de espera`,
"c876":`Assinatura Nãoordenada`,
"front-invoices-v1-nofilles-tocreate":`Por favor clique no botão Gerar factura para gerar uma factura e depois enviála.`,
"c779":`Data limite de assinatura`,
"c603":`Carta Biaxial MoM&YoY`,
"c455":`Objectivo do Contrato`,
"c428":`Despacho em modo mapa`,
"c55":`Por favor preencha o valor do imposto`,
"c899":`Distância de checkin`,
"label.facebook.title":`FacebookH5 MiniApp`,
"c487":`Nome do destinatário:`,
"label.social.posts.info":`Não foi encontrado nenhum conteúdo post`,
"c704":`Público`,
"c673":`Imagem Web`,
"front-electronic-signature-singed":`Início da assinatura`,
"c722":`1 conta ligada`,
"c595":`Tabela de áreas`,
"c120":`tipo(s)`,
"c68":`Ordem a pagar`,
"c479":`Formulários CloudCC Mailchimp`,
"front-electronic-signature-explain-mainTitle":`Assinatura electrónica e carimbo`,
"c5":`Imposto`,
"c976":``,
"c812":`COMENTÁRIOS`,
"c532":`Contagem dos casos de descanso`,
"c330":`Item de linha de contrato`,
"c249":`posto está a sair agora`,
"c630":`Ver no LinkedIn`,
"c958":`Posto Como o ID não pode estar vazio`,
"c170":`Falha na criação de dados com o registo id {0}, razão falhada: {1};`,
"c810":`REPLIES`,
"c783":`Requisitos de Assinatura`,
"c968":``,
"c752":`Iniciar Tarefa de Assinatura`,
"c439":`Visitante`,
"c67":`Submeter encomenda com sucesso!`,
"front-generate-v1-invoice":`Gerar Factura`,
"c477":`Deve autenticarse com a sua conta MailChimp. Por favor clique no botão "Authenticate MailChimp" e será redireccionado para Mail Chimp para enviar campanhas.`,
"c966":`Por favor contacte o administrador`,
"c764":`Rejeitado`,
"c301":`Podem ser introduzidos até 200 caracteres`,
"c61":`Por favor, abra primeiro o Conhecimento e depois utilizeo`,
"c815":`Arquivar tudo`,
"c827":`Tem nesta página alterações não guardadas que se perderão se continuar.`,
"c688":`Largura máxima`,
"c33":`Editar Tipo de Subscrição`,
"c217":`o correio está a sair {data}`,
"c721":`Desconectar a contagem`,
"c284":`Processamento de pedidos de dados de clientes dentro do CRM`,
"c939":`China  Macau`,
"c503":`Mantenhase a par do progresso do seu projecto`,
"c492":`Convidado`,
"c73":`Balanço actual`,
"label.the.peoples.republic.of.china":`República Popular da China`,
"c828":`LUGAR`,
"c36":`Prévisualização`,
"c954":`Novo número de telefone`,
"front-electronic-signature-innerSinger":`Signatário interno`,
"c508":`Análise do ROI`,
"c833":`Certificação Aprovada`,
"c207":`Formato Vectorial`,
"c31":`Meia tela`,
"c71":`Por favor escolha uma opção de pagamento`,
"c373":`Livro de Preços Padrão`,
"c545":`Tempo de resolução (h)`,
"c77":`Módulo de configuração`,
"label.lastcompiledate":`Tempo da última compilação`,
"c119":`Confirmar Recibo`,
"c281":`Processamento de dados`,
"c715":`A marca monitor menciona e responde rapidamente.`,
"c127":`Gerir Colunas`,
"c283":`Pedido de dados`,
"c919":`Utilizar o pool para estimular o potencial da equipa e melhorar a taxa de conversão de chumbo. O administrador do pool faz uma gestão unificada para as atribuições de leads e lotes. O pessoal de vendas também pode seleccionar os leads e receber acompanhamento.`,
"c82":`Apenas para Relâmpagos`,
"front-file-delete-intro":`O ficheiro foi removido`,
"c606":`Endereço de envio por defeito`,
"c905":`Acrescentar`,
"c644":`TEMPO PUBLICADO`,
"c75":`Saldo do Rebate`,
"c884":`Política de Privacidade`,
"c538":`Tempo de resolução de Avg`,
"c322":`Nova Factura`,
"c461":`Tendência de pagamento`,
"c825":`Empresas`,
"c56":`O total das facturas a receber e o montante a receber não são consistentes. Por favor, preencha novamente.`,
"c931":`Não activou o interruptor de posicionamento dos funcionários e não pode utilizar o intervalo de partilha de localização. Continuar?`,
"c276":`Habilitar o cumprimento do GDPR`,
"c334":`Montante do orçamento`,
"c733":`Campanha: Novo cartaz`,
"c384":`Nova Lista de Embalagem`,
"c139":`Modelo de reunião`,
"c957":`O ID de Comentário Postal não pode estar vazio`,
"front-electronic-signature-nosign":`Nenhum prestador de serviços de Esignature foi escolhido pela sua organização. Por favor contacte o administrador para activar este serviço.`,
"c419":`Plano de manutenção`,
"c934":`Título de Conversão`,
"c677":`Alinhado à direita`,
"c593":`Gráfico de linhas`,
"c272":`{0} tem um tempo limite de aceitação da encomenda. Conta: {1}, Assunto: {2}, Número: {3}. Clique para ver mais >`,
"c811":`RETWEETS`,
"c451":`Caso Dividido`,
"c277":`Uma vez eliminado o email, os seguintes emails também serão eliminados e não serão enviados para contactos futuros. Isto é irriversível.`,
"c244":`{!ServiceResource.name} rejeitou a encomenda. Número: "{!ServiceApontamento.nome}".`,
"c627":`Publicado em`,
"c601":`Tabela de alvos`,
"c251":`a publicação do(s) correio(s) não foi bem sucedida`,
"c202":`Partilhar no Mailchimp`,
"font-social-prohibit-create":`Não se pode criar um novo post enquanto se edita`,
"c394":`O CloudCC ajudao a gerir o negócio online e a melhorar a eficiência. Por favor escolha a aplicação que pretende utilizar e siga a introdução e orientação.`,
"c323":`Formato PDF`,
"front-setting-dialog-title-one":`A fim de evitar a perda de conta, iniciar sessão rapidamente e recuperar facilmente, por favor ligar o número de telefone`,
"front-electronic-signature-cancelIntro2":`Se esta é a sua primeira vez para vincular uma conta, por favor clique em Continuar para ir para o próximo passo. Se estiver a voltar a vincular após a desobstrução, recomendase que clique em Cancelar e voltar a vincular após a limpeza dos dados de navegação.`,
"c353":`Exibição de folhas de tempos`,
"c621":`Conteúdo rico de texto`,
"front-v1-partner-image-tooltip":`É suportado um ficheiro máximo de 2M. A imagem será redimensionada para {tamanho}. Recomendase o carregamento de imagens claras com proporções semelhantes.`,
"c772":`Concluído`,
"c734":`Nome do Canal de Cartazes`,
"c380":`Novo Pagamento`,
"c979":``,
"c233":`Não é possível eliminar a lista de embalagem do estado de expedição`,
"c458":`Mapa de distribuição de contas`,
"c697":`Escolha o endereço da conta{nome}`,
"c476":`Escolha o funcionário para enviar o código de convite para`,
"c634":`Criar um posto cativante e estabelecer ligação com o mundo`,
"c144":`O tempo final não pode exceder 2038. Por favor, seleccione uma nova hora de fim.`,
"c474":`Pode ser reatribuído utilizando as regras de atribuição de liderança. Para as regras de atribuição, consultar`,
"c371":`Sincronizar com a Oportunidade`,
"c420":`Bens de manutenção`,
"c620":`Isto é utilizado para agrupar múltiplos conteúdos para análise de um único esforço de marketing.`,
"c708":`Unificar ou não a escala`,
"c100":`Desconto`,
"c576":`Gráfico de Colunas 2D`,
"c751":`Data limite de assinatura:`,
"c252":`Definições de conformidade`,
"c699":`Novo Apenas`,
"c74":`Pagar por Rebate`,
"c805":`Escolha uma rede social para começar:`,
"c452":`Histórico de casos`,
"c740":`Por favor, seleccione um empregado para enviar convite`,
"c596":`Carta Biaxial`,
"c832":`Revisão`,
"c971":``,
"c262":`História`,
"c363":`Sensível`,
"label.singleSignOn.is.invalid":`Login livre foi inválido`,
"c72":`Pagamento a terceiros`,
"c292":`Marketing`,
"c499":`Serviço ao Cliente Eficiente para Impressionar os Clientes`,
"c574":`Gráfico de barras empilhadas`,
"c618":`Alterar o conteúdo ou tempo de publicação para este post.  O Twitter não permite que mais do que um post com o mesmo conteúdo seja publicado no prazo de 24 horas.`,
"front-setting-phone-format":`Por favor introduza o número de telefone no formato correcto`,
"c460":`Classificação do tamanho da conta`,
"c189":`A moeda da factura deve ser consistente com a moeda da encomenda. Por favor, refine a moeda e guardea novamente.`,
"label.exe.supported.request.rejected":`exe. não é suportado o envio de ficheiro. O pedido é recusado!`,
"c835":`Já existiu uma factura para esta citação. Para continuar ou não?`,
"c655":`Afixação a partir de`,
"c45":`Ligar por`,
"c43":`Conectar conta`,
"c481":`Iniciar sessão como um utilizador diferente`,
"c674":`Endereço externo`,
"c266":`Esta encomenda não pode ser alterada, pois foi concluída`,
"c967":``,
"c154":`Por favor pesquisar livros de preços depois de seleccionar produtos`,
"c841":`Tem ideias? Rascunho fora.   `,
"c615":`Nenhuma conta foi seleccionada`,
"c84":`Escolha emloyee para enviar o código de convite`,
"c401":`Serviço`,
"c290":`Objectos habilitados`,
"c205":`Descarregar o Código QR`,
"c928":`Podem ser seleccionados até 10 campos.`,
"c195":`Limite de submissão`,
"1":`Não há acções disponíveis`,
"c46":`Autorizar com sucesso`,
"c459":`Montante do contrato assinado`,
"c250":`as mensagens são guardadas como rascunhos`,
"c399":`Inventário`,
"c518":`O #recordName of #label falhou a aprovação para #failReason`,
"c396":`Escolher soluções diferentes`,
"c300":`Destruir solicitado por`,
"c789":`Método da Assinatura Irrestrita`,
"c874":`Já leu tudo na sua caixa de correio.`,
"c38":`Número de bloco comunitário`,
"c228":`Adicionar Subtarefa`,
"c342":`Lucro`,
"c879":`Clonar postos sociais`,
"c173":`Rebobinar com sucesso`,
"c778":`Iniciador`,
"c211":`Tamanho pequeno`,
"c496":`CloudCC Sales CloudCC  um CRM inteligente para todos os cenários para o ajudar a atingir os seus objectivos de vendas`,
"c427":`Despacho em Modo Gráfico de Gantt`,
"c851":`Isto mostra o número de posts que foram publicados nas suas contas durante o período seleccionado.`,
"c32":`Novo Tipo de Assinatura`,
"c28":`Crescimento de ano para ano`,
"c163":`Informar e cancelar simultaneamente o envio`,
"c225":`Ir para Tarefa`,
"c569":`Por favor escolha primeiro a conta`,
"c92":`Aberto uma vez`,
"c412":`Marcação de Serviço de AutoCriação`,
"c81":`Adicionar ao carrinho`,
"c653":`Isto mostra o número de gostos, reacções, e comentários para os seus posts publicados. Isto também inclui posts que foram publicados para as suas contas ligadas fora do CloudCC. Se estiver à procura de retweets no Twitter, vai encontrálos em Acções.`,
"c516":`Frequência`,
"c918":`Se as regras de autoreciclagem forem configuradas, o sistema fará a autoreciclagem dos registos para o pool quando a conta não tiver fechado o negócio após o limite de tempo. Isto melhora a eficiência do acompanhamento da conta.`,
"c809":`LIKES`,
"c181":`Por favor preencha a ordem de trabalho ou o registo do caso`,
"c745":`Por favor, introduza até 2 casas decimais`,
"c669":`Cor`,
"c929":`Por favor verifique a ligação à rede`,
"c117":`Poupar e pagar`,
"c938":`China Continental`,
"c112":`Todos os modelos {nome} estão actualmente desactivados. Por favor contacte o administrador para activar o modelo antes de gerar o {nome}.`,
"c347":`Alterar as horas de trabalho da tarefa do projecto`,
"c795":`Por favor escolha o modelo de contrato`,
"c17":`Inactivo. Por favor, seleccione novamente`,
"c787":`Assinado pelo Operador`,
"c829":`CAMPAIGN`,
"c161":`Informe também`,
"c65":`Deseja alterar o estado logístico do produto para Entregue`,
"c665":`Acrescentar mais um`,
"c767":`Verificar o progresso da assinatura`,
"c87":`Código QR do Formulário de Campanha`,
"c589":`Mapa de França`,
"front-electronic-signature-newTime":`Última Actualização em`,
"c813":`PARTILHA`,
"c85":`{member} inviter seleccionado`,
"c951":`Polónia`,
"c29":`Crescimento mês a mês`,
"c210":`Tamanho grande`,
"c39":`Arquivado`,
"c672":`Palavra`,
"c97":`Esta lista de selecção deve conter pelo menos uma opção "Convertido".`,
"c687":`Tamanho máximo`,
"c916":`Fechar piscina`,
"c475":`Por favor, preencha o formulário do proprietário da campanha`,
"c628":`Agendado`,
"c788":`O livro de preços para esta oportunidade está actualmente desactivado. Por favor, active o livro de preços antes de criar uma nova encomenda.`,
"c177":`Tamanho sugerido: 390*210`,
"c856":`Viva! Nada de posts sem graça.`,
"c70":`Informação de encomenda`,
"c546":`Últimas 24 horas`,
"c331":`Converter activos`,
"label.order.paidamount.greater.than.total":`Após os novos detalhes de pagamento serem criados, o montante reembolsado da encomenda será maior do que o montante da encomenda. Por favor, reajuste o pagamento e depois guardeo.`,
"c524":`Convidar de novo`,
"c246":`{!oldServiceResource.name} transferiu a ordem de trabalho numerada {!ServiceApontamento.name} para si.`,
"label.parameter.is.incorrect":`Parâmetros errados`,
"c667":`Espaçamento de ícones`,
"c737":`Plataforma Social`,
"c48":`Desligar`,
"c111":`Gerar {nome}`,
"c755":`Em sequência`,
"c526":`Activar Utilizador do Portal`,
"c450":`Fundir casos`,
"front-electronic-export-reChoseChimp":`A vista actual não tem registos de dados e não pode ser exportada. Por favor, seleccione uma nova vista`,
"label.invoice.paidamount.greater.than.total":`Após a criação dos novos detalhes de pagamento, o montante reembolsado da factura será superior ao valor total. Por favor, reajuste o pagamento e depois guardeo.`,
"c222":`Editar Projecto`,
"c849":`Contas no Twitter`,
"c678":`Preto e Branco`,
"c502":`Oferecer soluções abrangentes para o tratamento de todos os processos envolvidos nos serviços de campo para racionalizar as operações, melhorar a produtividade, aumentar a lealdade e a satisfação do cliente.`,
"c497":`Inventário mais inteligente, gestão empresarial e financeira mais forte`,
"c200":`Partilhar nas redes sociais`,
"c658":`Texto rico`,
"c434":`Novo Contacto Relacionado`,
"c641":`Só pode escolher não mais do que 4 images，click imagem seleccionada para a desmarcar. O tamanho da imagem que carrega deve ser inferior a 200kb`,
"c944":`Alemanha`,
"c411":`Compensação da data de vencimento`,
"c624":` Todas as contas`,
"label.twitter.title":`TwitterH5 MiniApp`,
"c791":`Assinatura padrão`,
"c306":`Concorda`,
"c14":`O utilizador actual não tem a permissão para apagar`,
"c176":`Apenas imagens png, jpg e jpeg são suportadas para carregar. A imagem carregada não pode exceder 2M.`,
"c166":`Por favor introduza a duração máxima da encomenda de acordo com as regras`,
"c731":`Alterar o livro de preços seleccionado irá também eliminar todos os produtos existentes. Tem a certeza de que vai mudar para o novo livro de preços?`,
"c237":`{!ServiceResource.name} acedeu à encomenda. Número: "{!ServiceAppointment.name}".`,
"c887":`Convidar de novo o utilizador com sucesso`,
"c227":`Editar Subtarefa`,
"c257":`Contacto disponível`,
"c712":`Relatar e comparar o desempenho entre redes, postos, e campanhas.`,
"c107":`Pesquisar utilizadores por nome, conta e número de telemóvel`,
"c370":`Contrato`,
"c895":`O cálculo da distância falhou, por favor introduza o endereço completo`,
"c693":`Autoregulação`,
"c763":`Assinado`,
"c302":`Interesses legítimos`,
"c577":`Tabela de Colunas Empilhadas`,
"c258":`Apresentar uma queixa`,
"c676":`Centro`,
"c868":`Após a desactivação desta conta, o sistema restringirá o seu acesso ou operações no seu portal. Continuar?`,
"c53":`Rácio (%)`,
"c527":`#userName atribuiulhe uma tarefa de aprovação`,
"label.facebook.title.setting":`Informação integrada no Facebook`,
"c340":`Alterar o proprietário do plano do projecto`,
"c706":`Sobre os gráficos`,
"label.mobile.used":`O número de telemóvel tem sido utilizado`,
"c328":`Código QR do activo`,
"c337":`Contactos  Destroy`,
"c642":`Imagens recentes`
}